
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j0wU0", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("6OT74")).then(()=>parcelRequire('11sRX'));

});
parcelRegister("fKq5I", function(module, exports) {
"use strict";

var $20Uq9 = parcelRequire("20Uq9");
module.exports = $20Uq9(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("20Uq9", function(module, exports) {
"use strict";
var $177758dc750d50ea$var$cachedBundles = {};
var $177758dc750d50ea$var$cachedPreloads = {};
var $177758dc750d50ea$var$cachedPrefetches = {};
function $177758dc750d50ea$var$getCache(type) {
    switch(type){
        case 'preload':
            return $177758dc750d50ea$var$cachedPreloads;
        case 'prefetch':
            return $177758dc750d50ea$var$cachedPrefetches;
        default:
            return $177758dc750d50ea$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $177758dc750d50ea$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("eYAiv", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("2MWxt")).then(()=>parcelRequire('aGMEi'));

});

parcelRegister("FCOGf", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("3NN9W")).then(()=>parcelRequire('caaFG'));

});

parcelRegister("8QPRU", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("i8WN1")).then(()=>parcelRequire('aZ0Sx'));

});

parcelRegister("bh2gX", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("MMtuR")).then(()=>parcelRequire('iEGk8'));

});

parcelRegister("6zMTy", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("j1Skh")).then(()=>parcelRequire('a43yv'));

});

parcelRegister("i7mHL", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("hUIiR")).then(()=>parcelRequire('2BQEx'));

});

parcelRegister("1vdkc", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("6SS5P")).then(()=>parcelRequire('k4vvc'));

});

parcelRegister("EJ9Pd", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("klZAl")).then(()=>parcelRequire('68m8f'));

});

parcelRegister("VfRNd", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("5xEoy")).then(()=>parcelRequire('PvL2A'));

});

parcelRegister("7Cmcd", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("fCBVN")).then(()=>parcelRequire('fjTuu'));

});

parcelRegister("hGaKk", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("3Cac3")).then(()=>parcelRequire('dG1Dm'));

});

parcelRegister("8vyDa", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("i3Nr5")).then(()=>parcelRequire('5ukhf'));

});

parcelRegister("aCMGc", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("8ZRjr")).then(()=>parcelRequire('bWyC7'));

});

parcelRegister("9C1up", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("bAwoY")).then(()=>parcelRequire('4bdyP'));

});

parcelRegister("gXjy0", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("eiNJp")).then(()=>parcelRequire('2C9ch'));

});

parcelRegister("5wCMx", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("b1997")).then(()=>parcelRequire('aGeQD'));

});

parcelRegister("2UvqW", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("4tKUq")).then(()=>parcelRequire('duojR'));

});

parcelRegister("62C6p", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("hn23i")).then(()=>parcelRequire('2vgBY'));

});

parcelRegister("9vuYc", function(module, exports) {

module.exports = (parcelRequire("fKq5I"))($parcel$resolve("af9Ft")).then(()=>parcelRequire('lbeJP'));

});

var $c6b05ee3b855a153$exports = {};
$parcel$extendImportMap({
    "6OT74": "de.71623aba.js",
    "2MWxt": "es.9748c3dc.js",
    "3NN9W": "fi.c2d2dc23.js",
    "i8WN1": "fr.0ad41a83.js",
    "MMtuR": "hu.4aff18d1.js",
    "j1Skh": "id.d6f29a7d.js",
    "hUIiR": "ja.50d46910.js",
    "6SS5P": "jv.5e25be30.js",
    "klZAl": "ko.50de3fbc.js",
    "5xEoy": "lv.0331a61d.js",
    "fCBVN": "nl.b1d41db2.js",
    "3Cac3": "pt-BR.94e6b589.js",
    "i3Nr5": "ru.d1a0e74c.js",
    "8ZRjr": "su.375b6bd2.js",
    "bAwoY": "sv.cbb7d259.js",
    "eiNJp": "zh-CN.02717f2c.js",
    "b1997": "zh-TW.7b7e5ba8.js",
    "8gElo": "cancel.340fb0bb.svg",
    "iDK6N": "check.e6114d75.svg",
    "dpNT8": "remove-layer.da17ce5a.svg",
    "kav7s": "brush-pressure.8782e24b.svg",
    "43nfB": "copy.22819386.svg",
    "9Vqzx": "tool-picker.896489f2.svg",
    "vALcr": "angle.319ede69.svg",
    "bReTA": "tool-zoom-in.a322442c.svg",
    "i3X7V": "tool-zoom-out.a0c9b082.svg",
    "fETts": "viewport-reset.f69c6fbc.svg",
    "ksMx1": "tool-hand.b64de96e.svg",
    "hRKJH": "edit-pencil.070f95f1.svg",
    "25BJB": "edit-crop.5a25544f.svg",
    "gShQZ": "add-layer.ec19e714.svg",
    "ldqtT": "duplicate-layer.fd421984.svg",
    "apAfQ": "merge-layers.ec5eab67.svg",
    "5E29d": "rename-layer.a037b591.svg",
    "14Bnf": "clip-to-below.0ecf9124.svg",
    "48B5J": "caret-down.5e676c46.svg",
    "8BBCz": "cursor-rotate.0c8e34b1.png",
    "g2W7q": "klecks-logo.ae8bd45e.png",
    "7SFt9": "new-image.1891be3f.svg",
    "2Vvkk": "import.eacba42d.svg",
    "1zJpX": "export.15a4d72c.svg",
    "9cKp0": "share.ab903904.svg",
    "3iiTs": "help.648f7d00.svg",
    "gGmfI": "tool-paint.1b2f44ed.svg",
    "67aEJ": "tool-fill.bbd4ae51.svg",
    "baTSW": "tool-gradient.dedc893d.svg",
    "a2j2Q": "tool-text.0da9f984.svg",
    "gZhDT": "tool-shape.522cd4b5.svg",
    "2x0SU": "tool-select.5ec1da7d.svg",
    "j4HZO": "tool-undo.9138898d.svg",
    "ea7ga": "edit-rotate.8fb5b1ef.svg",
    "gNPQL": "ui-collapse.da4b78fc.svg",
    "9Mrdl": "align-left.dd4a3407.svg",
    "jc4S8": "align-center.13c1a9ae.svg",
    "cgtA2": "align-right.20a4fe41.svg",
    "erfrN": "typo-italic.010c7282.svg",
    "kdJe6": "typo-bold.e186ac23.svg",
    "ialpb": "Caveat-Regular.2fe80bbd.woff2",
    "4YP0p": "ClimateCrisis-Regular-VariableFont_YEAR.3ad02523.woff2",
    "f9bZe": "CorrectionBrush.a69973aa.woff2",
    "dnR06": "DancingScript-Regular.ef2fe647.woff2",
    "lVw6N": "Diabolik-Regular-VF.f4eeb79e.woff2",
    "a0LKB": "FreckleFace-Regular.05946539.woff2",
    "eDCEO": "Gloock-Regular.60f8f765.woff2",
    "6nihP": "Pacha.08c8457a.woff2",
    "4rqd5": "GochiHand-Regular.c45792b0.woff2",
    "isxTc": "PassionOne-Bold.9e08b0dc.woff2",
    "9lp1S": "PixeloidSans.bc292131.woff2",
    "2yKB9": "PlaypenSans-Thin.314b29a4.woff2",
    "jJcCY": "Quicksand-Light.1f0c44a2.woff2",
    "1JYDa": "Silkscreen-Regular.cef2b4cb.woff2",
    "kVDlu": "Tehroc-Regular.4540047b.woff2",
    "caTXQ": "YUNGA-Display.30c04a15.woff2",
    "gJYYq": "edit-brightness-contrast.78620665.svg",
    "fDGND": "edit-curves.56e09e16.svg",
    "8f0bW": "edit-flip.8010ad0f.svg",
    "fAhTF": "edit-hue-saturation.373aa41d.svg",
    "lTNVM": "edit-invert.91bfa402.png",
    "2mMxs": "edit-perspective.474c436b.svg",
    "lkhcY": "edit-resize.673fffa7.svg",
    "c9hFy": "edit-tilt-shift.7ad164eb.png",
    "297B8": "edit-to-alpha.10878d74.svg",
    "jxtUn": "edit-transform.56e34528.svg",
    "lfC0f": "edit-triangle-blur.17417e43.png",
    "cDstS": "edit-unsharp-mask.38afa514.png",
    "arfqb": "edit-grid.c20f8e5f.svg",
    "jz2is": "edit-noise.20c18f19.svg",
    "aeV12": "edit-pattern.f6d27c58.svg",
    "cFLos": "edit-vanish-point.a8c2dde8.svg",
    "abcn9": "edit-distort.33c9d58d.svg",
    "efRnq": "brush-pen.c04fbc65.svg",
    "lGY8s": "brush-blend.d8ce5270.svg",
    "jDXzO": "brush-sketchy.6c75169d.png",
    "hkoNI": "brush-pixel.bfd351cf.svg",
    "baIZM": "brush-eraser.388bfa8c.svg",
    "91Av5": "brush-smudge.9c9edfb1.svg",
    "aI6cE": "brush-chemy.a5a188f6.svg",
    "k0KEP": "upload.fb4a8f36.svg",
    "28TVy": "loading.7ff8a2ac.gif",
    "4tKUq": "dist.8a85a6b5.js",
    "8EUal": "bitbof-logo.738252a6.svg",
    "lQWO9": "ui-swap-lr.695f74b3.svg",
    "hn23i": "licenses.8fd28823.js",
    "af9Ft": "font-licenses.74276106.js",
    "2xc61": "constrain.46a31747.svg",
    "gXLuy": "tab-settings.980aa34c.svg",
    "elaiI": "tab-edit.0d1e8b85.svg",
    "6rWqS": "cursor-picker.71be1460.png",
    "gy6aj": "cursor-fill.ab749dde.png",
    "9SVhx": "cursor-text.b4ebf6cd.png",
    "5mHop": "cursor-zoom-ew.d3ab2d60.png",
    "6WP3U": "select-mode-select.46ceb4fe.svg",
    "hNYGT": "select-mode-move.321505b0.svg",
    "lU1xy": "select-default.a4d71ff2.svg",
    "d4ONi": "select-union.add41cd9.svg",
    "efKXt": "select-subtract.f908cd8e.svg",
    "iG2IE": "select-shape-rect.ecb1b83c.svg",
    "heTsK": "select-shape-ellipse.42a3a2f0.svg",
    "bXno8": "select-shape-lasso.3dedd955.svg",
    "4BXSU": "select-shape-poly.25fd4f29.svg",
    "g8wiX": "select-transform-warp.b47bdcbe.svg",
    "ll6eH": "tab-layers.e4748a75.svg"
});

/**
 * by bitbof (bitbof.com)
 */ /**
 * features that were available before module script tags:
 * chrome 61
 * edge 16
 * safari 11
 * firefox 60
 * https://caniuse.com/es6-module
 */ !function() {
    function t() {
        var e = Array.prototype.slice.call(arguments), n = document.createDocumentFragment();
        e.forEach(function(e) {
            var t = e instanceof Node;
            n.appendChild(t ? e : document.createTextNode(String(e)));
        }), this.appendChild(n);
    }
    [
        Element.prototype,
        Document.prototype,
        DocumentFragment.prototype
    ].forEach(function(e) {
        e.hasOwnProperty("append") || Object.defineProperty(e, "append", {
            configurable: !0,
            enumerable: !0,
            writable: !0,
            value: t
        });
    });
}();


!function() {
    function t() {
        var e = Array.prototype.slice.call(arguments), n = document.createDocumentFragment();
        e.forEach(function(e) {
            var t = e instanceof Node;
            n.appendChild(t ? e : document.createTextNode(String(e)));
        }), this.insertBefore(n, this.firstChild);
    }
    [
        Element.prototype,
        Document.prototype,
        DocumentFragment.prototype
    ].forEach(function(e) {
        e.hasOwnProperty("prepend") || Object.defineProperty(e, "prepend", {
            configurable: !0,
            enumerable: !0,
            writable: !0,
            value: t
        });
    });
}();


String.prototype.padStart || (String.prototype.padStart = function(t, n) {
    return t >>= 0, n = String(n || " "), this.length > t ? String(this) : ((t -= this.length) > n.length && (n += n.repeat(t / n.length)), n.slice(0, t) + String(this));
});


Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
    value: function(r) {
        if (null == this) throw new TypeError('"this" is null or not defined');
        var e = Object(this), t = e.length >>> 0;
        if ("function" != typeof r) throw new TypeError("predicate must be a function");
        for(var n = arguments[1], o = 0; o < t;){
            var i = e[o];
            if (r.call(n, i, o, e)) return o;
            o++;
        }
        return -1;
    }
});




/*
 * ---- Below ----------------------
 * features that didn't have support until *after* browsers supported the modules script tag:
 * Chrome 61
 * Edge 16
 * Safari 11
 * Firefox 60
 * https://caniuse.com/es6-module
 */ // chrome 61, edge 79, safari 16, firefox 107
if (!('scrollTo' in Element.prototype)) Object.defineProperty(Element.prototype, 'scrollTo', {
    value: function(x, y) {
        this.scrollLeft = x;
        this.scrollTop = y;
    }
});
// chrome 61, edge 79, safari 16, firefox 107
if (!('scrollBy' in Element.prototype)) Object.defineProperty(Element.prototype, 'scrollBy', {
    value: function(x, y) {
        this.scrollLeft += x;
        this.scrollTop += y;
    }
});
// chrome 69, edge 79, safari 12, firefox 62
if (!Array.prototype.flat) Object.defineProperty(Array.prototype, 'flat', {
    configurable: true,
    value: function flat(...args) {
        const depth = isNaN(args[0]) ? 1 : Number(args[0]);
        return depth ? Array.prototype.reduce.call(this, function(acc, cur) {
            if (Array.isArray(cur)) // eslint-disable-next-line prefer-spread
            acc.push.apply(acc, flat.call(cur, depth - 1));
            else acc.push(cur);
            return acc;
        }, []) : Array.prototype.slice.call(this);
    },
    writable: true
});
// chrome 69, edge 79, safari 12, firefox 62
if (!Array.prototype.flatMap) Object.defineProperty(Array.prototype, 'flatMap', {
    configurable: true,
    writable: true,
    value: function(callback, thisArg) {
        if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function');
        const result = [];
        for(let i = 0; i < this.length; i++)if (i in this) {
            const mapped = callback.call(thisArg, this[i], i, this);
            if (Array.isArray(mapped)) result.push(...mapped);
            else result.push(mapped);
        }
        return result;
    }
});
// Chrome 85, Firefox 77, Safari 13.1
// if there are problems, maybe use core-js
if (!String.prototype.replaceAll) Object.defineProperty(String.prototype, 'replaceAll', {
    value: function(searchValue, replaceValue) {
        if (typeof replaceValue === 'function') throw new Error('replaceAll polyfill does not support replaceValue: function');
        return this.replace(new RegExp(searchValue, 'g'), replaceValue);
    }
});
// Chrome 92, Firefox 90, Safari 15.4
if (!('at' in Array.prototype)) Object.defineProperty(Array.prototype, 'at', {
    value: function(index) {
        if (index > 0) return this[index];
        if (index < 0) return this[index + this.length];
    }
});
/*
    Copyright 2018  Alfredo Mungo <alfredo.mungo@protonmail.ch>

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to
    deal in the Software without restriction, including without limitation the
    rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
    sell copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
    IN THE SOFTWARE.
*/ if (!Object.fromEntries) Object.defineProperty(Object, 'fromEntries', {
    value (entries) {
        if (!entries || !entries[Symbol.iterator]) throw new Error('Object.fromEntries() requires a single iterable argument');
        const o = {};
        Object.keys(entries).forEach((key)=>{
            const [k, v] = entries[key];
            o[k] = v;
        });
        return o;
    }
});
// sometimes Android WebView has no localStorage
if (!('localStorage' in window)) try {
    window.localStorage = {
        getItem: ()=>null,
        setItem: ()=>{},
        removeItem: ()=>{}
    };
} catch (e) {
// maybe it fails?
}


function $d60cff162e6a5c06$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $0616f0a0655c1023$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $d60cff162e6a5c06$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $70adf2daf994ff61$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $70adf2daf994ff61$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $70adf2daf994ff61$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


/**
 * track how many modals are opened
 */ class $6b37b427615ca1fa$export$f5386afdb763a67e {
    emit() {
        this.listeners.forEach((item)=>{
            item(this.count);
        });
    }
    // ----------------------------------- public -----------------------------------
    increase(v) {
        if (v !== undefined) this.count += v;
        else this.count++;
        this.emit();
    }
    decrease(v) {
        if (v !== undefined) this.count -= v;
        else this.count--;
        this.emit();
    }
    get() {
        return this.count;
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
    constructor(){
        this.listeners = [];
        this.count = 0;
    }
}
const $6b37b427615ca1fa$export$d3d1650bc39c4419 = new $6b37b427615ca1fa$export$f5386afdb763a67e();


function $fc4403c8ee6a33dc$export$c4f94c8b3850a5a9(referenceNode, newNode) {
    if (referenceNode.parentNode) referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
function $fc4403c8ee6a33dc$export$fe58198efe02b173(im, callback) {
    let counter = 0;
    function check() {
        if (counter === 1000) {
            alert("couldn't load");
            return;
        }
        if (im.complete) {
            counter++;
            callback();
        } else setTimeout(check, 1);
    }
    check();
}
function $fc4403c8ee6a33dc$export$2a09375022a33e78(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>resolve(img);
        img.onerror = reject;
        img.src = src;
    });
}
function $fc4403c8ee6a33dc$export$dbf350e5966cf602(el, styleObj) {
    const elStyle = el.style;
    Object.keys(styleObj).forEach((key)=>{
        const property = key;
        elStyle[property] = styleObj[property];
        if (property === 'userSelect') elStyle.webkitUserSelect = styleObj[property]; // Safari support
    });
}
function $fc4403c8ee6a33dc$export$74da2cba014bdc09(el, attrObj) {
    const keyArr = Object.keys(attrObj);
    let keyStr;
    for(let i = 0; i < keyArr.length; i++){
        keyStr = keyArr[i];
        el.setAttribute(keyStr, attrObj[keyStr]);
    }
}
function $fc4403c8ee6a33dc$export$10d8903dec122b9d(target, els) {
    const fragment = document.createDocumentFragment();
    els.forEach((item)=>item && fragment.append(item));
    target.append(fragment);
}
function $fc4403c8ee6a33dc$export$fa55905620c22535(aw, ah, bw, bh, min) {
    let width = aw * bw, height = ah * bw;
    if (width > bw) {
        height = bw / width * height;
        width = bw;
    }
    if (height > bh) {
        width = bh / height * width;
        height = bh;
    }
    if (min) {
        width = Math.max(min, width);
        height = Math.max(min, height);
    }
    return {
        width: width,
        height: height
    };
}
function $fc4403c8ee6a33dc$export$76d0c1a172b67a61(aw, ah, bw, bh) {
    return {
        x: aw / 2 - bw / 2,
        y: ah / 2 - bh / 2
    };
}
function $fc4403c8ee6a33dc$export$aa350b96d91cd94() {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const minutes = (date.getHours() * 60 + date.getMinutes()).toString(36).padStart(3, '0');
    return year + '_' + month + '_' + day + '_' + minutes + '_';
}
function $fc4403c8ee6a33dc$export$f81847884871263e(a, b) {
    return b ? $fc4403c8ee6a33dc$export$f81847884871263e(b, a % b) : a;
}
function $fc4403c8ee6a33dc$export$533b26079ad0b4b(numerator, denominator) {
    const g = $fc4403c8ee6a33dc$export$f81847884871263e(numerator, denominator);
    return [
        numerator / g,
        denominator / g
    ];
}
function $fc4403c8ee6a33dc$export$8215e6b900906daa(decimalNumber) {
    const len = decimalNumber.toString().length - 2;
    const denominator = Math.pow(10, len);
    const numerator = decimalNumber * denominator;
    return $fc4403c8ee6a33dc$export$533b26079ad0b4b(numerator, denominator);
}
function $fc4403c8ee6a33dc$export$5bcd6e94ed871c88(maybeBlob) {
    return maybeBlob instanceof Blob || Object.prototype.toString.call(maybeBlob) === '[object Blob]';
}
function $fc4403c8ee6a33dc$export$5063ec57a23c4f2e(blobObj) {
    if (!blobObj) throw new Error('blobObj is undefined or null');
    if (window.Blob && blobObj instanceof Blob) return URL.createObjectURL(blobObj); // object url
    else if (blobObj.constructor.name === 'Object') {
        const fauxBlob = blobObj;
        return 'data:' + fauxBlob.type + ';' + fauxBlob.encoding + ',' + fauxBlob.data; // data url
    } else throw new Error('unknown blob format');
}
function $fc4403c8ee6a33dc$export$1093707c159148e8(dateA, dateB) {
    dateA = new Date(dateA);
    dateB = new Date(dateB);
    dateA.setHours(0, 0, 0, 0);
    dateB.setHours(0, 0, 0, 0);
    return (dateB.getTime() - dateA.getTime()) / 86400000;
}
function $fc4403c8ee6a33dc$export$af0d87255f3cfd7e(obj) {
    // structuredClone became available around 2022. Let's wait a bit longer for it.
    return JSON.parse(JSON.stringify(obj));
}
function $fc4403c8ee6a33dc$export$331c30fd60da0115(p) {
    const mimetype = 'image/png';
    const err = ()=>alert('sharing not supported');
    p.canvas.toBlob(function(blob) {
        if (!blob) {
            err();
            p.callback();
            return;
        }
        try {
            const filesArray = [
                new File([
                    blob
                ], p.fileName, {
                    type: mimetype
                })
            ];
            navigator.share({
                title: p.title,
                files: filesArray
            }).then(()=>{}).catch(()=>{
                err();
            });
        } catch (e) {
            err();
        }
        p.callback();
    }, mimetype);
}
function $fc4403c8ee6a33dc$export$b981489921ee18cd(clickEvent) {
    const target = clickEvent.target;
    if (!target) return false;
    let el = target;
    while(el){
        if ([
            'A',
            'LABEL',
            'INPUT',
            'SUMMARY'
        ].includes(el.tagName)) return true;
        el = el.parentElement;
    }
    clickEvent.preventDefault();
    return false;
}
function $fc4403c8ee6a33dc$export$c54fe3b9ecaa84cf(p) {
    const result = document.createElementNS('http://www.w3.org/2000/svg', p.elementType);
    Object.entries(p).forEach(([keyStr, item])=>{
        if (keyStr === 'childrenArr') item.forEach((child)=>{
            result.append($fc4403c8ee6a33dc$export$c54fe3b9ecaa84cf(child));
        });
        else if (keyStr === 'css') $fc4403c8ee6a33dc$export$dbf350e5966cf602(result, item);
        else if (keyStr !== 'elementType') result.setAttribute(keyStr, item);
    });
    return result;
}
function $fc4403c8ee6a33dc$export$b813e062795b89b5(v) {
    // (disabled) eslint-disable-next-line no-null/no-null
    if (v === null) throw new Error('value is null');
    return v;
}
function $fc4403c8ee6a33dc$export$5c097f720de072a2(v, message = 'value is undefined') {
    if (v === undefined) throw new Error(message);
    return v;
}
function $fc4403c8ee6a33dc$export$d802c22d109d9806(v) {
    return v === null ? undefined : v;
}
const $fc4403c8ee6a33dc$var$matchMediaDark = 'matchMedia' in window ? window.matchMedia('(prefers-color-scheme: dark)') : false;
function $fc4403c8ee6a33dc$export$a79ad82046afa44e() {
    return $fc4403c8ee6a33dc$var$matchMediaDark && $fc4403c8ee6a33dc$var$matchMediaDark.matches;
}
function $fc4403c8ee6a33dc$export$a9dfd81f95a8a526(func) {
    $fc4403c8ee6a33dc$var$matchMediaDark && 'addEventListener' in $fc4403c8ee6a33dc$var$matchMediaDark && $fc4403c8ee6a33dc$var$matchMediaDark.addEventListener('change', func);
}
function $fc4403c8ee6a33dc$export$326d4de4659beb75(func) {
    $fc4403c8ee6a33dc$var$matchMediaDark && 'removeEventListener' in $fc4403c8ee6a33dc$var$matchMediaDark && $fc4403c8ee6a33dc$var$matchMediaDark.removeEventListener('change', func);
}
function $fc4403c8ee6a33dc$export$b3fb17ae4345ac8f(base64Str) {
    const parts = base64Str.match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/);
    const binStr = atob(parts[3]);
    const buf = new ArrayBuffer(binStr.length);
    const view = new Uint8Array(buf);
    for(let i = 0; i < view.length; i++)view[i] = binStr.charCodeAt(i);
    return new Blob([
        view
    ], {
        type: parts[1]
    });
}
function $fc4403c8ee6a33dc$export$7f1ebd623f131021(length, fillValue) {
    return new Array(length).fill(fillValue);
}
function $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2() {
    if ('randumUUID' in crypto) return crypto.randomUUID();
    // fallback just for dev
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $fc4403c8ee6a33dc$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $fc4403c8ee6a33dc$export$f85d414d081200d8(promise, name, timeoutMs = 5000) {
    return Promise.race([
        promise,
        new Promise((_, reject)=>{
            setTimeout(()=>reject(new Error(`Promise "${name}" timed out.`)), timeoutMs);
        })
    ]);
}
async function $fc4403c8ee6a33dc$export$b6a2e78b63791dfa(url) {
    const response = await fetch(url);
    const svgText = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, 'image/svg+xml');
    const svg = doc.querySelector('svg');
    if (!svg) throw new Error('No <svg> found in the file');
    // Optional: Clone to prevent reusing the same node
    return svg.cloneNode(true);
}


const $604d9bbf77127967$export$fa35291248be714f = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $604d9bbf77127967$export$69accc8c74894f83 = function() {
    const eventUsesHighResTimeStamp = new Event('').timeStamp < 3600000;
    return function() {
        return eventUsesHighResTimeStamp;
    };
}();
const $604d9bbf77127967$export$7728c852ca75bb6d = !!window.PointerEvent;
const $604d9bbf77127967$export$1a1016cfea93f0d5 = function() {
    let result;
    function test() {
        const div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.top = '0';
        div.style.left = 'max(0px, 25px)';
        document.body.append(div);
        setTimeout(function() {
            result = div.offsetLeft === 25;
            div.remove();
        }, 25);
    }
    if (document.body) test();
    else window.addEventListener('DOMContentLoaded', function() {
        test();
    });
    return function() {
        if (result === undefined) throw new Error('isCssMinMaxSupported not initialized');
        return result;
    };
}();
const $604d9bbf77127967$export$558f5e20caee48c2 = function() {
    return 'share' in navigator && 'canShare' in navigator;
};
function $604d9bbf77127967$export$4fb2cccfca937a8c(obj, ...handlers) {
    handlers.forEach((handler)=>{
        // (disabled) eslint-disable-next-line no-null/no-null
        obj[handler] = null;
    });
}
function $604d9bbf77127967$export$a432063205610fa1() {
    navigator.storage.estimate().then((estimate)=>{
        if (estimate.quota === undefined || estimate.usage === undefined) {
            console.log('no quota info');
            return;
        }
        console.log(`using ${(estimate.usage / estimate.quota * 100).toFixed(2)}% of total quota`);
        console.log('usage (GB)', (estimate.usage / 1024 / 1024 / 1024).toFixed(2));
        console.log('quota (GB)', (estimate.quota / 1024 / 1024 / 1024).toFixed(2));
    });
}


const $08e838e8af75c5e2$var$globalKey = (()=>{
    // keyStr - our key naming system
    // key - KeyboardEvent.key
    // code - KeyboardEvent.code
    const keyStrToKeyObj = {
        // keyStr not to contain a '+', because that's used for the comboStr
        space: [
            ' ',
            'Spacebar'
        ],
        alt: [
            'Alt',
            'AltGraph'
        ],
        shift: 'Shift',
        ctrl: 'Control',
        cmd: [
            'Meta',
            'MetaLeft',
            'MetaRight'
        ],
        enter: 'Enter',
        esc: 'Escape',
        backspace: 'Backspace',
        delete: 'Delete',
        sqbr_open: '[',
        sqbr_close: ']',
        a: [
            'a',
            'A'
        ],
        b: [
            'b',
            'B'
        ],
        c: [
            'c',
            'C'
        ],
        e: [
            'e',
            'E'
        ],
        f: [
            'f',
            'F'
        ],
        g: [
            'g',
            'G'
        ],
        l: [
            'l',
            'L'
        ],
        r: [
            'r',
            'R'
        ],
        s: [
            's',
            'S'
        ],
        t: [
            't',
            'T'
        ],
        u: [
            'u',
            'U'
        ],
        x: [
            'x',
            'X'
        ],
        y: [
            'y',
            'Y'
        ],
        z: [
            'z',
            'Z'
        ],
        plus: '+',
        minus: '-',
        left: 'ArrowLeft',
        right: 'ArrowRight',
        up: 'ArrowUp',
        down: 'ArrowDown',
        home: 'Home',
        end: 'End'
    };
    // ['space', 'alt', ... ]
    const keyStrArr = Object.keys(keyStrToKeyObj);
    // { space: false, ... }
    const isDownObj = Object.entries(keyStrToKeyObj).reduce((acc, [key])=>{
        acc[key] = false;
        return acc;
    }, {});
    // event.key to keyStr
    // { ArrowLeft: 'left', ... }
    const keyToKeyStrObj = Object.entries(keyStrToKeyObj).reduce((acc, [key, code])=>{
        if (typeof code === 'string') acc[code] = key;
        else code.forEach((item)=>{
            acc[item] = key;
        });
        return acc;
    }, {});
    let comboArr = [];
    // a physical key's "key" can change as other keys get pressed. to keep track, need to also track the code
    // { KeyE: 'e', KeyF: undefined } - undefined - not down, string - the associated keyStr
    let codeIsDownObj = {};
    const listenerArr = [];
    /**
     * Windows bug in all browsers: Pressing the Windows key leads to keyboard events not firing.
     * It breaks key state tracking.
     * Workaround: If after a timeout, only the meta key is pressed, fire a keyup for the meta key.
     */ let metaClearTimeout;
    const setupMetaClear = (keyStr, code)=>{
        metaClearTimeout = setTimeout(()=>{
            if (comboArr.length !== 1 || comboArr[0] === 'cmd') return;
            const oldComboStr = comboArr.join('+');
            isDownObj[keyStr] = false;
            codeIsDownObj[code] = undefined;
            // remove from combo
            for(let i = 0; i < comboArr.length; i++)if (comboArr[i] == keyStr) {
                comboArr.splice(i, 1);
                i--;
            }
            emitUp(keyStr, {
                preventDefault: function() {},
                stopPropagation: function() {}
            }, oldComboStr);
            metaClearTimeout = undefined;
        }, 1000);
    };
    const emitDown = function(a, b, c, d) {
        listenerArr.forEach((item)=>{
            if (!item[0]) return;
            item[0](a, b, c, d);
        });
    };
    const emitUp = function(a, b, c) {
        listenerArr.forEach((item)=>{
            if (!item[1]) return;
            item[1](a, b, c);
        });
    };
    const emitBlur = function() {
        listenerArr.forEach((item)=>{
            if (!item[2]) return;
            item[2]();
        });
    };
    function keyDown(e) {
        const key = e.key;
        const code = e.code;
        if (key in keyToKeyStrObj) {
            const keyStr = keyToKeyStrObj[key];
            if (isDownObj[keyStr]) {
                emitDown(keyStr, e, comboArr.join('+'), true);
                return;
            } else {
                if (keyStr === 'cmd') setupMetaClear(keyStr, code);
                else clearTimeout(metaClearTimeout);
                if (keyStr === 'esc') // Workaround for a macOS behavior
                // When in fullscreen, pressing escape exits the fullscreen mode.
                // When that happens, no keyup for escape is fired.
                setTimeout(()=>blur());
            }
            isDownObj[keyStr] = true;
            codeIsDownObj[code] = keyStr;
            //add to combo
            comboArr.push(keyStr);
            emitDown(keyStr, e, comboArr.join('+'));
        }
    }
    function keyUp(e) {
        const code = e.code;
        const oldComboStr = comboArr.join('+');
        // because of a macOS bug: when meta key is down, keyup of other keys does not fire.
        // https://stackoverflow.com/questions/25438608/javascript-keyup-isnt-called-when-command-and-another-is-pressed
        if ([
            'Meta',
            'MetaLeft',
            'MetaRight',
            'OSLeft',
            'OSRight'
        ].includes(code)) {
            blur();
            return;
        } else if (isDownObj['cmd']) {
            // Workaround for Windows bug. Windows doesn't fire keyup for Meta key when pressing Windows Key + Space,
            // neither does it fire blur
            blur();
            return;
        }
        const keyStr = codeIsDownObj[code];
        if (keyStr !== undefined) {
            isDownObj[keyStr] = false;
            codeIsDownObj[code] = undefined;
            // remove from combo
            for(let i = 0; i < comboArr.length; i++)if (comboArr[i] == keyStr) {
                comboArr.splice(i, 1);
                i--;
            }
            emitUp(keyStr, e, oldComboStr);
        }
    }
    function blur() {
        const oldComboStr = comboArr.join('+');
        comboArr = [];
        codeIsDownObj = {};
        const eventArr = [];
        keyStrArr.forEach((keyStr)=>{
            if (isDownObj[keyStr]) {
                isDownObj[keyStr] = false;
                eventArr.push(keyStr);
            }
        });
        for(let i = 0; i < eventArr.length; i++)emitUp(eventArr[i], {
            preventDefault: function() {},
            stopPropagation: function() {}
        }, oldComboStr);
        emitBlur();
    }
    return {
        add: (keyListenerRef)=>{
            if (listenerArr.includes(keyListenerRef)) return;
            const first = listenerArr.length === 0;
            listenerArr.push(keyListenerRef);
            if (first) {
                document.addEventListener('keydown', keyDown);
                document.addEventListener('keyup', keyUp);
                window.addEventListener('blur', blur);
            }
        },
        remove: (keyListenerRef)=>{
            if (!listenerArr.includes(keyListenerRef)) return;
            const last = listenerArr.length === 1;
            for(let i = 0; i < listenerArr.length; i++)if (listenerArr[i] === keyListenerRef) {
                listenerArr.splice(i, 1);
                break;
            }
            if (last) {
                document.removeEventListener('keydown', keyDown);
                document.removeEventListener('keyup', keyUp);
                window.removeEventListener('blur', blur);
                // cleanup
                comboArr = [];
                codeIsDownObj = {};
                keyStrArr.forEach((keyStr)=>{
                    if (isDownObj[keyStr]) isDownObj[keyStr] = false;
                });
            }
        },
        getIsDown: ()=>isDownObj,
        getCombo: ()=>comboArr,
        blur: blur
    };
})();
class $08e838e8af75c5e2$export$f17908c5de22d32e {
    isPressed(keyStr) {
        if (!(keyStr in $08e838e8af75c5e2$var$globalKey.getIsDown())) throw 'key "' + keyStr + '" not found';
        return $08e838e8af75c5e2$var$globalKey.getIsDown()[keyStr];
    }
    getComboStr() {
        return $08e838e8af75c5e2$var$globalKey.getCombo().join('+');
    }
    comboOnlyContains(keyStrArr) {
        for(let i = 0; i < $08e838e8af75c5e2$var$globalKey.getCombo().length; i++){
            if (!keyStrArr.includes($08e838e8af75c5e2$var$globalKey.getCombo()[i])) return false;
        }
        return true;
    }
    destroy() {
        $08e838e8af75c5e2$var$globalKey.remove(this.ref);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.onDown = p.onDown;
        this.onUp = p.onUp;
        this.onBlur = p.onBlur;
        this.ref = [
            this.onDown,
            this.onUp,
            this.onBlur
        ];
        $08e838e8af75c5e2$var$globalKey.add(this.ref);
    }
}
function $08e838e8af75c5e2$export$e9f65b0175de4c03(comboAStr, comboBStr) {
    return comboAStr.split('+').sort().join('+') === comboBStr.split('+').sort().join('+');
}





const $7b537f840072781f$var$SEQUENCE_TIMEOUT_MS = 200;
class $7b537f840072781f$export$c734b8535f2f8e38 {
    emit(delta) {
        if (this.position === null || this.sequenceUnit === null) return;
        this.callback({
            deltaY: Math.round(delta / this.sequenceUnit),
            pageX: this.position.pageX,
            pageY: this.position.pageY,
            clientX: this.position.clientX,
            clientY: this.position.clientY
        });
    }
    endSequence() {
        if (this.toEmitDelta !== null) {
            this.emit(this.toEmitDelta);
            this.toEmitDelta = null;
        }
        if (this.sequenceUnit !== null && !this.knownUnitArr.includes(this.sequenceUnit)) this.knownUnitArr.push(this.sequenceUnit);
        this.sequenceLength = 0;
        this.sequenceUnit = null;
    }
    process(event) {
        this.position = {
            pageX: event.pageX,
            pageY: event.pageY,
            clientX: event.clientX,
            clientY: event.clientY
        };
        if (this.endSequenceTimeout) clearTimeout(this.endSequenceTimeout);
        this.endSequenceTimeout = setTimeout(()=>this.endSequence(), $7b537f840072781f$var$SEQUENCE_TIMEOUT_MS);
        //prep delta
        let delta = event.deltaY;
        if ('deltaMode' in event && event.deltaMode === 1) delta *= 100 / 3;
        const absDelta = Math.abs(delta);
        //sequence begins
        if (this.sequenceLength === 0) {
            this.sequenceLength++;
            if (absDelta < 50) //dirty - probably a swipe scroll or pinch scroll on trackpad
            return;
            this.sequenceUnit = absDelta;
            if (this.knownUnitArr.includes(this.sequenceUnit)) //we know this unit - emit right away
            this.emit(delta);
            else //unknown unit - wait until next event or sequence end, to have more certainty that it's clean
            this.toEmitDelta = delta;
            return;
        }
        if (this.sequenceUnit === null) {
            //previously determined dirty sequence
            this.toEmitDelta = null;
            return;
        }
        //sequence continues
        if (absDelta === 0) //ignore zero scroll
        return;
        if (absDelta === this.sequenceUnit || absDelta / this.sequenceUnit % 1 < 0.0001 // a multiple
        ) ;
        else if (this.sequenceUnit / absDelta % 1 < 0.0001) //unit was actually a multiple - update it
        this.sequenceUnit = absDelta;
        else if (absDelta !== this.sequenceUnit) {
            //not clean - delta is varying - probably a swipe scroll or pinch scroll on trackpad
            this.sequenceUnit = null;
            this.toEmitDelta = null;
            return;
        }
        if (this.toEmitDelta !== null) {
            this.emit(this.toEmitDelta);
            this.toEmitDelta = null;
        }
        this.emit(delta);
    }
    // ----------------------------------- public -----------------------------------
    constructor(callback){
        this.callback = callback;
        this.knownUnitArr = [
            100
        ];
        this.sequenceLength = 0;
        this.sequenceUnit = null;
        this.toEmitDelta = null;
        this.position = null;
    }
}


/**
 * Apple Pencil on iPad in Safari has two problems:
 * - You need to press the stylus very strong to reach 1.0 pressure, to the point where the screen starts discoloring
 * - Always fires the same pressure value on pointerdown
 *
 * This normalizer tries to fix that with a workaround.
 *
 * pressure range [0, 1]
 */ class $11fbdc7b09b4db73$export$61f95f4b79132931 {
    // ----------------------------------- public -----------------------------------
    normalize(pressure, eventType, pointerType) {
        if (pointerType === 'pen') {
            if (!this.detectionComplete) {
                if (eventType === 'pointerdown') {
                    if (this.initialPointerDownPressure === -1) this.initialPointerDownPressure = pressure;
                    else if (this.initialPointerDownPressure === pressure) {
                        this.pointerDownPressureRepeatCount++;
                        if (this.pointerDownPressureRepeatCount > 1 && this.pointerMoveHasDifferentPressure) {
                            this.detectionComplete = true;
                            this.isApplePencil = true;
                        }
                    } else {
                        this.detectionComplete = true;
                        this.isApplePencil = false;
                    }
                } else if (eventType === 'pointermove') {
                    if (this.initialPointerDownPressure !== pressure) this.pointerMoveHasDifferentPressure = true;
                }
            }
            if (this.detectionComplete && this.isApplePencil) {
                if (this.initialPointerDownPressure === pressure) return 0;
                pressure = Math.min(2, pressure * 2);
            }
            return pressure;
        } else return pressure;
    }
    constructor(){
        this.detectionComplete = false;
        this.isApplePencil = false;
        // detection
        this.initialPointerDownPressure = -1;
        this.pointerDownPressureRepeatCount = 0;
        this.pointerMoveHasDifferentPressure = false;
    }
}


// keeping track of pointers for movement fallback
const $a07742141701d1f2$var$pointerArr = [];
function $a07742141701d1f2$var$addPointer(event) {
    const pointerObj = {
        pointerId: event.pointerId,
        lastPageX: null,
        lastPageY: null
    };
    $a07742141701d1f2$var$pointerArr.push(pointerObj);
    if ($a07742141701d1f2$var$pointerArr.length > 15) $a07742141701d1f2$var$pointerArr.shift();
    return pointerObj;
}
function $a07742141701d1f2$var$getPointer(event) {
    for(let i = $a07742141701d1f2$var$pointerArr.length - 1; i >= 0; i--){
        if (event.pointerId === $a07742141701d1f2$var$pointerArr[i].pointerId) return $a07742141701d1f2$var$pointerArr[i];
    }
    return null;
}
function $a07742141701d1f2$var$getButtonStr(buttons) {
    switch(buttons){
        case 1:
            return 'left';
        case 2:
            return 'right';
        case 4:
            return 'middle';
        default:
            return undefined;
    }
}
const $a07742141701d1f2$var$pressureNormalizer = new (0, $11fbdc7b09b4db73$export$61f95f4b79132931)();
const $a07742141701d1f2$var$timeStampOffset = (0, $604d9bbf77127967$export$69accc8c74894f83)() ? 0 : -performance.timing.navigationStart;
const $a07742141701d1f2$var$pointerDownEvt = (0, $604d9bbf77127967$export$7728c852ca75bb6d) ? 'pointerdown' : 'mousedown';
const $a07742141701d1f2$var$pointerMoveEvt = (0, $604d9bbf77127967$export$7728c852ca75bb6d) ? 'pointermove' : 'mousemove';
const $a07742141701d1f2$var$pointerUpEvt = (0, $604d9bbf77127967$export$7728c852ca75bb6d) ? 'pointerup' : 'mouseup';
const $a07742141701d1f2$var$pointerCancelEvt = (0, $604d9bbf77127967$export$7728c852ca75bb6d) ? 'pointercancel' : 'mousecancel';
const $a07742141701d1f2$var$pointerLeaveEvt = (0, $604d9bbf77127967$export$7728c852ca75bb6d) ? 'pointerleave' : 'mouseleave';
const $a07742141701d1f2$var$pointerEnterEvt = (0, $604d9bbf77127967$export$7728c852ca75bb6d) ? 'pointerenter' : 'mouseenter';
/**
 * More trustworthy pointer attributes. that behave the same across browsers.
 * returns a new object. Also attaches itself to the orig event. -> event.corrected
 */ function $a07742141701d1f2$var$correctPointerEvent(event, isPointerDown) {
    if ('corrected' in event) return event.corrected;
    function determineButtons() {
        if (event.buttons !== undefined) return event.buttons;
        /*
                button -> buttons
        none:	undefined -> 0
        left:	0 -> 1
        middle:	1 -> 4
        right:	2 -> 2
        fourth:	3 -> 8
        fifth:	4 -> 16
         */ if (event.button !== undefined) // old safari on mac has no buttons. remove eventually.
        return [
            1,
            4,
            2,
            8,
            16
        ][event.button];
        return 0;
    }
    const correctedObj = {
        pointerId: event.pointerId,
        pointerType: event.pointerType,
        pageX: event.pageX,
        pageY: event.pageY,
        clientX: event.clientX,
        clientY: event.clientY,
        movementX: event.movementX,
        movementY: event.movementY,
        timeStamp: event.timeStamp + $a07742141701d1f2$var$timeStampOffset,
        pressure: $a07742141701d1f2$var$pressureNormalizer.normalize(event.pressure, event.type, event.pointerType),
        buttons: determineButtons(),
        button: event.button,
        coalescedArr: [],
        eventPreventDefault: ()=>event.preventDefault(),
        eventStopPropagation: ()=>event.stopPropagation()
    };
    event.corrected = correctedObj;
    let customPressure = null;
    if ('pointerId' in event) {
        if ('pressure' in event && event.buttons !== 0) {
            if (event.pointerType === 'touch' && event.pressure === 0) {
                correctedObj.pressure = 1;
                customPressure = 1;
            }
            // Spec: If there's no pressure support, pressure is 0.5.
            // https://w3c.github.io/pointerevents/#dom-pointerevent-pressure
            // & in older Safari (<=16) it seems to be "mouse" and 0.
            if (event.pointerType === 'mouse' && (event.pressure === 0.5 || event.pressure === 0)) {
                correctedObj.pressure = 1;
                customPressure = 1;
            }
        }
    } else {
        correctedObj.pointerId = 0;
        correctedObj.pointerType = 'mouse';
        correctedObj.pressure = event.buttons !== 0 ? 1 : 0;
        customPressure = correctedObj.pressure;
    }
    if ((0, $604d9bbf77127967$export$fa35291248be714f) && event.pointerType != 'mouse' && event.type === 'pointermove' && event.buttons === 0) // once again firefox
    correctedObj.buttons = 1; // todo wrong if no buttons actually pressed
    let coalescedEventArr = [];
    if ('getCoalescedEvents' in event) coalescedEventArr = event.getCoalescedEvents();
    // chrome somehow movementX not same scale as pageX. todo: only chrome?
    // so make my own
    const pointerObj = $a07742141701d1f2$var$getPointer(correctedObj) || $a07742141701d1f2$var$addPointer(correctedObj);
    const totalLastX = pointerObj.lastPageX;
    const totalLastY = pointerObj.lastPageY;
    for(let i = 0; i < coalescedEventArr.length; i++){
        const eventItem = coalescedEventArr[i];
        correctedObj.coalescedArr.push({
            pageX: eventItem.pageX,
            pageY: eventItem.pageY,
            clientX: eventItem.clientX,
            clientY: eventItem.clientY,
            movementX: pointerObj.lastPageX === null ? 0 : eventItem.pageX - pointerObj.lastPageX,
            movementY: pointerObj.lastPageY === null ? 0 : eventItem.pageY - pointerObj.lastPageY,
            timeStamp: eventItem.timeStamp === 0 ? correctedObj.timeStamp : eventItem.timeStamp + $a07742141701d1f2$var$timeStampOffset,
            pressure: customPressure === null ? $a07742141701d1f2$var$pressureNormalizer.normalize(eventItem.pressure) : customPressure
        });
        pointerObj.lastPageX = eventItem.pageX;
        pointerObj.lastPageY = eventItem.pageY;
    }
    pointerObj.lastPageX = correctedObj.pageX;
    pointerObj.lastPageY = correctedObj.pageY;
    if (isPointerDown) {
        correctedObj.movementX = 0;
        correctedObj.movementY = 0;
    } else {
        correctedObj.movementX = totalLastX === null ? 0 : pointerObj.lastPageX - totalLastX;
        correctedObj.movementY = totalLastY === null ? 0 : pointerObj.lastPageY - totalLastY;
    }
    return correctedObj;
}
const $a07742141701d1f2$var$OPTIONS_PASSIVE = {
    passive: false
};
class $a07742141701d1f2$export$9371bd96776f4e82 {
    getDragObj(pointerId) {
        for(let i = 0; i < this.dragObjArr.length; i++){
            if (pointerId === this.dragObjArr[i].pointerId) return this.dragObjArr[i];
        }
        return null;
    }
    removeDragObj(pointerId) {
        let removedDragObj = null;
        for(let i = 0; i < this.dragPointerIdArr.length; i++)if (this.dragPointerIdArr[i] === pointerId) {
            removedDragObj = this.dragObjArr[i];
            this.dragObjArr.splice(i, 1);
            this.dragPointerIdArr.splice(i, 1);
            i--;
        }
        return removedDragObj;
    }
    /**
     * Creates a value for onPointer, from a pointer event handler.
     */ createPointerOutEvent(typeStr, correctedEvent, custom) {
        const bounds = this.targetElement.getBoundingClientRect();
        const result = (0, $0616f0a0655c1023$export$71511d61b312f219)({
            type: typeStr,
            pointerId: correctedEvent.pointerId,
            pointerType: correctedEvent.pointerType,
            pageX: correctedEvent.pageX,
            pageY: correctedEvent.pageY,
            clientX: correctedEvent.clientX,
            clientY: correctedEvent.clientY,
            relX: correctedEvent.clientX - bounds.left + this.targetElement.scrollLeft,
            relY: correctedEvent.clientY - bounds.top + this.targetElement.scrollTop,
            dX: correctedEvent.movementX,
            dY: correctedEvent.movementY,
            time: correctedEvent.timeStamp,
            eventPreventDefault: correctedEvent.eventPreventDefault,
            eventStopPropagation: correctedEvent.eventStopPropagation
        }, custom);
        if (typeStr === 'pointermove') {
            result.coalescedArr = [];
            if (correctedEvent.coalescedArr.length > 1) {
                let coalescedItem;
                for(let i = 0; i < correctedEvent.coalescedArr.length; i++){
                    coalescedItem = correctedEvent.coalescedArr[i];
                    result.coalescedArr.push({
                        pageX: coalescedItem.pageX,
                        pageY: coalescedItem.pageY,
                        clientX: coalescedItem.clientX,
                        clientY: coalescedItem.clientY,
                        relX: coalescedItem.clientX - bounds.left + this.targetElement.scrollLeft,
                        relY: coalescedItem.clientY - bounds.top + this.targetElement.scrollTop,
                        dX: coalescedItem.movementX,
                        dY: coalescedItem.movementY,
                        time: coalescedItem.timeStamp
                    });
                }
            }
        }
        return result;
    }
    setupDocumentListeners() {
        this.windowOnPointerMove && document.addEventListener($a07742141701d1f2$var$pointerMoveEvt, this.windowOnPointerMove, $a07742141701d1f2$var$OPTIONS_PASSIVE);
        this.windowOnPointerUp && document.addEventListener($a07742141701d1f2$var$pointerUpEvt, this.windowOnPointerUp, $a07742141701d1f2$var$OPTIONS_PASSIVE);
        this.windowOnPointerLeave && document.addEventListener($a07742141701d1f2$var$pointerCancelEvt, this.windowOnPointerLeave, $a07742141701d1f2$var$OPTIONS_PASSIVE);
        this.windowOnPointerLeave && document.addEventListener($a07742141701d1f2$var$pointerLeaveEvt, this.windowOnPointerLeave, $a07742141701d1f2$var$OPTIONS_PASSIVE);
    }
    destroyDocumentListeners() {
        this.windowOnPointerMove && document.removeEventListener($a07742141701d1f2$var$pointerMoveEvt, this.windowOnPointerMove);
        this.windowOnPointerUp && document.removeEventListener($a07742141701d1f2$var$pointerUpEvt, this.windowOnPointerUp);
        this.windowOnPointerLeave && document.removeEventListener($a07742141701d1f2$var$pointerCancelEvt, this.windowOnPointerLeave);
        this.windowOnPointerLeave && document.removeEventListener($a07742141701d1f2$var$pointerLeaveEvt, this.windowOnPointerLeave);
    }
    destroy() {
        if (this.isDestroyed) return;
        this.isDestroyed = true;
        this.onPointerEnter && this.targetElement.removeEventListener($a07742141701d1f2$var$pointerEnterEvt, this.onPointerEnter);
        this.onPointerLeave && this.targetElement.removeEventListener($a07742141701d1f2$var$pointerLeaveEvt, this.onPointerLeave);
        this.onPointerMove && this.targetElement.removeEventListener($a07742141701d1f2$var$pointerMoveEvt, this.onPointerMove);
        this.onPointerDown && this.targetElement.removeEventListener($a07742141701d1f2$var$pointerDownEvt, this.onPointerDown);
        this.onWheel && this.targetElement.removeEventListener('wheel', this.onWheel);
        this.destroyDocumentListeners();
        this.onTouchMoveScribbleFix && document.removeEventListener('touchmove', this.onTouchMoveScribbleFix);
        this.onTouchStart && this.targetElement.removeEventListener('touchstart', this.onTouchStart);
        this.onTouchMove && this.targetElement.removeEventListener('touchmove', this.onTouchMove);
        this.onTouchEnd && this.targetElement.removeEventListener('touchend', this.onTouchEnd);
        this.onTouchCancel && this.targetElement.removeEventListener('touchcancel', this.onTouchCancel);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isDestroyed = false;
        this.isOverCounter = 0;
        // pointers that are pressing a button
        this.dragObjArr = [];
        this.dragPointerIdArr = [];
        // chrome input glitch workaround
        this.lastPointerType = null;
        this.didSkip = false;
        this.targetElement = p.target;
        this.onPointerCallback = p.onPointer;
        this.onWheelCallback = p.onWheel;
        this.onEnterLeaveCallback = p.onEnterLeave;
        var _p_maxPointers;
        this.maxPointers = Math.max(1, (_p_maxPointers = p.maxPointers) !== null && _p_maxPointers !== void 0 ? _p_maxPointers : 1);
        const finalizeWheelEvent = (e)=>{
            if (this.isDestroyed || !this.onWheelCallback) return;
            const bounds = this.targetElement.getBoundingClientRect();
            const whlEvent = (0, $0616f0a0655c1023$export$71511d61b312f219)((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, e instanceof WheelEvent ? {
                deltaY: e.deltaY / 120,
                pageX: e.pageX,
                pageY: e.pageY
            } : e), {
                relX: e.clientX - bounds.left + this.targetElement.scrollLeft,
                relY: e.clientY - bounds.top + this.targetElement.scrollTop
            }), e instanceof WheelEvent ? {
                event: e
            } : {});
            this.onWheelCallback(whlEvent);
        };
        this.wheelCleaner = p.useDirtyWheel ? undefined : new (0, $7b537f840072781f$export$c734b8535f2f8e38)(finalizeWheelEvent);
        if (this.onPointerCallback) {
            this.onPointerMove = (event)=>{
                var _this_onPointerCallback, _this;
                const correctedEvent = $a07742141701d1f2$var$correctPointerEvent(event);
                const tempLastPointerType = this.lastPointerType;
                this.lastPointerType = correctedEvent.pointerType;
                if (this.dragPointerIdArr.includes(correctedEvent.pointerId) || this.dragPointerIdArr.length === this.maxPointers || correctedEvent.pointerType === 'touch') {
                    this.didSkip = false;
                    return;
                }
                // chrome input glitch workaround - throws in a random mouse event with the wrong position when using a stylus
                if (!this.didSkip && correctedEvent.pointerType === 'mouse' && tempLastPointerType === 'pen') {
                    this.didSkip = true;
                    return;
                }
                this.didSkip = false;
                const outEvent = this.createPointerOutEvent('pointermove', correctedEvent);
                (_this_onPointerCallback = (_this = this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this, outEvent);
            };
            this.onPointerDown = (event, onSkipGlobal)=>{
                var _this_onPointerCallback, _this;
                //BB.throwOut('pointerdown ' + event.pointerId + ' | ' + dragPointerIdArr.length);
                const correctedEvent = $a07742141701d1f2$var$correctPointerEvent(event, true);
                ////console.log('debug: ' + event.pointerId + ' pointerdown');
                if (this.dragPointerIdArr.includes(correctedEvent.pointerId) || this.dragPointerIdArr.length === this.maxPointers || ![
                    1,
                    2,
                    4
                ].includes(correctedEvent.buttons)) //BB.throwOut('pointerdown ignored');
                return;
                //set up global listeners
                if (this.dragObjArr.length === 0 && !onSkipGlobal) this.setupDocumentListeners();
                const dragObj = {
                    pointerId: correctedEvent.pointerId,
                    pointerType: correctedEvent.pointerType,
                    downPageX: correctedEvent.pageX,
                    downPageY: correctedEvent.pageY,
                    buttons: correctedEvent.buttons,
                    lastPageX: correctedEvent.pageX,
                    lastPageY: correctedEvent.pageY,
                    lastTimeStamp: correctedEvent.timeStamp
                };
                this.dragObjArr.push(dragObj);
                this.dragPointerIdArr.push(correctedEvent.pointerId);
                const outEvent = this.createPointerOutEvent('pointerdown', correctedEvent, {
                    downPageX: correctedEvent.pageX,
                    downPageY: correctedEvent.pageY,
                    button: $a07742141701d1f2$var$getButtonStr(correctedEvent.buttons),
                    pressure: correctedEvent.pressure
                });
                (_this_onPointerCallback = (_this = this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this, outEvent);
            };
            this.windowOnPointerMove = (event)=>{
                var _this_onPointerCallback, _this;
                //BB.throwOut('pointermove ' + event.pointerId);
                const correctedEvent = $a07742141701d1f2$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' GLOBALpointermove');
                if (!this.dragPointerIdArr.includes(correctedEvent.pointerId)) return;
                const dragObj = this.getDragObj(correctedEvent.pointerId);
                if (!dragObj) // todo need to handle this!
                return;
                //if pointer changes button its pressing -> turn into pointerup
                if (correctedEvent.buttons !== dragObj.buttons) {
                    var _this_onPointerCallback1, _this1;
                    //pointer up
                    //remove listener
                    if (this.dragObjArr.length === 1) this.destroyDocumentListeners();
                    this.removeDragObj(correctedEvent.pointerId);
                    const outEvent = this.createPointerOutEvent('pointerup', correctedEvent, {
                        downPageX: dragObj.downPageX,
                        downPageY: dragObj.downPageY
                    });
                    (_this_onPointerCallback1 = (_this1 = this).onPointerCallback) === null || _this_onPointerCallback1 === void 0 ? void 0 : _this_onPointerCallback1.call(_this1, outEvent);
                    return;
                }
                // ipad likes to do this
                if (correctedEvent.pointerType === 'pen' && correctedEvent.pageX === dragObj.lastPageX && correctedEvent.pageY === dragObj.lastPageY && correctedEvent.timeStamp === dragObj.lastTimeStamp) //ignore
                return;
                const outEvent = this.createPointerOutEvent('pointermove', correctedEvent, {
                    downPageX: dragObj.downPageX,
                    downPageY: dragObj.downPageY,
                    button: $a07742141701d1f2$var$getButtonStr(correctedEvent.buttons),
                    pressure: correctedEvent.pressure
                });
                dragObj.lastPageX = correctedEvent.pageX;
                dragObj.lastPageY = correctedEvent.pageY;
                dragObj.lastTimeStamp = correctedEvent.timeStamp;
                (_this_onPointerCallback = (_this = this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this, outEvent);
            };
            this.windowOnPointerUp = (event)=>{
                var _this_onPointerCallback, _this;
                //BB.throwOut('pointerup ' + event.pointerId);
                const correctedEvent = $a07742141701d1f2$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' GLOBALpointerup');
                if (!this.dragPointerIdArr.includes(correctedEvent.pointerId)) return;
                //remove listener
                if (this.dragObjArr.length === 1) this.destroyDocumentListeners();
                const dragObj = this.removeDragObj(correctedEvent.pointerId);
                if (!dragObj) // todo need to handle this!
                return;
                const outEvent = this.createPointerOutEvent('pointerup', correctedEvent, {
                    downPageX: dragObj.downPageX,
                    downPageY: dragObj.downPageY
                });
                (_this_onPointerCallback = (_this = this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this, outEvent);
            };
            this.windowOnPointerLeave = (event)=>{
                var _this_onPointerCallback, _this;
                //BB.throwOut('pointerleave ' + event.pointerId);
                const correctedEvent = $a07742141701d1f2$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' onGlobalPointerLeave', event);
                if (!this.dragPointerIdArr.includes(correctedEvent.pointerId)) //} || event.target !== document) {
                return;
                //remove listener
                if (this.dragObjArr.length === 1) this.destroyDocumentListeners();
                const dragObj = this.removeDragObj(correctedEvent.pointerId);
                if (!dragObj) // todo need to handle this!
                return;
                const outEvent = this.createPointerOutEvent('pointerup', correctedEvent, {
                    downPageX: dragObj.downPageX,
                    downPageY: dragObj.downPageY
                });
                (_this_onPointerCallback = (_this = this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this, outEvent);
            };
            this.targetElement.addEventListener($a07742141701d1f2$var$pointerMoveEvt, this.onPointerMove, $a07742141701d1f2$var$OPTIONS_PASSIVE);
            this.targetElement.addEventListener($a07742141701d1f2$var$pointerDownEvt, this.onPointerDown, $a07742141701d1f2$var$OPTIONS_PASSIVE);
            if (!(0, $604d9bbf77127967$export$7728c852ca75bb6d)) {
                const touchToFakePointer = (touch, touchEvent, isDown)=>{
                    return {
                        pointerId: touch.identifier,
                        pointerType: 'touch',
                        pageX: touch.pageX,
                        pageY: touch.pageY,
                        clientX: touch.clientX,
                        clientY: touch.clientY,
                        button: isDown ? 0 : undefined,
                        buttons: isDown ? 1 : 0,
                        timeStamp: touchEvent.timeStamp,
                        target: touchEvent.target,
                        pressure: isDown ? 1 : 0,
                        preventDefault: ()=>touchEvent.preventDefault(),
                        stopPropagation: ()=>touchEvent.stopPropagation()
                    };
                };
                const handleTouch = (e, type)=>{
                    for(let i = 0; i < e.changedTouches.length; i++){
                        const touch = e.changedTouches[i];
                        const fakePointer = touchToFakePointer(touch, e, [
                            'start',
                            'move'
                        ].includes(type));
                        if (type === 'start') this.onPointerDown(fakePointer, false);
                        else if (type === 'move') this.windowOnPointerMove(fakePointer);
                        else if (type === 'end') this.windowOnPointerUp(fakePointer);
                        else this.windowOnPointerLeave(fakePointer);
                    }
                };
                this.onTouchStart = (e)=>{
                    e.preventDefault();
                    handleTouch(e, 'start');
                };
                this.onTouchMove = (e)=>{
                    handleTouch(e, 'move');
                };
                this.onTouchEnd = (e)=>{
                    handleTouch(e, 'end');
                };
                this.onTouchCancel = (e)=>{
                    handleTouch(e, 'cancel');
                };
                this.targetElement.addEventListener('touchstart', this.onTouchStart, $a07742141701d1f2$var$OPTIONS_PASSIVE);
                this.targetElement.addEventListener('touchmove', this.onTouchMove, $a07742141701d1f2$var$OPTIONS_PASSIVE);
                this.targetElement.addEventListener('touchend', this.onTouchEnd, $a07742141701d1f2$var$OPTIONS_PASSIVE);
                this.targetElement.addEventListener('touchcancel', this.onTouchCancel, $a07742141701d1f2$var$OPTIONS_PASSIVE);
            }
        }
        if (this.onWheelCallback) {
            this.onWheel = (e)=>{
                if (this.wheelCleaner) this.wheelCleaner.process(e);
                else finalizeWheelEvent(e);
            };
            this.targetElement.addEventListener('wheel', this.onWheel, {
                passive: !!p.isWheelPassive
            });
        }
        if (this.onEnterLeaveCallback) {
            this.onPointerEnter = (e)=>{
                var _this_onEnterLeaveCallback, _this;
                // workaround for Safari which can falsely fire pointerenter. For more details see below.
                if (!$a07742141701d1f2$var$pointerTypeMouseOccurred && e.pointerType === 'mouse') return;
                this.isOverCounter++;
                (_this_onEnterLeaveCallback = (_this = this).onEnterLeaveCallback) === null || _this_onEnterLeaveCallback === void 0 ? void 0 : _this_onEnterLeaveCallback.call(_this, true);
            };
            this.onPointerLeave = ()=>{
                var _this_onEnterLeaveCallback, _this;
                this.isOverCounter--;
                (_this_onEnterLeaveCallback = (_this = this).onEnterLeaveCallback) === null || _this_onEnterLeaveCallback === void 0 ? void 0 : _this_onEnterLeaveCallback.call(_this, false);
            };
            this.targetElement.addEventListener($a07742141701d1f2$var$pointerEnterEvt, this.onPointerEnter, $a07742141701d1f2$var$OPTIONS_PASSIVE);
            this.targetElement.addEventListener($a07742141701d1f2$var$pointerLeaveEvt, this.onPointerLeave, $a07742141701d1f2$var$OPTIONS_PASSIVE);
        }
        if (p.fixScribble) {
            //ipad scribble workaround https://developer.apple.com/forums/thread/662874
            this.onTouchMoveScribbleFix = (e)=>e.preventDefault();
            this.targetElement.addEventListener('touchmove', this.onTouchMoveScribbleFix, $a07742141701d1f2$var$OPTIONS_PASSIVE);
        }
    }
}
// Workaround for Safari (iOS/IPadOS 26.2) https://bugs.webkit.org/show_bug.cgi?id=305856
// The incorrect pointerenter event will be of type "mouse" although the click happened with "touch".
// This workaround won't work if the user uses both touch and mouse. The probability of that should be low enough.
let $a07742141701d1f2$var$pointerTypeMouseOccurred = false;
setTimeout(()=>{
    const listener = (e)=>{
        if (e.pointerType === 'mouse' && !$a07742141701d1f2$var$pointerTypeMouseOccurred) {
            $a07742141701d1f2$var$pointerTypeMouseOccurred = true;
            document.removeEventListener($a07742141701d1f2$var$pointerMoveEvt, listener);
        }
    };
    document.addEventListener($a07742141701d1f2$var$pointerMoveEvt, listener);
});


/*window['canvases'] = [];

window['printCanvases'] = () => {
    let total = 0;

    console.log(window['canvases'].map(item => {
        total += item.width * item.height;
        return {w: item.width, h: item.height};
    }));

    console.log('total: ' + (total * 4 / 1000 / 1000) + 'mb');
};*/ function $9f64dcf89d8f9132$export$cd3d1f114b139967(w, h) {
    const result = document.createElement('canvas');
    if (w && h) {
        result.width = w;
        result.height = h;
    }
    // window['canvases'].push(result);
    return result;
}



function $6b6f23a269032ad5$export$ba7ed3181f35c1cc(selection) {
    const path = new Path2D();
    selection.forEach((poly)=>{
        poly.forEach((ring)=>{
            ring.forEach((point, index)=>{
                if (index === 0) path.moveTo(...point);
                else path.lineTo(...point);
            });
        });
        path.closePath();
    });
    return path;
}
function $6b6f23a269032ad5$export$8f2be1db13cf0f94(poly) {
    let result = '';
    poly.forEach((poly)=>{
        poly.forEach((ring)=>{
            result += 'M';
            ring.forEach((point)=>{
                result += point.join(',') + ' ';
            });
        });
    });
    return result.trim();
}




function $9414f5ea41e9cf25$export$2c9e8a9632a706b2(a, b, f) {
    return a * (1 - f) + b * f;
}
function $9414f5ea41e9cf25$export$6c4a311cc157c764(ax, ay, bx, by) {
    return Math.sqrt(Math.pow(ax - bx, 2) + Math.pow(ay - by, 2));
}
function $9414f5ea41e9cf25$export$499eb56409f6cbc2(ax, ay, bx, by) {
    // faster because no square-root
    return Math.pow(ax - bx, 2) + Math.pow(ay - by, 2);
}
function $9414f5ea41e9cf25$export$a4f99f99d3e99cfa(x, y) {
    // faster because no square-root
    return x * x + y * y;
}
function $9414f5ea41e9cf25$export$627023b405ba5028(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x);
}
function $9414f5ea41e9cf25$export$c03a8450eabc2532(p1, p2) {
    return $9414f5ea41e9cf25$export$627023b405ba5028(p1, p2) * 180 / Math.PI;
}
function $9414f5ea41e9cf25$export$151bd845d70e2099(p, rect) {
    return rect.x <= p.x && p.x <= rect.x + rect.width && rect.y <= p.y && p.y <= rect.y + rect.height;
}
function $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4(num, min, max) {
    return num < min ? min : num > max ? max : num;
}
function $9414f5ea41e9cf25$export$bb628a54ab399bc9(x, y, deg) {
    const theta = deg * (Math.PI / 180);
    const cs = Math.cos(theta);
    const sn = Math.sin(theta);
    return {
        x: x * cs - y * sn,
        y: x * sn + y * cs
    };
}
function $9414f5ea41e9cf25$export$95ec0760d3d00713(center, point, deg) {
    const rot = $9414f5ea41e9cf25$export$bb628a54ab399bc9(point.x - center.x, point.y - center.y, deg);
    rot.x += center.x;
    rot.y += center.y;
    return rot;
}
function $9414f5ea41e9cf25$export$c0156198713d0f0(angleDeg, snapDegIncrement, maxDistDeg) {
    const modDeg = Math.abs(angleDeg % snapDegIncrement);
    const dist = Math.min(modDeg, snapDegIncrement - modDeg);
    if (dist <= maxDistDeg) angleDeg = Math.round(angleDeg / snapDegIncrement) * snapDegIncrement;
    return angleDeg;
}
function $9414f5ea41e9cf25$export$ec85425cac357ca9(angleDeg) {
    angleDeg = angleDeg % 360;
    if (angleDeg > 180) angleDeg -= 360;
    else if (angleDeg < -180) angleDeg += 360;
    return angleDeg;
}
function $9414f5ea41e9cf25$export$bbf9af158036c5e9(remainder, fDx, fDy) {
    remainder.x += fDx;
    remainder.y += fDy;
    const dX = Math.round(remainder.x);
    const dY = Math.round(remainder.y);
    remainder.x -= dX;
    remainder.y -= dY;
    return {
        dX: dX,
        dY: dY
    };
}
function $9414f5ea41e9cf25$export$94cce7adf2ec2d08(f) {
    if (f % 1 === 0) {
        if (f % 2 === 0) return f;
        return f + 1;
    }
    const above = Math.ceil(f);
    const below = Math.floor(f);
    if (above % 2 === 0) return above;
    else return below;
}
function $9414f5ea41e9cf25$export$f373b6a7b0c159a(f) {
    if (f % 1 === 0) {
        if (f % 2 === 0) return f + 1;
        return f;
    }
    const above = Math.ceil(f);
    const below = Math.floor(f);
    if (above % 2 === 1) return above;
    else return below;
}
function $9414f5ea41e9cf25$export$2077e0241d6afd3c(f, digits) {
    const digitMult = Math.pow(10, digits);
    return Math.round(f /* + Number.EPSILON*/  * digitMult) / digitMult;
}
function $9414f5ea41e9cf25$export$5aa63862e8b9c037(bounds) {
    return (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, bounds), {
        x1: Math.min(bounds.x1, bounds.x2),
        y1: Math.min(bounds.y1, bounds.y2),
        x2: Math.max(bounds.x1, bounds.x2),
        y2: Math.max(bounds.y1, bounds.y2)
    });
}
function $9414f5ea41e9cf25$export$f4467a4f41373bc7(target, bounds) {
    if (!bounds && !target) throw new Error('at least one param needs to be defined');
    if (!bounds) return target;
    if (!target) target = {
        type: bounds.type,
        x1: bounds.x1,
        y1: bounds.y1,
        x2: bounds.x2,
        y2: bounds.y2
    };
    else {
        target.x1 = Math.min(target.x1, bounds.x1);
        target.y1 = Math.min(target.y1, bounds.y1);
        target.x2 = Math.max(target.x2, bounds.x2);
        target.y2 = Math.max(target.y2, bounds.y2);
    }
    return target;
}
function $9414f5ea41e9cf25$export$83720aaadc272d85(bounds, limit) {
    if (!bounds) return undefined;
    if (!limit) return bounds;
    const x1 = Math.max(limit.x1, bounds.x1);
    const y1 = Math.max(limit.y1, bounds.y1);
    const x2 = Math.min(limit.x2, bounds.x2);
    const y2 = Math.min(limit.y2, bounds.y2);
    if (x1 > x2 || y1 > y2) return undefined;
    var _bounds_type;
    return {
        type: (_bounds_type = bounds === null || bounds === void 0 ? void 0 : bounds.type) !== null && _bounds_type !== void 0 ? _bounds_type : limit === null || limit === void 0 ? void 0 : limit.type,
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $9414f5ea41e9cf25$export$ddc1c0069d484d49(bounds, width, height) {
    if (!bounds) return undefined;
    return $9414f5ea41e9cf25$export$83720aaadc272d85(bounds, {
        type: 'index',
        x1: 0,
        y1: 0,
        x2: width - 1,
        y2: height - 1
    });
}
function $9414f5ea41e9cf25$export$b0036cbc597df324(bounds) {
    const x1 = Math.floor(bounds.x1);
    const y1 = Math.floor(bounds.y1);
    const x2 = Math.ceil(bounds.x2 - 1);
    const y2 = Math.ceil(bounds.y2 - 1);
    return {
        type: 'index',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $9414f5ea41e9cf25$export$86989866a3954672(bounds) {
    const x1 = bounds.x1;
    const y1 = bounds.y1;
    const x2 = bounds.x2 + 1;
    const y2 = bounds.y2 + 1;
    return {
        type: 'coordinate',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $9414f5ea41e9cf25$export$3488993c9d026384(bounds) {
    return {
        x: bounds.x1,
        y: bounds.y1,
        width: bounds.x2 - bounds.x1 + 1,
        height: bounds.y2 - bounds.y1 + 1
    };
}
function $9414f5ea41e9cf25$export$d89ccdf57354a99c(rect, type) {
    const x2 = rect.x + rect.width;
    const y2 = rect.y + rect.height;
    return type === 'index' ? {
        type: 'index',
        x1: rect.x,
        y1: rect.y,
        x2: x2 - 1,
        y2: y2 - 1
    } : {
        type: 'coordinate',
        x1: rect.x,
        y1: rect.y,
        x2: x2,
        y2: y2
    };
}
function $9414f5ea41e9cf25$export$4218cb0e42c2e7e(bounds) {
    const isIndex = bounds.type === 'index';
    return {
        x: bounds.x1,
        y: bounds.y1,
        width: bounds.x2 - bounds.x1 + (isIndex ? 1 : 0),
        height: bounds.y2 - bounds.y1 + (isIndex ? 1 : 0)
    };
}


function $13d5aa49e37e2734$export$dd0873c0fb3ccff6(canvas) {
    const resultCanvas = (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)(canvas.width, canvas.height);
    const ctx = resultCanvas.getContext('2d');
    if (!ctx) throw new Error('2d context not supported or canvas already initialized');
    ctx.drawImage(canvas, 0, 0);
    return resultCanvas;
}
function $13d5aa49e37e2734$export$39f92e86d1722f3a(canvas, options) {
    const ctx = canvas.getContext('2d', options);
    if (!ctx) throw new Error("couldn't get 2d context");
    return ctx;
}
async function $13d5aa49e37e2734$export$bd64872f2769a724(path) {
    const im = await (0, $fc4403c8ee6a33dc$export$2a09375022a33e78)(path);
    const canvas = (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)(im.width, im.height);
    const ctx = canvas.getContext('2d');
    ctx.drawImage(im, 0, 0);
    return canvas;
}
function $13d5aa49e37e2734$export$1555f643cc9a976(transform, scaleX, scaleY) {
    if (![
        1,
        -1
    ].includes(scaleX) || ![
        1,
        -1
    ].includes(scaleY) || transform.width % 1 !== 0 || transform.height % 1 !== 0 || Math.abs(transform.angleDeg) % 90 !== 0) return false;
    const whSwapped = Math.abs(transform.angleDeg - 90) % 180 === 0;
    const width = whSwapped ? transform.height : transform.width;
    const height = whSwapped ? transform.width : transform.height;
    return (Math.abs(width) % 2 === 0 && transform.x % 1 === 0 || Math.abs(width) % 2 === 1 && transform.x % 1 === 0.5) && (Math.abs(height) % 2 === 0 && transform.y % 1 === 0 || Math.abs(height) % 2 === 1 && transform.y % 1 === 0.5);
}
function $13d5aa49e37e2734$export$ded2b43392504635(destCtx, transformImage, transform, bounds, pixelated) {
    if (!bounds) bounds = {
        x: 0,
        y: 0,
        width: transformImage.width,
        height: transformImage.height
    };
    destCtx.save();
    if (pixelated) destCtx.imageSmoothingEnabled = false;
    else {
        destCtx.imageSmoothingEnabled = true;
        destCtx.imageSmoothingQuality = 'high';
    }
    destCtx.translate(transform.x, transform.y);
    destCtx.rotate(transform.angleDeg / 180 * Math.PI);
    destCtx.scale(transform.width > 0 ? 1 : -1, transform.height > 0 ? 1 : -1);
    destCtx.drawImage(transformImage, bounds.x, bounds.y, bounds.width, bounds.height, -Math.abs(transform.width) / 2, -Math.abs(transform.height) / 2, Math.abs(transform.width), Math.abs(transform.height));
    destCtx.restore();
}
function $13d5aa49e37e2734$export$425a419ef9fc761f(baseCanvas, transformImage, transformObj) {
    transformObj = (0, $fc4403c8ee6a33dc$export$af0d87255f3cfd7e)(transformObj);
    if (!transformObj.center) transformObj.center = {
        x: transformImage.width / 2,
        y: transformImage.height / 2
    };
    if (!transformObj.scale) transformObj.scale = {
        x: 1,
        y: 1
    };
    if (!transformObj.angleDegree) transformObj.angleDegree = 0;
    if (!transformObj.translate) transformObj.translate = {
        x: 0,
        y: 0
    };
    const ctx = baseCanvas.getContext('2d');
    if (!ctx) throw new Error('2d context not supported or canvas already initialized');
    ctx.save();
    if (Math.abs(transformObj.scale.x - 1) > 0.000001 || Math.abs(transformObj.scale.y - 1) > 0.000001 || Math.abs(transformObj.angleDegree % 90) > 0.000001) {
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
    } else ctx.imageSmoothingEnabled = false;
    ctx.translate(transformObj.translate.x, transformObj.translate.y);
    ctx.translate(transformObj.center.x, transformObj.center.y);
    ctx.rotate(transformObj.angleDegree / 180 * Math.PI);
    ctx.scale(transformObj.scale.x, transformObj.scale.y);
    ctx.translate(-transformObj.center.x, -transformObj.center.y);
    ctx.drawImage(transformImage, 0, 0, transformImage.width, transformImage.height);
    ctx.restore();
}
const $13d5aa49e37e2734$export$754559b36e94ea2f = function(size, isDark) {
    const canvas = (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)();
    let ctx;
    if (size < 1) {
        canvas.width = 1;
        canvas.height = 1;
        ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('2d context not supported or canvas already initialized');
        ctx.fillStyle = 'rgb(128, 128, 128)';
        ctx.fillRect(0, 0, 1, 1);
    } else {
        canvas.width = size * 2;
        canvas.height = size * 2;
        ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('2d context not supported or canvas already initialized');
        ctx.fillStyle = isDark ? 'rgb(90, 90, 90)' : 'rgb(255, 255, 255)';
        ctx.fillRect(0, 0, size * 2, size * 2);
        ctx.fillStyle = isDark ? 'rgb(63, 63, 63)' : 'rgb(200, 200, 200)';
        ctx.fillRect(0, 0, size, size);
        ctx.fillRect(size, size, size * 2, size * 2);
    }
    return canvas;
};
const $13d5aa49e37e2734$export$42af33c76b681867 = function() {
    // previously created dataUrls
    const cache = {};
    return function(size, callback, isDark) {
        const modeStr = isDark ? 'd' : 'l';
        function create(size) {
            size = parseInt('' + size);
            if (cache['' + size + modeStr]) return cache['' + size + modeStr];
            const canvas = $13d5aa49e37e2734$export$754559b36e94ea2f(size, isDark);
            const result = canvas.toDataURL('image/png');
            cache['' + size + modeStr] = result;
            return result;
        }
        if (callback) //async
        setTimeout(function() {
            callback(create(size));
        }, 1);
        else //sync
        return create(size);
    };
}();
function $13d5aa49e37e2734$export$59b33278b5b2fc8a(canvas, w, h, tmp1, tmp2) {
    //determine base 2 exponents of old and new size
    function getBase2Obj(oldW, oldH, newW, newH) {
        const result = {
            oldWidthEx: Math.round(Math.log2(oldW)),
            oldHeightEx: Math.round(Math.log2(oldH)),
            newWidthEx: Math.ceil(Math.log2(newW)),
            newHeightEx: Math.ceil(Math.log2(newH))
        };
        result.oldWidthEx = Math.max(result.oldWidthEx, result.newWidthEx);
        result.oldHeightEx = Math.max(result.oldHeightEx, result.newHeightEx);
        return result;
    }
    if (!w || !h || w === canvas.width && h === canvas.height) return;
    w = Math.max(w, 1);
    h = Math.max(h, 1);
    if (w <= canvas.width && h <= canvas.height) {
        tmp1 = !tmp1 ? (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)() : tmp1;
        tmp2 = !tmp2 ? (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)() : tmp2;
        const base2 = getBase2Obj(canvas.width, canvas.height, w, h);
        //initially scale to a base of 2. unless new size is too close to old. e.g. sizing from 900 to 600
        tmp2.width = base2.oldWidthEx > base2.newWidthEx ? Math.pow(2, base2.oldWidthEx) : w;
        tmp2.height = base2.oldHeightEx > base2.newHeightEx ? Math.pow(2, base2.oldHeightEx) : h;
        tmp1.getContext('2d').save();
        tmp2.getContext('2d').save();
        let ew, eh;
        let buffer1 = tmp1, buffer2 = tmp2;
        ew = base2.oldWidthEx;
        eh = base2.oldHeightEx;
        let bufferCtx = buffer2.getContext('2d');
        bufferCtx.imageSmoothingEnabled = true;
        bufferCtx.imageSmoothingQuality = 'high';
        bufferCtx.globalCompositeOperation = 'copy';
        bufferCtx.drawImage(canvas, 0, 0, buffer2.width, buffer2.height);
        let currentWidth = buffer2.width;
        let currentHeight = buffer2.height;
        //stepwise half the size
        for(; ew > base2.newWidthEx || eh > base2.newHeightEx; ew--, eh--){
            bufferCtx = buffer1.getContext('2d');
            bufferCtx.imageSmoothingEnabled = true;
            bufferCtx.imageSmoothingQuality = 'high';
            bufferCtx.globalCompositeOperation = 'copy';
            const newWidth = ew > base2.newWidthEx ? currentWidth / 2 : currentWidth;
            const newHeight = eh > base2.newHeightEx ? currentHeight / 2 : currentHeight;
            //buffer also needs to be properly sized, unfortunately
            buffer1.width = newWidth;
            buffer1.height = newHeight;
            bufferCtx.drawImage(buffer2, 0, 0, currentWidth, currentHeight, 0, 0, newWidth, newHeight);
            currentWidth = newWidth;
            currentHeight = newHeight;
            //swap
            const tmp = buffer1;
            buffer1 = buffer2;
            buffer2 = tmp;
        }
        //when no longer can be halved, bring to target size
        canvas.width = w;
        canvas.height = h;
        const canvasCtx = canvas.getContext('2d');
        canvasCtx.save();
        canvasCtx.imageSmoothingEnabled = true;
        canvasCtx.imageSmoothingQuality = 'high';
        canvasCtx.drawImage(buffer2, 0, 0, currentWidth, currentHeight, 0, 0, w, h);
        canvasCtx.restore();
        tmp1.getContext('2d').restore();
        tmp2.getContext('2d').restore();
    } else if (w >= canvas.width && h >= canvas.height) {
        tmp1 = !tmp1 ? (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)() : tmp1;
        tmp1.width = w;
        tmp1.height = h;
        const tmp1Ctx = tmp1.getContext('2d');
        tmp1Ctx.save();
        tmp1Ctx.imageSmoothingEnabled = true;
        tmp1Ctx.imageSmoothingQuality = 'high';
        tmp1Ctx.drawImage(canvas, 0, 0, w, h);
        tmp1Ctx.restore();
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(tmp1, 0, 0);
    } else {
        $13d5aa49e37e2734$export$59b33278b5b2fc8a(canvas, w, canvas.height, tmp1, tmp2);
        $13d5aa49e37e2734$export$59b33278b5b2fc8a(canvas, w, h, tmp1, tmp2);
    }
}
function $13d5aa49e37e2734$export$5a7576952c826b4f(canvas) {
    const imdat = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
    for(let i = 0; i < imdat.data.length; i += 4){
        if (imdat.data[i + 3] === 0) continue;
        imdat.data[i + 3] = (imdat.data[i] + imdat.data[i + 1] + imdat.data[i + 2]) / 3 * (imdat.data[i + 3] / 255);
    }
    canvas.getContext('2d').putImageData(imdat, 0, 0);
}
function $13d5aa49e37e2734$export$2384aff49c9b73c2(canvas) {
    canvas.width = 1;
    canvas.height = 1;
    canvas.remove();
}
function $13d5aa49e37e2734$export$c1fcf1f93aeabfbf(context, //restricts the search to this area.
searchArea) {
    const searchRect = searchArea ? (0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)(searchArea) : {
        x: 0,
        y: 0,
        width: context.canvas.width,
        height: context.canvas.height
    };
    if (searchRect.width <= 0 || searchRect.height <= 0) return undefined;
    const imdat = context.getImageData(searchRect.x, searchRect.y, searchRect.width, searchRect.height);
    // top-left and bottom-right are non-transparent.
    if (imdat.data[3] > 0 && imdat.data[imdat.data.length - 1] > 0) return searchRect;
    const tempBounds = {};
    for(let i = 3; i < imdat.data.length; i += 4)if (imdat.data[i] > 0) {
        const px = (i - 3) / 4 % searchRect.width;
        const py = Math.floor((i - 3) / 4 / searchRect.width);
        if (tempBounds.x1 === undefined || px < tempBounds.x1) tempBounds.x1 = px;
        if (tempBounds.y1 === undefined || py < tempBounds.y1) tempBounds.y1 = py;
        if (tempBounds.x2 === undefined || px + 1 > tempBounds.x2) tempBounds.x2 = px;
        if (tempBounds.y2 === undefined || py + 1 > tempBounds.y2) tempBounds.y2 = py;
    }
    if (tempBounds.x1 === undefined || tempBounds.y1 === undefined || tempBounds.x2 === undefined || tempBounds.y2 === undefined) return undefined;
    return {
        x: tempBounds.x1 + searchRect.x,
        y: tempBounds.y1 + searchRect.y,
        width: tempBounds.x2 - tempBounds.x1 + 1,
        height: tempBounds.y2 - tempBounds.y1 + 1
    };
}
function $13d5aa49e37e2734$export$f84fa3da4a94c138(ctx, x, y, width, height) {
    try {
        return ctx.getImageData(x, y, width, height);
    } catch (e) {
        return new ImageData(width, height);
    }
}
function $13d5aa49e37e2734$export$27e43d53d0895782(canvas, mimeType) {
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>{
            if (blob) resolve(blob);
            else reject(new Error('Failed to create blob from canvas.'));
        }, mimeType);
    });
}
async function $13d5aa49e37e2734$export$403d539f215df596(canvas, mimeType) {
    if ('toBlob' in HTMLCanvasElement.prototype) return await $13d5aa49e37e2734$export$27e43d53d0895782(canvas, mimeType);
    else // assume base64
    return (0, $fc4403c8ee6a33dc$export$b3fb17ae4345ac8f)(canvas.toDataURL(mimeType));
}
function $13d5aa49e37e2734$export$f7b95c0f504bef8b(selection, context) {
    const canvas = context.canvas;
    context.save();
    context.fillRect(0, 0, canvas.width, canvas.height);
    const selectionPath = (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(selection);
    context.clip(selectionPath);
    context.fillStyle = 'white';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.restore();
}


// https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Matrix_math_for_the_web
// not optimized
function $1460f8c17429a8fd$var$getIdentity() {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
// point • matrix
function $1460f8c17429a8fd$var$multiplyMatrixAndPoint(matrix, point) {
    return [
        point[0] * matrix[0] + point[1] * matrix[4] + point[2] * matrix[8] + point[3] * matrix[12],
        point[0] * matrix[1] + point[1] * matrix[5] + point[2] * matrix[9] + point[3] * matrix[13],
        point[0] * matrix[2] + point[1] * matrix[6] + point[2] * matrix[10] + point[3] * matrix[14],
        point[0] * matrix[3] + point[1] * matrix[7] + point[2] * matrix[11] + point[3] * matrix[15]
    ];
}
//matrixB • matrixA
function $1460f8c17429a8fd$var$multiplyMatrices(matrixA, matrixB) {
    // Slice the second matrix up into rows
    const row0 = [
        matrixB[0],
        matrixB[1],
        matrixB[2],
        matrixB[3]
    ];
    const row1 = [
        matrixB[4],
        matrixB[5],
        matrixB[6],
        matrixB[7]
    ];
    const row2 = [
        matrixB[8],
        matrixB[9],
        matrixB[10],
        matrixB[11]
    ];
    const row3 = [
        matrixB[12],
        matrixB[13],
        matrixB[14],
        matrixB[15]
    ];
    // Multiply each row by matrixA
    const result0 = $1460f8c17429a8fd$var$multiplyMatrixAndPoint(matrixA, row0);
    const result1 = $1460f8c17429a8fd$var$multiplyMatrixAndPoint(matrixA, row1);
    const result2 = $1460f8c17429a8fd$var$multiplyMatrixAndPoint(matrixA, row2);
    const result3 = $1460f8c17429a8fd$var$multiplyMatrixAndPoint(matrixA, row3);
    // Turn the result rows back into a single matrix
    return [
        result0[0],
        result0[1],
        result0[2],
        result0[3],
        result1[0],
        result1[1],
        result1[2],
        result1[3],
        result2[0],
        result2[1],
        result2[2],
        result2[3],
        result3[0],
        result3[1],
        result3[2],
        result3[3]
    ];
}
function $1460f8c17429a8fd$var$createTranslationMatrix(x, y) {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        x,
        y,
        0,
        1
    ];
}
function $1460f8c17429a8fd$var$createRotationMatrix(angleRad) {
    //let angleRad = angleDeg / 360 * 2 * Math.PI;
    return [
        Math.cos(-angleRad),
        -Math.sin(-angleRad),
        0,
        0,
        Math.sin(-angleRad),
        Math.cos(-angleRad),
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
function $1460f8c17429a8fd$var$createScaleMatrix(f) {
    return [
        f,
        0,
        0,
        0,
        0,
        f,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
const $1460f8c17429a8fd$export$5b12bf1653c0dd85 = Object.freeze({
    getIdentity: $1460f8c17429a8fd$var$getIdentity,
    multiplyMatrixAndPoint: $1460f8c17429a8fd$var$multiplyMatrixAndPoint,
    multiplyMatrices: $1460f8c17429a8fd$var$multiplyMatrices,
    createTranslationMatrix: $1460f8c17429a8fd$var$createTranslationMatrix,
    createRotationMatrix: $1460f8c17429a8fd$var$createRotationMatrix,
    createScaleMatrix: $1460f8c17429a8fd$var$createScaleMatrix
});


const $2890e4902986ac94$export$ac4bca90992eed1 = {
    add: function(p1, p2) {
        return {
            x: p1.x + p2.x,
            y: p1.y + p2.y
        };
    },
    sub: function(p1, p2) {
        return {
            x: p1.x - p2.x,
            y: p1.y - p2.y
        };
    },
    nor: function(p) {
        const len = Math.sqrt(Math.pow(p.x, 2) + Math.pow(p.y, 2));
        return {
            x: p.x / len,
            y: p.y / len
        };
    },
    len: function(p) {
        return Math.sqrt(Math.pow(p.x, 2) + Math.pow(p.y, 2));
    },
    dist: function(p1, p2) {
        return $2890e4902986ac94$export$ac4bca90992eed1.len($2890e4902986ac94$export$ac4bca90992eed1.sub(p1, p2));
    },
    mul: function(p, s) {
        return {
            x: p.x * s,
            y: p.y * s
        };
    },
    angle: function(p1, p2) {
        return Math.atan2(p2.y - p1.y, p2.x - p1.x);
    },
    dot: function(a, b) {
        const aArr = [
            a.x,
            a.y
        ];
        const bArr = [
            b.x,
            b.y
        ];
        return aArr.map((x, i)=>aArr[i] * bArr[i]).reduce((m, n)=>m + n);
    }
};





const $4e47553489a532e8$export$b4c5b177db876445 = function(lineStart, lineEnd, p) {
    let x, y;
    if (lineStart.x === lineEnd.x) {
        x = lineStart.x;
        y = p.y;
        return {
            x: x,
            y: y
        };
    }
    const m = (lineEnd.y - lineStart.y) / (lineEnd.x - lineStart.x);
    const b = lineStart.y - m * lineStart.x;
    x = (m * p.y + p.x - m * b) / (m * m + 1);
    y = (m * m * p.y + m * p.x + b) / (m * m + 1);
    return {
        x: x,
        y: y
    };
};
class $4e47553489a532e8$export$8b36a4a83269a640 {
    // ---- interface ----
    /**
     * returns point when traveling *dist* along the line, > 0
     * @param dist
     */ getAtDist(dist) {
        let remainder = Math.min(this.getLength(), dist);
        let i = 0;
        for(; remainder > this.segmentArr[i].length && i < this.segmentArr.length - 2; i++)remainder -= this.segmentArr[i].length;
        const fac = Math.min(1, Math.max(0, remainder / this.segmentArr[i].length));
        return {
            x: this.segmentArr[i].x * (1 - fac) + this.segmentArr[i + 1].x * fac,
            y: this.segmentArr[i].y * (1 - fac) + this.segmentArr[i + 1].y * fac
        };
    }
    /**
     * total length of line
     */ getLength() {
        let result = 0;
        for(let i = 0; i < this.segmentArr.length - 1; i++)result += this.segmentArr[i].length;
        return result;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.segmentArr = [];
        for(let i = 0; i < p.points.length; i++)((i)=>{
            let length = 0;
            if (i < p.points.length - 1) length = (0, $9414f5ea41e9cf25$export$6c4a311cc157c764)(p.points[i].x, p.points[i].y, p.points[i + 1].x, p.points[i + 1].y);
            this.segmentArr[i] = {
                x: p.points[i].x,
                y: p.points[i].y,
                length: length
            };
        })(i);
    }
}
class $4e47553489a532e8$export$5379d955c16d4d43 {
    /**
     * creates bezier curve from control points
     * @param p1 - control point 1 {x: float, y: float}
     * @param p2 - control point 2 {x: float, y: float}
     * @param p3 - control point 3 {x: float, y: float}
     * @param p4 - control point 4 {x: float, y: float}
     * @param resolution - int
     * @returns bezier curve made up of points {x: float, y: float}
     */ getBezierPoints(p1, p2, p3, p4, resolution) {
        const curvePoints = [];
        let t;
        for(let i = 0; i <= resolution; i++){
            t = i / resolution;
            curvePoints[curvePoints.length] = {
                x: Math.pow(1 - t, 3) * p1.x + 3 * Math.pow(1 - t, 2) * t * p2.x + 3 * (1 - t) * Math.pow(t, 2) * p3.x + Math.pow(t, 3) * p4.x,
                y: Math.pow(1 - t, 3) * p1.y + 3 * Math.pow(1 - t, 2) * t * p2.y + 3 * (1 - t) * Math.pow(t, 2) * p3.y + Math.pow(t, 3) * p4.y
            };
        }
        return curvePoints;
    }
    // ---- interface ----
    /**
     * Add new point to line. "Drawn" line will go until the previous point.
     *
     * @param x - coord of new point
     * @param y
     * @param spacing - space between each step
     * @param callback - calls for each step
     * @param controlsCallback - calls that callback with the bezier control points
     */ add(x, y, spacing, callback, controlsCallback) {
        if (this.lastPoint && x === this.lastPoint.x && y === this.lastPoint.y) return;
        this.lastPoint = {
            x: x,
            y: y
        };
        this.pointArr[this.pointArr.length] = {
            x: x,
            y: y,
            spacing: spacing
        };
        //calculate directions
        if (this.pointArr.length === 1) {
            this.lastSpacing = spacing;
            return;
        } else if (this.pointArr.length === 2) {
            this.pointArr[0].dir = (0, $2890e4902986ac94$export$ac4bca90992eed1).nor((0, $2890e4902986ac94$export$ac4bca90992eed1).sub(this.pointArr[1], this.pointArr[0]));
            this.lastDot = spacing;
            this.lastSpacing = spacing;
            return;
        } else {
            const pointM1 = this.pointArr[this.pointArr.length - 1];
            const pointM2 = this.pointArr[this.pointArr.length - 2];
            const pointM3 = this.pointArr[this.pointArr.length - 3];
            pointM2.dir = (0, $2890e4902986ac94$export$ac4bca90992eed1).nor((0, $2890e4902986ac94$export$ac4bca90992eed1).sub(pointM1, pointM3));
            if (isNaN(pointM2.dir.x) || isNaN(pointM2.dir.y)) //when xy -3 == -1
            pointM2.dir = (0, $fc4403c8ee6a33dc$export$af0d87255f3cfd7e)(pointM3.dir);
        }
        //get bezier curve
        const a = this.pointArr[this.pointArr.length - 3];
        const b = this.pointArr[this.pointArr.length - 2];
        const p1 = a;
        const p2 = (0, $2890e4902986ac94$export$ac4bca90992eed1).add(a, (0, $2890e4902986ac94$export$ac4bca90992eed1).mul(a.dir, (0, $2890e4902986ac94$export$ac4bca90992eed1).dist(a, b) / 4));
        const p3 = (0, $2890e4902986ac94$export$ac4bca90992eed1).sub(b, (0, $2890e4902986ac94$export$ac4bca90992eed1).mul(b.dir, (0, $2890e4902986ac94$export$ac4bca90992eed1).dist(a, b) / 4));
        const p4 = b;
        let pointLine;
        if (callback) {
            const curvePoints = this.getBezierPoints(p1, p2, p3, p4, 20);
            pointLine = new $4e47553489a532e8$export$8b36a4a83269a640({
                points: curvePoints
            });
        } else pointLine = new $4e47553489a532e8$export$8b36a4a83269a640({
            points: [
                p1,
                p4
            ]
        });
        //iterate over curve with spacing and callback
        const len = pointLine.getLength();
        let tempSpacing = (0, $9414f5ea41e9cf25$export$2c9e8a9632a706b2)(this.lastSpacing, spacing, (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(this.lastDot / len, 0, 1));
        let d = this.lastDot;
        for(; d <= len; d += tempSpacing){
            tempSpacing = (0, $9414f5ea41e9cf25$export$2c9e8a9632a706b2)(this.lastSpacing, spacing, (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(d / len, 0, 1));
            const point = pointLine.getAtDist(d);
            const angle = this.lastCallbackPoint ? (0, $9414f5ea41e9cf25$export$c03a8450eabc2532)(this.lastCallbackPoint, point) : undefined;
            if (callback) callback({
                x: point.x,
                y: point.y,
                t: d / len,
                angle: angle,
                dAngle: this.lastCallbackPoint ? angle - this.lastAngle : 0
            });
            this.lastCallbackPoint = point;
            this.lastAngle = angle;
        }
        if (callback) this.lastDot = d - len;
        else {
            this.lastDot = 0;
            controlsCallback === null || controlsCallback === void 0 ? void 0 : controlsCallback({
                p1: p1,
                p2: p2,
                p3: p3,
                p4: p4
            });
        }
        this.lastSpacing = spacing;
    }
    addFinal(spacing, callback, controlsCallback) {
        if (this.pointArr.length < 2) return;
        const p1 = this.pointArr[this.pointArr.length - 2];
        const p2 = this.pointArr[this.pointArr.length - 1];
        const newP = (0, $2890e4902986ac94$export$ac4bca90992eed1).add(p2, (0, $2890e4902986ac94$export$ac4bca90992eed1).sub(p2, p1));
        this.add(newP.x, newP.y, spacing, callback, controlsCallback);
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.lastDot = 0;
        this.pointArr = [];
    }
}
class $4e47553489a532e8$export$80967b1eb9fd6eb4 {
    // ---- interface ----
    getFirstX() {
        return this.first;
    }
    getLastX() {
        return this.last;
    }
    interpolate(x) {
        const n = this.ya.length;
        let klo = 0;
        let khi = n - 1;
        // We will find the right place in the table by means of
        // bisection. This is optimal if sequential calls to this
        // routine are at random values of x. If sequential calls
        // are in order, and closely spaced, one would do better
        // to store previous values of klo and khi.
        while(khi - klo > 1){
            const k = khi + klo >> 1;
            if (this.xa[k] > x) khi = k;
            else klo = k;
        }
        const h = this.xa[khi] - this.xa[klo];
        const a = (this.xa[khi] - x) / h;
        const b = (x - this.xa[klo]) / h;
        // Cubic spline polynomial is now evaluated.
        return a * this.ya[klo] + b * this.ya[khi] + ((a * a * a - a) * this.y2[klo] + (b * b * b - b) * this.y2[khi]) * (h * h) / 6.0;
    }
    /**
     * find x to y. simply by stepping through. suboptimal, so don't call often.
     * searches in x 0-1 range
     */ findX(y, resolution) {
        let x;
        let dist;
        for(let i = 0; i <= resolution; i++){
            const tempX = i / resolution;
            const tempY = this.interpolate(tempX);
            if (x === undefined) {
                x = tempX;
                dist = Math.abs(tempY - y);
                continue;
            }
            const tempDist = Math.abs(tempY - y);
            if (tempDist < dist) {
                x = tempX;
                dist = tempDist;
            } else break;
        }
        return x;
    }
    // ----------------------------------- public -----------------------------------
    constructor(points){
        const n = points.length;
        this.xa = [];
        this.ya = [];
        this.u = [];
        this.y2 = [];
        let i;
        this.first = points[0][0];
        this.last = points[points.length - 1][0];
        points.sort(function(a, b) {
            return a[0] - b[0];
        });
        for(i = 0; i < n; i++){
            this.xa.push(points[i][0]);
            this.ya.push(points[i][1]);
        }
        this.u[0] = 0;
        this.y2[0] = 0;
        for(i = 1; i < n - 1; ++i){
            // This is the decomposition loop of the tridiagonal algorithm.
            // y2 and u are used for temporary storage of the decomposed factors.
            const wx = this.xa[i + 1] - this.xa[i - 1];
            const sig = (this.xa[i] - this.xa[i - 1]) / wx;
            const p = sig * this.y2[i - 1] + 2.0;
            this.y2[i] = (sig - 1.0) / p;
            const ddydx = (this.ya[i + 1] - this.ya[i]) / (this.xa[i + 1] - this.xa[i]) - (this.ya[i] - this.ya[i - 1]) / (this.xa[i] - this.xa[i - 1]);
            this.u[i] = (6.0 * ddydx / wx - sig * this.u[i - 1]) / p;
        }
        this.y2[n - 1] = 0;
        // This is the backsubstitution loop of the tridiagonal algorithm
        for(i = n - 2; i >= 0; --i)this.y2[i] = this.y2[i] * this.y2[i + 1] + this.u[i];
    }
}
function $4e47553489a532e8$export$c07c3aaef9f2da42(startVal, endVal, stepSize, exponent = 2) {
    function round(v, dec) {
        return Math.round(v * Math.pow(10, dec)) / Math.pow(10, dec);
    }
    const resultArr = [];
    for(let i = 0; i <= 1; i += stepSize)resultArr.push([
        round(i, 4),
        round(startVal + Math.pow(i, exponent) * (endVal - startVal), 4)
    ]);
    return resultArr;
}


// based on js color conversion http://www.webtoolkit.info/
class $b68f66663c02a5d5$export$d2edaecd208aed43 {
    constructor(h, s, v){
        this.h = Math.max(0, Math.min(360, h));
        this.s = Math.max(0.001, Math.min(100, s)); //bug when 0
        this.v = Math.max(0, Math.min(100, v));
    }
}
class $b68f66663c02a5d5$export$8f9ece5a47764b93 {
    constructor(r, g, b){
        this.r = Math.max(0, Math.min(255, r));
        this.g = Math.max(0, Math.min(255, g));
        this.b = Math.max(0, Math.min(255, b));
    }
}
class $b68f66663c02a5d5$export$89d3f85304bf0767 {
    constructor(c, m, y, k){
        this.c = Math.max(0, Math.min(100, c));
        this.m = Math.max(0, Math.min(100, m));
        this.y = Math.max(0, Math.min(100, y));
        this.k = Math.max(0, Math.min(100, k));
    }
}
const $b68f66663c02a5d5$export$fb7efcd2e153af6e = {
    _RGBtoHSV: function(RGB) {
        const result = new $b68f66663c02a5d5$export$d2edaecd208aed43(0, 0, 0);
        const r = RGB.r / 255;
        const g = RGB.g / 255;
        const b = RGB.b / 255;
        const minVal = Math.min(r, g, b);
        const maxVal = Math.max(r, g, b);
        const delta = maxVal - minVal;
        result.v = maxVal;
        if (delta == 0) {
            result.h = 0;
            result.s = 0;
        } else {
            result.s = delta / maxVal;
            const del_R = ((maxVal - r) / 6 + delta / 2) / delta;
            const del_G = ((maxVal - g) / 6 + delta / 2) / delta;
            const del_B = ((maxVal - b) / 6 + delta / 2) / delta;
            if (r == maxVal) result.h = del_B - del_G;
            else if (g == maxVal) result.h = 1 / 3 + del_R - del_B;
            else if (b == maxVal) result.h = 2 / 3 + del_G - del_R;
            if (result.h < 0) result.h += 1;
            if (result.h > 1) result.h -= 1;
        }
        result.h = Math.round(result.h * 360);
        result.s = Math.round(result.s * 100);
        result.v = Math.round(result.v * 100);
        return result;
    },
    _HSVtoRGB: function(HSV) {
        const result = new $b68f66663c02a5d5$export$8f9ece5a47764b93(0, 0, 0);
        let var_h, var_i, var_1, var_2, var_3, var_r, var_g, var_b;
        const h = HSV.h / 360 % 1;
        const s = HSV.s / 100;
        const v = HSV.v / 100;
        if (s == 0) {
            result.r = v * 255;
            result.g = v * 255;
            result.b = v * 255;
        } else {
            var_h = h * 6;
            var_i = Math.floor(var_h);
            var_1 = v * (1 - s);
            var_2 = v * (1 - s * (var_h - var_i));
            var_3 = v * (1 - s * (1 - (var_h - var_i)));
            if (var_i == 0) {
                var_r = v;
                var_g = var_3;
                var_b = var_1;
            } else if (var_i == 1) {
                var_r = var_2;
                var_g = v;
                var_b = var_1;
            } else if (var_i == 2) {
                var_r = var_1;
                var_g = v;
                var_b = var_3;
            } else if (var_i == 3) {
                var_r = var_1;
                var_g = var_2;
                var_b = v;
            } else if (var_i == 4) {
                var_r = var_3;
                var_g = var_1;
                var_b = v;
            } else {
                var_r = v;
                var_g = var_1;
                var_b = var_2;
            }
            result.r = var_r * 255;
            result.g = var_g * 255;
            result.b = var_b * 255;
            result.r = Math.round(result.r);
            result.g = Math.round(result.g);
            result.b = Math.round(result.b);
        }
        return result;
    },
    _CMYKtoRGB: function(CMYK) {
        const result = new $b68f66663c02a5d5$export$8f9ece5a47764b93(0, 0, 0);
        const c = CMYK.c / 100;
        const m = CMYK.m / 100;
        const y = CMYK.y / 100;
        const k = CMYK.k / 100;
        result.r = 1 - Math.min(1, c * (1 - k) + k);
        result.g = 1 - Math.min(1, m * (1 - k) + k);
        result.b = 1 - Math.min(1, y * (1 - k) + k);
        result.r = Math.round(result.r * 255);
        result.g = Math.round(result.g * 255);
        result.b = Math.round(result.b * 255);
        return result;
    },
    _RGBtoCMYK: function(RGB) {
        const result = new $b68f66663c02a5d5$export$89d3f85304bf0767(0, 0, 0, 0);
        const r = RGB.r / 255;
        const g = RGB.g / 255;
        const b = RGB.b / 255;
        result.k = Math.min(1 - r, 1 - g, 1 - b);
        result.c = (1 - r - result.k) / (1 - result.k);
        result.m = (1 - g - result.k) / (1 - result.k);
        result.y = (1 - b - result.k) / (1 - result.k);
        result.c = Math.round(result.c * 100);
        result.m = Math.round(result.m * 100);
        result.y = Math.round(result.y * 100);
        result.k = Math.round(result.k * 100);
        return result;
    },
    toRGB: function(o) {
        if (o instanceof $b68f66663c02a5d5$export$8f9ece5a47764b93) return o;
        if (o instanceof $b68f66663c02a5d5$export$d2edaecd208aed43) return this._HSVtoRGB(o);
        if (o instanceof $b68f66663c02a5d5$export$89d3f85304bf0767) return this._CMYKtoRGB(o);
        throw new Error('unknown type');
    },
    toHSV: function(o) {
        if (o instanceof $b68f66663c02a5d5$export$d2edaecd208aed43) return o;
        if (o instanceof $b68f66663c02a5d5$export$8f9ece5a47764b93) return this._RGBtoHSV(o);
        if (o instanceof $b68f66663c02a5d5$export$89d3f85304bf0767) return this._RGBtoHSV(this._CMYKtoRGB(o));
        throw new Error('unknown type');
    },
    toCMYK: function(o) {
        if (o instanceof $b68f66663c02a5d5$export$89d3f85304bf0767) return o;
        if (o instanceof $b68f66663c02a5d5$export$8f9ece5a47764b93) return this._RGBtoCMYK(o);
        if (o instanceof $b68f66663c02a5d5$export$d2edaecd208aed43) return this._RGBtoCMYK(this._HSVtoRGB(o));
        throw new Error('unknown type');
    },
    toHexString: function(o) {
        if (o instanceof $b68f66663c02a5d5$export$8f9ece5a47764b93 || 'r' in o && 'g' in o && 'b' in o) {
            let ha = parseInt('' + o.r).toString(16);
            let hb = parseInt('' + o.g).toString(16);
            let hc = parseInt('' + o.b).toString(16);
            if (ha.length == 1) ha = '0' + ha;
            if (hb.length == 1) hb = '0' + hb;
            if (hc.length == 1) hc = '0' + hc;
            return ha + hb + hc;
        }
        return '#000';
    },
    toRgbStr: function(rgbObj) {
        return 'rgb(' + Math.round(rgbObj.r) + ', ' + Math.round(rgbObj.g) + ', ' + Math.round(rgbObj.b) + ')';
    },
    toRgbaStr: function(rgbaObj) {
        return 'rgba(' + Math.round(rgbaObj.r) + ', ' + Math.round(rgbaObj.g) + ', ' + Math.round(rgbaObj.b) + ', ' + rgbaObj.a + ')';
    },
    hexToRGB: function(hexStr) {
        hexStr = hexStr.trim();
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hexStr = hexStr.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexStr);
        return result ? new $b68f66663c02a5d5$export$8f9ece5a47764b93(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)) : undefined;
    }
};
function $b68f66663c02a5d5$export$5cf396345d1238ae(rgbObj) {
    return rgbObj.r * 0.299 + rgbObj.g * 0.587 + rgbObj.b * 0.114 < 125;
}




function $52ad4d7a7d6372c1$export$7868464f598ba79d(target, text) {
    const div = document.createElement('div');
    div.innerHTML = text;
    target.append(div);
    return div;
}
function $52ad4d7a7d6372c1$export$906dfdb7df31ccfc(getAll = false) {
    var _document_activeElement;
    const result = !!document.activeElement && [
        'INPUT',
        'TEXTAREA',
        'SELECT'
    ].includes(document.activeElement.tagName);
    if (getAll) return result;
    else return result && !((_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.getAttribute('data-ignore-focus'));
}
function $52ad4d7a7d6372c1$export$e05240ca9e0b8bd9() {
    if ($52ad4d7a7d6372c1$export$906dfdb7df31ccfc(true)) {
        /*
            Unfocus anything that is focused.

            If an Input is focused in Firefox, and it gets detached from the DOM via a Node
            that isn't its direct parent, then Firefox will keep anything attached to this
            Input in memory. It will not be garbage collected until a new Input is focused.

            Workaround: Temporarily create an input, focus it, detach it.
             */ const focusEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: document.body,
            tagName: 'input',
            css: {
                opacity: '0',
                width: '0',
                height: '0'
            }
        });
        setTimeout(()=>{
            focusEl.select();
            focusEl.focus();
            focusEl.remove();
        }, 10);
    }
}
function $52ad4d7a7d6372c1$export$a3d02541b0ebf605() {
    if (window.getSelection) {
        const sel = window.getSelection();
        if (sel) {
            if (sel.empty) sel.empty();
            else if (sel.removeAllRanges) sel.removeAllRanges();
        }
    }
}
const $52ad4d7a7d6372c1$export$6bd63bfceaafae0c = function() {
    function preventFocus(event) {
        event.preventDefault();
        let didFocusRelated = false;
        if (event.relatedTarget) try {
            event.relatedTarget.focus();
            didFocusRelated = true;
        } catch (e) {
            console.error('failed to focus');
        }
        if (!didFocusRelated) event.currentTarget.blur();
    }
    return function(el) {
        el.setAttribute('tabindex', '-1');
        el.addEventListener('focus', preventFocus);
    };
}();
const $52ad4d7a7d6372c1$var$els = [];
function $52ad4d7a7d6372c1$export$c3da0dad1b44eea9(params) {
    if (!params) return document.createElement('div');
    const result = document.createElement(params.tagName ? params.tagName : 'div');
    params.css && (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(result, params.css);
    if (params.content) {
        if (typeof params.content === "string") result.innerHTML = params.content;
        else if (Array.isArray(params.content)) (0, $d9f9f4926aa80a1c$export$921068d8846a1559).append(result, params.content);
        else result.append(params.content);
    }
    if (params.textContent) result.textContent = params.textContent;
    if (params.className) result.className = params.className;
    if (params.id) result.id = params.id;
    if (params.parent) params.parent.append(result);
    if ('title' in params && params.title !== undefined) result.title = params.title;
    const listeners = [];
    if (params.onClick !== undefined) {
        result.addEventListener('click', params.onClick);
        !params.noRef && listeners.push([
            'click',
            params.onClick
        ]);
    }
    if (params.onChange !== undefined) {
        result.addEventListener('change', params.onChange);
        !params.noRef && listeners.push([
            'change',
            params.onChange
        ]);
    }
    if (listeners.length > 0) $52ad4d7a7d6372c1$var$els.push({
        el: result,
        listeners: listeners
    });
    if ('custom' in params && params.custom) {
        const customKeyArr = Object.keys(params.custom);
        for(let i = 0; i < customKeyArr.length; i++)result.setAttribute(customKeyArr[i], params.custom[customKeyArr[i]]);
    }
    return result;
}
function $52ad4d7a7d6372c1$export$b1da1db524e22115(el) {
    if (!el) return;
    for(let i = 0; i < $52ad4d7a7d6372c1$var$els.length; i++){
        const item = $52ad4d7a7d6372c1$var$els[i];
        if (item.el === el) {
            item.listeners.forEach((item)=>{
                el.removeEventListener(item[0], item[1]);
            });
            $52ad4d7a7d6372c1$var$els.splice(i, 1);
            return;
        }
    }
    // not found
    return;
}
function $52ad4d7a7d6372c1$export$ec664d7487540b(p) {
    const result = new Image();
    if (p.src !== undefined) result.src = p.src;
    if (p.alt !== undefined) result.alt = p.alt;
    if (p.width !== undefined) result.width = p.width;
    if (p.height !== undefined) result.height = p.height;
    if (p.className !== undefined) result.className = p.className;
    p.css && (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(result, p.css);
    return result;
}




/**
 * LocalStorage wrapper that does not throw exceptions.
 * If cookies disabled in Safari localStorage interactions throw exception "insecure operation"
 */ class $0ecef66681b62a8c$export$19fffca37ef3e106 {
    static getItem(key) {
        // (disabled) eslint-disable-next-line no-null/no-null
        let result = null;
        try {
            result = localStorage.getItem(key);
        } catch (e) {
            this.error = e;
        }
        return result;
    }
    static setItem(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            this.error = e;
        }
    }
    static removeItem(key) {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            this.error = e;
        }
    }
    static getError() {
        return this.error;
    }
}



class $2df67d7abe113884$export$fe11e0afe623a677 {
    // ----------------------------------- public -----------------------------------
    setChainOut(func) {
        this.chainOut = func;
    }
    chainIn(event) {
        if (event.type === 'pointermove') {
            if (event.coalescedArr && event.coalescedArr.length > 0) for(let i = 0; i < event.coalescedArr.length; i++){
                const eventCopy = (0, $fc4403c8ee6a33dc$export$af0d87255f3cfd7e)(event);
                if (i === 0) eventCopy.coalescedArr = [];
                const coalescedItem = event.coalescedArr[i];
                eventCopy.pageX = coalescedItem.pageX;
                eventCopy.pageY = coalescedItem.pageY;
                eventCopy.relX = coalescedItem.relX;
                eventCopy.relY = coalescedItem.relY;
                eventCopy.dX = coalescedItem.dX;
                eventCopy.dY = coalescedItem.dY;
                eventCopy.time = coalescedItem.time;
                eventCopy.isCoalesced = i < event.coalescedArr.length - 1;
                this.chainOut && this.chainOut(eventCopy);
            }
            else return event;
        } else return event;
        return null;
    }
}



class $ee2eb319667e1e48$export$510622b8aed00381 {
    failGesture() {
        if (this.eventQueueArr.length === 0) return;
        this.timeoutObj.firstLastDownTimeout && clearTimeout(this.timeoutObj.firstLastDownTimeout);
        this.timeoutObj.tapTimeout && clearTimeout(this.timeoutObj.tapTimeout);
        for(let i = 0; i < this.eventQueueArr.length; i++)this.chainOut && this.chainOut(this.eventQueueArr[i]);
        this.eventQueueArr = [];
        this.fingerArr = [];
    }
    success() {
        this.timeoutObj.firstLastDownTimeout && clearTimeout(this.timeoutObj.firstLastDownTimeout);
        this.timeoutObj.tapTimeout && clearTimeout(this.timeoutObj.tapTimeout);
        this.eventQueueArr = []; // events get swallowed
        this.fingerArr = [];
        this.onTap();
    }
    setupTimeout(timeoutStr, timeMS) {
        const diff = timeMS - this.nowTime;
        //console.log(fingers + ': ' + timeoutStr + ' diff', diff);
        if (diff <= 0) // time already up
        return false;
        this.timeoutObj[timeoutStr] = setTimeout(()=>this.failGesture(), diff);
        return true;
    }
    processEvent(event) {
        const tempLastEventTime = this.lastEventTime;
        this.lastEventTime = event.time;
        if (event.type === 'pointerdown') this.pointersDownIdArr.push(event.pointerId);
        else if (event.type === 'pointerup') {
            for(let i = 0; i < this.pointersDownIdArr.length; i++)if (this.pointersDownIdArr[i] === event.pointerId) {
                this.pointersDownIdArr.splice(i, 1);
                break;
            }
        }
        if (event.pointerType !== 'touch') {
            if (this.fingerArr.length > 0) // already in gesture -> fail
            this.failGesture();
            return;
        }
        this.nowTime = performance.now();
        if (event.type === 'pointerdown') {
            //console.log('down');
            if (this.fingerArr.length + 1 !== this.pointersDownIdArr.length) {
                // failed before, and some fingers are still down -> fail
                this.failGesture();
                return;
            }
            if (this.fingerArr.length === this.fingers) {
                // too many fingers down -> fail
                //console.log(fingers + ': too many fingers down -> fail');
                this.failGesture();
                return;
            }
            if (this.fingerArr.length > 0 && event.time - this.maxFirstLastFingerDownMs > this.fingerArr[0].downTimeMs) {
                // took too long to touch with all fingers -> fail
                //console.log(fingers + ': took too long to touch with all fingers -> fail');
                this.failGesture();
                return;
            }
            if (this.fingerArr.length === 0 && event.time - this.minSilenceBeforeDurationMs < tempLastEventTime) {
                // not enough silence before -> fail
                //console.log(fingers + ': not enough silence before -> fail');
                this.failGesture();
                return;
            }
            if (this.fingerArr.length === 0) {
                this.firstDownTime = event.time;
                if (!this.setupTimeout('firstLastDownTimeout', event.time + this.maxFirstLastFingerDownMs) || !this.setupTimeout('tapTimeout', event.time + this.maxTapMs)) {
                    // timeouts already up -> fail
                    this.failGesture();
                    return;
                }
            }
            this.fingerArr.push({
                pointerId: event.pointerId,
                downTimeMs: event.time,
                downPageX: event.pageX,
                downPageY: event.pageY
            });
            return;
        }
        if (event.type === 'pointermove') {
            if (this.fingerArr.length === 0) //not in a gesture -> ignore
            return;
            let fingerObj = null;
            for(let i = 0; i < this.fingerArr.length; i++)if (this.fingerArr[i].pointerId === event.pointerId) {
                fingerObj = this.fingerArr[i];
                break;
            }
            if (fingerObj === null) {
                // finger not part of the tap is on screen -> fail
                this.failGesture();
                return;
            }
            if (event.time - this.maxTapMs > this.firstDownTime) {
                // tap took too long -> fail
                //console.log(fingers + ': tap took too long -> fail');
                this.failGesture();
                return;
            }
            const distance = (0, $9414f5ea41e9cf25$export$6c4a311cc157c764)(event.pageX, event.pageY, fingerObj.downPageX, fingerObj.downPageY);
            if (distance > this.maxPressedDistancePx) {
                // finger moved too much -> fail
                //console.log(fingers + ': a finger moved too much -> fail', distance);
                this.failGesture();
                return;
            }
        }
        if (event.type === 'pointerup') {
            if (this.fingerArr.length === 0) //not in a gesture -> ignore
            return;
            //console.log('up', event.pageX, event.pageY);
            if (this.fingerArr.length !== this.fingers) {
                // not enough fingers -> fail
                //console.log(fingers + ': not enough fingers -> fail');
                this.failGesture();
                return;
            }
            let fingerObj = null;
            let i = 0;
            for(; i < this.fingerArr.length; i++)if (this.fingerArr[i].pointerId === event.pointerId) {
                fingerObj = this.fingerArr[i];
                break;
            }
            if (fingerObj === null) //do nothing
            return;
            if (event.time - this.maxTapMs > this.firstDownTime) {
                // tap took too long -> fail
                //console.log(fingers + ': tap took too long -> fail');
                this.failGesture();
                return;
            }
            const distance = (0, $9414f5ea41e9cf25$export$6c4a311cc157c764)(event.pageX, event.pageY, fingerObj.downPageX, fingerObj.downPageY);
            if (distance > this.maxPressedDistancePx) {
                // finger moved too much -> fail
                //console.log(fingers + ': b finger moved too much -> fail', distance, event.pageX, event.pageY);
                //console.log(fingerArr);
                this.failGesture();
                return;
            }
            fingerObj.isUp = true;
            let allAreUp = true;
            for(let i = 0; i < this.fingerArr.length; i++)if (!this.fingerArr[i].isUp) {
                allAreUp = false;
                break;
            }
            //console.log('fingerArr', fingerArr);
            if (allAreUp) {
                // success
                this.success();
                return true;
            }
        }
    }
    chainIn(event) {
        const result = this.processEvent(event);
        //console.log(fingerArr.length);
        if (result === true) //tap success -> event gets swallowed
        return null;
        if (this.fingerArr.length === 0) return event;
        else this.eventQueueArr.push(event);
        return null;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.minSilenceBeforeDurationMs = 50;
        this.maxTapMs = 500;
        this.maxFirstLastFingerDownMs = 250;
        this.maxPressedDistancePx = 12 //5 + fingers * 5;
        ;
        this.fingerArr = [];
        this.eventQueueArr = [];
        this.firstDownTime = 0;
        this.lastEventTime = 0;
        this.nowTime = performance.now();
        this.pointersDownIdArr = [];
        this.timeoutObj = {
            firstLastDownTimeout: null,
            tapTimeout: null
        };
        this.fingers = p.fingers;
        this.onTap = p.onTap;
    }
}



class $5ba93bbe34fd1582$export$d62358ac2d82abb3 {
    end() {
        this.gestureObj = null;
        this.eventQueueArr = [];
    }
    fail(doSwallow) {
        if (!this.gestureObj) // no gesture happening -> ignore
        return;
        this.timeoutObj.secondFingerTimeout && clearTimeout(this.timeoutObj.secondFingerTimeout);
        if (!doSwallow) for(let i = 0; i < this.eventQueueArr.length; i++)this.chainOut && this.chainOut(this.eventQueueArr[i]);
        this.end();
    }
    setupFailTimeout(timeMS) {
        const diff = timeMS - this.nowTime;
        if (diff <= 0) // time already up
        return false;
        this.timeoutObj.secondFingerTimeout = setTimeout(()=>this.fail(), diff);
        return true;
    }
    processEvent(event) {
        if (event.type === 'pointerdown') this.pointersDownIdArr.push(event.pointerId);
        else if (event.type === 'pointerup') {
            for(let i = 0; i < this.pointersDownIdArr.length; i++)if (this.pointersDownIdArr[i] === event.pointerId) {
                this.pointersDownIdArr.splice(i, 1);
                break;
            }
        }
        //pass through scenarios
        if (!this.gestureObj && (event.pointerType !== 'touch' || // wrong pointer type
        event.type === 'pointermove' && this.pointersDownIdArr.length > 0 || // failed before
        this.pointersDownIdArr.length > 1 || // failed before
        event.type === 'pointerup' // failed before
        )) return;
        this.nowTime = performance.now();
        //pointer down
        if (event.type === 'pointerdown') {
            if (this.gestureObj) {
                if (event.pointerType === 'touch') {
                    // touch finger down - as nth pointer
                    this.gestureObj.touchPointerArr.push({
                        pointerId: event.pointerId,
                        relX: event.relX,
                        relY: event.relY
                    });
                    if (this.gestureObj.isInProgress) this.continuePinch(this.gestureObj, {
                        type: 'down',
                        index: this.gestureObj.touchPointerArr.length - 1
                    });
                    else {
                        this.timeoutObj.secondFingerTimeout && clearTimeout(this.timeoutObj.secondFingerTimeout);
                        this.gestureObj.isInProgress = true;
                        this.beginPinch(this.gestureObj);
                    }
                    return;
                } else {
                    // non-touch finger down - as nth pointer
                    if (this.gestureObj.isInProgress) this.gestureObj.otherPointerIdArr.push(event.pointerId);
                    else // second pointer wrong type -> fail
                    this.fail();
                    return;
                }
            } else {
                // first finger down - can only be touch if no gestureObj
                this.gestureObj = {
                    touchPointerArr: [
                        {
                            pointerId: event.pointerId,
                            relX: event.relX,
                            relY: event.relY,
                            downRelX: event.relX,
                            downRelY: event.relY
                        }
                    ],
                    otherPointerIdArr: [],
                    isInProgress: false
                };
                if (!this.setupFailTimeout(event.time + this.untilSecondFingerDurationMs)) {
                    // time ran out -> fail
                    this.fail();
                    return;
                }
                return;
            }
        }
        // should not happen. something went wrong
        if (!this.gestureObj) {
            // throw? would make it less robust
            this.fail();
            return;
        }
        //pointer move
        if (event.type === 'pointermove' && event.pointerType === 'touch') {
            //gesture object should always exist here
            let touchPointerObj = null;
            let i = 0;
            for(; i < this.gestureObj.touchPointerArr.length; i++)if (event.pointerId === this.gestureObj.touchPointerArr[i].pointerId) {
                touchPointerObj = this.gestureObj.touchPointerArr[i];
                break;
            }
            //null should not be possible. something went wrong
            if (!touchPointerObj) {
                // throw? would make it less robust
                this.fail();
                return;
            }
            touchPointerObj.relX = event.relX;
            touchPointerObj.relY = event.relY;
            if (!this.gestureObj.isInProgress) {
                // only one finger down & pinching hasn't started
                // should not happen. something went wrong
                if (!('downRelX' in touchPointerObj && touchPointerObj.downRelX !== undefined) || !('downRelY' in touchPointerObj && touchPointerObj.downRelY !== undefined)) {
                    this.fail();
                    return;
                }
                const distance = (0, $9414f5ea41e9cf25$export$6c4a311cc157c764)(touchPointerObj.downRelX, touchPointerObj.downRelY, touchPointerObj.relX, touchPointerObj.relY);
                if (distance > this.firstFingerMaxDistancePx) {
                    // moved too much -> fail
                    this.fail();
                    return;
                }
            } else if (i < 2) // only first two touches can affect pinching
            this.continuePinch(this.gestureObj, {
                type: 'move',
                index: i
            });
            return;
        }
        //pointer up
        if (event.type === 'pointerup') {
            //gesture object should always exist here
            if (event.pointerType === 'touch') {
                let i = 0;
                for(; i < this.gestureObj.touchPointerArr.length; i++)if (this.gestureObj.touchPointerArr[i].pointerId === event.pointerId) {
                    this.gestureObj.touchPointerArr.splice(i, 1);
                    break;
                }
                if (this.gestureObj.touchPointerArr.length > 0) this.continuePinch(this.gestureObj, {
                    type: 'up',
                    index: i
                });
            } else {
                // non-touch
                for(let i = 0; i < this.gestureObj.otherPointerIdArr.length; i++)if (this.gestureObj.otherPointerIdArr[i] === event.pointerId) {
                    this.gestureObj.otherPointerIdArr.splice(i, 1);
                    break;
                }
            }
            //all fingers lifted?
            if (this.gestureObj.touchPointerArr.length === 0 && this.gestureObj.otherPointerIdArr.length === 0) {
                if (this.gestureObj.isInProgress) {
                    // lifted last finger -> end of pinching
                    this.end();
                    this.endPinch();
                } else // lifted finger again before pinching started -> fail
                this.fail();
                return;
            }
        }
    }
    beginPinch(gestureObj) {
        for(let i = 0; i < gestureObj.touchPointerArr.length; i++){
            const pointerObj = gestureObj.touchPointerArr[i];
            this.pincherArr.push({
                pointerId: pointerObj.pointerId,
                relX: pointerObj.relX,
                relY: pointerObj.relY,
                downRelX: pointerObj.relX,
                downRelY: pointerObj.relY
            });
        }
        const event = {
            type: 'move',
            // temp
            downRelX: 0,
            downRelY: 0,
            relX: 0,
            relY: 0,
            angleRad: 0,
            scale: 1
        };
        if (this.pincherArr.length === 1) {
            event.relX = this.pincherArr[0].downRelX;
            event.relY = this.pincherArr[0].downRelY;
        } else {
            event.relX = 0.5 * (this.pincherArr[0].downRelX + this.pincherArr[1].downRelX);
            event.relY = 0.5 * (this.pincherArr[0].downRelY + this.pincherArr[1].downRelY);
        }
        event.downRelX = event.relX;
        event.downRelY = event.relY;
        this.onPinch(event);
    }
    //actionObj = {type: 'down'|'move'|'up', index: number}
    continuePinch(gestureObj, actionObj) {
        if (actionObj.index > 1) // only first two pointers matter
        return;
        if (actionObj.type === 'move') {
            let event;
            this.pincherArr[actionObj.index].relX = gestureObj.touchPointerArr[actionObj.index].relX;
            this.pincherArr[actionObj.index].relY = gestureObj.touchPointerArr[actionObj.index].relY;
            if (this.pincherArr.length === 1) event = {
                type: 'move',
                downRelX: this.pincherArr[0].downRelX,
                downRelY: this.pincherArr[0].downRelY,
                relX: this.pincherArr[0].relX,
                relY: this.pincherArr[0].relY,
                angleRad: 0,
                scale: 1
            };
            else {
                const startDist = (0, $9414f5ea41e9cf25$export$6c4a311cc157c764)(this.pincherArr[0].downRelX, this.pincherArr[0].downRelY, this.pincherArr[1].downRelX, this.pincherArr[1].downRelY);
                const distance = (0, $9414f5ea41e9cf25$export$6c4a311cc157c764)(this.pincherArr[0].relX, this.pincherArr[0].relY, this.pincherArr[1].relX, this.pincherArr[1].relY);
                const startAngle = (0, $9414f5ea41e9cf25$export$627023b405ba5028)({
                    x: this.pincherArr[0].downRelX,
                    y: this.pincherArr[0].downRelY
                }, {
                    x: this.pincherArr[1].downRelX,
                    y: this.pincherArr[1].downRelY
                });
                const angle = (0, $9414f5ea41e9cf25$export$627023b405ba5028)({
                    x: this.pincherArr[0].relX,
                    y: this.pincherArr[0].relY
                }, {
                    x: this.pincherArr[1].relX,
                    y: this.pincherArr[1].relY
                });
                event = {
                    type: 'move',
                    downRelX: 0.5 * (this.pincherArr[0].downRelX + this.pincherArr[1].downRelX),
                    downRelY: 0.5 * (this.pincherArr[0].downRelY + this.pincherArr[1].downRelY),
                    relX: 0.5 * (this.pincherArr[0].relX + this.pincherArr[1].relX),
                    relY: 0.5 * (this.pincherArr[0].relY + this.pincherArr[1].relY),
                    angleRad: angle - startAngle,
                    scale: distance / startDist
                };
            }
            this.onPinch(event);
        } else if (actionObj.type === 'down' || actionObj.type === 'up') {
            this.endPinch();
            this.beginPinch(gestureObj);
        }
    }
    endPinch() {
        this.pincherArr = [];
        this.onPinch({
            type: 'end'
        });
    }
    chainIn(event) {
        this.processEvent(event);
        if (this.gestureObj) {
            if (!this.gestureObj.isInProgress) // might still fail -> into queue
            this.eventQueueArr.push(event);
        } else return event;
        return null;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.firstFingerMaxDistancePx = 10;
        this.untilSecondFingerDurationMs = 250;
        this.pointersDownIdArr = [];
        this.gestureObj = null;
        this.eventQueueArr = [];
        this.nowTime = performance.now();
        this.timeoutObj = {
            secondFingerTimeout: null
        };
        this.pincherArr = [];
        this.onPinch = p.onPinch;
    }
}



class $afe05ecd8ae7f4be$export$db3963a21c01d803 {
    // double tap achieved
    success() {
        this.timeoutObj.fail = null;
        this.timeoutObj.success = null;
        this.eventQueueArr = []; // events get swallowed
        const lastSequenceItem = this.sequenceArr[this.sequenceArr.length - 1];
        this.sequenceArr = [];
        if ('pageX' in lastSequenceItem) this.onDoubleTap({
            pageX: lastSequenceItem.pageX,
            pageY: lastSequenceItem.pageY,
            relX: lastSequenceItem.relX,
            relY: lastSequenceItem.relY
        });
    }
    // returns false if time already up. otherwise sets up timeout
    setupTimeout(timeoutStr, targetFunc, timeMS, noComparison) {
        const diff = timeMS - this.nowTime;
        // console.log(fingers + ': ' + timeoutStr + ' diff', diff);
        if (diff <= 0 && !noComparison) // time already up
        return false;
        this.timeoutObj[timeoutStr] = setTimeout(targetFunc, Math.max(0, diff));
        return true;
    }
    /**
     * @param event object - a pointer event from BB.PointerListener
     */ processEvent(event) {
        if (event.type === 'pointerdown') this.pointersDownIdArr.push(event.pointerId);
        else if (event.type === 'pointerup') {
            for(let i = 0; i < this.pointersDownIdArr.length; i++)if (this.pointersDownIdArr[i] === event.pointerId) {
                this.pointersDownIdArr.splice(i, 1);
                break;
            }
        }
        if (!this.allowedPointerTypeArr.includes(event.pointerType)) {
            //wrong input type -> fail
            //console.log('wrong input type -> fail');
            this.gestureFailed();
            return;
        }
        this.nowTime = performance.now();
        const lastSequenceItem = this.sequenceArr.length > 0 ? this.sequenceArr[this.sequenceArr.length - 1] : null;
        if (event.type === 'pointerup') this.lastUpTime = event.time;
        if (event.type === 'pointerdown') {
            if (this.pointersDownIdArr.length > 1) {
                // more than one pointer down -> fail
                //console.log('more than one pointer down -> fail');
                this.gestureFailed();
                return;
            }
            if (this.timeoutObj.success !== null) {
                // silence-after not achieved -> fail
                //console.log('silence-after not achieved -> fail');
                this.gestureFailed();
                return;
            }
            if (this.sequenceArr.length === 0 && this.nowTime - this.lastUpTime < this.minSilenceBeforeDurationMs) {
                // silence before not achieved -> fail
                //console.log('silence before not achieved -> fail');
                this.gestureFailed();
                return;
            }
            if (event.button && !this.allowedButtonArr.includes(event.button)) {
                // wrong button -> fail
                //console.log('wrong button -> fail', event.button, allowedButtonArr);
                this.gestureFailed();
                return;
            }
            if (lastSequenceItem && 'isDown' in lastSequenceItem && lastSequenceItem.isDown || this.sequenceArr.length > 2) {
                // jumbled -> fail
                //console.log('jumbled -> fail');
                this.gestureFailed();
                return;
            }
            if (lastSequenceItem && 'position' in lastSequenceItem) {
                const distance = (0, $9414f5ea41e9cf25$export$6c4a311cc157c764)(lastSequenceItem.position[0], lastSequenceItem.position[1], event.pageX, event.pageY);
                if (distance > this.maxInbetweenDistancePx) {
                    //moved too much -> reset
                    //console.log('maxInbetweenDistancePx -> reset');
                    this.gestureFailed();
                    if ('time' in lastSequenceItem && this.nowTime - lastSequenceItem.time < this.minSilenceBeforeDurationMs) //silence before not achieved -> fail
                    return;
                }
            }
            this.sequenceArr.push({
                isDown: true,
                time: this.nowTime,
                position: [
                    event.pageX,
                    event.pageY
                ],
                pointerId: event.pointerId
            });
            //maxUntilSecondDown
            if (this.sequenceArr.length > 1) this.timeoutObj.maxUntilSecondDown && clearTimeout(this.timeoutObj.maxUntilSecondDown);
            else if (!this.setupTimeout('maxUntilSecondDown', ()=>this.gestureFailed(), event.time + this.maxUntilSecondDownDurationMs)) {
                //console.log('event.time + maxPressedDurationMs -> fail');
                this.gestureFailed();
                return;
            }
            this.timeoutObj.fail && clearTimeout(this.timeoutObj.fail);
            if (!this.setupTimeout('fail', ()=>this.gestureFailed(), event.time + this.maxPressedDurationMs)) {
                //console.log('event.time + maxPressedDurationMs -> fail');
                this.gestureFailed();
                return;
            }
        }
        if (lastSequenceItem && event.type === 'pointermove' && 'pointerId' in lastSequenceItem && lastSequenceItem.pointerId === event.pointerId) {
            /*if (lastSequenceItem.pointerId !== event.pointerId) { //another pointer mixing in -> fail
                console.log('another pointer mixing in -> fail');
                this.fail();
                return;
            }*/ const distance = (0, $9414f5ea41e9cf25$export$6c4a311cc157c764)(lastSequenceItem.position[0], lastSequenceItem.position[1], event.pageX, event.pageY);
            if (distance > this.maxPressedDistancePx) {
                //moved too much -> fail
                //console.log('maxPressedDistancePx -> fail');
                this.gestureFailed();
                return;
            }
        }
        if (lastSequenceItem && event.type === 'pointerup') {
            if ('pointerId' in lastSequenceItem && lastSequenceItem.pointerId !== event.pointerId) {
                //another pointer mixing in -> fail
                this.gestureFailed();
                return;
            }
            if ('time' in lastSequenceItem && this.nowTime >= lastSequenceItem.time + this.maxPressedDurationMs) {
                //pressed too long -> fail
                this.gestureFailed();
                return;
            }
            this.timeoutObj.fail && clearTimeout(this.timeoutObj.fail);
            if (this.sequenceArr.length < 3) {
                if (!this.setupTimeout('fail', ()=>this.gestureFailed(), event.time + this.maxUpToUpDurationMs)) {
                    this.gestureFailed();
                    return;
                }
                this.sequenceArr = [
                    lastSequenceItem,
                    {
                        isUp: true,
                        time: this.nowTime,
                        position: [
                            event.pageX,
                            event.pageY
                        ]
                    }
                ];
                return;
            }
            if ('time' in this.sequenceArr[1] && this.nowTime < this.sequenceArr[1].time + this.maxUpToUpDurationMs) {
                // double tap almost success
                // only needs silence
                this.sequenceArr.push({
                    pageX: event.pageX,
                    pageY: event.pageY,
                    relX: event.relX,
                    relY: event.relY
                });
                if (!this.setupTimeout('success', ()=>this.success(), event.time + this.minSilenceAfterMs, true)) this.gestureFailed();
            } else // time up -> fail
            this.gestureFailed();
        }
    }
    chainIn(event) {
        this.processEvent(event);
        if (this.sequenceArr.length === 0) {
            //existing events can not become a double tap
            this.gestureFailed();
            return event;
        }
        // events might become a double tap -> queue
        this.eventQueueArr.push(event);
        return null;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    setAllowedPointerTypeArr(arr) {
        this.allowedPointerTypeArr = [
            ...arr
        ];
    }
    setAllowedButtonArr(arr) {
        this.allowedButtonArr = [
            ...arr
        ];
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.allowedPointerTypeArr = [
            'touch',
            'mouse',
            'pen'
        ];
        this.allowedButtonArr = [
            'left'
        ];
        this.minSilenceBeforeDurationMs = 400;
        this.maxPressedDurationMs = 300;
        this.maxPressedDistancePx = 10;
        this.maxInbetweenDistancePx = 19;
        this.maxUpToUpDurationMs = 500;
        this.maxUntilSecondDownDurationMs = 300;
        this.minSilenceAfterMs = 250;
        this.sequenceArr = [];
        this.pointersDownIdArr = [];
        this.lastUpTime = 0;
        this.nowTime = 0;
        this.eventQueueArr = [];
        this.timeoutObj = {
            fail: null,
            maxUntilSecondDown: null,
            success: null
        };
        this.onDoubleTap = p.onDoubleTap;
        if (p.isInstant) {
            this.minSilenceBeforeDurationMs = 0;
            this.minSilenceAfterMs = 0;
        }
        this.gestureFailed = ()=>{
            if (this.sequenceArr.length === 0) // no gesture started -> can be ignored
            return;
            this.timeoutObj.fail && clearTimeout(this.timeoutObj.fail);
            this.timeoutObj.maxUntilSecondDown && clearTimeout(this.timeoutObj.maxUntilSecondDown);
            this.timeoutObj.success && clearTimeout(this.timeoutObj.success);
            this.timeoutObj.fail = null;
            this.timeoutObj.maxUntilSecondDown = null;
            this.timeoutObj.success = null;
            if (this.chainOut) for(let i = 0; i < this.eventQueueArr.length; i++)this.chainOut(this.eventQueueArr[i]);
            this.eventQueueArr = [];
            this.sequenceArr = [];
        };
    }
}


class $68c13f25614f29c1$export$71ff2f51bf1f4062 {
    // ----------------------------------- public -----------------------------------
    chainIn(event) {
        if (this.ignorePointerIdArr.includes(event.pointerId)) {
            if (event.type === 'pointerup') {
                for(let i = 0; i < this.ignorePointerIdArr.length; i++)if (this.ignorePointerIdArr[i] === event.pointerId) {
                    this.ignorePointerIdArr.splice(i, 1);
                    break;
                }
            }
            return null;
        }
        if (this.downPointerId === null) {
            if (event.type === 'pointerdown') this.downPointerId = event.pointerId;
            return event;
        } else {
            if (event.pointerId !== this.downPointerId) {
                if (event.type === 'pointerdown') this.ignorePointerIdArr.push(event.pointerId);
                return null;
            }
            if (event.type === 'pointerup') this.downPointerId = null;
            return event;
        }
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    constructor(){
        this.downPointerId = null;
        this.ignorePointerIdArr = [];
    }
}


class $3c485cff20ed4548$export$649a211db9812745 {
    continueChain(i, event) {
        for(; i < this.chainArr.length; i++){
            event = this.chainArr[i].chainIn(event);
            if (event === null) return null;
        }
        this.chainOut && this.chainOut(event);
        return null;
    }
    /**
     * feed an event into the chain
     */ chainIn(event) {
        return this.continueChain(0, event);
    }
    /**
     * func will be called when event has passed through the chain
     */ setChainOut(func) {
        this.chainOut = func;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.chainArr = p.chainArr;
        for(let i = 0; i < this.chainArr.length; i++)((i)=>{
            this.chainArr[i].setChainOut((event)=>{
                this.continueChain(i + 1, event);
            });
        })(i);
    }
}


const $d9f9f4926aa80a1c$export$921068d8846a1559 = {
    // ---- browser ----
    eventUsesHighResTimeStamp: (0, $604d9bbf77127967$export$69accc8c74894f83),
    hasPointerEvents: (0, $604d9bbf77127967$export$7728c852ca75bb6d),
    isCssMinMaxSupported: (0, $604d9bbf77127967$export$1a1016cfea93f0d5),
    canShareFiles: (0, $604d9bbf77127967$export$558f5e20caee48c2),
    unsetEventHandler: $604d9bbf77127967$export$4fb2cccfca937a8c,
    insertAfter: // ---- base ----
    $fc4403c8ee6a33dc$export$c4f94c8b3850a5a9,
    loadImage: $fc4403c8ee6a33dc$export$fe58198efe02b173,
    css: $fc4403c8ee6a33dc$export$dbf350e5966cf602,
    setAttributes: $fc4403c8ee6a33dc$export$74da2cba014bdc09,
    append: $fc4403c8ee6a33dc$export$10d8903dec122b9d,
    fitInto: $fc4403c8ee6a33dc$export$fa55905620c22535,
    centerWithin: $fc4403c8ee6a33dc$export$76d0c1a172b67a61,
    getDate: $fc4403c8ee6a33dc$export$aa350b96d91cd94,
    gcd: $fc4403c8ee6a33dc$export$f81847884871263e,
    reduce: $fc4403c8ee6a33dc$export$533b26079ad0b4b,
    decToFraction: $fc4403c8ee6a33dc$export$8215e6b900906daa,
    imageBlobToUrl: $fc4403c8ee6a33dc$export$5063ec57a23c4f2e,
    dateDayDifference: $fc4403c8ee6a33dc$export$1093707c159148e8,
    copyObj: $fc4403c8ee6a33dc$export$af0d87255f3cfd7e,
    shareCanvas: $fc4403c8ee6a33dc$export$331c30fd60da0115,
    handleClick: $fc4403c8ee6a33dc$export$b981489921ee18cd,
    createSvg: $fc4403c8ee6a33dc$export$c54fe3b9ecaa84cf,
    LocalStorage: $0ecef66681b62a8c$export$19fffca37ef3e106,
    throwIfNull: $fc4403c8ee6a33dc$export$b813e062795b89b5,
    nullToUndefined: $fc4403c8ee6a33dc$export$d802c22d109d9806,
    isDark: $fc4403c8ee6a33dc$export$a79ad82046afa44e,
    mix: // ---- math ----
    $9414f5ea41e9cf25$export$2c9e8a9632a706b2,
    dist: $9414f5ea41e9cf25$export$6c4a311cc157c764,
    distSquared: $9414f5ea41e9cf25$export$499eb56409f6cbc2,
    lenSquared: $9414f5ea41e9cf25$export$a4f99f99d3e99cfa,
    pointsToAngleRad: $9414f5ea41e9cf25$export$627023b405ba5028,
    pointsToAngleDeg: $9414f5ea41e9cf25$export$c03a8450eabc2532,
    isInsideRect: $9414f5ea41e9cf25$export$151bd845d70e2099,
    clamp: $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4,
    rotate: $9414f5ea41e9cf25$export$bb628a54ab399bc9,
    rotateAround: $9414f5ea41e9cf25$export$95ec0760d3d00713,
    Matrix: $1460f8c17429a8fd$export$5b12bf1653c0dd85,
    Vec2: $2890e4902986ac94$export$ac4bca90992eed1,
    intDxy: $9414f5ea41e9cf25$export$bbf9af158036c5e9,
    roundEven: $9414f5ea41e9cf25$export$94cce7adf2ec2d08,
    roundUneven: $9414f5ea41e9cf25$export$f373b6a7b0c159a,
    round: $9414f5ea41e9cf25$export$2077e0241d6afd3c,
    updateBounds: $9414f5ea41e9cf25$export$f4467a4f41373bc7,
    indexBoundsInArea: $9414f5ea41e9cf25$export$ddc1c0069d484d49,
    projectPointOnLine: // ---- line ----
    $4e47553489a532e8$export$b4c5b177db876445,
    PointLine: $4e47553489a532e8$export$8b36a4a83269a640,
    BezierLine: $4e47553489a532e8$export$5379d955c16d4d43,
    SplineInterpolator: $4e47553489a532e8$export$80967b1eb9fd6eb4,
    powerSplineInput: $4e47553489a532e8$export$c07c3aaef9f2da42,
    // ---- canvas ----
    canvas: (0, $9f64dcf89d8f9132$export$cd3d1f114b139967),
    ctx: $13d5aa49e37e2734$export$39f92e86d1722f3a,
    copyCanvas: $13d5aa49e37e2734$export$dd0873c0fb3ccff6,
    testShouldPixelate: $13d5aa49e37e2734$export$1555f643cc9a976,
    drawTransformedImageWithBounds: $13d5aa49e37e2734$export$ded2b43392504635,
    drawTransformedImageOnCanvas: $13d5aa49e37e2734$export$425a419ef9fc761f,
    createCheckerCanvas: $13d5aa49e37e2734$export$754559b36e94ea2f,
    createCheckerDataUrl: $13d5aa49e37e2734$export$42af33c76b681867,
    resizeCanvas: $13d5aa49e37e2734$export$59b33278b5b2fc8a,
    convertToAlphaChannelCanvas: $13d5aa49e37e2734$export$5a7576952c826b4f,
    freeCanvas: $13d5aa49e37e2734$export$2384aff49c9b73c2,
    HSV: // ---- color ----
    $b68f66663c02a5d5$export$d2edaecd208aed43,
    RGB: $b68f66663c02a5d5$export$8f9ece5a47764b93,
    CMYK: $b68f66663c02a5d5$export$89d3f85304bf0767,
    ColorConverter: $b68f66663c02a5d5$export$fb7efcd2e153af6e,
    testIsWhiteBestContrast: $b68f66663c02a5d5$export$5cf396345d1238ae,
    appendTextDiv: // ---- UI ----
    $52ad4d7a7d6372c1$export$7868464f598ba79d,
    clearSelection: $52ad4d7a7d6372c1$export$a3d02541b0ebf605,
    el: $52ad4d7a7d6372c1$export$c3da0dad1b44eea9,
    destroyEl: $52ad4d7a7d6372c1$export$b1da1db524e22115,
    isInputFocused: $52ad4d7a7d6372c1$export$906dfdb7df31ccfc,
    unfocusAnyInput: $52ad4d7a7d6372c1$export$e05240ca9e0b8bd9,
    KeyListener: // ---- events / input ----
    $08e838e8af75c5e2$export$f17908c5de22d32e,
    PointerListener: $a07742141701d1f2$export$9371bd96776f4e82,
    sameKeys: $08e838e8af75c5e2$export$e9f65b0175de4c03,
    EventChain: $3c485cff20ed4548$export$649a211db9812745,
    DoubleTapper: $afe05ecd8ae7f4be$export$db3963a21c01d803,
    NFingerTapper: $ee2eb319667e1e48$export$510622b8aed00381,
    PinchZoomer: $5ba93bbe34fd1582$export$d62358ac2d82abb3,
    CoalescedExploder: $2df67d7abe113884$export$fe11e0afe623a677,
    OnePointerLimiter: $68c13f25614f29c1$export$71ff2f51bf1f4062
};
Object.keys($d9f9f4926aa80a1c$export$921068d8846a1559); // without this, parcel build may break this object



// generated from src/languages. "npm run lang:build" to update
var $3b474fbd2c41de06$exports = {};
$3b474fbd2c41de06$exports = JSON.parse('{"switch-ui-left-right":"Switch left/right UI","toggle-show-tools":"Show/Hide Tools","scroll":"Scroll","donate":"Donate","home":"Home","modal-new-tab":"Open in new tab","tab-edit":"Edit","tab-file":"File","tool-brush":"Brush","tool-paint-bucket":"Paint Bucket","tool-gradient":"Gradient","tool-shape":"Shape","tool-text":"Text","tool-hand":"Hand Tool","tool-select":"Select Tool","tool-zoom":"Zoom","tool-more-tools":"More Tools","tool-more-tools-click-again":"Click again for more tools","undo":"Undo","redo":"Redo","brush-pen":"Pen","brush-blend":"Blend","brush-sketchy":"Sketchy","brush-pixel":"Pixel","brush-chemy":"Chemy","brush-smudge":"Smudge","brush-size":"Size","brush-blending":"Blending","brush-toggle-pressure":"Toggle Pressure Sensitivity","brush-pen-circle":"Circle","brush-pen-chalk":"Chalk","brush-pen-calligraphy":"Calligraphy","brush-pen-square":"Square","brush-sketchy-scale":"Scale","brush-pixel-dither":"Dither","brush-chemy-fill":"Fill","brush-chemy-stroke":"Stroke","brush-chemy-mirror-x":"Horizontal Symmetry","brush-chemy-mirror-y":"Vertical Symmetry","brush-chemy-gradient":"Gradient","brush-eraser-transparent-bg":"Transparent Background","stabilizer":"Stabilizer","stabilizer-title":"Stroke Stabilizer","eyedropper":"Eyedropper","secondary-color":"Secondary Color","manual-color-input":"Manual Color Input","mci-hex":"Hex","mci-copy":"Copy","modal-ok":"Ok","modal-cancel":"Cancel","modal-close":"Close","layers-active-layer":"Active Layer","layers-layer":"Layer","layers-copy":"copy","layers-blending":"Blending","layers-new":"New Layer","layers-remove":"Remove Layer","layers-duplicate":"Duplicate Layer","layers-merge":"Merge with layer below","layers-clear":"Clear layer","layers-merge-advanced":"Advanced merge","layers-merge-all":"Merge all","layers-rename":"Rename","layers-active-layer-visible":"Active layer is visible","layers-active-layer-hidden":"Active layer is hidden","layers-visibility-toggle":"Layer Visibility","layers-blend-normal":"normal","layers-blend-darken":"darken","layers-blend-multiply":"multiply","layers-blend-color-burn":"color burn","layers-blend-lighten":"lighten","layers-blend-screen":"screen","layers-blend-color-dodge":"color dodge","layers-blend-overlay":"overlay","layers-blend-soft-light":"soft light","layers-blend-hard-light":"hard light","layers-blend-difference":"difference","layers-blend-exclusion":"exclusion","layers-blend-hue":"hue","layers-blend-saturation":"saturation","layers-blend-color":"color","layers-blend-luminosity":"luminosity","layers-rename-title":"Rename Layer","layers-rename-name":"Name","layers-rename-clear":"Clear Name","layers-rename-sketch":"Sketch","layers-rename-colors":"Colors","layers-rename-shading":"Shading","layers-rename-lines":"Lines","layers-rename-effects":"Effects","layers-rename-foreground":"Foreground","layers-merge-modal-title":"Merge/Mix Layers","layers-merge-description":"Merges the selected layer with the one underneath. Select the mix mode:","file-no-autosave":"No autosave, no cloud storage","file-new":"New","file-import":"Import","file-save":"Save","file-format":"File Format","file-show-save-dialog":"Show save dialog","file-copy":"Copy","file-copy-title":"Copy To Clipboard","file-paste":"Paste","file-share":"Share","file-storage":"Browser Storage","file-storage-about":"About Browser Storage","file-storage-cant-access":"Can\'t access storage.","file-storage-empty":"Empty","file-storage-store":"Store","file-storage-open":"Open","file-storage-open-confirmation":"This image is already open in another tab. Open it here too?","file-storage-open-failed":"Failed to load.","file-storage-clear":"Clear","file-storage-clear-prompt":"Clear Browser Storage? Clearing can not be undone.","file-storage-storing":"Storing","file-storage-overwrite":"Overwrite","file-storage-overwrite-confirm":"Overwrite Browser Storage? Overwritten data will be permanently deleted.","file-storage-min-ago":"{x}min ago","file-storage-hours-ago":"{x}h ago","file-storage-days-ago":"{x}d ago","file-storage-month-ago":"> 1month ago","file-storage-restored":"Restored from Browser Storage","file-storage-stored":"Stored to Browser Storage","file-storage-failed":"Failed to store to Browser Storage","file-storage-failed-1":"Failed to store. Possible causes:","file-storage-failed-2":"Out of disk space","file-storage-failed-3":"Storage disabled in incognito tab","file-storage-failed-4":"Browser doesn\'t support storage","file-storage-failed-clear":"Failed to clear.","file-upload":"Upload","tab-recovery-recover-tabs":"Recover closed tabs","tab-recovery-explanation":"Recovery data is only kept for a little while. Save to ensure your work is not lost.","tab-recovery-total-quota-label":"Total:","tab-recovery-empty":"Nothing to recover.","tab-recovery-recover":"Recover","tab-recovery-delete":"Delete","tab-recovery-delete-confirmation":"Delete this recovery? Deletion can not be undone.","tab-recovery-failed-to-recover":"Failed to recover tab.","tab-recovery-recovered":"Tab recovered.","cleared-layer":"Cleared layer","cleared-selected-area":"Cleared selected area","filled":"Filled","filled-selected-area":"Filled selection","new-title":"New Image","new-current":"Current","new-fit":"Fit","new-oversize":"Oversize","new-square":"Square","new-landscape":"Landscape","new-portrait":"Portrait","new-screen":"Screen","new-video":"Video","new-din-paper":"DIN Paper","new-px":"px","new-ratio":"Ratio","upload-title":"Upload to Imgur","upload-link-notice":"Anyone with the link to your uploaded image will be able to view it.","upload-name":"Title","upload-title-untitled":"Untitled","upload-caption":"Caption","upload-submit":"Upload","upload-uploading":"Uploading...","upload-success":"Upload Successful","upload-failed":"Upload failed.","upload-delete":"To delete your image from Imgur visit:","cropcopy-title-copy":"Copy To Clipboard","cropcopy-title-crop":"Crop","cropcopy-mask":"Mask unselected","cropcopy-click-hold":"Right-click or press hold to copy.","cropcopy-btn-copy":"To Clipboard","cropcopy-copied":"Copied.","cropcopy-btn-crop":"Apply Crop","crop-drag-to-crop":"Drag to crop","filter-crop-extend":"Crop/Extend","filter-flip":"Flip","filter-perspective":"Perspective","filter-resize":"Resize","filter-rotate":"Rotate","filter-transform":"Transform","filter-bright-contrast":"Bright/Contrast","filter-curves":"Curves","filter-hue-sat":"Hue/Saturation","filter-invert":"Invert","filter-tilt-shift":"Tilt Shift","filter-to-alpha":"To Alpha","filter-triangle-blur":"Triangle Blur","filter-unsharp-mask":"Unsharp Mask","filter-crop-title":"Crop / Extend","filter-crop-description":"Crop or extend the image.","filter-crop-left":"Left","filter-crop-right":"Right","filter-crop-top":"Top","filter-crop-bottom":"Bottom","filter-crop-rule-thirds":"Rule of Thirds","filter-crop-fill":"Fill","filter-flip-title":"Flip","filter-flip-description":"Flips layer or whole image.","filter-flip-horizontal":"Horizontal","filter-flip-vertical":"Vertical","filter-flip-image":"Flip Image","filter-flip-layer":"Flip Layer","filter-perspective-title":"Perspective","filter-perspective-description":"Transforms the selected layer.","filter-resize-title":"Resize","filter-resize-description":"Resizes the image.","filter-rotate-title":"Rotate","filter-rotate-description":"Rotates the image.","filter-transform-empty":"Layer is empty.","filter-transform-empty-selection":"Layer is empty in selected area.","filter-transform-title":"Transform","filter-transform-description":"Transforms selected layer. Hold Shift for additional behavior.","filter-transform-rotation":"Rotation","filter-transform-flip":"Flip","filter-transform-center":"Center","filter-transform-constrain":"Constrain","filter-transform-snap":"Snap","filter-transform-snap-title":"Snap Rotation And Position","filter-bright-contrast-title":"Brightness / Contrast","filter-bright-contrast-description":"Change brightness and contrast for the selected layer.","filter-bright-contrast-brightness":"Brightness","filter-bright-contrast-contrast":"Contrast","filter-curves-title":"Curves","filter-curves-description":"Apply curves on the selected layer.","filter-curves-all":"All","filter-hue-sat-title":"Hue / Saturation","filter-hue-sat-description":"Change hue and saturation for the selected layer.","filter-hue-sat-hue":"Hue","filter-hue-sat-saturation":"Saturation","filter-applied":"\\"{x}\\" applied","filter-tilt-shift-title":"Tilt Shift","filter-tilt-shift-description":"Applies tilt shift on the selected layer.","filter-tilt-shift-blur":"Blur Radius","filter-tilt-shift-gradient":"Gradient Radius","filter-to-alpha-title":"To Alpha","filter-to-alpha-description":"Generates alpha channel for selected layer from:","filter-to-alpha-inverted-lum":"Inverted Luminance","filter-to-alpha-lum":"Luminance","filter-to-alpha-replace":"Replace RGB","filter-triangle-blur-title":"Triangle Blur","filter-triangle-blur-description":"Applies triangle blur on the selected layer.","filter-unsharp-mask-title":"Unsharp Mask","filter-unsharp-mask-description":"Sharpens the selected layer by scaling pixels away from the average of their neighbors.","filter-unsharp-mask-strength":"Strength","filter-grid":"Grid","filter-grid-description":"Draws grid on selected layer.","filter-noise":"Noise","filter-noise-description":"Adds noise to selected layer.","filter-noise-scale":"Scale","filter-noise-alpha":"Alpha","filter-pattern":"Pattern","filter-pattern-description":"Generates pattern on selected layer. Drag the preview for further controls.","filter-distort":"Distort","filter-distort-description":"Distorts the selected layer.","filter-distort-phase":"Phase","filter-distort-stepsize":"Step Size","filter-distort-sync-xy":"Sync XY","filter-vanish-point":"Vanish Point","filter-vanish-point-title":"Vanishing Point","filter-vanish-point-description":"Adds vanishing point to selected layer. Drag preview to move.","filter-vanish-point-lines":"Lines","dropper-drop":"Drop to import","dropper-as-image":"As New Image","dropper-as-layer":"As Layer","import-opening":"Opening file...","import-title":"Import Image","import-too-large":"Image too large, will be downscaled.","import-btn-as-layer":"As Layer","import-btn-as-image":"As Image","import-as-layer-title":"Import Image as New Layer","import-as-layer-description":"Adjust the position of the imported image.","import-as-layer-limit-reached":"Layer limit reached. Image will be placed on existing layer.","import-as-layer-fit":"Fit","import-flatten":"Flatten image","import-unsupported-file":"Unsupported file type. See Help for supported types.","import-broken-file":"Couldn\'t load image. File might be corrupted.","import-psd-unsupported":"Unsupported features. PSD had to be flattened.","import-psd-limited-support":"PSD support is limited. Flattened will more likely look correct.","import-psd-too-large":"Image exceeds maximum dimensions of {x} x {x} pixels. Unable to import.","import-psd-size":"Image size","clipboard-read-fail":"Failed to read from clipboard.","clipboard-no-image":"No image found in clipboard.","hand-reset":"Reset","hand-fit":"Fit","hand-inertia-scrolling":"Inertia Scrolling","bucket-tolerance":"Tolerance","bucket-sample":"Sample","bucket-sample-title":"Which layers to sample color from","bucket-sample-all":"All","bucket-sample-active":"Active","bucket-sample-above":"Above","bucket-grow":"Grow","bucket-grow-title":"Grow filled area (in pixels)","bucket-contiguous":"Contiguous","bucket-contiguous-title":"Only fill connected areas","gradient-linear":"Linear","gradient-linear-mirror":"Linear-Mirror","gradient-radial":"Radial","shape-stroke":"Stroke","shape-fill":"Fill","shape-rect":"Rectangle","shape-ellipse":"Ellipse","shape-line":"Line","shape-line-width":"Line Width","shape-outwards":"Outwards","shape-fixed":"Fixed 1:1","shape-auto-pan":"Auto-pan","shape-auto-pan-title":"Automatically moves as you draw","text-instruction":"Click canvas to place text","text-title":"Add Text","text-text":"Text","text-font":"Font","text-placeholder":"Your text","text-color":"Color","text-size":"Size","text-line-height":"Line Height","text-letter-spacing":"Letter Spacing","text-left":"Left","text-center":"Center","text-right":"Right","text-italic":"Italic","text-bold":"Bold","text-failed-import":"Failed to import the following files:","text-supported-formats":"Supported formats:","select-select":"Select","select-transform":"Transform","select-lasso":"Lasso","select-polygon":"Polygon","select-boolean-replace":"Replace","select-boolean-add":"Add","select-boolean-subtract":"Subtract","select-all":"All","select-invert":"Invert","select-reset":"Reset","select-fill":"Fill","select-erase":"Erase","select-transform-warp":"Warp","select-transform-clone":"Clone","select-transform-clone-applied":"Cloned","select-transform-move-to-layer":"Move to layer:","select-transform-applied":"Transformation applied","select-transform-empty":"Selected area on active layer is empty.","save-reminder-title":"Unsaved Work","save-reminder-text":"Image was not saved in {a} minutes{b}. Save now to prevent eventual loss.","save-reminder-save-psd":"Save As PSD","save-reminder-psd-layers":"PSD will remember all layers.","backup-drawing":"You can backup your drawing.","submit":"Submit","submit-title":"Submit Drawing","submit-prompt":"Submit drawing?","submit-submitting":"Submitting","embed-init-loading":"Loading app","embed-init-waiting":"Waiting for image","help":"Help","tab-settings":"Settings","settings-language":"Language","settings-language-reload":"Will update after reloading.","settings-theme":"Theme","settings-save-reminder-label":"Save Reminder","settings-save-reminder-disabled":"disabled","settings-save-reminder-confirm-title":"Turn off Save Reminder?","settings-save-reminder-confirm-a":"There is no autosave and browser tabs don\'t last forever. If you don\'t periodically save you will likely lose work.","settings-save-reminder-confirm-b":"Disable at your own risk?","settings-save-reminder-confirm-disable":"Disable","theme-dark":"Dark","theme-light":"Light","terms-of-service":"Terms of Service","licenses":"Licenses","source-code":"Source Code","auto":"auto","zoom-in":"Zoom In","zoom-out":"Zoom Out","radius":"Radius","constrain-proportions":"Constrain Proportions","width":"Width","height":"Height","opacity":"Opacity","scatter":"Scatter","red":"Red","green":"Green","blue":"Blue","eraser":"Eraser","center":"Center","layers":"Layers","background":"Background","scaling-algorithm":"Scaling Algorithm","algorithm-smooth":"Smooth","algorithm-pixelated":"Pixelated","preview":"Preview","angle-snap":"Snap","angle-snap-title":"45\xb0 Angle Snapping","lock-alpha":"Lock Alpha","lock-alpha-title":"Locks layer\'s alpha channel","reverse":"Reverse","compare-before":"Before","compare-after":"After","loading":"Loading","more":"More","x-minutes":"{x}min","wip":"Work in progress","browser-zoom-help":"Double-tap or pinch-out to reset browser zoom.","dismiss":"Dismiss"}');


const $970d7af44d8b8038$export$33e6c23ebe2ee669 = (0, (/*@__PURE__*/$parcel$interopDefault($3b474fbd2c41de06$exports)));
const $970d7af44d8b8038$export$d0d68bb9ed2c643d = [
    {
        code: 'en',
        name: 'English'
    },
    {
        code: 'de',
        name: 'Deutsch'
    },
    {
        code: 'es',
        name: "Espa\xf1ol"
    },
    {
        code: 'fi',
        name: 'suomi'
    },
    {
        code: 'fr',
        name: "Fran\xe7ais"
    },
    {
        code: 'hu',
        name: 'Magyar'
    },
    {
        code: 'id',
        name: 'Bahasa Indonesia'
    },
    {
        code: 'ja',
        name: "\u65E5\u672C\u8A9E"
    },
    {
        code: 'jv',
        name: 'Basa Jawa'
    },
    {
        code: 'ko',
        name: "\uD55C\uAD6D\uC5B4"
    },
    {
        code: 'lv',
        name: "Latvie\u0161u Valoda"
    },
    {
        code: 'nl',
        name: 'Nederlands'
    },
    {
        code: 'pt-BR',
        name: "Portugu\xeas Brasil"
    },
    {
        code: 'ru',
        name: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    {
        code: 'su',
        name: 'Basa Sunda'
    },
    {
        code: 'sv',
        name: 'Svenska'
    },
    {
        code: 'zh-CN',
        name: "\u7B80\u4F53\u4E2D\u6587"
    },
    {
        code: 'zh-TW',
        name: "\u7E41\u9AD4\u4E2D\u6587"
    }
];

















const $970d7af44d8b8038$export$f02cbd868e2f57cf = async (code)=>{
    if (code === 'en') return $970d7af44d8b8038$export$33e6c23ebe2ee669;
    else if (code === 'de') return await (parcelRequire("j0wU0"));
    else if (code === 'es') return await (parcelRequire("eYAiv"));
    else if (code === 'fi') return await (parcelRequire("FCOGf"));
    else if (code === 'fr') return await (parcelRequire("8QPRU"));
    else if (code === 'hu') return await (parcelRequire("bh2gX"));
    else if (code === 'id') return await (parcelRequire("6zMTy"));
    else if (code === 'ja') return await (parcelRequire("i7mHL"));
    else if (code === 'jv') return await (parcelRequire("1vdkc"));
    else if (code === 'ko') return await (parcelRequire("EJ9Pd"));
    else if (code === 'lv') return await (parcelRequire("VfRNd"));
    else if (code === 'nl') return await (parcelRequire("7Cmcd"));
    else if (code === 'pt-BR') return await (parcelRequire("hGaKk"));
    else if (code === 'ru') return await (parcelRequire("8vyDa"));
    else if (code === 'su') return await (parcelRequire("aCMGc"));
    else if (code === 'sv') return await (parcelRequire("9C1up"));
    else if (code === 'zh-CN') return await (parcelRequire("gXjy0"));
    else if (code === 'zh-TW') return await (parcelRequire("5wCMx"));
    throw new Error('unknown language code');
};
 // Dismiss



const $63d0b335c576c718$export$991796128b2ca217 = 'klecks-language';
class $63d0b335c576c718$var$LanguageStrings {
    async setLanguage(langCode) {
        if (langCode === 'en') this.data = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, (0, $970d7af44d8b8038$export$33e6c23ebe2ee669));
        else this.data = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, (0, $970d7af44d8b8038$export$33e6c23ebe2ee669), await (0, $970d7af44d8b8038$export$f02cbd868e2f57cf)(langCode));
        this.code = langCode;
        document.documentElement.setAttribute('lang', langCode);
        this.listeners.forEach((item)=>{
            item();
        });
    }
    get(code) {
        if (!(code in this.data)) throw new Error("translation code doesn't exist: " + code);
        return this.data[code];
    }
    getLanguage() {
        return (0, $970d7af44d8b8038$export$d0d68bb9ed2c643d).find((item)=>{
            return item.code === this.code;
        });
    }
    getAutoLanguage() {
        const autoCode = $63d0b335c576c718$export$64783e31db14f0ba(false);
        return (0, $970d7af44d8b8038$export$d0d68bb9ed2c643d).find((item)=>{
            return item.code === autoCode;
        });
    }
    getCode() {
        return this.code;
    }
    // get notified on language change
    subscribe(subscriber) {
        if (this.listeners.includes(subscriber)) return;
        this.listeners.push(subscriber);
    }
    unsubscribe(subscriber) {
        for(let i = 0; i < this.listeners.length; i++)if (subscriber === this.listeners[i]) {
            this.listeners.splice(i, 1);
            return;
        }
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.listeners = [];
        // need to use setLanguage for a different language
        this.data = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, (0, $970d7af44d8b8038$export$33e6c23ebe2ee669));
        this.code = 'en';
    }
}
function $63d0b335c576c718$export$64783e31db14f0ba(useLocalStorage) {
    let result = 'en';
    const langs = []; // from highest to lowest priority
    const navLangs = navigator.languages ? navigator.languages : [
        navigator.language
    ];
    navLangs.forEach((item)=>{
        const split = item.split('-');
        langs.push(item);
        if (split.length === 2) langs.push(split[0]);
    });
    if (useLocalStorage) try {
        const item = (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem($63d0b335c576c718$export$991796128b2ca217);
        if (item) langs.unshift(item);
    } catch (e) {
    // likely cookies disabled in Safari
    }
    for(let i = 0; i < langs.length; i++){
        const lang = langs[i];
        const found = (0, $970d7af44d8b8038$export$d0d68bb9ed2c643d).find((item)=>{
            return item.code.toLowerCase() === lang.toLowerCase();
        });
        if (found) {
            result = found.code;
            break;
        }
    }
    return result;
}
const $63d0b335c576c718$var$activeLanguageCode = $63d0b335c576c718$export$64783e31db14f0ba(true);
const $63d0b335c576c718$export$e4ce066d17694649 = new $63d0b335c576c718$var$LanguageStrings();
const $63d0b335c576c718$export$ce37e184d908d785 = (code, replace)=>{
    if (replace) {
        let result = $63d0b335c576c718$export$e4ce066d17694649.get(code);
        const keyArr = Object.keys(replace);
        keyArr.forEach((key)=>{
            result = result.replace(`{${key}}`, replace[key]);
        });
        return result;
    } else return $63d0b335c576c718$export$e4ce066d17694649.get(code);
};
const $63d0b335c576c718$export$7a2ea9f2e4d199d3 = ()=>$63d0b335c576c718$export$e4ce066d17694649.setLanguage($63d0b335c576c718$var$activeLanguageCode);


window.onscroll = (e)=>{
    e.preventDefault();
};


var $f6d60f0cc8cfa5ae$exports = {};
$f6d60f0cc8cfa5ae$exports = $parcel$resolve("8gElo");


var $0c1a638761209cc7$exports = {};
$0c1a638761209cc7$exports = $parcel$resolve("iDK6N");


var $03e87c70019af696$exports = {};
$03e87c70019af696$exports = $parcel$resolve("dpNT8");


function $2016c314bff36ab9$export$d7e8d4d4450c819c(p) {
    (0, $6b37b427615ca1fa$export$d3d1650bc39c4419).increase();
    let isClosed = false;
    let ignoreBackground = !!p.ignoreBackground;
    // need this extra layer because chrome mobile otherwise scrolls the page and then glitches as the address bar goes away
    const rootRootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        parent: document.body,
        css: {
            position: 'absolute',
            left: '0',
            top: '0',
            right: '0',
            bottom: '0',
            overflow: 'hidden'
        }
    });
    const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        parent: rootRootEl,
        className: 'kl-popup'
    });
    const scrollContent = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        parent: rootEl,
        css: {
            width: '100%',
            minHeight: '100%',
            // padding: '10px 0',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }
    });
    const bgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        parent: scrollContent,
        onClick: ()=>{
            if (ignoreBackground) return;
            close('Cancel');
        },
        css: {
            position: 'absolute',
            left: '0',
            top: '0',
            zIndex: '0',
            width: '100%',
            height: '100%'
        }
    });
    const titleHeight = 40;
    const xButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'button',
        className: 'popup-x',
        content: `<img alt="${(0, $63d0b335c576c718$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($f6d60f0cc8cfa5ae$exports)))}">`,
        title: (0, $63d0b335c576c718$export$ce37e184d908d785)('modal-close'),
        onClick: ()=>{
            close('Cancel');
        },
        css: {
            width: titleHeight + 'px',
            height: titleHeight + 'px',
            lineHeight: titleHeight + 'px',
            position: 'absolute',
            right: '0',
            top: '0',
            background: 'none',
            boxShadow: 'none'
        }
    });
    let icon = undefined;
    if (p.type) icon = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: {
            error: 'kl-popup__icon-error',
            ok: 'kl-popup__icon-ok',
            warning: 'kl-popup__icon-warning',
            upload: 'kl-popup__icon-upload'
        }[p.type]
    });
    const boxClasses = [
        'kl-popup-box'
    ];
    boxClasses.push('kl-popup-box--sm');
    const boxEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        content: [
            xButton,
            icon,
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: p.message,
                css: {
                    marginRight: '15px',
                    marginBottom: p.div ? '10px' : undefined
                }
            }),
            p.div
        ],
        className: boxClasses.join(' '),
        css: p.style ? p.style : undefined
    });
    scrollContent.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            flex: '0.5'
        }
    }), boxEl, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            flex: '1'
        }
    }));
    const keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
        onDown: function(keyStr, e, comboStr) {
            if (isClosed) return;
            if (clickOnEnterBtn && comboStr === 'enter' && !(0, $d9f9f4926aa80a1c$export$921068d8846a1559).isInputFocused()) {
                e.stopPropagation();
                setTimeout(()=>{
                    clickOnEnterBtn && clickOnEnterBtn.click();
                }, 10);
            }
            if (comboStr === 'esc') {
                e.stopPropagation();
                e.preventDefault(); // stay in fullscreen on Mac
                close('Cancel');
            }
        }
    });
    // prevent ctrl scroll -> zooming page
    const wheelPrevent = (event)=>{
        if (keyListener.isPressed('ctrl')) event.preventDefault();
    };
    rootEl.addEventListener('wheel', wheelPrevent, {
        passive: false
    });
    rootEl.onclick = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).handleClick;
    let autoFocus;
    if (p.autoFocus) autoFocus = p.autoFocus;
    else if (p.autoFocus === false) autoFocus = undefined;
    else autoFocus = 'Ok';
    const buttonRowEl = p.buttons && p.buttons.length > 0 ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        parent: boxEl,
        css: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            marginTop: '12px',
            marginLeft: '-8px'
        }
    }) : undefined;
    let clickOnEnterBtn;
    const btnElArr = [];
    if (p.buttons) p.buttons.forEach((buttonName)=>{
        const btnClasses = [
            'kl-popup__btn'
        ];
        if (buttonName === 'Ok' || p.primaries && p.primaries.includes(buttonName)) btnClasses.push('kl-button-primary');
        if (buttonName === p.deleteButtonName) btnClasses.push('kl-button-delete');
        let iconUrl;
        let label = buttonName;
        if (buttonName === 'Ok') {
            label = (0, $63d0b335c576c718$export$ce37e184d908d785)('modal-ok');
            iconUrl = (0, (/*@__PURE__*/$parcel$interopDefault($0c1a638761209cc7$exports)));
        }
        if (buttonName === 'Cancel') {
            label = (0, $63d0b335c576c718$export$ce37e184d908d785)('modal-cancel');
            iconUrl = (0, (/*@__PURE__*/$parcel$interopDefault($f6d60f0cc8cfa5ae$exports)));
            btnClasses.push('kl-button-cancel');
        }
        if (buttonName === p.deleteButtonName) iconUrl = (0, (/*@__PURE__*/$parcel$interopDefault($03e87c70019af696$exports)));
        let iconImg = undefined;
        if (iconUrl) iconImg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'img',
            custom: {
                src: iconUrl,
                height: '17'
            }
        });
        const btn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: buttonRowEl,
            tagName: 'button',
            className: btnClasses.join(' '),
            content: [
                iconImg,
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    className: 'kl-popup__btn__text',
                    content: label
                })
            ],
            onClick: ()=>{
                close(buttonName);
            }
        });
        btnElArr.push(btn);
        if (autoFocus === buttonName) {
            setTimeout(()=>{
                btn.focus();
                rootEl.scrollTo(0, 0);
            }, 10);
            setTimeout(()=>{
                // safari needs a separate timeout
                rootEl.scrollTo(0, 0);
            }, 20);
        }
        if (buttonName === p.clickOnEnter) clickOnEnterBtn = btn;
    });
    function close(value) {
        if (isClosed) return;
        isClosed = true;
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clearSelection();
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unfocusAnyInput();
        rootRootEl.remove();
        (0, $6b37b427615ca1fa$export$d3d1650bc39c4419).decrease();
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(xButton);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(bgEl);
        keyListener.destroy();
        rootEl.removeEventListener('wheel', wheelPrevent);
        // (disabled) eslint-disable-next-line no-null/no-null
        rootEl.onclick = null;
        btnElArr.forEach((item)=>(0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(item));
        btnElArr.splice(0, btnElArr.length);
        if (p.callback) p.callback(value);
    }
    if (p.closeFunc) p.closeFunc(function() {
        close('Cancel');
    });
    return {
        setIgnoreBackground: (b)=>{
            ignoreBackground = b;
        }
    };
}








class $18361e3f5d6257e8$export$185108a9b725b68 {
    // ---- interface ----
    close() {
        (0, $6b37b427615ca1fa$export$d3d1650bc39c4419).decrease();
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.rootEl);
        this.rootEl.remove();
        window.removeEventListener('resize', this.updatePos);
        this.keyListener.destroy();
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.xButton);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.bgEl);
        this.onClose && this.onClose();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        (0, $6b37b427615ca1fa$export$d3d1650bc39c4419).increase();
        this.onClose = p.onClose;
        this.parent = document.body;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.parent,
            className: 'g-root kl-d-modal-root',
            css: {
                position: 'fixed',
                left: '0',
                top: '0',
                bottom: '0',
                right: '0',
                overflow: 'auto',
                animationName: 'consoleIn',
                animationDuration: '0.3s',
                animationTimingFunction: 'ease-out'
            },
            onClick: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).handleClick
        });
        //background element registering clicks
        this.bgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                bottom: '0',
                right: '0'
            },
            onClick: ()=>this.close()
        });
        //the actual popup box
        const popupEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-d-modal',
            css: {
                position: 'absolute',
                width: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).isCssMinMaxSupported() ? 'min(calc(100% - 40px), ' + (p.width ? p.width : 400) + 'px)' : (p.width ? p.width : 400) + 'px',
                height: p.height ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).isCssMinMaxSupported() ? 'min(calc(100% - 40px), ' + p.height + 'px)' : p.height + 'px' : 'calc(100% - 40px)',
                borderRadius: '10px',
                overflow: 'hidden'
            }
        });
        //x and y position via script. flex not powerful enough imo
        this.updatePos = ()=>{
            const elW = popupEl.offsetWidth;
            const elH = popupEl.offsetHeight;
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(popupEl, {
                left: Math.max(0, (window.innerWidth - elW) / 2) + 'px',
                top: Math.max(20, (window.innerHeight - elH) / 2 - elH * 0.2) + 'px'
            });
        };
        this.updatePos();
        window.addEventListener('resize', this.updatePos);
        //title row in popup
        const titleHeight = 40;
        const titleEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: popupEl,
            css: {
                height: titleHeight + 'px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingLeft: titleHeight / 2 + 'px'
            }
        });
        if (p.title) titleEl.append(p.title);
        this.xButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: titleEl,
            tagName: 'button',
            className: 'popup-x',
            content: `<img alt="${(0, $63d0b335c576c718$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($f6d60f0cc8cfa5ae$exports)))}">`,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('modal-close'),
            onClick: ()=>this.close(),
            css: {
                width: titleHeight + 'px',
                height: titleHeight + 'px',
                lineHeight: titleHeight + 'px',
                background: 'none',
                boxShadow: 'none'
            },
            custom: {
                tabindex: '0'
            }
        });
        const contentEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: popupEl,
            css: {
                height: 'calc(100% - ' + titleHeight + 'px)'
            }
        });
        if (p.content) contentEl.append(p.content);
        this.keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
            onDown: (keyStr, e)=>{
                if (keyStr === 'esc') {
                    e.stopPropagation();
                    e.preventDefault(); // stay in fullscreen on Mac
                    this.close();
                }
            }
        });
    }
}






class $213947897b67ec3a$export$48513f6b9f8ce62d {
    getValue() {
        return this.check.checked;
    }
    setValue(b) {
        this.check.checked = b;
        if (this.doHighlight) this.rootEl.classList.toggle('kl-checkbox--highlight', this.check.checked);
    }
    setEnabled(enabled) {
        this.check.disabled = !enabled;
        this.rootEl.classList.toggle('kl-checkbox--disabled', !enabled);
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.check.onchange = null;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        var _p_isEnabled;
        const isEnabled = (_p_isEnabled = p.isEnabled) !== null && _p_isEnabled !== void 0 ? _p_isEnabled : true;
        this.doHighlight = !!p.doHighlight;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-checkbox'
        });
        this.rootEl.classList.toggle('kl-checkbox--disabled', !isEnabled);
        const innerEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            tagName: 'label',
            className: 'kl-checkbox__inner',
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        this.check = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: innerEl,
            tagName: 'input',
            css: {
                margin: '0 5px 0 0',
                // otherwise varies by browser
                width: '14px',
                height: '14px'
            },
            custom: (0, $0616f0a0655c1023$export$71511d61b312f219)({
                type: 'checkbox',
                name: p.name
            }, !isEnabled ? {
                disabled: 'true'
            } : {})
        });
        this.check.checked = !!p.init;
        if (this.doHighlight && this.check.checked) this.rootEl.classList.add('kl-checkbox--highlight');
        if (!p.allowTab) this.check.tabIndex = -1;
        if (p.title) innerEl.title = p.title;
        const label = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: innerEl,
            content: p.label,
            css: {
                display: 'flex',
                alignItems: 'center',
                gap: '3px'
            }
        });
        this.check.onchange = ()=>{
            if (this.doHighlight) this.rootEl.classList.toggle('kl-checkbox--highlight', this.check.checked);
            p.callback && p.callback(this.check.checked);
            setTimeout(()=>{
                this.check.blur();
            }, 0);
        };
        if (p.css) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, p.css);
    }
}




class $760dd90d44275661$export$f5b8910cec6cf069 {
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.input.value;
    }
    setValue(v) {
        this.input.value = '' + v;
    }
    destroy() {
        this.pointerListener && this.pointerListener.destroy();
        this.keyListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.keyListener = {
            destroy: ()=>{}
        };
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'label',
            content: p.label,
            css: {
                display: 'flex',
                alignItems: 'center',
                gap: '5px'
            }
        });
        this.input = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'input',
            parent: this.rootEl,
            title: p.title,
            custom: {
                name: p.name
            }
        });
        var _p_type;
        this.type = (_p_type = p.type) !== null && _p_type !== void 0 ? _p_type : 'text';
        try {
            this.input.type = this.type;
        } catch (e) {
        // ie can't deal with number
        }
        var _p_step;
        const stepSize = (_p_step = p.step) !== null && _p_step !== void 0 ? _p_step : 1;
        if (this.type === 'number') {
            if (p.min !== undefined) this.input.min = '' + p.min;
            if (p.max !== undefined) this.input.max = '' + p.max;
            if (p.step !== undefined) this.input.step = '' + stepSize;
        }
        this.input.value = '' + p.init;
        let lastValidValue = this.input.value;
        /**
         * return true if not changed
         */ const handleChange = ()=>{
            const oldVal = lastValidValue;
            let newValue = this.input.value;
            if (p.doResetIfInvalid) {
                let didChange = false;
                if (newValue === '') {
                    newValue = lastValidValue;
                    didChange = true;
                }
                if (p.min !== undefined && parseFloat(newValue) < p.min) {
                    newValue = '' + p.min;
                    didChange = true;
                }
                if (p.max !== undefined && parseFloat(newValue) > p.max) {
                    newValue = '' + p.max;
                    didChange = true;
                }
                if (didChange) this.input.value = '' + newValue;
            }
            lastValidValue = newValue;
            return oldVal !== newValue;
        };
        if (p.onChange) {
            const onChange = p.onChange;
            this.input.onchange = ()=>{
                handleChange() && onChange(this.input.value);
            };
        }
        if (p.css) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.input, p.css);
        if (p.doScrollWithoutFocus && p.type === 'number' && p.onChange) {
            const onChange = p.onChange;
            this.keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({});
            this.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: this.input,
                onWheel: (e)=>{
                    /*if (document.hasFocus()) { // what was the point of this?
                        return;
                    }*/ const fac = this.keyListener.isPressed('shift') ? 4 : 1;
                    this.input.value = '' + (parseFloat(this.input.value) - e.deltaY * stepSize * fac);
                    handleChange() && onChange(this.input.value);
                }
            });
        }
    }
}
const $760dd90d44275661$export$b7e3ae3d7c15e42e = function(params) {
    const result = document.createElement('input');
    if (params.type) try {
        result.type = params.type;
    } catch (e) {
    /* empty */ // ie can't deal with number
    }
    else result.type = 'text';
    if (params.min !== undefined) result.min = '' + params.min;
    if (params.max !== undefined) result.max = '' + params.max;
    result.value = '' + params.init;
    if (params.callback) result.onchange = function() {
        params.callback(result.value);
    };
    if (params.css) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(result, params.css);
    return result;
};




class $b1ef42bd443626ca$export$ef9b1a59e592288f {
    setValue(val) {
        this.selectEl.value = val === undefined ? '' : val;
    }
    getValue() {
        return this.selectEl.value;
    }
    setDeltaValue(delta) {
        let index = 0;
        for(let i = 0; i < this.optionArr.length; i++){
            const option = this.optionArr[i];
            if (option.item && '' + option.item[0] === this.selectEl.value) {
                index = i;
                break;
            }
        }
        index = Math.max(0, Math.min(this.optionArr.length - 1, index + delta));
        const option = this.optionArr[index];
        this.selectEl.value = option.item ? option.item[0] : '';
        this.onChange && this.onChange(this.getValue());
    }
    getElement() {
        return this.selectEl;
    }
    updateLabel(id, label) {
        this.optionArr.forEach((option)=>{
            if (option.item && option.item[0] === id && option.el) {
                option.item[1] = label;
                option.el.textContent = option.item[1];
            }
        });
    }
    setOptionArr(optionArr) {
        const oldVal = this.selectEl.value;
        this.optionArr = [];
        this.selectEl.innerHTML = '';
        for(let i = 0; i < optionArr.length; i++){
            const item = optionArr[i];
            if (!item) {
                this.optionArr.push({
                    item: item
                });
                continue;
            }
            const el = document.createElement('option');
            el.value = item[0];
            el.textContent = item[1];
            if (item[2]) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(el, item[2].css);
            this.optionArr.push({
                item: item,
                el: el
            });
            this.selectEl.append(el);
        }
        // restore old value
        if (oldVal === '' || optionArr.findIndex((item)=>item && item[0] === oldVal) > -1) this.setValue(oldVal);
    }
    destroy() {
        this.selectEl.removeEventListener('change', this.changeListener);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.optionArr = [];
        this.selectEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'select',
            title: p.title,
            className: 'kl-select',
            css: {
                cursor: 'pointer',
                fontSize: '15px',
                padding: '3px'
            },
            custom: {
                name: p.name
            }
        });
        if (p.css) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.selectEl, p.css);
        const isFocusable = p.isFocusable;
        if (!isFocusable) this.selectEl.tabIndex = -1;
        this.setOptionArr(p.optionArr);
        if (p.onChange) this.onChange = p.onChange;
        this.changeListener = ()=>{
            if (!isFocusable) this.selectEl.blur();
            this.onChange && this.onChange(this.getValue());
        };
        this.selectEl.addEventListener('change', this.changeListener);
        this.selectEl.value = p.initValue !== undefined ? p.initValue : '';
    }
}



class $a14a8e8cf8cc5885$export$b6d053cded550773 {
    update() {
        this.rootEl.classList.toggle('image-toggle-active', this.isActive);
    }
    // --- interface ---
    setValue(b) {
        this.isActive = b;
        this.update();
    }
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.isActive;
    }
    destroy() {
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.rootEl);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isActive = p.initValue;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'image-toggle',
            title: p.title,
            content: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'image-toggle__im' + (p.darkInvert ? ' dark-invert' : ''),
                css: {
                    backgroundImage: "url('" + p.image + "')"
                }
            }),
            onClick: (e)=>{
                e.preventDefault();
                if (p.isRadio && this.isActive) return;
                this.isActive = !this.isActive;
                this.update();
                p.onChange(this.isActive);
            }
        });
        this.update();
    }
}




class $fa6faa989b2cc6b2$export$7cc1012a658e6ad8 {
    // --- interface ---
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.optionArr[this.activeIndex].id;
    }
    destroy() {
        this.optionArr.forEach((item)=>{
            item.radioEl.destroy();
        });
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'image-radio-wrapper',
            css: {
                display: 'flex'
            }
        });
        this.optionArr = [];
        const select = (index, id)=>{
            this.activeIndex = index;
            for(let i = 0; i < this.optionArr.length; i++)this.optionArr[i].radioEl.setValue(i === this.activeIndex);
            p.onChange(id);
        };
        let initialIndex;
        const createOption = (index, o)=>{
            if (o.id === p.initId) initialIndex = index;
            const radioEl = new (0, $a14a8e8cf8cc5885$export$b6d053cded550773)({
                image: o.image,
                title: o.title,
                initValue: o.id === p.initId,
                isRadio: true,
                onChange: ()=>{
                    select(index, o.id);
                },
                darkInvert: o.darkInvert
            });
            this.rootEl.append(radioEl.getElement());
            return {
                id: o.id,
                radioEl: radioEl
            };
        };
        for(let i = 0; i < p.optionArr.length; i++)this.optionArr.push(createOption(i, p.optionArr[i]));
        if (initialIndex === undefined) throw new Error('initId not in optionArr');
        this.activeIndex = initialIndex;
    }
}




var $28ed12ab6bd16517$exports = {};
$28ed12ab6bd16517$exports = $parcel$resolve("kav7s");




class $8d99bd5fadaac7f9$export$2358c75ad3c15b2d {
    update() {
        this.el.classList.toggle('kl-box-toggle--active', this.value);
    }
    getValue() {
        return this.value;
    }
    setValue(b) {
        this.value = b;
        this.update();
    }
    getElement() {
        return this.el;
    }
    destroy() {
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.el);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.value = !!p.init;
        this.el = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: p.label,
            title: p.title,
            className: typeof p.label === 'string' ? 'kl-box-toggle' : 'kl-box-toggle kl-box-toggle--custom-el',
            onClick: ()=>{
                this.value = !this.value;
                this.update();
                p.onChange(this.value);
            },
            css: {
                cursor: 'pointer'
            }
        });
        if (typeof p.label !== 'string') (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(p.label, {
            display: 'block',
            pointerEvents: 'none'
        });
        this.update();
    }
}


const $218f70778c2bf652$export$9da2e8821e6cbb57 = function(isChecked, changeCallback) {
    const toggleEl = new (0, $8d99bd5fadaac7f9$export$2358c75ad3c15b2d)({
        label: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'dark-invert',
            css: {
                width: '17px',
                height: '17px',
                backgroundImage: 'url("' + (0, (/*@__PURE__*/$parcel$interopDefault($28ed12ab6bd16517$exports))) + '")',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                margin: '1px',
                borderRadius: '3px'
            }
        }),
        title: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-toggle-pressure'),
        init: isChecked,
        onChange: (b)=>{
            changeCallback(b);
        }
    });
    return toggleEl.getElement();
};



/**
 * To make sliders more fine-grained. The falloff when moving cursor away from cursor.
 * Returns the factor [0,1]
 *  0 -> infinite movement required for change of 1
 *  1 -> 1px movement for change of 1
 *
 * @param deltaY vertical distance from pointerdown
 * @param isRightButton
 */ function $6e485eb0c82960d0$export$f8e41e222e32615d(deltaY, isRightButton) {
    let result = Math.min(10, 1 + Math.pow(Math.floor(deltaY / 50), 2));
    if (isRightButton) result *= 2;
    return 1 / result;
}






class $31b6ab403d8e5713$export$db3d4fde05db9a5e {
    emit() {
        if (this.lastValue !== Number(this.input.value)) {
            this.onChange(Number(this.input.value));
            this.lastValue = Number(this.input.value);
        }
    }
    privateOnClose() {
        if (this.isClosed) return;
        this.isClosed = true;
        this.emit();
        this.onClose();
        setTimeout(()=>{
            // because iPad keyboard changes the scroll position
            this.scrollBefore && window.scrollTo(this.scrollBefore.x, this.scrollBefore.y);
            this.scrollBefore = undefined;
        });
    }
    getElement() {
        return this.input;
    }
    setIsEnabled(b) {
        this.isEnabled = b;
    }
    focus() {
        this.input.focus();
        this.input.select();
    }
    destroy() {
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.input);
    }
    // ----------------------------------- public -----------------------------------
    constructor(value, min, max, rect, onChange, onClose, roundDigits){
        this.onChange = onChange;
        this.onClose = onClose;
        this.isEnabled = true;
        this.isClosed = false;
        this.input = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            type: 'number',
            init: value,
            min: min,
            max: max,
            callback: (val)=>{
                this.emit();
            }
        });
        if (roundDigits !== 0) this.input.setAttribute('step', 'any');
        this.input.onblur = ()=>{
            this.privateOnClose();
        };
        this.input.addEventListener('keyup', (e)=>{
            if ([
                'Enter',
                'Escape'
            ].includes(e.key)) this.privateOnClose();
            else this.emit();
        }, {
            passive: false
        });
        this.input.addEventListener('wheel', ()=>this.emit(), {
            passive: false
        });
        this.scrollBefore = {
            x: window.scrollX,
            y: window.scrollY
        };
        let currentValue;
        if (roundDigits || roundDigits === 0) currentValue = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(value, roundDigits);
        else currentValue = value;
        this.lastValue = currentValue;
        this.input.value = '' + currentValue;
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.input, {
            width: rect.width + 'px',
            height: rect.height + 'px'
        });
    }
}



class $cd73d123a4560ac3$export$a1855b925e534de7 {
    valueToSliderValue(value) {
        if (this.useSpline && this.splineInterpolator) return this.splineInterpolator.findX(value, Math.floor(this.resolution)) || 0;
        return (value - this.min) / (this.max - this.min);
    }
    sliderValueToValue(sliderValue) {
        let result = this.min + sliderValue * (this.max - this.min);
        if (this.useSpline && this.splineInterpolator) result = this.splineInterpolator.interpolate(sliderValue) || 0;
        return result;
    }
    updateLabel() {
        let displayValue = this.valueToDisplayValue(this.value);
        displayValue = this.formatFunc ? this.formatFunc(displayValue) : Math.round(displayValue);
        displayValue = displayValue.toLocaleString((0, $63d0b335c576c718$export$e4ce066d17694649).getCode());
        const unit = this.unit !== undefined ? this.unit : '';
        this.labelValueEl.textContent = displayValue + unit;
        const sliderValue = this.valueToSliderValue(this.value);
        this.control.style.width = sliderValue * this.elementWidth + 'px';
    }
    emit(isFinal) {
        if (!isFinal && this.isChangeOnFinal) return;
        if (isFinal || !this.eventResMs) {
            this.onChange(this.value);
            if (this.emitInterval) {
                clearInterval(this.emitInterval);
                this.emitInterval = undefined;
            }
            return;
        }
        if (this.emitInterval) this.emitValue = this.value;
        else {
            this.onChange(this.value);
            this.emitInterval = setInterval(()=>{
                if (this.emitValue === undefined) {
                    clearInterval(this.emitInterval);
                    this.emitInterval = undefined;
                } else {
                    this.onChange(this.emitValue);
                    this.emitValue = undefined;
                }
            }, this.eventResMs);
        }
    }
    updateEnable() {
        this.sliderWrapperEl.classList.toggle('slider-wrapper--disabled', !this.isEnabled);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.sliderWrapperEl, {
            opacity: this.isEnabled ? '' : '0.5',
            pointerEvents: this.isEnabled ? '' : 'none'
        });
        if (this.manualInput) this.manualInput.setIsEnabled(this.isEnabled);
    }
    showManualInput() {
        this.manualInput = new (0, $31b6ab403d8e5713$export$db3d4fde05db9a5e)(this.valueToDisplayValue(this.value), this.valueToDisplayValue(this.min), this.valueToDisplayValue(this.max), this.sliderWrapperEl.getBoundingClientRect(), (val)=>{
            val = this.displayValueToValue(val);
            this.setValue((0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(val, this.min, this.max));
            this.onChange(this.value);
        }, ()=>{
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.sliderWrapperEl, {
                display: ''
            });
            if (this.manualInput) {
                this.manualInput.getElement().remove();
                this.manualInput.destroy();
            }
            this.manualInput = undefined;
        }, this.manualInputRoundDigits && this.manualInputRoundDigits > 0 ? this.manualInputRoundDigits : 0);
        this.manualInput.setIsEnabled(this.isEnabled);
        this.rootEl.append(this.manualInput.getElement());
        setTimeout(()=>{
            this.manualInput && this.manualInput.focus();
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.sliderWrapperEl, {
            display: 'none'
        });
    }
    changeSliderValue(f) {
        if (!this.isEnabled) return;
        let sliderValue = this.valueToSliderValue(this.value);
        sliderValue = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(sliderValue + f, 0, 1);
        this.value = this.sliderValueToValue(sliderValue);
        this.updateLabel();
        this.onChange(this.value);
    }
    setValue(v) {
        this.value = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(v, this.min, this.max);
        this.updateLabel();
    }
    getValue() {
        return this.value;
    }
    getDisplayValue() {
        return this.valueToDisplayValue(this.value);
    }
    update(config) {
        this.min = config.min;
        this.max = config.max;
        this.useSpline = !!config.curve;
        if (this.useSpline) {
            if (!config.curve) throw new Error('curve needs to be set if useSpline true');
            const curveArr = config.curve === 'quadratic' ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(this.min, this.max, 0.1) : config.curve;
            this.splineInterpolator = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).SplineInterpolator(curveArr);
        } else this.splineInterpolator = undefined;
        this.setIsEnabled(!config.isDisabled);
    }
    setIsEnabled(e) {
        this.isEnabled = e;
        this.updateEnable();
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        clearTimeout(this.pointerListenerTimeout);
        this.pointerListener && this.pointerListener.destroy();
        if (this.manualInput) this.manualInput.destroy();
        if (this.emitInterval) clearInterval(this.emitInterval);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isEnabled = p.isEnabled !== false;
        this.manualInputRoundDigits = p.manualInputRoundDigits;
        this.useSpline = !!p.curve;
        if (!p.label) throw new Error('KlSlider missing params');
        if (p.min != 0 && p.max != 0 && p.value != 0) {
            if (!p.min || !p.max || !p.value) throw new Error('KlSlider broken params');
        }
        if (p.min >= p.max) throw new Error('KlSlider broken params');
        this.min = p.min;
        this.max = p.max;
        this.value = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(p.value, this.min, this.max);
        this.elementWidth = p.width;
        this.elementHeight = p.height;
        this.resolution = p.resolution ? p.resolution : this.elementWidth * 2;
        this.onChange = p.onChange ? p.onChange : ()=>{};
        if (!p.toValue !== !p.toDisplayValue) throw new Error('both or neither have to be set, toValue and toDisplayValue');
        this.displayValueToValue = p.toValue ? p.toValue : (displayValue)=>displayValue;
        this.valueToDisplayValue = p.toDisplayValue ? p.toDisplayValue : (value)=>value;
        this.isChangeOnFinal = !!p.isChangeOnFinal;
        this.formatFunc = p.formatFunc;
        this.eventResMs = p.eventResMs;
        this.unit = p.unit;
        if (this.useSpline) {
            if (!p.curve) throw new Error('curve needs to be set if useSpline true');
            const curveArr = p.curve === 'quadratic' ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(this.min, this.max, 0.1) : p.curve;
            this.splineInterpolator = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).SplineInterpolator(curveArr);
        }
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex'
            }
        });
        this.sliderWrapperEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'slider-wrapper',
            css: {
                overflow: 'hidden',
                position: 'relative',
                width: this.elementWidth + 'px',
                height: this.elementHeight + 'px',
                userSelect: 'none'
            }
        });
        this.rootEl.oncontextmenu = function() {
            return false;
        };
        this.label = p.label;
        const labelFontSize = this.elementHeight - 14;
        this.labelValueEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                fontWeight: 'bold'
            }
        });
        this.textEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    content: this.label,
                    css: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }
                }),
                this.labelValueEl
            ],
            css: {
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                padding: '0 7px',
                height: '100%',
                width: '100%',
                fontSize: labelFontSize + 'px',
                pointerEvents: 'none',
                gap: '8px'
            }
        });
        this.control = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'slider-inner',
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                width: this.valueToSliderValue(this.value) * this.elementWidth + 'px',
                height: this.elementHeight + 'px'
            }
        });
        const controlInner = document.createElement('div');
        this.sliderWrapperEl.append(this.control, this.textEl);
        this.control.append(controlInner);
        this.updateEnable();
        const doubleTapper = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).DoubleTapper({
            onDoubleTap: ()=>{
                this.showManualInput();
            }
        });
        doubleTapper.setAllowedButtonArr([
            'left',
            'right'
        ]);
        const eventChain = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).EventChain({
            chainArr: [
                doubleTapper
            ]
        });
        let virtualVal;
        const onPointer = (event)=>{
            event.eventPreventDefault();
            if (!this.isEnabled) return;
            if (event.type === 'pointerdown') {
                // unfocus manual slider input
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unfocusAnyInput();
                this.sliderWrapperEl.className = 'slider-wrapper slider-wrapper--active';
                if (event.button === 'left') {
                    let sliderValue = event.relX / this.elementWidth;
                    sliderValue = Math.max(0, Math.min(1, sliderValue));
                    this.value = this.sliderValueToValue(sliderValue);
                    this.updateLabel();
                    this.emit(false);
                }
                virtualVal = this.valueToSliderValue(this.value);
            }
            if (event.type === 'pointermove' && [
                'left',
                'right'
            ].includes(event.button || '')) {
                let deltaX = event.dX;
                const deltaY = Math.abs(event.pageY - (event.downPageY || 0));
                const factor = (0, $6e485eb0c82960d0$export$f8e41e222e32615d)(deltaY, event.button === 'right');
                deltaX *= factor;
                deltaX /= this.elementWidth;
                virtualVal += deltaX;
                const sliderValue = Math.max(0, Math.min(1, virtualVal));
                this.value = this.sliderValueToValue(sliderValue);
                this.updateLabel();
                this.emit(false);
            }
            if (event.type === 'pointerup') {
                this.sliderWrapperEl.className = 'slider-wrapper';
                this.emit(true);
            }
        };
        this.pointerListenerTimeout = setTimeout(()=>{
            this.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: this.sliderWrapperEl,
                fixScribble: true,
                onPointer: (e)=>{
                    onPointer(e);
                    eventChain.chainIn(e);
                },
                onWheel: (event)=>{
                    let sliderValue = this.valueToSliderValue(this.value);
                    sliderValue = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(sliderValue - event.deltaY / 40, 0, 1);
                    this.value = this.sliderValueToValue(sliderValue);
                    this.updateLabel();
                    this.onChange(this.value);
                }
            });
            this.updateLabel();
        }, 1);
    }
}






var $895204cb2449c455$exports = {};
$895204cb2449c455$exports = $parcel$resolve("43nfB");




function $934e5f47c3374e21$var$decomposeElString(el) {
    if (el === '') return {};
    let split;
    let tagName;
    const classes = [];
    split = el.split('.');
    if (split.length === 1) {
        split = split[0].split(',');
        tagName = split.shift();
    } else {
        tagName = split.shift();
        split.forEach((item, index)=>{
            const isLast = index === split.length - 1;
            if (isLast) {
                split = item.split(',');
                const last = split.shift();
                if (last !== undefined) classes.push(last);
            } else classes.push(item);
        });
    }
    const result = {};
    if (tagName !== '') result.tagName = tagName;
    if (classes.length > 0) result.classes = classes;
    if (split.length > 0) result.styles = split;
    return result;
}
function $934e5f47c3374e21$var$applyStyleNames(el, styleNames) {
    const style = {};
    const operations = {
        c: (params)=>{
            style.color = params[0];
        },
        bg: (params)=>{
            style.background = params[0];
        },
        p: (params)=>{
            style.padding = params[0] + 'px';
        },
        py: (params)=>{
            style.paddingTop = params[0] + 'px';
            style.paddingBottom = params[0] + 'px';
        },
        pt: (params)=>{
            style.paddingTop = params[0] + 'px';
        },
        pr: (params)=>{
            style.paddingRight = params[0] + 'px';
        },
        pb: (params)=>{
            style.paddingBottom = params[0] + 'px';
        },
        pl: (params)=>{
            style.paddingLeft = params[0] + 'px';
        },
        mt: (params)=>{
            style.marginTop = params[0] + 'px';
        },
        mr: (params)=>{
            style.marginRight = params[0] + 'px';
        },
        mb: (params)=>{
            style.marginBottom = params[0] + 'px';
        },
        ml: (params)=>{
            style.marginLeft = params[0] + 'px';
        },
        // flex
        flex: ()=>{
            style.display = 'flex';
        },
        flexCol: ()=>{
            style.flexDirection = 'column';
        },
        flexWrap: ()=>{
            style.flexWrap = 'wrap';
        },
        gap: (params)=>{
            style.gap = params.map((item)=>item + 'px').join(' ');
        },
        grow: ()=>{
            style.flexGrow = '1';
        },
        justify: (params)=>{
            style.justifyContent = params[0];
        },
        items: (params)=>{
            style.alignItems = params[0];
        },
        hidden: ()=>{
            style.display = 'none';
        },
        nowrap: ()=>{
            style.whiteSpace = 'nowrap';
        },
        abs: (params)=>{
            style.position = 'absolute';
            style.left = params[0] + 'px';
            style.top = params[1] + 'px';
        },
        w: (params)=>{
            style.width = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        h: (params)=>{
            style.height = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        minh: (params)=>{
            style.minHeight = params[0] + 'px';
        },
        z: (params)=>{
            style.zIndex = params[0];
        },
        overflow: (params)=>{
            style.overflow = params[0];
        },
        pos: (params)=>{
            style.position = params[0];
        },
        left: (params)=>{
            style.left = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        top: (params)=>{
            style.top = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        right: (params)=>{
            style.right = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        bottom: (params)=>{
            style.bottom = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        size: (params)=>{
            style.fontSize = params[0] + 'px';
        },
        pointer: (params)=>{
            style.pointerEvents = params[0];
        }
    };
    styleNames.forEach((item)=>{
        const params = item.split('-');
        const operation = params.shift();
        operations[operation](params);
    });
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(el, style);
}
function $934e5f47c3374e21$export$db3b6bfb95261072(element, inner) {
    if (element === undefined) return document.createElement('div');
    if (typeof element !== 'string') {
        if (!(element instanceof HTMLElement)) element = (0, $52ad4d7a7d6372c1$export$c3da0dad1b44eea9)(element);
        if (inner) {
            if (typeof inner === 'string') element.innerHTML = inner;
            else element.append(...inner);
        }
        return element;
    }
    const decomp = $934e5f47c3374e21$var$decomposeElString(element);
    var _decomp_tagName;
    const result = document.createElement((_decomp_tagName = decomp.tagName) !== null && _decomp_tagName !== void 0 ? _decomp_tagName : 'div');
    decomp.classes && result.classList.add(...decomp.classes);
    decomp.styles && $934e5f47c3374e21$var$applyStyleNames(result, decomp.styles);
    if (inner) {
        if (typeof inner === 'string') result.innerHTML = inner;
        else result.append(...inner);
    }
    return result;
}


var $cf02414f4b0b48a4$export$9852986a3ec5f6a0;
$cf02414f4b0b48a4$export$9852986a3ec5f6a0 = `_7-bVqq_table`;


class $49ce344532144fcf$export$cc42e119007cb939 {
    // ----------------------------------- public -----------------------------------
    constructor(p){
        let lastValidRgb = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(p.color.r, p.color.g, p.color.b);
        const previewEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '20px',
                height: '20px',
                marginBottom: '10px',
                boxShadow: 'inset 0 0 0 1px #fff, 0 0 0 1px #000',
                background: '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(lastValidRgb)
            }
        });
        // --- Hex ---
        const hexLabel = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('mci-hex')
        });
        const hexInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(lastValidRgb),
            css: {
                width: '80px'
            },
            callback: function() {
                let rgbObj = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.hexToRGB(hexInput.value);
                if (!rgbObj) {
                    rgbObj = lastValidRgb;
                    hexInput.value = '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(lastValidRgb);
                } else lastValidRgb = rgbObj;
                previewEl.style.background = '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(rgbObj);
                for(let i = 0; i < rgbArr.length; i++)rgbArr[i].update();
            }
        });
        const copyButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: '<img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($895204cb2449c455$exports))) + '" height="20" alt=""/>',
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('mci-copy'),
            onClick: function() {
                hexInput.select();
                navigator.clipboard.writeText(hexInput.value).then().catch();
            }
        });
        const hexRowEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)({
            css: {
                display: 'flex',
                alignItems: 'center',
                marginBottom: '15px',
                flexWrap: 'wrap',
                gap: '5px 10px',
                maxWidth: '250px'
            }
        }, [
            hexLabel,
            (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,items-center,gap-10', [
                hexInput,
                copyButton
            ])
        ]);
        setTimeout(function() {
            hexInput.focus();
            hexInput.select();
        }, 0);
        // --- R G B ---
        function createRgbInputRow(labelStr, attributeStr) {
            const inputEl = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
                init: lastValidRgb[attributeStr],
                min: 0,
                max: 255,
                type: 'number',
                css: {
                    width: '80px'
                },
                callback: function() {
                    if (inputEl.value === '' || parseFloat(inputEl.value) < 0 || parseFloat(inputEl.value) > 255) {
                        result.update();
                        return;
                    }
                    inputEl.value = '' + Math.round(parseFloat(inputEl.value));
                    lastValidRgb[attributeStr] = Number(inputEl.value);
                    previewEl.style.background = '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(lastValidRgb);
                    hexInput.value = '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(lastValidRgb);
                }
            });
            const rowEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)('tr', [
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)('td,pr-10', labelStr),
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)('td', [
                    inputEl
                ])
            ]);
            const result = {
                update: ()=>{
                    inputEl.value = '' + lastValidRgb[attributeStr];
                },
                destroy: ()=>{
                    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unsetEventHandler(inputEl, 'onchange');
                },
                element: rowEl
            };
            return result;
        }
        const rgbArr = [
            createRgbInputRow((0, $63d0b335c576c718$export$ce37e184d908d785)('red'), 'r'),
            createRgbInputRow((0, $63d0b335c576c718$export$ce37e184d908d785)('green'), 'g'),
            createRgbInputRow((0, $63d0b335c576c718$export$ce37e184d908d785)('blue'), 'b')
        ];
        const rootEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)('', [
            previewEl,
            hexRowEl,
            (0, $934e5f47c3374e21$export$db3b6bfb95261072)('table.' + $cf02414f4b0b48a4$export$9852986a3ec5f6a0, [
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)('tbody', rgbArr.map((item)=>item.element))
            ])
        ]);
        (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
            message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('manual-color-input')}</b>`,
            div: rootEl,
            autoFocus: false,
            clickOnEnter: 'Ok',
            buttons: [
                'Ok',
                'Cancel'
            ],
            callback: function(resultStr) {
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(copyButton);
                rgbArr.forEach((item)=>item.destroy());
                rgbArr.splice(0, rgbArr.length);
                p.onClose(resultStr === 'Ok' ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.hexToRGB(hexInput.value) : undefined);
            }
        });
    }
}





var $d1c3e18053002796$exports = {};
$d1c3e18053002796$exports = $parcel$resolve("9Vqzx");





const $74a507c74cfe9692$var$LS_THEME_KEY = 'klecks-theme';
class $74a507c74cfe9692$var$Theme {
    updateTheme() {
        const oldTheme = this.theme;
        this.theme = this.storedTheme || this.mediaQueryTheme;
        if (this.theme === oldTheme) return;
        document.documentElement.classList.toggle('kl-theme-dark', this.theme === 'dark');
        this.listeners.forEach((item)=>item());
    }
    readLocalStorage() {
        let result = (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem($74a507c74cfe9692$var$LS_THEME_KEY);
        if (!result || typeof result === 'string' && ![
            'dark',
            'light'
        ].includes(result)) {
            result = undefined;
            (0, $0ecef66681b62a8c$export$19fffca37ef3e106).removeItem($74a507c74cfe9692$var$LS_THEME_KEY); // reset because invalid
        }
        return result;
    }
    isDark() {
        return this.theme === 'dark';
    }
    addIsDarkListener(func) {
        if (this.listeners.includes(func)) return;
        this.listeners.push(func);
    }
    removeIsDarkListener(func) {
        for(let i = 0; i < this.listeners.length; i++)if (this.listeners[i] === func) {
            this.listeners.splice(i, 1);
            return;
        }
    }
    getMediaQueryTheme() {
        return this.mediaQueryTheme;
    }
    getStoredTheme() {
        return this.storedTheme;
    }
    setStoredTheme(theme) {
        if (theme) (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem($74a507c74cfe9692$var$LS_THEME_KEY, theme);
        else (0, $0ecef66681b62a8c$export$19fffca37ef3e106).removeItem($74a507c74cfe9692$var$LS_THEME_KEY);
        this.storedTheme = theme;
        this.updateTheme();
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        // initialization will be overwritten.
        this.mediaQueryTheme = 'light' // prefers-color-scheme
        ;
        this.theme = 'light';
        this.listeners = [];
        // init media query
        this.mediaQueryTheme = (0, $fc4403c8ee6a33dc$export$a79ad82046afa44e)() ? 'dark' : 'light';
        (0, $fc4403c8ee6a33dc$export$a9dfd81f95a8a526)(()=>{
            this.mediaQueryTheme = (0, $fc4403c8ee6a33dc$export$a79ad82046afa44e)() ? 'dark' : 'light';
            this.updateTheme();
        });
        // init local storage
        this.storedTheme = this.readLocalStorage();
        addEventListener('storage', (e)=>{
            if (e.key === $74a507c74cfe9692$var$LS_THEME_KEY) {
                this.storedTheme = this.readLocalStorage();
                this.updateTheme();
            }
        });
        this.updateTheme();
    }
}
const $74a507c74cfe9692$export$5714e40777c1bcc2 = new $74a507c74cfe9692$var$Theme();


const $7a2aeb795d64bafc$export$e4203cb02d5e5b28 = (0, $74a507c74cfe9692$export$5714e40777c1bcc2).isDark() ? 255 : 255;
function $7a2aeb795d64bafc$export$8627e24041b28589() {
    return {
        r: $7a2aeb795d64bafc$export$e4203cb02d5e5b28,
        g: $7a2aeb795d64bafc$export$e4203cb02d5e5b28,
        b: $7a2aeb795d64bafc$export$e4203cb02d5e5b28
    };
}




function $f133619cff967492$export$eed76a6c3d7eed98(grad) {
    for(let i = 0; i <= 100; i++){
        const frac = i / 100;
        const col = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(frac * 360, 100, 100));
        grad.addColorStop(frac, '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(col));
    }
}


class $90a88670cfc900e0$export$4e5102252876c5d7 {
    updatePrimaryHSV(hsv) {
        if (hsv.s === 0) this.primaryColorHsv = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(this.primaryColorHsv.h, hsv.s, hsv.v);
        else this.primaryColorHsv = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(hsv.h, hsv.s, hsv.v);
    }
    updateSVCanvas() {
        const rgb = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(this.primaryColorHsv.h, 100, 100));
        this.svGradient.style.setProperty('--kl-color-picker--hue', '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(rgb));
    }
    updateSVPointer() {
        const left = this.primaryColorHsv.s / 100 * this.width - 7;
        const top = (1 - this.primaryColorHsv.v / 100) * this.svHeight - 6;
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.pointerSV, {
            left: left + 'px',
            top: top + 'px'
        });
    }
    setColPreview() {
        this.divPreview.style.backgroundColor = 'rgb(' + this.primaryColorRgb.r + ',' + this.primaryColorRgb.g + ',' + this.primaryColorRgb.b + ')';
        if ((0, $d9f9f4926aa80a1c$export$921068d8846a1559).testIsWhiteBestContrast(this.primaryColorRgb)) {
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.pickerButton, {
                filter: 'invert(1)'
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.hexButton, {
                filter: 'invert(1)'
            });
        } else {
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.pickerButton, {
                filter: ''
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.hexButton, {
                filter: ''
            });
        }
    }
    updateSecondaryColor() {
        this.secondaryColorBtn.style.backgroundColor = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(this.secondaryColorRgb);
    }
    setColor(c) {
        this.primaryColorRgb = {
            r: parseInt('' + c.r),
            g: parseInt('' + c.g),
            b: parseInt('' + c.b)
        };
        this.updatePrimaryHSV((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHSV(c));
        this.controlH.style.left = parseInt('' + (this.primaryColorHsv.h / 359 * this.width - 1)) + 'px';
        this.updateSVCanvas();
        this.updateSVPointer();
        this.setColPreview();
    }
    getColor() {
        return new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b);
    }
    getSecondaryRGB() {
        return new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(this.secondaryColorRgb.r, this.secondaryColorRgb.g, this.secondaryColorRgb.b);
    }
    getIsEyedropping() {
        return this.isPicking;
    }
    setIsEyedropping(b) {
        if (b) {
            this.isPicking = true;
            this.onEyedropper(true);
            this.pickerButton.classList.add('color-picker-preview-button-active');
        } else {
            this.isPicking = false;
            this.onEyedropper(false);
            this.pickerButton.classList.remove('color-picker-preview-button-active');
        }
    }
    enable(e) {
        const style = {
            pointerEvents: e ? '' : 'none',
            opacity: e ? '1' : '0.5'
        };
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, style);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.outputDiv, style);
    }
    setHeight(h) {
        h = parseInt('' + (h - this.height * 2 - 3), 10);
        if (h === this.svHeight) return;
        this.svHeight = h;
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.svGradient, {
            width: this.width + 'px',
            height: this.svHeight + 'px'
        });
        this.SVContainer.style.height = this.svHeight + 'px';
        this.updateSVPointer();
    }
    swapColors() {
        // swap hsv
        let tmp = this.secondaryColorHsv;
        this.secondaryColorHsv = this.primaryColorHsv;
        this.updatePrimaryHSV(tmp);
        // swap rgb
        tmp = this.secondaryColorRgb;
        this.secondaryColorRgb = this.primaryColorRgb;
        this.primaryColorRgb = tmp;
        this.controlH.style.left = parseInt('' + (this.primaryColorHsv.h / 359 * this.width - 1)) + 'px';
        this.updateSVCanvas();
        this.updateSVPointer();
        this.setColPreview();
        this.updateSecondaryColor();
        this.emitColor(new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b));
    }
    getElement() {
        return this.rootEl;
    }
    getOutputElement() {
        return this.outputDiv;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-color-picker',
            css: {
                position: 'relative'
            }
        });
        this.outputDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        this.width = p.width;
        this.svHeight = p.svHeight;
        this.height = p.height;
        this.emitColor = p.onPick;
        this.onEyedropper = p.onEyedropper;
        this.primaryColorRgb = {
            r: parseInt('' + p.startValue.r),
            g: parseInt('' + p.startValue.g),
            b: parseInt('' + p.startValue.b)
        };
        this.primaryColorHsv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHSV(p.startValue); // BB.HSV
        this.secondaryColorRgb = {
            r: (0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28),
            g: (0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28),
            b: (0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28)
        };
        this.secondaryColorHsv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter._RGBtoHSV(this.secondaryColorRgb); // BB.HSV
        const svWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        this.svGradient = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                background: 'linear-gradient(0deg, #000 0%, rgba(255, 0, 0, 0) 100%), linear-gradient(-90deg, var(--kl-color-picker--hue) 0%, #fff 100%)',
                width: this.width + 'px',
                height: this.svHeight + 'px'
            }
        });
        svWrapper.append(this.svGradient);
        const divH = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-color-picker__h',
            css: {
                overflow: 'hidden',
                position: 'relative',
                width: this.width + 'px',
                height: this.height + 'px',
                cursor: 'ew-resize',
                marginTop: '1px',
                marginBottom: '1px'
            }
        });
        this.divPreview = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-color-picker__preview',
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                width: this.height * 2.5 + 'px',
                height: this.height + 'px'
            }
        });
        this.controlH = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const createHueBg = (targetEl)=>{
            const im = new Image();
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(im, {
                position: 'absolute',
                left: '0',
                top: '0',
                display: 'none',
                pointerEvents: 'none'
            });
            const cv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.width, this.height);
            const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(cv);
            const gradH = ctx.createLinearGradient(0, 0, this.width, 0);
            (0, $f133619cff967492$export$eed76a6c3d7eed98)(gradH);
            ctx.fillStyle = gradH;
            ctx.fillRect(0, 0, this.width, this.height);
            targetEl.append(im);
            im.alt = 'hue';
            im.src = cv.toDataURL('image/png');
            im.style.display = 'block';
        };
        this.updateSVCanvas();
        this.rootEl.style.width = this.width + 'px';
        this.rootEl.oncontextmenu = ()=>{
            return false;
        };
        this.SVContainer = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-color-picker__sv',
            css: {
                width: this.width + 'px',
                height: this.svHeight + 'px',
                overflow: 'hidden',
                display: 'block',
                position: 'relative',
                cursor: 'crosshair'
            }
        });
        this.pointerSV = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                position: 'absolute',
                pointerEvents: 'none',
                boxShadow: '0px 0px 0 1px #000, inset 0px 0px 0 1px #fff'
            }
        });
        this.SVContainer.append(svWrapper, this.pointerSV);
        this.updateSVPointer();
        this.rootEl.append(this.SVContainer, divH);
        this.outputDiv.append(this.divPreview);
        //divH.className = "svSlider";
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.controlH, {
            width: '2px',
            height: this.height + 'px',
            background: '#000',
            borderLeft: '1px solid #fff',
            position: 'absolute',
            top: '0',
            left: parseInt('' + (this.primaryColorHsv.h / 360 * this.width - 1)) + 'px'
        });
        const virtualHSV = {
            h: 0,
            s: 0,
            v: 0
        };
        this.pickerButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('eyedropper') + ' [Alt]',
            className: 'color-picker-preview-button',
            css: {
                width: '30px',
                height: '30px',
                backgroundImage: 'url(' + (0, (/*@__PURE__*/$parcel$interopDefault($d1c3e18053002796$exports))) + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '70%',
                backgroundPosition: 'center'
            },
            onClick: ()=>{
                if (this.isPicking) this.setIsEyedropping(false);
                else {
                    this.pickerButton.classList.remove('color-picker-preview-button-hover');
                    this.pickerButton.classList.add('color-picker-preview-button-active');
                    this.isPicking = true;
                    this.onEyedropper(true);
                }
            }
        });
        this.isPicking = false;
        const pickerButtonPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.pickerButton,
            onEnterLeave: (isOver)=>{
                if (this.isPicking) return;
                this.pickerButton.classList.toggle('color-picker-preview-button-hover', isOver);
            }
        });
        this.divPreview.append(this.pickerButton);
        this.hexButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: '#',
            className: 'color-picker-preview-button',
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('manual-color-input'),
            css: {
                height: '100%',
                width: this.height + 'px',
                lineHeight: this.height + 'px',
                fontSize: this.height * 0.65 + 'px'
            },
            onClick: ()=>{
                new (0, $49ce344532144fcf$export$cc42e119007cb939)({
                    color: new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b),
                    onClose: (rgbObj)=>{
                        if (!rgbObj) return;
                        this.setColor(rgbObj);
                        this.emitColor(new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b));
                    }
                });
            }
        });
        const hexButtonPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.hexButton,
            onEnterLeave: (isOver)=>{
                this.hexButton.classList.toggle('color-picker-preview-button-hover', isOver);
            }
        });
        this.divPreview.append(this.hexButton);
        this.setColPreview();
        setTimeout(()=>{
            createHueBg(divH);
            divH.append(this.controlH);
            const svPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: svWrapper,
                fixScribble: true,
                onPointer: (event)=>{
                    if (event.type === 'pointerdown') {
                        // prevent manual slider input keeping focus on iPad
                        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unfocusAnyInput();
                        this.SVContainer.classList.toggle('kl-color-picker--active', true);
                        if (event.button === 'left') {
                            virtualHSV.s = event.relX / this.width * 100;
                            virtualHSV.v = 100 - event.relY / this.svHeight * 100;
                            this.primaryColorHsv = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(this.primaryColorHsv.h, virtualHSV.s, virtualHSV.v);
                            this.primaryColorRgb = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv);
                            this.updateSVPointer();
                            this.setColPreview();
                            this.emitColor((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv));
                        } else {
                            virtualHSV.s = this.primaryColorHsv.s;
                            virtualHSV.v = this.primaryColorHsv.v;
                        }
                    }
                    if (event.type === 'pointermove' && [
                        'left',
                        'right'
                    ].includes(event.button || '')) {
                        let factor = 1;
                        if (event.button === 'right') factor = 0.5;
                        virtualHSV.s += event.dX / this.width * 100 * factor;
                        virtualHSV.v -= event.dY / this.svHeight * 100 * factor;
                        this.primaryColorHsv = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(this.primaryColorHsv.h, virtualHSV.s, virtualHSV.v);
                        this.primaryColorRgb = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv);
                        this.updateSVPointer();
                        this.setColPreview();
                        this.emitColor((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv));
                    }
                    if (event.type === 'pointerup') this.SVContainer.classList.toggle('kl-color-picker--active', false);
                }
            });
            const hPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: divH,
                fixScribble: true,
                onPointer: (event)=>{
                    if (event.type === 'pointerdown') {
                        // prevent manual slider input keeping focus on iPad
                        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unfocusAnyInput();
                        divH.classList.toggle('kl-color-picker--active', true);
                        if (event.button === 'left') {
                            virtualHSV.h = event.relX / this.width * 359.99;
                            this.primaryColorHsv = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(virtualHSV.h, this.primaryColorHsv.s, this.primaryColorHsv.v);
                            this.primaryColorRgb = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv);
                            this.controlH.style.left = Math.round(this.primaryColorHsv.h / 359.99 * this.width) - 1 + 'px';
                            this.updateSVCanvas();
                            this.setColPreview();
                            this.emitColor((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv));
                        } else virtualHSV.h = this.primaryColorHsv.h;
                    }
                    if (event.type === 'pointermove' && [
                        'left',
                        'right'
                    ].includes(event.button || '')) {
                        const deltaY = Math.abs(event.pageY - event.downPageY);
                        const factor = (0, $6e485eb0c82960d0$export$f8e41e222e32615d)(deltaY, event.button === 'right');
                        virtualHSV.h += event.dX / this.width * 359.99 * factor;
                        if (event.button === 'right') {
                            virtualHSV.h = virtualHSV.h % 359.99;
                            if (virtualHSV.h < 0) virtualHSV.h += 359.99;
                        }
                        virtualHSV.h = Math.min(359.99, virtualHSV.h);
                        this.primaryColorHsv = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(virtualHSV.h, this.primaryColorHsv.s, this.primaryColorHsv.v);
                        this.primaryColorRgb = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv);
                        this.controlH.style.left = Math.round(this.primaryColorHsv.h / 359.99 * this.width) - 1 + 'px';
                        this.updateSVCanvas();
                        this.setColPreview();
                        this.emitColor((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv));
                    }
                    if (event.type === 'pointerup') divH.classList.toggle('kl-color-picker--active', false);
                }
            });
        }, 1);
        // --- secondary color ---
        this.secondaryColorBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.outputDiv,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('secondary-color') + ' [X]',
            className: 'kl-color-picker__secondary',
            css: {
                cursor: 'pointer',
                marginLeft: '5px',
                width: '22px',
                height: '22px'
            },
            onClick: (e)=>{
                e.preventDefault();
                this.swapColors();
            }
        });
        this.updateSecondaryColor();
    }
}






class $8f768338795db7a0$export$66306bf21a9ff39e {
    updateSV() {
        const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.canvasSV);
        if (!ctx) throw new Error("couldn't create canvas");
        for(let i = 0; i < this.canvasSV.height; i += 1){
            const gradient1 = ctx.createLinearGradient(0, 0, this.canvasSV.width, 0);
            const colleft = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(this.color.h, 1, 100 - i / this.canvasSV.height * 100.0));
            const colright = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(this.color.h, 100, 100 - i / this.canvasSV.height * 100.0));
            gradient1.addColorStop(0, '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(colleft));
            gradient1.addColorStop(1, '#' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHexString(colright));
            ctx.fillStyle = '#ff0000'; //needed for chrome...otherwise alpha problem
            ctx.fillStyle = gradient1;
            ctx.fillRect(0, i, this.canvasSV.width, 1);
        }
    }
    updateSVPointer() {
        const left = this.color.s / 100 * this.width - 4;
        const top = (1 - this.color.v / 100) * this.heightSV - 4;
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.pointerSV, {
            left: left + 'px',
            top: top + 'px'
        });
    }
    updateHPointer() {
        this.pointerH.style.left = this.color.h / 359.999 * this.width - 1 + 'px';
    }
    // ---- interface ----
    setColor(c) {
        if (this.hPointerId !== null || this.svPointerId !== null) return;
        this.color = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHSV(new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(c.r, c.g, c.b));
        this.updateSV();
        this.updateSVPointer();
        this.updateHPointer();
    }
    getColor() {
        return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.color);
    }
    getElement() {
        return this.rootEl;
    }
    end() {
        this.svPointerId = null;
        this.hPointerId = null;
    }
    destroy() {
        this.svPointerListener.destroy();
        this.hPointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: p.width + 'px',
                position: 'relative',
                overflow: 'hidden',
                userSelect: 'none'
            }
        });
        this.rootEl.oncontextmenu = (e)=>{
            e.preventDefault();
        };
        this.color = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toHSV(new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(p.color.r, p.color.g, p.color.b));
        this.width = p.width;
        this.heightSV = p.heightSV;
        this.canvasSV = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(10, 10);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.canvasSV, {
            width: this.width + 'px',
            height: this.heightSV + 'px',
            cursor: 'crosshair'
        });
        this.updateSV();
        const canvasH = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(p.width, p.heightH);
        canvasH.style.cursor = 'ew-resize';
        (()=>{
            const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvasH);
            const gradH = ctx.createLinearGradient(0, 0, p.width, 0);
            (0, $f133619cff967492$export$eed76a6c3d7eed98)(gradH);
            ctx.fillStyle = gradH;
            ctx.fillRect(0, 0, p.width, p.heightH);
        })();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.canvasSV, {
            width: p.width + 'px',
            height: p.heightSV + 'px',
            overflow: 'hidden',
            position: 'relative'
        });
        this.canvasSV.style.cssFloat = 'left';
        canvasH.style.cssFloat = 'left';
        this.rootEl.append(this.canvasSV, canvasH);
        this.pointerSV = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                width: '8px',
                height: '8px',
                borderRadius: '8px',
                position: 'absolute',
                pointerEvents: 'none',
                boxShadow: '0 0 0 1px #000, inset 0 0 0 1px #fff'
            }
        });
        this.pointerH = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                width: '0',
                height: p.heightH + 'px',
                borderLeft: '1px solid #fff',
                borderRight: '1px solid #000',
                position: 'absolute',
                top: p.heightSV + 'px',
                pointerEvents: 'none'
            }
        });
        this.updateSVPointer();
        this.updateHPointer();
        const virtualHSV = {
            h: 0,
            s: 0,
            v: 0
        };
        this.svPointerId = null;
        this.svPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.canvasSV,
            fixScribble: true,
            onPointer: (event)=>{
                if (event.type === 'pointerdown') {
                    // prevent manual slider input keeping focus on iPad
                    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unfocusAnyInput();
                    this.svPointerId = event.pointerId;
                    if (event.button === 'left') {
                        virtualHSV.s = event.relX / p.width * 100;
                        virtualHSV.v = 100 - event.relY / p.heightSV * 100;
                        this.color = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(this.color.h, virtualHSV.s, virtualHSV.v);
                        this.updateSVPointer();
                        p.callback((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.color));
                    } else {
                        virtualHSV.s = this.color.s;
                        virtualHSV.v = this.color.v;
                    }
                }
                if (event.type === 'pointermove' && [
                    'left',
                    'right'
                ].includes('' + event.button) && this.svPointerId === event.pointerId) {
                    let factor = 1;
                    if (event.button === 'right') factor = 0.5;
                    virtualHSV.s += event.dX / p.width * 100 * factor;
                    virtualHSV.v -= event.dY / p.heightSV * 100 * factor;
                    this.color = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(this.color.h, virtualHSV.s, virtualHSV.v);
                    this.updateSVPointer();
                    p.callback((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.color));
                }
                if (event.type === 'pointerup') this.svPointerId = null;
            }
        });
        this.hPointerId = null;
        this.hPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: canvasH,
            fixScribble: true,
            onPointer: (event)=>{
                if (event.type === 'pointerdown') {
                    this.hPointerId = event.pointerId;
                    if (event.button === 'left') {
                        virtualHSV.h = event.relX / p.width * 359.99;
                        this.color = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(virtualHSV.h, this.color.s, this.color.v);
                        this.updateSV();
                        this.updateHPointer();
                        p.callback((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.color));
                    } else virtualHSV.h = this.color.h;
                }
                if (event.type === 'pointermove' && [
                    'left',
                    'right'
                ].includes('' + event.button) && this.hPointerId === event.pointerId) {
                    const deltaY = Math.abs(event.pageY - event.downPageY);
                    const factor = (0, $6e485eb0c82960d0$export$f8e41e222e32615d)(deltaY, event.button === 'right');
                    virtualHSV.h += event.dX / p.width * 359.99 * factor;
                    if (event.button === 'right') {
                        virtualHSV.h = virtualHSV.h % 359.99;
                        if (virtualHSV.h < 0) virtualHSV.h += 359.99;
                    }
                    virtualHSV.h = Math.min(359.99, virtualHSV.h);
                    this.color = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).HSV(virtualHSV.h, this.color.s, this.color.v);
                    this.updateSV();
                    this.updateHPointer();
                    p.callback((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRGB(this.color));
                }
                if (event.type === 'pointerup') this.hPointerId = null;
            }
        });
        const cleardiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                clear: 'both'
            }
        });
    }
}




class $867da577d723d824$export$ac00cea56cec3037 {
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    setActive(isActive) {
        this.sliderPoint.style.backgroundColor = isActive ? '#fff' : '#eaeaea';
    }
    destroy() {
        this.pointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'relative'
            }
        });
        const sliderLine = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-point-slider__line',
            css: {
                marginTop: parseInt('' + (p.pointSize / 2 - 1)) + 'px',
                width: p.width + 'px'
            }
        });
        this.sliderPoint = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-point-slider__point'
        });
        let sliderPos;
        //sliderPoint
        const touchAreaEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            // expand clickable area
            parent: this.sliderPoint,
            css: {
                // background: 'rgba(255,0,0,0.4)',
                margin: '-7px 0 0 -7px',
                width: 'calc(100% + 14px)',
                height: 'calc(100% + 7px)'
            }
        });
        const redrawPoint = ()=>{
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.sliderPoint, {
                left: sliderPos + 'px'
            });
        };
        const getValue = ()=>{
            return sliderPos / (p.width - p.pointSize);
        };
        {
            let isDragging = false;
            let isFirst;
            sliderPos = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(p.init * (p.width - p.pointSize), 0, p.width - p.pointSize);
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.sliderPoint, {
                width: p.pointSize + 'px',
                height: p.pointSize + 'px',
                borderRadius: p.pointSize + 'px'
            });
            redrawPoint();
            let imaginaryPos;
            this.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: this.sliderPoint,
                fixScribble: true,
                onPointer: (event)=>{
                    if (event.type === 'pointerdown' && event.button === 'left' && !p.getDoIgnore()) {
                        isFirst = true;
                        isDragging = true;
                        imaginaryPos = sliderPos;
                        redrawPoint();
                        event.eventStopPropagation();
                    } else if (event.type === 'pointermove' && event.button === 'left' && isDragging) {
                        event.eventStopPropagation();
                        imaginaryPos = imaginaryPos + event.dX;
                        sliderPos = parseInt('' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(imaginaryPos, 0, p.width - p.pointSize));
                        redrawPoint();
                        p.callback(getValue(), isFirst, false);
                        isFirst = false;
                    }
                    if (event.type === 'pointerup' && isDragging) {
                        event.eventStopPropagation();
                        isDragging = false;
                        redrawPoint();
                        p.callback(getValue(), false, true);
                    }
                }
            });
        }
    }
}







class $3032e23fa8f3a9e5$export$24ba9b81662d4366 {
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.colorArr[this.selectedIndex];
    }
    destroy() {
        this.rootEl.remove();
        this.buttonArr.forEach((item)=>{
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(item.el);
        });
        this.buttonArr.splice(0, this.buttonArr.length);
        this.colorInput.onchange = null;
        this.colorInput.oninput = null;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.colorArr = [];
        this.selectedIndex = 0;
        var _p_title;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: p.label ? p.label : '',
            title: (_p_title = p.title) !== null && _p_title !== void 0 ? _p_title : undefined,
            css: (0, $0616f0a0655c1023$export$71511d61b312f219)({
                display: 'flex',
                alignItems: 'center',
                gap: '7px',
                position: 'relative'
            }, p.css)
        });
        this.buttonArr = [];
        const buttonSize = 22;
        this.onColorInputChange = ()=>{
            const i = this.selectedIndex;
            const color = this.colorArr[i];
            if (!color || color.a < 1) // ignore
            return;
            const newRawColor = this.colorInput.value;
            this.buttonArr[this.selectedIndex].el.style.backgroundColor = newRawColor;
            this.colorArr[i] = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, (0, $b68f66663c02a5d5$export$fb7efcd2e153af6e).hexToRGB(newRawColor)), {
                a: 1
            });
            p.onChange(this.colorArr[i]);
        };
        this.colorInput = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'input',
            custom: {
                type: 'color',
                tabIndex: '-1'
            }
        });
        this.colorInput.onchange = this.onColorInputChange;
        this.colorInput.oninput = this.onColorInputChange;
        // build colorArr while removing duplicates
        for(let i = 0; i < p.colorArr.length; i++){
            const item = p.colorArr[i];
            let found = false;
            for(let e = 0; e < this.colorArr.length; e++){
                const sItem = this.colorArr[e];
                if (sItem === item) {
                    found = true;
                    break;
                }
                if (sItem === null || item === null) continue;
                if (sItem.r === item.r && sItem.g === item.g && sItem.b === item.b && sItem.a === item.a) {
                    found = true;
                    break;
                }
            }
            if (found) continue;
            this.colorArr.push(item);
            if ('initialIndex' in p && p.initialIndex === i) this.selectedIndex = this.colorArr.length - 1;
        }
        for(let i = 0; i < this.colorArr.length; i++)((i)=>{
            const color = this.colorArr[i];
            const colorButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: this.rootEl,
                content: color ? '' : 'X',
                className: 'kl-color-option',
                css: {
                    width: buttonSize + 'px',
                    height: buttonSize + 'px',
                    backgroundColor: color ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(color) : 'transparent',
                    lineHeight: buttonSize + 1 + 'px'
                },
                onClick: (e)=>{
                    if (this.selectedIndex === i) {
                        if (color && color.a === 1) this.colorInput.showPicker ? this.colorInput.showPicker() : this.colorInput.click();
                        return;
                    }
                    e.preventDefault();
                    this.selectedIndex = i;
                    update();
                    p.onChange(this.colorArr[i]); // color may change
                }
            });
            if (color && color.a === 0) colorButton.style.background = 'var(--kl-checkerboard-background)';
            const setIsSelected = (b)=>{
                colorButton.classList.toggle('kl-color-option--active', b);
            };
            this.buttonArr.push({
                el: colorButton,
                setIsSelected: setIsSelected
            });
        })(i);
        this.rootEl.append((0, $934e5f47c3374e21$export$db3b6bfb95261072)(',w-0,h-0,overflow-hidden,abs-0-0', [
            this.colorInput
        ]));
        const update = ()=>{
            for(let i = 0; i < this.buttonArr.length; i++)this.buttonArr[i].setIsSelected(i === this.selectedIndex);
        };
        update();
    }
}




class $1166276dc18d3ea9$export$c019608e5b5bb4cb {
    getIndex() {
        for(let i = 0; i < this.optionArr.length; i++){
            if (this.optionArr[i].id === this.selectedId) return i;
        }
        return -1;
    }
    update() {
        for(let i = 0; i < this.optionArr.length; i++)this.optionArr[i].el.classList.toggle('kl-option-selected', this.optionArr[i].id === this.selectedId);
    }
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.selectedId;
    }
    next() {
        this.selectedId = this.optionArr[(this.getIndex() + 1) % this.optionArr.length].id;
        this.update();
        this.onChange && this.onChange(this.selectedId);
    }
    setValue(val, skipEmit) {
        if (this.selectedId === val) return;
        if (this.onBeforeChange && !this.onBeforeChange(val)) return;
        this.selectedId = val;
        this.update();
        !skipEmit && this.onChange && this.onChange(this.selectedId);
    }
    previous() {
        this.selectedId = this.optionArr[(this.optionArr.length + this.getIndex() - 1) % this.optionArr.length].id;
        this.update();
        this.onChange && this.onChange(this.selectedId);
    }
    destroy() {
        this.rootEl.remove();
        this.optionArr.forEach((item)=>{
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(item.el);
        });
        this.optionArr.splice(0, this.optionArr.length);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: p.css
        });
        const wrapperEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-option-wrapper',
            css: {
                display: 'flex',
                flexDirection: p.isColumn ? 'column' : 'row'
            }
        });
        if (p.onChange) {
            this.onChange = p.onChange;
            this.onBeforeChange = p.onBeforeChange;
        }
        this.optionArr = [];
        this.selectedId = 'initialId' in p && p.initId !== undefined ? p.initId : p.optionArr[0].id;
        const createOption = (o)=>{
            const classArr = [
                'kl-option'
            ];
            if (p.isSmall) classArr.push('kl-option--small');
            if (typeof o.label !== 'string') {
                classArr.push('kl-option--custom-el');
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(o.label, {
                    display: 'block',
                    pointerEvents: 'none'
                });
            }
            const optionObj = {
                id: o.id,
                el: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    parent: wrapperEl,
                    content: o.label,
                    className: classArr.join(' '),
                    onClick: ()=>{
                        if (this.selectedId !== optionObj.id) {
                            if (this.onBeforeChange && !this.onBeforeChange(optionObj.id)) return;
                            this.selectedId = optionObj.id;
                            this.update();
                            this.onChange && this.onChange(this.selectedId);
                        }
                    },
                    css: p.optionCss
                })
            };
            if (o.title) optionObj.el.title = o.title;
            this.optionArr.push(optionObj);
        };
        for(let i = 0; i < p.optionArr.length; i++)createOption(p.optionArr[i]);
        this.update();
        if (p.changeOnInit) setTimeout(()=>{
            this.onChange && this.onChange(this.selectedId);
        }, 0);
    }
}



var $e64ad8a2a278ae06$exports = {};
$e64ad8a2a278ae06$exports = $parcel$resolve("vALcr");



class $7ed35ae008fa6be6$export$5ee0af1d5c87e856 {
    updateUiState() {
        if (this.uiState === 'left') this.el.style.left = '271px';
        else this.el.style.removeProperty('left');
    }
    setWide(b) {
        this.isWide = b;
        if (!this.el) return;
        if (this.isWide) {
            this.el.style.width = '100%';
            this.el.style.left = '';
        } else {
            this.el.style.removeProperty('width');
            this.el.style.left = this.uiState === 'left' ? '271px' : '';
        }
    }
    setUiState(state) {
        this.uiState = state;
        this.updateUiState();
    }
    out(msg, doPulse) {
        if (typeof msg === 'string') {
            this.angleIm.style.display = 'none';
            this.innerInnerEl.style.removeProperty('font-family');
            this.innerInnerEl.innerHTML = msg;
        } else if (msg.type === 'transform') {
            this.angleIm.style.display = 'inline-block';
            this.angleIm.style.transform = 'rotate(' + msg.angleDeg + 'deg)';
            if (msg.angleDeg % 90 === 0) this.angleIm.style.boxShadow = 'inset 0 0 0 1px rgba(255, 255, 255, 0.7)';
            else this.angleIm.style.boxShadow = '';
            this.innerInnerEl.style.fontFamily = 'monospace';
            this.innerInnerEl.innerHTML = Math.round(msg.scale * 100) + '%';
        } else this.angleIm.style.display = 'none';
        if (doPulse) {
            this.innerEl.style.animation = '';
            setTimeout(()=>this.innerEl.style.animation = 'topOverlayPulse 0.5s ease-out', 20);
            clearTimeout(this.timeout3);
            this.timeout3 = setTimeout(()=>this.innerEl.style.animation = '', 520);
        }
        clearTimeout(this.timeout);
        clearTimeout(this.timeout2);
        this.el.style.animationName = doPulse ? 'consoleInFast' : 'consoleIn';
        this.el.style.opacity = '1';
        this.timeout = setTimeout(()=>{
            this.el.style.opacity = '0';
            this.el.style.animationName = 'consoleOut';
            this.timeout2 = setTimeout(()=>{
                this.el.style.display = 'none';
            }, 450);
        }, 1200);
        this.el.style.display = 'flex';
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.isWide = false // tool space hidden
        ;
        this.uiState = 'right';
        this.el = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'top-overlay g-root',
            onClick: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).handleClick
        });
        this.updateUiState();
        this.innerEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'top-overlay--inner'
        });
        this.angleIm = new Image();
        this.angleIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($e64ad8a2a278ae06$exports)));
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.angleIm, {
            verticalAlign: 'bottom',
            width: '20px',
            height: '20px',
            marginLeft: '5px',
            borderRadius: '10px'
        });
        this.innerInnerEl = document.createElement('div');
        this.innerInnerEl.style.display = 'inline-block';
        this.innerEl.append(this.innerInnerEl, this.angleIm);
        this.el.append(this.innerEl);
        document.body.append(this.el);
        this.el.style.display = 'none';
    }
}











/**
 * Calculate a point transformed with an affine matrix
 * @param matrix {Matrix} Affine Matrix
 * @param  point {Point} Point
 * @returns {Point} Point
 */ function $855520c81dfcb96a$export$9b20165a36586806(matrix, point) {
    return Array.isArray(point) ? [
        matrix.a * point[0] + matrix.c * point[1] + matrix.e,
        matrix.b * point[0] + matrix.d * point[1] + matrix.f
    ] : {
        x: matrix.a * point.x + matrix.c * point.y + matrix.e,
        y: matrix.b * point.x + matrix.d * point.y + matrix.f
    };
}
function $855520c81dfcb96a$export$25080e195dd950cc(matrix, points) {
    return points.map((point)=>$855520c81dfcb96a$export$9b20165a36586806(matrix, point));
}


/**
 * Extract an affine matrix from an object that contains a,b,c,d,e,f keys
 * Any value could be a float or a string that contains a float
 * @param object {Object} Object that contains a,b,c,d,e,f keys
 * @return {Matrix} Affine Matrix
 */ function $93526789c874f75a$export$9144c32b59cbaec4(object) {
    return {
        a: parseFloat(object.a),
        b: parseFloat(object.b),
        c: parseFloat(object.c),
        d: parseFloat(object.d),
        e: parseFloat(object.e),
        f: parseFloat(object.f)
    };
}


/**
 * @ignore
 * @type {RegExp}
 */ const $9e90c8f24fdf1c6b$var$matrixRegex = /^matrix\(\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*\)$/i;
function $9e90c8f24fdf1c6b$export$3004f64547af360e(string) {
    const parseFloatOrThrow = (number)=>{
        const n = parseFloat(number);
        if (Number.isFinite(n)) return n // excludes NaN, +Infinite, -Infinite
        ;
        throw new Error(`'${string}' is not a matrix`);
    };
    const prefix = string.substring(0, 7).toLowerCase();
    const suffix = string.substring(string.length - 1);
    const body = string.substring(7, string.length - 1);
    const elements = body.split(',');
    if (prefix === 'matrix(' && suffix === ')' && elements.length === 6) return {
        a: parseFloatOrThrow(elements[0]),
        b: parseFloatOrThrow(elements[1]),
        c: parseFloatOrThrow(elements[2]),
        d: parseFloatOrThrow(elements[3]),
        e: parseFloatOrThrow(elements[4]),
        f: parseFloatOrThrow(elements[5])
    };
    throw new Error(`'${string}' is not a matrix`);
}
function $9e90c8f24fdf1c6b$export$c1c8983dc21927d2(string) {
    const parsed = string.match($9e90c8f24fdf1c6b$var$matrixRegex);
    if (parsed === null || parsed.length < 7) throw new Error(`'${string}' is not a matrix`);
    return {
        a: parseFloat(parsed[1]),
        b: parseFloat(parsed[2]),
        c: parseFloat(parsed[3]),
        d: parseFloat(parsed[4]),
        e: parseFloat(parsed[5]),
        f: parseFloat(parsed[6])
    };
}


/**
 * Identity matrix
 * @returns {Matrix} Affine Matrix
 */ function $5c473edaf09eadd3$export$f0954fd7d5368655() {
    return {
        a: 1,
        c: 0,
        e: 0,
        b: 0,
        d: 1,
        f: 0
    };
}


/**
 * Calculate a matrix that is the inverse of the provided matrix
 * @param matrix {Matrix} Affine Matrix
 * @returns {Matrix} Inverted Affine Matrix
 */ function $077740f52fe6870e$export$70ae2c07e401031b(matrix) {
    // http://www.wolframalpha.com/input/?i=Inverse+%5B%7B%7Ba,c,e%7D,%7Bb,d,f%7D,%7B0,0,1%7D%7D%5D
    const { a: a, b: b, c: c, d: d, e: e, f: f } = matrix;
    const denom = a * d - b * c;
    return {
        a: d / denom,
        b: b / -denom,
        c: c / -denom,
        d: a / denom,
        e: (d * e - c * f) / -denom,
        f: (b * e - a * f) / denom
    };
}


function $bd2ee0a774cbe423$export$fce6876652108ab(val) {
    return typeof val === 'undefined';
}
function $bd2ee0a774cbe423$export$e90fb89750dba83f(n) {
    return typeof n === 'number' && !Number.isNaN(n) && Number.isFinite(n);
}
function $bd2ee0a774cbe423$export$a6cdc56e425d0d0a(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}
function $bd2ee0a774cbe423$export$ea33763237293206(obj, keys) {
    return keys.every((key)=>key in obj);
}


function $a6f1fb0b7ca0d744$export$b500e24115cd4dcf(object) {
    return (0, $bd2ee0a774cbe423$export$a6cdc56e425d0d0a)(object) && 'a' in object && (0, $bd2ee0a774cbe423$export$e90fb89750dba83f)(object.a) && 'b' in object && (0, $bd2ee0a774cbe423$export$e90fb89750dba83f)(object.b) && 'c' in object && (0, $bd2ee0a774cbe423$export$e90fb89750dba83f)(object.c) && 'd' in object && (0, $bd2ee0a774cbe423$export$e90fb89750dba83f)(object.d) && 'e' in object && (0, $bd2ee0a774cbe423$export$e90fb89750dba83f)(object.e) && 'f' in object && (0, $bd2ee0a774cbe423$export$e90fb89750dba83f)(object.f);
}



/**
 * Calculate a translate matrix
 * @param tx {number} Translation on axis x
 * @param [ty = 0] {number} Translation on axis y
 * @returns {Matrix} Affine Matrix
 */ function $cf0617f9860dc277$export$d73ee8ef04f5226a(tx, ty = 0) {
    return {
        a: 1,
        c: 0,
        e: tx,
        b: 0,
        d: 1,
        f: ty
    };
}


/**
 * Merge multiple matrices into one
 * @param matrices {...Matrix | Matrix[]} Matrices listed as separate parameters or in an array
 * @returns {Matrix} Affine Matrix
 */ function $611d5fdbbcda65d9$export$51186ad6e864892a(...matrices) {
    matrices = Array.isArray(matrices[0]) ? matrices[0] : matrices;
    const multiply = (m1, m2)=>{
        return {
            a: m1.a * m2.a + m1.c * m2.b,
            c: m1.a * m2.c + m1.c * m2.d,
            e: m1.a * m2.e + m1.c * m2.f + m1.e,
            b: m1.b * m2.a + m1.d * m2.b,
            d: m1.b * m2.c + m1.d * m2.d,
            f: m1.b * m2.e + m1.d * m2.f + m1.f
        };
    };
    switch(matrices.length){
        case 0:
            throw new Error('no matrices provided');
        case 1:
            return matrices[0];
        case 2:
            return multiply(matrices[0], matrices[1]);
        default:
            {
                const [m1, m2, ...rest] = matrices;
                const m = multiply(m1, m2);
                return $611d5fdbbcda65d9$export$51186ad6e864892a(m, ...rest);
            }
    }
}
function $611d5fdbbcda65d9$export$f672e0b6f7222cd7(...matrices) {
    return $611d5fdbbcda65d9$export$51186ad6e864892a(...matrices);
}


const { cos: $20520e5c69c4ad5d$var$cos, sin: $20520e5c69c4ad5d$var$sin, PI: $20520e5c69c4ad5d$var$PI } = Math;
function $20520e5c69c4ad5d$export$bb628a54ab399bc9(angle, cx, cy) {
    const cosAngle = $20520e5c69c4ad5d$var$cos(angle);
    const sinAngle = $20520e5c69c4ad5d$var$sin(angle);
    const rotationMatrix = {
        a: cosAngle,
        c: -sinAngle,
        e: 0,
        b: sinAngle,
        d: cosAngle,
        f: 0
    };
    if ((0, $bd2ee0a774cbe423$export$fce6876652108ab)(cx) || (0, $bd2ee0a774cbe423$export$fce6876652108ab)(cy)) return rotationMatrix;
    return (0, $611d5fdbbcda65d9$export$51186ad6e864892a)([
        (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(cx, cy),
        rotationMatrix,
        (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(-cx, -cy)
    ]);
}
function $20520e5c69c4ad5d$export$9ade995dfe562073(angle, cx, cy) {
    return $20520e5c69c4ad5d$export$bb628a54ab399bc9(angle * $20520e5c69c4ad5d$var$PI / 180, cx, cy);
}





function $a78c550eaaca7cca$export$dcdf75081b88279d(sx, sy, cx, cy) {
    if ((0, $bd2ee0a774cbe423$export$fce6876652108ab)(sy)) sy = sx;
    const scaleMatrix = {
        a: sx,
        c: 0,
        e: 0,
        b: 0,
        d: sy,
        f: 0
    };
    if ((0, $bd2ee0a774cbe423$export$fce6876652108ab)(cx) || (0, $bd2ee0a774cbe423$export$fce6876652108ab)(cy)) return scaleMatrix;
    return (0, $611d5fdbbcda65d9$export$51186ad6e864892a)([
        (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(cx, cy),
        scaleMatrix,
        (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(-cx, -cy)
    ]);
}


/**
 * Calculate a shear matrix
 * @param shx {number} Shear on axis x
 * @param shy {number} Shear on axis y
 * @returns {Matrix} Affine Matrix
 */ function $f7fa8858c5bed69e$export$4861775273fb6d4f(shx, shy) {
    return {
        a: 1,
        c: shx,
        e: 0,
        b: shy,
        d: 1,
        f: 0
    };
}


// https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/skew
const { tan: $efe14c63f0506f3c$var$tan } = Math;
function $efe14c63f0506f3c$export$dd2d5a892675faf1(ax, ay) {
    return {
        a: 1,
        c: $efe14c63f0506f3c$var$tan(ax),
        e: 0,
        b: $efe14c63f0506f3c$var$tan(ay),
        d: 1,
        f: 0
    };
}
function $efe14c63f0506f3c$export$80b820e0f249e768(ax, ay) {
    return $efe14c63f0506f3c$export$dd2d5a892675faf1(ax * Math.PI / 180, ay * Math.PI / 180);
}


/**
 * Serialize an affine matrix to a string that can be used with CSS or SVG
 * @param matrix {Matrix} Affine Matrix
 * @returns {string} String that contains an affine matrix formatted as matrix(a,b,c,d,e,f)
 */ function $3855bc26fe20e480$export$5d05fd1a2be8c220(matrix) {
    return $3855bc26fe20e480$export$f84e8e69fd4488a5(matrix);
}
function $3855bc26fe20e480$export$1d0eee16b7a93374(matrix) {
    return $3855bc26fe20e480$export$f84e8e69fd4488a5(matrix);
}
function $3855bc26fe20e480$export$f84e8e69fd4488a5(matrix) {
    return `matrix(${matrix.a},${matrix.b},${matrix.c},${matrix.d},${matrix.e},${matrix.f})`;
}






/**
 * Rounds all elements of the given matrix using the given precision
 * @param matrix {Matrix} An affine matrix to round
 * @param [precision] {number} A precision to use for Math.round. Defaults to 10000000000 (meaning which rounds to the 10th digit after the comma).
 * @returns {Matrix} The rounded Affine Matrix
 */ function $31383089db14caf7$export$8459a0a25f7ea1f1(matrix, precision = 10000000000) {
    return {
        a: Math.round(matrix.a * precision) / precision,
        b: Math.round(matrix.b * precision) / precision,
        c: Math.round(matrix.c * precision) / precision,
        d: Math.round(matrix.d * precision) / precision,
        e: Math.round(matrix.e * precision) / precision,
        f: Math.round(matrix.f * precision) / precision
    };
}


function $858256bd43cb5a95$export$2565f8052cb7f44a(t1, t2) {
    // point p = first point of the triangle
    const px1 = t1[0].x != null ? t1[0].x : t1[0][0];
    const py1 = t1[0].y != null ? t1[0].y : t1[0][1];
    const px2 = t2[0].x != null ? t2[0].x : t2[0][0];
    const py2 = t2[0].y != null ? t2[0].y : t2[0][1];
    // point q = second point of the triangle
    const qx1 = t1[1].x != null ? t1[1].x : t1[1][0];
    const qy1 = t1[1].y != null ? t1[1].y : t1[1][1];
    const qx2 = t2[1].x != null ? t2[1].x : t2[1][0];
    const qy2 = t2[1].y != null ? t2[1].y : t2[1][1];
    // point r = third point of the triangle
    const rx1 = t1[2].x != null ? t1[2].x : t1[2][0];
    const ry1 = t1[2].y != null ? t1[2].y : t1[2][1];
    const rx2 = t2[2].x != null ? t2[2].x : t2[2][0];
    const ry2 = t2[2].y != null ? t2[2].y : t2[2][1];
    const r1 = {
        a: px1 - rx1,
        b: py1 - ry1,
        c: qx1 - rx1,
        d: qy1 - ry1,
        e: rx1,
        f: ry1
    };
    const r2 = {
        a: px2 - rx2,
        b: py2 - ry2,
        c: qx2 - rx2,
        d: qy2 - ry2,
        e: rx2,
        f: ry2
    };
    const inverseR1 = (0, $077740f52fe6870e$export$70ae2c07e401031b)(r1);
    const affineMatrix = (0, $611d5fdbbcda65d9$export$51186ad6e864892a)([
        r2,
        inverseR1
    ]);
    // round the matrix elements to smooth the finite inversion
    return (0, $31383089db14caf7$export$8459a0a25f7ea1f1)(affineMatrix);
}









function $780e51f01f4de949$export$36aa15ab5c729b62(definitionOrArrayOfDefinition) {
    return Array.isArray(definitionOrArrayOfDefinition) ? definitionOrArrayOfDefinition.map(mapper) : mapper(definitionOrArrayOfDefinition);
    function mapper(descriptor) {
        switch(descriptor.type){
            case 'matrix':
                if ('a' in descriptor && 'b' in descriptor && 'c' in descriptor && 'd' in descriptor && 'e' in descriptor && 'f' in descriptor) return (0, $93526789c874f75a$export$9144c32b59cbaec4)(descriptor);
                else throw new Error('MISSING_MANDATORY_PARAM');
            case 'translate':
                if (!('tx' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                if ('ty' in descriptor) return (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(descriptor.tx, descriptor.ty);
                return (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(descriptor.tx);
            case 'scale':
                if (!('sx' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                if ('sy' in descriptor) return (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(descriptor.sx, descriptor.sy);
                return (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(descriptor.sx);
            case 'rotate':
                if (!('angle' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                if ('cx' in descriptor && 'cy' in descriptor) return (0, $20520e5c69c4ad5d$export$9ade995dfe562073)(descriptor.angle, descriptor.cx, descriptor.cy);
                return (0, $20520e5c69c4ad5d$export$9ade995dfe562073)(descriptor.angle);
            case 'skewX':
                if (!('angle' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                return (0, $efe14c63f0506f3c$export$80b820e0f249e768)(descriptor.angle, 0);
            case 'skewY':
                if (!('angle' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                return (0, $efe14c63f0506f3c$export$80b820e0f249e768)(0, descriptor.angle);
            case 'shear':
                if (!('shx' in descriptor && 'shy' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                return (0, $f7fa8858c5bed69e$export$4861775273fb6d4f)(descriptor.shx, descriptor.shy);
            default:
                throw new Error('UNSUPPORTED_DESCRIPTOR');
        }
    }
}


// @generated by Peggy 5.0.6.
//
// https://peggyjs.org/
class $2c16fa132dd43ca2$export$f21cea08b0dd60e8 extends SyntaxError {
    format(sources) {
        let str = "Error: " + this.message;
        if (this.location) {
            let src = null;
            const st = sources.find((s)=>s.source === this.location.source);
            if (st) src = st.text.split(/\r\n|\n|\r/g);
            const s = this.location.start;
            const offset_s = this.location.source && typeof this.location.source.offset === "function" ? this.location.source.offset(s) : s;
            const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
            if (src) {
                const e = this.location.end;
                const filler = "".padEnd(offset_s.line.toString().length, " ");
                const line = src[s.line - 1];
                const last = s.line === e.line ? e.column : line.length + 1;
                const hatLen = last - s.column || 1;
                str += "\n --> " + loc + "\n" + filler + " |\n" + offset_s.line + " | " + line + "\n" + filler + " | " + "".padEnd(s.column - 1, " ") + "".padEnd(hatLen, "^");
            } else str += "\n at " + loc;
        }
        return str;
    }
    static buildMessage(expected, found) {
        function hex(ch) {
            return ch.codePointAt(0).toString(16).toUpperCase();
        }
        const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode") ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu") : null;
        function unicodeEscape(s) {
            if (nonPrintable) return s.replace(nonPrintable, (ch)=>"\\u{" + hex(ch) + "}");
            return s;
        }
        function literalEscape(s) {
            return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/"/g, "\\\"").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch)=>"\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch)=>"\\x" + hex(ch)));
        }
        function classEscape(s) {
            return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch)=>"\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch)=>"\\x" + hex(ch)));
        }
        const DESCRIBE_EXPECTATION_FNS = {
            literal (expectation) {
                return "\"" + literalEscape(expectation.text) + "\"";
            },
            class (expectation) {
                const escapedParts = expectation.parts.map((part)=>Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part));
                return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
            },
            any () {
                return "any character";
            },
            end () {
                return "end of input";
            },
            other (expectation) {
                return expectation.description;
            }
        };
        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected) {
            const descriptions = expected.map(describeExpectation);
            descriptions.sort();
            if (descriptions.length > 0) {
                let j = 1;
                for(let i = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                    descriptions[j] = descriptions[i];
                    j++;
                }
                descriptions.length = j;
            }
            switch(descriptions.length){
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + " or " + descriptions[1];
                default:
                    return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
            }
        }
        function describeFound(found) {
            return found ? "\"" + literalEscape(found) + "\"" : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
    }
    constructor(message, expected, found, location){
        super(message);
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
    }
}
function $2c16fa132dd43ca2$export$98e6a39c04603d36(input, options) {
    options = options !== undefined ? options : {};
    const peg$FAILED = {};
    const peg$source = options.grammarSource;
    const peg$startRuleFunctions = {
        transformList: peg$parsetransformList
    };
    let peg$startRuleFunction = peg$parsetransformList;
    const peg$c0 = "matrix";
    const peg$c1 = "(";
    const peg$c2 = ")";
    const peg$c3 = "translate";
    const peg$c4 = "scale";
    const peg$c5 = "rotate";
    const peg$c6 = "skewX";
    const peg$c7 = "skewY";
    const peg$c8 = ",";
    const peg$c9 = ".";
    const peg$r0 = /^[eE]/;
    const peg$r1 = /^[+\-]/;
    const peg$r2 = /^[0-9]/;
    const peg$r3 = /^[ \t\r\n]/;
    const peg$e0 = peg$literalExpectation("matrix", false);
    const peg$e1 = peg$literalExpectation("(", false);
    const peg$e2 = peg$literalExpectation(")", false);
    const peg$e3 = peg$literalExpectation("translate", false);
    const peg$e4 = peg$literalExpectation("scale", false);
    const peg$e5 = peg$literalExpectation("rotate", false);
    const peg$e6 = peg$literalExpectation("skewX", false);
    const peg$e7 = peg$literalExpectation("skewY", false);
    const peg$e8 = peg$literalExpectation(",", false);
    const peg$e9 = peg$otherExpectation("fractionalConstant");
    const peg$e10 = peg$literalExpectation(".", false);
    const peg$e11 = peg$classExpectation([
        "e",
        "E"
    ], false, false, false);
    const peg$e12 = peg$classExpectation([
        "+",
        "-"
    ], false, false, false);
    const peg$e13 = peg$classExpectation([
        [
            "0",
            "9"
        ]
    ], false, false, false);
    const peg$e14 = peg$classExpectation([
        " ",
        "\t",
        "\r",
        "\n"
    ], false, false, false);
    function peg$f0(ts) {
        return ts;
    }
    function peg$f1(t, ts) {
        return t.concat(ts);
    }
    function peg$f2(a, b, c, d, e, f) {
        return [
            {
                type: 'matrix',
                a: a,
                b: b,
                c: c,
                d: d,
                e: e,
                f: f
            }
        ];
    }
    function peg$f3(tx, ty) {
        var t = {
            type: 'translate',
            tx: tx
        };
        if (ty) t.ty = ty;
        return [
            t
        ];
    }
    function peg$f4(sx, sy) {
        var s = {
            type: 'scale',
            sx: sx
        };
        if (sy) s.sy = sy;
        return [
            s
        ];
    }
    function peg$f5(angle, c) {
        var r = {
            type: 'rotate',
            angle: angle
        };
        if (c) {
            r.cx = c[0];
            r.cy = c[1];
        }
        return [
            r
        ];
    }
    function peg$f6(angle) {
        return [
            {
                type: 'skewX',
                angle: angle
            }
        ];
    }
    function peg$f7(angle) {
        return [
            {
                type: 'skewY',
                angle: angle
            }
        ];
    }
    function peg$f8(f) {
        return parseFloat(f.join(""));
    }
    function peg$f9(i) {
        return parseInt(i.join(""));
    }
    function peg$f10(n) {
        return n;
    }
    function peg$f11(n1, n2) {
        return [
            n1,
            n2
        ];
    }
    function peg$f12(ds) {
        return ds.join("");
    }
    function peg$f13(f, e) {
        return [
            f,
            e || null
        ].join("");
    }
    function peg$f14(d, e) {
        return [
            d,
            e
        ].join("");
    }
    function peg$f15(d1, d2) {
        return [
            d1 ? d1.join("") : null,
            ".",
            d2.join("")
        ].join("");
    }
    function peg$f16(d) {
        return d.join("");
    }
    function peg$f17(s, d) {
        return [
            'e',
            s,
            d.join("")
        ].join("");
    }
    let peg$currPos = options.peg$currPos | 0;
    let peg$savedPos = peg$currPos;
    const peg$posDetailsCache = [
        {
            line: 1,
            column: 1
        }
    ];
    let peg$maxFailPos = peg$currPos;
    let peg$maxFailExpected = options.peg$maxFailExpected || [];
    let peg$silentFails = options.peg$silentFails | 0;
    let peg$result;
    if (options.startRule) {
        if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function offset() {
        return peg$savedPos;
    }
    function range() {
        return {
            source: peg$source,
            start: peg$savedPos,
            end: peg$currPos
        };
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([
            peg$otherExpectation(description)
        ], input.substring(peg$savedPos, peg$currPos), location);
    }
    function error(message, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location);
    }
    function peg$getUnicode(pos = peg$currPos) {
        const cp = input.codePointAt(pos);
        if (cp === undefined) return "";
        return String.fromCodePoint(cp);
    }
    function peg$literalExpectation(text, ignoreCase) {
        return {
            type: "literal",
            text: text,
            ignoreCase: ignoreCase
        };
    }
    function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
        return {
            type: "class",
            parts: parts,
            inverted: inverted,
            ignoreCase: ignoreCase,
            unicode: unicode
        };
    }
    function peg$anyExpectation() {
        return {
            type: "any"
        };
    }
    function peg$endExpectation() {
        return {
            type: "end"
        };
    }
    function peg$otherExpectation(description) {
        return {
            type: "other",
            description: description
        };
    }
    function peg$computePosDetails(pos) {
        let details = peg$posDetailsCache[pos];
        let p;
        if (details) return details;
        else {
            if (pos >= peg$posDetailsCache.length) p = peg$posDetailsCache.length - 1;
            else {
                p = pos;
                while(!peg$posDetailsCache[--p]);
            }
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while(p < pos){
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                } else details.column++;
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos, offset) {
        const startPosDetails = peg$computePosDetails(startPos);
        const endPosDetails = peg$computePosDetails(endPos);
        const res = {
            source: peg$source,
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
        if (offset && peg$source && typeof peg$source.offset === "function") {
            res.start = peg$source.offset(res.start);
            res.end = peg$source.offset(res.end);
        }
        return res;
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) return;
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildSimpleError(message, location) {
        return new $2c16fa132dd43ca2$export$f21cea08b0dd60e8(message, null, null, location);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new $2c16fa132dd43ca2$export$f21cea08b0dd60e8($2c16fa132dd43ca2$export$f21cea08b0dd60e8.buildMessage(expected, found), expected, found, location);
    }
    function peg$parsetransformList() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsewsp();
        while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = peg$parsewsp();
        }
        s2 = peg$parsetransforms();
        if (s2 === peg$FAILED) s2 = null;
        s3 = [];
        s4 = peg$parsewsp();
        while(s4 !== peg$FAILED){
            s3.push(s4);
            s4 = peg$parsewsp();
        }
        peg$savedPos = s0;
        s0 = peg$f0(s2);
        return s0;
    }
    function peg$parsetransforms() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parsetransform();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsecommaWsp();
            if (s3 !== peg$FAILED) while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsecommaWsp();
            }
            else s2 = peg$FAILED;
            if (s2 !== peg$FAILED) {
                s3 = peg$parsetransforms();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f1(s1, s3);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) s0 = peg$parsetransform();
        return s0;
    }
    function peg$parsetransform() {
        let s0;
        s0 = peg$parsematrix();
        if (s0 === peg$FAILED) {
            s0 = peg$parsetranslate();
            if (s0 === peg$FAILED) {
                s0 = peg$parsescale();
                if (s0 === peg$FAILED) {
                    s0 = peg$parserotate();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseskewX();
                        if (s0 === peg$FAILED) s0 = peg$parseskewY();
                    }
                }
            }
        }
        return s0;
    }
    function peg$parsematrix() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 6) === peg$c0) {
            s1 = peg$c0;
            peg$currPos += 6;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e0);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWsp();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parsenumber();
                        if (s7 !== peg$FAILED) {
                            s8 = peg$parsecommaWsp();
                            if (s8 !== peg$FAILED) {
                                s9 = peg$parsenumber();
                                if (s9 !== peg$FAILED) {
                                    s10 = peg$parsecommaWsp();
                                    if (s10 !== peg$FAILED) {
                                        s11 = peg$parsenumber();
                                        if (s11 !== peg$FAILED) {
                                            s12 = peg$parsecommaWsp();
                                            if (s12 !== peg$FAILED) {
                                                s13 = peg$parsenumber();
                                                if (s13 !== peg$FAILED) {
                                                    s14 = peg$parsecommaWsp();
                                                    if (s14 !== peg$FAILED) {
                                                        s15 = peg$parsenumber();
                                                        if (s15 !== peg$FAILED) {
                                                            s16 = [];
                                                            s17 = peg$parsewsp();
                                                            while(s17 !== peg$FAILED){
                                                                s16.push(s17);
                                                                s17 = peg$parsewsp();
                                                            }
                                                            if (input.charCodeAt(peg$currPos) === 41) {
                                                                s17 = peg$c2;
                                                                peg$currPos++;
                                                            } else {
                                                                s17 = peg$FAILED;
                                                                if (peg$silentFails === 0) peg$fail(peg$e2);
                                                            }
                                                            if (s17 !== peg$FAILED) {
                                                                peg$savedPos = s0;
                                                                s0 = peg$f2(s5, s7, s9, s11, s13, s15);
                                                            } else {
                                                                peg$currPos = s0;
                                                                s0 = peg$FAILED;
                                                            }
                                                        } else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsetranslate() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 9) === peg$c3) {
            s1 = peg$c3;
            peg$currPos += 9;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e3);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWspNumber();
                    if (s6 === peg$FAILED) s6 = null;
                    s7 = [];
                    s8 = peg$parsewsp();
                    while(s8 !== peg$FAILED){
                        s7.push(s8);
                        s8 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c2;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f3(s5, s6);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsescale() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c4) {
            s1 = peg$c4;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e4);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWspNumber();
                    if (s6 === peg$FAILED) s6 = null;
                    s7 = [];
                    s8 = peg$parsewsp();
                    while(s8 !== peg$FAILED){
                        s7.push(s8);
                        s8 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c2;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f4(s5, s6);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parserotate() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 6) === peg$c5) {
            s1 = peg$c5;
            peg$currPos += 6;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e5);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWspTwoNumbers();
                    if (s6 === peg$FAILED) s6 = null;
                    s7 = [];
                    s8 = peg$parsewsp();
                    while(s8 !== peg$FAILED){
                        s7.push(s8);
                        s8 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c2;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f5(s5, s6);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseskewX() {
        let s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c6) {
            s1 = peg$c6;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e6);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = [];
                    s7 = peg$parsewsp();
                    while(s7 !== peg$FAILED){
                        s6.push(s7);
                        s7 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s7 = peg$c2;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s7 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f6(s5);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseskewY() {
        let s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c7) {
            s1 = peg$c7;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e7);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = [];
                    s7 = peg$parsewsp();
                    while(s7 !== peg$FAILED){
                        s6.push(s7);
                        s7 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s7 = peg$c2;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s7 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f7(s5);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsenumber() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$parsesign();
        if (s2 === peg$FAILED) s2 = null;
        s3 = peg$parsefloatingPointConstant();
        if (s3 !== peg$FAILED) {
            s2 = [
                s2,
                s3
            ];
            s1 = s2;
        } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f8(s1);
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$parsesign();
            if (s2 === peg$FAILED) s2 = null;
            s3 = peg$parseintegerConstant();
            if (s3 !== peg$FAILED) {
                s2 = [
                    s2,
                    s3
                ];
                s1 = s2;
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f9(s1);
            }
            s0 = s1;
        }
        return s0;
    }
    function peg$parsecommaWspNumber() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsecommaWsp();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumber();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f10(s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsecommaWspTwoNumbers() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$parsecommaWsp();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumber();
            if (s2 !== peg$FAILED) {
                s3 = peg$parsecommaWsp();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsenumber();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f11(s2, s4);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsecommaWsp() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsewsp();
        if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = peg$parsewsp();
        }
        else s1 = peg$FAILED;
        if (s1 !== peg$FAILED) {
            s2 = peg$parsecomma();
            if (s2 === peg$FAILED) s2 = null;
            s3 = [];
            s4 = peg$parsewsp();
            while(s4 !== peg$FAILED){
                s3.push(s4);
                s4 = peg$parsewsp();
            }
            s1 = [
                s1,
                s2,
                s3
            ];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsecomma();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                s1 = [
                    s1,
                    s2
                ];
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsecomma() {
        let s0;
        if (input.charCodeAt(peg$currPos) === 44) {
            s0 = peg$c8;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e8);
        }
        return s0;
    }
    function peg$parseintegerConstant() {
        let s0, s1;
        s0 = peg$currPos;
        s1 = peg$parsedigitSequence();
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f12(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parsefloatingPointConstant() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsefractionalConstant();
        if (s1 !== peg$FAILED) {
            s2 = peg$parseexponent();
            if (s2 === peg$FAILED) s2 = null;
            peg$savedPos = s0;
            s0 = peg$f13(s1, s2);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedigitSequence();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseexponent();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f14(s1, s2);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsefractionalConstant() {
        let s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parsedigitSequence();
        if (s1 === peg$FAILED) s1 = null;
        if (input.charCodeAt(peg$currPos) === 46) {
            s2 = peg$c9;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e10);
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsedigitSequence();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f15(s1, s3);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedigitSequence();
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 46) {
                    s2 = peg$c9;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e10);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f16(s1);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e9);
        }
        return s0;
    }
    function peg$parseexponent() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = input.charAt(peg$currPos);
        if (peg$r0.test(s1)) peg$currPos++;
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e11);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsesign();
            if (s2 === peg$FAILED) s2 = null;
            s3 = peg$parsedigitSequence();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f17(s2, s3);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsesign() {
        let s0;
        s0 = input.charAt(peg$currPos);
        if (peg$r1.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e12);
        }
        return s0;
    }
    function peg$parsedigitSequence() {
        let s0, s1;
        s0 = [];
        s1 = peg$parsedigit();
        if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
            s0.push(s1);
            s1 = peg$parsedigit();
        }
        else s0 = peg$FAILED;
        return s0;
    }
    function peg$parsedigit() {
        let s0;
        s0 = input.charAt(peg$currPos);
        if (peg$r2.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e13);
        }
        return s0;
    }
    function peg$parsewsp() {
        let s0;
        s0 = input.charAt(peg$currPos);
        if (peg$r3.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e14);
        }
        return s0;
    }
    peg$result = peg$startRuleFunction();
    const peg$success = peg$result !== peg$FAILED && peg$currPos === input.length;
    function peg$throw() {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
    if (options.peg$library) return /** @type {any} */ {
        peg$result: peg$result,
        peg$currPos: peg$currPos,
        peg$FAILED: peg$FAILED,
        peg$maxFailExpected: peg$maxFailExpected,
        peg$maxFailPos: peg$maxFailPos,
        peg$success: peg$success,
        peg$throw: peg$success ? undefined : peg$throw
    };
    if (peg$success) return peg$result;
    else peg$throw();
}
const $2c16fa132dd43ca2$export$b495b1bde973ffbd = [
    "transformList"
];


function $b513f9bb54aec525$export$dd451a2a4984e188(transformString) {
    return (0, $2c16fa132dd43ca2$export$98e6a39c04603d36)(transformString);
}




function $9048946b52312c93$export$34daa7fcbfeb2849(matrix, flipX = false, flipY = false) {
    // Remove flip from the matrix first - flip could be incorrectly interpreted as
    // rotations (e.g. flipX + flipY = rotate by 180 degrees).
    // Note flipX is a vertical flip, and flipY is a horizontal flip.
    if (flipX) {
        if (flipY) matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)(matrix, (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(-1, -1));
        else matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)(matrix, (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(1, -1));
    } else if (flipY) matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)(matrix, (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(-1, 1));
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    let scaleX, scaleY, rotation;
    if (a !== 0 || c !== 0) {
        const hypotAc = Math.hypot(a, c);
        scaleX = hypotAc;
        scaleY = (a * d - b * c) / hypotAc;
        const acos = Math.acos(a / hypotAc);
        rotation = c > 0 ? -acos : acos;
    } else if (b !== 0 || d !== 0) {
        const hypotBd = Math.hypot(b, d);
        scaleX = (a * d - b * c) / hypotBd;
        scaleY = hypotBd;
        const acos = Math.acos(b / hypotBd);
        rotation = Math.PI / 2 + (d > 0 ? -acos : acos);
    } else {
        scaleX = 0;
        scaleY = 0;
        rotation = 0;
    }
    // put the flip factors back
    if (flipY) scaleX = -scaleX;
    if (flipX) scaleY = -scaleY;
    return {
        translate: {
            tx: matrix.e,
            ty: matrix.f
        },
        scale: {
            sx: scaleX,
            sy: scaleY
        },
        rotation: {
            angle: rotation
        }
    };
}


/**
 * Tranformation matrix that mirrors on x-axis
 * @returns {Matrix} Affine Matrix
 */ function $c5e3ac5094d89f40$export$9ffbcc0b36390a8f() {
    return {
        a: 1,
        c: 0,
        e: 0,
        b: 0,
        d: -1,
        f: 0
    };
}
function $c5e3ac5094d89f40$export$13e88519d622f890() {
    return {
        a: -1,
        c: 0,
        e: 0,
        b: 0,
        d: 1,
        f: 0
    };
}
function $c5e3ac5094d89f40$export$8817f89b5790665a() {
    return {
        a: -1,
        c: 0,
        e: 0,
        b: 0,
        d: -1,
        f: 0
    };
}







function $c3d40be9971a56b4$export$91619259a15f04b8(startingPoint, endingPoint) {
    const tx = endingPoint.x - startingPoint.x;
    const ty = endingPoint.y - startingPoint.y;
    return (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(tx, ty);
}
function $c3d40be9971a56b4$export$87d7516aee2dd9d9(startingPoint1, startingPoint2, endingPoint1, endingPoint2) {
    // finds translation
    const translationMatrix = $c3d40be9971a56b4$export$91619259a15f04b8(startingPoint1, endingPoint1);
    const pointA = (0, $855520c81dfcb96a$export$9b20165a36586806)(translationMatrix, startingPoint2) // I have to translate this point
    ;
    const center = endingPoint1;
    const pointB = endingPoint2;
    // finds rotation matrix
    const angle = Math.atan2(pointB.y - center.y, pointB.x - center.x) - Math.atan2(pointA.y - center.y, pointA.x - center.x);
    const rotationMatrix = (0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(angle, center.x, center.y);
    // finds scale matrix
    const d1 = Math.sqrt(Math.pow(pointA.x - center.x, 2) + Math.pow(pointA.y - center.y, 2));
    const d2 = Math.sqrt(Math.pow(pointB.x - center.x, 2) + Math.pow(pointB.y - center.y, 2));
    const scalingLevel = d2 / d1;
    const scalingMatrix = (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(scalingLevel, scalingLevel, center.x, center.y);
    return (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)([
        translationMatrix,
        scalingMatrix,
        rotationMatrix
    ]);
}





function $00bfc001d6438b5d$export$ad1d215dd03fe75a(transform) {
    const scaleX = 'scale' in transform ? transform.scale : transform.scaleX;
    const scaleY = 'scale' in transform ? transform.scale : transform.scaleY;
    return (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(transform.x, transform.y), (0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(transform.angleDeg / 180 * Math.PI), (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(scaleX, scaleY));
}


function $974f651610599156$export$2b60e7dafdbde18a(m) {
    return [
        m.a,
        m.b,
        m.c,
        m.d,
        m.e,
        m.f
    ];
}





// finds the largest index that is defined
function $58cad15031bfc18d$var$getLatestDefined(array) {
    for(let i = array.length - 1; i >= 0; i--){
        const value = array[i];
        if (value !== undefined) return value;
    }
    throw new Error('no defined entry found');
}
// in an array of maps, finds array[i][prop] for the largest index
// where array[i][prop] is defined
function $58cad15031bfc18d$var$getLatestDefinedProp(array, prop) {
    for(let i = array.length - 1; i >= 0; i--){
        if (!array[i]) continue;
        const value = array[i][prop];
        if (value !== undefined) return value;
    }
    throw new Error('no defined entry found');
}
// For each tile gets the latest which is defined.
// Each tile[] is from a history entry.
function $58cad15031bfc18d$var$composeLayerTiles(tilesEntries) {
    const result = [
        ...$58cad15031bfc18d$var$getLatestDefined(tilesEntries)
    ];
    Object.entries(result).forEach(([id])=>{
        result[+id] = $58cad15031bfc18d$var$getLatestDefinedProp(tilesEntries, id);
    });
    return result;
}
// combines layers from multiple history entries into the latest representation
function $58cad15031bfc18d$var$composeLayer(layerEntries) {
    // Safe fallback for isClipped (may not be in older history entries)
    let isClipped = false;
    for(let i = layerEntries.length - 1; i >= 0; i--){
        const entry = layerEntries[i];
        if (entry && entry.isClipped !== undefined) {
            isClipped = entry.isClipped;
            break;
        }
    }
    return {
        name: $58cad15031bfc18d$var$getLatestDefinedProp(layerEntries, 'name'),
        opacity: $58cad15031bfc18d$var$getLatestDefinedProp(layerEntries, 'opacity'),
        isVisible: $58cad15031bfc18d$var$getLatestDefinedProp(layerEntries, 'isVisible'),
        mixModeStr: $58cad15031bfc18d$var$getLatestDefinedProp(layerEntries, 'mixModeStr'),
        index: $58cad15031bfc18d$var$getLatestDefinedProp(layerEntries, 'index'),
        tiles: $58cad15031bfc18d$var$composeLayerTiles(layerEntries.map((item)=>item ? item.tiles : undefined)),
        isClipped: isClipped
    };
}
// combines layerMaps from multiple history entries into the latest representation
function $58cad15031bfc18d$var$composeLayerMap(layerMaps) {
    const result = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, $58cad15031bfc18d$var$getLatestDefined(layerMaps));
    Object.entries(result).forEach(([id])=>{
        result[id] = $58cad15031bfc18d$var$composeLayer(layerMaps.map((item)=>item ? item[id] : undefined));
    });
    return result;
}
function $58cad15031bfc18d$export$801426c37c1dd1c8(entries, targetIndex) {
    if (targetIndex === undefined) targetIndex = entries.length - 1;
    entries = entries.slice(0, targetIndex + 1);
    return {
        projectId: $58cad15031bfc18d$var$getLatestDefinedProp(entries, 'projectId'),
        size: $58cad15031bfc18d$var$getLatestDefinedProp(entries, 'size'),
        activeLayerId: $58cad15031bfc18d$var$getLatestDefinedProp(entries, 'activeLayerId'),
        selection: $58cad15031bfc18d$var$getLatestDefinedProp(entries, 'selection'),
        layerMap: $58cad15031bfc18d$var$composeLayerMap(entries.map((item)=>item.layerMap))
    };
}


function $15ded6c5722f2bc8$export$dba0834b723f37f4(obj) {
    return typeof obj === 'object' && obj !== null && 'fill' in obj && typeof obj.fill === 'string';
}


function $2cbc755fe0cf3940$export$9522719957028754(entry) {
    var // for complex selection paths
    _entry_selection_value, _entry_selection;
    let result = 0;
    (_entry_selection = entry.selection) === null || _entry_selection === void 0 ? void 0 : (_entry_selection_value = _entry_selection.value) === null || _entry_selection_value === void 0 ? void 0 : _entry_selection_value.forEach((poly)=>{
        poly.forEach((ring)=>{
            result += ring.length * 2 * 8; // each number 8 bytes
        });
    });
    entry.layerMap && Object.entries(entry.layerMap).forEach(([, layer])=>{
        var _layer_tiles;
        (_layer_tiles = layer.tiles) === null || _layer_tiles === void 0 ? void 0 : _layer_tiles.forEach((tile)=>{
            if (tile === undefined) return;
            if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) result += tile.fill.length * 2; // 2 byte per character
            else result += tile.data.width * tile.data.height * 4; // 4 channels, each 1 byte
        });
    });
    return result;
}


function $cf71a5c2f724654d$export$770e40ded99d2233(entry, composed) {
    if (entry.size !== undefined) {
        if (entry.size.width !== composed.size.width) return true;
        if (entry.size.height !== composed.size.height) return true;
    }
    if (entry.selection !== undefined) {
        if (entry.selection.value !== composed.selection.value) return true;
    }
    if (entry.activeLayerId !== undefined) {
        if (entry.activeLayerId !== composed.activeLayerId) return true;
    }
    if (entry.layerMap !== undefined) {
        const entryLayerMapIds = Object.keys(entry.layerMap);
        for (const layerId of Object.keys(composed.layerMap)){
            if (!entryLayerMapIds.includes(layerId)) return true;
        }
        for (const layerId of entryLayerMapIds){
            const composedLayer = composed.layerMap[layerId];
            if (!composedLayer) return true;
            const entryLayer = entry.layerMap[layerId];
            if (entryLayer.name !== undefined && entryLayer.name !== composedLayer.name) return true;
            if (entryLayer.opacity !== undefined && entryLayer.opacity !== composedLayer.opacity) return true;
            if (entryLayer.isVisible !== undefined && entryLayer.isVisible !== composedLayer.isVisible) return true;
            if (entryLayer.mixModeStr !== undefined && entryLayer.mixModeStr !== composedLayer.mixModeStr) return true;
            if (entryLayer.index !== undefined && entryLayer.index !== composedLayer.index) return true;
            if (entryLayer.tiles !== undefined) // not needed currently
            return true;
        }
    }
    return false;
}




const $e4ca4e13bf821815$export$dcf9b1c44bd9f3ca = 200e6; // 200 MB
const $e4ca4e13bf821815$export$b2fc749d02ee72fc = 10e6; // 10 MB
const $e4ca4e13bf821815$export$3581b93879161a65 = 50;
const $e4ca4e13bf821815$export$31969bbe78931f29 = 1e9; // 1 GB
function $e4ca4e13bf821815$export$d67e774f8b500179(entries) {
    return entries.reduce((sum, e)=>sum + e.memoryEstimateBytes, 0);
}
function $e4ca4e13bf821815$export$d87cc29d5f016b5d(entries) {
    entries = [
        ...entries
    ];
    const totalBytes = $e4ca4e13bf821815$export$d67e774f8b500179(entries);
    if (totalBytes <= $e4ca4e13bf821815$export$dcf9b1c44bd9f3ca) // we always keep all below this threshold
    return entries;
    const newestEntryIndex = entries.length - 1; // index of the newest entry
    // limit age of large entries
    // Otherwise they may stick around very long and drive up the average memory usage.
    let oldestIndex = 0;
    for(let i = 0; i <= newestEntryIndex; i++){
        const age = newestEntryIndex - i;
        if (entries[i].memoryEstimateBytes > $e4ca4e13bf821815$export$b2fc749d02ee72fc && age > $e4ca4e13bf821815$export$3581b93879161a65) oldestIndex = i;
    }
    // Regular entries together can't exceed ALWAYS_KEEP_THRESHOLD_BYTES.
    // Large entries not included in this.
    {
        let accumulatedBytes = 0;
        for(let i = newestEntryIndex; i >= 0; i--){
            if (entries[i].memoryEstimateBytes > $e4ca4e13bf821815$export$b2fc749d02ee72fc) continue;
            accumulatedBytes += entries[i].memoryEstimateBytes;
            if (accumulatedBytes > $e4ca4e13bf821815$export$dcf9b1c44bd9f3ca) {
                oldestIndex = Math.max(oldestIndex, i);
                break;
            }
        }
    }
    // can't exceed TOTAL_THRESHOLD_BYTES
    {
        let accumulatedBytes = 0;
        for(let i = newestEntryIndex; i >= 0; i--){
            accumulatedBytes += entries[i].memoryEstimateBytes;
            if (accumulatedBytes > $e4ca4e13bf821815$export$31969bbe78931f29) {
                oldestIndex = Math.max(oldestIndex, i);
                break;
            }
        }
    }
    // compose entries 0..oldestIndex into a single "oldest" entry
    while(oldestIndex > 0){
        const composedData = (0, $58cad15031bfc18d$export$801426c37c1dd1c8)(entries.slice(0, oldestIndex + 1).map((item)=>item.data), oldestIndex);
        const memoryEstimateBytes = (0, $2cbc755fe0cf3940$export$9522719957028754)(composedData);
        entries = [
            {
                timestamp: entries[oldestIndex].timestamp,
                memoryEstimateBytes: memoryEstimateBytes,
                description: 'oldest',
                data: composedData
            },
            ...entries.slice(oldestIndex + 1)
        ];
        oldestIndex = 0;
        // Despite the earlier check the composed entry may still push the total over 1 GB.
        if ($e4ca4e13bf821815$export$d67e774f8b500179(entries) > $e4ca4e13bf821815$export$31969bbe78931f29) oldestIndex = 1;
    }
    return entries;
}


const $d2dccce11beb16cf$export$f7bc58374d6bc9b6 = 256;
const $d2dccce11beb16cf$var$HISTORY_DEBUGGING = false;
class $d2dccce11beb16cf$export$1a1044741a812c67 {
    broadcast() {
        this.changeCount++;
        setTimeout(()=>{
            for(let i = 0; i < this.listeners.length; i++)this.listeners[i]();
        });
    }
    updateComposed() {
        this.composed = (0, $58cad15031bfc18d$export$801426c37c1dd1c8)(this.entries.slice(0, this.index + 1).map((item)=>item.data));
    }
    /**
     * Needed, because sometimes there are actions that would cause other undo steps.
     * For example a filter that does something with two layers and then merges them.
     * That should be a single undo step, and prevent merging from creating its own undo step.
     * Pause prevents creation of unintended undo steps.
     */ pause(b) {
        if (b) this.pauseStack++;
        else this.pauseStack = Math.max(0, this.pauseStack - 1);
    }
    /**
     * listens to changes - on undo, redo, push
     */ addListener(l) {
        this.listeners.push(l);
    }
    // doesn't push if: paused or if entry is empty
    push(entryData, replaceTop) {
        if (this.pauseStack > 0) return;
        if (Object.keys(entryData).length === 0) // no change -> noop
        return;
        const entry = {
            timestamp: new Date().getTime(),
            memoryEstimateBytes: (0, $2cbc755fe0cf3940$export$9522719957028754)(entryData),
            data: entryData
        };
        if (replaceTop && this.index > 0) {
            this.index--;
            // remove current top
            while(this.index < this.entries.length - 1)this.entries.pop();
            // it's possible that new entry replacing top is same to composed history
            // e.g. toggle layer visibility twice
            const isDifferent = (0, $cf71a5c2f724654d$export$770e40ded99d2233)(entryData, (0, $58cad15031bfc18d$export$801426c37c1dd1c8)(this.entries.slice(0, this.index + 1).map((item)=>item.data)));
            // only need to push if it's different
            isDifferent && this.entries.push(entry);
        } else {
            while(this.index < this.entries.length - 1)this.entries.pop();
            this.entries.push(entry);
        }
        this.entries = (0, $e4ca4e13bf821815$export$d87cc29d5f016b5d)(this.entries);
        if ($d2dccce11beb16cf$var$HISTORY_DEBUGGING) {
            const totalBytes = (0, $e4ca4e13bf821815$export$d67e774f8b500179)(this.entries);
            console.log(`[KlHistory] pushed ${(entry.memoryEstimateBytes / 1e6).toFixed(1)} MB \u{2014} total: ${(totalBytes / 1e6).toFixed(1)} MB (${this.entries.length} entries)`);
        }
        this.totalActions++;
        this.index = this.entries.length - 1;
        this.updateComposed();
        this.broadcast();
    }
    increaseIndex() {
        if (this.canRedo()) this.index++;
        this.updateComposed();
        this.broadcast();
        return this.entries[this.index];
    }
    decreaseIndex() {
        if (this.canUndo()) this.index--;
        this.updateComposed();
        this.broadcast();
        return this.entries[this.index];
    }
    canUndo() {
        return this.index > 0;
    }
    canRedo() {
        return this.index < this.entries.length - 1;
    }
    getEntries() {
        return this.entries.slice(0, this.index + 1);
    }
    getComposed() {
        return this.composed;
    }
    getChangeCount() {
        return this.changeCount;
    }
    getTotalIndex() {
        return this.totalActions;
    }
    isPaused() {
        return this.pauseStack > 0;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.index = 0 // current action the user is on.
        ;
        this.totalActions = 0;
        this.changeCount = 0 // number keeps incrementing with each change (push, undo, redo)
        ;
        this.pauseStack = 0 // how often paused without unpause. push does nothing when paused.
        ;
        this.listeners = [] // broadcasts on undo, redo, push
        ;
        this.entries = [
            {
                timestamp: new Date().getTime(),
                memoryEstimateBytes: (0, $2cbc755fe0cf3940$export$9522719957028754)(p.oldest),
                data: p.oldest
            }
        ];
        this.composed = p.oldest;
        if ($d2dccce11beb16cf$var$HISTORY_DEBUGGING) window.getHistoryEntries = ()=>this.entries;
    }
}


const $e68ebad69e0ff595$export$40257b1b753712da = false;
/**
 * renders into all ProjectViewports
 */ class $e68ebad69e0ff595$var$DebugRender {
    render(ctx, width, height, scale) {
        this.internalRenderFuncs.forEach((func)=>{
            ctx.save();
            func(ctx, width, height, scale);
            ctx.restore();
        });
        this.renderFuncs.forEach((func)=>{
            ctx.save();
            func(ctx, width, height, scale);
            ctx.restore();
        });
    }
    // add something to be rendered
    add(func) {
        this.renderFuncs.push(func);
    }
    remove(func) {
        for(let i = 0; i < this.renderFuncs.length; i++)if (this.renderFuncs[i] === func) {
            this.renderFuncs.splice(i, 1);
            return;
        }
    }
    clear() {
        this.renderFuncs = [];
    }
    // --------------- public ---------------------
    constructor(){
        this.internalRenderFuncs = [];
        this.renderFuncs = [];
        if ($e68ebad69e0ff595$export$40257b1b753712da) {
            // draw checkerboard
            const checkerCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createCheckerCanvas(256, false);
            const pattern = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)((0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx((0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas((0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6))).createPattern(checkerCanvas, 'repeat'));
            this.internalRenderFuncs.push((ctx, width, height)=>{
                ctx.fillStyle = pattern;
                ctx.globalAlpha = 0.2;
                ctx.fillRect(0, 0, width, height);
            });
        }
    }
}
const $e68ebad69e0ff595$export$7bf40fdf7bf55821 = new $e68ebad69e0ff595$var$DebugRender();


function $0ca7fca685ce788f$var$fixScale(scale, pixels) {
    return Math.round(pixels * scale) / pixels;
}
class $0ca7fca685ce788f$export$a140ed60c2ca052c {
    render(optimizeForAnimation) {
        var _this_renderAfter, _this;
        const isDark = (0, $74a507c74cfe9692$export$5714e40777c1bcc2).isDark();
        const transform = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.transform), {
            x: this.transform.x,
            y: this.transform.y,
            scale: this.transform.scale
        });
        if (this.doResize) {
            this.doResize = false;
            this.resFactor = this.useNativeResolution ? devicePixelRatio : 1;
            this.canvas.width = Math.round(this.width * this.resFactor);
            this.canvas.height = Math.round(this.height * this.resFactor);
        }
        const renderedTransform = optimizeForAnimation ? {
            x: transform.x,
            y: transform.y,
            angleDeg: transform.angleDeg,
            scaleX: transform.scale,
            scaleY: transform.scale
        } : {
            x: Math.round(transform.x),
            y: Math.round(transform.y),
            scaleX: $0ca7fca685ce788f$var$fixScale(transform.scale, this.project.width),
            scaleY: $0ca7fca685ce788f$var$fixScale(transform.scale, this.project.height),
            angleDeg: transform.angleDeg
        };
        const renderedMat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(renderedTransform);
        this.ctx.save();
        if (renderedTransform.scaleX >= 4 || renderedTransform.scaleX === 1 && renderedTransform.angleDeg === 0) this.ctx.imageSmoothingEnabled = false;
        else {
            this.ctx.imageSmoothingEnabled = true;
            this.ctx.imageSmoothingQuality = 'low'; // art.scale >= 1 ? 'low' : 'medium';
        }
        // this.ctx.imageSmoothingEnabled = false;
        if (this.drawBackground) {
            this.ctx.fillStyle = isDark ? 'rgb(33, 33, 33)' : 'rgb(158,158,158)';
            this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        } else {
            this.ctx.fillStyle = this.pattern;
            this.ctx.fillRect(0, 0, this.width, this.height);
        }
        // this.ctx.scale(this.resFactor, this.resFactor);
        this.ctx.translate(renderedTransform.x, renderedTransform.y);
        this.ctx.scale(renderedTransform.scaleX, renderedTransform.scaleY);
        this.ctx.rotate(renderedTransform.angleDeg / 180 * Math.PI);
        if (this.drawBackground) {
            this.ctx.save();
            this.ctx.fillStyle = (0, $74a507c74cfe9692$export$5714e40777c1bcc2).isDark() ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.2)';
            const scaledPixelX = 1 / renderedTransform.scaleX;
            const scaledPixelY = 1 / renderedTransform.scaleY;
            this.ctx.fillRect(-scaledPixelX, -scaledPixelY, this.project.width + scaledPixelX * 2, this.project.height + scaledPixelY * 2);
            this.ctx.fillStyle = this.pattern;
            try {
                // setTransform got browser support since 2018-2020. catch if fails.
                this.pattern.setTransform((0, $077740f52fe6870e$export$70ae2c07e401031b)(renderedMat));
            } catch (e) {
            /* */ }
            this.ctx.fillRect(0, 0, this.project.width, this.project.height);
            this.ctx.restore();
        }
        this.project.layers.forEach((layer)=>{
            if (!layer.isVisible || !layer.opacity) return;
            this.ctx.save();
            this.ctx.globalCompositeOperation = layer.mixModeStr;
            this.ctx.globalAlpha = layer.opacity;
            let image;
            if (typeof layer.image === 'function') {
                const res = layer.image(renderedTransform, this.canvas.width, this.canvas.height);
                if ('image' in res && 'transform' in res) {
                    image = res.image;
                    this.ctx.setTransform(...(0, $974f651610599156$export$2b60e7dafdbde18a)((0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)(renderedMat, res.transform)));
                } else image = res;
            } else image = layer.image;
            this.ctx.drawImage(image, 0, 0); // , this.project.width, this.project.height);
            this.ctx.restore();
        });
        (_this_renderAfter = (_this = this).renderAfter) === null || _this_renderAfter === void 0 ? void 0 : _this_renderAfter.call(_this, this.ctx, renderedTransform);
        (0, $e68ebad69e0ff595$export$40257b1b753712da) && (0, $e68ebad69e0ff595$export$7bf40fdf7bf55821).render(this.ctx, this.project.width, this.project.height, renderedTransform.scaleX);
        this.ctx.restore();
    }
    setSize(width, height) {
        this.doResize = true;
        this.width = width;
        this.height = height;
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.canvas, {
            width: this.doFillParent ? '100%' : this.width + 'px',
            height: this.doFillParent ? '100%' : this.height + 'px'
        });
    }
    setTransform(transform) {
        this.transform = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform);
    }
    setProject(project) {
        this.project = project;
    }
    getTransform() {
        return (0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.transform);
    }
    setUseNativeResolution(b) {
        this.useNativeResolution = b;
        this.doResize = true;
    }
    getUseNativeResolution() {
        return this.useNativeResolution;
    }
    getElement() {
        return this.canvas;
    }
    destroy() {
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(this.canvas);
        (0, $74a507c74cfe9692$export$5714e40777c1bcc2).removeIsDarkListener(this.onIsDark);
        window.removeEventListener('resize', this.resizeListener);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.doResize = true;
        this.onIsDark = ()=>{
            this.pattern = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.ctx.createPattern((0, $d9f9f4926aa80a1c$export$921068d8846a1559).createCheckerCanvas(10, (0, $74a507c74cfe9692$export$5714e40777c1bcc2).isDark()), 'repeat'));
            this.render();
        };
        this.oldDPR = devicePixelRatio;
        this.resizeListener = ()=>{
            if (devicePixelRatio !== this.oldDPR) {
                this.canvas.style.imageRendering = Math.round(devicePixelRatio) !== devicePixelRatio ? '' : 'pixelated';
                this.oldDPR = devicePixelRatio;
            }
        };
        this.width = p.width;
        this.height = p.height;
        this.project = p.project;
        this.useNativeResolution = !!p.useNativeResolution;
        var _p_drawBackground;
        this.drawBackground = (_p_drawBackground = p.drawBackground) !== null && _p_drawBackground !== void 0 ? _p_drawBackground : true;
        this.doFillParent = !!p.fillParent;
        this.renderAfter = p.renderAfter;
        this.transform = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.transform);
        this.resFactor = this.useNativeResolution ? devicePixelRatio : 1;
        this.canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.width * this.resFactor, this.height * this.resFactor);
        this.ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.canvas);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.canvas, {
            width: this.doFillParent ? '100%' : this.width + 'px',
            height: this.doFillParent ? '100%' : this.height + 'px',
            imageRendering: Math.round(devicePixelRatio) !== devicePixelRatio ? undefined : 'pixelated',
            display: 'block'
        });
        window.addEventListener('resize', this.resizeListener);
        this.pattern = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(// Exception: InvalidStateError: The object is in an invalid state.
        this.ctx.createPattern((0, $d9f9f4926aa80a1c$export$921068d8846a1559).createCheckerCanvas(10, (0, $74a507c74cfe9692$export$5714e40777c1bcc2).isDark()), 'repeat'));
        (0, $74a507c74cfe9692$export$5714e40777c1bcc2).addIsDarkListener(this.onIsDark);
    // this.render();
    }
}




var $4ae8ffb159df37c1$exports = {};
$4ae8ffb159df37c1$exports = $parcel$resolve("bReTA");


var $c1f95fb9358806e5$exports = {};
$c1f95fb9358806e5$exports = $parcel$resolve("i3X7V");


var $e4b592a73e1920d7$exports = {};
$e4b592a73e1920d7$exports = $parcel$resolve("fETts");


var $071c8859c903033f$exports = {};
$071c8859c903033f$exports = $parcel$resolve("ksMx1");


var $12ab2cee238fdb68$exports = {};
$12ab2cee238fdb68$exports = $parcel$resolve("hRKJH");




var $36bbe8d945937d2a$export$77aefb1076e6c10f;
var $36bbe8d945937d2a$export$48c2d0f2f545ac27;
var $36bbe8d945937d2a$export$d7b7311ec04a3e8f;
$36bbe8d945937d2a$export$77aefb1076e6c10f = `VFEAZq_kl-theme-dark`;
$36bbe8d945937d2a$export$48c2d0f2f545ac27 = `VFEAZq_preview`;
$36bbe8d945937d2a$export$d7b7311ec04a3e8f = `VFEAZq_viewport`;


function $b18d1bd8e7aad78b$export$8c03162b1a39d183(oldScale, stepNum) {
    const step = Math.log2(oldScale);
    let newStep = step / Math.abs(stepNum);
    newStep += stepNum > 0 ? 1 : -1;
    newStep = Math.round(newStep);
    newStep *= Math.abs(stepNum);
    return Math.pow(2, newStep);
}






function $68a5ab3e745a3a87$export$99c68a89351e15c0(viewportPoint, canvasPoint, scale, angleDeg) {
    const mat = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $a78c550eaaca7cca$export$dcdf75081b88279d)(-scale, -scale), (0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(angleDeg / 180 * Math.PI));
    const topLeftP = (0, $855520c81dfcb96a$export$9b20165a36586806)(mat, canvasPoint);
    topLeftP.x += viewportPoint.x;
    topLeftP.y += viewportPoint.y;
    return {
        x: topLeftP.x,
        y: topLeftP.y,
        scale: scale,
        angleDeg: angleDeg
    };
}




function $bfc75b1b92419309$export$935bc53f7df03c95(transform, viewportP) {
    const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(transform);
    const canvasP = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(m), viewportP);
    return {
        viewportP: viewportP,
        canvasP: canvasP,
        scale: transform.scale,
        angleDeg: transform.angleDeg
    };
}





var $a40e51dbac8cdac4$export$8bb18c96af1baaf3;
var $a40e51dbac8cdac4$export$eea3e4f737fa39e3;
var $a40e51dbac8cdac4$export$d1eb619e8f7efb22;
var $a40e51dbac8cdac4$export$2f48b40a5a83dc1b;
$a40e51dbac8cdac4$export$8bb18c96af1baaf3 = `uIhb5a_blackAnim`;
$a40e51dbac8cdac4$export$8bb18c96af1baaf3;
$a40e51dbac8cdac4$export$eea3e4f737fa39e3 = `uIhb5a_blackPath`;
$a40e51dbac8cdac4$export$d1eb619e8f7efb22 = `uIhb5a_whiteAnim`;
$a40e51dbac8cdac4$export$d1eb619e8f7efb22;
$a40e51dbac8cdac4$export$2f48b40a5a83dc1b = `uIhb5a_whitePath`;





function $1d9e27e0466b80f7$export$aa391dbbf8073422(multiPolygon, transform) {
    return multiPolygon.map((poly)=>{
        return poly.map((ring)=>{
            return ring.map((point)=>{
                return Object.values((0, $855520c81dfcb96a$export$9b20165a36586806)(transform, {
                    x: point[0],
                    y: point[1]
                }));
            });
        });
    });
}


var $fa2cff2ef725812f$exports = {};
(function(global, factory) {
    $fa2cff2ef725812f$exports = factory();
})($fa2cff2ef725812f$exports, function() {
    'use strict';
    /**
     * splaytree v3.1.2
     * Fast Splay tree for Node and browser
     *
     * @author Alexander Milevski <info@w8r.name>
     * @license MIT
     * @preserve
     */ /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */ function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    var Node = /** @class */ function() {
        function Node(key, data) {
            this.next = null;
            this.key = key;
            this.data = data;
            this.left = null;
            this.right = null;
        }
        return Node;
    }();
    /* follows "An implementation of top-down splaying"
     * by D. Sleator <sleator@cs.cmu.edu> March 1992
     */ function DEFAULT_COMPARE(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    /**
     * Simple top down splay, not requiring i to be in the tree t.
     */ function splay(i, t, comparator) {
        var N = new Node(null, null);
        var l = N;
        var r = N;
        while(true){
            var cmp = comparator(i, t.key);
            //if (i < t.key) {
            if (cmp < 0) {
                if (t.left === null) break;
                //if (i < t.left.key) {
                if (comparator(i, t.left.key) < 0) {
                    var y = t.left; /* rotate right */ 
                    t.left = y.right;
                    y.right = t;
                    t = y;
                    if (t.left === null) break;
                }
                r.left = t; /* link right */ 
                r = t;
                t = t.left;
            //} else if (i > t.key) {
            } else if (cmp > 0) {
                if (t.right === null) break;
                //if (i > t.right.key) {
                if (comparator(i, t.right.key) > 0) {
                    var y = t.right; /* rotate left */ 
                    t.right = y.left;
                    y.left = t;
                    t = y;
                    if (t.right === null) break;
                }
                l.right = t; /* link left */ 
                l = t;
                t = t.right;
            } else break;
        }
        /* assemble */ l.right = t.left;
        r.left = t.right;
        t.left = N.right;
        t.right = N.left;
        return t;
    }
    function insert(i, data, t, comparator) {
        var node = new Node(i, data);
        if (t === null) {
            node.left = node.right = null;
            return node;
        }
        t = splay(i, t, comparator);
        var cmp = comparator(i, t.key);
        if (cmp < 0) {
            node.left = t.left;
            node.right = t;
            t.left = null;
        } else if (cmp >= 0) {
            node.right = t.right;
            node.left = t;
            t.right = null;
        }
        return node;
    }
    function split(key, v, comparator) {
        var left = null;
        var right = null;
        if (v) {
            v = splay(key, v, comparator);
            var cmp = comparator(v.key, key);
            if (cmp === 0) {
                left = v.left;
                right = v.right;
            } else if (cmp < 0) {
                right = v.right;
                v.right = null;
                left = v;
            } else {
                left = v.left;
                v.left = null;
                right = v;
            }
        }
        return {
            left: left,
            right: right
        };
    }
    function merge(left, right, comparator) {
        if (right === null) return left;
        if (left === null) return right;
        right = splay(left.key, right, comparator);
        right.left = left;
        return right;
    }
    /**
     * Prints level of the tree
     */ function printRow(root, prefix, isTail, out, printNode) {
        if (root) {
            out("" + prefix + (isTail ? "\u2514\u2500\u2500 " : "\u251C\u2500\u2500 ") + printNode(root) + "\n");
            var indent = prefix + (isTail ? '    ' : "\u2502   ");
            if (root.left) printRow(root.left, indent, false, out, printNode);
            if (root.right) printRow(root.right, indent, true, out, printNode);
        }
    }
    var Tree = /** @class */ function() {
        function Tree(comparator) {
            if (comparator === void 0) comparator = DEFAULT_COMPARE;
            this._root = null;
            this._size = 0;
            this._comparator = comparator;
        }
        /**
       * Inserts a key, allows duplicates
       */ Tree.prototype.insert = function(key, data) {
            this._size++;
            return this._root = insert(key, data, this._root, this._comparator);
        };
        /**
       * Adds a key, if it is not present in the tree
       */ Tree.prototype.add = function(key, data) {
            var node = new Node(key, data);
            if (this._root === null) {
                node.left = node.right = null;
                this._size++;
                this._root = node;
            }
            var comparator = this._comparator;
            var t = splay(key, this._root, comparator);
            var cmp = comparator(key, t.key);
            if (cmp === 0) this._root = t;
            else {
                if (cmp < 0) {
                    node.left = t.left;
                    node.right = t;
                    t.left = null;
                } else if (cmp > 0) {
                    node.right = t.right;
                    node.left = t;
                    t.right = null;
                }
                this._size++;
                this._root = node;
            }
            return this._root;
        };
        /**
       * @param  {Key} key
       * @return {Node|null}
       */ Tree.prototype.remove = function(key) {
            this._root = this._remove(key, this._root, this._comparator);
        };
        /**
       * Deletes i from the tree if it's there
       */ Tree.prototype._remove = function(i, t, comparator) {
            var x;
            if (t === null) return null;
            t = splay(i, t, comparator);
            var cmp = comparator(i, t.key);
            if (cmp === 0) {
                /* found it */ if (t.left === null) x = t.right;
                else {
                    x = splay(i, t.left, comparator);
                    x.right = t.right;
                }
                this._size--;
                return x;
            }
            return t; /* It wasn't there */ 
        };
        /**
       * Removes and returns the node with smallest key
       */ Tree.prototype.pop = function() {
            var node = this._root;
            if (node) {
                while(node.left)node = node.left;
                this._root = splay(node.key, this._root, this._comparator);
                this._root = this._remove(node.key, this._root, this._comparator);
                return {
                    key: node.key,
                    data: node.data
                };
            }
            return null;
        };
        /**
       * Find without splaying
       */ Tree.prototype.findStatic = function(key) {
            var current = this._root;
            var compare = this._comparator;
            while(current){
                var cmp = compare(key, current.key);
                if (cmp === 0) return current;
                else if (cmp < 0) current = current.left;
                else current = current.right;
            }
            return null;
        };
        Tree.prototype.find = function(key) {
            if (this._root) {
                this._root = splay(key, this._root, this._comparator);
                if (this._comparator(key, this._root.key) !== 0) return null;
            }
            return this._root;
        };
        Tree.prototype.contains = function(key) {
            var current = this._root;
            var compare = this._comparator;
            while(current){
                var cmp = compare(key, current.key);
                if (cmp === 0) return true;
                else if (cmp < 0) current = current.left;
                else current = current.right;
            }
            return false;
        };
        Tree.prototype.forEach = function(visitor, ctx) {
            var current = this._root;
            var Q = []; /* Initialize stack s */ 
            var done = false;
            while(!done){
                if (current !== null) {
                    Q.push(current);
                    current = current.left;
                } else if (Q.length !== 0) {
                    current = Q.pop();
                    visitor.call(ctx, current);
                    current = current.right;
                } else done = true;
            }
            return this;
        };
        /**
       * Walk key range from `low` to `high`. Stops if `fn` returns a value.
       */ Tree.prototype.range = function(low, high, fn, ctx) {
            var Q = [];
            var compare = this._comparator;
            var node = this._root;
            var cmp;
            while(Q.length !== 0 || node)if (node) {
                Q.push(node);
                node = node.left;
            } else {
                node = Q.pop();
                cmp = compare(node.key, high);
                if (cmp > 0) break;
                else if (compare(node.key, low) >= 0) {
                    if (fn.call(ctx, node)) return this; // stop if smth is returned
                }
                node = node.right;
            }
            return this;
        };
        /**
       * Returns array of keys
       */ Tree.prototype.keys = function() {
            var keys = [];
            this.forEach(function(_a) {
                var key = _a.key;
                return keys.push(key);
            });
            return keys;
        };
        /**
       * Returns array of all the data in the nodes
       */ Tree.prototype.values = function() {
            var values = [];
            this.forEach(function(_a) {
                var data = _a.data;
                return values.push(data);
            });
            return values;
        };
        Tree.prototype.min = function() {
            if (this._root) return this.minNode(this._root).key;
            return null;
        };
        Tree.prototype.max = function() {
            if (this._root) return this.maxNode(this._root).key;
            return null;
        };
        Tree.prototype.minNode = function(t) {
            if (t === void 0) t = this._root;
            if (t) while(t.left)t = t.left;
            return t;
        };
        Tree.prototype.maxNode = function(t) {
            if (t === void 0) t = this._root;
            if (t) while(t.right)t = t.right;
            return t;
        };
        /**
       * Returns node at given index
       */ Tree.prototype.at = function(index) {
            var current = this._root;
            var done = false;
            var i = 0;
            var Q = [];
            while(!done){
                if (current) {
                    Q.push(current);
                    current = current.left;
                } else if (Q.length > 0) {
                    current = Q.pop();
                    if (i === index) return current;
                    i++;
                    current = current.right;
                } else done = true;
            }
            return null;
        };
        Tree.prototype.next = function(d) {
            var root = this._root;
            var successor = null;
            if (d.right) {
                successor = d.right;
                while(successor.left)successor = successor.left;
                return successor;
            }
            var comparator = this._comparator;
            while(root){
                var cmp = comparator(d.key, root.key);
                if (cmp === 0) break;
                else if (cmp < 0) {
                    successor = root;
                    root = root.left;
                } else root = root.right;
            }
            return successor;
        };
        Tree.prototype.prev = function(d) {
            var root = this._root;
            var predecessor = null;
            if (d.left !== null) {
                predecessor = d.left;
                while(predecessor.right)predecessor = predecessor.right;
                return predecessor;
            }
            var comparator = this._comparator;
            while(root){
                var cmp = comparator(d.key, root.key);
                if (cmp === 0) break;
                else if (cmp < 0) root = root.left;
                else {
                    predecessor = root;
                    root = root.right;
                }
            }
            return predecessor;
        };
        Tree.prototype.clear = function() {
            this._root = null;
            this._size = 0;
            return this;
        };
        Tree.prototype.toList = function() {
            return toList(this._root);
        };
        /**
       * Bulk-load items. Both array have to be same size
       */ Tree.prototype.load = function(keys, values, presort) {
            if (values === void 0) values = [];
            if (presort === void 0) presort = false;
            var size = keys.length;
            var comparator = this._comparator;
            // sort if needed
            if (presort) sort(keys, values, 0, size - 1, comparator);
            if (this._root === null) {
                // empty tree
                this._root = loadRecursive(keys, values, 0, size);
                this._size = size;
            } else {
                // that re-builds the whole tree from two in-order traversals
                var mergedList = mergeLists(this.toList(), createList(keys, values), comparator);
                size = this._size + size;
                this._root = sortedListToBST({
                    head: mergedList
                }, 0, size);
            }
            return this;
        };
        Tree.prototype.isEmpty = function() {
            return this._root === null;
        };
        Object.defineProperty(Tree.prototype, "size", {
            get: function() {
                return this._size;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tree.prototype, "root", {
            get: function() {
                return this._root;
            },
            enumerable: true,
            configurable: true
        });
        Tree.prototype.toString = function(printNode) {
            if (printNode === void 0) printNode = function(n) {
                return String(n.key);
            };
            var out = [];
            printRow(this._root, '', true, function(v) {
                return out.push(v);
            }, printNode);
            return out.join('');
        };
        Tree.prototype.update = function(key, newKey, newData) {
            var comparator = this._comparator;
            var _a = split(key, this._root, comparator), left = _a.left, right = _a.right;
            if (comparator(key, newKey) < 0) right = insert(newKey, newData, right, comparator);
            else left = insert(newKey, newData, left, comparator);
            this._root = merge(left, right, comparator);
        };
        Tree.prototype.split = function(key) {
            return split(key, this._root, this._comparator);
        };
        Tree.prototype[Symbol.iterator] = function() {
            var current, Q, done;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        current = this._root;
                        Q = [];
                        done = false;
                        _a.label = 1;
                    case 1:
                        if (!!done) return [
                            3 /*break*/ ,
                            6
                        ];
                        if (!(current !== null)) return [
                            3 /*break*/ ,
                            2
                        ];
                        Q.push(current);
                        current = current.left;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(Q.length !== 0)) return [
                            3 /*break*/ ,
                            4
                        ];
                        current = Q.pop();
                        return [
                            4 /*yield*/ ,
                            current
                        ];
                    case 3:
                        _a.sent();
                        current = current.right;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        done = true;
                        _a.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        };
        return Tree;
    }();
    function loadRecursive(keys, values, start, end) {
        var size = end - start;
        if (size > 0) {
            var middle = start + Math.floor(size / 2);
            var key = keys[middle];
            var data = values[middle];
            var node = new Node(key, data);
            node.left = loadRecursive(keys, values, start, middle);
            node.right = loadRecursive(keys, values, middle + 1, end);
            return node;
        }
        return null;
    }
    function createList(keys, values) {
        var head = new Node(null, null);
        var p = head;
        for(var i = 0; i < keys.length; i++)p = p.next = new Node(keys[i], values[i]);
        p.next = null;
        return head.next;
    }
    function toList(root) {
        var current = root;
        var Q = [];
        var done = false;
        var head = new Node(null, null);
        var p = head;
        while(!done){
            if (current) {
                Q.push(current);
                current = current.left;
            } else if (Q.length > 0) {
                current = p = p.next = Q.pop();
                current = current.right;
            } else done = true;
        }
        p.next = null; // that'll work even if the tree was empty
        return head.next;
    }
    function sortedListToBST(list, start, end) {
        var size = end - start;
        if (size > 0) {
            var middle = start + Math.floor(size / 2);
            var left = sortedListToBST(list, start, middle);
            var root = list.head;
            root.left = left;
            list.head = list.head.next;
            root.right = sortedListToBST(list, middle + 1, end);
            return root;
        }
        return null;
    }
    function mergeLists(l1, l2, compare) {
        var head = new Node(null, null); // dummy
        var p = head;
        var p1 = l1;
        var p2 = l2;
        while(p1 !== null && p2 !== null){
            if (compare(p1.key, p2.key) < 0) {
                p.next = p1;
                p1 = p1.next;
            } else {
                p.next = p2;
                p2 = p2.next;
            }
            p = p.next;
        }
        if (p1 !== null) p.next = p1;
        else if (p2 !== null) p.next = p2;
        return head.next;
    }
    function sort(keys, values, left, right, compare) {
        if (left >= right) return;
        var pivot = keys[left + right >> 1];
        var i = left - 1;
        var j = right + 1;
        while(true){
            do i++;
            while (compare(keys[i], pivot) < 0);
            do j--;
            while (compare(keys[j], pivot) > 0);
            if (i >= j) break;
            var tmp = keys[i];
            keys[i] = keys[j];
            keys[j] = tmp;
            tmp = values[i];
            values[i] = values[j];
            values[j] = tmp;
        }
        sort(keys, values, left, j, compare);
        sort(keys, values, j + 1, right, compare);
    }
    /**
     * A bounding box has the format:
     *
     *  { ll: { x: xmin, y: ymin }, ur: { x: xmax, y: ymax } }
     *
     */ const isInBbox = (bbox, point)=>{
        return bbox.ll.x <= point.x && point.x <= bbox.ur.x && bbox.ll.y <= point.y && point.y <= bbox.ur.y;
    };
    /* Returns either null, or a bbox (aka an ordered pair of points)
     * If there is only one point of overlap, a bbox with identical points
     * will be returned */ const getBboxOverlap = (b1, b2)=>{
        // check if the bboxes overlap at all
        if (b2.ur.x < b1.ll.x || b1.ur.x < b2.ll.x || b2.ur.y < b1.ll.y || b1.ur.y < b2.ll.y) return null;
        // find the middle two X values
        const lowerX = b1.ll.x < b2.ll.x ? b2.ll.x : b1.ll.x;
        const upperX = b1.ur.x < b2.ur.x ? b1.ur.x : b2.ur.x;
        // find the middle two Y values
        const lowerY = b1.ll.y < b2.ll.y ? b2.ll.y : b1.ll.y;
        const upperY = b1.ur.y < b2.ur.y ? b1.ur.y : b2.ur.y;
        // put those middle values together to get the overlap
        return {
            ll: {
                x: lowerX,
                y: lowerY
            },
            ur: {
                x: upperX,
                y: upperY
            }
        };
    };
    /* Javascript doesn't do integer math. Everything is
     * floating point with percision Number.EPSILON.
     *
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/EPSILON
     */ let epsilon$1 = Number.EPSILON;
    // IE Polyfill
    if (epsilon$1 === undefined) epsilon$1 = Math.pow(2, -52);
    const EPSILON_SQ = epsilon$1 * epsilon$1;
    /* FLP comparator */ const cmp = (a, b)=>{
        // check if they're both 0
        if (-epsilon$1 < a && a < epsilon$1) {
            if (-epsilon$1 < b && b < epsilon$1) return 0;
        }
        // check if they're flp equal
        const ab = a - b;
        if (ab * ab < EPSILON_SQ * a * b) return 0;
        // normal comparison
        return a < b ? -1 : 1;
    };
    /**
     * This class rounds incoming values sufficiently so that
     * floating points problems are, for the most part, avoided.
     *
     * Incoming points are have their x & y values tested against
     * all previously seen x & y values. If either is 'too close'
     * to a previously seen value, it's value is 'snapped' to the
     * previously seen value.
     *
     * All points should be rounded by this class before being
     * stored in any data structures in the rest of this algorithm.
     */ class PtRounder {
        reset() {
            this.xRounder = new CoordRounder();
            this.yRounder = new CoordRounder();
        }
        round(x, y) {
            return {
                x: this.xRounder.round(x),
                y: this.yRounder.round(y)
            };
        }
        constructor(){
            this.reset();
        }
    }
    class CoordRounder {
        // Note: this can rounds input values backwards or forwards.
        //       You might ask, why not restrict this to just rounding
        //       forwards? Wouldn't that allow left endpoints to always
        //       remain left endpoints during splitting (never change to
        //       right). No - it wouldn't, because we snap intersections
        //       to endpoints (to establish independence from the segment
        //       angle for t-intersections).
        round(coord) {
            const node = this.tree.add(coord);
            const prevNode = this.tree.prev(node);
            if (prevNode !== null && cmp(node.key, prevNode.key) === 0) {
                this.tree.remove(coord);
                return prevNode.key;
            }
            const nextNode = this.tree.next(node);
            if (nextNode !== null && cmp(node.key, nextNode.key) === 0) {
                this.tree.remove(coord);
                return nextNode.key;
            }
            return coord;
        }
        constructor(){
            this.tree = new Tree();
            // preseed with 0 so we don't end up with values < Number.EPSILON
            this.round(0);
        }
    }
    // singleton available by import
    const rounder = new PtRounder();
    const epsilon = 1.1102230246251565e-16;
    const splitter = 134217729;
    const resulterrbound = (3 + 8 * epsilon) * epsilon;
    // fast_expansion_sum_zeroelim routine from oritinal code
    function sum(elen, e, flen, f, h) {
        let Q, Qnew, hh, bvirt;
        let enow = e[0];
        let fnow = f[0];
        let eindex = 0;
        let findex = 0;
        if (fnow > enow === fnow > -enow) {
            Q = enow;
            enow = e[++eindex];
        } else {
            Q = fnow;
            fnow = f[++findex];
        }
        let hindex = 0;
        if (eindex < elen && findex < flen) {
            if (fnow > enow === fnow > -enow) {
                Qnew = enow + Q;
                hh = Q - (Qnew - enow);
                enow = e[++eindex];
            } else {
                Qnew = fnow + Q;
                hh = Q - (Qnew - fnow);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
            while(eindex < elen && findex < flen){
                if (fnow > enow === fnow > -enow) {
                    Qnew = Q + enow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (enow - bvirt);
                    enow = e[++eindex];
                } else {
                    Qnew = Q + fnow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                    fnow = f[++findex];
                }
                Q = Qnew;
                if (hh !== 0) h[hindex++] = hh;
            }
        }
        while(eindex < elen){
            Qnew = Q + enow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (enow - bvirt);
            enow = e[++eindex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        while(findex < flen){
            Qnew = Q + fnow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (fnow - bvirt);
            fnow = f[++findex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        if (Q !== 0 || hindex === 0) h[hindex++] = Q;
        return hindex;
    }
    function estimate(elen, e) {
        let Q = e[0];
        for(let i = 1; i < elen; i++)Q += e[i];
        return Q;
    }
    function vec(n) {
        return new Float64Array(n);
    }
    const ccwerrboundA = (3 + 16 * epsilon) * epsilon;
    const ccwerrboundB = (2 + 12 * epsilon) * epsilon;
    const ccwerrboundC = (9 + 64 * epsilon) * epsilon * epsilon;
    const B = vec(4);
    const C1 = vec(8);
    const C2 = vec(12);
    const D = vec(16);
    const u = vec(4);
    function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
        let acxtail, acytail, bcxtail, bcytail;
        let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
        const acx = ax - cx;
        const bcx = bx - cx;
        const acy = ay - cy;
        const bcy = by - cy;
        s1 = acx * bcy;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcx;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        B[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        B[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        B[2] = _j - (u3 - bvirt) + (_i - bvirt);
        B[3] = u3;
        let det = estimate(4, B);
        let errbound = ccwerrboundB * detsum;
        if (det >= errbound || -det >= errbound) return det;
        bvirt = ax - acx;
        acxtail = ax - (acx + bvirt) + (bvirt - cx);
        bvirt = bx - bcx;
        bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
        bvirt = ay - acy;
        acytail = ay - (acy + bvirt) + (bvirt - cy);
        bvirt = by - bcy;
        bcytail = by - (bcy + bvirt) + (bvirt - cy);
        if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
        errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
        det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
        if (det >= errbound || -det >= errbound) return det;
        s1 = acxtail * bcy;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcx;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C1len = sum(4, B, 4, u, C1);
        s1 = acx * bcytail;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcxtail;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C2len = sum(C1len, C1, 4, u, C2);
        s1 = acxtail * bcytail;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcxtail;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const Dlen = sum(C2len, C2, 4, u, D);
        return D[Dlen - 1];
    }
    function orient2d(ax, ay, bx, by, cx, cy) {
        const detleft = (ay - cy) * (bx - cx);
        const detright = (ax - cx) * (by - cy);
        const det = detleft - detright;
        const detsum = Math.abs(detleft + detright);
        if (Math.abs(det) >= ccwerrboundA * detsum) return det;
        return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
    }
    /* Cross Product of two vectors with first point at origin */ const crossProduct = (a, b)=>a.x * b.y - a.y * b.x;
    /* Dot Product of two vectors with first point at origin */ const dotProduct = (a, b)=>a.x * b.x + a.y * b.y;
    /* Comparator for two vectors with same starting point */ const compareVectorAngles = (basePt, endPt1, endPt2)=>{
        const res = orient2d(basePt.x, basePt.y, endPt1.x, endPt1.y, endPt2.x, endPt2.y);
        if (res > 0) return -1;
        if (res < 0) return 1;
        return 0;
    };
    const length = (v)=>Math.sqrt(dotProduct(v, v));
    /* Get the sine of the angle from pShared -> pAngle to pShaed -> pBase */ const sineOfAngle = (pShared, pBase, pAngle)=>{
        const vBase = {
            x: pBase.x - pShared.x,
            y: pBase.y - pShared.y
        };
        const vAngle = {
            x: pAngle.x - pShared.x,
            y: pAngle.y - pShared.y
        };
        return crossProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };
    /* Get the cosine of the angle from pShared -> pAngle to pShaed -> pBase */ const cosineOfAngle = (pShared, pBase, pAngle)=>{
        const vBase = {
            x: pBase.x - pShared.x,
            y: pBase.y - pShared.y
        };
        const vAngle = {
            x: pAngle.x - pShared.x,
            y: pAngle.y - pShared.y
        };
        return dotProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };
    /* Get the x coordinate where the given line (defined by a point and vector)
     * crosses the horizontal line with the given y coordiante.
     * In the case of parrallel lines (including overlapping ones) returns null. */ const horizontalIntersection = (pt, v, y)=>{
        if (v.y === 0) return null;
        return {
            x: pt.x + v.x / v.y * (y - pt.y),
            y: y
        };
    };
    /* Get the y coordinate where the given line (defined by a point and vector)
     * crosses the vertical line with the given x coordiante.
     * In the case of parrallel lines (including overlapping ones) returns null. */ const verticalIntersection = (pt, v, x)=>{
        if (v.x === 0) return null;
        return {
            x: x,
            y: pt.y + v.y / v.x * (x - pt.x)
        };
    };
    /* Get the intersection of two lines, each defined by a base point and a vector.
     * In the case of parrallel lines (including overlapping ones) returns null. */ const intersection$1 = (pt1, v1, pt2, v2)=>{
        // take some shortcuts for vertical and horizontal lines
        // this also ensures we don't calculate an intersection and then discover
        // it's actually outside the bounding box of the line
        if (v1.x === 0) return verticalIntersection(pt2, v2, pt1.x);
        if (v2.x === 0) return verticalIntersection(pt1, v1, pt2.x);
        if (v1.y === 0) return horizontalIntersection(pt2, v2, pt1.y);
        if (v2.y === 0) return horizontalIntersection(pt1, v1, pt2.y);
        // General case for non-overlapping segments.
        // This algorithm is based on Schneider and Eberly.
        // http://www.cimec.org.ar/~ncalvo/Schneider_Eberly.pdf - pg 244
        const kross = crossProduct(v1, v2);
        if (kross == 0) return null;
        const ve = {
            x: pt2.x - pt1.x,
            y: pt2.y - pt1.y
        };
        const d1 = crossProduct(ve, v1) / kross;
        const d2 = crossProduct(ve, v2) / kross;
        // take the average of the two calculations to minimize rounding error
        const x1 = pt1.x + d2 * v1.x, x2 = pt2.x + d1 * v2.x;
        const y1 = pt1.y + d2 * v1.y, y2 = pt2.y + d1 * v2.y;
        const x = (x1 + x2) / 2;
        const y = (y1 + y2) / 2;
        return {
            x: x,
            y: y
        };
    };
    class SweepEvent {
        // for ordering sweep events in the sweep event queue
        static compare(a, b) {
            // favor event with a point that the sweep line hits first
            const ptCmp = SweepEvent.comparePoints(a.point, b.point);
            if (ptCmp !== 0) return ptCmp;
            // the points are the same, so link them if needed
            if (a.point !== b.point) a.link(b);
            // favor right events over left
            if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1;
            // we have two matching left or right endpoints
            // ordering of this case is the same as for their segments
            return Segment.compare(a.segment, b.segment);
        }
        // for ordering points in sweep line order
        static comparePoints(aPt, bPt) {
            if (aPt.x < bPt.x) return -1;
            if (aPt.x > bPt.x) return 1;
            if (aPt.y < bPt.y) return -1;
            if (aPt.y > bPt.y) return 1;
            return 0;
        }
        link(other) {
            if (other.point === this.point) throw new Error("Tried to link already linked events");
            const otherEvents = other.point.events;
            for(let i = 0, iMax = otherEvents.length; i < iMax; i++){
                const evt = otherEvents[i];
                this.point.events.push(evt);
                evt.point = this.point;
            }
            this.checkForConsuming();
        }
        /* Do a pass over our linked events and check to see if any pair
       * of segments match, and should be consumed. */ checkForConsuming() {
            // FIXME: The loops in this method run O(n^2) => no good.
            //        Maintain little ordered sweep event trees?
            //        Can we maintaining an ordering that avoids the need
            //        for the re-sorting with getLeftmostComparator in geom-out?
            // Compare each pair of events to see if other events also match
            const numEvents = this.point.events.length;
            for(let i = 0; i < numEvents; i++){
                const evt1 = this.point.events[i];
                if (evt1.segment.consumedBy !== undefined) continue;
                for(let j = i + 1; j < numEvents; j++){
                    const evt2 = this.point.events[j];
                    if (evt2.consumedBy !== undefined) continue;
                    if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
                    evt1.segment.consume(evt2.segment);
                }
            }
        }
        getAvailableLinkedEvents() {
            // point.events is always of length 2 or greater
            const events = [];
            for(let i = 0, iMax = this.point.events.length; i < iMax; i++){
                const evt = this.point.events[i];
                if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) events.push(evt);
            }
            return events;
        }
        /**
       * Returns a comparator function for sorting linked events that will
       * favor the event that will give us the smallest left-side angle.
       * All ring construction starts as low as possible heading to the right,
       * so by always turning left as sharp as possible we'll get polygons
       * without uncessary loops & holes.
       *
       * The comparator function has a compute cache such that it avoids
       * re-computing already-computed values.
       */ getLeftmostComparator(baseEvent) {
            const cache = new Map();
            const fillCache = (linkedEvent)=>{
                const nextEvent = linkedEvent.otherSE;
                cache.set(linkedEvent, {
                    sine: sineOfAngle(this.point, baseEvent.point, nextEvent.point),
                    cosine: cosineOfAngle(this.point, baseEvent.point, nextEvent.point)
                });
            };
            return (a, b)=>{
                if (!cache.has(a)) fillCache(a);
                if (!cache.has(b)) fillCache(b);
                const { sine: asine, cosine: acosine } = cache.get(a);
                const { sine: bsine, cosine: bcosine } = cache.get(b);
                // both on or above x-axis
                if (asine >= 0 && bsine >= 0) {
                    if (acosine < bcosine) return 1;
                    if (acosine > bcosine) return -1;
                    return 0;
                }
                // both below x-axis
                if (asine < 0 && bsine < 0) {
                    if (acosine < bcosine) return -1;
                    if (acosine > bcosine) return 1;
                    return 0;
                }
                // one above x-axis, one below
                if (bsine < asine) return -1;
                if (bsine > asine) return 1;
                return 0;
            };
        }
        // Warning: 'point' input will be modified and re-used (for performance)
        constructor(point, isLeft){
            if (point.events === undefined) point.events = [
                this
            ];
            else point.events.push(this);
            this.point = point;
            this.isLeft = isLeft;
        // this.segment, this.otherSE set by factory
        }
    }
    // Give segments unique ID's to get consistent sorting of
    // segments and sweep events when all else is identical
    let segmentId = 0;
    class Segment {
        /* This compare() function is for ordering segments in the sweep
       * line tree, and does so according to the following criteria:
       *
       * Consider the vertical line that lies an infinestimal step to the
       * right of the right-more of the two left endpoints of the input
       * segments. Imagine slowly moving a point up from negative infinity
       * in the increasing y direction. Which of the two segments will that
       * point intersect first? That segment comes 'before' the other one.
       *
       * If neither segment would be intersected by such a line, (if one
       * or more of the segments are vertical) then the line to be considered
       * is directly on the right-more of the two left inputs.
       */ static compare(a, b) {
            const alx = a.leftSE.point.x;
            const blx = b.leftSE.point.x;
            const arx = a.rightSE.point.x;
            const brx = b.rightSE.point.x;
            // check if they're even in the same vertical plane
            if (brx < alx) return 1;
            if (arx < blx) return -1;
            const aly = a.leftSE.point.y;
            const bly = b.leftSE.point.y;
            const ary = a.rightSE.point.y;
            const bry = b.rightSE.point.y;
            // is left endpoint of segment B the right-more?
            if (alx < blx) {
                // are the two segments in the same horizontal plane?
                if (bly < aly && bly < ary) return 1;
                if (bly > aly && bly > ary) return -1;
                // is the B left endpoint colinear to segment A?
                const aCmpBLeft = a.comparePoint(b.leftSE.point);
                if (aCmpBLeft < 0) return 1;
                if (aCmpBLeft > 0) return -1;
                // is the A right endpoint colinear to segment B ?
                const bCmpARight = b.comparePoint(a.rightSE.point);
                if (bCmpARight !== 0) return bCmpARight;
                // colinear segments, consider the one with left-more
                // left endpoint to be first (arbitrary?)
                return -1;
            }
            // is left endpoint of segment A the right-more?
            if (alx > blx) {
                if (aly < bly && aly < bry) return -1;
                if (aly > bly && aly > bry) return 1;
                // is the A left endpoint colinear to segment B?
                const bCmpALeft = b.comparePoint(a.leftSE.point);
                if (bCmpALeft !== 0) return bCmpALeft;
                // is the B right endpoint colinear to segment A?
                const aCmpBRight = a.comparePoint(b.rightSE.point);
                if (aCmpBRight < 0) return 1;
                if (aCmpBRight > 0) return -1;
                // colinear segments, consider the one with left-more
                // left endpoint to be first (arbitrary?)
                return 1;
            }
            // if we get here, the two left endpoints are in the same
            // vertical plane, ie alx === blx
            // consider the lower left-endpoint to come first
            if (aly < bly) return -1;
            if (aly > bly) return 1;
            // left endpoints are identical
            // check for colinearity by using the left-more right endpoint
            // is the A right endpoint more left-more?
            if (arx < brx) {
                const bCmpARight = b.comparePoint(a.rightSE.point);
                if (bCmpARight !== 0) return bCmpARight;
            }
            // is the B right endpoint more left-more?
            if (arx > brx) {
                const aCmpBRight = a.comparePoint(b.rightSE.point);
                if (aCmpBRight < 0) return 1;
                if (aCmpBRight > 0) return -1;
            }
            if (arx !== brx) {
                // are these two [almost] vertical segments with opposite orientation?
                // if so, the one with the lower right endpoint comes first
                const ay = ary - aly;
                const ax = arx - alx;
                const by = bry - bly;
                const bx = brx - blx;
                if (ay > ax && by < bx) return 1;
                if (ay < ax && by > bx) return -1;
            }
            // we have colinear segments with matching orientation
            // consider the one with more left-more right endpoint to be first
            if (arx > brx) return 1;
            if (arx < brx) return -1;
            // if we get here, two two right endpoints are in the same
            // vertical plane, ie arx === brx
            // consider the lower right-endpoint to come first
            if (ary < bry) return -1;
            if (ary > bry) return 1;
            // right endpoints identical as well, so the segments are idential
            // fall back on creation order as consistent tie-breaker
            if (a.id < b.id) return -1;
            if (a.id > b.id) return 1;
            // identical segment, ie a === b
            return 0;
        }
        static fromRing(pt1, pt2, ring) {
            let leftPt, rightPt, winding;
            // ordering the two points according to sweep line ordering
            const cmpPts = SweepEvent.comparePoints(pt1, pt2);
            if (cmpPts < 0) {
                leftPt = pt1;
                rightPt = pt2;
                winding = 1;
            } else if (cmpPts > 0) {
                leftPt = pt2;
                rightPt = pt1;
                winding = -1;
            } else throw new Error(`Tried to create degenerate segment at [${pt1.x}, ${pt1.y}]`);
            const leftSE = new SweepEvent(leftPt, true);
            const rightSE = new SweepEvent(rightPt, false);
            return new Segment(leftSE, rightSE, [
                ring
            ], [
                winding
            ]);
        }
        /* When a segment is split, the rightSE is replaced with a new sweep event */ replaceRightSE(newRightSE) {
            this.rightSE = newRightSE;
            this.rightSE.segment = this;
            this.rightSE.otherSE = this.leftSE;
            this.leftSE.otherSE = this.rightSE;
        }
        bbox() {
            const y1 = this.leftSE.point.y;
            const y2 = this.rightSE.point.y;
            return {
                ll: {
                    x: this.leftSE.point.x,
                    y: y1 < y2 ? y1 : y2
                },
                ur: {
                    x: this.rightSE.point.x,
                    y: y1 > y2 ? y1 : y2
                }
            };
        }
        /* A vector from the left point to the right */ vector() {
            return {
                x: this.rightSE.point.x - this.leftSE.point.x,
                y: this.rightSE.point.y - this.leftSE.point.y
            };
        }
        isAnEndpoint(pt) {
            return pt.x === this.leftSE.point.x && pt.y === this.leftSE.point.y || pt.x === this.rightSE.point.x && pt.y === this.rightSE.point.y;
        }
        /* Compare this segment with a point.
       *
       * A point P is considered to be colinear to a segment if there
       * exists a distance D such that if we travel along the segment
       * from one * endpoint towards the other a distance D, we find
       * ourselves at point P.
       *
       * Return value indicates:
       *
       *   1: point lies above the segment (to the left of vertical)
       *   0: point is colinear to segment
       *  -1: point lies below the segment (to the right of vertical)
       */ comparePoint(point) {
            if (this.isAnEndpoint(point)) return 0;
            const lPt = this.leftSE.point;
            const rPt = this.rightSE.point;
            const v = this.vector();
            // Exactly vertical segments.
            if (lPt.x === rPt.x) {
                if (point.x === lPt.x) return 0;
                return point.x < lPt.x ? 1 : -1;
            }
            // Nearly vertical segments with an intersection.
            // Check to see where a point on the line with matching Y coordinate is.
            const yDist = (point.y - lPt.y) / v.y;
            const xFromYDist = lPt.x + yDist * v.x;
            if (point.x === xFromYDist) return 0;
            // General case.
            // Check to see where a point on the line with matching X coordinate is.
            const xDist = (point.x - lPt.x) / v.x;
            const yFromXDist = lPt.y + xDist * v.y;
            if (point.y === yFromXDist) return 0;
            return point.y < yFromXDist ? -1 : 1;
        }
        /**
       * Given another segment, returns the first non-trivial intersection
       * between the two segments (in terms of sweep line ordering), if it exists.
       *
       * A 'non-trivial' intersection is one that will cause one or both of the
       * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
       *
       *   * endpoint of segA with endpoint of segB --> trivial
       *   * endpoint of segA with point along segB --> non-trivial
       *   * endpoint of segB with point along segA --> non-trivial
       *   * point along segA with point along segB --> non-trivial
       *
       * If no non-trivial intersection exists, return null
       * Else, return null.
       */ getIntersection(other) {
            // If bboxes don't overlap, there can't be any intersections
            const tBbox = this.bbox();
            const oBbox = other.bbox();
            const bboxOverlap = getBboxOverlap(tBbox, oBbox);
            if (bboxOverlap === null) return null;
            // We first check to see if the endpoints can be considered intersections.
            // This will 'snap' intersections to endpoints if possible, and will
            // handle cases of colinearity.
            const tlp = this.leftSE.point;
            const trp = this.rightSE.point;
            const olp = other.leftSE.point;
            const orp = other.rightSE.point;
            // does each endpoint touch the other segment?
            // note that we restrict the 'touching' definition to only allow segments
            // to touch endpoints that lie forward from where we are in the sweep line pass
            const touchesOtherLSE = isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
            const touchesThisLSE = isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
            const touchesOtherRSE = isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
            const touchesThisRSE = isInBbox(oBbox, trp) && other.comparePoint(trp) === 0;
            // do left endpoints match?
            if (touchesThisLSE && touchesOtherLSE) {
                // these two cases are for colinear segments with matching left
                // endpoints, and one segment being longer than the other
                if (touchesThisRSE && !touchesOtherRSE) return trp;
                if (!touchesThisRSE && touchesOtherRSE) return orp;
                // either the two segments match exactly (two trival intersections)
                // or just on their left endpoint (one trivial intersection
                return null;
            }
            // does this left endpoint matches (other doesn't)
            if (touchesThisLSE) {
                // check for segments that just intersect on opposing endpoints
                if (touchesOtherRSE) {
                    if (tlp.x === orp.x && tlp.y === orp.y) return null;
                }
                // t-intersection on left endpoint
                return tlp;
            }
            // does other left endpoint matches (this doesn't)
            if (touchesOtherLSE) {
                // check for segments that just intersect on opposing endpoints
                if (touchesThisRSE) {
                    if (trp.x === olp.x && trp.y === olp.y) return null;
                }
                // t-intersection on left endpoint
                return olp;
            }
            // trivial intersection on right endpoints
            if (touchesThisRSE && touchesOtherRSE) return null;
            // t-intersections on just one right endpoint
            if (touchesThisRSE) return trp;
            if (touchesOtherRSE) return orp;
            // None of our endpoints intersect. Look for a general intersection between
            // infinite lines laid over the segments
            const pt = intersection$1(tlp, this.vector(), olp, other.vector());
            // are the segments parrallel? Note that if they were colinear with overlap,
            // they would have an endpoint intersection and that case was already handled above
            if (pt === null) return null;
            // is the intersection found between the lines not on the segments?
            if (!isInBbox(bboxOverlap, pt)) return null;
            // round the the computed point if needed
            return rounder.round(pt.x, pt.y);
        }
        /**
       * Split the given segment into multiple segments on the given points.
       *  * Each existing segment will retain its leftSE and a new rightSE will be
       *    generated for it.
       *  * A new segment will be generated which will adopt the original segment's
       *    rightSE, and a new leftSE will be generated for it.
       *  * If there are more than two points given to split on, new segments
       *    in the middle will be generated with new leftSE and rightSE's.
       *  * An array of the newly generated SweepEvents will be returned.
       *
       * Warning: input array of points is modified
       */ split(point) {
            const newEvents = [];
            const alreadyLinked = point.events !== undefined;
            const newLeftSE = new SweepEvent(point, true);
            const newRightSE = new SweepEvent(point, false);
            const oldRightSE = this.rightSE;
            this.replaceRightSE(newRightSE);
            newEvents.push(newRightSE);
            newEvents.push(newLeftSE);
            const newSeg = new Segment(newLeftSE, oldRightSE, this.rings.slice(), this.windings.slice());
            // when splitting a nearly vertical downward-facing segment,
            // sometimes one of the resulting new segments is vertical, in which
            // case its left and right events may need to be swapped
            if (SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) newSeg.swapEvents();
            if (SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) this.swapEvents();
            // in the point we just used to create new sweep events with was already
            // linked to other events, we need to check if either of the affected
            // segments should be consumed
            if (alreadyLinked) {
                newLeftSE.checkForConsuming();
                newRightSE.checkForConsuming();
            }
            return newEvents;
        }
        /* Swap which event is left and right */ swapEvents() {
            const tmpEvt = this.rightSE;
            this.rightSE = this.leftSE;
            this.leftSE = tmpEvt;
            this.leftSE.isLeft = true;
            this.rightSE.isLeft = false;
            for(let i = 0, iMax = this.windings.length; i < iMax; i++)this.windings[i] *= -1;
        }
        /* Consume another segment. We take their rings under our wing
       * and mark them as consumed. Use for perfectly overlapping segments */ consume(other) {
            let consumer = this;
            let consumee = other;
            while(consumer.consumedBy)consumer = consumer.consumedBy;
            while(consumee.consumedBy)consumee = consumee.consumedBy;
            const cmp = Segment.compare(consumer, consumee);
            if (cmp === 0) return; // already consumed
            // the winner of the consumption is the earlier segment
            // according to sweep line ordering
            if (cmp > 0) {
                const tmp = consumer;
                consumer = consumee;
                consumee = tmp;
            }
            // make sure a segment doesn't consume it's prev
            if (consumer.prev === consumee) {
                const tmp = consumer;
                consumer = consumee;
                consumee = tmp;
            }
            for(let i = 0, iMax = consumee.rings.length; i < iMax; i++){
                const ring = consumee.rings[i];
                const winding = consumee.windings[i];
                const index = consumer.rings.indexOf(ring);
                if (index === -1) {
                    consumer.rings.push(ring);
                    consumer.windings.push(winding);
                } else consumer.windings[index] += winding;
            }
            consumee.rings = null;
            consumee.windings = null;
            consumee.consumedBy = consumer;
            // mark sweep events consumed as to maintain ordering in sweep event queue
            consumee.leftSE.consumedBy = consumer.leftSE;
            consumee.rightSE.consumedBy = consumer.rightSE;
        }
        /* The first segment previous segment chain that is in the result */ prevInResult() {
            if (this._prevInResult !== undefined) return this._prevInResult;
            if (!this.prev) this._prevInResult = null;
            else if (this.prev.isInResult()) this._prevInResult = this.prev;
            else this._prevInResult = this.prev.prevInResult();
            return this._prevInResult;
        }
        beforeState() {
            if (this._beforeState !== undefined) return this._beforeState;
            if (!this.prev) this._beforeState = {
                rings: [],
                windings: [],
                multiPolys: []
            };
            else {
                const seg = this.prev.consumedBy || this.prev;
                this._beforeState = seg.afterState();
            }
            return this._beforeState;
        }
        afterState() {
            if (this._afterState !== undefined) return this._afterState;
            const beforeState = this.beforeState();
            this._afterState = {
                rings: beforeState.rings.slice(0),
                windings: beforeState.windings.slice(0),
                multiPolys: []
            };
            const ringsAfter = this._afterState.rings;
            const windingsAfter = this._afterState.windings;
            const mpsAfter = this._afterState.multiPolys;
            // calculate ringsAfter, windingsAfter
            for(let i = 0, iMax = this.rings.length; i < iMax; i++){
                const ring = this.rings[i];
                const winding = this.windings[i];
                const index = ringsAfter.indexOf(ring);
                if (index === -1) {
                    ringsAfter.push(ring);
                    windingsAfter.push(winding);
                } else windingsAfter[index] += winding;
            }
            // calcualte polysAfter
            const polysAfter = [];
            const polysExclude = [];
            for(let i = 0, iMax = ringsAfter.length; i < iMax; i++){
                if (windingsAfter[i] === 0) continue; // non-zero rule
                const ring = ringsAfter[i];
                const poly = ring.poly;
                if (polysExclude.indexOf(poly) !== -1) continue;
                if (ring.isExterior) polysAfter.push(poly);
                else {
                    if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);
                    const index = polysAfter.indexOf(ring.poly);
                    if (index !== -1) polysAfter.splice(index, 1);
                }
            }
            // calculate multiPolysAfter
            for(let i = 0, iMax = polysAfter.length; i < iMax; i++){
                const mp = polysAfter[i].multiPoly;
                if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
            }
            return this._afterState;
        }
        /* Is this segment part of the final result? */ isInResult() {
            // if we've been consumed, we're not in the result
            if (this.consumedBy) return false;
            if (this._isInResult !== undefined) return this._isInResult;
            const mpsBefore = this.beforeState().multiPolys;
            const mpsAfter = this.afterState().multiPolys;
            switch(operation.type){
                case "union":
                    {
                        // UNION - included iff:
                        //  * On one side of us there is 0 poly interiors AND
                        //  * On the other side there is 1 or more.
                        const noBefores = mpsBefore.length === 0;
                        const noAfters = mpsAfter.length === 0;
                        this._isInResult = noBefores !== noAfters;
                        break;
                    }
                case "intersection":
                    {
                        // INTERSECTION - included iff:
                        //  * on one side of us all multipolys are rep. with poly interiors AND
                        //  * on the other side of us, not all multipolys are repsented
                        //    with poly interiors
                        let least;
                        let most;
                        if (mpsBefore.length < mpsAfter.length) {
                            least = mpsBefore.length;
                            most = mpsAfter.length;
                        } else {
                            least = mpsAfter.length;
                            most = mpsBefore.length;
                        }
                        this._isInResult = most === operation.numMultiPolys && least < most;
                        break;
                    }
                case "xor":
                    {
                        // XOR - included iff:
                        //  * the difference between the number of multipolys represented
                        //    with poly interiors on our two sides is an odd number
                        const diff = Math.abs(mpsBefore.length - mpsAfter.length);
                        this._isInResult = diff % 2 === 1;
                        break;
                    }
                case "difference":
                    {
                        // DIFFERENCE included iff:
                        //  * on exactly one side, we have just the subject
                        const isJustSubject = (mps)=>mps.length === 1 && mps[0].isSubject;
                        this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
                        break;
                    }
                default:
                    throw new Error(`Unrecognized operation type found ${operation.type}`);
            }
            return this._isInResult;
        }
        /* Warning: a reference to ringWindings input will be stored,
       *  and possibly will be later modified */ constructor(leftSE, rightSE, rings, windings){
            this.id = ++segmentId;
            this.leftSE = leftSE;
            leftSE.segment = this;
            leftSE.otherSE = rightSE;
            this.rightSE = rightSE;
            rightSE.segment = this;
            rightSE.otherSE = leftSE;
            this.rings = rings;
            this.windings = windings;
        // left unset for performance, set later in algorithm
        // this.ringOut, this.consumedBy, this.prev
        }
    }
    class RingIn {
        getSweepEvents() {
            const sweepEvents = [];
            for(let i = 0, iMax = this.segments.length; i < iMax; i++){
                const segment = this.segments[i];
                sweepEvents.push(segment.leftSE);
                sweepEvents.push(segment.rightSE);
            }
            return sweepEvents;
        }
        constructor(geomRing, poly, isExterior){
            if (!Array.isArray(geomRing) || geomRing.length === 0) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.poly = poly;
            this.isExterior = isExterior;
            this.segments = [];
            if (typeof geomRing[0][0] !== "number" || typeof geomRing[0][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            const firstPoint = rounder.round(geomRing[0][0], geomRing[0][1]);
            this.bbox = {
                ll: {
                    x: firstPoint.x,
                    y: firstPoint.y
                },
                ur: {
                    x: firstPoint.x,
                    y: firstPoint.y
                }
            };
            let prevPoint = firstPoint;
            for(let i = 1, iMax = geomRing.length; i < iMax; i++){
                if (typeof geomRing[i][0] !== "number" || typeof geomRing[i][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                let point = rounder.round(geomRing[i][0], geomRing[i][1]);
                // skip repeated points
                if (point.x === prevPoint.x && point.y === prevPoint.y) continue;
                this.segments.push(Segment.fromRing(prevPoint, point, this));
                if (point.x < this.bbox.ll.x) this.bbox.ll.x = point.x;
                if (point.y < this.bbox.ll.y) this.bbox.ll.y = point.y;
                if (point.x > this.bbox.ur.x) this.bbox.ur.x = point.x;
                if (point.y > this.bbox.ur.y) this.bbox.ur.y = point.y;
                prevPoint = point;
            }
            // add segment from last to first if last is not the same as first
            if (firstPoint.x !== prevPoint.x || firstPoint.y !== prevPoint.y) this.segments.push(Segment.fromRing(prevPoint, firstPoint, this));
        }
    }
    class PolyIn {
        getSweepEvents() {
            const sweepEvents = this.exteriorRing.getSweepEvents();
            for(let i = 0, iMax = this.interiorRings.length; i < iMax; i++){
                const ringSweepEvents = this.interiorRings[i].getSweepEvents();
                for(let j = 0, jMax = ringSweepEvents.length; j < jMax; j++)sweepEvents.push(ringSweepEvents[j]);
            }
            return sweepEvents;
        }
        constructor(geomPoly, multiPoly){
            if (!Array.isArray(geomPoly)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.exteriorRing = new RingIn(geomPoly[0], this, true);
            // copy by value
            this.bbox = {
                ll: {
                    x: this.exteriorRing.bbox.ll.x,
                    y: this.exteriorRing.bbox.ll.y
                },
                ur: {
                    x: this.exteriorRing.bbox.ur.x,
                    y: this.exteriorRing.bbox.ur.y
                }
            };
            this.interiorRings = [];
            for(let i = 1, iMax = geomPoly.length; i < iMax; i++){
                const ring = new RingIn(geomPoly[i], this, false);
                if (ring.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = ring.bbox.ll.x;
                if (ring.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = ring.bbox.ll.y;
                if (ring.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = ring.bbox.ur.x;
                if (ring.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = ring.bbox.ur.y;
                this.interiorRings.push(ring);
            }
            this.multiPoly = multiPoly;
        }
    }
    class MultiPolyIn {
        getSweepEvents() {
            const sweepEvents = [];
            for(let i = 0, iMax = this.polys.length; i < iMax; i++){
                const polySweepEvents = this.polys[i].getSweepEvents();
                for(let j = 0, jMax = polySweepEvents.length; j < jMax; j++)sweepEvents.push(polySweepEvents[j]);
            }
            return sweepEvents;
        }
        constructor(geom, isSubject){
            if (!Array.isArray(geom)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            try {
                // if the input looks like a polygon, convert it to a multipolygon
                if (typeof geom[0][0][0] === "number") geom = [
                    geom
                ];
            } catch (ex) {
            // The input is either malformed or has empty arrays.
            // In either case, it will be handled later on.
            }
            this.polys = [];
            this.bbox = {
                ll: {
                    x: Number.POSITIVE_INFINITY,
                    y: Number.POSITIVE_INFINITY
                },
                ur: {
                    x: Number.NEGATIVE_INFINITY,
                    y: Number.NEGATIVE_INFINITY
                }
            };
            for(let i = 0, iMax = geom.length; i < iMax; i++){
                const poly = new PolyIn(geom[i], this);
                if (poly.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = poly.bbox.ll.x;
                if (poly.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = poly.bbox.ll.y;
                if (poly.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = poly.bbox.ur.x;
                if (poly.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = poly.bbox.ur.y;
                this.polys.push(poly);
            }
            this.isSubject = isSubject;
        }
    }
    class RingOut {
        /* Given the segments from the sweep line pass, compute & return a series
       * of closed rings from all the segments marked to be part of the result */ static factory(allSegments) {
            const ringsOut = [];
            for(let i = 0, iMax = allSegments.length; i < iMax; i++){
                const segment = allSegments[i];
                if (!segment.isInResult() || segment.ringOut) continue;
                let prevEvent = null;
                let event = segment.leftSE;
                let nextEvent = segment.rightSE;
                const events = [
                    event
                ];
                const startingPoint = event.point;
                const intersectionLEs = [];
                /* Walk the chain of linked events to form a closed ring */ while(true){
                    prevEvent = event;
                    event = nextEvent;
                    events.push(event);
                    /* Is the ring complete? */ if (event.point === startingPoint) break;
                    while(true){
                        const availableLEs = event.getAvailableLinkedEvents();
                        /* Did we hit a dead end? This shouldn't happen.
               * Indicates some earlier part of the algorithm malfunctioned. */ if (availableLEs.length === 0) {
                            const firstPt = events[0].point;
                            const lastPt = events[events.length - 1].point;
                            throw new Error(`Unable to complete output ring starting at [${firstPt.x},` + ` ${firstPt.y}]. Last matching segment found ends at` + ` [${lastPt.x}, ${lastPt.y}].`);
                        }
                        /* Only one way to go, so cotinue on the path */ if (availableLEs.length === 1) {
                            nextEvent = availableLEs[0].otherSE;
                            break;
                        }
                        /* We must have an intersection. Check for a completed loop */ let indexLE = null;
                        for(let j = 0, jMax = intersectionLEs.length; j < jMax; j++)if (intersectionLEs[j].point === event.point) {
                            indexLE = j;
                            break;
                        }
                        /* Found a completed loop. Cut that off and make a ring */ if (indexLE !== null) {
                            const intersectionLE = intersectionLEs.splice(indexLE)[0];
                            const ringEvents = events.splice(intersectionLE.index);
                            ringEvents.unshift(ringEvents[0].otherSE);
                            ringsOut.push(new RingOut(ringEvents.reverse()));
                            continue;
                        }
                        /* register the intersection */ intersectionLEs.push({
                            index: events.length,
                            point: event.point
                        });
                        /* Choose the left-most option to continue the walk */ const comparator = event.getLeftmostComparator(prevEvent);
                        nextEvent = availableLEs.sort(comparator)[0].otherSE;
                        break;
                    }
                }
                ringsOut.push(new RingOut(events));
            }
            return ringsOut;
        }
        getGeom() {
            // Remove superfluous points (ie extra points along a straight line),
            let prevPt = this.events[0].point;
            const points = [
                prevPt
            ];
            for(let i = 1, iMax = this.events.length - 1; i < iMax; i++){
                const pt = this.events[i].point;
                const nextPt = this.events[i + 1].point;
                if (compareVectorAngles(pt, prevPt, nextPt) === 0) continue;
                points.push(pt);
                prevPt = pt;
            }
            // ring was all (within rounding error of angle calc) colinear points
            if (points.length === 1) return null;
            // check if the starting point is necessary
            const pt = points[0];
            const nextPt = points[1];
            if (compareVectorAngles(pt, prevPt, nextPt) === 0) points.shift();
            points.push(points[0]);
            const step = this.isExteriorRing() ? 1 : -1;
            const iStart = this.isExteriorRing() ? 0 : points.length - 1;
            const iEnd = this.isExteriorRing() ? points.length : -1;
            const orderedPoints = [];
            for(let i = iStart; i != iEnd; i += step)orderedPoints.push([
                points[i].x,
                points[i].y
            ]);
            return orderedPoints;
        }
        isExteriorRing() {
            if (this._isExteriorRing === undefined) {
                const enclosing = this.enclosingRing();
                this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
            }
            return this._isExteriorRing;
        }
        enclosingRing() {
            if (this._enclosingRing === undefined) this._enclosingRing = this._calcEnclosingRing();
            return this._enclosingRing;
        }
        /* Returns the ring that encloses this one, if any */ _calcEnclosingRing() {
            // start with the ealier sweep line event so that the prevSeg
            // chain doesn't lead us inside of a loop of ours
            let leftMostEvt = this.events[0];
            for(let i = 1, iMax = this.events.length; i < iMax; i++){
                const evt = this.events[i];
                if (SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
            }
            let prevSeg = leftMostEvt.segment.prevInResult();
            let prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
            while(true){
                // no segment found, thus no ring can enclose us
                if (!prevSeg) return null;
                // no segments below prev segment found, thus the ring of the prev
                // segment must loop back around and enclose us
                if (!prevPrevSeg) return prevSeg.ringOut;
                // if the two segments are of different rings, the ring of the prev
                // segment must either loop around us or the ring of the prev prev
                // seg, which would make us and the ring of the prev peers
                if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
                    if (prevPrevSeg.ringOut.enclosingRing() !== prevSeg.ringOut) return prevSeg.ringOut;
                    else return prevSeg.ringOut.enclosingRing();
                }
                // two segments are from the same ring, so this was a penisula
                // of that ring. iterate downward, keep searching
                prevSeg = prevPrevSeg.prevInResult();
                prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
            }
        }
        constructor(events){
            this.events = events;
            for(let i = 0, iMax = events.length; i < iMax; i++)events[i].segment.ringOut = this;
            this.poly = null;
        }
    }
    class PolyOut {
        addInterior(ring) {
            this.interiorRings.push(ring);
            ring.poly = this;
        }
        getGeom() {
            const geom = [
                this.exteriorRing.getGeom()
            ];
            // exterior ring was all (within rounding error of angle calc) colinear points
            if (geom[0] === null) return null;
            for(let i = 0, iMax = this.interiorRings.length; i < iMax; i++){
                const ringGeom = this.interiorRings[i].getGeom();
                // interior ring was all (within rounding error of angle calc) colinear points
                if (ringGeom === null) continue;
                geom.push(ringGeom);
            }
            return geom;
        }
        constructor(exteriorRing){
            this.exteriorRing = exteriorRing;
            exteriorRing.poly = this;
            this.interiorRings = [];
        }
    }
    class MultiPolyOut {
        getGeom() {
            const geom = [];
            for(let i = 0, iMax = this.polys.length; i < iMax; i++){
                const polyGeom = this.polys[i].getGeom();
                // exterior ring was all (within rounding error of angle calc) colinear points
                if (polyGeom === null) continue;
                geom.push(polyGeom);
            }
            return geom;
        }
        _composePolys(rings) {
            const polys = [];
            for(let i = 0, iMax = rings.length; i < iMax; i++){
                const ring = rings[i];
                if (ring.poly) continue;
                if (ring.isExteriorRing()) polys.push(new PolyOut(ring));
                else {
                    const enclosingRing = ring.enclosingRing();
                    if (!enclosingRing.poly) polys.push(new PolyOut(enclosingRing));
                    enclosingRing.poly.addInterior(ring);
                }
            }
            return polys;
        }
        constructor(rings){
            this.rings = rings;
            this.polys = this._composePolys(rings);
        }
    }
    /**
     * NOTE:  We must be careful not to change any segments while
     *        they are in the SplayTree. AFAIK, there's no way to tell
     *        the tree to rebalance itself - thus before splitting
     *        a segment that's in the tree, we remove it from the tree,
     *        do the split, then re-insert it. (Even though splitting a
     *        segment *shouldn't* change its correct position in the
     *        sweep line tree, the reality is because of rounding errors,
     *        it sometimes does.)
     */ class SweepLine {
        process(event) {
            const segment = event.segment;
            const newEvents = [];
            // if we've already been consumed by another segment,
            // clean up our body parts and get out
            if (event.consumedBy) {
                if (event.isLeft) this.queue.remove(event.otherSE);
                else this.tree.remove(segment);
                return newEvents;
            }
            const node = event.isLeft ? this.tree.add(segment) : this.tree.find(segment);
            if (!node) throw new Error(`Unable to find segment #${segment.id} ` + `[${segment.leftSE.point.x}, ${segment.leftSE.point.y}] -> ` + `[${segment.rightSE.point.x}, ${segment.rightSE.point.y}] ` + "in SweepLine tree.");
            let prevNode = node;
            let nextNode = node;
            let prevSeg = undefined;
            let nextSeg = undefined;
            // skip consumed segments still in tree
            while(prevSeg === undefined){
                prevNode = this.tree.prev(prevNode);
                if (prevNode === null) prevSeg = null;
                else if (prevNode.key.consumedBy === undefined) prevSeg = prevNode.key;
            }
            // skip consumed segments still in tree
            while(nextSeg === undefined){
                nextNode = this.tree.next(nextNode);
                if (nextNode === null) nextSeg = null;
                else if (nextNode.key.consumedBy === undefined) nextSeg = nextNode.key;
            }
            if (event.isLeft) {
                // Check for intersections against the previous segment in the sweep line
                let prevMySplitter = null;
                if (prevSeg) {
                    const prevInter = prevSeg.getIntersection(segment);
                    if (prevInter !== null) {
                        if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;
                        if (!prevSeg.isAnEndpoint(prevInter)) {
                            const newEventsFromSplit = this._splitSafely(prevSeg, prevInter);
                            for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                        }
                    }
                }
                // Check for intersections against the next segment in the sweep line
                let nextMySplitter = null;
                if (nextSeg) {
                    const nextInter = nextSeg.getIntersection(segment);
                    if (nextInter !== null) {
                        if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;
                        if (!nextSeg.isAnEndpoint(nextInter)) {
                            const newEventsFromSplit = this._splitSafely(nextSeg, nextInter);
                            for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                        }
                    }
                }
                // For simplicity, even if we find more than one intersection we only
                // spilt on the 'earliest' (sweep-line style) of the intersections.
                // The other intersection will be handled in a future process().
                if (prevMySplitter !== null || nextMySplitter !== null) {
                    let mySplitter = null;
                    if (prevMySplitter === null) mySplitter = nextMySplitter;
                    else if (nextMySplitter === null) mySplitter = prevMySplitter;
                    else {
                        const cmpSplitters = SweepEvent.comparePoints(prevMySplitter, nextMySplitter);
                        mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
                    }
                    // Rounding errors can cause changes in ordering,
                    // so remove afected segments and right sweep events before splitting
                    this.queue.remove(segment.rightSE);
                    newEvents.push(segment.rightSE);
                    const newEventsFromSplit = segment.split(mySplitter);
                    for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                }
                if (newEvents.length > 0) {
                    // We found some intersections, so re-do the current event to
                    // make sure sweep line ordering is totally consistent for later
                    // use with the segment 'prev' pointers
                    this.tree.remove(segment);
                    newEvents.push(event);
                } else {
                    // done with left event
                    this.segments.push(segment);
                    segment.prev = prevSeg;
                }
            } else {
                // event.isRight
                // since we're about to be removed from the sweep line, check for
                // intersections between our previous and next segments
                if (prevSeg && nextSeg) {
                    const inter = prevSeg.getIntersection(nextSeg);
                    if (inter !== null) {
                        if (!prevSeg.isAnEndpoint(inter)) {
                            const newEventsFromSplit = this._splitSafely(prevSeg, inter);
                            for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                        }
                        if (!nextSeg.isAnEndpoint(inter)) {
                            const newEventsFromSplit = this._splitSafely(nextSeg, inter);
                            for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                        }
                    }
                }
                this.tree.remove(segment);
            }
            return newEvents;
        }
        /* Safely split a segment that is currently in the datastructures
       * IE - a segment other than the one that is currently being processed. */ _splitSafely(seg, pt) {
            // Rounding errors can cause changes in ordering,
            // so remove afected segments and right sweep events before splitting
            // removeNode() doesn't work, so have re-find the seg
            // https://github.com/w8r/splay-tree/pull/5
            this.tree.remove(seg);
            const rightSE = seg.rightSE;
            this.queue.remove(rightSE);
            const newEvents = seg.split(pt);
            newEvents.push(rightSE);
            // splitting can trigger consumption
            if (seg.consumedBy === undefined) this.tree.add(seg);
            return newEvents;
        }
        constructor(queue){
            let comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Segment.compare;
            this.queue = queue;
            this.tree = new Tree(comparator);
            this.segments = [];
        }
    }
    // Limits on iterative processes to prevent infinite loops - usually caused by floating-point math round-off errors.
    const POLYGON_CLIPPING_MAX_QUEUE_SIZE = 1000000;
    const POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS = 1000000;
    class Operation {
        run(type, geom, moreGeoms) {
            operation.type = type;
            rounder.reset();
            /* Convert inputs to MultiPoly objects */ const multipolys = [
                new MultiPolyIn(geom, true)
            ];
            for(let i = 0, iMax = moreGeoms.length; i < iMax; i++)multipolys.push(new MultiPolyIn(moreGeoms[i], false));
            operation.numMultiPolys = multipolys.length;
            /* BBox optimization for difference operation
         * If the bbox of a multipolygon that's part of the clipping doesn't
         * intersect the bbox of the subject at all, we can just drop that
         * multiploygon. */ if (operation.type === "difference") {
                // in place removal
                const subject = multipolys[0];
                let i = 1;
                while(i < multipolys.length)if (getBboxOverlap(multipolys[i].bbox, subject.bbox) !== null) i++;
                else multipolys.splice(i, 1);
            }
            /* BBox optimization for intersection operation
         * If we can find any pair of multipolygons whose bbox does not overlap,
         * then the result will be empty. */ if (operation.type === "intersection") // TODO: this is O(n^2) in number of polygons. By sorting the bboxes,
            //       it could be optimized to O(n * ln(n))
            for(let i = 0, iMax = multipolys.length; i < iMax; i++){
                const mpA = multipolys[i];
                for(let j = i + 1, jMax = multipolys.length; j < jMax; j++){
                    if (getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
                }
            }
            /* Put segment endpoints in a priority queue */ const queue = new Tree(SweepEvent.compare);
            for(let i = 0, iMax = multipolys.length; i < iMax; i++){
                const sweepEvents = multipolys[i].getSweepEvents();
                for(let j = 0, jMax = sweepEvents.length; j < jMax; j++){
                    queue.insert(sweepEvents[j]);
                    if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) // prevents an infinite loop, an otherwise common manifestation of bugs
                    throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big).");
                }
            }
            /* Pass the sweep line over those endpoints */ const sweepLine = new SweepLine(queue);
            let prevQueueSize = queue.size;
            let node = queue.pop();
            while(node){
                const evt = node.key;
                if (queue.size === prevQueueSize) {
                    // prevents an infinite loop, an otherwise common manifestation of bugs
                    const seg = evt.segment;
                    throw new Error(`Unable to pop() ${evt.isLeft ? "left" : "right"} SweepEvent ` + `[${evt.point.x}, ${evt.point.y}] from segment #${seg.id} ` + `[${seg.leftSE.point.x}, ${seg.leftSE.point.y}] -> ` + `[${seg.rightSE.point.x}, ${seg.rightSE.point.y}] from queue.`);
                }
                if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) // prevents an infinite loop, an otherwise common manifestation of bugs
                throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big).");
                if (sweepLine.segments.length > POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS) // prevents an infinite loop, an otherwise common manifestation of bugs
                throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments).");
                const newEvents = sweepLine.process(evt);
                for(let i = 0, iMax = newEvents.length; i < iMax; i++){
                    const evt = newEvents[i];
                    if (evt.consumedBy === undefined) queue.insert(evt);
                }
                prevQueueSize = queue.size;
                node = queue.pop();
            }
            // free some memory we don't need anymore
            rounder.reset();
            /* Collect and compile segments we're keeping into a multipolygon */ const ringsOut = RingOut.factory(sweepLine.segments);
            const result = new MultiPolyOut(ringsOut);
            return result.getGeom();
        }
    }
    // singleton available by import
    const operation = new Operation();
    const union = function(geom) {
        for(var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)moreGeoms[_key - 1] = arguments[_key];
        return operation.run("union", geom, moreGeoms);
    };
    const intersection = function(geom) {
        for(var _len2 = arguments.length, moreGeoms = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)moreGeoms[_key2 - 1] = arguments[_key2];
        return operation.run("intersection", geom, moreGeoms);
    };
    const xor = function(geom) {
        for(var _len3 = arguments.length, moreGeoms = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)moreGeoms[_key3 - 1] = arguments[_key3];
        return operation.run("xor", geom, moreGeoms);
    };
    const difference = function(subjectGeom) {
        for(var _len4 = arguments.length, clippingGeoms = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)clippingGeoms[_key4 - 1] = arguments[_key4];
        return operation.run("difference", subjectGeom, clippingGeoms);
    };
    var index = {
        union: union,
        intersection: intersection,
        xor: xor,
        difference: difference
    };
    return index;
});


function $bec2c57bfccd422e$export$7ec1a3fdd6e82838(operation, geom, ...geoms) {
    let result = []; // initialized with fallback
    try {
        result = $fa2cff2ef725812f$exports[operation](geom, ...geoms);
    } catch (e) {
    /* */ }
    return result;
}
function $bec2c57bfccd422e$export$ea06409da076aec8(multiPolygon, clip) {
    const result = [];
    for (const polygon of multiPolygon)for (const ring of polygon){
        const clipped = $bec2c57bfccd422e$export$7ec1a3fdd6e82838('intersection', [
            [
                ring
            ]
        ], [
            [
                clip
            ]
        ]);
        for (const poly of clipped)result.push(poly);
    }
    return result;
}


function $af70c2e1b3c35649$export$f3040a9d9c5d06ba(multiPolygon) {
    return multiPolygon.map((poly)=>{
        return poly.map((ring)=>{
            return ring.map((point)=>{
                return [
                    Math.round(point[0] + 0.5) - 0.5,
                    Math.round(point[1] + 0.5) - 0.5
                ]; // on .5
            });
        });
    });
}
class $af70c2e1b3c35649$export$c61ab90e0d3eb9b1 {
    update() {
        const selection = this.renderedSelection === null ? this.selection : this.renderedSelection;
        if (!selection) {
            this.svgPath1.setAttribute('d', '');
            this.svgPath2.setAttribute('d', '');
            return;
        }
        // firefox has problems with non-scaling-stroke, so we scale manually.
        // ^ it has visual glitches when the transformation changes.
        const transformedSelection = (0, $1d9e27e0466b80f7$export$aa391dbbf8073422)(selection, this.viewportMat);
        // Firefox has bad performance when zoomed in far (guess: it doesn't clip the path)
        // So we clip manually.
        const clipPadding = 10;
        const clippedSelection = (0, $bec2c57bfccd422e$export$ea06409da076aec8)(transformedSelection, [
            [
                -clipPadding,
                -clipPadding
            ],
            [
                this.viewportWidth + clipPadding,
                -clipPadding
            ],
            [
                this.viewportWidth + clipPadding,
                this.viewportHeight + clipPadding
            ],
            [
                -clipPadding,
                this.viewportHeight + clipPadding
            ],
            [
                -clipPadding,
                -clipPadding
            ]
        ]);
        const d = (0, $6b6f23a269032ad5$export$8f2be1db13cf0f94)($af70c2e1b3c35649$export$f3040a9d9c5d06ba(clippedSelection));
        this.svgPath1.setAttribute('d', d);
        this.svgPath2.setAttribute('d', d);
    }
    setTransform(transform) {
        this.viewportTransform = transform;
        this.viewportMat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewportTransform);
        this.update();
    }
    setSelection(selection) {
        if (this.selection === selection) return;
        this.selection = selection;
        // only need to update when this.selection is used
        if (this.renderedSelection === null) this.update();
    }
    // overwrite project selection
    setRenderedSelection(renderedSelection, isImmediate) {
        if (this.renderedSelection === renderedSelection) return;
        this.renderedSelection = renderedSelection;
        this.update();
    }
    // render project selection again
    clearRenderedSelection(isImmediate) {
        this.renderedSelection = null;
        if (!isImmediate) // good enough to update on next setSelection. (to prevent flickering)
        return;
        this.update();
    }
    setSize(width, height) {
        this.viewportWidth = width;
        this.viewportHeight = height;
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.rootEl.remove();
        this.selection = undefined;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.renderedSelection = null // overwrites this.selection, unless it's null
        ;
        this.viewportTransform = p.transform;
        this.viewportMat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewportTransform);
        this.selection = p.selection;
        this.viewportWidth = p.width;
        this.viewportHeight = p.height;
        this.svgPath1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'path',
            'vector-effect': 'non-scaling-stroke'
        });
        this.svgPath1.classList.add($a40e51dbac8cdac4$export$2f48b40a5a83dc1b);
        this.svgPath2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'path',
            'vector-effect': 'non-scaling-stroke'
        });
        this.svgPath2.classList.add($a40e51dbac8cdac4$export$eea3e4f737fa39e3);
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.rootEl.append(this.svgPath1, this.svgPath2);
    }
}



const $324add89932145ee$var$DEFAULT_PADDING = 10;
class $324add89932145ee$export$133773870222880f {
    requestRerender() {
        this.doRender = true;
    }
    resetOrZoom(x, y) {
        if (this.isReset) {
            this.isReset = false;
            const canvasP = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)((0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewport.getTransform())), {
                x: x,
                y: y
            });
            this.viewport.setTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)({
                x: this.width / 2,
                y: this.height / 2
            }, canvasP, 1, 0));
            this.requestRerender();
        } else this.reset();
    }
    reset() {
        const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(this.project.width, this.project.height, this.width - this.padding * 2, this.height - this.padding * 2);
        const scale = fit.width / this.project.width;
        this.viewport.setTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)({
            x: this.width / 2,
            y: this.height / 2
        }, {
            x: this.project.width / 2,
            y: this.project.height / 2
        }, scale, 0));
        this.isReset = true;
        this.requestRerender();
    }
    transformCanvas(t) {
        if (t.type === 'translate') {
            const old = this.viewport.getTransform();
            if (t.x === 0 && t.y === 0) return;
            this.viewport.setTransform((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, old), {
                x: old.x + t.x,
                y: old.y + t.y
            }));
        } else if (t.type === 'zoom') {
            const old = this.viewport.getTransform();
            const viewportRect = this.viewport.getElement().getBoundingClientRect();
            var _t_vX;
            t.vX = (_t_vX = t.vX) !== null && _t_vX !== void 0 ? _t_vX : viewportRect.width / 2;
            var _t_vY;
            t.vY = (_t_vY = t.vY) !== null && _t_vY !== void 0 ? _t_vY : viewportRect.height / 2;
            const metaTransform = (0, $bfc75b1b92419309$export$935bc53f7df03c95)(old, {
                x: t.vX,
                y: t.vY
            });
            metaTransform.scale *= t.fac;
            this.viewport.setTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg));
        }
        this.isReset = false;
        this.requestRerender();
    }
    render() {
        this.requestRerender();
    }
    setTransform(transform) {
        this.viewport.setTransform(transform);
        this.requestRerender();
        this.isReset = false;
    }
    getTransform() {
        return this.viewport.getTransform();
    }
    onPointer(event) {
        this.pointerChain.chainIn(event);
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        var _this_selectionRenderer;
        this.animationFrameId !== undefined && cancelAnimationFrame(this.animationFrameId);
        this.viewport.destroy();
        this.viewportPointerListener.destroy();
        this.rootEl.remove();
        this.modeToggle && this.modeToggle.destroy();
        (_this_selectionRenderer = this.selectionRenderer) === null || _this_selectionRenderer === void 0 ? void 0 : _this_selectionRenderer.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isReset = true;
        this.doRender = false;
        this.lastEmittedTransform = {
            x: 0,
            y: 0,
            scale: 0,
            angleDeg: 0
        };
        this.renderLoop = ()=>{
            this.animationFrameId = requestAnimationFrame(this.renderLoop);
            if (this.doRender) {
                var _this_selectionRenderer;
                this.doRender = false;
                this.viewport.render();
                const viewportTransform = this.viewport.getTransform();
                (_this_selectionRenderer = this.selectionRenderer) === null || _this_selectionRenderer === void 0 ? void 0 : _this_selectionRenderer.setTransform(viewportTransform);
                if (this.onTransformChange && JSON.stringify(this.lastEmittedTransform) !== JSON.stringify(viewportTransform)) {
                    this.onTransformChange(viewportTransform);
                    this.lastEmittedTransform = viewportTransform;
                }
            }
        };
        this.onWheel = (e)=>{
            const viewportRect = this.viewport.getElement().getBoundingClientRect();
            const vX = e.pageX - viewportRect.x;
            const vY = e.pageY - viewportRect.y;
            const oldScale = this.viewport.getTransform().scale;
            const newScale = (0, $b18d1bd8e7aad78b$export$8c03162b1a39d183)(oldScale, -e.deltaY / 2);
            this.transformCanvas({
                type: 'zoom',
                vX: vX,
                vY: vY,
                fac: newScale / oldScale
            });
        };
        this.width = p.width;
        this.height = p.height;
        this.project = p.project;
        this.onTransformChange = p.onTransformChange;
        var _p_padding;
        this.padding = (_p_padding = p.padding) !== null && _p_padding !== void 0 ? _p_padding : $324add89932145ee$var$DEFAULT_PADDING;
        const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(this.project.width, this.project.height, this.width - this.padding * 2, this.height - this.padding * 2);
        const scale = fit.width / this.project.width;
        this.viewport = new (0, $0ca7fca685ce788f$export$a140ed60c2ca052c)({
            width: this.width,
            height: this.height,
            transform: (0, $68a5ab3e745a3a87$export$99c68a89351e15c0)({
                x: this.width / 2,
                y: this.height / 2
            }, {
                x: this.project.width / 2,
                y: this.project.height / 2
            }, scale, 0),
            project: this.project,
            useNativeResolution: false,
            drawBackground: true
        });
        const doubleTapper = new (0, $afe05ecd8ae7f4be$export$db3963a21c01d803)({
            onDoubleTap: (e)=>{
                const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewport.getTransform());
                const tl = (0, $855520c81dfcb96a$export$9b20165a36586806)(m, {
                    x: 0,
                    y: 0
                });
                const br = (0, $855520c81dfcb96a$export$9b20165a36586806)(m, {
                    x: this.project.width,
                    y: this.project.height
                });
                const isInside = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).isInsideRect({
                    x: e.relX,
                    y: e.relY
                }, {
                    x: tl.x,
                    y: tl.y,
                    width: br.x - tl.x,
                    height: br.y - tl.y
                });
                if (!this.isReset || isInside) this.resetOrZoom(e.relX, e.relY);
            },
            isInstant: true
        });
        let oldTransform = undefined;
        const pinchZoomer = new (0, $5ba93bbe34fd1582$export$d62358ac2d82abb3)({
            onPinch: (e)=>{
                if (e.type === 'move') {
                    if (!oldTransform) oldTransform = this.viewport.getTransform();
                    const metaTransform = (0, $bfc75b1b92419309$export$935bc53f7df03c95)(oldTransform, {
                        x: e.downRelX,
                        y: e.downRelY
                    });
                    metaTransform.scale *= e.scale;
                    metaTransform.viewportP.x += e.relX - e.downRelX;
                    metaTransform.viewportP.y += e.relY - e.downRelY;
                    this.viewport.setTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg));
                    this.requestRerender();
                    this.isReset = false;
                } else if (e.type === 'end') oldTransform = undefined;
            }
        });
        this.pointerChain = new (0, $3c485cff20ed4548$export$649a211db9812745)({
            chainArr: [
                pinchZoomer,
                doubleTapper
            ]
        });
        this.pointerChain.setChainOut((e)=>{
            if (e.button && [
                'left',
                'middle'
            ].includes(e.button) && e.type === 'pointermove') this.transformCanvas({
                type: 'translate',
                x: e.dX,
                y: e.dY
            });
        });
        this.viewport.getElement().classList.add($36bbe8d945937d2a$export$d7b7311ec04a3e8f);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.viewport.getElement(), {
            userSelect: 'none',
            touchAction: 'none'
        });
        this.viewport.getElement().addEventListener('touchend', (e)=>{
            e.preventDefault();
            return false;
        });
        this.viewport.getElement().addEventListener('contextmenu', (e)=>{
            e.preventDefault();
            return false;
        });
        this.viewport.getElement().addEventListener('dragstart', (e)=>{
            e.preventDefault();
            return false;
        });
        this.viewportPointerListener = new (0, $a07742141701d1f2$export$9371bd96776f4e82)({
            target: this.viewport.getElement(),
            onPointer: (e)=>{
                this.pointerChain.chainIn(e);
            },
            onWheel: this.onWheel,
            maxPointers: 2
        });
        this.viewport.getElement().addEventListener('wheel', (e)=>{
            e.preventDefault();
        });
        const svgRoot = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'svg'
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(svgRoot, {
            position: 'absolute',
            left: '0',
            top: '0',
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        });
        if (p.selection) {
            this.selectionRenderer = new (0, $af70c2e1b3c35649$export$c61ab90e0d3eb9b1)({
                transform: this.lastEmittedTransform,
                selection: p.selection,
                width: this.width,
                height: this.height
            });
            svgRoot.append(this.selectionRenderer.getElement());
        }
        if (p.hasEditMode) this.modeToggle = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                'edit',
                'hand'
            ].map((id)=>{
                var _p_editIcon;
                const el = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    className: 'dark-invert',
                    css: {
                        width: '28px',
                        height: '28px',
                        backgroundSize: 'contain',
                        margin: '5px',
                        backgroundImage: `url(${id === 'edit' ? (_p_editIcon = p.editIcon) !== null && _p_editIcon !== void 0 ? _p_editIcon : (0, (/*@__PURE__*/$parcel$interopDefault($12ab2cee238fdb68$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($071c8859c903033f$exports)))})`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }
                });
                return {
                    id: id,
                    label: el,
                    title: id === 'edit' ? (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-edit') : (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-hand')
                };
            }),
            initId: 'edit',
            onChange: (val)=>{
                p.onModeChange && p.onModeChange(val);
            }
        });
        // pointer-events: auto - So the canvas can be ignored, while the buttons still work.
        this.rootEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)({
            className: p.hasBorder === false ? undefined : $36bbe8d945937d2a$export$48c2d0f2f545ac27,
            css: {
                position: 'relative',
                zIndex: '0'
            }
        }, [
            this.viewport.getElement(),
            svgRoot,
            ...this.modeToggle ? [
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',pos-absolute,left-5,top-5,z-1,pointer-auto', [
                    this.modeToggle.getElement()
                ])
            ] : [],
            (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',pos-absolute,right-5,bottom-5,flex,flexCol,gap-5,z-1,pointer-auto', [
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)({
                    tagName: 'button',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('hand-reset'),
                    onClick: ()=>{
                        this.reset();
                    },
                    content: `<img alt="reset" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e4b592a73e1920d7$exports)))}">`,
                    noRef: true
                }),
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)({
                    tagName: 'button',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('zoom-in'),
                    onClick: ()=>{
                        const oldScale = this.viewport.getTransform().scale;
                        const newScale = (0, $b18d1bd8e7aad78b$export$8c03162b1a39d183)(oldScale, 1);
                        this.transformCanvas({
                            type: 'zoom',
                            fac: newScale / oldScale
                        });
                    },
                    content: `<img alt="zoom-in" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($4ae8ffb159df37c1$exports)))}">`,
                    noRef: true
                }),
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)({
                    tagName: 'button',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('zoom-out'),
                    onClick: ()=>{
                        const oldScale = this.viewport.getTransform().scale;
                        const newScale = (0, $b18d1bd8e7aad78b$export$8c03162b1a39d183)(oldScale, -1);
                        this.transformCanvas({
                            type: 'zoom',
                            fac: newScale / oldScale
                        });
                    },
                    content: `<img alt="zoom-out" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($c1f95fb9358806e5$exports)))}">`,
                    noRef: true
                })
            ])
        ]);
        this.renderLoop();
    }
}






var $2d3a7d1efb01840c$exports = {};
$2d3a7d1efb01840c$exports = $parcel$resolve("25BJB");






class $c5a9090dbc3ef918$export$40175a5948a88a57 {
    resetCrop() {
        this.cropRect = {
            x: 0,
            y: 0,
            width: this.canvas.width,
            height: this.canvas.height
        };
    }
    getViewportSelectionRect() {
        const transform = this.preview.getTransform();
        const mat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(transform);
        const p = (0, $855520c81dfcb96a$export$9b20165a36586806)(mat, this.cropRect);
        return {
            x: p.x,
            y: p.y,
            width: this.cropRect.width * transform.scale,
            height: this.cropRect.height * transform.scale
        };
    }
    async updateCroppedCanvas() {
        var _this_onChange, _this;
        this.croppedCanvas.width = Math.round(this.cropRect.width);
        this.croppedCanvas.height = Math.round(this.cropRect.height);
        const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.croppedCanvas);
        ctx.drawImage(this.canvas, Math.round(-this.cropRect.x), Math.round(-this.cropRect.y));
        const blob = await (0, $13d5aa49e37e2734$export$403d539f215df596)(this.croppedCanvas, 'image/png');
        this.croppedBlob = blob;
        if (this.croppedObjectUrl !== '') URL.revokeObjectURL(this.croppedObjectUrl);
        this.croppedObjectUrl = URL.createObjectURL(blob);
        if (this.croppedImageElement) this.croppedImageElement.src = this.croppedObjectUrl;
        (_this_onChange = (_this = this).onChange) === null || _this_onChange === void 0 ? void 0 : _this_onChange.call(_this, this.croppedCanvas.width, this.croppedCanvas.height);
    }
    updateSelectionRect() {
        var _this_onChange, _this;
        const rect = this.getViewportSelectionRect();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.selectionRectEl, {
            left: rect.x + 'px',
            top: rect.y + 'px',
            width: rect.width + 'px',
            height: rect.height + 'px',
            display: this.isReset() ? 'none' : ''
        });
        (_this_onChange = (_this = this).onChange) === null || _this_onChange === void 0 ? void 0 : _this_onChange.call(_this, Math.round(this.cropRect.width), Math.round(this.cropRect.height));
    }
    isReset() {
        return this.cropRect.x === 0 && this.cropRect.y === 0 && this.cropRect.width === this.canvas.width && this.cropRect.height === this.canvas.height;
    }
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    // in input canvas coordinates
    getCropRect() {
        return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.cropRect);
    }
    getCroppedCanvas() {
        return this.croppedCanvas;
    }
    // image/png blob
    getCroppedBlob() {
        return this.croppedBlob;
    }
    setCanvas(canvas) {
        this.canvas = canvas;
        this.previewLayer.image = canvas;
        this.updateCroppedCanvas();
        this.preview.render();
    }
    destroy() {
        if (this.croppedImageElement) this.croppedImageElement.src = '';
        URL.revokeObjectURL(this.croppedObjectUrl);
        this.rootEl.remove();
        this.eventTarget.style.removeProperty('width');
        this.eventTarget.style.removeProperty('height');
        this.keyListener.destroy();
        this.pointerListener.destroy();
        this.preview.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.cropRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        } // canvas coordinates
        ;
        this.mode = 'edit';
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-edit-crop-preview',
            css: {
                position: 'relative',
                height: p.height + 'px',
                width: p.width + 'px',
                overflow: 'hidden'
            }
        });
        if (p.onChange) this.onChange = p.onChange;
        this.canvas = p.canvas;
        if (p.init) this.cropRect = p.init;
        else this.resetCrop();
        const isInsideSelectionRect = (p)=>{
            return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).isInsideRect(p, this.getViewportSelectionRect());
        };
        this.croppedCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas();
        this.croppedBlob = {};
        this.croppedObjectUrl = '';
        this.eventTarget = this.croppedCanvas;
        if (p.enableRightClickCopy) {
            this.croppedImageElement = new Image();
            this.eventTarget = this.croppedImageElement;
        }
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.eventTarget, {
            height: p.height + 'px',
            width: p.width + 'px'
        });
        this.rootEl.append(this.eventTarget);
        this.updateCroppedCanvas();
        this.previewLayer = {
            image: p.canvas,
            opacity: 1,
            isVisible: true,
            mixModeStr: 'source-over',
            hasClipping: false
        };
        this.preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: p.width,
            height: p.height - 2,
            project: {
                width: p.canvas.width,
                height: p.canvas.height,
                layers: [
                    this.previewLayer
                ]
            },
            hasEditMode: true,
            onModeChange: (mode)=>{
                this.mode = mode;
                this.preview.getElement().style.pointerEvents = mode === 'edit' ? 'none' : '';
                this.rootEl.title = mode === 'edit' ? (0, $63d0b335c576c718$export$ce37e184d908d785)('crop-drag-to-crop') : '';
            },
            onTransformChange: ()=>this.updateSelectionRect(),
            padding: 20,
            hasBorder: false,
            editIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2d3a7d1efb01840c$exports)))
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.preview.getElement(), {
            position: 'absolute',
            left: '0',
            top: '0',
            overflow: 'hidden',
            pointerEvents: 'none'
        });
        this.preview.render();
        this.rootEl.append(this.preview.getElement());
        this.selectionRectEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.preview.getElement(),
            className: 'kl-edit-crop-preview__sel'
        });
        this.updateSelectionRect();
        //gen crop from viewport points
        const genCrop = (p1, p2)=>{
            const mat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.preview.getTransform());
            const inverseMat = (0, $077740f52fe6870e$export$70ae2c07e401031b)(mat);
            const topLeftP = {
                x: Math.min(p1.x, p2.x),
                y: Math.min(p1.y, p2.y)
            };
            const bottomRightP = {
                x: Math.max(p1.x, p2.x),
                y: Math.max(p1.y, p2.y)
            };
            const origTopLeftP = (0, $855520c81dfcb96a$export$9b20165a36586806)(inverseMat, topLeftP);
            const origBottomRightP = (0, $855520c81dfcb96a$export$9b20165a36586806)(inverseMat, bottomRightP);
            origTopLeftP.x = (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(Math.floor(origTopLeftP.x), 0, this.canvas.width);
            origTopLeftP.y = (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(Math.floor(origTopLeftP.y), 0, this.canvas.height);
            origBottomRightP.x = (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(Math.ceil(origBottomRightP.x), 0, this.canvas.width);
            origBottomRightP.y = (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(Math.ceil(origBottomRightP.y), 0, this.canvas.height);
            return {
                x: origTopLeftP.x,
                y: origTopLeftP.y,
                width: origBottomRightP.x - origTopLeftP.x,
                height: origBottomRightP.y - origTopLeftP.y
            };
        };
        let startP;
        let startCrop = null;
        let isDragging = false;
        let didMove = false;
        let updateCropTimeout;
        const pointerChain = new (0, $3c485cff20ed4548$export$649a211db9812745)({
            chainArr: [
                new (0, $68c13f25614f29c1$export$71ff2f51bf1f4062)()
            ]
        });
        pointerChain.setChainOut((event)=>{
            if (event.type === 'pointerdown' && event.button === 'left') {
                event.eventPreventDefault();
                isDragging = true;
                startP = {
                    x: event.relX,
                    y: event.relY
                };
                if (!this.isReset() && isInsideSelectionRect(startP)) startCrop = {
                    x: this.cropRect.x,
                    y: this.cropRect.y,
                    width: this.cropRect.width,
                    height: this.cropRect.height
                };
                else this.cropRect = genCrop(startP, startP);
            } else if (event.type === 'pointermove' && event.button === 'left') {
                event.eventPreventDefault();
                didMove = true;
                if (startCrop) {
                    const transform = this.preview.getTransform();
                    this.cropRect.x = startCrop.x + Math.round((event.relX - startP.x) / transform.scale);
                    this.cropRect.y = startCrop.y + Math.round((event.relY - startP.y) / transform.scale);
                    this.cropRect.x = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.x, 0, this.canvas.width - this.cropRect.width);
                    this.cropRect.y = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.y, 0, this.canvas.height - this.cropRect.height);
                } else this.cropRect = genCrop(startP, {
                    x: event.relX,
                    y: event.relY
                });
                this.updateSelectionRect();
            } else if (event.type === 'pointerup' && startP) {
                event.eventPreventDefault();
                isDragging = false;
                startCrop = null;
                startP = null;
                if (this.cropRect.width === 0 || this.cropRect.height === 0 || !didMove) {
                    this.resetCrop();
                    this.updateSelectionRect();
                }
                didMove = false;
                updateCropTimeout = setTimeout(()=>this.updateCroppedCanvas(), 1);
            }
        });
        this.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.eventTarget,
            fixScribble: true,
            onWheel: (event)=>{
                this.preview.onWheel(event);
            },
            onPointer: (event)=>{
                if (this.mode === 'hand') {
                    event.eventPreventDefault();
                    this.preview.onPointer(event);
                    return;
                }
                pointerChain.chainIn(event);
            },
            maxPointers: 2
        });
        this.keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
            onDown: (keyStr, e)=>{
                if (isDragging) return;
                let doUpdate = false;
                const transform = this.preview.getTransform();
                const stepSize = Math.max(1, 1 / transform.scale);
                const shiftIsPressed = this.keyListener.isPressed('shift');
                if (keyStr === 'left') {
                    if (shiftIsPressed) this.cropRect.width = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.width - stepSize, 1, this.canvas.width - this.cropRect.x);
                    else this.cropRect.x = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.x - stepSize, 0, this.canvas.width - this.cropRect.width);
                    doUpdate = true;
                }
                if (keyStr === 'right') {
                    if (shiftIsPressed) this.cropRect.width = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.width + stepSize, 1, this.canvas.width - this.cropRect.x);
                    else this.cropRect.x = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.x + stepSize, 0, this.canvas.width - this.cropRect.width);
                    doUpdate = true;
                }
                if (keyStr === 'up') {
                    if (shiftIsPressed) this.cropRect.height = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.height - stepSize, 1, this.canvas.height - this.cropRect.y);
                    else this.cropRect.y = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.y - stepSize, 0, this.canvas.height - this.cropRect.height);
                    doUpdate = true;
                }
                if (keyStr === 'down') {
                    if (shiftIsPressed) this.cropRect.height = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.height + stepSize, 1, this.canvas.height - this.cropRect.y);
                    else this.cropRect.y = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.cropRect.y + stepSize, 0, this.canvas.height - this.cropRect.height);
                    doUpdate = true;
                }
                if (doUpdate) {
                    e.preventDefault();
                    this.updateSelectionRect();
                    clearTimeout(updateCropTimeout);
                    updateCropTimeout = setTimeout(()=>this.updateCroppedCanvas(), 100);
                }
            }
        });
    }
}








function $b6390a4afb7d8067$export$a04a50ae6d6450f8(poly, type) {
    let x1;
    let y1;
    let x2;
    let y2;
    poly.forEach((poly)=>{
        poly.forEach((ring)=>{
            ring.forEach((p)=>{
                x1 = x1 === undefined ? p[0] : Math.min(x1, p[0]);
                y1 = y1 === undefined ? p[1] : Math.min(y1, p[1]);
                x2 = x2 === undefined ? p[0] : Math.max(x2, p[0]);
                y2 = y2 === undefined ? p[1] : Math.max(y2, p[1]);
            });
        });
    });
    if (x1 === undefined || y1 === undefined || x2 === undefined || y2 === undefined) throw new Error('empty MultiPolygon');
    const bounds = {
        type: 'coordinate',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
    return type === 'index' ? (0, $9414f5ea41e9cf25$export$b0036cbc597df324)(bounds) : bounds;
}




let $5e9fef22bb47992b$var$maskSelection = false;
function $5e9fef22bb47992b$export$32b89bc9bb92706a(parent, getFullCanvas, cropCallback, output, showCropButton, closeOnBlur = true, selection) {
    let clipboardItemIsSupported = false;
    try {
        clipboardItemIsSupported = !!ClipboardItem;
    } catch (e) {
    /* empty */ }
    const div = document.createElement('div');
    const isSmall = window.innerWidth < 550 || window.innerHeight < 550;
    const maskToggle = selection ? new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
        init: $5e9fef22bb47992b$var$maskSelection,
        label: (0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-mask'),
        name: 'check-mask-selection',
        css: {
            width: 'fit-content'
        },
        callback: (b)=>{
            $5e9fef22bb47992b$var$maskSelection = b;
            cropCopy.setCanvas(getFullCanvas(b));
        }
    }) : undefined;
    const topWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        content: [
            maskToggle === null || maskToggle === void 0 ? void 0 : maskToggle.getElement(),
            (0, $63d0b335c576c718$export$ce37e184d908d785)('crop-drag-to-crop') + (clipboardItemIsSupported ? '' : '<br>' + (0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-click-hold'))
        ],
        css: {
            textAlign: 'center'
        }
    });
    div.append(topWrapper);
    const fullCanvas = getFullCanvas($5e9fef22bb47992b$var$maskSelection);
    let init;
    if (selection) {
        const bounds = (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(selection, 'index');
        const boundsInCanvas = (0, $9414f5ea41e9cf25$export$ddc1c0069d484d49)(bounds, fullCanvas.width, fullCanvas.height);
        init = boundsInCanvas ? (0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)(boundsInCanvas) : undefined;
    }
    const cropCopy = new (0, $c5a9090dbc3ef918$export$40175a5948a88a57)({
        width: isSmall ? 340 : 540,
        height: isSmall ? 300 : 350,
        canvas: fullCanvas,
        enableRightClickCopy: true,
        init: init
    });
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(cropCopy.getElement(), {
        marginTop: '10px',
        marginLeft: '-20px'
    });
    div.append(cropCopy.getElement());
    async function toClipboard() {
        try {
            const blob = cropCopy.getCroppedBlob();
            await navigator.clipboard.write([
                new ClipboardItem({
                    [blob.type]: blob
                })
            ]);
            setTimeout(function() {
                output.out((0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-copied'), true);
            }, 200);
        } catch (err) {
            console.error(err.name, err.message);
            return;
        }
    }
    const keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
        onDown: function(keyStr, KeyEvent, comboStr) {
            if ([
                'ctrl+c',
                'cmd+c'
            ].includes(comboStr)) {
                toClipboard();
                closeFunc && closeFunc();
            }
        }
    });
    let closeFunc;
    function blur() {
        if (closeOnBlur) closeFunc === null || closeFunc === void 0 ? void 0 : closeFunc();
    }
    window.addEventListener('blur', blur);
    const buttonArr = [];
    if (clipboardItemIsSupported) buttonArr.push((0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-btn-copy'));
    if (showCropButton) buttonArr.push((0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-btn-crop'));
    buttonArr.push('Cancel');
    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
        message: '<b>' + (showCropButton ? `${(0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-title-copy')} / ${(0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-title-crop')}` : `${(0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-title-copy')}`) + '</b>',
        div: div,
        style: isSmall ? {} : {
            width: '540px'
        },
        buttons: buttonArr,
        primaries: [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-btn-copy')
        ],
        callback: function(result) {
            if (result === (0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-btn-copy')) toClipboard();
            else if (result === (0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-btn-crop')) {
                const rectObj = cropCopy.getCropRect();
                cropCallback({
                    left: Math.round(-rectObj.x),
                    right: Math.round(rectObj.x + rectObj.width - fullCanvas.width),
                    top: Math.round(-rectObj.y),
                    bottom: Math.round(rectObj.y + rectObj.height - fullCanvas.height)
                });
            }
            window.removeEventListener('blur', blur);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(cropCopy.getCroppedCanvas());
            cropCopy.destroy();
            keyListener.destroy();
        },
        clickOnEnter: (0, $63d0b335c576c718$export$ce37e184d908d785)('cropcopy-btn-copy'),
        closeFunc: function(func) {
            closeFunc = func;
        }
    });
}







/**
 * Set values in data within rect to 254, unless they're 255
 *
 * @param data Uint8Array
 * @param width int
 * @param x0 int
 * @param y0 int
 * @param x1 int >x0
 * @param y1 int >y0
 */ function $469fa98e1403db53$var$fillRect(data, width, x0, y0, x1, y1) {
    for(let x = x0; x <= x1; x++)for(let y = y0; y <= y1; y++){
        if (data[y * width + x] === 255) continue;
        data[y * width + x] = 254;
    }
}
// test, should fill, if there is a tolerance < 255
function $469fa98e1403db53$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, i) {
    return (srcArr[i * 4] - initR) ** 2 <= toleranceSquared && (srcArr[i * 4 + 1] - initG) ** 2 <= toleranceSquared && (srcArr[i * 4 + 2] - initB) ** 2 <= toleranceSquared && (srcArr[i * 4 + 3] - initA) ** 2 <= toleranceSquared;
}
// check is within selection
function $469fa98e1403db53$var$selectionMaskTest(selectionMaskArr, i) {
    return !selectionMaskArr || !!selectionMaskArr[i];
}
/**
 *
 * @param srcArr Uint8ClampedArray rgba
 * @param selectionMaskArr Uint8Array width x height, 0 or 1 values
 * @param targetArr Uint8Array
 * @param width int
 * @param height int
 * @param px int
 * @param py int
 * @param tolerance int 0 - 255
 * @param grow int >= 0
 * @param isContiguous boolean
 */ function $469fa98e1403db53$var$floodFill(srcArr, selectionMaskArr, targetArr, width, height, px, py, tolerance, grow, isContiguous) {
    const initR = srcArr[(py * width + px) * 4];
    const initG = srcArr[(py * width + px) * 4 + 1];
    const initB = srcArr[(py * width + px) * 4 + 2];
    const initA = srcArr[(py * width + px) * 4 + 3];
    const view = new DataView(srcArr.buffer);
    const init = view.getUint32((py * width + px) * 4, true);
    const toleranceSquared = tolerance ** 2;
    const bounds = {
        type: 'index',
        x1: px,
        y1: py,
        x2: px,
        y2: py
    };
    if (isContiguous) {
        const q = []; // queue of pixel indices. they are already filled.
        q.push(py * width + px); // starting pixel, where the user clicked to fill
        targetArr[py * width + px] = 255;
        let i, e;
        let x, y;
        while(q.length){
            // checks neighbors of queued pixels, fills, and queues them.
            // Adds to queue after filling it. Skip if was already filled.
            i = q.pop();
            y = Math.floor(i / width);
            x = i % width;
            if (x > 0) {
                // can go left
                e = i - 1;
                if (targetArr[e] !== 255 && $469fa98e1403db53$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $469fa98e1403db53$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.x1 = Math.min(bounds.x1, x - 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
            if (x < width - 1) {
                // can go right
                e = i + 1;
                if (targetArr[e] !== 255 && $469fa98e1403db53$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $469fa98e1403db53$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.x2 = Math.max(bounds.x2, x + 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
            if (y > 0) {
                // can go up
                e = i - width;
                if (targetArr[e] !== 255 && $469fa98e1403db53$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $469fa98e1403db53$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.y1 = Math.min(bounds.y1, y - 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
            if (y < height - 1) {
                // can go down
                e = i + width;
                if (targetArr[e] !== 255 && $469fa98e1403db53$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $469fa98e1403db53$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.y2 = Math.max(bounds.y2, y + 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
        }
    } else // not contiguous
    for(let y = 0, i = 0; y < height; y++){
        for(let x = 0; x < width; x++, i++)if ($469fa98e1403db53$var$selectionMaskTest(selectionMaskArr, i) && (view.getUint32(i * 4, true) === init || tolerance > 0 && $469fa98e1403db53$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, i))) {
            targetArr[i] = 255;
            if (x < bounds.x1) bounds.x1 = x;
            if (y < bounds.y1) bounds.y1 = y;
            if (x > bounds.x2) bounds.x2 = x;
            if (y > bounds.y2) bounds.y2 = y;
        }
    }
    if (grow === 0) return bounds;
    // --- grow ---
    // how does it grow? it finds all pixel at the edge.
    // then depending on what kind of edge it is, it draws a rectangle into target
    // In the rectangle each pixel has the value 254, or else it will mess it all up.
    // after it's all done, replaces it with 255
    let x0, x1, y0, y1;
    let l, tl, t, tr, r, br, b, bl; // left, top left, top, top right, etc.
    for(let x = bounds.x1; x <= bounds.x2; x++)for(let y = bounds.y1; y <= bounds.y2; y++){
        if (targetArr[y * width + x] !== 255) continue;
        // bounds of rectangle
        x0 = x;
        x1 = x;
        y0 = y;
        y1 = y;
        l = targetArr[y * width + x - 1] !== 255;
        tl = targetArr[(y - 1) * width + x - 1] !== 255;
        t = targetArr[(y - 1) * width + x] !== 255;
        tr = targetArr[(y - 1) * width + x + 1] !== 255;
        r = targetArr[y * width + x + 1] !== 255;
        br = targetArr[(y + 1) * width + x + 1] !== 255;
        b = targetArr[(y + 1) * width + x] !== 255;
        bl = targetArr[(y + 1) * width + x - 1] !== 255;
        if (l) // left
        x0 = x - grow;
        if (l && tl && t) {
            // top left
            x0 = x - grow;
            y0 = y - grow;
        }
        if (t) // top
        y0 = Math.min(y0, y - grow);
        if (t && tr && r) {
            // top right
            y0 = Math.min(y0, y - grow);
            x1 = x + grow;
        }
        if (r) // right
        x1 = Math.max(x1, x + grow);
        if (r && br && b) {
            // bottom right
            x1 = Math.max(x1, x + grow);
            y1 = Math.max(y1, y + grow);
        }
        if (b) // bottom
        y1 = Math.max(y1, y + grow);
        if (b && bl && l) {
            // bottom left
            x0 = Math.min(x0, x - grow);
            y1 = Math.max(y1, y + grow);
        }
        if (!l && !tl && !t && !tr && !r && !br && !b && !bl) continue;
        $469fa98e1403db53$var$fillRect(targetArr, width, Math.max(0, x0), Math.max(0, y0), Math.min(width - 1, x1), Math.min(height - 1, y1));
    }
    for(let i = 0; i < width * height; i++)if (targetArr[i] === 254) targetArr[i] = 255;
    // expand bounds by grow
    bounds.x1 -= grow;
    bounds.y1 -= grow;
    bounds.x2 += grow;
    bounds.y2 += grow;
    return bounds;
}
function $469fa98e1403db53$export$13d50f258a8034f(rgbaArr, // width x height, 0 or 1 values
selectionMaskArr, width, height, x, y, tolerance, grow, isContiguous) {
    x = Math.round(x); // just in case
    y = Math.round(y);
    const resultArr = new Uint8Array(new ArrayBuffer(width * height));
    const bounds = $469fa98e1403db53$var$floodFill(rgbaArr, selectionMaskArr, resultArr, width, height, x, y, tolerance, grow, isContiguous);
    return {
        data: resultArr,
        bounds: bounds
    };
}





function $182738d3ab29089b$export$5dd60a54dd55622(bounds, transform) {
    const p1 = (0, $855520c81dfcb96a$export$9b20165a36586806)(transform, {
        x: bounds.x1,
        y: bounds.y1
    });
    const p2 = (0, $855520c81dfcb96a$export$9b20165a36586806)(transform, {
        x: bounds.x2,
        y: bounds.y1
    });
    const p3 = (0, $855520c81dfcb96a$export$9b20165a36586806)(transform, {
        x: bounds.x2,
        y: bounds.y2
    });
    const p4 = (0, $855520c81dfcb96a$export$9b20165a36586806)(transform, {
        x: bounds.x1,
        y: bounds.y2
    });
    return {
        type: 'coordinate',
        x1: Math.min(p1.x, p2.x, p3.x, p4.x),
        y1: Math.min(p1.y, p2.y, p3.y, p4.y),
        x2: Math.max(p1.x, p2.x, p3.x, p4.x),
        y2: Math.max(p1.y, p2.y, p3.y, p4.y)
    };
}





class $583d130d11db85ad$export$27550cc14d7ae85a {
    onDown(x, y, angleRad) {
        this.downX = x;
        this.downY = y;
        this.downAngleRad = angleRad;
    }
    onMove(x, y) {
        this.onShape(false, this.downX, this.downY, x, y, this.downAngleRad);
    }
    onUp(x, y) {
        this.onShape(true, this.downX, this.downY, x, y, this.downAngleRad);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.downX = 0;
        this.downY = 0;
        this.downAngleRad = 0;
        this.onShape = p.onShape;
    }
}
function $583d130d11db85ad$export$71b514a25c47df50(ctx, shapeObj, selectionPath) {
    shapeObj = (0, $0616f0a0655c1023$export$71511d61b312f219)({
        // defaults
        angleRad: 0,
        isOutwards: false,
        opacity: 1,
        isEraser: false,
        doLockAlpha: false
    }, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(shapeObj));
    let bounds = {
        type: 'coordinate',
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
    };
    if ([
        'rect',
        'ellipse',
        'line'
    ].includes(shapeObj.type)) {
        if (shapeObj.angleRad === undefined) throw new Error('angleRad undefined');
        const lineWidth = shapeObj.lineWidth === undefined ? -1 : Math.round(shapeObj.lineWidth);
        const angleDeg = shapeObj.angleRad * 180 / Math.PI;
        // --- prep color ---
        if (!shapeObj.isEraser && shapeObj.fillRgb === undefined && shapeObj.strokeRgb === undefined) throw new Error('fillRgb and strokeRgb undefined');
        const colorRgb = shapeObj.isEraser ? {
            r: 255,
            g: 255,
            b: 255
        } : shapeObj.fillRgb ? shapeObj.fillRgb : shapeObj.strokeRgb;
        // --- prep canvas ---
        ctx.save();
        selectionPath && ctx.clip(selectionPath);
        if (shapeObj.opacity) ctx.globalAlpha = shapeObj.opacity;
        if (shapeObj.isEraser) ctx.globalCompositeOperation = 'destination-out';
        if (shapeObj.doLockAlpha) ctx.globalCompositeOperation = 'source-atop';
        const transformation = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(-shapeObj.angleRad));
        ctx.setTransform(...(0, $974f651610599156$export$2b60e7dafdbde18a)(transformation));
        if (shapeObj.fillRgb) ctx.fillStyle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(colorRgb);
        else if (shapeObj.strokeRgb) {
            ctx.strokeStyle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(colorRgb);
            ctx.lineWidth = lineWidth;
        }
        let x1 = shapeObj.x1;
        let y1 = shapeObj.y1;
        let x2 = shapeObj.x2;
        let y2 = shapeObj.y2;
        // --- angle snapping ---
        if (shapeObj.isAngleSnap) {
            const r1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(x1, y1, shapeObj.angleRad / Math.PI * 180);
            const r2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(x2, y2, shapeObj.angleRad / Math.PI * 180);
            const pAngleDeg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).pointsToAngleDeg(r1, r2) + 90;
            const pAngleDegSnapped = Math.round(pAngleDeg / 45) * 45;
            const rotated = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotateAround({
                x: x1,
                y: y1
            }, {
                x: x2,
                y: y2
            }, pAngleDegSnapped - pAngleDeg);
            x2 = rotated.x;
            y2 = rotated.y;
            // needs to be perfect if p1->p2 aligns with canvas x- or y-axis
            if ((angleDeg + pAngleDegSnapped) % 90 === 0) {
                if (Math.round((angleDeg - pAngleDegSnapped) / 90) % 2 === 0) // up or down
                x2 = x1;
                else // left or right
                y2 = y1;
            }
        }
        let x = x1;
        let y = y1;
        let dX = x2 - x1;
        let dY = y2 - y1;
        // --- 1:1 ratio ---
        if (shapeObj.type !== 'line' && shapeObj.isFixedRatio) {
            let r1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(shapeObj.x1, shapeObj.y1, shapeObj.angleRad / Math.PI * 180);
            let r2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(shapeObj.x2, shapeObj.y2, shapeObj.angleRad / Math.PI * 180);
            const rx = r1.x;
            const ry = r1.y;
            let rdX = r2.x - r1.x;
            let rdY = r2.y - r1.y;
            if (Math.abs(rdX) < Math.abs(rdY)) rdY = Math.abs(rdX) * (rdY < 0 ? -1 : 1);
            else rdX = Math.abs(rdY) * (rdX < 0 ? -1 : 1);
            r2.x = rx + rdX;
            r2.y = ry + rdY;
            r1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(r1.x, r1.y, -shapeObj.angleRad / Math.PI * 180);
            r2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(r2.x, r2.y, -shapeObj.angleRad / Math.PI * 180);
            x1 = r1.x;
            y1 = r1.y;
            x2 = r2.x;
            y2 = r2.y;
            x = x1;
            y = y1;
            dX = x2 - x1;
            dY = y2 - y1;
        }
        // outwards modifier
        if (shapeObj.isOutwards) {
            x -= dX;
            y -= dY;
            dX *= 2;
            dY *= 2;
            x1 = x;
            y1 = y;
            x2 = x + dX;
            y2 = y + dY;
        }
        let p1;
        let p2;
        if (shapeObj.type === 'line') {
            // --- line ---
            // rounded
            const x1r = Math.round(x1);
            const y1r = Math.round(y1);
            const x2r = Math.round(x2);
            const y2r = Math.round(y2);
            // floored
            const x1f = Math.floor(x1);
            const y1f = Math.floor(y1);
            const x2f = Math.floor(x2);
            const y2f = Math.floor(y2);
            if (lineWidth % 2 === 0) {
                if (y1r === y2r) {
                    p1 = {
                        x: x1f,
                        y: y1r
                    };
                    p2 = {
                        x: x2f,
                        y: y2r
                    };
                    if (x1f < x2f) p2.x += 1;
                    else p1.x += 1;
                } else if (x1r === x2r) {
                    p1 = {
                        x: x1r,
                        y: y1f
                    };
                    p2 = {
                        x: x2r,
                        y: y2f
                    };
                    if (y1f < y2f) p2.y += 1;
                    else p1.y += 1;
                } else {
                    p1 = {
                        x: x1,
                        y: y1
                    };
                    p2 = {
                        x: x2,
                        y: y2
                    };
                }
            } else {
                p1 = {
                    x: x1f,
                    y: y1f
                };
                p2 = {
                    x: x2f,
                    y: y2f
                };
                if (y1f === y2f) {
                    if (x1f < x2f) p2.x += 1;
                    else p1.x += 1;
                    p1.y += 0.5;
                    p2.y += 0.5;
                } else if (x1f === x2f) {
                    if (y1f < y2f) p2.y += 1;
                    else p1.y += 1;
                    p1.x += 0.5;
                    p2.x += 0.5;
                } else {
                    p1.x = x1;
                    p1.y = y1;
                    p2.x = x2;
                    p2.y = y2;
                }
            }
            bounds = {
                type: 'coordinate',
                x1: Math.min(p1.x, p2.x) - lineWidth / 2,
                y1: Math.min(p1.y, p2.y) - lineWidth / 2,
                x2: Math.max(p1.x, p2.x) + lineWidth / 2,
                y2: Math.max(p1.y, p2.y) + lineWidth / 2
            };
            p1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(p1.x, p1.y, shapeObj.angleRad / Math.PI * 180);
            p2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(p2.x, p2.y, shapeObj.angleRad / Math.PI * 180);
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
        } else if (shapeObj.type === 'rect') {
            // --- rect ---
            // floored
            const x1f = Math.floor(x1);
            const y1f = Math.floor(y1);
            const x2f = Math.floor(x2);
            const y2f = Math.floor(y2);
            if (angleDeg % 90 === 0) {
                if (shapeObj.fillRgb) {
                    if (x1 % 1 === 0) x1 += 1;
                    if (y1 % 1 === 0) y1 += 1;
                    if (x2 % 1 === 0) x2 += 1;
                    if (y2 % 1 === 0) y2 += 1;
                    p1 = {
                        x: x1 < x2 ? x1f : x2f,
                        y: y1 < y2 ? y1f : y2f
                    };
                    p2 = {
                        x: Math.ceil((x1 < x2 ? x2 : x1) - p1.x),
                        y: Math.ceil((y1 < y2 ? y2 : y1) - p1.y)
                    };
                    p2.x = p1.x + p2.x;
                    p2.y = p1.y + p2.y;
                } else if (lineWidth % 2 === 0) {
                    p1 = {
                        x: x1f,
                        y: y1f
                    };
                    p2 = {
                        x: x2f,
                        y: y2f
                    };
                } else {
                    p1 = {
                        x: x1f + 0.5,
                        y: y1f + 0.5
                    };
                    p2 = {
                        x: x2f + 0.5,
                        y: y2f + 0.5
                    };
                }
            } else {
                p1 = {
                    x: x1,
                    y: y1
                };
                p2 = {
                    x: x2,
                    y: y2
                };
            }
            p1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(p1.x, p1.y, shapeObj.angleRad / Math.PI * 180);
            p2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(p2.x, p2.y, shapeObj.angleRad / Math.PI * 180);
            const rect = {
                x: p1.x,
                y: p1.y,
                width: p2.x - p1.x,
                height: p2.y - p1.y
            };
            const padding = shapeObj.fillRgb ? 0 : lineWidth / 2;
            bounds = (0, $182738d3ab29089b$export$5dd60a54dd55622)({
                type: 'coordinate',
                x1: Math.min(p1.x, p2.x) - padding,
                y1: Math.min(p1.y, p2.y) - padding,
                x2: Math.max(p1.x, p2.x) + padding,
                y2: Math.max(p1.y, p2.y) + padding
            }, transformation);
            if (shapeObj.fillRgb) ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
            else ctx.strokeRect(rect.x, rect.y, rect.width, rect.height);
        } else {
            // --- circle ---
            p1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(x1, y1, shapeObj.angleRad / Math.PI * 180);
            p2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(x2, y2, shapeObj.angleRad / Math.PI * 180);
            x = p1.x;
            y = p1.y;
            dX = p2.x - p1.x;
            dY = p2.y - p1.y;
            const center = {
                x: x + dX / 2,
                y: y + dY / 2
            };
            const rX = Math.abs(dX / 2);
            const rY = Math.abs(dY / 2);
            ctx.beginPath();
            ctx.ellipse(center.x, center.y, rX, rY, 0, 0, Math.PI * 2);
            if (shapeObj.fillRgb) ctx.fill();
            else ctx.stroke();
            const padding = shapeObj.fillRgb ? 0 : lineWidth / 2;
            // bounds are bigger than they need to be when it's rotated and rX ~ rY. should be good enough though.
            bounds = (0, $182738d3ab29089b$export$5dd60a54dd55622)({
                type: 'coordinate',
                x1: center.x - rX - padding,
                y1: center.y - rY - padding,
                x2: center.x + rX + padding,
                y2: center.y + rY + padding
            }, transformation);
        }
        ctx.restore();
    } else throw new Error('unknown shape');
    return (0, $9414f5ea41e9cf25$export$b0036cbc597df324)(bounds);
}



// accurately represents the bounds of the text, even it's fancy Zalgo text that tries to break layout
function $67e715fe604c9329$var$textMetricToRect(metrics, align) {
    const ascent = metrics.actualBoundingBoxAscent;
    const descent = metrics.actualBoundingBoxDescent;
    const left = metrics.actualBoundingBoxLeft;
    const right = metrics.actualBoundingBoxRight;
    const width = right + left; // More accurate width calculation considering left/right bounds
    const height = ascent + descent;
    if (align === 'left') return {
        x: -left,
        y: -ascent,
        width: width,
        height: height
    };
    if (align === 'right') return {
        x: -width,
        y: -ascent,
        width: width,
        height: height
    };
    // center
    return {
        x: -left,
        y: -ascent,
        width: width,
        height: height
    };
}
function $67e715fe604c9329$export$482c90f94eb9717c(canvas, p, selectionPath) {
    p = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(p);
    // setup context
    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
    ctx.save();
    selectionPath && ctx.clip(selectionPath);
    ctx.textAlign = p.align;
    ctx.letterSpacing = p.letterSpacing ? p.letterSpacing + 'px' : '0';
    // font
    const fontArr = [
        p.size + 'px ' + (p.font ? p.font : 'sans-serif')
    ];
    if (p.isBold) fontArr.unshift('bold');
    if (p.isItalic) fontArr.unshift('italic');
    ctx.font = fontArr.join(' ');
    // fill
    ctx.fillStyle = p.fill ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(p.fill.color) : 'transparent';
    // stroke
    ctx.strokeStyle = p.stroke ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(p.stroke.color) : 'transparent';
    if (p.stroke) {
        ctx.lineWidth = p.stroke.lineWidth;
        ctx.lineJoin = 'round';
    }
    ctx.translate(p.x, p.y);
    ctx.rotate(-p.angleRad);
    const lines = p.text.split('\n').map((line)=>line.replaceAll('\t', '    '));
    // bounds
    const bounds = {
        type: 'index',
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
    };
    {
        let isFirst = true;
        lines.forEach((line, lineIndex)=>{
            const metrics = ctx.measureText(line);
            const x = 0;
            var _p_lineHeight;
            const y = p.size * ((_p_lineHeight = p.lineHeight) !== null && _p_lineHeight !== void 0 ? _p_lineHeight : 1) * lineIndex;
            const mRect = $67e715fe604c9329$var$textMetricToRect(metrics, p.align);
            if (isFirst) {
                isFirst = false;
                bounds.x1 = x + mRect.x;
                bounds.y1 = y + mRect.y;
                bounds.x2 = x + mRect.x + mRect.width - 1;
                bounds.y2 = y + mRect.y + mRect.height - 1;
            } else {
                bounds.x1 = Math.min(bounds.x1, x + mRect.x);
                bounds.y1 = Math.min(bounds.y1, y + mRect.y);
                bounds.x2 = Math.max(bounds.x2, x + mRect.x + mRect.width - 1);
                bounds.y2 = Math.max(bounds.y2, y + mRect.y + mRect.height - 1);
            }
        });
    }
    // draw stroke
    lines.forEach((line, lineIndex)=>{
        const x = 0;
        var _p_lineHeight;
        const y = p.size * ((_p_lineHeight = p.lineHeight) !== null && _p_lineHeight !== void 0 ? _p_lineHeight : 1) * lineIndex;
        ctx.strokeText(line, x, y);
    });
    // draw fill
    lines.forEach((line, lineIndex)=>{
        const x = 0;
        var _p_lineHeight;
        const y = p.size * ((_p_lineHeight = p.lineHeight) !== null && _p_lineHeight !== void 0 ? _p_lineHeight : 1) * lineIndex;
        ctx.fillText(line, x, y);
    });
    ctx.restore();
    return {
        x: bounds.x1,
        y: bounds.y1,
        width: bounds.x2 - bounds.x1,
        height: bounds.y2 - bounds.y1
    };
}








/**
 * Draw a single layer's image content to the given context.
 * Does NOT apply opacity or blend mode — caller is responsible for those.
 */ function $2b8bf7b32e5ba51f$var$drawLayerImage(targetCtx, layer, w, h, pixelated) {
    if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(layer.image)) {
        targetCtx.fillStyle = layer.image.fill;
        targetCtx.fillRect(0, 0, w, h);
    } else if (layer.image instanceof Array) throw new Error('drawProject: tile arrays not supported here');
    else {
        if (pixelated) targetCtx.imageSmoothingEnabled = false;
        targetCtx.drawImage(layer.image, 0, 0, w, h);
    }
}
function $2b8bf7b32e5ba51f$export$5f63a7b18dc4503a(project, factor, selection) {
    const w = Math.max(1, Math.round(project.width * factor));
    const h = Math.max(1, Math.round(project.height * factor));
    const pixelated = factor > 1;
    const resultCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
    const transformedSelection = selection ? (0, $1d9e27e0466b80f7$export$aa391dbbf8073422)(selection, (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(w / project.width, h / project.height)) : undefined;
    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(resultCanvas);
    ctx.save();
    if (transformedSelection) ctx.clip((0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(transformedSelection));
    const layers = project.layers;
    // Walk layers bottom → top, grouping clipped layers with their base.
    let i = 0;
    while(i < layers.length){
        const baseLayer = layers[i];
        // Collect consecutive clipped layers directly above this base
        const clippedLayers = [];
        let j = i + 1;
        while(j < layers.length && layers[j].isClipped){
            clippedLayers.push(layers[j]);
            j++;
        }
        i = j;
        if (!baseLayer.isVisible || baseLayer.opacity === 0) continue;
        if (clippedLayers.length === 0) {
            // ── Simple layer ──
            ctx.globalAlpha = baseLayer.opacity;
            var _baseLayer_mixModeStr;
            ctx.globalCompositeOperation = (_baseLayer_mixModeStr = baseLayer.mixModeStr) !== null && _baseLayer_mixModeStr !== void 0 ? _baseLayer_mixModeStr : 'source-over';
            $2b8bf7b32e5ba51f$var$drawLayerImage(ctx, baseLayer, w, h, pixelated);
            ctx.globalAlpha = 1;
            ctx.globalCompositeOperation = 'source-over';
        } else {
            // ── Clipping group ──
            // Draw base at full alpha so we can use it as a mask for all clipped layers.
            const baseCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
            const baseCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(baseCanvas);
            $2b8bf7b32e5ba51f$var$drawLayerImage(baseCtx, baseLayer, w, h, pixelated);
            // Start the group with the base content.
            const groupCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
            const groupCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(groupCanvas);
            groupCtx.drawImage(baseCanvas, 0, 0);
            // Each clipped layer: render → clip by base alpha → blend into group.
            for (const clipLayer of clippedLayers){
                if (!clipLayer.isVisible || clipLayer.opacity === 0) continue;
                const clipCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
                const clipCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(clipCanvas);
                $2b8bf7b32e5ba51f$var$drawLayerImage(clipCtx, clipLayer, w, h, pixelated);
                // Clip to base alpha
                clipCtx.globalCompositeOperation = 'destination-in';
                clipCtx.globalAlpha = 1;
                clipCtx.drawImage(baseCanvas, 0, 0);
                // Blend into group
                groupCtx.globalAlpha = clipLayer.opacity;
                var _clipLayer_mixModeStr;
                groupCtx.globalCompositeOperation = (_clipLayer_mixModeStr = clipLayer.mixModeStr) !== null && _clipLayer_mixModeStr !== void 0 ? _clipLayer_mixModeStr : 'source-over';
                groupCtx.drawImage(clipCanvas, 0, 0);
                groupCtx.globalAlpha = 1;
                groupCtx.globalCompositeOperation = 'source-over';
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(clipCanvas);
            }
            // Composite the whole group onto the result at the base's blend mode/opacity.
            ctx.globalAlpha = baseLayer.opacity;
            var _baseLayer_mixModeStr1;
            ctx.globalCompositeOperation = (_baseLayer_mixModeStr1 = baseLayer.mixModeStr) !== null && _baseLayer_mixModeStr1 !== void 0 ? _baseLayer_mixModeStr1 : 'source-over';
            ctx.drawImage(groupCanvas, 0, 0);
            ctx.globalAlpha = 1;
            ctx.globalCompositeOperation = 'source-over';
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(baseCanvas);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(groupCanvas);
        }
    }
    ctx.restore();
    return resultCanvas;
}






class $64881aa9f7f8f596$export$74d12f09ff9f1956 {
    onDown(x, y, angleRad) {
        this.downX = x;
        this.downY = y;
        this.downAngleRad = angleRad;
    }
    onMove(x, y) {
        this.onGradient(false, this.downX, this.downY, x, y, this.downAngleRad);
    }
    onUp(x, y) {
        this.onGradient(true, this.downX, this.downY, x, y, this.downAngleRad);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.downX = 0;
        this.downY = 0;
        this.downAngleRad = 0;
        this.onGradient = p.onGradient;
    }
}
function $64881aa9f7f8f596$export$b1f70a113e3b5c1b(ctx, gradientObj, selectionPath) {
    ctx.save();
    selectionPath && ctx.clip(selectionPath);
    const x1 = gradientObj.x1;
    const y1 = gradientObj.y1;
    let x2 = gradientObj.x2;
    let y2 = gradientObj.y2;
    if (gradientObj.doSnap) {
        const angleDeg = gradientObj.angleRad * 180 / Math.PI;
        const r1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(x1, y1, gradientObj.angleRad / Math.PI * 180);
        const r2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(x2, y2, gradientObj.angleRad / Math.PI * 180);
        const pAngleDeg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).pointsToAngleDeg(r1, r2) + 90;
        const pAngleDegSnapped = Math.round(pAngleDeg / 45) * 45;
        const rotated = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotateAround({
            x: x1,
            y: y1
        }, {
            x: x2,
            y: y2
        }, pAngleDegSnapped - pAngleDeg);
        x2 = rotated.x;
        y2 = rotated.y;
        // needs to be perfect if p1->p2 aligns with canvas x- or y-axis
        if ((angleDeg + pAngleDegSnapped) % 90 === 0) {
            if (Math.round((angleDeg - pAngleDegSnapped) / 90) % 2 === 0) // up or down
            x2 = x1;
            else // left or right
            y2 = y1;
        }
    }
    let baseColor = gradientObj.color1;
    if (gradientObj.isEraser && gradientObj.doLockAlpha) baseColor = {
        r: 255,
        g: 255,
        b: 255
    };
    let color1 = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, baseColor), {
        a: gradientObj.opacity
    });
    let color2 = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, baseColor), {
        a: 0
    });
    if (gradientObj.isReversed) {
        const temp = color1;
        color1 = color2;
        color2 = temp;
    }
    let gradient;
    if (gradientObj.type === 'linear') {
        gradient = ctx.createLinearGradient(x1, y1, x2, y2);
        gradient.addColorStop(0, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(color1));
        gradient.addColorStop(1, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(color2));
    } else if (gradientObj.type === 'linear-mirror') {
        const d = {
            x: x2 - x1,
            y: y2 - y1
        };
        gradient = ctx.createLinearGradient(x1 - d.x, y1 - d.y, x2, y2);
        gradient.addColorStop(0, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(color2));
        gradient.addColorStop(0.5, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(color1));
        gradient.addColorStop(1, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(color2));
    } else if (gradientObj.type === 'radial') {
        const r = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.dist({
            x: x1,
            y: y1
        }, {
            x: x2,
            y: y2
        });
        gradient = ctx.createRadialGradient(x1, y1, 0, x1, y1, r);
        gradient.addColorStop(0, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(color1));
        gradient.addColorStop(1, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr(color2));
    }
    ctx.fillStyle = gradient;
    if (gradientObj.isEraser) ctx.globalCompositeOperation = 'destination-out';
    if (gradientObj.doLockAlpha) ctx.globalCompositeOperation = 'source-atop';
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.restore();
}










let $07b32ff703dd0314$var$layerId = 0;
function $07b32ff703dd0314$export$b2ce7a8a096070e2() {
    return '' + $07b32ff703dd0314$var$layerId++;
}



function $ad14059c4ef400ae$export$9a1731baa7701cc7(width, height, fill) {
    const result = [];
    const tilesX = Math.ceil(width / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
    const tilesY = Math.ceil(height / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
    for(let y = 0; y < tilesY; y++)for(let x = 0; x < tilesX; x++)result.push({
        fill: fill
    });
    return result;
}




function $a57b9cfc6d913e03$export$87eabc555ccfbb9f(a, b) {
    if (a.index > b.index) return 1;
    if (a.index < b.index) return -1;
    return 0;
}



function $44d5e766b59f1f60$var$applyTilesToCanvas(canvas, context, tiles, tilesPerX, prevTiles) {
    tiles.forEach((item, index)=>{
        if (prevTiles && item === prevTiles[index]) return;
        const x = index % tilesPerX;
        const y = Math.floor(index / tilesPerX);
        if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(item)) {
            context.save();
            context.fillStyle = item.fill;
            context.clearRect(x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
            context.fillRect(x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
            context.restore();
        } else if (item) context.putImageData(item.data, x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
    });
}
function $44d5e766b59f1f60$export$cee5b735b1b9bad1(layers, before, after) {
    const sizeDidChange = before.size.width !== after.size.width || before.size.height !== after.size.height;
    return Object.entries(after.layerMap).map(([id, composedAfterLayer])=>{
        let canvas = {};
        let context = {};
        const composedBeforeLayer = before.layerMap[id];
        const tilesPerX = Math.ceil(after.size.width / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
        if (sizeDidChange || !composedBeforeLayer) {
            // create new canvas
            canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(after.size.width, after.size.height);
            context = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
            composedAfterLayer.tiles.forEach((item, index)=>{
                const x = index % tilesPerX;
                const y = Math.floor(index / tilesPerX);
                if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(item)) {
                    context.save();
                    context.fillStyle = item.fill;
                    context.fillRect(x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
                    context.restore();
                } else context.putImageData(item.data, x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
            });
        } else {
            canvas = layers[composedBeforeLayer.index].canvas;
            context = layers[composedBeforeLayer.index].context;
            composedAfterLayer.tiles.forEach((item, index)=>{
                if (item === composedBeforeLayer.tiles[index]) // todo more advanced check ^
                return;
                const x = index % tilesPerX;
                const y = Math.floor(index / tilesPerX);
                if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(item)) {
                    context.save();
                    context.fillStyle = item.fill;
                    context.clearRect(x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
                    context.fillRect(x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
                    context.restore();
                } else context.putImageData(item.data, x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
            });
        }
        return {
            id: id,
            index: composedAfterLayer.index,
            name: composedAfterLayer.name,
            mixModeStr: composedAfterLayer.mixModeStr,
            isVisible: composedAfterLayer.isVisible,
            opacity: composedAfterLayer.opacity,
            canvas: canvas,
            context: context,
            isClipped: composedAfterLayer.isClipped || undefined
        };
    }).sort((0, $a57b9cfc6d913e03$export$87eabc555ccfbb9f));
}


function $791a43fc2c5e07f3$export$e173233eae155bba(entry, layerId) {
    const keys = Object.keys(entry);
    if (keys.length !== 1 || !entry.layerMap) return false;
    const ids = Object.keys(entry.layerMap);
    for(let i = 0; i < ids.length; i++){
        const id = ids[i];
        const layer = entry.layerMap[id];
        if (id === layerId) {
            const layerKeys = Object.keys(layer);
            if (layerKeys.length !== 1 || layerKeys[0] !== 'opacity') return false;
        } else {
            const layerKeys = Object.keys(layer);
            if (layerKeys.length > 0) return false;
        }
    }
    return true;
}


function $17c16cc75e4c1e0d$export$b706b44cfdbaaa7d(entry, layerId) {
    const keys = Object.keys(entry);
    if (keys.length !== 1 || !entry.layerMap) return false;
    const ids = Object.keys(entry.layerMap);
    for(let i = 0; i < ids.length; i++){
        const id = ids[i];
        const layer = entry.layerMap[id];
        if (id === layerId) {
            const layerKeys = Object.keys(layer);
            if (layerKeys.length !== 1 || layerKeys[0] !== 'isVisible') return false;
        } else {
            const layerKeys = Object.keys(layer);
            if (layerKeys.length > 0) return false;
        }
    }
    return true;
}






function $536e5ff7428d1419$export$6b742be78fc940fb(canvas, col, row, tileSize) {
    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
    const width = Math.min(canvas.width, (col + 1) * tileSize) - col * tileSize;
    const height = Math.min(canvas.height, (row + 1) * tileSize) - row * tileSize;
    if (width <= 0 || height <= 0) throw new Error('invalid out-of-bounds tile');
    /*
        NS_ERROR_FAILURE & NS_ERROR_OUT_OF_MEMORY
        Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:148.0) Gecko/20100101 Firefox/148.0
        Probably out of memory judging by https://searchfox.org/firefox-main/source/dom/canvas/CanvasRenderingContext2D.cpp
        I am able to force NS_ERROR_FAILURE with 83GB worth of canvas elements (32gb ram).
        Maybe a memory leak?
     */ /*
        Uncaught SecurityError: Failed to execute 'getImageData' on 'CanvasRenderingContext2D': The canvas has been tainted by cross-origin data.
        Mozilla/5.0 (X11; CrOS x86_64 14541.0.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36
        -> no idea how this was achieved. Tried importing svg with cross-origin content. Did not result in that exception
     */ // Exception: InvalidStateError: The object is in an invalid state.
    return (0, $13d5aa49e37e2734$export$f84fa3da4a94c138)(ctx, col * tileSize, row * tileSize, width, height);
}





function $b37280925142c567$export$2098fe43203ddd32(bounds, width, height, tileSize = (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6)) {
    // ensure: 1 top left, 2 bottom right
    bounds = {
        type: 'index',
        x1: Math.min(bounds.x1, bounds.x2),
        y1: Math.min(bounds.y1, bounds.y2),
        x2: Math.max(bounds.x1, bounds.x2),
        y2: Math.max(bounds.y1, bounds.y2)
    };
    const boundsInCanvas = (0, $9414f5ea41e9cf25$export$ddc1c0069d484d49)(bounds, width, height);
    const tilesX = Math.ceil(width / tileSize);
    const tilesY = Math.ceil(height / tileSize);
    if (!boundsInCanvas) // no change if bounds don't overlap canvas
    return (0, $fc4403c8ee6a33dc$export$7f1ebd623f131021)(tilesX * tilesY, false);
    const result = (0, $fc4403c8ee6a33dc$export$7f1ebd623f131021)(tilesX * tilesY, false);
    const tileBounds = {
        x1: (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x1 / tileSize), 0, tilesX - 1),
        y1: (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / tileSize), 0, tilesY - 1),
        x2: (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / tileSize), 0, tilesX - 1),
        y2: (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y2 / tileSize), 0, tilesY - 1)
    };
    for(let i = tileBounds.x1; i <= tileBounds.x2; i++)for(let e = tileBounds.y1; e <= tileBounds.y2; e++)result[e * tilesX + i] = true;
    return result;
}
function $b37280925142c567$export$1774f90c6da5013c(oldChangedOrEmpty, newChanged) {
    return newChanged.map((newItem, index)=>{
        return newItem || !!oldChangedOrEmpty[index];
    });
}


const $2946cfe57170d555$export$3d7bd55e322555b1 = (imageData)=>{
    return new ImageData(new Uint8ClampedArray(imageData.data), imageData.width, imageData.height);
};



function $96d94f28640c04c3$export$55941c74c8f934(data) {
    return {
        id: (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)(),
        // timestamp: new Date().getTime(),
        data: data
    };
}
function $96d94f28640c04c3$export$1a44c122b8668cb(tile) {
    return {
        id: (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)(),
        // timestamp: new Date().getTime(),
        data: (0, $2946cfe57170d555$export$3d7bd55e322555b1)(tile.data)
    };
}



function $a262f7e0a9f5e4af$export$6706c882ea9c3dbd(canvas, changedTiles) {
    const result = [];
    const tilesX = Math.ceil(canvas.width / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
    const tilesY = Math.ceil(canvas.height / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
    for(let row = 0; row < tilesY; row++)for(let col = 0; col < tilesX; col++)result.push(changedTiles[row * tilesX + col] ? (0, $96d94f28640c04c3$export$55941c74c8f934)((0, $536e5ff7428d1419$export$6b742be78fc940fb)(canvas, col, row, (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6))) : undefined);
    return result;
}
function $a262f7e0a9f5e4af$export$7b1ba44282f9a519(canvas, bounds) {
    if (bounds) {
        const changedTiles = (0, $b37280925142c567$export$2098fe43203ddd32)(bounds, canvas.width, canvas.height);
        return $a262f7e0a9f5e4af$export$6706c882ea9c3dbd(canvas, changedTiles);
    } else {
        // only do a single read back
        const ctx = canvas.getContext('2d');
        /*
            Uncaught SecurityError: Failed to execute 'getImageData' on 'CanvasRenderingContext2D': The canvas has been tainted by cross-origin data.
            Mozilla/5.0 (X11; CrOS x86_64 14541.0.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36
            -> no idea how this was achieved. Tried importing svg with cross-origin content. Did not result in that exception
         */ // InvalidStateError: The object is in an invalid state.
        const fullImageData = (0, $13d5aa49e37e2734$export$f84fa3da4a94c138)(ctx, 0, 0, canvas.width, canvas.height);
        const tilesX = Math.ceil(canvas.width / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
        const tilesY = Math.ceil(canvas.height / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
        const result = [];
        // manually transfer into tiles
        for(let row = 0; row < tilesY; row++)for(let col = 0; col < tilesX; col++){
            const x = col * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            const y = row * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            const tileWidth = Math.min((0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), canvas.width - x);
            const tileHeight = Math.min((0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), canvas.height - y);
            const tileData = new ImageData(tileWidth, tileHeight);
            for(let line = 0; line < tileHeight; line++){
                const srcStart = ((y + line) * canvas.width + x) * 4;
                const destStart = line * tileWidth * 4;
                tileData.data.set(fullImageData.data.subarray(srcStart, srcStart + tileWidth * 4), destStart);
            }
            result.push((0, $96d94f28640c04c3$export$55941c74c8f934)(tileData));
        }
        return result;
    }
}


// create individual THistoryEntryLayer
function $52ec11e106a92aac$var$createEntryLayer(layer, attributes, bounds, tiles) {
    const useAll = attributes === 'all';
    const result = {};
    if (useAll || attributes.includes('name')) result.name = layer.name;
    if (useAll || attributes.includes('opacity')) result.opacity = layer.opacity;
    if (useAll || attributes.includes('isVisible')) result.isVisible = layer.isVisible;
    if (useAll || attributes.includes('mixModeStr')) result.mixModeStr = layer.mixModeStr;
    if (useAll || attributes.includes('index')) result.index = layer.index;
    if (useAll || attributes.includes('tiles')) result.tiles = tiles !== null && tiles !== void 0 ? tiles : (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(layer.context.canvas, bounds);
    if (useAll || attributes.includes('isClipped')) result.isClipped = !!layer.isClipped;
    return result;
}
function $52ec11e106a92aac$export$7cefb04ac49374c4(layers, ...items) {
    var _items_find;
    const generic = (_items_find = items.find((item)=>item && !('layerId' in item))) !== null && _items_find !== void 0 ? _items_find : {
        attributes: []
    };
    const targets = items.filter((item)=>!!item).filter((item)=>'layerId' in item);
    return Object.fromEntries(layers.map((layer, index)=>{
        for (const target of targets){
            if (target.layerId === layer.id) return [
                layer.id,
                $52ec11e106a92aac$var$createEntryLayer(layer, target.attributes, target.bounds, target.tiles)
            ];
        }
        return [
            layer.id,
            $52ec11e106a92aac$var$createEntryLayer(layer, generic.attributes)
        ];
    }));
}






class $b3e5416e029154db$export$a8c18874b9331404 {
    // Reads from history (ImageData) to avoid reading from canvas.
    getColorAt(x, y, composed) {
        x = Math.floor(x);
        y = Math.floor(y);
        if (x < 0 || x >= composed.size.width || y < 0 || y >= composed.size.height) return new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(0, 0, 0);
        const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(1, 1);
        const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
        ctx.imageSmoothingEnabled = false;
        const tilesX = Math.ceil(composed.size.width / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
        const tileCol = Math.floor(x / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
        const tileRow = Math.floor(y / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
        const tileIndex = tileRow * tilesX + tileCol;
        Object.values(composed.layerMap).sort((0, $a57b9cfc6d913e03$export$87eabc555ccfbb9f)).forEach((layer)=>{
            if (!layer.isVisible || layer.opacity === 0) return;
            const tile = layer.tiles[tileIndex];
            let fillStyle = '';
            if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) fillStyle = tile.fill;
            else {
                let tileWidth = (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
                if (composed.size.width % (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6) !== 0 && tileCol === tilesX - 1) tileWidth = composed.size.width % (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
                const pixelIndex = y % (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6) * tileWidth + x % (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
                if (tile.data.data[pixelIndex * 4 + 3] === 0) return;
                fillStyle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr({
                    r: tile.data.data[pixelIndex * 4],
                    g: tile.data.data[pixelIndex * 4 + 1],
                    b: tile.data.data[pixelIndex * 4 + 2],
                    a: tile.data.data[pixelIndex * 4 + 3] / 255
                });
            }
            ctx.fillStyle = fillStyle;
            ctx.globalAlpha = layer.opacity;
            ctx.globalCompositeOperation = layer.mixModeStr;
            ctx.fillRect(0, 0, 1, 1);
        });
        const imData = ctx.getImageData(0, 0, 1, 1);
        return new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(imData.data[0], imData.data[1], imData.data[2]);
    }
    // ----------------------------------- public -----------------------------------
    constructor(){}
}




function $b5fa43d1e9c9aab9$export$199acb5b15c43176(poly, x, y) {
    return poly.map((poly)=>{
        return poly.map((ring)=>{
            return ring.map((p)=>{
                return [
                    p[0] + x,
                    p[1] + y
                ];
            });
        });
    });
}




function $12e0dda7c62dd122$export$820c5732ce56544(selection, width, height) {
    const result = new Uint8Array(new ArrayBuffer(width * height));
    const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(width, height);
    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
    (0, $13d5aa49e37e2734$export$f7b95c0f504bef8b)(selection, ctx);
    const imageData = ctx.getImageData(0, 0, width, height);
    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(canvas);
    const len = width * height;
    for(let i = 0, e = 0; i < len; i++, e += 4)result[i] = imageData.data[e] >>> 7;
    return result;
}


const $d26b85e649dca02a$export$9f4f73b1bd7c2f26 = 16;
const $d26b85e649dca02a$var$KL_CANVAS_DEBUGGING = false;
class $d26b85e649dca02a$export$4a819bde91671014 {
    updateIndices() {
        this.layers.forEach((item, index)=>{
            item.index = index;
        });
    }
    /*
     * Resets canvas -> 1 layer, 100% opacity,
     * unless layers provided.
     * @param p
     */ reset(p) {
        if (!p.width || !p.height || p.width < 1 || p.height < 1 || isNaN(p.width) || isNaN(p.height)) throw new Error('invalid canvas size');
        this.width = p.width;
        this.height = p.height;
        this.selection = undefined;
        this.layers.splice(1, Math.max(0, this.layers.length - 1));
        this.klHistory.pause(true);
        try {
            if (p.layers) for(let i = 0; i < p.layers.length; i++){
                const pItem = p.layers[i];
                if (!this.layers[i]) this.addLayer();
                const layer = this.layers[i];
                layer.id = pItem.id;
                layer.name = pItem.name;
                layer.isVisible = pItem.isVisible;
                layer.mixModeStr = pItem.mixModeStr ? pItem.mixModeStr : 'source-over';
                layer.canvas.width = this.width;
                layer.canvas.height = this.height;
                layer.context.drawImage(pItem.image, 0, 0);
                this.setOpacity(i, pItem.opacity);
            }
            else {
                const layer = this.layers[0];
                layer.name = p.layerName ? p.layerName : (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-layer') + ' 1';
                layer.isVisible = true;
                layer.canvas.width = this.width;
                layer.canvas.height = this.height;
                layer.mixModeStr = 'source-over';
                this.setOpacity(0, 1);
                if (p.color) this.layerFill(0, p.color);
                else if (p.image) layer.context.drawImage(p.image, 0, 0);
            }
        } finally{
            this.klHistory.pause(false);
        }
        this.updateIndices();
        if (!this.klHistory.isPaused()) {
            var _p_projectId;
            const historyEntryData = {
                projectId: {
                    value: (_p_projectId = p.projectId) !== null && _p_projectId !== void 0 ? _p_projectId : (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)()
                },
                size: {
                    width: this.width,
                    height: this.height
                },
                selection: {
                    value: this.selection
                },
                activeLayerId: this.layers[this.layers.length - 1].id,
                layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                    attributes: 'all'
                })
            };
            this.klHistory.push(historyEntryData);
        }
        return this.layers.length - 1;
    }
    isLayerLimitReached() {
        return this.layers.length >= $d26b85e649dca02a$export$9f4f73b1bd7c2f26;
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    /**
     * without resizing
     */ setSize(width, height) {
        this.width = width;
        this.height = height;
    }
    getLayerCount() {
        return this.layers.length;
    }
    resize(w, h, algorithm = 'smooth') {
        if (!w || !h || w === this.width && h === this.height || isNaN(w) || isNaN(h) || w < 1 || h < 1) return false;
        w = Math.max(w, 1);
        h = Math.max(h, 1);
        let tmp1, tmp2;
        if (algorithm === 'pixelated') {
            tmp1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
            const tmp1Ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(tmp1);
            tmp1Ctx.imageSmoothingEnabled = false;
            for(let i = 0; i < this.layers.length; i++){
                if (i > 0) tmp1Ctx.clearRect(0, 0, w, h);
                const layer = this.layers[i];
                tmp1Ctx.drawImage(layer.canvas, 0, 0, w, h);
                layer.canvas.width = w;
                layer.canvas.height = h;
                layer.context.drawImage(tmp1, 0, 0);
            }
        } else if (algorithm === 'smooth') {
            tmp1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas();
            tmp2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas();
            for(let i = 0; i < this.layers.length; i++)(0, $d9f9f4926aa80a1c$export$921068d8846a1559).resizeCanvas(this.layers[i].canvas, w, h, tmp1, tmp2);
        } else throw new Error('unknown resize algorithm');
        if (this.selection) this.selection = (0, $1d9e27e0466b80f7$export$aa391dbbf8073422)(this.selection, (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(w / this.width, h / this.height));
        this.width = w;
        this.height = h;
        this.klHistory.push((0, $0616f0a0655c1023$export$71511d61b312f219)({
            size: {
                width: this.width,
                height: this.height
            },
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'tiles'
                ]
            })
        }, this.selection ? {
            selection: {
                value: this.selection
            }
        } : {}));
        return true;
    }
    /**
     * crop / extend
     */ resizeCanvas(p) {
        const newW = Math.round(p.left) + this.width + Math.round(p.right);
        const newH = Math.round(p.top) + this.height + Math.round(p.bottom);
        const offX = Math.round(p.left);
        const offY = Math.round(p.top);
        if (isNaN(newW) || isNaN(newH) || newW < 1 || newH < 1) throw new Error('KlCanvas.resizeCanvas - invalid canvas size');
        for(let i = 0; i < this.layers.length; i++){
            const ctemp = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.width, this.height);
            const layer = this.layers[i];
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(ctemp).drawImage(layer.canvas, 0, 0);
            layer.canvas.width = newW;
            layer.canvas.height = newH;
            layer.context.save();
            if (i === 0 && p.fillColor) {
                layer.context.fillStyle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(p.fillColor);
                layer.context.fillRect(0, 0, newW, newH);
                layer.context.clearRect(offX, offY, this.width, this.height);
            }
            layer.context.drawImage(ctemp, offX, offY);
            layer.context.restore();
        }
        this.width = newW;
        this.height = newH;
        if (this.selection) this.selection = (0, $b5fa43d1e9c9aab9$export$199acb5b15c43176)(this.selection, offX, offY);
        this.klHistory.push((0, $0616f0a0655c1023$export$71511d61b312f219)({
            size: {
                width: this.width,
                height: this.height
            },
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'tiles'
                ]
            })
        }, this.selection ? {
            selection: {
                value: this.selection
            }
        } : {}));
    }
    /**
     * will be inserted above of selected
     */ addLayer(selectedIndex, data) {
        if (this.isLayerLimitReached()) return false;
        const index = selectedIndex === undefined ? this.layers.length : selectedIndex + 1;
        const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.width, this.height);
        const context = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
        if (data) {
            if (typeof data.image === 'function') data.image(context);
            else context.drawImage(data.image, 0, 0);
        }
        const layerId = (0, $07b32ff703dd0314$export$b2ce7a8a096070e2)();
        var _data_mixModeStr;
        const layer = {
            id: layerId,
            index: index,
            name: data && data.name !== undefined ? data.name : (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-layer') + ' ' + (this.layers.length + this.layerNrOffset),
            mixModeStr: data ? (_data_mixModeStr = data.mixModeStr) !== null && _data_mixModeStr !== void 0 ? _data_mixModeStr : 'source-over' : 'source-over',
            isVisible: data ? data.isVisible : true,
            opacity: data ? data.opacity : 1,
            canvas: canvas,
            context: context
        };
        this.layers.splice(index, 0, layer);
        this.klHistory.pause(true);
        try {
            this.setOpacity(index, 1);
        } finally{
            this.klHistory.pause(false);
        }
        this.updateIndices();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: layerId,
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            }, {
                layerId: layerId,
                attributes: 'all',
                tiles: data ? undefined : (0, $ad14059c4ef400ae$export$9a1731baa7701cc7)(this.width, this.height, 'transparent')
            })
        });
        return index;
    }
    duplicateLayer(srcIndex) {
        if (!this.layers[srcIndex] || this.isLayerLimitReached()) return false;
        const srcLayer = this.layers[srcIndex];
        const newIndex = srcIndex + 1;
        const composed = this.klHistory.getComposed();
        const srcComposed = composed.layerMap[srcLayer.id];
        const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.width, this.height);
        const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
        const layerId = (0, $07b32ff703dd0314$export$b2ce7a8a096070e2)();
        const newLayer = {
            id: layerId,
            index: newIndex,
            name: srcLayer.name + ' ' + (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-copy'),
            mixModeStr: srcLayer.mixModeStr,
            isVisible: srcLayer.isVisible,
            opacity: srcLayer.opacity,
            canvas: canvas,
            context: ctx
        };
        this.layers.splice(newIndex, 0, newLayer);
        {
            // draw into new layer from old
            const tilesPerX = Math.ceil(this.width / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
            // Uncaught TypeError: Cannot read properties of undefined (reading 'tiles')
            srcComposed.tiles.forEach((tile, index)=>{
                const x = index % tilesPerX;
                const y = Math.floor(index / tilesPerX);
                ctx.save();
                if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) {
                    ctx.fillStyle = tile.fill;
                    ctx.fillRect(x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
                } else ctx.putImageData(tile.data, x * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), y * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
                ctx.restore();
            });
        }
        this.updateIndices();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: layerId,
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            }, {
                layerId: layerId,
                attributes: 'all',
                tiles: srcComposed.tiles.map((tile)=>{
                    if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) return (0, $0616f0a0655c1023$export$71511d61b312f219)({}, tile);
                    return (0, $96d94f28640c04c3$export$1a44c122b8668cb)(tile);
                })
            })
        });
        return srcIndex + 1;
    }
    getLayerContext(index, doReturnNull) {
        if (this.layers[index]) return this.layers[index].context;
        if (doReturnNull) return null;
        throw new Error('layer of index ' + index + ' not found (in ' + this.layers.length + ' layers)');
    }
    removeLayer(index) {
        const toDeleteLayer = this.layers[index];
        if (!toDeleteLayer) return false;
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(toDeleteLayer.canvas);
        this.layers.splice(index, 1);
        this.updateIndices();
        const activeLayerIndex = Math.max(0, index - 1);
        const activeLayerId = this.layers[activeLayerIndex].id;
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: activeLayerId,
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            })
        });
        return activeLayerIndex;
    }
    renameLayer(index, name) {
        const targetLayer = this.layers[index];
        if (targetLayer) targetLayer.name = name;
        else return false;
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'name'
                ]
            })
        });
        return true;
    }
    setOpacity(layerIndex, opacity) {
        if (!this.layers[layerIndex]) return;
        opacity = Math.max(0, Math.min(1, opacity));
        this.layers[layerIndex].opacity = opacity;
        if (!this.klHistory.isPaused()) {
            const layerId = this.layers[layerIndex].id;
            const topEntry = this.klHistory.getEntries().at(-1).data;
            const replaceTop = (0, $791a43fc2c5e07f3$export$e173233eae155bba)(topEntry, layerId);
            this.klHistory.push({
                layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                    layerId: layerId,
                    attributes: [
                        'opacity'
                    ]
                })
            }, replaceTop);
        }
    }
    setLayerIsVisible(layerIndex, isVisible) {
        if (this.layers[layerIndex]) this.layers[layerIndex].isVisible = isVisible;
        else throw new Error(`layer ${layerIndex} undefined`);
        if (!this.klHistory.isPaused()) {
            const layerId = this.layers[layerIndex].id;
            const topEntry = this.klHistory.getEntries().at(-1).data;
            const replaceTop = (0, $17c16cc75e4c1e0d$export$b706b44cfdbaaa7d)(topEntry, layerId);
            this.klHistory.push({
                layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                    layerId: layerId,
                    attributes: [
                        'isVisible'
                    ]
                })
            }, replaceTop);
        }
    }
    moveLayer(index, delta) {
        if (delta === 0) return;
        if (!this.layers[index]) return;
        const temp = this.layers[index];
        this.layers.splice(index, 1);
        const targetIndex = Math.max(0, Math.min(index + delta, this.layers.length));
        this.layers.splice(targetIndex, 0, temp);
        this.updateIndices();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: this.layers[targetIndex].id,
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            })
        });
        return targetIndex;
    }
    mergeLayers(layerBottomIndex, layerTopIndex, mixModeStr) {
        if (!this.layers[layerBottomIndex] || !this.layers[layerTopIndex] || layerBottomIndex === layerTopIndex) return;
        //order messed up
        if (layerBottomIndex > layerTopIndex) {
            const temp = layerBottomIndex;
            layerBottomIndex = layerTopIndex;
            layerTopIndex = temp;
        }
        const topLayer = this.layers[layerTopIndex];
        const bottomLayer = this.layers[layerBottomIndex];
        if (mixModeStr === undefined) mixModeStr = topLayer.mixModeStr;
        const topOpacity = this.layers[layerTopIndex].opacity;
        const mergedPixelData = topLayer.opacity > 0;
        if (mergedPixelData) {
            const bottomCtx = bottomLayer.context;
            bottomCtx.save();
            if (mixModeStr === 'as-alpha') {
                // todo remove this?
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).convertToAlphaChannelCanvas(topLayer.canvas);
                bottomCtx.globalCompositeOperation = 'destination-in';
                bottomCtx.globalAlpha = topOpacity;
                bottomCtx.drawImage(topLayer.canvas, 0, 0);
            } else {
                // If the top layer is clipped, its content must be masked to the bottom layer's
                // current alpha before merging so the visual result matches what was on screen.
                let sourceCanvas = topLayer.canvas;
                let ownedTemp = false;
                if (topLayer.isClipped) {
                    const w = this.width;
                    const h = this.height;
                    const tempCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
                    const tempCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(tempCanvas);
                    tempCtx.drawImage(topLayer.canvas, 0, 0);
                    tempCtx.globalCompositeOperation = 'destination-in';
                    tempCtx.drawImage(bottomLayer.canvas, 0, 0);
                    sourceCanvas = tempCanvas;
                    ownedTemp = true;
                }
                if (mixModeStr) bottomCtx.globalCompositeOperation = mixModeStr;
                bottomCtx.globalAlpha = topOpacity;
                bottomCtx.drawImage(sourceCanvas, 0, 0);
                if (ownedTemp) (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(sourceCanvas);
            }
            bottomCtx.restore();
        }
        this.klHistory.pause(true);
        try {
            this.removeLayer(layerTopIndex);
        } finally{
            this.klHistory.pause(false);
        }
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: bottomLayer.id,
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            }, mergedPixelData ? {
                layerId: bottomLayer.id,
                attributes: 'all'
            } : undefined)
        });
        return layerBottomIndex;
    }
    mergeAll() {
        if (this.layers.length === 1) return false;
        // draw all on bottom layer
        const bottomLayer = this.layers[0];
        bottomLayer.name = (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-layer') + ' 1';
        const bottomCtx = bottomLayer.context;
        for(let i = 1; i < this.layers.length; i++){
            const layer = this.layers[i];
            if (!layer.isVisible || layer.opacity === 0) continue;
            bottomCtx.save();
            bottomCtx.globalCompositeOperation = layer.mixModeStr;
            bottomCtx.globalAlpha = layer.opacity;
            bottomCtx.drawImage(layer.canvas, 0, 0);
            bottomCtx.restore();
        }
        this.klHistory.pause(true);
        try {
            // remove upper layers
            for(let i = this.layers.length - 1; i > 0; i--)this.removeLayer(i);
        } finally{
            this.klHistory.pause(false);
        }
        if (!this.klHistory.isPaused()) {
            const activeLayerId = bottomLayer.id;
            this.klHistory.push({
                activeLayerId: activeLayerId,
                layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                    attributes: [
                        'tiles'
                    ]
                })
            });
        }
        return 0;
    }
    // rotates the canvas with all layers. either by 90, 180, or 270 degrees
    rotate(deg) {
        while(deg < 0)deg += 360;
        deg %= 360;
        if (deg !== 90 && deg !== 180 && deg !== 270) return;
        const temp = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas();
        if (deg === 180) {
            temp.width = this.width;
            temp.height = this.height;
        } else if (deg === 90 || deg === 270) {
            temp.width = this.height;
            temp.height = this.width;
        }
        let matrix = (0, $5c473edaf09eadd3$export$f0954fd7d5368655)();
        if (deg === 90) matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(this.height, 0), (0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(Math.PI / 2));
        else if (deg === 180) matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(this.width, this.height), (0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(Math.PI));
        else if (deg === 270) matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(0, this.width), (0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(3 * Math.PI / 2));
        const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(temp);
        for(let i = 0; i < this.layers.length; i++){
            ctx.clearRect(0, 0, temp.width, temp.height);
            ctx.save();
            ctx.setTransform(...(0, $974f651610599156$export$2b60e7dafdbde18a)(matrix));
            ctx.drawImage(this.layers[i].canvas, 0, 0);
            ctx.restore();
            this.layers[i].canvas.width = temp.width;
            this.layers[i].canvas.height = temp.height;
            this.layers[i].context.drawImage(temp, 0, 0);
        }
        this.width = temp.width;
        this.height = temp.height;
        if (this.selection) this.selection = (0, $1d9e27e0466b80f7$export$aa391dbbf8073422)(this.selection, matrix);
        this.klHistory.push((0, $0616f0a0655c1023$export$71511d61b312f219)({
            size: {
                width: this.width,
                height: this.height
            },
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'tiles'
                ]
            })
        }, this.selection ? {
            selection: {
                value: this.selection
            }
        } : {}));
    }
    flip(isHorizontal, isVertical, layerIndex) {
        if (!isHorizontal && !isVertical) return;
        const temp = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.width, this.height);
        temp.width = this.width;
        temp.height = this.height;
        const tempCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(temp);
        const matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(temp.width / 2, temp.height / 2), (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(isHorizontal ? -1 : 1, isVertical ? -1 : 1), (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(-temp.width / 2, -temp.height / 2));
        for(let i = 0; i < this.layers.length; i++){
            if ((layerIndex || layerIndex === 0) && i !== layerIndex) continue;
            tempCtx.save();
            tempCtx.clearRect(0, 0, temp.width, temp.height);
            tempCtx.setTransform(...(0, $974f651610599156$export$2b60e7dafdbde18a)(matrix));
            tempCtx.drawImage(this.layers[i].canvas, 0, 0);
            tempCtx.restore();
            this.layers[i].context.clearRect(0, 0, this.layers[i].canvas.width, this.layers[i].canvas.height);
            this.layers[i].context.drawImage(temp, 0, 0);
        }
        if (this.selection) this.selection = (0, $1d9e27e0466b80f7$export$aa391dbbf8073422)(this.selection, matrix);
        const targetLayer = layerIndex === undefined ? undefined : this.layers[layerIndex];
        this.klHistory.push((0, $0616f0a0655c1023$export$71511d61b312f219)({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, targetLayer ? {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ]
            } : {
                attributes: [
                    'tiles'
                ]
            })
        }, this.selection ? {
            selection: {
                value: this.selection
            }
        } : {}));
    }
    // arbitrary drawing operation & focus layer
    drawOperation(layerIndex, operation) {
        const targetLayer = this.layers[layerIndex];
        const ctx = targetLayer.context;
        operation(ctx);
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: targetLayer.id,
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ]
            })
        });
    }
    layerFill(layerIndex, colorObj, compositeOperation, doClipSelection) {
        const ctx = this.layers[layerIndex].context;
        ctx.save();
        const isUniformFill = !(doClipSelection && this.selection) && compositeOperation === undefined;
        if (compositeOperation) ctx.globalCompositeOperation = compositeOperation;
        let bounds;
        if (doClipSelection && this.selection) {
            const selectionPath = (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection);
            ctx.clip(selectionPath);
            bounds = (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index');
        }
        const fill = 'rgba(' + colorObj.r + ',' + colorObj.g + ',' + colorObj.b + ',1)';
        ctx.fillStyle = fill;
        ctx.fillRect(0, 0, this.layers[layerIndex].canvas.width, this.layers[layerIndex].canvas.height);
        ctx.restore();
        // workaround for chrome bug https://bugs.chromium.org/p/chromium/issues/detail?id=1281185
        // TODO remove if chrome updated
        ctx.save();
        ctx.fillStyle = 'rgba(0,0,0,0.01)';
        ctx.fillRect(-0.9999999, -0.9999999, 1, 1);
        ctx.restore();
        /*if (!document.getElementById('testocanvas')) {
            layerCanvasArr[layerIndex].id = 'testocanvas';
            document.body.append(layerCanvasArr[layerIndex]);
            BB.css(layerCanvasArr[layerIndex], {
                position: 'fixed',
                left: '0',
                top: '0',
                zIndex: '1111111',
                transform: 'scale(0.2)',
                border: '10px solid red',
            });
        }
        if (!document.getElementById('testocanvas')) {
            let c = document.createElement('canvas');
            c.width = 1000;
            c.height = 1000;
            let ctx2 = c.getContext('2d');
            ctx2.drawImage(layerCanvasArr[layerIndex], 0, 0);
            c.id = 'testocanvas';
            document.body.append(c);
            BB.css(c, {
                position: 'fixed',
                left: '0',
                top: '0',
                zIndex: '1111111',
                transform: 'scale(0.2)',
                border: '10px solid red',
            });
        }*/ if (!this.klHistory.isPaused()) {
            const targetLayer = this.layers[layerIndex];
            this.klHistory.push({
                layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                    layerId: targetLayer.id,
                    attributes: [
                        'tiles'
                    ],
                    tiles: isUniformFill ? (0, $ad14059c4ef400ae$export$9a1731baa7701cc7)(this.width, this.height, fill) : undefined,
                    bounds: bounds
                })
            });
        }
    }
    floodFill(layerIndex, x, y, rgb, opacity, tolerance, sampleStr, grow, isContiguous) {
        if (x < 0 || y < 0 || x >= this.width || y >= this.height || opacity === 0) return;
        tolerance = Math.round(tolerance);
        x = Math.round(x);
        y = Math.round(y);
        if (![
            'above',
            'current',
            'all'
        ].includes(sampleStr)) throw new Error('invalid sampleStr');
        const selectionMask = this.selection ? (0, $12e0dda7c62dd122$export$820c5732ce56544)(this.selection, this.width, this.height) : undefined;
        if (selectionMask && selectionMask[y * this.width + x] === 0) // don't fill if outside of selection
        return;
        const targetLayer = this.layers[layerIndex];
        let result;
        let targetCtx;
        let targetImageData;
        if (sampleStr === 'all') {
            const srcCanvas = this.layers.length === 1 ? this.layers[0].canvas : this.getCompleteCanvas(1);
            const srcCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(srcCanvas);
            const srcImageData = srcCtx.getImageData(0, 0, this.width, this.height);
            const srcData = srcImageData.data;
            result = (0, $469fa98e1403db53$export$13d50f258a8034f)(srcData, selectionMask, this.width, this.height, x, y, tolerance, Math.round(grow), isContiguous);
            targetCtx = targetLayer.context;
            targetImageData = targetCtx.getImageData(0, 0, this.width, this.height);
        } else {
            const srcIndex = sampleStr === 'above' ? layerIndex + 1 : layerIndex;
            if (srcIndex >= this.layers.length) return;
            const srcCtx = this.layers[srcIndex].context;
            const srcImageData = srcCtx.getImageData(0, 0, this.width, this.height);
            const srcData = srcImageData.data;
            result = (0, $469fa98e1403db53$export$13d50f258a8034f)(srcData, selectionMask, this.width, this.height, x, y, tolerance, Math.round(grow), isContiguous);
            targetCtx = layerIndex === srcIndex ? srcCtx : targetLayer.context;
            targetImageData = layerIndex === srcIndex ? srcImageData : targetCtx.getImageData(0, 0, this.width, this.height);
        }
        const targetData = targetImageData.data;
        if (rgb) {
            if (opacity === 1) {
                for(let i = 0; i < this.width * this.height; i++)if (result.data[i] === 255) {
                    targetData[i * 4] = rgb.r;
                    targetData[i * 4 + 1] = rgb.g;
                    targetData[i * 4 + 2] = rgb.b;
                    targetData[i * 4 + 3] = 255;
                }
            } else {
                for(let i = 0; i < this.width * this.height; i++)if (result.data[i] === 255) {
                    targetData[i * 4] = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(targetData[i * 4], rgb.r, opacity);
                    targetData[i * 4 + 1] = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(targetData[i * 4 + 1], rgb.g, opacity);
                    targetData[i * 4 + 2] = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(targetData[i * 4 + 2], rgb.b, opacity);
                    targetData[i * 4 + 3] = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(targetData[i * 4 + 3], 255, opacity);
                }
            }
        } else // erase
        if (opacity === 1) {
            for(let i = 0; i < this.width * this.height; i++)if (result.data[i] === 255) targetData[i * 4 + 3] = 0;
        } else {
            for(let i = 0; i < this.width * this.height; i++)if (result.data[i] === 255) targetData[i * 4 + 3] = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(targetData[i * 4 + 3], 0, opacity);
        }
        targetCtx.putImageData(targetImageData, 0, 0);
        // const ctx = this.layers[layerIndex].context;
        // ctx.save();
        // ctx.fillStyle = 'rgba(255,0,0,0.2)';
        // ctx.fillRect(
        //     result.bounds.x1,
        //     result.bounds.y1,
        //     result.bounds.x2 - result.bounds.x1,
        //     result.bounds.y2 - result.bounds.y1,
        // );
        // ctx.restore();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ],
                bounds: result.bounds
            })
        });
    }
    /**
     * draw geometric shape (circle, line, rect)
     * @param layerIndex
     * @param shapeObj
     */ drawShape(layerIndex, shapeObj) {
        if (shapeObj.x1 === shapeObj.x2 && shapeObj.y1 === shapeObj.y2) return;
        const targetLayer = this.layers[layerIndex];
        const selectionPath = this.selection ? new Path2D((0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection)) : undefined;
        const bounds = (0, $583d130d11db85ad$export$71b514a25c47df50)(targetLayer.context, shapeObj, selectionPath);
        // debug
        /*const ctx = this.layers[layerIndex].context;
        ctx.save();
        ctx.fillStyle = 'rgba(255,0,0,0.2)';
        ctx.fillRect(bounds.x1, bounds.y1, bounds.x2 - bounds.x1, bounds.y2 - bounds.y1);
        ctx.restore();*/ if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ],
                bounds: bounds
            })
        });
    }
    drawGradient(layerIndex, gradientObj) {
        const targetLayer = this.layers[layerIndex];
        const selectionPath = this.selection ? new Path2D((0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection)) : undefined;
        (0, $64881aa9f7f8f596$export$b1f70a113e3b5c1b)(targetLayer.context, gradientObj, selectionPath);
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ]
            })
        });
    }
    text(layerIndex, p) {
        const targetLayer = this.layers[layerIndex];
        const rect = (0, $67e715fe604c9329$export$482c90f94eb9717c)(targetLayer.canvas, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(p), this.selection ? new Path2D((0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection)) : undefined);
        // add 2, because rect not entirely accurate
        const padding = 2 + (p.stroke ? p.stroke.lineWidth / 2 : 0);
        const changedBounds = (0, $182738d3ab29089b$export$5dd60a54dd55622)((0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)(rect, 'coordinate'), (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(p.x, p.y), (0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(-p.angleRad)));
        changedBounds.x1 -= padding;
        changedBounds.y1 -= padding;
        changedBounds.x2 += padding;
        changedBounds.y2 += padding;
        // const ctx = this.layers[layerIndex].context;
        // ctx.save();
        // ctx.fillStyle = 'rgba(255,0,0,0.2)';
        // ctx.fillRect(bounds.x1, bounds.y1, bounds.x2 - bounds.x1, bounds.y2 - bounds.y1);
        // ctx.restore();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ],
                bounds: (0, $9414f5ea41e9cf25$export$b0036cbc597df324)(changedBounds)
            })
        });
    }
    eraseLayer(p) {
        const targetLayer = this.layers[p.layerIndex];
        const ctx = targetLayer.context;
        ctx.save();
        let bounds;
        if (p.useSelection && this.selection) {
            const selectionPath = (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection);
            ctx.clip(selectionPath);
            bounds = (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index');
        }
        if (p.useAlphaLock) ctx.globalCompositeOperation = 'source-atop';
        else ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr((0, $7a2aeb795d64bafc$export$8627e24041b28589)());
        ctx.fillRect(0, 0, this.width, this.height);
        ctx.restore();
        const isUniformFill = !p.useAlphaLock && !(p.useSelection && this.selection);
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ],
                tiles: isUniformFill ? (0, $ad14059c4ef400ae$export$9a1731baa7701cc7)(this.width, this.height, 'transparent') : undefined,
                bounds: bounds
            })
        });
    }
    getKlHistory() {
        return this.klHistory;
    }
    getLayersRaw() {
        return this.layers;
    }
    getLayers() {
        return this.layers.map((layer)=>{
            return {
                id: layer.id,
                canvas: layer.canvas,
                context: layer.context,
                isVisible: layer.isVisible,
                opacity: layer.opacity,
                name: layer.name,
                mixModeStr: layer.mixModeStr
            };
        });
    }
    getLayersFast() {
        return this.layers.map((item)=>{
            return (0, $0616f0a0655c1023$export$71511d61b312f219)({
                canvas: item.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                name: item.name,
                mixModeStr: item.mixModeStr
            }, item.compositeObj ? {
                compositeObj: item.compositeObj
            } : {}, item.isClipped ? {
                isClipped: item.isClipped
            } : {});
        });
    }
    getLayerIndex(canvasObj, doReturnNull) {
        for(let i = 0; i < this.layers.length; i++){
            if (this.layers[i].canvas === canvasObj) return i;
        }
        if (!doReturnNull) throw new Error('layer not found (in ' + this.layers.length + ' layers)');
        return null;
    }
    getLayerOld(index, doReturnNull) {
        if (this.layers[index]) return {
            context: this.layers[index].context,
            isVisible: this.layers[index].isVisible,
            opacity: this.layers[index].opacity,
            name: this.layers[index].name,
            id: index
        };
        if (!doReturnNull) throw new Error('layer of index ' + index + ' not found (in ' + this.layers.length + ' layers)');
        return null;
    }
    getLayer(index) {
        return this.layers[index];
    }
    getColorAt(x, y) {
        let result;
        try {
            result = this.eyedropper.getColorAt(x, y, this.klHistory.getComposed());
        } catch (_) {
        // history probably messed up. but the app should stay operational
        }
        return result;
    }
    getCompleteCanvas(factor, maskSelection) {
        return (0, $2b8bf7b32e5ba51f$export$5f63a7b18dc4503a)(this.getProject(), factor, maskSelection ? this.selection : undefined);
    }
    getProject() {
        return {
            projectId: this.klHistory.getComposed().projectId.value,
            width: this.width,
            height: this.height,
            layers: this.layers.map((layer)=>{
                return {
                    name: layer.name,
                    isVisible: layer.isVisible,
                    opacity: layer.opacity,
                    mixModeStr: layer.mixModeStr,
                    image: layer.canvas,
                    isClipped: layer.isClipped
                };
            })
        };
    }
    setMixMode(layerIndex, mixModeStr) {
        const targetLayer = this.layers[layerIndex];
        targetLayer.mixModeStr = mixModeStr;
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'mixModeStr'
                ]
            })
        });
    }
    /**
     * Mark a layer as a background layer (protected: can't be drawn on, deleted, or renamed).
     * background=true also fills the canvas with the given color.
     */ setLayerBackground(layerIndex, isBackground, color) {
        const targetLayer = this.layers[layerIndex];
        if (!targetLayer) return;
        targetLayer.isBackground = isBackground;
        if (isBackground && color) {
            targetLayer.backgroundColor = color;
            const ctx = targetLayer.context;
            ctx.save();
            ctx.clearRect(0, 0, targetLayer.canvas.width, targetLayer.canvas.height);
            ctx.fillStyle = `rgb(${color.r},${color.g},${color.b})`;
            ctx.fillRect(0, 0, targetLayer.canvas.width, targetLayer.canvas.height);
            ctx.restore();
            if (!this.klHistory.isPaused()) this.klHistory.push({
                layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                    layerId: targetLayer.id,
                    attributes: [
                        'tiles'
                    ]
                })
            });
        } else if (!isBackground) targetLayer.backgroundColor = undefined;
    }
    /**
     * Change the fill color of a background layer.
     */ setBackgroundColor(layerIndex, color) {
        const targetLayer = this.layers[layerIndex];
        if (!targetLayer || !targetLayer.isBackground) return;
        targetLayer.backgroundColor = color;
        const ctx = targetLayer.context;
        ctx.save();
        ctx.clearRect(0, 0, targetLayer.canvas.width, targetLayer.canvas.height);
        ctx.fillStyle = `rgb(${color.r},${color.g},${color.b})`;
        ctx.fillRect(0, 0, targetLayer.canvas.width, targetLayer.canvas.height);
        ctx.restore();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ]
            })
        });
    }
    /**
     * Toggle whether a layer clips to the alpha of the layer below it.
     * When clipped, the layer's visible area is limited to where the base layer is non-transparent.
     */ setLayerClipped(layerIndex, isClipped) {
        const targetLayer = this.layers[layerIndex];
        if (!targetLayer) return;
        targetLayer.isClipped = isClipped || undefined; // store undefined for false to keep it clean
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'isClipped'
                ]
            })
        });
    }
    /**
     * Set composite drawing step for KlCanvasWorkspace.
     * To apply temporary manipulations to a layer.
     *
     * @param layerIndex
     * @param compositeObj
     */ setComposite(layerIndex, compositeObj) {
        if (!this.layers[layerIndex]) throw new Error('invalid layer');
        this.layers[layerIndex].compositeObj = compositeObj;
    }
    setSelection(selection) {
        if (!this.selection && !selection) return;
        this.selection = selection;
        this.klHistory.push({
            selection: {
                value: selection
            }
        });
    }
    getSelection() {
        return this.selection;
    }
    /**
     * called after undo/redo, to apply the changes to the klCanvas.
     * before - before undo/redo was called - equivalent to current state of klCanvas.
     * after - after undo/redo was called.
     */ updateViaComposed(before, after) {
        this.width = after.size.width;
        this.height = after.size.height;
        this.selection = after.selection.value;
        this.layers = (0, $44d5e766b59f1f60$export$cee5b735b1b9bad1)(this.layers, before, after);
    }
    destroy() {
        if (this.isDestroyed) return;
        this.layers.forEach((layer)=>{
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(layer.canvas);
            layer.canvas = {};
            layer.context = {};
        });
        this.layers = [];
        this.isDestroyed = true;
    }
    // ----------------------------------- public -----------------------------------
    constructor(history, layerNrOffset = 0){
        this.layerNrOffset = layerNrOffset;
        this.isDestroyed = false;
        this.selection = undefined;
        this.klHistory = history;
        this.layers = [];
        if ($d26b85e649dca02a$var$KL_CANVAS_DEBUGGING) window.getCanvasLayers = ()=>this.layers;
        this.eyedropper = new (0, $b3e5416e029154db$export$a8c18874b9331404)();
        this.width = 0;
        this.height = 0;
        this.updateViaComposed({
            projectId: {
                value: (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)()
            },
            size: {
                width: 0,
                height: 0
            },
            activeLayerId: '',
            selection: {
                value: []
            },
            layerMap: {}
        }, this.klHistory.getComposed());
    }
}




function $326f2f7e3662b29f$export$6e1bedb2a6cdff30(blendMode) {
    if (!blendMode) return (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-blend-normal');
    const codes = {
        'source-over': 'layers-blend-normal',
        darken: 'layers-blend-darken',
        multiply: 'layers-blend-multiply',
        'color-burn': 'layers-blend-color-burn',
        lighten: 'layers-blend-lighten',
        screen: 'layers-blend-screen',
        'color-dodge': 'layers-blend-color-dodge',
        overlay: 'layers-blend-overlay',
        'soft-light': 'layers-blend-soft-light',
        'hard-light': 'layers-blend-hard-light',
        difference: 'layers-blend-difference',
        exclusion: 'layers-blend-exclusion',
        hue: 'layers-blend-hue',
        saturation: 'layers-blend-saturation',
        color: 'layers-blend-color',
        luminosity: 'layers-blend-luminosity'
    };
    if (!(blendMode in codes)) throw new Error('unknown blend mode');
    return (0, $63d0b335c576c718$export$ce37e184d908d785)(codes[blendMode]);
}






function $22c3a0a9dd5ca668$export$28debfc111084e87(parentEl, currentName, callback) {
    const div = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
    const label = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        content: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-name') + ':',
        css: {
            marginRight: '5px'
        }
    });
    const row = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            display: 'flex'
        }
    });
    const input = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'input'
    });
    input.value = currentName;
    input.setAttribute('data-ignore-focus', 'true');
    input.style.flexGrow = '1';
    const clearBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'button',
        content: '<img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($03e87c70019af696$exports))) + '" height="20"/>',
        title: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-clear'),
        css: {
            marginLeft: '10px'
        },
        onClick: ()=>{
            input.value = '';
            input.focus();
        }
    });
    const suggestions = [
        (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-sketch'),
        (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-colors'),
        (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-shading'),
        (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-lines'),
        (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-effects'),
        (0, $63d0b335c576c718$export$ce37e184d908d785)('background'),
        (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-foreground')
    ];
    const suggestionBtns = [];
    const row2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '5px',
            marginLeft: '-5px'
        }
    });
    suggestions.forEach((item)=>{
        const btn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: row2,
            tagName: 'button',
            content: item,
            onClick: ()=>{
                input.value = '' + btn.textContent;
            },
            css: {
                margin: '5px 0 0 5px'
            }
        });
        suggestionBtns.push(btn);
    });
    div.append(label);
    label.append(row, row2);
    row.append(input, clearBtn);
    setTimeout(()=>{
        input.focus();
        input.select();
    }, 10);
    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-title')}</b>`,
        div: div,
        buttons: [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename'),
            'Cancel'
        ],
        primaries: [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename')
        ],
        callback: (val)=>{
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(clearBtn);
            suggestionBtns.forEach((item)=>{
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(item);
            });
            suggestionBtns.splice(0, suggestionBtns.length);
            if (val === (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename')) callback(input.value);
            else callback(undefined);
        },
        clickOnEnter: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename')
    });
}







function $e304a6ae1452211c$export$ee79aceabae6bb8a(parentEl, p) {
    const div = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
    div.innerHTML = (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-merge-description');
    const options = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
        optionArr: [
            {
                id: p.mixModeStr,
                label: (0, $326f2f7e3662b29f$export$6e1bedb2a6cdff30)(p.mixModeStr)
            },
            {
                id: 'source-in',
                label: 'source-in'
            },
            {
                id: 'source-out',
                label: 'source-out'
            },
            {
                id: 'source-atop',
                label: 'source-atop'
            },
            {
                id: 'destination-in',
                label: 'destination-in'
            },
            {
                id: 'destination-out',
                label: 'destination-out'
            },
            {
                id: 'destination-atop',
                label: 'destination-atop'
            },
            {
                id: 'xor',
                label: 'xor'
            }
        ],
        initId: p.mixModeStr,
        onChange: ()=>{
            update();
        },
        isSmall: true,
        css: {
            marginTop: '5px'
        }
    });
    div.append(options.getElement());
    const thumbDimensions = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(p.topCanvas.width, p.topCanvas.height, 200, 200, 1);
    const preview = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(thumbDimensions.width, thumbDimensions.height);
    preview.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('preview');
    preview.className = 'kl-merge-preview';
    const spacer = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        content: '<br/>',
        css: {
            clear: 'both'
        }
    });
    div.append(spacer, preview);
    const alphaCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyCanvas(preview);
    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(alphaCanvas).drawImage(p.topCanvas, 0, 0, alphaCanvas.width, alphaCanvas.height);
    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).convertToAlphaChannelCanvas(alphaCanvas);
    const update = ()=>{
        const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(preview);
        ctx.save();
        ctx.clearRect(0, 0, preview.width, preview.height);
        if (preview.width > p.topCanvas.width) ctx.imageSmoothingEnabled = false;
        ctx.drawImage(p.bottomCanvas, 0, 0, preview.width, preview.height);
        if (options.getValue() === 'as-alpha') {
            ctx.globalCompositeOperation = 'destination-in';
            ctx.globalAlpha = p.topOpacity;
            ctx.drawImage(alphaCanvas, 0, 0, preview.width, preview.height);
        } else {
            ctx.globalCompositeOperation = options.getValue();
            ctx.globalAlpha = p.topOpacity;
            ctx.drawImage(p.topCanvas, 0, 0, preview.width, preview.height);
        }
        ctx.restore();
    };
    update();
    const keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
        onDown: (keyStr)=>{
            if (keyStr === 'right') options.next();
            if (keyStr === 'left') options.previous();
        }
    });
    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('layers-merge-modal-title')}</b>`,
        div: div,
        buttons: [
            'Ok',
            'Cancel'
        ],
        clickOnEnter: 'Ok',
        callback: (val)=>{
            keyListener.destroy();
            options.destroy();
            if (val === 'Ok') p.callback(options.getValue());
        }
    });
}







class $be599a9dc46f5101$export$e44a253a59704894 {
    getElement() {
        return this.rootElement;
    }
    setEnabled(id, enabled) {
        this.onSetEnabled(id, enabled);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isExpanded = false;
        this.onSetEnabled = ()=>0;
        const button = (0, $934e5f47c3374e21$export$db3b6bfb95261072)('button,w-full,h-full', [
            p.button
        ]);
        button.onclick = ()=>{
            toggle(!this.isExpanded);
        };
        if (p.buttonTitle) button.title = p.buttonTitle;
        (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(button);
        const items = [];
        const itemMap = {};
        p.items.forEach((item)=>{
            const itemButton = (0, $52ad4d7a7d6372c1$export$c3da0dad1b44eea9)({
                tagName: 'button',
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    gap: '10px'
                }
            });
            itemButton.append((0, $52ad4d7a7d6372c1$export$c3da0dad1b44eea9)({
                content: item[1]
            }));
            if (item[2]) itemButton.append((0, $52ad4d7a7d6372c1$export$c3da0dad1b44eea9)({
                content: item[2],
                css: {
                    fontSize: '0.8em',
                    opacity: '0.8'
                }
            }));
            (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(itemButton);
            itemButton.onclick = ()=>{
                toggle(false);
                p.onItemClick(item[0]);
            };
            items.push(itemButton);
            itemMap[item[0]] = itemButton;
        });
        this.onSetEnabled = (id, enabled)=>{
            itemMap[id].disabled = !enabled;
        };
        const menu = (0, $934e5f47c3374e21$export$db3b6bfb95261072)('.kl-dropdown-menu,right-0,top-full,nowrap,hidden', items);
        this.rootElement = (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',pos-relative', [
            button,
            menu
        ]);
        const toggle = (force)=>{
            this.isExpanded = force;
            menu.style.display = this.isExpanded ? '' : 'none';
            if (this.isExpanded) {
                document.addEventListener('pointerdown', onPointerDown, {
                    passive: false
                });
                window.addEventListener('blur', onBlur);
            } else {
                document.removeEventListener('pointerdown', onPointerDown);
                window.removeEventListener('blur', onBlur);
            }
        };
        const onPointerDown = (e)=>{
            const target = e.target;
            if (button.contains(target) || menu.contains(target)) return;
            toggle(false);
        };
        const onBlur = ()=>toggle(false);
    }
}


var $4dde6a6ccaabd5ab$exports = {};
$4dde6a6ccaabd5ab$exports = $parcel$resolve("gShQZ");


var $0ecce9fc138ec1e3$exports = {};
$0ecce9fc138ec1e3$exports = $parcel$resolve("ldqtT");


var $be3ab0e4c204533c$exports = {};
$be3ab0e4c204533c$exports = $parcel$resolve("apAfQ");



var $7444ed87edb442c4$exports = {};
$7444ed87edb442c4$exports = $parcel$resolve("5E29d");


var $9ec1d0f2e5b91b12$exports = {};
$9ec1d0f2e5b91b12$exports = $parcel$resolve("14Bnf");


var $7dc8b75d4dbc1df5$exports = {};
$7dc8b75d4dbc1df5$exports = $parcel$resolve("48B5J");





let $233d9c7abf759c47$var$activeMenu = null;
function $233d9c7abf759c47$export$348e85af22e9951b(p) {
    // Dismiss any existing menu
    if ($233d9c7abf759c47$var$activeMenu) {
        $233d9c7abf759c47$var$activeMenu.remove();
        $233d9c7abf759c47$var$activeMenu = null;
    }
    const menuEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: 'kl-layer-context-menu kl-popup-box',
        css: {
            position: 'fixed',
            zIndex: '10000',
            minWidth: '160px',
            borderRadius: '4px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
            padding: '4px 0',
            userSelect: 'none',
            fontSize: '13px'
        }
    });
    $233d9c7abf759c47$var$activeMenu = menuEl;
    const items = [];
    if (!p.isBackground) items.push({
        label: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-title'),
        action: 'rename'
    });
    items.push({
        label: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-duplicate'),
        action: 'duplicate',
        disabled: !p.canAdd
    });
    items.push({
        isDivider: true
    });
    items.push({
        label: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-new') + ' Above',
        action: 'add-above',
        disabled: !p.canAdd
    });
    items.push({
        label: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-new') + ' Below',
        action: 'add-below',
        disabled: !p.canAdd
    });
    items.push({
        isDivider: true
    });
    if (!p.isBackground) items.push({
        label: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-merge'),
        action: 'merge-down',
        disabled: !p.canMergeDown
    });
    items.push({
        label: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-clear'),
        action: 'clear'
    });
    if (!p.isBackground) {
        // Clip to layer below
        items.push({
            isDivider: true
        });
        items.push({
            label: p.isClipped ? "\u2713 Clip to Layer Below" : 'Clip to Layer Below',
            action: 'toggle-clip',
            disabled: !p.canClip
        });
        items.push({
            isDivider: true
        });
        items.push({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-remove'),
            action: 'delete',
            disabled: !p.canDelete
        });
    }
    items.forEach((item)=>{
        if ('isDivider' in item && item.isDivider) {
            const divider = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    height: '1px',
                    margin: '4px 0',
                    background: 'currentColor',
                    opacity: '0.15'
                }
            });
            menuEl.append(divider);
            return;
        }
        const menuItem = item;
        const btn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: menuItem.label,
            css: {
                display: 'block',
                width: '100%',
                padding: '6px 16px',
                textAlign: 'left',
                background: 'none',
                border: 'none',
                cursor: menuItem.disabled ? 'default' : 'pointer',
                color: menuItem.disabled ? 'var(--kl-text-muted, #999)' : 'inherit',
                fontSize: '13px',
                lineHeight: '1.4'
            }
        });
        btn.disabled = !!menuItem.disabled;
        btn.onpointerenter = ()=>{
            if (!menuItem.disabled) btn.style.background = 'rgba(128,128,128,0.25)';
        };
        btn.onpointerleave = ()=>{
            btn.style.background = 'none';
        };
        btn.onclick = (e)=>{
            e.stopPropagation();
            if (menuItem.disabled) return;
            close();
            p.onAction(menuItem.action);
        };
        menuEl.append(btn);
    });
    // Position the menu
    document.body.append(menuEl);
    // Adjust position to keep within viewport
    const rect = menuEl.getBoundingClientRect();
    let left = p.x;
    let top = p.y;
    if (left + rect.width > window.innerWidth) left = window.innerWidth - rect.width - 4;
    if (top + rect.height > window.innerHeight) top = window.innerHeight - rect.height - 4;
    menuEl.style.left = Math.max(0, left) + 'px';
    menuEl.style.top = Math.max(0, top) + 'px';
    const close = ()=>{
        if (menuEl.parentNode) menuEl.remove();
        if ($233d9c7abf759c47$var$activeMenu === menuEl) $233d9c7abf759c47$var$activeMenu = null;
        document.removeEventListener('pointerdown', onDocPointerDown, true);
        document.removeEventListener('keydown', onKeyDown, true);
        document.removeEventListener('contextmenu', onContextMenu, true);
    };
    const onDocPointerDown = (e)=>{
        if (!menuEl.contains(e.target)) close();
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Escape') close();
    };
    const onContextMenu = (e)=>{
        if (!menuEl.contains(e.target)) {
            e.preventDefault();
            close();
        }
    };
    // Slight delay to avoid immediately closing from the right-click that opened it
    setTimeout(()=>{
        document.addEventListener('pointerdown', onDocPointerDown, true);
        document.addEventListener('keydown', onKeyDown, true);
        document.addEventListener('contextmenu', onContextMenu, true);
    }, 50);
}



const $a4100dd1ad7b3844$var$paddingLeft = 25;
class $a4100dd1ad7b3844$export$c3bf51e04f391d6d {
    move(oldSpotIndex, newSpotIndex) {
        if (isNaN(oldSpotIndex) || isNaN(newSpotIndex)) throw 'layers-ui - invalid move';
        for(let i = 0; i < this.layerElArr.length; i++)((i)=>{
            let posy = this.layerElArr[i].spot;
            if (this.layerElArr[i].spot === oldSpotIndex) posy = newSpotIndex;
            else {
                if (this.layerElArr[i].spot > oldSpotIndex) posy--;
                if (posy >= newSpotIndex) posy++;
            }
            this.layerElArr[i].spot = posy;
            this.layerElArr[i].posY = (this.layerHeight + this.layerSpacing) * (this.klCanvasLayerArr.length - posy - 1);
            this.layerElArr[i].style.top = this.layerElArr[i].posY + 'px';
        })(i);
        if (oldSpotIndex === newSpotIndex) return;
        this.applyUncommitted();
        this.klCanvas.moveLayer(this.selectedSpotIndex, newSpotIndex - oldSpotIndex);
        this.klCanvasLayerArr = this.klCanvas.getLayers();
        this.selectedSpotIndex = newSpotIndex;
        this.mergeBtn.disabled = this.selectedSpotIndex === 0;
    }
    posToSpot(p) {
        let result = parseInt('' + (p / (this.layerHeight + this.layerSpacing) + 0.5));
        result = Math.min(this.klCanvasLayerArr.length - 1, Math.max(0, result));
        result = this.klCanvasLayerArr.length - result - 1;
        return result;
    }
    /**
     * update css position of all layers that are not being dragged, while dragging
     */ updateLayersVerticalPosition(elementIndex, newspot) {
        newspot = Math.min(this.klCanvasLayerArr.length - 1, Math.max(0, newspot));
        if (newspot === this.lastpos) return;
        for(let i = 0; i < this.layerElArr.length; i++){
            if (this.layerElArr[i].spot === elementIndex) continue;
            let posy = this.layerElArr[i].spot;
            if (this.layerElArr[i].spot > elementIndex) posy--;
            if (posy >= newspot) posy++;
            this.layerElArr[i].posY = (this.layerHeight + this.layerSpacing) * (this.klCanvasLayerArr.length - posy - 1);
            this.layerElArr[i].style.top = this.layerElArr[i].posY + 'px';
        }
        this.lastpos = newspot;
    }
    renameLayer(layerSpot) {
        (0, $22c3a0a9dd5ca668$export$28debfc111084e87)(this.parentEl, this.klCanvas.getLayerOld(layerSpot).name, (newName)=>{
            if (newName === undefined || newName === this.klCanvas.getLayerOld(layerSpot).name) return;
            this.klCanvas.renameLayer(layerSpot, newName);
            //this.createLayerList();
            this.onSelect(layerSpot, false);
        });
    }
    _openBackgroundColorPicker(layerIndex) {
        const currentLayer = this.klCanvas.getLayer(layerIndex);
        var _currentLayer_backgroundColor;
        const currentColor = (_currentLayer_backgroundColor = currentLayer.backgroundColor) !== null && _currentLayer_backgroundColor !== void 0 ? _currentLayer_backgroundColor : {
            r: 255,
            g: 255,
            b: 255
        };
        const toHex2 = (n)=>n.toString(16).padStart(2, '0');
        const colorStr = `#${toHex2(currentColor.r)}${toHex2(currentColor.g)}${toHex2(currentColor.b)}`;
        const colorInput = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'input',
            custom: {
                type: 'color',
                value: colorStr
            },
            css: {
                display: 'block',
                width: '100%',
                height: '40px',
                cursor: 'pointer',
                border: 'none'
            }
        });
        const wrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                padding: '10px'
            }
        });
        wrapper.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: 'Background Color:',
            css: {
                marginBottom: '8px',
                fontSize: '14px'
            }
        }), colorInput);
        (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
            div: wrapper,
            message: '',
            buttons: [
                'Ok',
                'Cancel'
            ],
            callback: (result)=>{
                if (result !== 'Ok') return;
                const hex = colorInput.value;
                const r = parseInt(hex.slice(1, 3), 16);
                const g = parseInt(hex.slice(3, 5), 16);
                const b = parseInt(hex.slice(5, 7), 16);
                const newColor = {
                    r: r,
                    g: g,
                    b: b
                };
                this.klCanvas.setBackgroundColor(layerIndex, newColor);
                if (this.onChangeBackgroundColor) this.onChangeBackgroundColor(layerIndex, newColor);
                this.onSelect(layerIndex, false);
            }
        });
    }
    updateHeight() {
        this.layerListEl.style.height = this.layerElArr.length * 35 + 'px';
    }
    createLayerList(force) {
        if (this.klHistory.getChangeCount() === this.oldHistoryState && !force) return;
        this.isManipulating = false;
        this.oldHistoryState = this.klHistory.getChangeCount();
        this.klCanvasLayerArr = this.klCanvas.getLayers();
        const createLayerEntry = (index)=>{
            const klLayer = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.klCanvas.getLayerOld(index));
            const klCanvasLayer = this.klCanvas.getLayer(index);
            const layerName = klLayer.name;
            const opacity = this.klCanvasLayerArr[index].opacity;
            const isVisible = klLayer.isVisible;
            const layercanvas = this.klCanvasLayerArr[index].context.canvas;
            const isBackground = !!klCanvasLayer.isBackground;
            const layer = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'kl-layer'
            });
            this.layerElArr[index] = layer;
            layer.posY = (this.klCanvasLayerArr.length - 1) * 35 - index * 35;
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer, {
                top: layer.posY + 'px'
            });
            // Visual distinction for background layers
            if (isBackground) {
                layer.classList.add('kl-layer--background');
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer, {
                    background: 'linear-gradient(to right, rgba(200,180,120,0.12), transparent)'
                });
            }
            const innerLayer = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(innerLayer, {
                position: 'relative'
            });
            const container1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(container1, {
                width: '270px',
                height: '34px'
            });
            const container2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
            layer.append(innerLayer);
            innerLayer.append(container1, container2);
            layer.spot = index;
            //checkbox - visibility
            {
                const checkWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    tagName: 'label',
                    parent: container1,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-visibility-toggle'),
                    css: {
                        display: 'flex',
                        width: '25px',
                        height: '100%',
                        justifyContent: 'right',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }
                });
                const check = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    tagName: 'input',
                    parent: checkWrapper,
                    custom: {
                        type: 'checkbox',
                        tabindex: '-1',
                        name: 'layer-visibility'
                    },
                    css: {
                        display: 'block',
                        cursor: 'pointer',
                        margin: '0',
                        marginRight: '5px'
                    }
                });
                check.checked = isVisible;
                check.onchange = ()=>{
                    this.klCanvas.setLayerIsVisible(layer.spot, check.checked);
                    if (layer.spot === this.selectedSpotIndex) this.onSelect(this.selectedSpotIndex, false);
                };
                // prevent layer getting dragged
                const preventFunc = (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                };
                if (0, $604d9bbf77127967$export$7728c852ca75bb6d) checkWrapper.onpointerdown = preventFunc;
                else checkWrapper.onmousedown = preventFunc;
            }
            //thumb
            {
                const thumbDimensions = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(layercanvas.width, layercanvas.height, 30, 30, 1);
                layer.thumb = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(thumbDimensions.width, thumbDimensions.height);
                const thc = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(layer.thumb);
                thc.save();
                if (layer.thumb.width > layercanvas.width) thc.imageSmoothingEnabled = false;
                thc.drawImage(layercanvas, 0, 0, layer.thumb.width, layer.thumb.height);
                thc.restore();
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer.thumb, {
                    position: 'absolute',
                    left: (32 - layer.thumb.width) / 2 + $a4100dd1ad7b3844$var$paddingLeft + 'px',
                    top: (32 - layer.thumb.height) / 2 + 1 + 'px',
                    background: 'var(--kl-checkerboard-background)'
                });
            }
            // Red left border for clipped layers
            if (klCanvasLayer.isClipped) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(container1, {
                borderLeft: '5px solid #f33'
            });
            layer.label = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'kl-layer__label'
            });
            layer.layerName = layerName;
            // Show lock icon for background layers
            if (isBackground) layer.label.append("\uD83D\uDD12 ");
            layer.label.append(layer.layerName);
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer.label, {
                position: 'absolute',
                left: 38 + $a4100dd1ad7b3844$var$paddingLeft + 'px',
                top: "1px",
                fontSize: '13px',
                width: '165px',
                height: '20px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            });
            layer.label.ondblclick = ()=>{
                if (isBackground) {
                    // Background layer: open color picker
                    this.applyUncommitted();
                    this._openBackgroundColorPicker(index);
                    return;
                }
                this.applyUncommitted();
                this.renameLayer(layer.spot);
            };
            layer.opacityLabel = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'kl-layer__opacity-label'
            });
            layer.opacity = opacity;
            layer.opacityLabel.append(parseInt('' + layer.opacity * 100) + '%');
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer.opacityLabel, {
                position: 'absolute',
                left: 189 + $a4100dd1ad7b3844$var$paddingLeft + 'px',
                top: "1px",
                fontSize: '13px',
                textAlign: 'right',
                width: '50px',
                transition: 'color 0.2s ease-in-out',
                textDecoration: isVisible ? undefined : 'line-through'
            });
            let oldOpacity;
            const opacitySlider = new (0, $867da577d723d824$export$ac00cea56cec3037)({
                init: layer.opacity,
                width: 200,
                pointSize: 14,
                callback: (sliderValue, isFirst, isLast)=>{
                    if (isFirst) {
                        this.isManipulating = true;
                        oldOpacity = this.klCanvas.getLayerOld(layer.spot).opacity;
                        return;
                    }
                    if (isLast) {
                        this.isManipulating = false;
                        if (oldOpacity !== sliderValue) this.klCanvas.setOpacity(layer.spot, sliderValue);
                        return;
                    }
                    layer.opacityLabel.innerHTML = Math.round(sliderValue * 100) + '%';
                    this.klHistory.pause(true);
                    try {
                        this.klCanvas.setOpacity(layer.spot, sliderValue);
                    } finally{
                        this.klHistory.pause(false);
                    }
                    this.onUpdateProject();
                },
                getDoIgnore: ()=>this.isManipulating
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(opacitySlider.getElement(), {
                position: 'absolute',
                left: 39 + $a4100dd1ad7b3844$var$paddingLeft + 'px',
                top: '17px'
            });
            layer.opacitySlider = opacitySlider;
            //larger layer preview - hover
            layer.thumb.onpointerover = (e)=>{
                if (e.buttons !== 0 && (!e.pointerType || e.pointerType !== 'touch')) //shouldn't show while dragging
                return;
                const thumbDimensions = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(layercanvas.width, layercanvas.height, 250, 250, 1);
                if (this.largeThumbCanvas.width !== thumbDimensions.width || this.largeThumbCanvas.height !== thumbDimensions.height) {
                    this.largeThumbCanvas.width = thumbDimensions.width;
                    this.largeThumbCanvas.height = thumbDimensions.height;
                }
                const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.largeThumbCanvas);
                ctx.save();
                if (this.largeThumbCanvas.width > layercanvas.width) ctx.imageSmoothingEnabled = false;
                ctx.imageSmoothingQuality = 'high';
                ctx.clearRect(0, 0, this.largeThumbCanvas.width, this.largeThumbCanvas.height);
                ctx.drawImage(layercanvas, 0, 0, this.largeThumbCanvas.width, this.largeThumbCanvas.height);
                ctx.restore();
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.largeThumbDiv, {
                    top: e.clientY - this.largeThumbCanvas.height / 2 + 'px',
                    opacity: '0'
                });
                if (!this.largeThumbInDocument) {
                    document.body.append(this.largeThumbDiv);
                    this.largeThumbInDocument = true;
                }
                clearTimeout(this.largeThumbInTimeout);
                this.largeThumbInTimeout = setTimeout(()=>{
                    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.largeThumbDiv, {
                        opacity: '1'
                    });
                }, 20);
                clearTimeout(this.largeThumbTimeout);
            };
            layer.thumb.onpointerout = ()=>{
                clearTimeout(this.largeThumbInTimeout);
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.largeThumbDiv, {
                    opacity: '0'
                });
                clearTimeout(this.largeThumbTimeout);
                this.largeThumbTimeout = setTimeout(()=>{
                    if (!this.largeThumbInDocument) return;
                    this.largeThumbDiv.remove();
                    this.largeThumbInDocument = false;
                }, 300);
            };
            container1.append(layer.thumb, layer.label, layer.opacityLabel, opacitySlider.getElement());
            let dragstart = false;
            let freshSelection = false;
            //events for moving layers up and down
            let isDragging = false;
            const dragEventHandler = (event)=>{
                if (event.type === 'pointerdown' && event.button === 'left' && !this.isManipulating) {
                    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer, {
                        transition: 'box-shadow 0.3s ease-in-out',
                        zIndex: '1'
                    });
                    this.lastpos = layer.spot;
                    freshSelection = false;
                    if (!layer.isSelected) {
                        freshSelection = true;
                        this.activateLayer(layer.spot);
                    }
                    dragstart = true;
                    isDragging = true;
                    this.isManipulating = true;
                } else if (event.type === 'pointermove' && event.button === 'left' && isDragging) {
                    if (dragstart) {
                        dragstart = false;
                        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer, {
                            boxShadow: '1px 3px 5px rgba(0,0,0,0.4)'
                        });
                    }
                    layer.posY += event.dY;
                    const corrected = Math.max(0, Math.min((this.klCanvasLayerArr.length - 1) * 35, layer.posY));
                    layer.style.top = corrected + 'px';
                    this.updateLayersVerticalPosition(layer.spot, this.posToSpot(layer.posY));
                }
                if (event.type === 'pointerup' && isDragging) {
                    this.isManipulating = false;
                    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer, {
                        transition: 'all 0.1s linear'
                    });
                    setTimeout(()=>{
                        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer, {
                            boxShadow: ''
                        });
                    }, 20);
                    layer.posY = Math.max(0, Math.min((this.klCanvasLayerArr.length - 1) * 35, layer.posY));
                    layer.style.zIndex = '';
                    const newSpot = this.posToSpot(layer.posY);
                    const oldSpot = layer.spot;
                    this.move(layer.spot, newSpot);
                    if (oldSpot != newSpot) this.onSelect(this.selectedSpotIndex, false);
                    if (oldSpot === newSpot && freshSelection) {
                        this.applyUncommitted();
                        this.onSelect(this.selectedSpotIndex, true);
                    }
                    freshSelection = false;
                }
            };
            layer.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: container1,
                onPointer: dragEventHandler,
                maxPointers: 1
            });
            // Right-click context menu
            container1.oncontextmenu = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                // Select the layer first
                if (!layer.isSelected) {
                    this.activateLayer(layer.spot);
                    this.applyUncommitted();
                    this.onSelect(layer.spot, true);
                }
                const klLayerInfo = this.klCanvas.getLayer(layer.spot);
                const isBackground = !!klLayerInfo.isBackground;
                const isClipped = !!klLayerInfo.isClipped;
                (0, $233d9c7abf759c47$export$348e85af22e9951b)({
                    x: e.clientX,
                    y: e.clientY,
                    canDelete: this.layerElArr.length > 1 && !isBackground,
                    canMergeDown: layer.spot > 0,
                    canAdd: this.klCanvasLayerArr.length < (0, $d26b85e649dca02a$export$9f4f73b1bd7c2f26),
                    isBackground: isBackground,
                    isClipped: isClipped,
                    canClip: layer.spot > 0 && !isBackground,
                    onAction: (action)=>{
                        this.applyUncommitted();
                        if (action === 'rename') this.renameLayer(layer.spot);
                        else if (action === 'duplicate') {
                            if (this.klCanvas.duplicateLayer(this.selectedSpotIndex) === false) return;
                            this.klCanvasLayerArr = this.klCanvas.getLayers();
                            this.selectedSpotIndex++;
                            this.onSelect(this.selectedSpotIndex, false);
                            this.updateButtons();
                        } else if (action === 'delete') {
                            if (this.layerElArr.length <= 1) return;
                            this.klCanvas.removeLayer(this.selectedSpotIndex);
                            if (this.selectedSpotIndex > 0) this.selectedSpotIndex--;
                            this.klCanvasLayerArr = this.klCanvas.getLayers();
                            this.onSelect(this.selectedSpotIndex, false);
                            this.updateButtons();
                        } else if (action === 'merge-down') {
                            if (this.selectedSpotIndex <= 0) return;
                            this.klCanvas.mergeLayers(this.selectedSpotIndex, this.selectedSpotIndex - 1);
                            this.klCanvasLayerArr = this.klCanvas.getLayers();
                            this.selectedSpotIndex--;
                            this.onSelect(this.selectedSpotIndex, false);
                            this.updateButtons();
                        } else if (action === 'clear') this.onClearLayer();
                        else if (action === 'add-above') {
                            if (this.klCanvas.addLayer(this.selectedSpotIndex) === false) return;
                            this.klCanvasLayerArr = this.klCanvas.getLayers();
                            this.selectedSpotIndex = this.selectedSpotIndex + 1;
                            this.onSelect(this.selectedSpotIndex, false);
                            this.updateButtons();
                        } else if (action === 'add-below') {
                            const belowIndex = Math.max(0, this.selectedSpotIndex - 1);
                            if (this.klCanvas.addLayer(belowIndex) === false) return;
                            this.klCanvasLayerArr = this.klCanvas.getLayers();
                            this.onSelect(this.selectedSpotIndex, false);
                            this.updateButtons();
                        } else if (action === 'toggle-clip') {
                            const currentLayer = this.klCanvas.getLayer(layer.spot);
                            this.klCanvas.setLayerClipped(layer.spot, !currentLayer.isClipped);
                            this.onSelect(layer.spot, false);
                        }
                    }
                });
            };
            this.layerListEl.append(layer);
        };
        this.layerElArr = [];
        while(this.layerListEl.firstChild){
            const child = this.layerListEl.firstChild;
            child.pointerListener.destroy();
            child.opacitySlider.destroy();
            child.remove();
        }
        for(let i = 0; i < this.klCanvasLayerArr.length; i++)createLayerEntry(i);
        this.activateLayer(this.selectedSpotIndex);
        this.updateHeight();
    }
    updateButtons() {
        const maxReached = this.klCanvasLayerArr.length === (0, $d26b85e649dca02a$export$9f4f73b1bd7c2f26);
        const oneLayer = this.klCanvasLayerArr.length === 1;
        const selectedLayer = this.klCanvas.getLayer(this.selectedSpotIndex);
        const isBackground = !!(selectedLayer && selectedLayer.isBackground);
        this.addBtn.disabled = maxReached;
        this.removeBtn.disabled = oneLayer || isBackground;
        this.duplicateBtn.disabled = maxReached;
        this.mergeBtn.disabled = this.selectedSpotIndex === 0;
        this.clipBtn.disabled = this.selectedSpotIndex === 0 || isBackground;
        this.moreDropdown.setEnabled('advanced-merge', !oneLayer);
        this.moreDropdown.setEnabled('merge-all', !oneLayer);
    }
    // ---- interface ----
    update(activeLayerSpotIndex) {
        this.klCanvasLayerArr = this.klCanvas.getLayers();
        if (activeLayerSpotIndex || activeLayerSpotIndex === 0) this.selectedSpotIndex = activeLayerSpotIndex;
        this.updateButtons();
        if (this.isVisible) this.createLayerList();
    }
    getSelected() {
        return this.selectedSpotIndex;
    }
    activateLayer(spotIndex) {
        if (spotIndex < 0 || spotIndex > this.layerElArr.length - 1) throw 'invalid spotIndex ' + spotIndex + ', layerElArr.length ' + this.layerElArr.length;
        this.selectedSpotIndex = spotIndex;
        this.modeSelect.setValue(this.klCanvasLayerArr[this.selectedSpotIndex].mixModeStr);
        for(let i = 0; i < this.layerElArr.length; i++){
            const layer = this.layerElArr[i];
            const isSelected = this.selectedSpotIndex === layer.spot;
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(layer, {
                boxShadow: ''
            });
            layer.classList.toggle('kl-layer--selected', isSelected);
            layer.opacitySlider.setActive(isSelected);
            layer.isSelected = isSelected;
        }
        this.mergeBtn.disabled = this.selectedSpotIndex === 0;
    }
    setUiState(stateStr) {
        this.uiState = stateStr;
        if (this.uiState === 'left') (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.largeThumbDiv, {
            left: '280px',
            right: ''
        });
        else (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.largeThumbDiv, {
            left: '',
            right: '280px'
        });
    }
    getElement() {
        return this.rootEl;
    }
    advancedMergeDialog() {
        this.applyUncommitted();
        if (this.selectedSpotIndex <= 0) return;
        (0, $e304a6ae1452211c$export$ee79aceabae6bb8a)(this.parentEl, {
            topCanvas: this.klCanvasLayerArr[this.selectedSpotIndex].context.canvas,
            bottomCanvas: this.klCanvasLayerArr[this.selectedSpotIndex - 1].context.canvas,
            topOpacity: this.klCanvas.getLayerOld(this.selectedSpotIndex).opacity,
            mixModeStr: this.klCanvasLayerArr[this.selectedSpotIndex].mixModeStr,
            callback: (mode)=>{
                this.klCanvas.mergeLayers(this.selectedSpotIndex, this.selectedSpotIndex - 1, mode);
                this.klCanvasLayerArr = this.klCanvas.getLayers();
                this.selectedSpotIndex--;
                //this.createLayerList();
                this.onSelect(this.selectedSpotIndex, false);
                this.updateButtons();
            }
        });
    }
    setIsVisible(b) {
        if (b === this.isVisible) return;
        this.isVisible = b;
        this.rootEl.style.display = b ? 'block' : 'none';
    }
    getMaskEditLayerIndex() {
        return null;
    }
    exitMaskEditMode() {
    // no-op: mask edit mode removed
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isVisible = true;
        this.isManipulating = false;
        this.lastpos = 0;
        this.layerHeight = 35;
        this.layerSpacing = 0;
        this.klCanvas = p.klCanvas;
        this.onSelect = p.onSelect;
        this.parentEl = p.parentEl;
        this.uiState = p.uiState;
        this.applyUncommitted = p.applyUncommitted;
        this.klHistory = p.klHistory;
        this.onUpdateProject = p.onUpdateProject;
        this.onClearLayer = p.onClearLayer;
        this.onChangeBackgroundColor = p.onChangeBackgroundColor;
        this.layerElArr = [];
        this.layerHeight = 35;
        this.layerSpacing = 0;
        const width = 270;
        this.largeThumbDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            onClick: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).handleClick,
            css: {
                position: 'absolute',
                top: '500px',
                boxShadow: '1px 1px 3px rgba(0,0,0,0.3)',
                pointerEvents: 'none',
                padding: '0',
                border: '1px solid #aaa',
                transition: 'opacity 0.3s ease-out',
                userSelect: 'none',
                background: 'var(--kl-checkerboard-background)'
            }
        });
        this.setUiState(this.uiState);
        this.largeThumbCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(200, 200);
        this.largeThumbCanvas.style.display = 'block';
        this.largeThumbDiv.append(this.largeThumbCanvas);
        this.largeThumbInDocument = false;
        this.klCanvasLayerArr = this.klCanvas.getLayers();
        this.selectedSpotIndex = this.klCanvasLayerArr.length - 1;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                marginRight: '10px',
                marginBottom: '10px',
                marginLeft: '10px',
                marginTop: '10px',
                cursor: 'default',
                position: 'relative',
                zIndex: '0'
            }
        });
        const listDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: width + 'px',
                position: 'relative',
                margin: '0 -10px',
                zIndex: '0'
            }
        });
        this.layerListEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: listDiv
        });
        this.addBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button'
        });
        this.duplicateBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button'
        });
        this.mergeBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button'
        });
        this.removeBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button'
        });
        this.clipBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button'
        });
        const renameBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button'
        });
        this.moreDropdown = new (0, $be599a9dc46f5101$export$e44a253a59704894)({
            button: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($7dc8b75d4dbc1df5$exports)))}" width="13"/>`,
                css: {
                    display: 'flex',
                    justifyContent: 'center',
                    opacity: '0.9'
                }
            }),
            buttonTitle: (0, $63d0b335c576c718$export$ce37e184d908d785)('more'),
            items: [
                [
                    'clear-layer',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-clear'),
                    "\u232B"
                ],
                [
                    'advanced-merge',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-merge-advanced'),
                    'Ctrl + Shift + E'
                ],
                [
                    'merge-all',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-merge-all')
                ]
            ],
            onItemClick: (id)=>{
                if (id === 'clear-layer') {
                    this.applyUncommitted();
                    this.onClearLayer();
                }
                if (id === 'advanced-merge') this.advancedMergeDialog();
                if (id === 'merge-all') {
                    this.applyUncommitted();
                    const newIndex = this.klCanvas.mergeAll();
                    if (newIndex === false) return;
                    this.klCanvasLayerArr = this.klCanvas.getLayers();
                    this.selectedSpotIndex = newIndex;
                    this.onSelect(this.selectedSpotIndex, false);
                    this.updateButtons();
                }
            }
        });
        this.updateButtons();
        const createButtons = ()=>{
            const div = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
            const async = ()=>{
                (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(this.addBtn);
                (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(this.duplicateBtn);
                (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(this.mergeBtn);
                (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(this.removeBtn);
                (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(renameBtn);
                (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(this.clipBtn);
                const commonStyle = {
                    cssFloat: 'left',
                    paddingLeft: '5px',
                    paddingRight: '3px'
                };
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.addBtn, commonStyle);
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.duplicateBtn, commonStyle);
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.mergeBtn, commonStyle);
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.removeBtn, commonStyle);
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(renameBtn, {
                    cssFloat: 'left',
                    height: '30px',
                    lineHeight: '20px'
                });
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.clipBtn, commonStyle);
                this.addBtn.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-new');
                this.duplicateBtn.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-duplicate');
                this.removeBtn.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-remove');
                this.mergeBtn.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-merge');
                renameBtn.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-rename-title');
                this.clipBtn.title = 'Clip to Layer Below';
                this.addBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($4dde6a6ccaabd5ab$exports))) + "' height='20'/>";
                this.duplicateBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($0ecce9fc138ec1e3$exports))) + "' height='20'/>";
                this.mergeBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($be3ab0e4c204533c$exports))) + "' height='20'/>";
                this.removeBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($03e87c70019af696$exports))) + "' height='20'/>";
                renameBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($7444ed87edb442c4$exports))) + "' height='20'/>";
                this.clipBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($9ec1d0f2e5b91b12$exports))) + "' height='20'/>";
                div.append((0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,gap-5,mb-10', [
                    this.addBtn,
                    this.removeBtn,
                    this.duplicateBtn,
                    this.mergeBtn,
                    renameBtn,
                    this.clipBtn,
                    (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',grow-1'),
                    this.moreDropdown.getElement()
                ]));
                this.addBtn.onclick = ()=>{
                    this.applyUncommitted();
                    if (this.klCanvas.addLayer(this.selectedSpotIndex) === false) return;
                    this.klCanvasLayerArr = this.klCanvas.getLayers();
                    this.selectedSpotIndex = this.selectedSpotIndex + 1;
                    this.onSelect(this.selectedSpotIndex, false);
                    this.updateButtons();
                };
                this.duplicateBtn.onclick = ()=>{
                    this.applyUncommitted();
                    if (this.klCanvas.duplicateLayer(this.selectedSpotIndex) === false) return;
                    this.klCanvasLayerArr = this.klCanvas.getLayers();
                    this.selectedSpotIndex++;
                    this.onSelect(this.selectedSpotIndex, false);
                    this.updateButtons();
                };
                this.removeBtn.onclick = ()=>{
                    this.applyUncommitted();
                    if (this.layerElArr.length <= 1) return;
                    this.klCanvas.removeLayer(this.selectedSpotIndex);
                    if (this.selectedSpotIndex > 0) this.selectedSpotIndex--;
                    this.klCanvasLayerArr = this.klCanvas.getLayers();
                    this.onSelect(this.selectedSpotIndex, false);
                    this.updateButtons();
                };
                this.mergeBtn.onclick = ()=>{
                    // fast merge
                    this.applyUncommitted();
                    if (this.selectedSpotIndex <= 0) return;
                    this.klCanvas.mergeLayers(this.selectedSpotIndex, this.selectedSpotIndex - 1);
                    this.klCanvasLayerArr = this.klCanvas.getLayers();
                    this.selectedSpotIndex--;
                    this.onSelect(this.selectedSpotIndex, false);
                    this.updateButtons();
                };
                renameBtn.onclick = ()=>{
                    this.applyUncommitted();
                    this.renameLayer(this.selectedSpotIndex);
                };
                this.clipBtn.onclick = ()=>{
                    this.applyUncommitted();
                    const currentLayer = this.klCanvas.getLayer(this.selectedSpotIndex);
                    this.klCanvas.setLayerClipped(this.selectedSpotIndex, !currentLayer.isClipped);
                    this.onSelect(this.selectedSpotIndex, false);
                };
            };
            setTimeout(async, 1);
            return div;
        };
        this.rootEl.append(createButtons());
        let modeWrapper;
        modeWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-blending') + '&nbsp;',
            css: {
                fontSize: '15px'
            }
        });
        this.modeSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
            optionArr: [
                'source-over',
                undefined,
                'darken',
                'multiply',
                'color-burn',
                undefined,
                'lighten',
                'screen',
                'color-dodge',
                undefined,
                'overlay',
                'soft-light',
                'hard-light',
                undefined,
                'difference',
                'exclusion',
                undefined,
                'hue',
                'saturation',
                'color',
                'luminosity'
            ].map((item)=>{
                return item ? [
                    item,
                    (0, $326f2f7e3662b29f$export$6e1bedb2a6cdff30)(item)
                ] : undefined;
            }),
            onChange: (val)=>{
                this.klCanvas.setMixMode(this.selectedSpotIndex, val);
                this.update(this.selectedSpotIndex);
            },
            css: {
                marginBottom: '10px'
            },
            name: 'layer-blend-mode'
        });
        modeWrapper.append(this.modeSelect.getElement());
        this.rootEl.append(modeWrapper);
        this.rootEl.append(listDiv);
        this.klHistory.addListener(()=>{
            if (this.rootEl.style.display !== 'block') return;
            this.createLayerList();
        });
        this.createLayerList();
    }
}




class $1ac505c1a3109a32$export$e258ade1648009b7 {
    getElement() {
        return this.canvas;
    }
    render() {
        if (!this.ctx) return;
        this.ctx.save();
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        for(let i = 0; i < this.layers.length; i++){
            const layer = this.layers[i];
            if (!layer.isVisible || layer.opacity === 0) continue;
            this.ctx.globalAlpha = this.layers[i].opacity;
            this.ctx.globalCompositeOperation = this.layers[i].mixModeStr;
            if (this.canvas.width > this.layers[i].image.width) this.ctx.imageSmoothingEnabled = false;
            this.ctx.drawImage(this.layers[i].image, 0, 0, this.canvas.width, this.canvas.height);
        }
        this.ctx.restore();
    }
    destroy() {}
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.layers = p.layers;
        const scale = p.width / p.layers[0].image.width;
        const width = scale > 1 ? p.layers[0].image.width : p.width;
        const height = scale > 1 ? p.layers[0].image.height : p.height;
        this.canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(width, height);
        this.ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.canvas);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.canvas, {
            width: '100%',
            height: '100%',
            imageRendering: scale > 1 ? 'pixelated' : undefined,
            background: 'var(--kl-checkerboard-background)',
            backgroundSize: '16px'
        });
        setTimeout(()=>this.render(), 0);
    }
}




var $69ac20eb6dca0794$exports = {};
$69ac20eb6dca0794$exports = $parcel$resolve("8BBCz");



function $9e052f3767af1736$export$958c2bfe8d7142a9(transform) {
    transform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(transform);
    if (Math.abs(transform.angleDeg) % 90 !== 0) return transform;
    transform.width = Math.round(transform.width);
    transform.height = Math.round(transform.height);
    // 0° is original orientation.
    // At 90° and 270° width and height become swapped due to different orientation.
    const whSwapped = Math.abs(transform.angleDeg - 90) % 180 === 0;
    transform.x = (whSwapped ? transform.height : transform.width) % 2 === 0 ? Math.round(transform.x) : Math.round(transform.x - 0.5) + 0.5;
    transform.y = (whSwapped ? transform.width : transform.height) % 2 === 0 ? Math.round(transform.y) : Math.round(transform.y - 0.5) + 0.5;
    return transform;
}
function $9e052f3767af1736$export$6a4549ec4168874a(x, y, transform) {
    let px, py;
    px = x - transform.x;
    py = y - transform.y;
    const rot = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotateAround({
        x: 0,
        y: 0
    }, {
        x: px,
        y: py
    }, -transform.angleDeg);
    px = rot.x;
    py = rot.y;
    return {
        x: px,
        y: py
    };
}
function $9e052f3767af1736$export$3fba3b383c654cc6(x, y, transform) {
    const rot = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotateAround({
        x: 0,
        y: 0
    }, {
        x: x,
        y: y
    }, transform.angleDeg);
    return {
        x: rot.x + transform.x,
        y: rot.y + transform.y
    };
}






const $d42d1384577ab84d$var$gripSize = 16;
const $d42d1384577ab84d$var$edgeSize = 10;
// 0 - east
function $d42d1384577ab84d$var$angleDegToCursor(angleDeg) {
    const cursors = [
        'e',
        'ne',
        'n',
        'nw',
        'w',
        'sw',
        's',
        'se'
    ];
    while(angleDeg < 0)angleDeg += 360;
    const index = Math.round(angleDeg / 45) % cursors.length;
    return cursors[index] + '-resize';
}
class $d42d1384577ab84d$export$79a74567acf241b0 {
    updateScaled() {
        const viewportMatrix = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewportTransform);
        const centerInViewport = (0, $855520c81dfcb96a$export$9b20165a36586806)(viewportMatrix, {
            x: this.value.x,
            y: this.value.y
        });
        this.rectInViewport.x = centerInViewport.x;
        this.rectInViewport.y = centerInViewport.y;
        this.rectInViewport.width = this.value.width * this.viewportTransform.scale;
        this.rectInViewport.height = this.value.height * this.viewportTransform.scale;
        this.rectInViewport.corners = this.corners.map((item)=>{
            return {
                x: item.x * this.viewportTransform.scale,
                y: item.y * this.viewportTransform.scale
            };
        });
    }
    /**
     * Returns snapped point, if ix, iy snaps. If no snapping, returns point unchanged.
     * both in image space
     *
     * @param iX - image space
     * @param iY - image space
     * @private
     */ snapCorner(iX, iY) {
        if (!this.snappingEnabled) return {
            x: iX,
            y: iY
        };
        let dist;
        const snap = {
            x: undefined,
            y: undefined,
            dist: {
                x: undefined,
                y: undefined
            }
        };
        for(let e = 0; e < this.snapX.length; e++){
            dist = Math.abs(iX - this.snapX[e]);
            if (dist < this.minSnapDist / this.viewportTransform.scale) {
                if (snap.x === undefined || dist < snap.dist.x) {
                    snap.x = this.snapX[e];
                    snap.dist.x = dist;
                }
            }
        }
        for(let e = 0; e < this.snapY.length; e++){
            dist = Math.abs(iY - this.snapY[e]);
            if (dist < this.minSnapDist / this.viewportTransform.scale) {
                if (snap.y === undefined || dist < snap.dist.y) {
                    snap.y = this.snapY[e];
                    snap.dist.y = dist;
                }
            }
        }
        if (snap.x === undefined && snap.y === undefined) return {
            x: iX,
            y: iY
        };
        var _snap_x, _snap_y;
        return {
            x: (_snap_x = snap.x) !== null && _snap_x !== void 0 ? _snap_x : iX,
            y: (_snap_y = snap.y) !== null && _snap_y !== void 0 ? _snap_y : iY
        };
    }
    /**
     * If constrained return nearest corner pos that fits aspect ratio
     *
     * @param cornerIndex
     * @param iX
     * @param iY
     * @private
     */ constrainCorner(cornerIndex, iX, iY) {
        if (!this.isConstrained) return {
            x: iX,
            y: iY
        };
        const flip = this.value.width * this.value.height < 0 ? -1 : 1;
        return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).projectPointOnLine({
            x: this.value.x,
            y: this.value.y
        }, (0, $9e052f3767af1736$export$3fba3b383c654cc6)(this.ratio, flip * ([
            0,
            2
        ].includes(cornerIndex) ? 1 : -1), this.value), {
            x: iX,
            y: iY
        });
    }
    /**
     * Update corners according to width height.
     * Not their DOM.
     */ updateCornerPositions() {
        this.corners[0].x = -this.value.width / 2; // top left
        this.corners[0].y = -this.value.height / 2;
        this.corners[1].x = this.value.width / 2; // top right
        this.corners[1].y = -this.value.height / 2;
        this.corners[2].x = this.value.width / 2; // bottom right
        this.corners[2].y = this.value.height / 2;
        this.corners[3].x = -this.value.width / 2; // bottom left
        this.corners[3].y = this.value.height / 2;
    }
    /**
     * If constrained and dragging an edge, restore aspect ratio
     * Updates corner positions.
     *
     * @param widthChanged
     * @param heightChanged
     * @private
     */ restoreRatio(widthChanged, heightChanged) {
        if (!this.isConstrained) return;
        const angle90 = Math.abs(this.value.angleDeg) % 90 === 0;
        const whSwapped = Math.abs(this.value.angleDeg - 90) % 180 === 0;
        if (heightChanged && !widthChanged) {
            const newHeight = Math.abs(this.corners[3].y - this.corners[0].y);
            let newWidth = this.ratio * newHeight;
            if (angle90) newWidth = (whSwapped ? this.value.y % 1 : this.value.x % 1) === 0 ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).roundEven(newWidth) : (0, $d9f9f4926aa80a1c$export$921068d8846a1559).roundUneven(newWidth);
            if (this.corners[1].x - this.corners[0].x < 0) newWidth *= -1;
            this.corners[0].x = -newWidth / 2;
            this.corners[3].x = -newWidth / 2;
            this.corners[1].x = newWidth / 2;
            this.corners[2].x = newWidth / 2;
        }
        if (!heightChanged && widthChanged) {
            const newWidth = Math.abs(this.corners[0].x - this.corners[1].x);
            let newHeight = newWidth / this.ratio;
            if (angle90) newHeight = (whSwapped ? this.value.x % 1 : this.value.y % 1) === 0 ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).roundEven(newHeight) : (0, $d9f9f4926aa80a1c$export$921068d8846a1559).roundUneven(newHeight);
            if (this.corners[3].y - this.corners[0].y < 0) newHeight *= -1;
            this.corners[0].y = -newHeight / 2;
            this.corners[1].y = -newHeight / 2;
            this.corners[2].y = newHeight / 2;
            this.corners[3].y = newHeight / 2;
        }
    }
    /**
     * update transform based on corners
     * @private
     */ updateTransformViaCorners() {
        // calc transform center in image space
        const rot = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotateAround({
            x: 0,
            y: 0
        }, {
            x: (this.corners[0].x + this.corners[1].x) / 2,
            y: (this.corners[0].y + this.corners[3].y) / 2
        }, this.value.angleDeg);
        this.value.x = rot.x + this.value.x;
        this.value.y = rot.y + this.value.y;
        // update size
        this.value.width = this.corners[1].x - this.corners[0].x;
        this.value.height = this.corners[3].y - this.corners[0].y;
        // new center means corners changed their position
        this.updateCornerPositions();
        this.updateDOM();
    }
    /**
     * updates DOM according to transform
     * @param skipCallback
     */ updateDOM(skipCallback) {
        this.updateScaled();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.transEl, {
            left: this.rectInViewport.x + 'px',
            top: this.rectInViewport.y + 'px',
            transformOrigin: '0 0',
            transform: 'rotate(' + (this.value.angleDeg + this.viewportTransform.angleDeg) + 'deg)'
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.boundsEl, {
            width: Math.abs(this.rectInViewport.width) + 'px',
            height: Math.abs(this.rectInViewport.height) + 'px',
            left: Math.min(this.rectInViewport.corners[0].x, this.rectInViewport.corners[1].x) + 'px',
            top: Math.min(this.rectInViewport.corners[0].y, this.rectInViewport.corners[3].y) + 'px'
        });
        this.corners[0].updateDOM();
        this.corners[1].updateDOM();
        this.corners[2].updateDOM();
        this.corners[3].updateDOM();
        this.edges[0].updateDOM();
        this.edges[1].updateDOM();
        this.edges[2].updateDOM();
        this.edges[3].updateDOM();
        this.angleGrip.x = 0;
        this.angleGrip.y = -Math.abs(this.value.height * this.viewportTransform.scale) / 2 - 20;
        this.angleGrip.updateDOM();
        if (!skipCallback) {
            if (this.callback) // why should updateDOM trigger the callback?
            this.callback((0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.value));
        }
    }
    getValue() {
        return (0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.value);
    }
    setIsConstrained(b) {
        this.isConstrained = b;
        if (b && this.value.width !== 0 && this.value.height !== 0) this.ratio = Math.abs(this.value.width / this.value.height);
    }
    setSnapping(b) {
        this.snappingEnabled = b;
    }
    setSnappingPoints(snapX, snapY) {
        this.snapX = snapX;
        this.snapY = snapY;
    }
    setPos(p) {
        this.value.x = p.x;
        this.value.y = p.y;
        this.updateDOM(true);
    }
    move(dX, dY) {
        this.value.x += dX;
        this.value.y += dY;
        this.updateDOM(false);
    }
    setSize(w, h) {
        this.value.width = w;
        this.value.height = h;
        if (Math.abs(this.value.angleDeg) % 90 === 0) this.value = (0, $9e052f3767af1736$export$958c2bfe8d7142a9)(this.value);
        this.updateCornerPositions();
        this.updateDOM(false);
    }
    initialise(transform) {
        this.value.x = transform.x;
        this.value.y = transform.y;
        this.value.width = transform.width;
        this.value.height = transform.height;
        this.value.angleDeg = transform.angleDeg;
        this.ratio = Math.abs(transform.width / transform.height);
        this.updateCornerPositions();
        this.updateDOM(true);
    }
    setAngleDeg(a) {
        this.value.angleDeg = a;
        if (Math.abs(this.value.angleDeg) % 90 === 0) {
            this.value = (0, $9e052f3767af1736$export$958c2bfe8d7142a9)(this.value);
            this.updateCornerPositions();
        }
        this.updateDOM(true);
    }
    setViewportTransform(transform) {
        this.viewportTransform = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform);
        this.updateScaled();
        // skip callback because viewport change does not affect the value
        this.updateDOM(true);
    }
    getElement() {
        return this.rootEl;
    }
    getRatio() {
        return this.ratio;
    }
    destroy() {
        this.keyListener.destroy();
        this.boundsPointerListener.destroy();
        this.corners.forEach((item)=>item.pointerListener.destroy());
        this.edges.forEach((item)=>item.pointerListener.destroy());
        this.anglePointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rectInViewport = {
            // x and y in center of rect
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            // relative to center of rect. without rotation.
            corners: [
                {
                    x: 0,
                    y: 0
                }
            ]
        };
        this.minSnapDist = 7 // minimal snapping distance in px viewport space
        ;
        this.corners = [];
        this.edges = [];
        this.viewportTransform = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.viewportTransform);
        this.value = {
            // coordinates and dimensions of transformation
            x: p.x,
            y: p.y,
            width: p.width,
            height: p.height,
            angleDeg: p.angleDeg
        };
        this.isConstrained = p.isConstrained;
        this.snapX = p.snapX;
        this.snapY = p.snapY;
        this.callback = p.callback;
        this.snappingEnabled = true;
        this.ratio = this.value.width / this.value.height;
        const onWheel = p.onWheel ? (e)=>{
            if (!p.onWheel || !p.wheelParent) return;
            const parentRect = p.wheelParent.getBoundingClientRect();
            e.relX = e.pageX - parentRect.left;
            e.relY = e.pageY - parentRect.top;
            p.onWheel(e);
        } : undefined;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-free-transform',
            css: {
                userSelect: 'none'
            }
        });
        this.transEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                position: 'absolute'
            }
        });
        this.boundsEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                cursor: 'move',
                boxShadow: 'rgba(255, 255, 255, 0.5) 0 0 0 1px inset, rgba(0, 0, 0, 0.5) 0 0 0 1px'
            }
        });
        const pointerRemainder = {
            x: 0,
            y: 0
        };
        function resetRemainder() {
            pointerRemainder.x = 0;
            pointerRemainder.y = 0;
        }
        this.keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({});
        let boundsStartP = {
            x: 0,
            y: 0
        };
        this.boundsPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.boundsEl,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointerdown') boundsStartP = {
                    x: this.value.x,
                    y: this.value.y
                };
                if (event.type === 'pointermove' && event.button === 'left') {
                    const viewportMatrix = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewportTransform);
                    const originInCanvas = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(viewportMatrix), {
                        x: event.downPageX,
                        y: event.downPageY
                    });
                    const deltaInCanvas = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(viewportMatrix), {
                        x: event.pageX,
                        y: event.pageY
                    });
                    const delta = {
                        x: deltaInCanvas.x - originInCanvas.x,
                        y: deltaInCanvas.y - originInCanvas.y
                    };
                    this.value.x = boundsStartP.x + delta.x;
                    this.value.y = boundsStartP.y + delta.y;
                    let dist;
                    let snap = {
                        distX: -1,
                        distY: -1
                    };
                    if (this.snappingEnabled) {
                        let i;
                        for(i = 0; i < this.snapX.length; i++){
                            dist = Math.abs(this.value.x - this.snapX[i]);
                            if (dist < this.minSnapDist / this.viewportTransform.scale) {
                                if (snap.x === undefined || dist < snap.distX) {
                                    snap.x = this.snapX[i];
                                    snap.distX = dist;
                                }
                            }
                        }
                        for(i = 0; i < this.snapY.length; i++){
                            dist = Math.abs(this.value.y - this.snapY[i]);
                            if (dist < this.minSnapDist / this.viewportTransform.scale) {
                                if (snap.y === undefined || dist < snap.distY) {
                                    snap.y = this.snapY[i];
                                    snap.distY = dist;
                                }
                            }
                        }
                        let iP;
                        for(i = 0; i < 4; i++){
                            iP = (0, $9e052f3767af1736$export$3fba3b383c654cc6)(this.corners[i].x, this.corners[i].y, this.value);
                            let j;
                            for(j = 0; j < this.snapX.length; j++){
                                dist = Math.abs(iP.x - this.snapX[j]);
                                if (dist < this.minSnapDist / this.viewportTransform.scale) {
                                    if (snap.x === undefined || dist < snap.distX) {
                                        snap.x = this.snapX[j] - (iP.x - this.value.x);
                                        snap.distX = dist;
                                    }
                                }
                            }
                            for(j = 0; j < this.snapY.length; j++){
                                dist = Math.abs(iP.y - this.snapY[j]);
                                if (dist < this.minSnapDist / this.viewportTransform.scale) {
                                    if (snap.y === undefined || dist < snap.distY) {
                                        snap.y = this.snapY[j] - (iP.y - this.value.y);
                                        snap.distY = dist;
                                    }
                                }
                            }
                        }
                    }
                    if (this.keyListener.getComboStr() === 'shift') {
                        let projected = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).projectPointOnLine({
                            x: 0,
                            y: boundsStartP.y
                        }, {
                            x: 10,
                            y: boundsStartP.y
                        }, {
                            x: this.value.x,
                            y: this.value.y
                        });
                        let dist = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).dist(projected.x, projected.y, this.value.x, this.value.y);
                        snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist,
                            distY: dist
                        };
                        projected = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).projectPointOnLine({
                            x: boundsStartP.x,
                            y: 0
                        }, {
                            x: boundsStartP.x,
                            y: 10
                        }, {
                            x: this.value.x,
                            y: this.value.y
                        });
                        dist = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).dist(projected.x, projected.y, this.value.x, this.value.y);
                        if (dist < snap.distX) snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist,
                            distY: dist
                        };
                        projected = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).projectPointOnLine({
                            x: boundsStartP.x,
                            y: boundsStartP.y
                        }, {
                            x: boundsStartP.x + 1,
                            y: boundsStartP.y + 1
                        }, {
                            x: this.value.x,
                            y: this.value.y
                        });
                        dist = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).dist(projected.x, projected.y, this.value.x, this.value.y);
                        if (dist < snap.distX) snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist,
                            distY: dist
                        };
                        projected = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).projectPointOnLine({
                            x: boundsStartP.x,
                            y: boundsStartP.y
                        }, {
                            x: boundsStartP.x + 1,
                            y: boundsStartP.y - 1
                        }, {
                            x: this.value.x,
                            y: this.value.y
                        });
                        dist = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).dist(projected.x, projected.y, this.value.x, this.value.y);
                        if (dist < snap.distX) snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist,
                            distY: dist
                        };
                    }
                    if (snap.x != undefined) this.value.x = snap.x;
                    if (snap.y != undefined) this.value.y = snap.y;
                    // snap to pixels
                    if (Math.abs(this.value.angleDeg) % 90 === 0) {
                        this.value = (0, $9e052f3767af1736$export$958c2bfe8d7142a9)(this.value);
                        this.updateCornerPositions();
                    }
                    this.updateDOM();
                }
            },
            useDirtyWheel: true,
            onWheel: onWheel
        });
        for(let i = 0; i < 4; i++)((i)=>{
            const g = this.corners[i] = {
                i: i,
                el: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    css: {
                        width: $d42d1384577ab84d$var$gripSize + 'px',
                        height: $d42d1384577ab84d$var$gripSize + 'px',
                        background: '#fff',
                        /*background: [
                                '#ff0000',
                                '#00ff00',
                                '#0000ff',
                                '#ff00ff',
                            ][i],*/ borderRadius: $d42d1384577ab84d$var$gripSize + 'px',
                        position: 'absolute',
                        border: '2px solid #000'
                    }
                }),
                x: 0,
                y: 0,
                virtualPos: {
                    x: 0,
                    y: 0
                }
            };
            g.updateDOM = ()=>{
                // grip position
                // if it gets small: slightly offset grips, so easier to handle
                const offsetArr = [
                    [
                        -1,
                        -1
                    ],
                    [
                        1,
                        -1
                    ],
                    [
                        1,
                        1
                    ],
                    [
                        -1,
                        1
                    ]
                ].map((item)=>{
                    item[0] *= this.value.width > 0 ? 1 : -1;
                    item[1] *= this.value.height > 0 ? 1 : -1;
                    return item;
                });
                const tinyOffset = Math.abs(this.rectInViewport.width) < 20 || Math.abs(this.rectInViewport.height) < 20 ? 10 : 0;
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g.el, {
                    left: this.rectInViewport.corners[g.i].x - $d42d1384577ab84d$var$gripSize / 2 + offsetArr[i][0] * tinyOffset + 'px',
                    top: this.rectInViewport.corners[g.i].y - $d42d1384577ab84d$var$gripSize / 2 + offsetArr[i][1] * tinyOffset + 'px'
                });
                // cursor
                const xMult = this.value.width < 0 ? -1 : 1;
                const yMult = this.value.height < 0 ? -1 : 1;
                const cornerVectors = [
                    {
                        x: -1,
                        y: -1
                    },
                    {
                        x: 1,
                        y: -1
                    },
                    {
                        x: 1,
                        y: 1
                    },
                    {
                        x: -1,
                        y: 1
                    }
                ];
                const cornerVector = {
                    x: cornerVectors[i].x * xMult,
                    y: cornerVectors[i].y * yMult * -1
                };
                const angleDeg = (0, $9414f5ea41e9cf25$export$c03a8450eabc2532)({
                    x: 0,
                    y: 0
                }, cornerVector) - this.value.angleDeg - this.viewportTransform.angleDeg;
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g.el, {
                    cursor: $d42d1384577ab84d$var$angleDegToCursor(angleDeg)
                });
            };
            g.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: this.corners[i].el,
                fixScribble: true,
                onPointer: (event)=>{
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown' && event.button === 'left') this.corners[i].virtualPos = (0, $9e052f3767af1736$export$3fba3b383c654cc6)(this.corners[i].x, this.corners[i].y, this.value);
                    else if (event.type === 'pointermove' && event.button === 'left') {
                        const viewportMatrix = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewportTransform);
                        const originInCanvas = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(viewportMatrix), {
                            x: 0,
                            y: 0
                        });
                        const deltaInCanvas = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(viewportMatrix), {
                            x: event.dX,
                            y: event.dY
                        });
                        const delta = {
                            x: deltaInCanvas.x - originInCanvas.x,
                            y: deltaInCanvas.y - originInCanvas.y
                        };
                        this.corners[i].virtualPos.x += delta.x;
                        this.corners[i].virtualPos.y += delta.y;
                        let iP = {
                            x: this.corners[i].virtualPos.x,
                            y: this.corners[i].virtualPos.y
                        };
                        iP = this.constrainCorner(i, iP.x, iP.y);
                        if (!this.isConstrained) iP = this.snapCorner(iP.x, iP.y);
                        if (Math.abs(this.value.angleDeg) % 90 === 0) {
                            iP.x = Math.round(iP.x);
                            iP.y = Math.round(iP.y);
                        }
                        const tP = (0, $9e052f3767af1736$export$6a4549ec4168874a)(iP.x, iP.y, this.value);
                        const dX = tP.x - this.corners[i].x;
                        const dY = tP.y - this.corners[i].y;
                        this.corners[i].x = tP.x;
                        this.corners[i].y = tP.y;
                        let indexes = [];
                        if (i === 0) // top left
                        indexes = [
                            3,
                            1,
                            2
                        ];
                        else if (i === 1) // top right
                        indexes = [
                            2,
                            0,
                            3
                        ];
                        else if (i === 2) // bottom right
                        indexes = [
                            1,
                            3,
                            0
                        ];
                        else if (i === 3) // bottom left
                        indexes = [
                            0,
                            2,
                            1
                        ];
                        this.corners[indexes[0]].x = this.corners[i].x;
                        this.corners[indexes[1]].y = this.corners[i].y;
                        if (this.keyListener.isPressed('shift')) {
                            this.corners[indexes[2]].x -= dX;
                            this.corners[indexes[2]].y -= dY;
                            this.corners[indexes[1]].x = this.corners[indexes[2]].x;
                            this.corners[indexes[0]].y = this.corners[indexes[2]].y;
                        }
                        this.updateTransformViaCorners();
                    }
                },
                useDirtyWheel: true,
                onWheel: onWheel
            });
        })(i);
        this.updateCornerPositions();
        this.updateScaled();
        let isInverted;
        for(let i = 0; i < 4; i++)((i)=>{
            this.edges[i] = {
                el: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    css: {
                        width: $d42d1384577ab84d$var$edgeSize + 'px',
                        height: $d42d1384577ab84d$var$edgeSize + 'px',
                        //background: ['red', 'green', 'blue', 'orange'][i],
                        position: 'absolute'
                    }
                })
            };
            const g = this.edges[i];
            g.updateDOM = ()=>{
                if (i === 0) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g.el, {
                    left: Math.min(this.rectInViewport.corners[0].x, this.rectInViewport.corners[1].x) + 'px',
                    top: Math.min(this.rectInViewport.corners[0].y, this.rectInViewport.corners[3].y) - $d42d1384577ab84d$var$edgeSize + 'px',
                    width: Math.abs(this.rectInViewport.width) + 'px',
                    height: $d42d1384577ab84d$var$edgeSize + 'px'
                });
                else if (i === 1) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g.el, {
                    left: Math.max(this.rectInViewport.corners[0].x, this.rectInViewport.corners[1].x) + 'px',
                    top: Math.min(this.rectInViewport.corners[1].y, this.rectInViewport.corners[2].y) + 'px',
                    width: $d42d1384577ab84d$var$edgeSize + 'px',
                    height: Math.abs(this.rectInViewport.height) + 'px'
                });
                else if (i === 2) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g.el, {
                    left: Math.min(this.rectInViewport.corners[3].x, this.rectInViewport.corners[2].x) + 'px',
                    top: Math.max(this.rectInViewport.corners[0].y, this.rectInViewport.corners[3].y) + 'px',
                    width: Math.abs(this.rectInViewport.width) + 'px',
                    height: $d42d1384577ab84d$var$edgeSize + 'px'
                });
                else if (i === 3) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g.el, {
                    left: Math.min(this.rectInViewport.corners[0].x, this.rectInViewport.corners[1].x) - $d42d1384577ab84d$var$edgeSize + 'px',
                    top: Math.min(this.rectInViewport.corners[0].y, this.rectInViewport.corners[3].y) + 'px',
                    width: $d42d1384577ab84d$var$edgeSize + 'px',
                    height: Math.abs(this.rectInViewport.height) + 'px'
                });
                const xFlipped = this.value.width < 0;
                const yFlipped = this.value.height < 0;
                const angles = [
                    yFlipped ? -90 : 90,
                    xFlipped ? 180 : 0,
                    yFlipped ? 90 : -90,
                    xFlipped ? 0 : 180
                ];
                const angleDeg = angles[i] - this.value.angleDeg - this.viewportTransform.angleDeg;
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g.el, {
                    cursor: $d42d1384577ab84d$var$angleDegToCursor(angleDeg)
                });
            };
            const isVertical = [
                0,
                2
            ].includes(i);
            g.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: this.edges[i].el,
                fixScribble: true,
                onPointer: (event)=>{
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown' && event.button === 'left') {
                        if (isVertical) // top bottom
                        isInverted = this.corners[0].y >= this.corners[3].y;
                        else // left right
                        isInverted = this.corners[0].x >= this.corners[1].x;
                        resetRemainder();
                    }
                    if (event.type === 'pointermove' && event.button === 'left') {
                        const viewportMatrix = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewportTransform);
                        const originInCanvas = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(viewportMatrix), {
                            x: 0,
                            y: 0
                        });
                        const deltaInCanvas = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(viewportMatrix), {
                            x: event.dX,
                            y: event.dY
                        });
                        const originInTransform = (0, $9e052f3767af1736$export$6a4549ec4168874a)(originInCanvas.x, originInCanvas.y, this.value);
                        const deltaInTransform = (0, $9e052f3767af1736$export$6a4549ec4168874a)(deltaInCanvas.x, deltaInCanvas.y, this.value);
                        const tfD = {
                            x: deltaInTransform.x - originInTransform.x,
                            y: deltaInTransform.y - originInTransform.y
                        };
                        let ti = {
                            dX: tfD.x,
                            dY: tfD.y
                        };
                        if (Math.abs(this.value.angleDeg) % 90 === 0) ti = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(pointerRemainder, tfD.x, tfD.y);
                        let indexes = [];
                        if (i === 0) // top
                        indexes = [
                            2,
                            3,
                            0,
                            1
                        ];
                        else if (i === 1) // right
                        indexes = [
                            0,
                            3,
                            1,
                            2
                        ];
                        else if (i === 2) // bottom
                        indexes = [
                            0,
                            1,
                            2,
                            3
                        ];
                        else if (i === 3) // left
                        indexes = [
                            1,
                            2,
                            0,
                            3
                        ];
                        const dimension = isVertical ? 'y' : 'x';
                        const d = isVertical ? ti.dY : ti.dX;
                        if (isInverted) {
                            this.corners[indexes[0]][dimension] += d;
                            this.corners[indexes[1]][dimension] += d;
                        } else {
                            this.corners[indexes[2]][dimension] += d;
                            this.corners[indexes[3]][dimension] += d;
                        }
                        if (this.keyListener.isPressed('shift')) {
                            if (isInverted) {
                                this.corners[indexes[2]][dimension] -= d;
                                this.corners[indexes[3]][dimension] -= d;
                            } else {
                                this.corners[indexes[0]][dimension] -= d;
                                this.corners[indexes[1]][dimension] -= d;
                            }
                        }
                        if (isVertical) // top bottom
                        this.restoreRatio(false, true);
                        else // left right
                        this.restoreRatio(true, false);
                        this.updateTransformViaCorners();
                    }
                },
                useDirtyWheel: true,
                onWheel: onWheel
            });
        })(i);
        this.angleGrip = {
            el: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    cursor: 'url(' + (0, (/*@__PURE__*/$parcel$interopDefault($69ac20eb6dca0794$exports))) + ') 10 10, move',
                    width: $d42d1384577ab84d$var$gripSize + 'px',
                    height: $d42d1384577ab84d$var$gripSize + 'px',
                    background: '#0ff',
                    borderRadius: $d42d1384577ab84d$var$gripSize + 'px',
                    position: 'absolute',
                    boxShadow: 'inset 0 0 0 2px #000'
                }
            }),
            x: 0,
            y: 0,
            snap: false,
            updateDOM: ()=>{
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.angleGrip.el, {
                    left: this.angleGrip.x - $d42d1384577ab84d$var$gripSize / 2 + 'px',
                    top: this.angleGrip.y - $d42d1384577ab84d$var$gripSize / 2 + 'px'
                });
            }
        };
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.angleGrip.el,
            css: {
                width: '2px',
                height: '13px',
                left: $d42d1384577ab84d$var$gripSize / 2 - 1 + 'px',
                top: $d42d1384577ab84d$var$gripSize + 'px',
                background: '#0ff',
                position: 'absolute'
            }
        });
        this.anglePointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.angleGrip.el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const viewportMatrix = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewportTransform);
                    const rootBoundingClientRect = this.rootEl.getBoundingClientRect();
                    const cursorInViewportPosition = {
                        x: event.clientX - rootBoundingClientRect.left,
                        y: event.clientY - rootBoundingClientRect.top
                    };
                    const cursorInCanvasPosition = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(viewportMatrix), cursorInViewportPosition);
                    const a = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).pointsToAngleDeg({
                        x: this.value.x,
                        y: this.value.y
                    }, cursorInCanvasPosition) + 90;
                    this.value.angleDeg = a;
                    const snapDeg = Math.round(a / 360 * 8) * 45;
                    if (this.keyListener.getComboStr() === 'shift') this.value.angleDeg = snapDeg;
                    else if (this.snappingEnabled && Math.abs(snapDeg - a) < 8) this.value.angleDeg = snapDeg;
                    this.updateDOM();
                }
                if (event.type === 'pointerup') {
                    if (Math.abs(this.value.angleDeg) % 90 === 0) {
                        this.value = (0, $9e052f3767af1736$export$958c2bfe8d7142a9)(this.value);
                        this.updateCornerPositions();
                        this.updateDOM();
                    }
                }
            },
            useDirtyWheel: true,
            onWheel: onWheel
        });
        this.value = (0, $9e052f3767af1736$export$958c2bfe8d7142a9)(this.value);
        this.updateDOM(true);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).append(this.transEl, [
            this.boundsEl,
            this.edges[0].el,
            this.edges[1].el,
            this.edges[2].el,
            this.edges[3].el,
            this.corners[0].el,
            this.corners[1].el,
            this.corners[2].el,
            this.corners[3].el,
            this.angleGrip.el
        ]);
    }
}






class $1fee4e0c7c231d15$export$205c2dd29f8a66b5 {
    updatePreview() {
        const transform = this.freeTransform.getValue();
        const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.previewCanvas);
        ctx.save();
        ctx.clearRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).drawTransformedImageWithBounds(ctx, this.layers[this.transformIndex].image, transform, undefined, this.algorithm === 'pixelated' || (0, $d9f9f4926aa80a1c$export$921068d8846a1559).testShouldPixelate(transform, transform.width / this.initTransform.width, transform.height / this.initTransform.height));
        ctx.restore();
        this.preview.render();
    }
    // ---- interface ----
    move(dX, dY) {
        this.freeTransform.move(dX, dY);
    }
    reset() {
        const w = this.layers[this.transformIndex].image.width;
        const h = this.layers[this.transformIndex].image.height;
        this.freeTransform.setSize(w, h);
        this.freeTransform.setPos({
            x: w / 2,
            y: h / 2
        });
        this.freeTransform.setAngleDeg(0);
        this.updatePreview();
    }
    setTransformFit() {
        const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(this.layers[this.transformIndex].image.width, this.layers[this.transformIndex].image.height, this.imageWidth, this.imageHeight, 1);
        this.freeTransform.setSize(fit.width, fit.height);
        this.freeTransform.setPos({
            x: fit.width / 2,
            y: fit.height / 2
        });
        this.freeTransform.setAngleDeg(0);
        this.updatePreview();
    }
    setTransformCenter() {
        this.freeTransform.setPos({
            x: this.imageWidth / 2,
            y: this.imageHeight / 2
        });
        this.freeTransform.setAngleDeg(0);
        this.updatePreview();
    }
    setAlgorithm(algo) {
        this.algorithm = algo;
        this.updatePreview();
    }
    /**
     * gives you the transformation in the original scale
     */ getTransformation() {
        return this.freeTransform.getValue();
    }
    getIsPixelated() {
        const transform = this.freeTransform.getValue();
        return this.algorithm === 'pixelated' || (0, $d9f9f4926aa80a1c$export$921068d8846a1559).testShouldPixelate(transform, transform.width / this.initTransform.width, transform.height / this.initTransform.height);
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.freeTransform.destroy();
        this.preview.destroy();
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(this.previewCanvas);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.algorithm = 'smooth';
        this.imageWidth = p.imageWidth;
        this.imageHeight = p.imageHeight;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper',
            css: {
                width: p.elementWidth + 'px',
                height: p.elementHeight + 'px'
            }
        });
        this.rootEl.oncontextmenu = ()=>{
            return false;
        };
        this.layers = p.layers;
        this.transformIndex = p.transformIndex;
        this.previewLayerArr = this.layers.map((item)=>{
            var _item_mixModeStr;
            return {
                image: item.image,
                isVisible: item.isVisible,
                mixModeStr: (_item_mixModeStr = item.mixModeStr) !== null && _item_mixModeStr !== void 0 ? _item_mixModeStr : 'source-over',
                opacity: item.opacity,
                hasClipping: false
            };
        });
        this.previewCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.imageWidth, this.imageHeight);
        this.previewLayerArr[this.previewLayerArr.length - 1].image = this.previewCanvas;
        this.preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: p.elementWidth,
            height: p.elementHeight,
            project: {
                width: p.imageWidth,
                height: p.imageHeight,
                layers: this.previewLayerArr
            },
            hasEditMode: true,
            onModeChange: (m)=>{
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.freeTransform.getElement(), {
                    pointerEvents: m === 'edit' ? '' : 'none',
                    opacity: m === 'edit' ? '' : '0.5'
                });
            },
            onTransformChange: (transform)=>{
                this.freeTransform.setViewportTransform(transform);
            },
            padding: 30
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.preview.getElement(), {
            overflow: 'hidden',
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        this.rootEl.append(this.preview.getElement());
        this.initTransform = {
            x: this.imageWidth / 2,
            y: this.imageHeight / 2,
            width: this.layers[this.transformIndex].image.width,
            height: this.layers[this.transformIndex].image.height
        };
        this.freeTransform = new (0, $d42d1384577ab84d$export$79a74567acf241b0)({
            x: this.initTransform.x,
            y: this.initTransform.y,
            width: this.initTransform.width,
            height: this.initTransform.height,
            angleDeg: 0,
            isConstrained: true,
            snapX: [
                0,
                this.imageWidth
            ],
            snapY: [
                0,
                this.imageHeight
            ],
            viewportTransform: this.preview.getTransform(),
            callback: ()=>{
                this.updatePreview();
            }
        });
        this.preview.getElement().append(this.freeTransform.getElement());
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.freeTransform.getElement(), {
            position: 'absolute',
            left: '0',
            top: '0'
        });
        setTimeout(()=>this.updatePreview(), 0);
    }
}




class $c4e8a5b20c195c16$export$71ed2b85d4ca43d3 {
    update() {
        this.edges[0].update();
        this.edges[1].update();
        this.edges[2].update();
        this.edges[3].update();
        this.cornerElArr[0].update();
        this.cornerElArr[1].update();
        this.cornerElArr[2].update();
        this.cornerElArr[3].update();
        this.darken[0].update();
        this.darken[1].update();
        this.darken[2].update();
        this.darken[3].update();
        this.outline.update();
        this.thirdsHorizontal.update();
        this.thirdsVertical.update();
    }
    commit() {
        this.pointerRemainder.x = 0;
        this.pointerRemainder.y = 0;
        this.callback(this.getTransform());
    }
    // ---- interface ----
    getTransform() {
        this.grips[1].x -= this.grips[0].x;
        this.grips[1].y -= this.grips[0].y;
        this.grips[2].x -= this.grips[0].x;
        this.grips[2].y -= this.grips[0].y;
        this.grips[3].x -= this.grips[0].x;
        this.grips[3].y -= this.grips[0].y;
        this.x += this.grips[0].x;
        this.y += this.grips[0].y;
        this.grips[0].x = 0;
        this.grips[0].y = 0;
        return {
            x: this.x,
            y: this.y,
            width: this.grips[1].x,
            height: this.grips[2].y
        };
    }
    setTransform(p) {
        this.x = p.x;
        this.y = p.y;
        this.width = p.width;
        this.height = p.height;
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
            left: this.x * this.scale + 'px',
            top: this.y * this.scale + 'px'
        });
        this.grips[0].x = 0;
        this.grips[0].y = 0;
        this.grips[1].x = this.width;
        this.grips[1].y = 0;
        this.grips[2].x = this.width;
        this.grips[2].y = this.height;
        this.grips[3].x = 0;
        this.grips[3].y = this.height;
        this.update();
        this.commit();
    }
    setScale(s) {
        this.scale = s;
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
            left: this.x * this.scale + 'px',
            top: this.y * this.scale + 'px'
        });
        this.update();
    }
    showThirds(b) {
        this.thirdsHorizontal.el.style.display = b ? 'block' : 'none';
        this.thirdsVertical.el.style.display = b ? 'block' : 'none';
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.keyListener.destroy();
        this.outlinePointerListener.destroy();
        this.corner0PointerListener.destroy();
        this.corner1PointerListener.destroy();
        this.corner2PointerListener.destroy();
        this.corner3PointerListener.destroy();
        this.edge0PointerListener.destroy();
        this.edge1PointerListener.destroy();
        this.edge2PointerListener.destroy();
        this.edge3PointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.x = p.x;
        this.y = p.y;
        this.width = p.width;
        this.height = p.height;
        this.scale = p.scale;
        this.callback = p.callback;
        const maxW = p.maxW;
        const maxH = p.maxH;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const gripCursors = [
            'nw',
            'n',
            'ne',
            'e',
            'se',
            's',
            'sw',
            'w'
        ];
        this.keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({});
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
            position: 'absolute',
            left: this.x * this.scale + 'px',
            top: this.y * this.scale + 'px'
        });
        this.outline = {
            el: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    position: 'absolute',
                    border: '1px dashed #fff',
                    cursor: 'move'
                }
            }),
            update: ()=>{
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.outline.el, {
                    left: this.grips[0].x * this.scale - 1 + 'px',
                    top: this.grips[0].y * this.scale - 1 + 'px',
                    width: (this.grips[2].x - this.grips[0].x) * this.scale + 'px',
                    height: (this.grips[2].y - this.grips[0].y) * this.scale + 'px'
                });
            }
        };
        this.pointerRemainder = {
            // needs to be reset after dragging complete
            x: 0,
            y: 0
        };
        this.outlinePointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.outline.el,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const { dX: dX, dY: dY } = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(this.pointerRemainder, event.dX / this.scale, event.dY / this.scale);
                    this.grips[0].x += dX;
                    this.grips[0].y += dY;
                    this.grips[1].x += dX;
                    this.grips[1].y += dY;
                    this.grips[2].x += dX;
                    this.grips[2].y += dY;
                    this.grips[3].x += dX;
                    this.grips[3].y += dY;
                    this.update();
                }
                if (event.type === 'pointerup') this.commit();
            }
        });
        this.thirdsHorizontal = {
            el: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    position: 'absolute',
                    borderTop: '1px solid #0ff',
                    borderBottom: '1px solid #0ff'
                }
            }),
            update: ()=>{
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.thirdsHorizontal.el, {
                    left: this.grips[0].x * this.scale + 'px',
                    top: (this.grips[0].y + (this.grips[2].y - this.grips[0].y) / 3) * this.scale + 'px',
                    width: (this.grips[2].x - this.grips[0].x) * this.scale + 'px',
                    height: (this.grips[2].y - this.grips[0].y) / 3 * this.scale + 'px'
                });
            }
        };
        this.thirdsVertical = {
            el: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    position: 'absolute',
                    borderLeft: '1px solid #0ff',
                    borderRight: '1px solid #0ff'
                }
            }),
            update: ()=>{
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.thirdsVertical.el, {
                    left: (this.grips[0].x + (this.grips[2].x - this.grips[0].x) / 3) * this.scale + 'px',
                    top: this.grips[0].y * this.scale + 'px',
                    width: (this.grips[2].x - this.grips[0].x) / 3 * this.scale + 'px',
                    height: (this.grips[2].y - this.grips[0].y) * this.scale + 'px'
                });
            }
        };
        const gripSize = 40;
        const gripOverlay = 10;
        if (p.init) this.grips = [
            {
                x: p.init.x1,
                y: p.init.y1
            },
            {
                x: p.init.x2 + 1,
                y: p.init.y1
            },
            {
                x: p.init.x2 + 1,
                y: p.init.y2 + 1
            },
            {
                x: p.init.x1,
                y: p.init.y2 + 1
            }
        ];
        else this.grips = [
            {
                x: 0,
                y: 0
            },
            {
                x: this.width,
                y: 0
            },
            {
                x: this.width,
                y: this.height
            },
            {
                x: 0,
                y: this.height
            }
        ];
        const transformTop = (dY)=>{
            this.grips[0].y += dY;
            this.grips[0].y = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.grips[0].y, this.grips[3].y - maxH, this.grips[3].y - 1);
            this.grips[1].y = this.grips[0].y;
        };
        const transformRight = (dX)=>{
            this.grips[1].x += dX;
            this.grips[1].x = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.grips[1].x, this.grips[0].x + 1, this.grips[0].x + maxW);
            this.grips[2].x = this.grips[1].x;
        };
        const transformBottom = (dY)=>{
            this.grips[2].y += dY;
            this.grips[2].y = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.grips[2].y, this.grips[1].y + 1, this.grips[1].y + maxH);
            this.grips[3].y = this.grips[2].y;
        };
        const transformLeft = (dX)=>{
            this.grips[0].x += dX;
            this.grips[0].x = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.grips[0].x, this.grips[1].x - maxW, this.grips[1].x - 1);
            this.grips[3].x = this.grips[0].x;
        };
        this.edges = [];
        for(let i = 0; i < 4; i++)((i)=>{
            const el = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    width: gripSize + 'px',
                    height: gripSize + 'px',
                    //background: '#0f0',
                    position: 'absolute'
                }
            });
            const update = ()=>{
                if (i === 0) //top
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(el, {
                    left: this.grips[0].x * this.scale + gripOverlay + 'px',
                    top: this.grips[0].y * this.scale - gripSize * 2 + gripOverlay + 'px',
                    width: (this.grips[1].x - this.grips[0].x) * this.scale - gripOverlay * 2 + 'px',
                    height: gripSize * 2 + 'px'
                });
                else if (i === 1) //right
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(el, {
                    left: this.grips[1].x * this.scale - gripOverlay + 'px',
                    top: this.grips[1].y * this.scale + gripOverlay + 'px',
                    width: gripSize * 2 + 'px',
                    height: (this.grips[2].y - this.grips[1].y) * this.scale - gripOverlay * 2 + 'px'
                });
                else if (i === 2) //bottom
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(el, {
                    left: this.grips[3].x * this.scale + gripOverlay + 'px',
                    top: this.grips[3].y * this.scale - gripOverlay + 'px',
                    width: (this.grips[2].x - this.grips[3].x) * this.scale - gripOverlay * 2 + 'px',
                    height: gripSize * 2 + 'px'
                });
                else if (i === 3) //left
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(el, {
                    left: this.grips[0].x * this.scale - gripSize * 2 + gripOverlay + 'px',
                    top: this.grips[0].y * this.scale + gripOverlay + 'px',
                    width: gripSize * 2 + 'px',
                    height: (this.grips[3].y - this.grips[0].y) * this.scale - gripOverlay * 2 + 'px'
                });
                const angleOffset = i * 2 + 1;
                el.style.cursor = gripCursors[angleOffset] + '-resize';
            };
            this.edges[i] = {
                el: el,
                update: update
            };
        })(i);
        this.darken = [];
        for(let i = 0; i < 4; i++)((i)=>{
            const g = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    position: 'absolute',
                    background: '#000',
                    opacity: '0.5'
                }
            });
            const update = ()=>{
                if (i === 0) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g, {
                    left: this.grips[0].x * this.scale + 'px',
                    top: this.grips[0].y * this.scale - 8000 + 'px',
                    width: (this.grips[1].x - this.grips[0].x) * this.scale + 'px',
                    height: '8000px'
                });
                else if (i === 1) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g, {
                    left: this.grips[1].x * this.scale + 'px',
                    top: this.grips[1].y * this.scale - 8000 + 'px',
                    width: '8000px',
                    height: "16000px"
                });
                else if (i === 2) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g, {
                    left: this.grips[3].x * this.scale + 'px',
                    top: this.grips[3].y * this.scale + 'px',
                    width: (this.grips[2].x - this.grips[3].x) * this.scale + 'px',
                    height: '8000px'
                });
                else if (i === 3) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g, {
                    left: this.grips[0].x * this.scale - 8000 + 'px',
                    top: this.grips[0].y * this.scale - 8000 + 'px',
                    width: '8000px',
                    height: "16000px"
                });
            };
            this.darken[i] = {
                el: g,
                update: update
            };
        })(i);
        this.edge0PointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.edges[0].el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const { dY: dY } = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(this.pointerRemainder, event.dX / this.scale, event.dY / this.scale);
                    transformTop(dY);
                    if (this.keyListener.isPressed('shift')) transformBottom(-dY);
                    this.update();
                }
                if (event.type === 'pointerup') this.commit();
            }
        });
        this.edge1PointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.edges[1].el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const { dX: dX, dY: dY } = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(this.pointerRemainder, event.dX / this.scale, event.dY / this.scale);
                    transformRight(dX);
                    if (this.keyListener.isPressed('shift')) transformLeft(-dX);
                    this.update();
                }
                if (event.type === 'pointerup') this.commit();
            }
        });
        this.edge2PointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.edges[2].el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const { dX: dX, dY: dY } = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(this.pointerRemainder, event.dX / this.scale, event.dY / this.scale);
                    transformBottom(dY);
                    if (this.keyListener.isPressed('shift')) transformTop(-dY);
                    this.update();
                }
                if (event.type === 'pointerup') this.commit();
            }
        });
        this.edge3PointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.edges[3].el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const { dX: dX, dY: dY } = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(this.pointerRemainder, event.dX / this.scale, event.dY / this.scale);
                    transformLeft(dX);
                    if (this.keyListener.isPressed('shift')) transformRight(-dX);
                    this.update();
                }
                if (event.type === 'pointerup') this.commit();
            }
        });
        this.cornerElArr = [];
        (()=>{
            for(let i = 0; i < 4; i++)((i)=>{
                const g = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    css: {
                        //background: '#f00',
                        width: gripSize * 2 + 'px',
                        height: gripSize * 2 + 'px',
                        position: 'absolute',
                        cursor: [
                            'nwse-resize',
                            'nesw-resize'
                        ][i % 2]
                    }
                });
                const update = ()=>{
                    if (i === 0) //top left
                    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g, {
                        left: this.grips[0].x * this.scale - gripSize * 2 + gripOverlay + 'px',
                        top: this.grips[0].y * this.scale - gripSize * 2 + gripOverlay + 'px'
                    });
                    else if (i === 1) //top right
                    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g, {
                        left: this.grips[1].x * this.scale - gripOverlay + 'px',
                        top: this.grips[1].y * this.scale - gripSize * 2 + gripOverlay + 'px'
                    });
                    else if (i === 2) //bottom right
                    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g, {
                        left: this.grips[1].x * this.scale - gripOverlay + 'px',
                        top: this.grips[2].y * this.scale - gripOverlay + 'px'
                    });
                    else if (i === 3) //bottom left
                    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(g, {
                        left: this.grips[0].x * this.scale - gripSize * 2 + gripOverlay + 'px',
                        top: this.grips[2].y * this.scale - gripOverlay + 'px'
                    });
                };
                this.cornerElArr[i] = {
                    el: g,
                    update: update
                };
            })(i);
        })();
        //top left
        this.corner0PointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.cornerElArr[0].el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const { dX: dX, dY: dY } = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(this.pointerRemainder, event.dX / this.scale, event.dY / this.scale);
                    transformLeft(dX);
                    transformTop(dY);
                    if (this.keyListener.isPressed('shift')) {
                        transformRight(-dX);
                        transformBottom(-dY);
                    }
                    this.update();
                }
                if (event.type === 'pointerup') this.commit();
            }
        });
        //top right
        this.corner1PointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.cornerElArr[1].el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const { dX: dX, dY: dY } = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(this.pointerRemainder, event.dX / this.scale, event.dY / this.scale);
                    transformRight(dX);
                    transformTop(dY);
                    if (this.keyListener.isPressed('shift')) {
                        transformLeft(-dX);
                        transformBottom(-dY);
                    }
                    this.update();
                }
                if (event.type === 'pointerup') this.commit();
            }
        });
        //bottom right
        this.corner2PointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.cornerElArr[2].el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const { dX: dX, dY: dY } = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(this.pointerRemainder, event.dX / this.scale, event.dY / this.scale);
                    transformRight(dX);
                    transformBottom(dY);
                    if (this.keyListener.isPressed('shift')) {
                        transformLeft(-dX);
                        transformTop(-dY);
                    }
                    this.update();
                }
                if (event.type === 'pointerup') this.commit();
            }
        });
        //bottom left
        this.corner3PointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.cornerElArr[3].el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const { dX: dX, dY: dY } = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).intDxy(this.pointerRemainder, event.dX / this.scale, event.dY / this.scale);
                    transformLeft(dX);
                    transformBottom(dY);
                    if (this.keyListener.isPressed('shift')) {
                        transformRight(-dX);
                        transformTop(-dY);
                    }
                    this.update();
                }
                if (event.type === 'pointerup') this.commit();
            }
        });
        this.rootEl.append(this.darken[1].el, this.darken[0].el, this.darken[2].el, this.darken[3].el, this.thirdsHorizontal.el, this.thirdsVertical.el, this.outline.el, this.edges[1].el, this.edges[0].el, this.edges[2].el, this.edges[3].el, this.cornerElArr[0].el, this.cornerElArr[1].el, this.cornerElArr[2].el, this.cornerElArr[3].el);
        this.update();
    }
}






class $6f827bc527014b7f$export$d25420b53e16716f {
    updateCheckerPatterns() {
        const checker = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createCheckerCanvas(4, (0, $74a507c74cfe9692$export$5714e40777c1bcc2).isDark());
        this.animationCanvasCheckerPattern = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.animationCanvasCtx.createPattern(checker, 'repeat'));
        this.largeCanvasCheckerPattern = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.canvasCtx.createPattern(checker, 'repeat'));
    }
    animate() {
        if (this.animationCount === 0) return;
        this.animationCount--;
        this.canvasCtx.save();
        this.canvasCtx.globalAlpha = Math.pow((this.animationLength - this.animationCount) / this.animationLength, 2);
        this.canvasCtx.drawImage(this.animationCanvas, 0, 0);
        this.canvasCtx.restore();
        if (this.animationCount > 0) requestAnimationFrame(()=>this.animate());
    }
    /**
     * is always instant
     */ drawLargeCanvas() {
        if (!this.largeCanvasIsVisible || !this.layer) return;
        const layerCanvas = this.layer.canvas;
        const canvasDimensions = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(layerCanvas.width, layerCanvas.height, this.largeCanvasSize, this.largeCanvasSize, 1);
        this.largeCanvas.width = Math.round(canvasDimensions.width);
        this.largeCanvas.height = Math.round(canvasDimensions.height);
        this.largeCanvasCtx.save();
        if (this.largeCanvas.width > layerCanvas.width) this.largeCanvasCtx.imageSmoothingEnabled = false;
        else {
            this.largeCanvasCtx.imageSmoothingEnabled = true;
            this.largeCanvasCtx.imageSmoothingQuality = 'high';
        }
        this.largeCanvasCtx.fillStyle = this.largeCanvasCheckerPattern;
        this.largeCanvasCtx.fillRect(0, 0, this.largeCanvas.width, this.largeCanvas.height);
        this.largeCanvasCtx.drawImage(layerCanvas, 0, 0, this.largeCanvas.width, this.largeCanvas.height);
        this.largeCanvasCtx.restore();
        const bounds = this.rootEl.getBoundingClientRect();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.largeCanvasWrapper, {
            top: Math.max(10, bounds.top + this.height / 2 - this.largeCanvas.height / 2) + 'px'
        });
    }
    updateLabel() {
        if (!this.isPreviewVisible || !this.layer) return;
        const layerIsVisible = this.layer.isVisible;
        this.checkEl.parentElement.title = layerIsVisible ? (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-active-layer-visible') : (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-active-layer-hidden');
        this.checkEl.checked = layerIsVisible;
        this.checkEl.style.boxShadow = layerIsVisible ? '' : '0 0 0 1px red';
        this.nameLabelEl.textContent = this.layer.name;
        if (this.layer.isVisible) this.opacityEl.innerHTML = (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity') + '<br>' + Math.round(this.layer.opacity * 100) + '%';
        else this.opacityEl.innerHTML = (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity') + '<br><s>' + Math.round(this.layer.opacity * 100) + '%</s>';
    }
    draw(isInstant) {
        if (!this.isPreviewVisible || !this.layer) return;
        this.updateLabel();
        const layerCanvas = this.layer.canvas;
        if (layerCanvas.width !== this.lastDrawnSize.width || layerCanvas.height !== this.lastDrawnSize.height) {
            const canvasDimensions = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(layerCanvas.width, layerCanvas.height, this.canvasSize, this.canvasSize, 1);
            this.canvas.width = Math.round(canvasDimensions.width);
            this.canvas.height = Math.round(canvasDimensions.height);
            isInstant = true; // can't animate when size changed
        }
        this.animationCanvas.width = this.canvas.width;
        this.animationCanvas.height = this.canvas.height;
        this.animationCanvasCtx.save();
        this.animationCanvasCtx.imageSmoothingEnabled = false;
        this.animationCanvasCtx.fillStyle = this.animationCanvasCheckerPattern;
        this.animationCanvasCtx.fillRect(0, 0, this.animationCanvas.width, this.animationCanvas.height);
        this.animationCanvasCtx.drawImage(layerCanvas, 0, 0, this.animationCanvas.width, this.animationCanvas.height);
        this.animationCanvasCtx.restore();
        if (isInstant) {
            this.animationCount = 0;
            this.canvasCtx.save();
            this.canvasCtx.drawImage(this.animationCanvas, 0, 0);
            this.canvasCtx.restore();
        } else {
            this.animationCount = this.animationLength;
            this.animate();
        }
        this.drawLargeCanvas();
        this.lastDrawnState = this.klHistory.getChangeCount();
        this.lastDrawnSize.width = layerCanvas.width;
        this.lastDrawnSize.height = layerCanvas.height;
    }
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    setIsVisible(b) {
        if (this.isPreviewVisible === b) return;
        this.isPreviewVisible = b;
        this.contentWrapperEl.style.display = this.isPreviewVisible ? 'flex' : 'none';
        this.rootEl.style.marginBottom = this.isPreviewVisible ? '' : '10px';
        const currentState = this.klHistory.getChangeCount();
        if (b && this.lastDrawnState !== currentState) this.draw(true);
    }
    //when the layer might have changed
    setLayer(layer) {
        this.layer = layer;
        this.draw(true);
    }
    setUiState(stateStr) {
        this.uiState = stateStr;
        if (this.uiState === 'left') (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.largeCanvasWrapper, {
            left: '280px',
            right: ''
        });
        else (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.largeCanvasWrapper, {
            left: '',
            right: '280px'
        });
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.animationCanvasCheckerPattern = {};
        this.largeCanvasCheckerPattern = {};
        // internally redraws with in an interval. checks history is something changed
        // this update will be animated
        // it will not be animated if the resolution changed
        // also redraws when you call updateLayer - not animated
        // syncs via updateLayer, and internally updates layer opacity via a hack
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-layer-preview'
        });
        this.klHistory = p.klHistory;
        this.isPreviewVisible = true;
        this.height = 40;
        this.canvasSize = this.height - 10;
        this.largeCanvasSize = 300;
        this.lastDrawnState = -2;
        this.lastDrawnSize = {
            width: 0,
            height: 0
        };
        this.animationCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(); // to help animate the transition
        this.animationCanvasCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.animationCanvas);
        this.animationLength = 30;
        this.animationCount = 0;
        this.largeCanvasIsVisible = false;
        let largeCanvasAnimationTimeout;
        const largeCanvasAnimationDurationMs = 300;
        this.uiState = p.uiState;
        // --- setup dom ---
        this.contentWrapperEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                alignItems: 'center',
                height: this.height + 'px'
            }
        });
        const checkWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                width: '23px',
                flexShrink: '0'
            }
        });
        this.checkEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: checkWrapper,
            tagName: 'input',
            css: {
                pointerEvents: 'none'
            },
            custom: {
                type: 'checkbox',
                disabled: 'true',
                name: 'layer-visible'
            }
        });
        const canvasWrapperEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                //background: '#f00',
                minWidth: this.height + 'px',
                height: this.height + 'px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        });
        this.canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.canvasSize, this.canvasSize);
        this.canvasCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.canvas);
        this.canvas.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-active-layer');
        const nameWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                //background: '#ff0',
                flexGrow: '1',
                paddingLeft: '10px',
                fontSize: '13px',
                overflow: 'hidden',
                position: 'relative'
            }
        });
        this.nameLabelEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: '',
            css: {
                cssFloat: 'left',
                whiteSpace: 'nowrap'
            }
        });
        const clickableEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                // background: 'rgba(0,255,0,0.6)',
                position: 'absolute',
                left: '10px',
                top: '0',
                width: '90px',
                height: '100%'
            }
        });
        if (p.onClick) {
            clickableEl.addEventListener('click', ()=>p.onClick(), {
                passive: false
            });
            this.canvas.addEventListener('click', ()=>p.onClick(), {
                passive: false
            });
            checkWrapper.addEventListener('click', ()=>p.onClick(), {
                passive: false
            });
        }
        this.opacityEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity') + '<br>100%',
            css: {
                minWidth: '60px',
                fontSize: '12px',
                textAlign: 'center'
            }
        });
        this.largeCanvasWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            onClick: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).handleClick,
            css: {
                pointerEvents: 'none',
                background: '#fff',
                position: 'absolute',
                right: '280px',
                top: '10px',
                border: '1px solid #aaa',
                boxShadow: '1px 1px 3px rgba(0,0,0,0.3)',
                transition: 'opacity ' + largeCanvasAnimationDurationMs + 'ms ease-in-out',
                userSelect: 'none',
                display: 'block',
                ['webkitTouchCallout']: 'none'
            }
        });
        this.largeCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.largeCanvasSize, this.largeCanvasSize);
        this.largeCanvasWrapper.append(this.largeCanvas);
        this.largeCanvasCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.largeCanvas);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.largeCanvas, {
            display: 'block'
        });
        canvasWrapperEl.append(this.canvas);
        nameWrapper.append(this.nameLabelEl, clickableEl);
        this.contentWrapperEl.append(checkWrapper, canvasWrapperEl, nameWrapper, this.opacityEl);
        this.rootEl.append(this.contentWrapperEl);
        this.updateCheckerPatterns();
        (0, $74a507c74cfe9692$export$5714e40777c1bcc2).addIsDarkListener(()=>{
            this.updateCheckerPatterns();
            this.draw(true);
        });
        // --- update logic ---
        // cross-fade done via 2 canvases (old and new state)
        // both have checkerboard background drawn on them, both fully opaque
        // -> no "lighter" is needed for accurate cross-fading
        // label should update instantly
        this.klHistory.addListener(()=>{
            this.updateLabel();
        });
        setInterval(()=>{
            if (!this.layer) return;
            const currentState = this.klHistory.getChangeCount();
            if (currentState === this.lastDrawnState) return;
            this.draw(false);
        }, 2000);
        const removeLargeCanvas = ()=>{
            this.largeCanvasWrapper.remove();
        };
        const showLargeCanvas = (b)=>{
            if (this.largeCanvasIsVisible === b) return;
            clearTimeout(largeCanvasAnimationTimeout);
            this.largeCanvasIsVisible = b;
            if (b) largeCanvasAnimationTimeout = setTimeout(()=>{
                this.drawLargeCanvas();
                this.largeCanvasWrapper.style.opacity = '0';
                p.klRootEl.append(this.largeCanvasWrapper);
                setTimeout(()=>{
                    this.largeCanvasWrapper.style.opacity = '1';
                }, 20);
            }, 250);
            else {
                this.largeCanvasWrapper.style.opacity = '0';
                largeCanvasAnimationTimeout = setTimeout(removeLargeCanvas, largeCanvasAnimationDurationMs + 20);
            }
        };
        const pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.canvas,
            onEnterLeave: (b)=>{
                showLargeCanvas(b);
            }
        });
    }
}






function $8522c24dbe0f81fc$export$8f6817a932bf45cd() {
    return window.innerWidth < 550;
}


const $3ec5d4ed5944260f$export$ec2d17c6d3ae0768 = {
    width: 340,
    height: 220
};
const $3ec5d4ed5944260f$export$3a4a74a7d8c44e62 = {
    width: 540,
    height: 300
};
function $3ec5d4ed5944260f$export$8b9199c1f5e4be8(isSmall) {
    return isSmall ? $3ec5d4ed5944260f$export$ec2d17c6d3ae0768.width : $3ec5d4ed5944260f$export$3a4a74a7d8c44e62.width;
}
function $3ec5d4ed5944260f$export$94cffdbcf128864a(isSmall) {
    return isSmall ? $3ec5d4ed5944260f$export$ec2d17c6d3ae0768.height : $3ec5d4ed5944260f$export$3a4a74a7d8c44e62.height;
}




function $6be05b3a68464314$export$962af7e240721d88(params) {
    const div = document.createElement('div');
    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).appendTextDiv(div, (0, $63d0b335c576c718$export$ce37e184d908d785)('import-as-layer-description'));
    if (params.klCanvas.isLayerLimitReached()) {
        const noteEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-import-note',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-as-layer-limit-reached')
        });
        div.append(noteEl);
    }
    const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
    const buttonRowEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            display: 'flex'
        }
    });
    const originalSizeBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'button',
        content: '1:1',
        css: {
            marginRight: '10px'
        },
        onClick: function() {
            freeTransformCanvas.reset();
        }
    });
    const fitSizeBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'button',
        content: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-as-layer-fit'),
        css: {
            marginRight: '10px'
        },
        onClick: function() {
            freeTransformCanvas.setTransformFit();
        }
    });
    const centerBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'button',
        content: (0, $63d0b335c576c718$export$ce37e184d908d785)('center'),
        css: {
            marginRight: '10px'
        },
        onClick: function() {
            freeTransformCanvas.setTransformCenter();
        }
    });
    const algorithmSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
        isFocusable: true,
        optionArr: [
            [
                'smooth',
                (0, $63d0b335c576c718$export$ce37e184d908d785)('algorithm-smooth')
            ],
            [
                'pixelated',
                (0, $63d0b335c576c718$export$ce37e184d908d785)('algorithm-pixelated')
            ]
        ],
        initValue: 'smooth',
        title: (0, $63d0b335c576c718$export$ce37e184d908d785)('scaling-algorithm'),
        onChange: (val)=>{
            freeTransformCanvas.setAlgorithm(val);
        },
        name: 'interpolation-algorithm'
    });
    buttonRowEl.append(originalSizeBtn, fitSizeBtn, centerBtn, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            flexGrow: '1'
        }
    }), algorithmSelect.getElement());
    div.append(buttonRowEl);
    const layers = [];
    {
        const klCanvasLayerArr = params.klCanvas.getLayers();
        for(let i = 0; i < klCanvasLayerArr.length; i++)layers.push({
            image: klCanvasLayerArr[i].context.canvas,
            isVisible: klCanvasLayerArr[i].isVisible,
            opacity: klCanvasLayerArr[i].opacity,
            mixModeStr: klCanvasLayerArr[i].mixModeStr
        });
    }
    layers.push({
        image: params.importImage,
        isVisible: true,
        opacity: 1,
        mixModeStr: 'source-over'
    });
    const freeTransformCanvas = new (0, $1fee4e0c7c231d15$export$205c2dd29f8a66b5)({
        elementWidth: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
        elementHeight: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall) + 50,
        imageWidth: params.klCanvas.getLayerContext(0).canvas.width,
        imageHeight: params.klCanvas.getLayerContext(0).canvas.height,
        layers: layers,
        transformIndex: layers.length - 1
    });
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(freeTransformCanvas.getElement(), {
        marginTop: '10px',
        marginLeft: '-20px'
    });
    div.append(freeTransformCanvas.getElement());
    function move(x, y) {
        freeTransformCanvas.move(x, y);
    }
    const keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
        onDown: function(keyStr) {
            if (keyStr === 'left') move(-1, 0);
            if (keyStr === 'right') move(1, 0);
            if (keyStr === 'up') move(0, -1);
            if (keyStr === 'down') move(0, 1);
        }
    });
    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('import-as-layer-title')}</b>`,
        div: div,
        style: isSmall ? undefined : {
            width: '540px'
        },
        buttons: [
            'Ok',
            'Cancel'
        ],
        clickOnEnter: 'Ok',
        callback: function(buttonStr) {
            keyListener.destroy();
            freeTransformCanvas.destroy();
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(originalSizeBtn);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(fitSizeBtn);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(centerBtn);
            if (buttonStr === 'Ok') params.callback(freeTransformCanvas.getTransformation(), freeTransformCanvas.getIsPixelated());
            else params.callback();
        }
    });
}




class $71c20b9a25b8f899$export$e789742143ba5b1 {
    // ----------------------------------- public -----------------------------------
    constructor(p){
        //set up DOM
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('dropper-drop'),
            css: {
                paddingTop: '100px',
                position: 'fixed',
                left: '0',
                top: '0',
                width: '100%',
                height: '100%',
                background: 'rgba(50, 50, 50, 0.7)',
                color: '#fff',
                textShadow: '2px 2px #000',
                textAlign: 'center',
                fontSize: '25px'
            }
        });
        const wrapperEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                marginTop: '50px',
                display: 'flex',
                justifyContent: 'center'
            }
        });
        const optionStyle = {
            width: '200px',
            padding: '50px',
            margin: '10px',
            //opacity: 0.5,
            borderRadius: '20px',
            border: '1px dashed #fff',
            background: '#00aefe',
            fontWeight: 'bold'
        };
        const optionLayerEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('dropper-as-layer'),
            css: optionStyle
        });
        const optionImageEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('dropper-as-image'),
            css: optionStyle
        });
        this.rootEl.append(wrapperEl);
        wrapperEl.append(optionLayerEl, optionImageEl);
        let rootCounter = 0;
        let optionLayerCounter = 0;
        let optionImageCounter = 0;
        const destroy = ()=>{
            rootCounter = 0;
            optionLayerCounter = 0;
            optionImageCounter = 0;
            this.rootEl.remove();
        };
        /**
         * check, can drop content be imported
         */ const testAcceptType = (event)=>{
            return !!event.dataTransfer && !event.dataTransfer.types.includes('text/plain');
        };
        const updateOptions = ()=>{
            const boxShadow = '0 0 20px 4px #fff';
            if (optionLayerCounter > 0) {
                optionLayerEl.style.boxShadow = boxShadow;
                optionImageEl.style.boxShadow = '';
            } else if (optionImageCounter > 0) {
                optionLayerEl.style.boxShadow = '';
                optionImageEl.style.boxShadow = boxShadow;
            } else {
                optionLayerEl.style.boxShadow = '';
                optionImageEl.style.boxShadow = '';
            }
        };
        optionLayerEl.addEventListener('dragenter', ()=>{
            optionLayerCounter++;
            updateOptions();
        }, {
            passive: false
        });
        optionLayerEl.addEventListener('dragleave', ()=>{
            optionLayerCounter--;
            updateOptions();
        }, {
            passive: false
        });
        optionImageEl.addEventListener('dragenter', ()=>{
            optionImageCounter++;
            updateOptions();
        }, {
            passive: false
        });
        optionImageEl.addEventListener('dragleave', ()=>{
            optionImageCounter--;
            updateOptions();
        }, {
            passive: false
        });
        const rootDragOver = (event)=>{
            if (!testAcceptType(event)) return;
            event.stopPropagation();
            event.preventDefault();
        };
        const rootDragEnter = (event)=>{
            if (!p.enabledTest() || !testAcceptType(event)) return;
            if (rootCounter === 0) p.target.append(this.rootEl);
            rootCounter++;
        };
        const rootDragLeave = (event)=>{
            if (!testAcceptType(event) || rootCounter === 0) return;
            rootCounter = Math.max(0, rootCounter - 1);
            if (rootCounter === 0) this.rootEl.remove();
        };
        const rootDrop = (event)=>{
            if (!testAcceptType(event) || !event.dataTransfer || event.dataTransfer.files.length === 0) {
                destroy();
                return;
            }
            event.stopPropagation();
            event.preventDefault();
            let optionStr = 'default';
            if (optionLayerCounter > 0) optionStr = 'layer';
            else if (optionImageCounter > 0) optionStr = 'image';
            p.onDrop(event.dataTransfer.files, optionStr);
            if (rootCounter > 0) this.rootEl.remove();
            rootCounter = 0;
            optionLayerCounter = 0;
            optionImageCounter = 0;
            updateOptions();
        };
        window.addEventListener('dragover', rootDragOver, {
            passive: false
        });
        window.addEventListener('dragenter', rootDragEnter, {
            passive: false
        });
        window.addEventListener('dragleave', rootDragLeave, {
            passive: false
        });
        window.addEventListener('drop', rootDrop, {
            passive: false
        });
        // if something goes wrong and you're stuck with overlay
        this.rootEl.addEventListener('pointerdown', ()=>{
            destroy();
        }, {
            passive: false
        });
        const keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
            onDown: (keyStr)=>{
                if (rootCounter > 0 && keyStr === 'esc') destroy();
            }
        });
    }
}







class $b80d451cabaa19d2$export$9f0da9b942594e99 {
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        const sizeObj = {
            width: 150,
            svHeight: 90,
            hHeight: 20,
            sliderHeight: 25
        };
        let isVisible = false;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-overlay-toolspace'
        });
        const queuedObj = {
            color: null,
            size: null,
            opacity: null
        };
        // --- inputs ---
        //color selection
        const colorEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-overlay-toolspace__color'
        });
        const colorSlider = new (0, $8f768338795db7a0$export$66306bf21a9ff39e)({
            width: sizeObj.width,
            heightSV: sizeObj.svHeight,
            heightH: sizeObj.hHeight,
            color: p.brushSettingService.getColor(),
            callback: (rgbObj)=>{
                selectedColorEl.style.backgroundColor = 'rgb(' + rgbObj.r + ',' + rgbObj.g + ',' + rgbObj.b + ')';
                p.brushSettingService.setColor(rgbObj, subscriptionFunc);
            }
        });
        const selectedColorEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: sizeObj.width + 'px',
                height: sizeObj.hHeight + 'px',
                pointerEvents: 'none'
            }
        });
        {
            const initialColor = p.brushSettingService.getColor();
            selectedColorEl.style.backgroundColor = 'rgb(' + initialColor.r + ',' + initialColor.g + ',' + initialColor.b + ')';
        }
        colorEl.append(selectedColorEl, colorSlider.getElement());
        const updateColor = (rgbObj)=>{
            colorSlider.setColor(rgbObj);
            selectedColorEl.style.backgroundColor = 'rgb(' + rgbObj.r + ',' + rgbObj.g + ',' + rgbObj.b + ')';
        };
        //brushsize slider
        const sizeSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-size'),
            width: sizeObj.width,
            height: sizeObj.sliderHeight,
            min: 0,
            max: 500,
            value: 50,
            resolution: 225,
            eventResMs: 1000 / 30,
            toDisplayValue: (val)=>val * 2,
            toValue: (displayValue)=>displayValue / 2,
            onChange: (v)=>{
                p.brushSettingService.setSize(v);
            },
            formatFunc: (displayValue)=>{
                if (displayValue < 10) return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(displayValue, 1);
                else return Math.round(displayValue);
            }
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(sizeSlider.getElement(), {
            marginTop: '2px'
        });
        const opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
            width: sizeObj.width,
            height: sizeObj.sliderHeight,
            min: 0,
            max: 1,
            value: 1,
            resolution: 225,
            eventResMs: 1000 / 30,
            toDisplayValue: (val)=>val * 100,
            toValue: (displayValue)=>displayValue / 100,
            onChange: (v)=>{
                p.brushSettingService.setOpacity(v);
            }
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(opacitySlider.getElement(), {
            margin: '2px 0'
        });
        this.rootEl.append(sizeSlider.getElement(), opacitySlider.getElement());
        // --- general setup ---
        const subscriptionFunc = (event)=>{
            if (event.type === 'color') {
                if (!isVisible) queuedObj.color = event.value;
                else updateColor(event.value);
            }
            if (event.type === 'size') {
                if (!isVisible) queuedObj.size = event.value;
                else sizeSlider.setValue(event.value);
            }
            if (event.type === 'opacity') {
                if (!isVisible) queuedObj.opacity = event.value;
                else opacitySlider.setValue(event.value);
            }
            if (event.type === 'sliderConfig') {
                sizeSlider.update(event.value.sizeSlider);
                opacitySlider.update(event.value.opacitySlider);
            }
        };
        p.brushSettingService.subscribe(subscriptionFunc);
        {
            const sliderConfig = p.brushSettingService.getSliderConfig();
            sizeSlider.update(sliderConfig.sizeSlider);
            opacitySlider.update(sliderConfig.opacitySlider);
            sizeSlider.setValue(p.brushSettingService.getSize());
            opacitySlider.setValue(p.brushSettingService.getOpacity());
        }
        const updateUI = ()=>{
            // unfocus manual slider input
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unfocusAnyInput();
            this.rootEl.style.display = isVisible ? 'block' : 'none';
            if (isVisible && mousePos) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
                left: mousePos.x - Math.round(sizeObj.width / 2) + 'px',
                top: mousePos.y - Math.round(sizeObj.svHeight + sizeObj.hHeight * 3 / 2) + 'px'
            });
        };
        let mousePos = null;
        document.addEventListener('pointermove', (event)=>{
            mousePos = {
                x: event.pageX,
                y: event.pageY
            };
        }, {
            passive: false
        });
        const keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
            onDown: (keyStr, event, comboStr, isRepeat)=>{
                if (isRepeat) return;
                if (isVisible) {
                    isVisible = false;
                    updateUI();
                    return;
                }
                if (!p.enabledTest() || !mousePos) return;
                if ([
                    'ctrl+alt',
                    'cmd+alt',
                    'alt+ctrl',
                    'alt+cmd'
                ].includes(comboStr)) {
                    event.preventDefault();
                    isVisible = true;
                    if (queuedObj.color !== null) {
                        updateColor(queuedObj.color);
                        queuedObj.color = null;
                    }
                    if (queuedObj.size !== null) {
                        sizeSlider.setValue(queuedObj.size);
                        queuedObj.size = null;
                    }
                    if (queuedObj.opacity !== null) {
                        opacitySlider.setValue(queuedObj.opacity);
                        queuedObj.opacity = null;
                    }
                    updateUI();
                }
            },
            onUp: (keyStr, event, oldComboStr)=>{
                if ([
                    'ctrl+alt',
                    'cmd+alt',
                    'alt+ctrl',
                    'alt+cmd'
                ].includes(oldComboStr) && isVisible) {
                    isVisible = false;
                    colorSlider.end();
                    updateUI();
                }
            },
            onBlur: ()=>{
                if (isVisible) {
                    isVisible = false;
                    colorSlider.end();
                    updateUI();
                }
            }
        });
    }
}



var $d2b76ee5a41cc2d0$exports = {};
$d2b76ee5a41cc2d0$exports = $parcel$resolve("g2W7q");


var $cecb4b55c8dd017e$exports = {};
$cecb4b55c8dd017e$exports = $parcel$resolve("7SFt9");


var $375749381ca7b7b7$exports = {};
$375749381ca7b7b7$exports = $parcel$resolve("2Vvkk");


var $d94e039749bb6ca4$exports = {};
$d94e039749bb6ca4$exports = $parcel$resolve("1zJpX");


var $390be88d04af75ef$exports = {};
$390be88d04af75ef$exports = $parcel$resolve("9cKp0");


var $1fbb59b08bf77b76$exports = {};
$1fbb59b08bf77b76$exports = $parcel$resolve("3iiTs");




class $50947f5db7d72ab3$export$665d2c76b1eb8459 {
    setLogo(logoImg, isPixelated, keepOriginalColors) {
        const el = document.getElementById('kl-logo-button-im');
        if (el) {
            el.style.backgroundImage = "url('" + logoImg + "')";
            el.style.imageRendering = isPixelated ? 'pixelated' : '';
            el.classList.toggle('dark-invert', !keepOriginalColors);
        }
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-toolspace-row',
            css: {
                height: '36px',
                display: 'flex'
            }
        });
        function createButton(p) {
            const padding = 6 + (p.extraPadding ? p.extraPadding : 0);
            const el = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'toolspace-row-button nohighlight',
                title: p.title,
                onClick: p.onClick,
                css: {
                    padding: p.contain ? padding + 'px 0' : ''
                }
            });
            const im = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: p.darkInvert ? 'dark-invert' : undefined,
                id: 'kl-logo-button-im',
                css: {
                    backgroundImage: "url('" + p.image + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: p.contain ? 'contain' : '',
                    //filter: 'grayscale(1)',
                    height: '100%'
                }
            });
            im.style.pointerEvents = 'none';
            el.append(im);
            const pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                // because :hover causes problems w touch
                target: el,
                onEnterLeave: function(isOver) {
                    el.classList.toggle('toolspace-row-button-hover', isOver);
                }
            });
            return {
                el: el,
                pointerListener: pointerListener
            };
        }
        const logoButton = createButton({
            onClick: p.onLogo,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('home'),
            image: p.logoImg ? p.logoImg : (0, (/*@__PURE__*/$parcel$interopDefault($d2b76ee5a41cc2d0$exports))),
            contain: true,
            darkInvert: true
        });
        logoButton.el.classList.add('kl-tool-row-border-right');
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(logoButton.el, {
            width: '46px'
        });
        const newButton = createButton({
            onClick: p.onNew,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-new'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($cecb4b55c8dd017e$exports))),
            extraPadding: 1,
            contain: true
        });
        const importButton = createButton({
            onClick: p.onImport,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-import'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($375749381ca7b7b7$exports))),
            extraPadding: 1,
            contain: true
        });
        const saveButton = createButton({
            onClick: p.onSave,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-save'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($d94e039749bb6ca4$exports))),
            extraPadding: 1,
            contain: true
        });
        let shareButton = null;
        if ((0, $d9f9f4926aa80a1c$export$921068d8846a1559).canShareFiles()) shareButton = createButton({
            onClick: p.onShare,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-share'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($390be88d04af75ef$exports))),
            contain: true,
            darkInvert: true
        });
        const helpButton = createButton({
            onClick: p.onHelp,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('help'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($1fbb59b08bf77b76$exports))),
            contain: true,
            darkInvert: true
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).append(this.rootEl, [
            logoButton.el,
            newButton.el,
            importButton.el,
            saveButton.el,
            shareButton ? shareButton.el : undefined,
            helpButton.el
        ]);
    }
}




var $4933c2551a80d49a$exports = {};
$4933c2551a80d49a$exports = $parcel$resolve("gGmfI");


var $43ffa4c6f98eaf6b$exports = {};
$43ffa4c6f98eaf6b$exports = $parcel$resolve("67aEJ");


var $c4a14de060935e98$exports = {};
$c4a14de060935e98$exports = $parcel$resolve("baTSW");


var $821d1b86107d7d25$exports = {};
$821d1b86107d7d25$exports = $parcel$resolve("a2j2Q");


var $fd406f4e4b510fcf$exports = {};
$fd406f4e4b510fcf$exports = $parcel$resolve("gZhDT");


var $7783104c7d4a03b1$exports = {};
$7783104c7d4a03b1$exports = $parcel$resolve("2x0SU");






class $d199831ecec4fae4$export$a0a40f8a0b8fee15 {
    updateButton() {
        this.activeButton.title = this.titleArr[this.currentActiveIndex] + (this.isActive ? ' (' + (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-more-tools-click-again') + ')' : '');
        this.activeButtonIm.style.backgroundImage = "url('" + this.imArr[this.currentActiveIndex] + "')";
    }
    // ---- interface ----
    setIsSmall(b) {
        this.activeButton.style.padding = b ? this.smallMargin : '10px 0';
        for(let i = 0; i < this.optionArr.length; i++)this.dropdownBtnArr[i].setIsSmall(b);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.arrowButton, {
            width: b ? '14px' : '18px',
            height: b ? '14px' : '18px'
        });
    }
    setActive(activeStr) {
        if (this.optionArr.includes(activeStr)) {
            this.isActive = true;
            for(let i = 0; i < this.optionArr.length; i++)if (this.optionArr[i] === activeStr) {
                this.currentActiveIndex = i;
                break;
            }
            this.activeButton.classList.add('toolspace-row-button-activated');
            this.updateButton();
        } else {
            this.isActive = false;
            this.activeButton.classList.remove('toolspace-row-button-activated');
            this.updateButton();
        }
    }
    getActive() {
        return this.optionArr[this.currentActiveIndex];
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.smallMargin = '6px 0';
        this.optionArr = [
            'brush',
            'paintBucket',
            'gradient',
            'text',
            'shape',
            'select'
        ];
        this.imArr = [
            (0, (/*@__PURE__*/$parcel$interopDefault($4933c2551a80d49a$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($43ffa4c6f98eaf6b$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($c4a14de060935e98$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($821d1b86107d7d25$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fd406f4e4b510fcf$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7783104c7d4a03b1$exports)))
        ];
        this.titleArr = [
            `${(0, $63d0b335c576c718$export$ce37e184d908d785)('tool-brush')} [B]`,
            `${(0, $63d0b335c576c718$export$ce37e184d908d785)('tool-paint-bucket')} [G]`,
            `${(0, $63d0b335c576c718$export$ce37e184d908d785)('tool-gradient')} [G]`,
            `${(0, $63d0b335c576c718$export$ce37e184d908d785)('tool-text')} [T]`,
            `${(0, $63d0b335c576c718$export$ce37e184d908d785)('tool-shape')} [U]`,
            `${(0, $63d0b335c576c718$export$ce37e184d908d785)('tool-select')} [L]`
        ];
        this.currentActiveIndex = 0;
        this.isActive = true;
        let isOpen = false;
        //preload images
        setTimeout(()=>{
            for(let i = 1; i < this.imArr.length; i++){
                const im = new Image();
                im.src = this.imArr[i];
            }
        }, 100);
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'relative',
                flexGrow: '1'
            }
        });
        let openTimeout;
        let isDragging = false;
        let startX;
        let startY;
        let pointerListener;
        if ((0, $d9f9f4926aa80a1c$export$921068d8846a1559).hasPointerEvents) pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.rootEl,
            onPointer: (event)=>{
                if (event.type === 'pointerdown') {
                    if (isOpen) return;
                    openTimeout = setTimeout(()=>{
                        showDropdown();
                    }, 400);
                    isDragging = true;
                    startX = event.pageX;
                    startY = event.pageY;
                } else if (event.type === 'pointermove' && isDragging) {
                    if (!isOpen && (0, $d9f9f4926aa80a1c$export$921068d8846a1559).dist(startX, startY, event.pageX, event.pageY) > 5) {
                        clearTimeout(openTimeout);
                        showDropdown();
                    }
                } else if (event.type === 'pointerup' && isDragging) {
                    clearTimeout(openTimeout);
                    isDragging = false;
                    if (isOpen) {
                        const target = document.elementFromPoint(event.pageX, event.pageY);
                        for(let i = 0; i < this.dropdownBtnArr.length; i++)if (target === this.dropdownBtnArr[i].wrapper) {
                            closeDropdown();
                            this.isActive = true;
                            this.currentActiveIndex = i;
                            this.updateButton();
                            p.onChange(this.optionArr[this.currentActiveIndex]);
                            break;
                        }
                    }
                }
            }
        });
        this.activeButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'toolspace-row-button nohighlight toolspace-row-button-activated',
            title: this.titleArr[this.currentActiveIndex],
            onClick: (e)=>{
                if (this.isActive && !isOpen) {
                    e.preventDefault();
                    e.stopPropagation();
                    showDropdown();
                    return;
                }
                this.isActive = true;
                p.onChange(this.optionArr[this.currentActiveIndex]);
                if (isOpen) closeDropdown();
            },
            css: {
                padding: '10px 0',
                pointerEvents: 'auto',
                height: '100%',
                boxSizing: 'border-box',
                zIndex: '1'
            }
        });
        // hover via JS, so hover-state not stuck on mobile
        const activeButtonPointerListener = new (0, $a07742141701d1f2$export$9371bd96776f4e82)({
            target: this.activeButton,
            onEnterLeave: (isOver)=>{
                this.activeButton.classList.toggle('kl-tool-button--hover', isOver);
            }
        });
        this.activeButtonIm = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.activeButton,
            className: 'dark-invert',
            css: {
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                width: 'calc(100% - 7px)',
                height: '100%',
                pointerEvents: 'none',
                opacity: '0.75'
            }
        });
        this.arrowButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.activeButton,
            className: 'kl-tooldropdown-caret',
            content: (0, $934e5f47c3374e21$export$db3b6bfb95261072)('.dark-invert'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-more-tools'),
            onClick: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                showDropdown();
            }
        });
        const overlay = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                //background: 'rgba(255,0,0,0.5)',
                left: '0',
                top: '0',
                right: '0',
                bottom: '0'
            }
        });
        const overlayPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: overlay,
            onPointer: (e)=>{
                if (e.type === 'pointerdown') {
                    e.eventPreventDefault();
                    closeDropdown();
                }
            }
        });
        const dropdownWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'tool-dropdown-wrapper',
            css: {
                position: 'absolute',
                width: '100%',
                height: 100 * (this.optionArr.length - 1) + '%',
                top: '100%',
                left: '0',
                zIndex: '-1',
                boxSizing: 'border-box',
                cursor: 'pointer',
                transition: 'height 0.1s ease-in-out, opacity 0.1s ease-in-out',
                borderBottomLeftRadius: '5px',
                borderBottomRightRadius: '5px',
                overflow: 'hidden'
            }
        });
        this.dropdownBtnArr = [];
        const createDropdownButton = (p)=>{
            const wrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: dropdownWrapper,
                className: 'tool-dropdown-button',
                title: p.title,
                css: {
                    padding: '10px 0',
                    height: 100 / (this.optionArr.length - 1) + '%',
                    boxSizing: 'border-box'
                },
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    p.onClick(p.index);
                }
            });
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: wrapper,
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + p.image + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    height: '100%',
                    pointerEvents: 'none',
                    opacity: '0.75'
                }
            });
            // --- interface ---
            const show = (b)=>{
                wrapper.style.display = b ? 'block' : 'none';
            };
            const setIsSmall = (b)=>{
                wrapper.style.padding = b ? this.smallMargin : '10px 0';
            };
            return {
                wrapper: wrapper,
                show: show,
                setIsSmall: setIsSmall
            };
        };
        const onClickDropdownBtn = (index)=>{
            closeDropdown();
            this.isActive = true;
            this.currentActiveIndex = index;
            this.updateButton();
            p.onChange(this.optionArr[this.currentActiveIndex]);
        };
        for(let i = 0; i < this.optionArr.length; i++)this.dropdownBtnArr.push(createDropdownButton({
            index: i,
            id: this.optionArr[i],
            image: this.imArr[i],
            title: this.titleArr[i],
            onClick: onClickDropdownBtn
        }));
        const showDropdown = ()=>{
            if ((0, $6b37b427615ca1fa$export$d3d1650bc39c4419).get() > 0) return;
            (0, $6b37b427615ca1fa$export$d3d1650bc39c4419).increase(0.5);
            isOpen = true;
            for(let i = 0; i < this.optionArr.length; i++)this.dropdownBtnArr[i].show(this.currentActiveIndex !== i);
            this.arrowButton.style.setProperty('opacity', '0');
            this.arrowButton.style.setProperty('pointer-events', 'none');
            this.rootEl.style.zIndex = '1';
            document.body.append(overlay);
            this.rootEl.append(dropdownWrapper);
        };
        const closeDropdown = ()=>{
            (0, $6b37b427615ca1fa$export$d3d1650bc39c4419).decrease(0.5);
            isOpen = false;
            this.arrowButton.style.removeProperty('opacity');
            this.arrowButton.style.removeProperty('pointer-events');
            this.rootEl.style.removeProperty('z-index');
            overlay.remove();
            dropdownWrapper.remove();
        };
        this.updateButton();
    }
}







var $c6fbe1c307e83b0f$exports = {};
$c6fbe1c307e83b0f$exports = $parcel$resolve("j4HZO");




class $79297c17befec587$export$c744a22bef9e0b97 {
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    setIsSmall(b) {
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
            height: b ? '36px' : '54px'
        });
        this.toolDropdown.setIsSmall(b);
        this.handButton.setIsSmall(b);
        this.zoomInButton.setIsSmall(b);
        this.zoomOutButton.setIsSmall(b);
        this.undoButton.setIsSmall(b);
        this.redoButton.setIsSmall(b);
        if (b) {
            this.zoomInNOutButton.el.style.display = 'none';
            this.undoNRedoButton.el.style.display = 'none';
            this.zoomInButton.el.style.display = 'block';
            this.zoomOutButton.el.style.display = 'block';
            this.undoButton.el.style.display = 'block';
            this.redoButton.el.style.display = 'block';
        } else {
            this.zoomInNOutButton.el.style.display = 'block';
            this.undoNRedoButton.el.style.display = 'block';
            this.zoomInButton.el.style.display = 'none';
            this.zoomOutButton.el.style.display = 'none';
            this.undoButton.el.style.display = 'none';
            this.redoButton.el.style.display = 'none';
        }
    }
    setEnableZoomIn(b) {
        this.zoomInButton.el.classList.toggle('toolspace-row-button-disabled', !b);
        this.zoomInNOutButton.setIsEnabledLeft(b);
    }
    setEnableZoomOut(b) {
        this.zoomOutButton.el.classList.toggle('toolspace-row-button-disabled', !b);
        this.zoomInNOutButton.setIsEnabledRight(b);
    }
    setEnableUndo(b) {
        this.undoButton.el.classList.toggle('toolspace-row-button-disabled', !b);
        this.undoNRedoButton.setIsEnabledLeft(b);
    }
    setEnableRedo(b) {
        this.redoButton.el.classList.toggle('toolspace-row-button-disabled', !b);
        this.undoNRedoButton.setIsEnabledRight(b);
    }
    setActive(activeStr, doEmit) {
        if (this.currentActiveStr === activeStr) return;
        this.currentActiveStr = activeStr;
        this.toolDropdown.setActive(this.currentActiveStr);
        this.handButton.el.classList.toggle('toolspace-row-button-activated', this.currentActiveStr === 'hand');
        if (doEmit) this.onActivate(this.currentActiveStr);
    }
    getActive() {
        return this.currentActiveStr;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-toolspace-row',
            css: {
                height: '54px',
                display: 'flex'
            }
        });
        this.onActivate = p.onActivate;
        this.currentActiveStr = 'brush';
        const createButton = (p)=>{
            const smallMargin = p.doLighten ? '6px 0' : '8px 0';
            const el = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'toolspace-row-button nohighlight',
                //title: p.title,
                onClick: p.onClick,
                css: {
                    padding: p.contain ? '10px 0' : ''
                }
            });
            const im = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + p.image + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: p.contain ? 'contain' : '',
                    //filter: 'grayscale(1)',
                    height: '100%',
                    transform: p.doMirror ? 'scale(-1, 1)' : '',
                    pointerEvents: 'none',
                    opacity: p.doLighten ? '0.75' : '1'
                }
            });
            el.append(im);
            const pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                // because :hover causes problems w touch
                target: el,
                onEnterLeave: (isOver)=>{
                    el.classList.toggle('toolspace-row-button-hover', isOver);
                }
            });
            const setIsSmall = (b)=>{
                el.style.padding = p.contain ? b ? smallMargin : '10px 0' : '';
            };
            return {
                el: el,
                pointerListener: pointerListener,
                setIsSmall: setIsSmall
            };
        };
        const createTriangleButton = (p)=>{
            // because IE and Edge don't support clip path
            const result = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    flexGrow: '1',
                    position: 'relative'
                }
            });
            const svg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
                elementType: 'svg',
                width: '67px',
                height: '54px',
                viewBox: '0 0 100 100',
                preserveAspectRatio: 'none'
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(svg, {
                position: 'absolute',
                left: '0',
                top: '0'
            });
            const blurRadius = 10;
            const blurOffsetX = 2;
            const blurOffsetY = 2;
            const defs = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
                // inset shadow via svg
                elementType: 'defs',
                childrenArr: [
                    {
                        elementType: 'filter',
                        id: 'innershadow',
                        x0: '-50%',
                        y0: '-50%',
                        width: '200%',
                        height: '200%',
                        childrenArr: [
                            {
                                elementType: 'feGaussianBlur',
                                in: 'SourceAlpha',
                                stdDeviation: '' + blurRadius,
                                result: 'blur'
                            },
                            {
                                elementType: 'feOffset',
                                dx: '' + blurOffsetX,
                                dy: '' + blurOffsetY
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'SourceAlpha',
                                operator: 'arithmetic',
                                k2: '-1',
                                k3: '1',
                                result: 'shadowDiff'
                            },
                            {
                                elementType: 'feFlood',
                                'flood-color': '#000',
                                'flood-opacity': '0.2'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'shadowDiff',
                                operator: 'in'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'SourceGraphic',
                                operator: 'over',
                                result: 'firstfilter'
                            },
                            {
                                elementType: 'feGaussianBlur',
                                in: 'firstfilter',
                                stdDeviation: '' + blurRadius,
                                result: 'blur2'
                            },
                            {
                                elementType: 'feOffset',
                                dx: '' + blurOffsetX,
                                dy: '' + blurOffsetY
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'firstfilter',
                                operator: 'arithmetic',
                                k2: '-1',
                                k3: '1',
                                result: 'shadowDiff'
                            },
                            {
                                elementType: 'feFlood',
                                'flood-color': '#000',
                                'flood-opacity': '0.2'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'shadowDiff',
                                operator: 'in'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'firstfilter',
                                operator: 'over'
                            }
                        ]
                    }
                ]
            });
            const svgTriangleLeft = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
                elementType: 'path',
                'vector-effect': 'non-scaling-stroke',
                d: 'M0,0 L 100,0 0,100 z',
                fill: 'rgba(0,0,0,0)',
                class: 'toolspace-svg-triangle-button'
            });
            svgTriangleLeft.onclick = ()=>{
                p.onLeft();
                svgTriangleLeft.classList.remove('toolspace-svg-triangle-button-hover');
            };
            const svgTriangleRight = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
                elementType: 'path',
                'vector-effect': 'non-scaling-stroke',
                d: 'M100,100 L 100,0 0,100 z',
                fill: 'rgba(0,0,0,0)',
                class: 'toolspace-svg-triangle-button'
            });
            svgTriangleRight.onclick = ()=>{
                p.onRight();
                svgTriangleRight.classList.remove('toolspace-svg-triangle-button-hover');
            };
            // because :hover causes problems w touch
            const leftPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: svgTriangleLeft,
                onEnterLeave: (isOver)=>{
                    svgTriangleLeft.classList.toggle('toolspace-svg-triangle-button-hover', isOver);
                }
            });
            const rightPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: svgTriangleRight,
                onEnterLeave: (isOver)=>{
                    svgTriangleRight.classList.toggle('toolspace-svg-triangle-button-hover', isOver);
                }
            });
            svg.append(defs, svgTriangleLeft, svgTriangleRight);
            result.append(svg);
            const leftIm = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: result,
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + p.leftImage + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    width: '20px',
                    height: '20px',
                    position: 'absolute',
                    left: '10px',
                    top: '8px',
                    //transform: p.doMirror ? 'scale(-1, 1)' : '',
                    pointerEvents: 'none'
                }
            });
            result.append(leftIm);
            const rightIm = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: result,
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + (p.rightImage ? p.rightImage : p.leftImage) + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    width: '20px',
                    height: '20px',
                    position: 'absolute',
                    right: '10px',
                    bottom: '8px',
                    transform: p.rightImage ? '' : 'scale(-1, 1)',
                    pointerEvents: 'none'
                }
            });
            const setIsEnabledLeft = (b)=>{
                svgTriangleLeft.classList.toggle('toolspace-row-button-disabled', !b);
                leftIm.classList.toggle('toolspace-row-button-disabled', !b);
            };
            const setIsEnabledRight = (b)=>{
                svgTriangleRight.classList.toggle('toolspace-row-button-disabled', !b);
                rightIm.classList.toggle('toolspace-row-button-disabled', !b);
            };
            return {
                el: result,
                setIsEnabledLeft: setIsEnabledLeft,
                setIsEnabledRight: setIsEnabledRight,
                leftPointerListener: leftPointerListener,
                rightPointerListener: rightPointerListener
            };
        };
        this.toolDropdown = new (0, $d199831ecec4fae4$export$a0a40f8a0b8fee15)({
            onChange: (activeStr)=>{
                this.setActive(activeStr, true);
            }
        });
        this.rootEl.append(this.toolDropdown.getElement());
        this.handButton = createButton({
            onClick: ()=>{
                this.setActive('hand', true);
            },
            image: (0, (/*@__PURE__*/$parcel$interopDefault($071c8859c903033f$exports))),
            contain: true,
            doLighten: true
        });
        this.handButton.el.classList.add('kl-tool-row-border-right');
        this.handButton.el.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-hand');
        this.rootEl.append(this.handButton.el);
        this.zoomInNOutButton = createTriangleButton({
            onLeft: p.onZoomIn,
            onRight: p.onZoomOut,
            leftImage: (0, (/*@__PURE__*/$parcel$interopDefault($4ae8ffb159df37c1$exports))),
            rightImage: (0, (/*@__PURE__*/$parcel$interopDefault($c1f95fb9358806e5$exports)))
        });
        this.zoomInNOutButton.el.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-zoom');
        this.rootEl.append(this.zoomInNOutButton.el);
        this.zoomInButton = createButton({
            onClick: p.onZoomIn,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($4ae8ffb159df37c1$exports))),
            contain: true
        });
        this.zoomInButton.el.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('zoom-in');
        this.rootEl.append(this.zoomInButton.el);
        this.zoomOutButton = createButton({
            onClick: p.onZoomOut,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($c1f95fb9358806e5$exports))),
            contain: true
        });
        this.zoomOutButton.el.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('zoom-out');
        this.rootEl.append(this.zoomOutButton.el);
        this.undoNRedoButton = createTriangleButton({
            onLeft: p.onUndo,
            onRight: p.onRedo,
            leftImage: (0, (/*@__PURE__*/$parcel$interopDefault($c6fbe1c307e83b0f$exports))),
            rightImage: null
        });
        this.undoNRedoButton.el.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('undo') + '/' + (0, $63d0b335c576c718$export$ce37e184d908d785)('redo');
        this.undoNRedoButton.setIsEnabledLeft(false);
        this.undoNRedoButton.setIsEnabledRight(false);
        this.rootEl.append(this.undoNRedoButton.el);
        this.undoButton = createButton({
            onClick: p.onUndo,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($c6fbe1c307e83b0f$exports))),
            contain: true
        });
        this.undoButton.el.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('undo');
        this.undoButton.el.classList.add('toolspace-row-button-disabled');
        this.rootEl.append(this.undoButton.el);
        this.redoButton = createButton({
            onClick: p.onRedo,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($c6fbe1c307e83b0f$exports))),
            contain: true,
            doMirror: true
        });
        this.redoButton.el.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('redo');
        this.redoButton.el.classList.add('toolspace-row-button-disabled');
        this.rootEl.append(this.redoButton.el);
        this.zoomInButton.el.style.display = 'none';
        this.zoomOutButton.el.style.display = 'none';
        this.undoButton.el.style.display = 'none';
        this.redoButton.el.style.display = 'none';
    }
}





class $6ae4f2a30e17169a$export$8162a66cd18867a7 {
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'label',
            className: 'kl-stabilizer',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('stabilizer') + '&nbsp;',
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('stabilizer-title')
        });
        const strengthSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
            optionArr: [
                [
                    '0',
                    '0'
                ],
                [
                    '1',
                    '1'
                ],
                [
                    '2',
                    '2'
                ],
                [
                    '3',
                    '3'
                ],
                [
                    '4',
                    '4'
                ],
                [
                    '5',
                    '5'
                ]
            ],
            initValue: '' + p.smoothing,
            onChange: function(val) {
                p.onSelect(parseInt(val));
            },
            name: 'stabilizer-strength'
        });
        this.rootEl.append(strengthSelect.getElement());
        this.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.rootEl,
            onWheel: function(e) {
                strengthSelect.setDeltaValue(e.deltaY);
            }
        });
    }
}




class $ae064bc6cfaee2ee$export$3c6d17ed0106bfb9 {
    // update
    update() {
        for(let i = 0; i < this.tabArr.length; i++)this.tabArr[i].update(this.activeTab);
    }
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    open(tabId) {
        for(let i = 0; i < this.tabArr.length; i++)if (this.tabArr[i].id === tabId) {
            if (this.activeTab === this.tabArr[i]) // already open
            return;
            this.activeTab.onClose();
            this.activeTab = this.tabArr[i];
            this.activeTab.onOpen();
            this.activeTab.el.append(this.roundRight, this.roundLeft);
            this.update();
            return;
        }
        throw 'TabRow.open - invalid tabId';
    }
    getOpenedTabId() {
        return '' + this.activeTab.id;
    }
    setIsVisible(tabId, isVisible) {
        for(let i = 0; i < this.tabArr.length; i++)if (this.tabArr[i].id === tabId) {
            this.tabArr[i].isVisible = isVisible;
            this.update();
            return;
        }
        throw 'TabRow.setIsVisible - invalid tabId';
    }
    destroy() {
        this.tabArr.forEach((item)=>{
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(item.el);
            item.pointerListener.destroy();
        });
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        var _p_height;
        const height = (_p_height = p.height) !== null && _p_height !== void 0 ? _p_height : 35;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'tabrow',
            css: {
                height: height + 1 + 'px'
            }
        });
        this.tabArr = []; //creates its own internal arr
        const roundSize = 10;
        this.roundRight = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'tabrow__tab__rounding-left'
        });
        this.roundLeft = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'tabrow__tab__rounding-right'
        });
        const createTab = (pTabObj, initialId, useAccent)=>{
            const isVisible = 'isVisible' in pTabObj && pTabObj.isVisible !== undefined ? pTabObj.isVisible : true;
            const result = {
                id: pTabObj.id,
                isVisible: isVisible,
                onOpen: pTabObj.onOpen,
                onClose: pTabObj.onClose,
                update: (openedTabObj)=>{
                    result.el.className = openedTabObj === result ? useAccent ? 'tabrow__tab tabrow__tab--opened-accented' : 'tabrow__tab tabrow__tab--opened' : 'tabrow__tab';
                    result.el.style.display = result.isVisible ? 'block' : 'none';
                },
                el: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    parent: this.rootEl,
                    content: 'label' in pTabObj ? pTabObj.label : '',
                    title: 'title' in pTabObj ? pTabObj.title : undefined,
                    className: initialId === pTabObj.id ? useAccent ? 'tabrow__tab tabrow__tab--opened-accented' : 'tabrow__tab tabrow__tab--opened' : 'tabrow__tab',
                    css: {
                        lineHeight: height + 'px',
                        display: isVisible ? 'block' : 'none'
                    },
                    onClick: ()=>{
                        if (this.activeTab === result) return;
                        this.open(result.id);
                    }
                }),
                pointerListener: {}
            };
            if ('image' in pTabObj) (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'span',
                parent: result.el,
                className: 'dark-invert',
                css: {
                    backgroundImage: `url("${pTabObj.image}")`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    height: height - 7 + 'px',
                    justifyContent: 'center',
                    margin: '4px auto'
                }
            });
            if ('css' in pTabObj && pTabObj.css !== undefined) (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(result.el, pTabObj.css);
            result.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                // because :hover causes problems w touch
                target: result.el,
                onEnterLeave: (isOver)=>{
                    result.el.classList.toggle('tabrow__tab-hover', isOver);
                }
            });
            if (initialId === result.id) {
                result.onOpen();
                result.el.append(this.roundRight, this.roundLeft);
            } else result.onClose();
            return result;
        };
        let initTabObj = null;
        for(let i = 0; i < p.tabArr.length; i++){
            const tab = createTab(p.tabArr[i], p.initialId, p.useAccent || false);
            if (tab.id === p.initialId) initTabObj = tab;
            this.tabArr.push(tab);
        }
        if (!initTabObj) throw 'invalid initialId';
        this.activeTab = initTabObj;
    }
}




var $457bbdb587ea898d$exports = {};
$457bbdb587ea898d$exports = $parcel$resolve("ea7ga");







const $d4c26c4eab3ed9b4$var$LS_INERTIA_KEY = 'kl-inertia-scroll';
class $d4c26c4eab3ed9b4$export$cf20160367bae46c {
    updateUi() {
        this.scaleEl.innerHTML = Math.round(this.scale * 100) + '%';
        this.angleEl.innerHTML = Math.round(this.angleDeg) + "\xb0";
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.angleIm, {
            transform: 'rotate(' + this.angleDeg + 'deg)',
            boxShadow: this.angleDeg % 90 === 0 ? 'inset 0 0 0 1px rgba(255,255,255, 1), 0 0 0 1px rgba(0, 0, 0, 0.3)' : ''
        });
    }
    getElement() {
        return this.rootEl;
    }
    setIsVisible(pIsVisible) {
        this.isVisible = pIsVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) this.updateUi();
    }
    update(pScale, pAngleDeg) {
        this.scale = pScale;
        this.angleDeg = pAngleDeg;
        if (this.isVisible) this.updateUi();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isVisible = true;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                margin: '10px'
            }
        });
        this.scale = p.scale;
        this.angleDeg = p.angleDeg;
        this.onAngleChange = p.onAngleChange;
        const row1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                marginBottom: '10px',
                display: 'flex'
            }
        });
        const row2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                marginBottom: '10px'
            }
        });
        const row3 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex'
            }
        });
        this.rootEl.append(row1, row2, row3);
        this.scaleEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '65px',
                userSelect: 'none',
                fontFamily: 'monospace'
            }
        });
        row1.append(this.scaleEl);
        this.angleIm = new Image();
        this.angleIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($e64ad8a2a278ae06$exports)));
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.angleIm, {
            verticalAlign: 'bottom',
            width: '20px',
            height: '20px',
            marginRight: '5px',
            borderRadius: '10px',
            background: 'rgba(0,0,0,0.2)',
            userSelect: 'none'
        });
        row1.append(this.angleIm);
        this.angleEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: row1,
            css: {
                userSelect: 'none'
            }
        });
        this.updateUi();
        const resetButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('hand-reset'),
            onClick: p.onReset
        });
        (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(resetButton);
        const fitButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('hand-fit'),
            css: {
                marginLeft: '10px'
            },
            onClick: p.onFit
        });
        (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(fitButton);
        row2.append(resetButton, fitButton);
        const leftRotateIcon = new Image();
        leftRotateIcon.height = 20;
        leftRotateIcon.src = (0, (/*@__PURE__*/$parcel$interopDefault($457bbdb587ea898d$exports)));
        leftRotateIcon.alt = 'Rotate';
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(leftRotateIcon, {
            transform: 'scale(-1, 1)'
        });
        const leftRotateButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: leftRotateIcon,
            onClick: function() {
                p.onAngleChange(-15, true);
            }
        });
        (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(leftRotateButton);
        const resetAngleButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: "0\xb0",
            css: {
                marginLeft: '10px'
            },
            onClick: function() {
                p.onAngleChange(0);
            }
        });
        (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(resetAngleButton);
        const rightRotateButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: '<img height="20" src="' + (0, (/*@__PURE__*/$parcel$interopDefault($457bbdb587ea898d$exports))) + '" alt="Rotate"/>',
            css: {
                marginLeft: '10px'
            },
            onClick: function() {
                p.onAngleChange(15, true);
            }
        });
        (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(rightRotateButton);
        row3.append(leftRotateButton, resetAngleButton, rightRotateButton);
        const inertiaToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('hand-inertia-scrolling'),
            init: (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem($d4c26c4eab3ed9b4$var$LS_INERTIA_KEY) === 'true',
            callback: (b)=>{
                (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem($d4c26c4eab3ed9b4$var$LS_INERTIA_KEY, '' + b);
                p.onChangeUseInertiaScrolling(b);
            },
            name: 'enable-inertia-scrolling'
        });
        setTimeout(()=>{
            p.onChangeUseInertiaScrolling(inertiaToggle.getValue());
        }, 500);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(inertiaToggle.getElement(), {
            marginTop: '10px',
            display: 'inline-block'
        });
        this.rootEl.append(inertiaToggle.getElement());
    }
}








class $274b5c24f0b5af79$export$1e63e3b0645421a2 {
    getElement() {
        return this.rootEl;
    }
    setIsVisible(pIsVisible) {
        this.isVisible = pIsVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) this.colorDiv.append(this.colorSlider.getElement(), this.colorSlider.getOutputElement());
    }
    /**
     * [0, 1]
     */ getTolerance() {
        // slider may display 0 when value is 1 -> avoid confusing users
        if (Math.round(this.toleranceSlider.getDisplayValue()) === 0) return 0;
        return this.toleranceSlider.getValue();
    }
    getOpacity() {
        return this.opacitySlider.getValue();
    }
    getSample() {
        return this.modeSelect.getValue();
    }
    getGrow() {
        return parseInt(this.growSelect.getValue(), 10);
    }
    getContiguous() {
        return this.isContiguous;
    }
    getIsEraser() {
        return this.eraserToggle.getValue();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                margin: '10px'
            }
        });
        this.isVisible = true;
        this.colorDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                marginBottom: '10px'
            }
        });
        this.colorSlider = p.colorSlider;
        this.opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
            width: 250,
            height: 30,
            min: 0.01,
            max: 1,
            value: 1,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100
        });
        this.rootEl.append(this.opacitySlider.getElement());
        this.toleranceSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-tolerance'),
            width: 250,
            height: 30,
            min: 0,
            max: 255,
            value: 51,
            toValue: (displayValue)=>displayValue * 2.55,
            toDisplayValue: (value)=>value / 2.55
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.toleranceSlider.getElement(), {
            marginTop: '10px'
        });
        this.rootEl.append(this.toleranceSlider.getElement());
        const selectRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                marginTop: '10px'
            }
        });
        const modeWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-sample') + '&nbsp;',
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-sample-title'),
            css: {
                fontSize: '15px'
            }
        });
        this.modeSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
            optionArr: [
                [
                    'all',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-sample-all')
                ],
                [
                    'current',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-sample-active')
                ],
                [
                    'above',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-sample-above')
                ]
            ],
            initValue: 'all',
            name: 'sampling-mode'
        });
        const modePointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.modeSelect.getElement(),
            onWheel: (e)=>{
                this.modeSelect.setDeltaValue(e.deltaY);
            }
        });
        modeWrapper.append(this.modeSelect.getElement());
        selectRow.append(modeWrapper);
        const growWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-grow') + '&nbsp;',
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-grow-title'),
            css: {
                fontSize: '15px',
                marginLeft: '10px'
            }
        });
        this.growSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
            optionArr: [
                [
                    '0',
                    '0'
                ],
                [
                    '1',
                    '1'
                ],
                [
                    '2',
                    '2'
                ],
                [
                    '3',
                    '3'
                ],
                [
                    '4',
                    '4'
                ],
                [
                    '5',
                    '5'
                ],
                [
                    '6',
                    '6'
                ],
                [
                    '7',
                    '7'
                ]
            ],
            initValue: '0',
            name: 'fill-growth'
        });
        const growPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.growSelect.getElement(),
            onWheel: (e)=>{
                this.growSelect.setDeltaValue(e.deltaY);
            }
        });
        growWrapper.append(this.growSelect.getElement());
        selectRow.append(growWrapper);
        this.isContiguous = true;
        const contiguousToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-contiguous'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('bucket-contiguous-title'),
            callback: (b)=>{
                this.isContiguous = b;
            },
            name: 'is-contiguous'
        });
        this.eraserToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('eraser'),
            name: 'eraser-toggle'
        });
        this.rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                contiguousToggle.getElement(),
                this.eraserToggle.getElement()
            ],
            css: {
                display: 'flex',
                marginTop: '10px',
                gap: '10px'
            }
        }));
    }
}




class $a6bad5d4783f8133$export$32a22540e4b2f123 {
    getElement() {
        return this.rootEl;
    }
    setIsVisible(pIsVisible) {
        this.isVisible = pIsVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) this.colorDiv.append(this.colorSlider.getElement(), this.colorSlider.getOutputElement());
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isVisible = true;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                margin: '10px'
            }
        });
        this.colorSlider = p.colorSlider;
        this.colorDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                marginBottom: '10px'
            }
        });
        const hint = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-instruction')
        });
    }
}








class $f0a35036bcb542fb$export$a9387b1d4260d39c {
    getElement() {
        return this.rootEl;
    }
    setIsVisible(pIsVisible) {
        this.isVisible = pIsVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) {
            this.colorDiv.append(this.colorSlider.getElement());
            this.colorDiv.append(this.colorSlider.getOutputElement());
        //update();
        }
    }
    getShape() {
        return this.shape;
    }
    getMode() {
        return this.mode;
    }
    getIsEraser() {
        return this.eraserToggle.getValue();
    }
    getOpacity() {
        return this.opacitySlider.getValue();
    }
    getLineWidth() {
        return this.lineWidthSlider.getValue();
    }
    getIsOutwards() {
        return this.outwardsToggle.getValue();
    }
    getIsFixed() {
        return this.fixedToggle.getValue();
    }
    getIsSnap() {
        return this.snapToggle.getValue();
    }
    getDoLockAlpha() {
        return this.lockAlphaToggle.getValue();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.shape = 'rect';
        this.mode = 'stroke';
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                margin: '10px'
            }
        });
        this.isVisible = true;
        this.colorDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                marginBottom: '10px'
            }
        });
        this.colorSlider = p.colorSlider;
        const previewSize = 35;
        const previewPadding = 8;
        const rectStrokeSvgRect = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'rect',
            x: '' + previewPadding,
            width: '' + (previewSize - previewPadding * 2)
        });
        const rectStrokeSvg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        rectStrokeSvg.classList.add('dark-invert');
        rectStrokeSvg.append(rectStrokeSvgRect);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(rectStrokeSvg, {
            display: 'block'
        });
        const rectFilledSvgRect = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'rect',
            x: '' + previewPadding,
            width: '' + (previewSize - previewPadding * 2)
        });
        const rectFilledSvg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        rectFilledSvg.classList.add('dark-invert');
        rectFilledSvg.append(rectFilledSvgRect);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(rectFilledSvg, {
            display: 'block'
        });
        const ellipseStrokeSvgEllipse = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'ellipse',
            cx: '' + previewSize / 2,
            cy: '' + previewSize / 2,
            rx: '' + (previewSize / 2 - previewPadding)
        });
        const ellipseStrokeSvg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        ellipseStrokeSvg.classList.add('dark-invert');
        ellipseStrokeSvg.append(ellipseStrokeSvgEllipse);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(ellipseStrokeSvg, {
            display: 'block'
        });
        const ellipseFilledSvgEllipse = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'ellipse',
            cx: '' + previewSize / 2,
            cy: '' + previewSize / 2,
            rx: '' + (previewSize / 2 - previewPadding)
        });
        const ellipseFilledSvg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        ellipseFilledSvg.classList.add('dark-invert');
        ellipseFilledSvg.append(ellipseFilledSvgEllipse);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(ellipseFilledSvg, {
            display: 'block'
        });
        const lineSvgLine = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'line',
            x1: '' + previewPadding,
            x2: '' + (previewSize - previewPadding)
        });
        const lineSvg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        lineSvg.classList.add('dark-invert');
        lineSvg.append(lineSvgLine);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(lineSvg, {
            display: 'block'
        });
        const updatePreviews = ()=>{
            const strokeWidth = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(Math.round(this.lineWidthSlider.getValue() / 10), 1, 10) + 'px';
            const squish = 1.35;
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(rectStrokeSvgRect, {
                fill: 'none',
                stroke: 'black',
                strokeWidth: strokeWidth
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(rectFilledSvgRect, {
                fill: 'black',
                stroke: 'none'
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(ellipseStrokeSvgEllipse, {
                fill: 'none',
                stroke: 'black',
                strokeWidth: strokeWidth
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(ellipseFilledSvgEllipse, {
                fill: 'black',
                stroke: 'none'
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(lineSvgLine, {
                fill: 'none',
                stroke: 'black',
                strokeWidth: strokeWidth
            });
            if (this.fixedToggle.getValue()) {
                rectStrokeSvgRect.setAttribute('y', '' + previewPadding);
                rectStrokeSvgRect.setAttribute('height', '' + (previewSize - previewPadding * 2));
                rectFilledSvgRect.setAttribute('y', '' + previewPadding);
                rectFilledSvgRect.setAttribute('height', '' + (previewSize - previewPadding * 2));
                ellipseStrokeSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding));
                ellipseFilledSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding));
            } else {
                rectStrokeSvgRect.setAttribute('y', '' + previewPadding * squish);
                rectStrokeSvgRect.setAttribute('height', '' + (previewSize - previewPadding * squish * 2));
                rectFilledSvgRect.setAttribute('y', '' + previewPadding * squish);
                rectFilledSvgRect.setAttribute('height', '' + (previewSize - previewPadding * squish * 2));
                ellipseStrokeSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding * squish));
                ellipseFilledSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding * squish));
            }
            if (this.snapToggle.getValue()) {
                lineSvgLine.setAttribute('y1', '' + (previewSize - previewPadding));
                lineSvgLine.setAttribute('y2', '' + previewPadding);
            } else {
                lineSvgLine.setAttribute('y1', '' + (previewSize - previewPadding * squish));
                lineSvgLine.setAttribute('y2', '' + previewPadding * squish);
            }
        };
        const row1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'start'
            }
        });
        const shapeOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'rect-stroke',
                    label: rectStrokeSvg,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-rect') + ' ' + (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-stroke')
                },
                {
                    id: 'ellipse-stroke',
                    label: ellipseStrokeSvg,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-ellipse') + ' ' + (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-stroke')
                },
                {
                    id: 'line',
                    label: lineSvg,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-line')
                },
                {
                    id: 'rect-fill',
                    label: rectFilledSvg,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-rect') + ' ' + (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-fill')
                },
                {
                    id: 'ellipse-fill',
                    label: ellipseFilledSvg,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-ellipse') + ' ' + (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-fill')
                }
            ],
            initId: this.shape + ' ' + this.mode,
            onChange: (id)=>{
                const split = id.split('-');
                this.shape = split[0];
                this.mode = split[1];
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.fixedToggle.getElement(), {
                    display: this.shape === 'line' ? 'none' : ''
                });
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.snapToggle.getElement(), {
                    display: this.shape === 'line' ? '' : 'none'
                });
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.lineWidthSlider.getElement(), {
                    display: this.shape !== 'line' && this.mode === 'fill' ? 'none' : ''
                });
            },
            changeOnInit: true,
            css: {
                width: '120px'
            }
        });
        row1.append(shapeOptions.getElement());
        this.eraserToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('eraser'),
            callback: ()=>{
                updatePreviews();
            },
            name: 'enable-eraser'
        });
        this.lockAlphaToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha-title'),
            doHighlight: true,
            name: 'enable-alpha-lock'
        });
        this.lockAlphaToggle.getElement().style.marginTop = '10px';
        this.panningToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-auto-pan'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-auto-pan-title'),
            callback: (b)=>p.onChangePanning(b),
            name: 'enable-auto-pan'
        });
        this.panningToggle.getElement().style.marginTop = '10px';
        row1.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                this.eraserToggle.getElement(),
                this.lockAlphaToggle.getElement(),
                this.panningToggle.getElement()
            ]
        }));
        this.lineWidthSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-line-width'),
            width: 250,
            height: 30,
            min: 1,
            max: 200,
            value: 4,
            curve: 'quadratic',
            onChange: ()=>{
                updatePreviews();
            }
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.lineWidthSlider.getElement(), {
            marginTop: '10px'
        });
        this.rootEl.append(this.lineWidthSlider.getElement());
        this.opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
            width: 250,
            height: 30,
            min: 0.01,
            max: 1,
            value: 1,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.opacitySlider.getElement(), {
            marginTop: '10px'
        });
        this.rootEl.append(this.opacitySlider.getElement());
        const row2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px',
                gap: '10px'
            }
        });
        this.outwardsToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-outwards'),
            name: 'enable-outwards'
        });
        row2.append(this.outwardsToggle.getElement());
        this.fixedToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-fixed'),
            callback: ()=>{
                updatePreviews();
            },
            name: 'enable-fixed-proportions'
        });
        row2.append(this.fixedToggle.getElement());
        this.snapToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('angle-snap'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('angle-snap-title'),
            callback: ()=>{
                updatePreviews();
            },
            name: 'enable-angle-snapping'
        });
        row2.append(this.snapToggle.getElement());
        updatePreviews();
    }
}








function $1b372d80cb7a52ec$export$9852986a3ec5f6a0(data, cellProps) {
    const result = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'table',
        className: 'kl-table'
    });
    data.forEach((row, rowIndex)=>{
        const rowEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'tr'
        });
        rowEl.append(...row.map((el, colIndex)=>{
            const cellEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'td',
                content: el
            });
            const key = rowIndex + '.' + colIndex;
            if (cellProps !== undefined && key in cellProps) cellEl.rowSpan = cellProps[key].rowspan;
            return cellEl;
        }));
        result.append(rowEl);
    });
    return result;
}



function $d43dc22de82019e6$export$f77a89101d7d6586(p) {
    const currentColor = p.currentColor;
    const secondaryColor = p.secondaryColor;
    const maxCanvasSize = p.maxCanvasSize;
    const canvasWidth = p.canvasWidth;
    const canvasHeight = p.canvasHeight;
    const workspaceWidth = p.workspaceWidth;
    const workspaceHeight = p.workspaceHeight;
    const onConfirm = p.onConfirm;
    const onCancel = p.onCancel;
    function createRatioSize(ratioX, ratioY, width, height, padding) {
        return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(ratioX, ratioY, Math.min(maxCanvasSize, width - padding), Math.min(maxCanvasSize, height - padding), 1);
    }
    const newImDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
    const widthInput = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'input',
        custom: {
            name: 'image-width'
        }
    });
    const unitStyle = {
        color: '#888',
        fontSize: '12px',
        marginLeft: '5px'
    };
    const widthUnit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        textContent: (0, $63d0b335c576c718$export$ce37e184d908d785)('new-px'),
        css: unitStyle
    });
    const heightInput = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'input',
        custom: {
            name: 'image-height'
        }
    });
    const heightUnit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        textContent: (0, $63d0b335c576c718$export$ce37e184d908d785)('new-px'),
        css: unitStyle
    });
    widthInput.setAttribute('data-ignore-focus', 'true');
    heightInput.setAttribute('data-ignore-focus', 'true');
    widthInput.type = 'number';
    widthInput.min = '1';
    widthInput.max = '' + maxCanvasSize;
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(widthInput, {
        width: '70px'
    });
    heightInput.type = 'number';
    heightInput.min = '1';
    heightInput.max = '' + maxCanvasSize;
    heightInput.style.width = '70px';
    widthInput.value = '' + canvasWidth;
    heightInput.value = '' + canvasHeight;
    widthInput.onclick = ()=>{
        widthInput.focus();
        updateRatio();
    };
    heightInput.onclick = ()=>{
        heightInput.focus();
        updateRatio();
    };
    const sizeTable = (0, $1b372d80cb7a52ec$export$9852986a3ec5f6a0)([
        [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('width') + ':&nbsp;',
            widthInput,
            widthUnit
        ],
        [
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    height: '5px'
                }
            }),
            '',
            ''
        ],
        [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('height') + ':&nbsp;',
            heightInput,
            heightUnit
        ]
    ]);
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(sizeTable, {
        marginBottom: '10px'
    });
    const ratioWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            marginTop: '5px',
            color: '#888'
        }
    });
    const templateWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '5px',
            marginBottom: '10px'
        }
    });
    const presetBtnConfig = {
        tagName: 'button',
        css: {
            flexGrow: '1'
        }
    };
    const presetFitBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el(presetBtnConfig);
    const presetCurrentBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el(presetBtnConfig);
    const presetSquareBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el(presetBtnConfig);
    const presetLandscapeBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el(presetBtnConfig);
    const presetPortraitBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el(presetBtnConfig);
    const presetOversizeBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el(presetBtnConfig);
    presetCurrentBtn.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('new-current');
    presetFitBtn.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('new-fit');
    presetOversizeBtn.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('new-oversize');
    presetLandscapeBtn.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('new-landscape');
    presetPortraitBtn.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('new-portrait');
    presetSquareBtn.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('new-square');
    templateWrapper.append(presetCurrentBtn, presetFitBtn, presetOversizeBtn, presetSquareBtn, presetLandscapeBtn, presetPortraitBtn);
    const templatePadding = 0;
    presetCurrentBtn.onclick = function() {
        widthInput.value = '' + canvasWidth;
        heightInput.value = '' + canvasHeight;
        updateRatio();
    };
    presetFitBtn.onclick = function() {
        widthInput.value = '' + workspaceWidth;
        heightInput.value = '' + workspaceHeight;
        updateRatio();
    };
    presetOversizeBtn.onclick = function() {
        widthInput.value = '' + (workspaceWidth + 500);
        heightInput.value = '' + (workspaceHeight + 500);
        updateRatio();
    };
    presetSquareBtn.onclick = function() {
        const sizeObj = createRatioSize(1, 1, workspaceWidth, workspaceHeight, templatePadding);
        widthInput.value = '' + Math.round(sizeObj.width);
        heightInput.value = '' + Math.round(sizeObj.height);
        updateRatio();
    };
    presetLandscapeBtn.onclick = function() {
        const sizeObj = createRatioSize(4, 3, workspaceWidth, workspaceHeight, templatePadding);
        widthInput.value = '' + Math.round(sizeObj.width);
        heightInput.value = '' + Math.round(sizeObj.height);
        updateRatio();
    };
    presetPortraitBtn.onclick = function() {
        const sizeObj = createRatioSize(3, 4, workspaceWidth, workspaceHeight, templatePadding);
        widthInput.value = '' + Math.round(sizeObj.width);
        heightInput.value = '' + Math.round(sizeObj.height);
        updateRatio();
    };
    const select = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
        isFocusable: true,
        optionArr: [
            [
                'screen',
                (0, $63d0b335c576c718$export$ce37e184d908d785)('new-screen')
            ],
            [
                '16 9',
                (0, $63d0b335c576c718$export$ce37e184d908d785)('new-video') + ' 16:9'
            ],
            [
                '3 2',
                '3:2'
            ],
            [
                '5 3',
                '5:3'
            ],
            [
                '2 1',
                '2:1'
            ],
            [
                'paper',
                (0, $63d0b335c576c718$export$ce37e184d908d785)('new-din-paper') + " \u221A2:1"
            ],
            [
                '9 16',
                '9:16'
            ],
            [
                '2 3',
                '2:3'
            ],
            [
                '3 5',
                '3:5'
            ],
            [
                '1 2',
                '1:2'
            ],
            [
                '1 1.4142135623730951',
                "1:\u221A2"
            ]
        ],
        onChange: function(val) {
            if (val === 'screen') {
                widthInput.value = '' + window.screen.width;
                heightInput.value = '' + window.screen.height;
            } else if (val === 'paper') {
                const sizeObj = createRatioSize(Math.sqrt(2), 1, workspaceWidth, workspaceHeight, templatePadding);
                widthInput.value = '' + Math.round(sizeObj.width);
                heightInput.value = '' + Math.round(sizeObj.height);
            } else {
                const split = val.split(' ');
                const sizeObj = createRatioSize(parseFloat(split[0]), parseFloat(split[1]), workspaceWidth, workspaceHeight, templatePadding);
                widthInput.value = '' + Math.round(sizeObj.width);
                heightInput.value = '' + Math.round(sizeObj.height);
            }
            updateRatio();
            select.setValue(undefined);
        },
        name: 'image-format'
    });
    setTimeout(()=>{
        // safari: not empty without also setting it to null via timeout
        select.setValue(undefined);
    }, 0);
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(select.getElement(), {
        width: '80px',
        flexGrow: '1'
    });
    templateWrapper.append(select.getElement());
    let backgroundRgba = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
    };
    const colorOptionsArr = [
        {
            r: 255,
            g: 255,
            b: 255,
            a: 1
        },
        {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        },
        {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        },
        {
            r: currentColor.r,
            g: currentColor.g,
            b: currentColor.b,
            a: 1
        },
        {
            r: secondaryColor.r,
            g: secondaryColor.g,
            b: secondaryColor.b,
            a: 1
        }
    ];
    const colorOptions = new (0, $3032e23fa8f3a9e5$export$24ba9b81662d4366)({
        colorArr: colorOptionsArr,
        initialIndex: 0,
        onChange: function(rgbaObj) {
            backgroundRgba = rgbaObj;
            preview.style.backgroundColor = 'rgba(' + rgbaObj.r + ',' + rgbaObj.g + ',' + rgbaObj.b + ', ' + rgbaObj.a + ')';
        }
    });
    const previewWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: 'kl-transparent-preview',
        css: {
            boxSizing: 'border-box',
            width: '340px',
            height: '140px',
            display: 'table',
            padding: '10px',
            marginTop: '10px',
            marginLeft: '-20px',
            background: 'var(--kl-checkerboard-background)'
        }
    });
    const preview = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: 'kl-transparent-preview__canvas',
        css: {
            width: "200px",
            height: "100px",
            backgroundColor: 'rgba(' + backgroundRgba.r + ',' + backgroundRgba.g + ',' + backgroundRgba.b + ', ' + backgroundRgba.a + ')',
            marginLeft: 'auto',
            marginRight: 'auto',
            color: '#aaa',
            fontSize: '16px',
            fontWeight: 'bold',
            textAlign: 'center',
            verticalAlign: 'center',
            display: 'table',
            overflow: 'hidden'
        }
    });
    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        parent: previewWrapper,
        content: preview,
        css: {
            display: 'table-cell',
            verticalAlign: 'middle'
        }
    });
    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        parent: preview,
        css: {
            display: 'table-cell',
            verticalAlign: 'middle'
        }
    });
    function updateRatio() {
        widthInput.value = '' + Math.min(maxCanvasSize, parseInt(widthInput.value));
        heightInput.value = '' + Math.min(maxCanvasSize, parseInt(heightInput.value));
        function hcf(u, v) {
            let U = u, V = v;
            while(true){
                if (!(U %= V)) return V;
                if (!(V %= U)) return U;
            }
        }
        let w = parseInt(widthInput.value);
        let h = parseInt(heightInput.value);
        if (w < 1 || w > maxCanvasSize || h < 1 || h > maxCanvasSize) {
            if (w > maxCanvasSize) w = maxCanvasSize;
            else if (h > maxCanvasSize) h = maxCanvasSize;
            widthInput.value = '' + w;
            heightInput.value = '' + h;
        }
        //generated canvas size doesn't always match ratio. so check if a common ratio is very close
        const commonRatios = [
            [
                1,
                2
            ],
            [
                2,
                1
            ],
            [
                2,
                3
            ],
            [
                3,
                2
            ],
            [
                3,
                4
            ],
            [
                4,
                3
            ],
            [
                4,
                5
            ],
            [
                5,
                4
            ],
            [
                16,
                9
            ],
            [
                9,
                16
            ],
            [
                3,
                2
            ],
            [
                2,
                3
            ],
            [
                5,
                3
            ],
            [
                3,
                5
            ],
            [
                2,
                1
            ],
            [
                1,
                2
            ],
            [
                1.414,
                1
            ],
            [
                1,
                1.414
            ]
        ];
        const reducedArr = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).reduce(w, h);
        let closestRatio = commonRatios[0];
        let closestDistance = Math.abs(commonRatios[0][0] / commonRatios[0][1] - reducedArr[0] / reducedArr[1]);
        for(let i = 0; i < commonRatios.length; i++)if (Math.abs(commonRatios[i][0] / commonRatios[i][1] - reducedArr[0] / reducedArr[1]) < closestDistance) {
            closestRatio = commonRatios[i];
            closestDistance = Math.abs(commonRatios[i][0] / commonRatios[i][1] - reducedArr[0] / reducedArr[1]);
        }
        //display ratio
        if (closestDistance > 0 && closestDistance < 0.005) ratioWrapper.innerText = (0, $63d0b335c576c718$export$ce37e184d908d785)('new-ratio') + ': ~' + closestRatio[0] + ':' + closestRatio[1];
        else ratioWrapper.innerText = (0, $63d0b335c576c718$export$ce37e184d908d785)('new-ratio') + ': ' + reducedArr[0] + ':' + reducedArr[1];
        const realw = w;
        const T = hcf(w, h);
        w /= T;
        h /= T;
        w *= 260;
        h *= 260;
        if (w > 260) {
            h = 260 / w * h;
            w = 260;
        }
        if (h > 100) {
            w = 100 / h * w;
            h = 100;
        }
        preview.style.width = w + 'px';
        preview.style.height = h + 'px';
        previewWrapper.style.backgroundSize = Math.round(Math.max(4, 60 * (w / realw))) + 'px';
    }
    widthInput.onchange = ()=>{
        if (widthInput.value === '' || parseInt(widthInput.value) < 0) widthInput.value = '1';
        updateRatio();
    };
    widthInput.onkeyup = ()=>{
        updateRatio();
    };
    heightInput.onchange = ()=>{
        if (heightInput.value === '' || parseFloat(heightInput.value) < 0) heightInput.value = '1';
        updateRatio();
    };
    heightInput.onkeyup = ()=>{
        updateRatio();
    };
    updateRatio();
    newImDiv.append(templateWrapper);
    const secondRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        parent: newImDiv,
        css: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end'
        }
    });
    const secondRowLeft = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        parent: secondRow
    });
    secondRowLeft.append(sizeTable, ratioWrapper);
    secondRow.append(colorOptions.getElement());
    newImDiv.append(previewWrapper);
    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('new-title')}</b>`,
        div: newImDiv,
        buttons: [
            'Ok',
            'Cancel'
        ],
        callback: function(result) {
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unsetEventHandler(widthInput, 'onclick', 'onchange', 'onkeyup');
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unsetEventHandler(widthInput, 'onclick', 'onchange', 'onkeyup');
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unsetEventHandler(presetCurrentBtn, 'onclick');
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unsetEventHandler(presetFitBtn, 'onclick');
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unsetEventHandler(presetOversizeBtn, 'onclick');
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unsetEventHandler(presetSquareBtn, 'onclick');
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unsetEventHandler(presetLandscapeBtn, 'onclick');
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).unsetEventHandler(presetPortraitBtn, 'onclick');
            select.destroy();
            colorOptions.destroy();
            if (result === 'Cancel' || parseInt(widthInput.value) <= 0 || parseInt(heightInput.value) <= 0 || isNaN(parseInt(widthInput.value)) || isNaN(parseInt(heightInput.value))) {
                onCancel();
                return;
            }
            onConfirm(parseInt(widthInput.value), parseInt(heightInput.value), backgroundRgba);
        },
        clickOnEnter: 'Ok'
    });
}



var $9117841db70813fe$exports = {};
$9117841db70813fe$exports = $parcel$resolve("gNPQL");



class $da66208906376381$export$5b91f641162972fc {
    update() {
        if (this.orientation === 'left') this.icon.style.transform = this.stateIsOpen ? 'rotate(180deg)' : '';
        else this.icon.style.transform = this.stateIsOpen ? '' : 'rotate(180deg)';
    }
    // ---- interface ----
    isOpen() {
        return this.stateIsOpen;
    }
    setIsOpen(b) {
        this.stateIsOpen = b;
        this.update();
    }
    setOrientation(dirStr) {
        this.orientation = dirStr;
        this.update();
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.stateIsOpen = true;
        this.orientation = 'right';
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-toolspace-toggle',
            css: {
                width: '36px',
                height: '36px',
                background: 'rgba(100, 100, 100, 0.9)',
                color: '#fff',
                textAlign: 'center',
                lineHeight: '36px',
                cursor: 'pointer',
                userSelect: 'none',
                padding: '6px',
                boxSizing: 'border-box'
            },
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('toggle-show-tools'),
            onClick: (e)=>{
                e.preventDefault();
                this.stateIsOpen = !this.stateIsOpen;
                this.update();
                p.onChange();
            }
        });
        this.icon = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($9117841db70813fe$exports)))})`,
                width: '100%',
                height: '100%',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                userSelect: 'none'
            }
        });
        this.update();
        this.rootEl.oncontextmenu = ()=>{
            return false;
        };
    }
}














class $5b663384e3b198ee$export$5cdfb22682d2a5dd {
    getElement() {
        return this.rootEl;
    }
    getValues() {
        const c = this.colorOptions.getValue();
        if (c === null || (c === null || c === void 0 ? void 0 : c.a) === 0) return {
            fill: undefined
        };
        const color = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, c), {
            a: this.opacitySlider.getValue()
        });
        return {
            fill: {
                color: color
            }
        };
    }
    destroy() {
        this.colorOptions.destroy();
        this.opacitySlider.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        const emit = ()=>{
            p.onUpdate(this.getValues());
        };
        const colorOptionsArr = [
            null,
            p.fill ? (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.fill.color), {
                a: 1
            }) : null,
            (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.primaryColor), {
                a: 1
            }),
            (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.secondaryColor), {
                a: 1
            }),
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }
        ];
        this.colorOptions = new (0, $3032e23fa8f3a9e5$export$24ba9b81662d4366)({
            colorArr: colorOptionsArr,
            initialIndex: p.fill ? 1 : 0,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-fill'),
            onChange: (c)=>{
                this.opacitySlider.getElement().style.display = c !== null ? '' : 'none';
                emit();
            }
        });
        this.opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
            width: 150,
            height: 30,
            min: 0.01,
            max: 1,
            value: p.fill ? p.fill.color.a : 1,
            resolution: 225,
            eventResMs: 1000 / 30,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100,
            onChange: ()=>emit()
        });
        this.opacitySlider.getElement().style.display = p.fill ? '' : 'none';
        const svg = (0, $fc4403c8ee6a33dc$export$c54fe3b9ecaa84cf)({
            elementType: 'svg',
            class: 'dark-invert',
            width: '25px',
            height: '25px',
            viewBox: '0 0 30 30',
            childrenArr: [
                {
                    elementType: 'polyline',
                    points: '0,0 30,0 30,8 19,8 19,30 11,30 11,8 0,8 0,0 1,0',
                    'transform-origin': '15px 15px',
                    transform: 'scale(0.8)',
                    fill: '#000c'
                }
            ]
        });
        this.rootEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,gap-10,items-center,flexWrap,minh-30', [
            svg,
            this.colorOptions.getElement(),
            this.opacitySlider.getElement()
        ]);
    }
}






var $315a705fa3433ae6$exports = {};
$315a705fa3433ae6$exports = $parcel$resolve("9Mrdl");


var $e5df0b13d75826cd$exports = {};
$e5df0b13d75826cd$exports = $parcel$resolve("jc4S8");


var $a1cea9aca69ddd68$exports = {};
$a1cea9aca69ddd68$exports = $parcel$resolve("cgtA2");


var $041702a13c2910e6$exports = {};
$041702a13c2910e6$exports = $parcel$resolve("erfrN");


var $bc84f5ada50c06b2$exports = {};
$bc84f5ada50c06b2$exports = $parcel$resolve("kdJe6");





var $92c039c456df5a07$exports = {};
$92c039c456df5a07$exports = $parcel$resolve("ialpb");


var $5eed4fe9e62e10f4$exports = {};
$5eed4fe9e62e10f4$exports = $parcel$resolve("4YP0p");


var $a5133487986846a4$exports = {};
$a5133487986846a4$exports = $parcel$resolve("f9bZe");


var $13dfbe8d2ff438cb$exports = {};
$13dfbe8d2ff438cb$exports = $parcel$resolve("dnR06");


var $688a9de8d1071fcf$exports = {};
$688a9de8d1071fcf$exports = $parcel$resolve("lVw6N");


var $7cf6bec9e2531e1f$exports = {};
$7cf6bec9e2531e1f$exports = $parcel$resolve("a0LKB");


var $ba82ad4ee7b3ebd8$exports = {};
$ba82ad4ee7b3ebd8$exports = $parcel$resolve("eDCEO");


var $cc5f7fec6c15577d$exports = {};
$cc5f7fec6c15577d$exports = $parcel$resolve("6nihP");


var $1bcb94bbbc95f401$exports = {};
$1bcb94bbbc95f401$exports = $parcel$resolve("4rqd5");


var $6522185860067a32$exports = {};
$6522185860067a32$exports = $parcel$resolve("isxTc");


var $5028e011d7b584f5$exports = {};
$5028e011d7b584f5$exports = $parcel$resolve("9lp1S");


var $69a66a6c9d6bd8fe$exports = {};
$69a66a6c9d6bd8fe$exports = $parcel$resolve("2yKB9");


var $0d7c2eb8c0922891$exports = {};
$0d7c2eb8c0922891$exports = $parcel$resolve("jJcCY");


var $8f14af5d029252e9$exports = {};
$8f14af5d029252e9$exports = $parcel$resolve("1JYDa");


var $27cbd83f0cd9a873$exports = {};
$27cbd83f0cd9a873$exports = $parcel$resolve("kVDlu");


var $7035b0d6c3ead178$exports = {};
$7035b0d6c3ead178$exports = $parcel$resolve("caTXQ");


const $8e39776a1261b902$export$826128ff895ed268 = [
    {
        name: 'Caveat',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($92c039c456df5a07$exports)))
    },
    {
        name: 'ClimateCrisis',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($5eed4fe9e62e10f4$exports)))
    },
    {
        name: 'CorrectionBrush',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($a5133487986846a4$exports)))
    },
    {
        name: 'DancingScript',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($13dfbe8d2ff438cb$exports)))
    },
    {
        name: 'Diabolik',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($688a9de8d1071fcf$exports)))
    },
    {
        name: 'FreckleFace',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($7cf6bec9e2531e1f$exports)))
    },
    {
        name: 'Gloock',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($ba82ad4ee7b3ebd8$exports)))
    },
    {
        name: 'GochiHand',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($1bcb94bbbc95f401$exports)))
    },
    {
        name: 'Pacha',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($cc5f7fec6c15577d$exports)))
    },
    {
        name: 'PassionOne',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($6522185860067a32$exports)))
    },
    {
        name: 'PixeloidSans',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($5028e011d7b584f5$exports)))
    },
    {
        name: 'PlaypenSans',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($69a66a6c9d6bd8fe$exports)))
    },
    {
        name: 'Quicksand',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($0d7c2eb8c0922891$exports)))
    },
    {
        name: 'Silkscreen',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($8f14af5d029252e9$exports)))
    },
    {
        name: 'Tehroc',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($27cbd83f0cd9a873$exports)))
    },
    {
        name: 'YUNGA',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($7035b0d6c3ead178$exports)))
    }
];



const $0d66a3ca6c18ec8d$var$importedFonts = [
    {
        fontFamily: 'sans-serif',
        fontName: 'Sans-serif'
    },
    {
        fontFamily: 'serif',
        fontName: 'Serif'
    },
    {
        fontFamily: 'monospace',
        fontName: 'Monospace'
    },
    {
        fontFamily: 'cursive',
        fontName: 'Cursive'
    },
    {
        fontFamily: 'fantasy',
        fontName: 'Fantasy'
    },
    ...(0, $8e39776a1261b902$export$826128ff895ed268).map((item)=>{
        return {
            fontFamily: item.name,
            fontName: item.name
        };
    })
];
let $0d66a3ca6c18ec8d$var$didLoadBundledFonts = false;
async function $0d66a3ca6c18ec8d$var$loadBundledFonts() {
    if ($0d66a3ca6c18ec8d$var$didLoadBundledFonts) return;
    $0d66a3ca6c18ec8d$var$didLoadBundledFonts = true;
    const promises = (0, $8e39776a1261b902$export$826128ff895ed268).map(async (item)=>{
        const response = await fetch(item.url);
        const buffer = await response.arrayBuffer();
        const font = new FontFace(item.name, buffer);
        // await font.load();
        document.fonts.add(font);
    });
    await Promise.all(promises);
}
class $0d66a3ca6c18ec8d$export$2e7faedafda1fc85 {
    // only load fonts when interacting with the font input
    loadBundledFonts() {
        !$0d66a3ca6c18ec8d$var$didLoadBundledFonts && $0d66a3ca6c18ec8d$var$loadBundledFonts().then(()=>{
            this.onUpdate({
                font: this.fontSelect.getValue()
            });
        });
    }
    importFont() {
        const acceptedExtensions = [
            'ttf',
            'otf',
            'woff',
            'woff2',
            'eot'
        ];
        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.accept = acceptedExtensions.map((item)=>'.' + item).join(', ');
        input.focus();
        input.click();
        input.onchange = async ()=>{
            if (!input.files || input.files.length === 0) return;
            let toSelect = undefined;
            const failedToLoadFilenames = [];
            let acceptedAtLeastOne = false;
            const fontFamilies = $0d66a3ca6c18ec8d$var$importedFonts.map((i)=>i.fontFamily);
            for(let i = 0; i < input.files.length; i++){
                const file = input.files[i];
                const fontName = 'kl-' + $0d66a3ca6c18ec8d$var$importedFonts.length;
                if (fontFamilies.includes(fontName)) continue;
                if (!toSelect) {
                    toSelect = fontName;
                    this.importButton.disabled = true;
                    this.importButton.innerText = (0, $63d0b335c576c718$export$ce37e184d908d785)('loading');
                }
                const split = file.name.split('.');
                split.pop();
                $0d66a3ca6c18ec8d$var$importedFonts.push({
                    fontFamily: fontName,
                    fontName: split.join('.')
                });
                const font = new FontFace(fontName, await file.arrayBuffer());
                try {
                    await font.load();
                    document.fonts.add(font);
                    acceptedAtLeastOne = true;
                } catch (err) {
                    failedToLoadFilenames.push(file.name);
                }
            }
            if (failedToLoadFilenames.length > 0) (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
                message: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    content: [
                        (0, $63d0b335c576c718$export$ce37e184d908d785)('text-failed-import'),
                        (0, $934e5f47c3374e21$export$db3b6bfb95261072)('br'),
                        failedToLoadFilenames.join(', '),
                        (0, $934e5f47c3374e21$export$db3b6bfb95261072)('br'),
                        (0, $934e5f47c3374e21$export$db3b6bfb95261072)('br'),
                        (0, $63d0b335c576c718$export$ce37e184d908d785)('text-supported-formats'),
                        (0, $934e5f47c3374e21$export$db3b6bfb95261072)('br'),
                        acceptedExtensions.join(', ')
                    ]
                }),
                type: 'error'
            });
            if (!acceptedAtLeastOne) {
                this.importButton.disabled = false;
                this.importButton.innerText = (0, $63d0b335c576c718$export$ce37e184d908d785)('file-import');
                return;
            }
            // update font selection
            setTimeout(()=>{
                this.fontSelect.setOptionArr($0d66a3ca6c18ec8d$var$importedFonts.map((i)=>{
                    return [
                        i.fontFamily,
                        i.fontName,
                        {
                            css: {
                                fontFamily: i.fontFamily,
                                fontSize: '1.2em'
                            }
                        }
                    ];
                }));
                this.fontSelect.setValue(toSelect);
                this.onUpdate({
                    font: toSelect
                });
                this.importButton.disabled = false;
                this.importButton.innerText = (0, $63d0b335c576c718$export$ce37e184d908d785)('file-import');
            });
        };
    }
    getElement() {
        return this.rootEl;
    }
    getValues() {
        return {
            font: this.fontSelect.getValue(),
            size: +this.sizeInput.getValue(),
            letterSpacing: +this.letterSpacingInput.getValue(),
            lineHeight: +this.lineHeightInput.getValue(),
            align: this.alignRadioList.getValue(),
            isItalic: this.italicToggle.getValue(),
            isBold: this.boldToggle.getValue()
        };
    }
    destroy() {
        this.fontPointerListener.destroy();
        this.fontSelect.getElement().removeEventListener('focus', this.onFocus);
        this.fontSelect.destroy();
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.importButton);
        this.sizeInput.destroy();
        this.lineHeightInput.destroy();
        this.letterSpacingInput.destroy();
        this.alignRadioList.destroy();
        this.italicToggle.destroy();
        this.boldToggle.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.onUpdate = p.onUpdate;
        this.fontSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
            initValue: p.font,
            optionArr: $0d66a3ca6c18ec8d$var$importedFonts.map((i)=>{
                return [
                    i.fontFamily,
                    i.fontName,
                    {
                        css: {
                            fontFamily: i.fontFamily,
                            fontSize: '1.2em'
                        }
                    }
                ];
            }),
            isFocusable: true,
            css: {
                width: '180px'
            },
            onChange: (v)=>{
                this.loadBundledFonts();
                p.onUpdate({
                    font: v
                });
            },
            name: 'font'
        });
        this.onFocus = ()=>this.loadBundledFonts();
        this.fontSelect.getElement().addEventListener('focus', this.onFocus);
        this.fontPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.fontSelect.getElement(),
            onWheel: (e)=>this.fontSelect.setDeltaValue(e.deltaY)
        });
        this.importButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-import'),
            onClick: ()=>{
                this.importFont();
            }
        });
        const sizeLabel = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    tagName: 'span',
                    content: 'A',
                    css: {
                        fontSize: '0.6em'
                    }
                }),
                'A'
            ],
            css: {
                width: '25px',
                height: '25px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '1.2em',
                userSelect: 'none'
            }
        });
        this.sizeInput = new (0, $760dd90d44275661$export$f5b8910cec6cf069)({
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-size'),
            type: 'number',
            min: 0,
            max: 1000,
            init: p.size,
            onChange: (v)=>{
                p.onUpdate({
                    size: parseFloat(v)
                });
            },
            doResetIfInvalid: true,
            doScrollWithoutFocus: true,
            css: {
                width: '70px'
            },
            name: 'font-size'
        });
        var _p_lineHeight;
        this.lineHeightInput = new (0, $760dd90d44275661$export$f5b8910cec6cf069)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-line-height'),
            type: 'number',
            min: 0,
            max: 10,
            step: 0.1,
            init: (_p_lineHeight = p.lineHeight) !== null && _p_lineHeight !== void 0 ? _p_lineHeight : 1,
            onChange: (v)=>{
                p.onUpdate({
                    lineHeight: parseFloat(v)
                });
            },
            doResetIfInvalid: true,
            doScrollWithoutFocus: true,
            css: {
                width: '60px'
            },
            name: 'line-height'
        });
        var _p_letterSpacing;
        this.letterSpacingInput = new (0, $760dd90d44275661$export$f5b8910cec6cf069)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-letter-spacing'),
            type: 'number',
            min: -100,
            max: 100,
            init: (_p_letterSpacing = p.letterSpacing) !== null && _p_letterSpacing !== void 0 ? _p_letterSpacing : 0,
            onChange: (v)=>{
                p.onUpdate({
                    letterSpacing: parseFloat(v)
                });
            },
            doResetIfInvalid: true,
            doScrollWithoutFocus: true,
            css: {
                width: '60px'
            },
            name: 'letter-spacing'
        });
        this.alignRadioList = new (0, $fa6faa989b2cc6b2$export$7cc1012a658e6ad8)({
            optionArr: [
                {
                    id: 'left',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-left'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($315a705fa3433ae6$exports))),
                    darkInvert: true
                },
                {
                    id: 'center',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-center'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($e5df0b13d75826cd$exports))),
                    darkInvert: true
                },
                {
                    id: 'right',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-right'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($a1cea9aca69ddd68$exports))),
                    darkInvert: true
                }
            ],
            initId: p.align,
            onChange: (v)=>p.onUpdate({
                    align: v
                })
        });
        this.italicToggle = new (0, $a14a8e8cf8cc5885$export$b6d053cded550773)({
            image: (0, (/*@__PURE__*/$parcel$interopDefault($041702a13c2910e6$exports))),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-italic'),
            initValue: p.isItalic,
            onChange: (v)=>p.onUpdate({
                    isItalic: v
                }),
            darkInvert: true
        });
        this.boldToggle = new (0, $a14a8e8cf8cc5885$export$b6d053cded550773)({
            image: (0, (/*@__PURE__*/$parcel$interopDefault($bc84f5ada50c06b2$exports))),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-bold'),
            initValue: p.isBold,
            onChange: (v)=>p.onUpdate({
                    isBold: v
                }),
            darkInvert: true
        });
        this.rootEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,flexWrap,gap-10-15,items-center', [
            (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,gap-5,items-center', [
                sizeLabel,
                this.sizeInput.getElement()
            ]),
            (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,gap-5', [
                this.fontSelect.getElement(),
                this.importButton
            ]),
            (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,gap-7', [
                this.alignRadioList.getElement(),
                this.italicToggle.getElement(),
                this.boldToggle.getElement()
            ]),
            this.letterSpacingInput.getElement(),
            this.lineHeightInput.getElement()
        ]);
    }
}










class $c73fdb6c21e3a26a$export$42bb0e3b48d549f6 {
    getElement() {
        return this.rootEl;
    }
    getValues() {
        const c = this.colorOptions.getValue();
        if (c === null || (c === null || c === void 0 ? void 0 : c.a) === 0) return {
            stroke: undefined
        };
        const color = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, c), {
            a: this.opacitySlider.getValue()
        });
        return {
            stroke: {
                color: color,
                lineWidth: this.lineWidthSlider.getValue()
            }
        };
    }
    destroy() {
        this.colorOptions.destroy();
        this.opacitySlider.destroy();
        this.lineWidthSlider.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                boxShadow: '0 0 0 1px #aaa'
            }
        });
        const emit = ()=>{
            p.onUpdate(this.getValues());
        };
        const colorOptionsArr = [
            null,
            p.stroke ? (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.stroke.color), {
                a: 1
            }) : null,
            (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.secondaryColor), {
                a: 1
            }),
            (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.primaryColor), {
                a: 1
            }),
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            }
        ];
        this.colorOptions = new (0, $3032e23fa8f3a9e5$export$24ba9b81662d4366)({
            colorArr: colorOptionsArr,
            initialIndex: p.stroke ? 1 : 0,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-stroke'),
            onChange: (c)=>{
                this.opacitySlider.getElement().style.display = c !== null ? '' : 'none';
                this.lineWidthSlider.getElement().style.display = c !== null ? '' : 'none';
                emit();
            }
        });
        this.opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
            width: 150,
            height: 30,
            min: 0.01,
            max: 1,
            value: p.stroke ? p.stroke.color.a : 1,
            resolution: 225,
            eventResMs: 1000 / 30,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100,
            onChange: ()=>emit()
        });
        this.lineWidthSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-line-width'),
            width: 150,
            height: 30,
            min: 0.5,
            max: 100,
            value: p.stroke ? p.stroke.lineWidth : 2,
            eventResMs: 1000 / 30,
            curve: 'quadratic',
            onChange: ()=>emit()
        });
        this.opacitySlider.getElement().style.display = p.stroke ? '' : 'none';
        this.lineWidthSlider.getElement().style.display = p.stroke ? '' : 'none';
        const svg = (0, $fc4403c8ee6a33dc$export$c54fe3b9ecaa84cf)({
            elementType: 'svg',
            class: 'dark-invert',
            width: '25px',
            height: '25px',
            viewBox: '0 0 30 30',
            childrenArr: [
                {
                    elementType: 'polyline',
                    points: '0,0 30,0 30,8 19,8 19,30 11,30 11,8 0,8 0,0 1,0',
                    fill: 'none',
                    stroke: '#000c',
                    'stroke-width': '3',
                    'transform-origin': '15px 15px',
                    transform: 'scale(0.8)'
                }
            ]
        });
        this.rootEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,gap-10,items-center,flexWrap,minh-30', [
            svg,
            this.colorOptions.getElement(),
            this.opacitySlider.getElement(),
            this.lineWidthSlider.getElement()
        ]);
    }
}





class $be275a032c52a6ed$export$c6656360602b35c2 {
    emit() {
        const text = this.textInput.value;
        if (text === this.lastEmittedText) return;
        this.lastEmittedText = text;
        this.onUpdate({
            text: text
        });
    }
    getElement() {
        return this.rootEl;
    }
    getValues() {
        return {
            text: this.textInput.value
        };
    }
    focus() {
        this.textInput.focus();
    }
    destroy() {
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.textInput);
        this.textInput.removeEventListener('input', this.onInput);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.onInput = ()=>{
            this.emit();
        };
        this.lastEmittedText = p.text;
        this.onUpdate = p.onUpdate;
        this.rootEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)('');
        this.textInput = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'textarea',
            parent: this.rootEl,
            content: p.text,
            custom: {
                placeholder: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-placeholder')
            },
            css: {
                whiteSpace: 'pre',
                overflow: 'auto',
                width: '100%',
                height: '70px',
                resize: 'vertical'
            },
            onChange: ()=>{
                this.emit();
            }
        });
        this.textInput.addEventListener('input', this.onInput);
    }
}














class $4ada09c4693c46d4$export$1d311696e0fb2158 {
    canZoom(d) {
        return this.zoomFac !== Math.min(2, Math.max(-2, this.zoomFac + d));
    }
    changeZoomFac(d) {
        this.zoomFac = Math.min(2, Math.max(-2, this.zoomFac + d));
        this.render();
        this.zoomInBtn.disabled = !this.canZoom(1);
        this.zoomOutBtn.disabled = !this.canZoom(-1);
    }
    /** Move text by x y **/ move(x, y) {
        const rotated = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(x, y, -this.rotationSlider.getValue() / Math.PI * 180);
        this.text.x += rotated.x / this.scale;
        this.text.y += rotated.y / this.scale;
        this.render();
    }
    render() {
        // try to draw very much like klCanvasWorkspace
        const angleRad = this.rotationSlider.getValue();
        // --- draw text ---
        this.textCtx.clearRect(0, 0, this.textCanvas.width, this.textCanvas.height);
        const bounds = (0, $67e715fe604c9329$export$482c90f94eb9717c)(this.textCanvas, (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.text), {
            x: this.text.x,
            y: this.text.y,
            angleRad: this.rotationSlider.getValue()
        }), this.selectionPath);
        if (this.selectionPath) {
            this.textCtx.save();
            this.textCtx.setLineDash([
                4
            ]);
            this.textCtx.strokeStyle = '#000';
            this.textCtx.stroke(this.selectionPath);
            this.textCtx.lineDashOffset = 4;
            this.textCtx.strokeStyle = '#fff';
            this.textCtx.stroke(this.selectionPath);
            this.textCtx.restore();
        }
        // transform offset
        const transformedOffset = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.mul((0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(this.offset.x, this.offset.y, -angleRad / Math.PI * 180), 1 / this.scale);
        // --- determine transformation of viewport ---
        // text should always be visible
        bounds.x -= 3;
        bounds.y -= 3;
        bounds.width += 6;
        bounds.height += 6;
        const rotatedXY = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(bounds.x, bounds.y, -angleRad / Math.PI * 180);
        const rotatedWH = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotate(bounds.width, bounds.height, -angleRad / Math.PI * 180);
        const centerX = this.text.x + rotatedXY.x + rotatedWH.x / 2 + transformedOffset.x;
        const centerY = this.text.y + rotatedXY.y + rotatedWH.y / 2 + transformedOffset.y;
        const padding = 100;
        const fitBounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(bounds.width, bounds.height, this.width - padding, this.height - padding);
        this.scale = Math.min(1, fitBounds.width / bounds.width);
        this.scale = Math.min(4, this.scale * Math.pow(2, this.zoomFac));
        // --- compose text and target layer ---
        this.targetCtx.save();
        if (this.scale >= 4) this.targetCtx.imageSmoothingEnabled = false;
        else {
            this.targetCtx.imageSmoothingEnabled = true;
            this.targetCtx.imageSmoothingQuality = this.scale >= 1 ? 'low' : 'medium';
        }
        this.targetCtx.clearRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
        this.targetCtx.translate(this.width / 2, this.height / 2);
        this.targetCtx.scale(this.scale, this.scale);
        this.targetCtx.rotate(angleRad);
        this.targetCtx.drawImage(this.layerArr[this.layerIndex].canvas, -centerX, -centerY);
        this.targetCtx.drawImage(this.textCanvas, -centerX, -centerY);
        this.targetCtx.restore();
        const isDark = (0, $74a507c74cfe9692$export$5714e40777c1bcc2).isDark();
        // --- layers ---
        this.layersCtx.save();
        this.layersCtx.fillStyle = isDark ? 'rgb(33,33,33)' : 'rgb(158,158,158)';
        this.layersCtx.fillRect(0, 0, this.width, this.height);
        {
            // bg
            this.layersCtx.save();
            this.layersCtx.translate(this.width / 2, this.height / 2);
            this.layersCtx.scale(this.scale, this.scale);
            this.layersCtx.rotate(angleRad);
            this.layersCtx.imageSmoothingEnabled = false;
            //outline
            const borderSize = 1 / this.scale;
            this.layersCtx.globalAlpha = isDark ? 0.25 : 0.2;
            this.layersCtx.drawImage(isDark ? this.emptyCanvasLight : this.emptyCanvas, -centerX - borderSize, -centerY - borderSize, this.textCanvas.width + borderSize * 2, this.textCanvas.height + borderSize * 2);
            this.layersCtx.globalAlpha = 1;
            //erase
            this.layersCtx.globalCompositeOperation = 'destination-out';
            this.layersCtx.drawImage(this.emptyCanvas, -centerX, -centerY, this.textCanvas.width, this.textCanvas.height);
            this.layersCtx.restore();
        }
        // individual layers
        if (this.scale >= 4) this.layersCtx.imageSmoothingEnabled = false;
        else {
            this.layersCtx.imageSmoothingEnabled = true;
            this.layersCtx.imageSmoothingQuality = this.scale >= 1 ? 'low' : 'medium';
        }
        // layers below
        this.layersCtx.save();
        this.layersCtx.translate(this.width / 2, this.height / 2);
        this.layersCtx.scale(this.scale, this.scale);
        this.layersCtx.rotate(angleRad);
        for(let i = 0; i < this.layerIndex; i++)if (this.layerArr[i].isVisible && this.layerArr[i].opacity > 0) {
            this.layersCtx.globalAlpha = this.layerArr[i].opacity;
            this.layersCtx.globalCompositeOperation = this.layerArr[i].mixModeStr;
            this.layersCtx.drawImage(this.layerArr[i].canvas, -centerX, -centerY);
        }
        this.layersCtx.restore();
        // target layer
        this.layersCtx.globalAlpha = this.layerArr[this.layerIndex].opacity * (this.layerArr[this.layerIndex].isVisible ? 1 : 0);
        this.layersCtx.globalCompositeOperation = this.layerArr[this.layerIndex].mixModeStr;
        this.layersCtx.drawImage(this.targetCanvas, 0, 0);
        // layers above
        this.layersCtx.save();
        this.layersCtx.translate(this.width / 2, this.height / 2);
        this.layersCtx.scale(this.scale, this.scale);
        this.layersCtx.rotate(angleRad);
        for(let i = this.layerIndex + 1; i < this.layerArr.length; i++)if (this.layerArr[i].isVisible && this.layerArr[i].opacity > 0) {
            this.layersCtx.globalAlpha = this.layerArr[i].opacity;
            this.layersCtx.globalCompositeOperation = this.layerArr[i].mixModeStr;
            this.layersCtx.drawImage(this.layerArr[i].canvas, -centerX, -centerY);
        }
        this.layersCtx.restore();
        this.layersCtx.restore();
        // --- final composite ---
        this.previewCtx.save();
        this.previewCtx.fillStyle = this.checkerPattern;
        this.previewCtx.fillRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
        this.previewCtx.drawImage(this.layersCanvas, 0, 0);
        this.previewCtx.restore();
        // bounds
        this.previewCtx.save();
        this.previewCtx.globalCompositeOperation = 'difference';
        this.previewCtx.strokeStyle = '#fff';
        this.previewCtx.lineWidth = 0.5;
        this.previewCtx.translate(-this.offset.x, -this.offset.y);
        this.previewCtx.strokeRect(Math.round(this.width / 2 - bounds.width / 2 * this.scale) + 0.5, Math.round(this.height / 2 - bounds.height / 2 * this.scale) + 0.5, Math.round(bounds.width * this.scale), Math.round(bounds.height * this.scale));
        this.previewCtx.restore();
    }
    getElement() {
        return this.rootEl;
    }
    getInputsElement() {
        return this.inputsRootEl;
    }
    getValues() {
        return {
            x: this.text.x,
            y: this.text.y,
            angleRad: this.rotationSlider.getValue()
        };
    }
    setText(text) {
        const x = this.text.x;
        const y = this.text.y;
        const angleRad = this.text.angleRad;
        this.text = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, text), {
            x: x,
            y: y,
            angleRad: angleRad
        });
        this.render();
    }
    setSize(width, height) {
        // prevents: Failed to execute 'drawImage' on 'CanvasRenderingContext2D':
        // The image argument is a canvas element with a width or height of 0.
        width = Math.max(1, width);
        height = Math.max(1, height);
        if (width === this.width && height === this.height) return;
        this.width = width;
        this.height = height;
        this.targetCanvas.width = this.width;
        this.targetCanvas.height = this.height;
        this.layersCanvas.width = this.width;
        this.layersCanvas.height = this.height;
        this.previewCanvas.width = this.width;
        this.previewCanvas.height = this.height;
        this.previewWrapper.style.width = this.width + 'px';
        this.render();
    }
    destroy() {
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.rootEl);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.inputsRootEl);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.previewWrapper);
        clearInterval(this.interval);
        this.rotationSlider.destroy();
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.zoomInBtn);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.zoomOutBtn);
        this.eventCapture.remove();
        this.previewPointerListener.destroy();
        this.keyListener.destroy();
        (0, $74a507c74cfe9692$export$5714e40777c1bcc2).removeIsDarkListener(this.onDarkChange);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.offset = {
            x: 0,
            y: 0
        };
        this.zoomFac = 0;
        this.scale = 1;
        this.layerArr = [];
        this.onDarkChange = ()=>{
            this.checkerPattern = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.previewCtx.createPattern((0, $d9f9f4926aa80a1c$export$921068d8846a1559).createCheckerCanvas(8, (0, $74a507c74cfe9692$export$5714e40777c1bcc2).isDark()), 'repeat'));
            this.render();
        };
        this.rootEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)();
        this.text = p.text;
        this.layerIndex = p.layerIndex;
        const selection = p.klCanvas.getSelection();
        this.selectionPath = selection ? new Path2D((0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(selection)) : undefined;
        const isSmallWidth = window.innerWidth < 550;
        const isSmallHeight = window.innerHeight < 630;
        // --- preview ---
        // Text drawn on klCanvas-sized canvas: textCanvas
        // LayerArr[target].canvas & textCanvas then drawn on targetCanvas
        //      they are transformed. canvas size of final preview
        // All layers and targetCanvas drawn on layersCanvas. transformed and size of final preview
        // Checkerboard, layersCanvas, and outline then drawn on previewCanvas
        this.width = isSmallWidth ? 340 : 540;
        this.height = isSmallWidth ? isSmallHeight ? 210 : 260 : isSmallHeight ? 230 : 350;
        this.layerArr = p.klCanvas.getLayersFast();
        this.textCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(p.klCanvas.getWidth(), p.klCanvas.getHeight());
        this.textCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.textCanvas);
        this.targetCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.width, this.height);
        this.targetCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.targetCanvas);
        this.layersCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.width, this.height);
        this.layersCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.layersCanvas);
        this.previewCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.width, this.height); // the one that is visible
        this.previewCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.previewCanvas);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.previewCanvas, {
            display: 'block'
        });
        this.previewWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                position: 'relative',
                width: this.width + 'px',
                cursor: 'move',
                touchAction: 'none'
            }
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            // inset shadow on preview
            parent: this.previewWrapper,
            className: 'kl-text-preview-wrapper'
        });
        this.previewWrapper.append(this.previewCanvas);
        this.checkerPattern = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.previewCtx.createPattern((0, $d9f9f4926aa80a1c$export$921068d8846a1559).createCheckerCanvas(8, (0, $74a507c74cfe9692$export$5714e40777c1bcc2).isDark()), 'repeat'));
        this.emptyCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(1, 1);
        this.emptyCanvasLight = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(1, 1);
        {
            let ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.emptyCanvas);
            ctx.fillRect(0, 0, 1, 1);
            ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.emptyCanvasLight);
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, 1, 1);
        }
        (0, $74a507c74cfe9692$export$5714e40777c1bcc2).addIsDarkListener(this.onDarkChange);
        this.previewCanvas.oncontextmenu = (e)=>e.preventDefault();
        let dragged = false;
        let isDown = false;
        let offsetDragged = false;
        this.previewPointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.previewCanvas,
            onPointer: (e)=>{
                // drag detect
                if (e.type === 'pointerdown') {
                    dragged = false;
                    isDown = true;
                }
                if (e.type === 'pointermove' && isDown) dragged = true;
                if (e.type === 'pointerup') {
                    if (isDown && dragged && e.pointerType === 'mouse') // With touch/pen it would be annoying to focus again,
                    // because it probably pops out the keyboard.
                    p.onDragEnd();
                    dragged = false;
                    isDown = false;
                }
                if (e.type === 'pointermove' && e.button === 'left') {
                    e.eventPreventDefault();
                    this.offset = {
                        x: 0,
                        y: 0
                    };
                    this.move(-e.dX, -e.dY);
                }
                if (e.type === 'pointerdown' && e.button === 'right') document.body.append(this.eventCapture);
                if (e.type === 'pointerup') setTimeout(()=>this.eventCapture.remove(), 20);
                if (e.type === 'pointermove' && e.button === 'right') {
                    offsetDragged = true;
                    e.eventPreventDefault();
                    this.offset.x -= e.dX;
                    this.offset.y -= e.dY;
                    this.render();
                }
                if (e.type === 'pointerup' && offsetDragged) {
                    let count = 0;
                    this.interval = setInterval(()=>{
                        if (count > 8) {
                            clearInterval(this.interval);
                            this.offset = {
                                x: 0,
                                y: 0
                            };
                            this.render();
                        }
                        this.offset = {
                            x: this.offset.x * 0.6,
                            y: this.offset.y * 0.6
                        };
                        this.render();
                        count++;
                    }, 10);
                    this.offset = {
                        x: this.offset.x * 0.6,
                        y: this.offset.y * 0.6
                    };
                    this.render();
                }
            },
            onWheel: (e)=>{
                this.changeZoomFac(-e.deltaY);
            }
        });
        const wheelPrevent = (event)=>event.preventDefault();
        this.previewCanvas.addEventListener('wheel', wheelPrevent, {
            passive: false
        });
        this.rotationSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-rotation'),
            width: 150,
            height: 30,
            min: -Math.PI,
            max: Math.PI,
            value: p.text.angleRad,
            resolution: 225,
            // eventResMs: 1000 / 30,
            toValue: (deg)=>deg * Math.PI / 180,
            toDisplayValue: (rad)=>rad / Math.PI * 180,
            onChange: ()=>{
                this.offset = {
                    x: 0,
                    y: 0
                };
                this.render();
            },
            unit: "\xb0"
        });
        this.zoomInBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: `<img height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($4ae8ffb159df37c1$exports)))}">`,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('zoom-in'),
            onClick: ()=>this.changeZoomFac(1),
            css: {
                fontWeight: 'bold'
            }
        });
        this.zoomOutBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: `<img height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($c1f95fb9358806e5$exports)))}">`,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('zoom-out'),
            onClick: ()=>this.changeZoomFac(-1),
            css: {
                fontWeight: 'bold'
            }
        });
        this.eventCapture = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                right: '0',
                bottom: '0',
                zIndex: '999',
                cursor: 'move'
            }
        });
        this.eventCapture.oncontextmenu = (e)=>e.preventDefault();
        this.keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
            onDown: (keyStr)=>{
                if ((0, $d9f9f4926aa80a1c$export$921068d8846a1559).isInputFocused(true)) return;
                const factor = this.keyListener.isPressed('shift') ? 4 : 1;
                if (keyStr === 'left') this.move(-factor, 0);
                if (keyStr === 'right') this.move(factor, 0);
                if (keyStr === 'up') this.move(0, -factor);
                if (keyStr === 'down') this.move(0, factor);
            }
        });
        this.inputsRootEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,gap-5', [
            this.rotationSlider.getElement(),
            (0, $934e5f47c3374e21$export$db3b6bfb95261072)(),
            this.zoomInBtn,
            this.zoomOutBtn
        ]);
    }
}


var $d9aa3b7905088459$export$7b388ca536128c6d;
var $d9aa3b7905088459$export$62d58b1c91e8e902;
var $d9aa3b7905088459$export$84aa927130f1a919;
var $d9aa3b7905088459$export$ee483a02838ec162;
var $d9aa3b7905088459$export$e114d13b1a258938;
$d9aa3b7905088459$export$7b388ca536128c6d = `_5vlQAW_inputs`;
$d9aa3b7905088459$export$62d58b1c91e8e902 = `_5vlQAW_tab`;
$d9aa3b7905088459$export$84aa927130f1a919 = `_5vlQAW_tabWrapper`;
$d9aa3b7905088459$export$ee483a02838ec162 = `_5vlQAW_viewportInputs`;
$d9aa3b7905088459$export$e114d13b1a258938 = `_5vlQAW_viewportWrapper`;




function $3217004ef102ca9c$export$e263e067d6140649(p) {
    const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({});
    let text = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(p.text);
    const viewportWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: $d9aa3b7905088459$export$e114d13b1a258938
    });
    const viewportUI = new (0, $4ada09c4693c46d4$export$1d311696e0fb2158)({
        text: text,
        klCanvas: p.klCanvas,
        layerIndex: p.layerIndex,
        onDragEnd: ()=>tabs.getOpenedTabId() === 'text' ? textUI.focus() : 0
    });
    viewportUI.render();
    function onUpdate(p) {
        text = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, text, p);
        viewportUI.setText(text);
    }
    const fontUI = new (0, $0d66a3ca6c18ec8d$export$2e7faedafda1fc85)((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, text), {
        onUpdate: (p)=>{
            onUpdate(p);
        }
    }));
    const colorWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            display: 'flex',
            gap: '10px',
            flexDirection: 'column'
        }
    });
    const fillUI = new (0, $5b663384e3b198ee$export$5cdfb22682d2a5dd)({
        fill: text.fill,
        primaryColor: p.primaryColor,
        secondaryColor: p.secondaryColor,
        onUpdate: (p)=>{
            onUpdate(p);
        }
    });
    const strokeUI = new (0, $c73fdb6c21e3a26a$export$42bb0e3b48d549f6)({
        stroke: text.stroke,
        primaryColor: p.primaryColor,
        secondaryColor: p.secondaryColor,
        onUpdate: (p)=>{
            onUpdate(p);
        }
    });
    const textUI = new (0, $be275a032c52a6ed$export$c6656360602b35c2)({
        text: text.text,
        onUpdate: (p)=>{
            p.text !== undefined && modal.setIgnoreBackground(p.text.length > 0);
            onUpdate(p);
        }
    });
    const tabs = new (0, $ae064bc6cfaee2ee$export$3c6d17ed0106bfb9)({
        initialId: 'text',
        height: 40,
        tabArr: [
            {
                id: 'text',
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-text'),
                onOpen: ()=>{
                    textUI.getElement().style.display = '';
                    textUI.focus();
                },
                onClose: ()=>{
                    textUI.getElement().style.display = 'none';
                }
            },
            {
                id: 'font',
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-font'),
                onOpen: ()=>{
                    fontUI.getElement().style.display = 'flex';
                },
                onClose: ()=>{
                    fontUI.getElement().style.display = 'none';
                }
            },
            {
                id: 'color',
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('text-color'),
                onOpen: ()=>{
                    colorWrapper.style.display = 'flex';
                },
                onClose: ()=>{
                    colorWrapper.style.display = 'none';
                }
            }
        ]
    });
    tabs.getElement().classList.add($d9aa3b7905088459$export$62d58b1c91e8e902);
    rootEl.append((0, $934e5f47c3374e21$export$db3b6bfb95261072)('', [
        (0, $934e5f47c3374e21$export$db3b6bfb95261072)(viewportWrapper, [
            viewportUI.getElement()
        ]),
        (0, $934e5f47c3374e21$export$db3b6bfb95261072)('.' + $d9aa3b7905088459$export$ee483a02838ec162, [
            viewportUI.getInputsElement()
        ]),
        (0, $934e5f47c3374e21$export$db3b6bfb95261072)('.tabrow.' + $d9aa3b7905088459$export$84aa927130f1a919, [
            (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',w-240,h-40'),
            tabs.getElement()
        ]),
        (0, $934e5f47c3374e21$export$db3b6bfb95261072)('.' + $d9aa3b7905088459$export$7b388ca536128c6d, [
            (0, $934e5f47c3374e21$export$db3b6bfb95261072)(colorWrapper, [
                fillUI.getElement(),
                strokeUI.getElement()
            ]),
            fontUI.getElement(),
            textUI.getElement()
        ])
    ]));
    const onResize = ()=>{
        const b = viewportWrapper.getBoundingClientRect();
        const w = Math.ceil(b.width);
        const h = Math.ceil(b.height);
        viewportUI.setSize(w, h);
    };
    window.addEventListener('resize', onResize);
    setTimeout(()=>{
        onResize();
    });
    setTimeout(()=>{
        textUI.focus();
    }, 100);
    // prevent mobile keyboards scrolling page
    function onScroll() {
        window.scrollTo(0, 0);
    }
    window.addEventListener('scroll', onScroll, {
        passive: false
    });
    const onModalExit = (val)=>{
        window.removeEventListener('resize', onResize);
        window.removeEventListener('scroll', onScroll);
        viewportUI.destroy();
        fontUI.destroy();
        fillUI.destroy();
        strokeUI.destroy();
        textUI.destroy();
        tabs.destroy();
        if (val === 'Ok') p.onConfirm((0, $0616f0a0655c1023$export$71511d61b312f219)({}, viewportUI.getValues(), fontUI.getValues(), fillUI.getValues(), strokeUI.getValues(), textUI.getValues()));
    };
    const modal = (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('text-title')}</b>`,
        div: rootEl,
        buttons: [
            'Ok',
            'Cancel'
        ],
        ignoreBackground: p.text.text.length > 0,
        callback: onModalExit,
        style: {
            width: 'calc(100% - 50px)',
            maxWidth: '1000px',
            minWidth: '300px',
            boxSizing: 'border-box'
        },
        clickOnEnter: 'Ok'
    });
}








function $aa951ef8a5f9de6d$export$1bf16d9bd59fd8f9(p) {
    const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
    const isSmall = window.innerWidth < 550 || window.innerHeight < 550;
    const style = isSmall ? {} : {
        width: '540px'
    };
    const resolutionEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        css: {
            marginTop: '10px',
            textAlign: 'center',
            color: '#888',
            lineHeight: '20px'
        }
    });
    const cropCopy = new (0, $c5a9090dbc3ef918$export$40175a5948a88a57)({
        width: isSmall ? 340 : 540,
        height: isSmall ? 300 : 400,
        canvas: p.image.canvas,
        enableRightClickCopy: false,
        onChange: (width, height)=>{
            if (!resolutionEl) return;
            updateResolution(width, height);
        }
    });
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(cropCopy.getElement(), {
        marginLeft: '-20px'
    });
    cropCopy.getElement().title = (0, $63d0b335c576c718$export$ce37e184d908d785)('crop-drag-to-crop');
    rootEl.append(cropCopy.getElement(), resolutionEl);
    function updateResolution(w, h) {
        const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(w, h, p.maxSize, p.maxSize);
        if (fit.width < w) {
            resolutionEl.innerHTML = `<span class="kl-text-error">${w} X ${h}</span> \u{27F6} ${Math.round(fit.width)} X ${Math.round(fit.height)}`;
            resolutionEl.title = (0, $63d0b335c576c718$export$ce37e184d908d785)('import-too-large');
        } else {
            resolutionEl.innerHTML = `${w} X ${h}`;
            resolutionEl.title = '';
        }
    }
    updateResolution(p.image.width, p.image.height);
    let doFlatten = false;
    function showWarnings(psdWarningArr) {
        const contentArr = [];
        const warningMap = {
            mask: 'Masks not supported. Mask was applied.',
            clipping: 'Clipping not supported. Clipping layers were merged.',
            group: 'Groups not supported. Layers were ungrouped.',
            adjustment: 'Adjustment layers not supported.',
            'layer-effect': 'Layer effects not supported.',
            'smart-object': 'Smart objects not supported.',
            'blend-mode': 'Unsupported layer blend mode.',
            'bits-per-channel': 'Unsupported color depth. Only 8bit per channel supported.'
        };
        for(let i = 0; i < psdWarningArr.length; i++)contentArr.push('- ' + warningMap[psdWarningArr[i]]);
        alert(contentArr.join('\n'));
    }
    let flattenCheckbox;
    let warningsEl;
    if (p.image.type === 'psd') {
        if (p.image.layers) {
            flattenCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
                init: doFlatten,
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-flatten'),
                callback: (b)=>{
                    doFlatten = b;
                },
                name: 'flatten-image'
            });
            rootEl.append(flattenCheckbox.getElement());
            if (p.image.warningArr) {
                const noteEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    className: 'kl-import-note',
                    content: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-psd-limited-support')
                });
                const warnings = p.image.warningArr;
                warningsEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    parent: noteEl,
                    tagName: 'a',
                    content: 'Details',
                    css: {
                        marginLeft: '5px'
                    },
                    onClick: ()=>showWarnings(warnings)
                });
                rootEl.append(noteEl);
            }
        } else {
            const noteEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'kl-import-note',
                content: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-psd-unsupported')
            });
            rootEl.append(noteEl);
        }
    }
    function callback(result) {
        const croppedCanvas = cropCopy.getCroppedCanvas();
        const cropRect = cropCopy.getCropRect();
        const isCropped = p.image.width !== cropRect.width || p.image.height !== cropRect.height;
        cropCopy.destroy();
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(warningsEl);
        if (flattenCheckbox) flattenCheckbox.destroy();
        if (result === (0, $63d0b335c576c718$export$ce37e184d908d785)('import-btn-as-layer')) {
            p.callback({
                type: 'as-layer',
                image: isCropped ? croppedCanvas : p.image.canvas
            });
            if (!isCropped) (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(croppedCanvas);
        } else if (result === (0, $63d0b335c576c718$export$ce37e184d908d785)('import-btn-as-image')) {
            if (p.image.type === 'psd') {
                if (doFlatten) delete p.image.layers;
                p.callback({
                    type: 'as-image-psd',
                    image: p.image,
                    cropObj: cropRect
                });
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(croppedCanvas);
            } else if (p.image.type === 'image') p.callback({
                type: 'as-image',
                image: croppedCanvas
            });
        } else {
            p.callback({
                type: 'cancel'
            });
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(croppedCanvas);
        }
    }
    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('import-title')}</b>`,
        div: rootEl,
        style: style,
        buttons: [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('import-btn-as-layer'),
            (0, $63d0b335c576c718$export$ce37e184d908d785)('import-btn-as-image'),
            'Cancel'
        ],
        primaries: [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('import-btn-as-layer'),
            (0, $63d0b335c576c718$export$ce37e184d908d785)('import-btn-as-image')
        ],
        callback: callback,
        autoFocus: 'As Image'
    });
}


var $e9d04a247aa46c18$exports = {};

$parcel$export($e9d04a247aa46c18$exports, "blendPsdToKl", function () { return $e9d04a247aa46c18$export$6df36f0c42d2440f; });
$parcel$export($e9d04a247aa46c18$exports, "blendKlToPsd", function () { return $e9d04a247aa46c18$export$4e3b1f7d3ad623b4; });
$parcel$export($e9d04a247aa46c18$exports, "readPsd", function () { return $e9d04a247aa46c18$export$3d649861c4b13fa2; });
$parcel$export($e9d04a247aa46c18$exports, "klPsdToKlProject", function () { return $e9d04a247aa46c18$export$56493bf279c387b3; });





let $e9d04a247aa46c18$var$kl2PsdMap;
let $e9d04a247aa46c18$var$psd2KlMap;
function $e9d04a247aa46c18$var$init() {
    if ($e9d04a247aa46c18$var$kl2PsdMap) return;
    $e9d04a247aa46c18$var$kl2PsdMap = {
        'source-over': 'normal',
        darken: 'darken',
        multiply: 'multiply',
        'color-burn': 'color burn',
        lighten: 'lighten',
        screen: 'screen',
        'color-dodge': 'color dodge',
        overlay: 'overlay',
        'soft-light': 'soft light',
        'hard-light': 'hard light',
        difference: 'difference',
        exclusion: 'exclusion',
        hue: 'hue',
        saturation: 'saturation',
        color: 'color',
        luminosity: 'luminosity'
    };
    $e9d04a247aa46c18$var$psd2KlMap = Object.fromEntries(Object.entries($e9d04a247aa46c18$var$kl2PsdMap).map((a)=>a.reverse()));
}
function $e9d04a247aa46c18$export$6df36f0c42d2440f(str) {
    $e9d04a247aa46c18$var$init();
    return $e9d04a247aa46c18$var$psd2KlMap[str];
}
function $e9d04a247aa46c18$export$4e3b1f7d3ad623b4(str) {
    $e9d04a247aa46c18$var$init();
    return $e9d04a247aa46c18$var$kl2PsdMap[str];
}
function $e9d04a247aa46c18$export$3d649861c4b13fa2(psdObj) {
    if (!psdObj.canvas) throw new Error('psdObj.canvas undefined');
    const result = {
        type: 'psd',
        canvas: psdObj.canvas,
        width: psdObj.width,
        height: psdObj.height
    };
    function addWarning(warningStr) {
        if (!result.warningArr) result.warningArr = [];
        if (result.warningArr.includes(warningStr)) return;
        result.warningArr.push(warningStr);
    }
    function getMixModeStr(blendMode) {
        let mixModeStr = $e9d04a247aa46c18$export$6df36f0c42d2440f(blendMode);
        if (!mixModeStr) {
            addWarning('blend-mode');
            mixModeStr = 'source-over';
        }
        return mixModeStr;
    }
    if (psdObj.bitsPerChannel !== 8) addWarning('bits-per-channel');
    if (!psdObj.children) {
        result.error = true;
        return result;
    }
    // count resulting layers
    const maxLayers = (0, $d26b85e649dca02a$export$9f4f73b1bd7c2f26);
    let layerCount = 0;
    function countWithinGroup(groupObj) {
        let result = 0;
        if (groupObj.blendMode) {
            const mixModeStr = $e9d04a247aa46c18$export$6df36f0c42d2440f(groupObj.blendMode);
            if (mixModeStr && mixModeStr !== 'source-over') return 1;
        }
        if (groupObj.children) for(let i = 0; i < groupObj.children.length; i++){
            const item = groupObj.children[i];
            if (item.adjustment) continue;
            if (item.clipping) {
                // simple clipping layers are now imported as separate clipped layers
                if (!item.children) result++;
                continue;
            }
            if (item.children) {
                addWarning('group');
                result += countWithinGroup(item);
            } else result++;
        }
        return result;
    }
    layerCount += countWithinGroup(psdObj);
    if (layerCount > maxLayers) {
        result.error = true;
        return result;
    }
    result.layers = [];
    function prepareMask(maskCanvas, defaultColor) {
        const groupMaskCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(maskCanvas);
        const imData = groupMaskCtx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
        if (defaultColor === 0) for(let i = 0; i < imData.data.length; i += 4)imData.data[i + 3] = imData.data[i];
        else for(let i = 0; i < imData.data.length; i += 4)imData.data[i + 3] = 255 - imData.data[i];
        groupMaskCtx.putImageData(imData, 0, 0);
    }
    function convertGroup(psdGroupObj) {
        let resultArr = [];
        const groupIsVisible = !psdGroupObj.hidden;
        const groupOpacity = (0, $fc4403c8ee6a33dc$export$5c097f720de072a2)(psdGroupObj.opacity, 'groupOpacity is undefined');
        const groupMixModeStr = getMixModeStr(psdGroupObj.blendMode);
        let groupCanvas;
        let groupCtx;
        if (groupMixModeStr !== 'source-over') {
            groupCanvas = (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)(result.width, result.height);
            groupCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(groupCanvas);
        }
        // prepare group mask
        if (psdGroupObj.mask) {
            addWarning('mask');
            prepareMask(psdGroupObj.mask.canvas, psdGroupObj.mask.defaultColor);
        }
        if (psdGroupObj.children) for(let i = 0; i < psdGroupObj.children.length; i++){
            const item = psdGroupObj.children[i];
            if (item.clipping) continue;
            if (item.adjustment) {
                addWarning('adjustment');
                continue;
            }
            const hasClipping = (item.children || item.canvas) && psdGroupObj.children[i + 1] && psdGroupObj.children[i + 1].clipping;
            if (hasClipping && item.children) addWarning('clipping');
            if (item.children) {
                const convertedChildGroupItems = convertGroup(item);
                for(let e = 0; e < convertedChildGroupItems.length; e++){
                    const innerItem = convertedChildGroupItems[e];
                    const innerCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(innerItem.image);
                    // clipping
                    if (hasClipping) {
                        const clippingCanvas = (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)(result.width, result.height);
                        const clippingCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(clippingCanvas);
                        clippingCtx.drawImage(innerItem.image, 0, 0);
                        for(let f = i + 1; f < psdGroupObj.children.length && psdGroupObj.children[f].clipping; f++){
                            const clippingItem = psdGroupObj.children[f];
                            if (clippingItem.opacity === 0 || clippingItem.hidden) continue;
                            if (clippingItem.blendMode === undefined) throw new Error('clippingItem.blendMode undefined');
                            if (clippingItem.opacity === undefined) throw new Error('clippingItem.opacity undefined');
                            if (clippingItem.canvas === undefined) throw new Error('clippingItem.canvas undefined');
                            if (clippingItem.left === undefined) throw new Error('clippingItem.left undefined');
                            if (clippingItem.top === undefined) throw new Error('clippingItem.top undefined');
                            clippingCtx.globalCompositeOperation = getMixModeStr(clippingItem.blendMode);
                            clippingCtx.globalAlpha = clippingItem.opacity;
                            clippingCtx.drawImage(clippingItem.canvas, clippingItem.left, clippingItem.top);
                        }
                        innerCtx.globalCompositeOperation = 'source-atop';
                        innerCtx.drawImage(clippingCanvas, 0, 0);
                    }
                    // group mask
                    if (psdGroupObj.mask) {
                        innerCtx.globalCompositeOperation = psdGroupObj.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                        if (psdGroupObj.mask.canvas === undefined) throw new Error('psdGroupObj.mask.canvas undefined');
                        if (psdGroupObj.mask.left === undefined) throw new Error('psdGroupObj.mask.left undefined');
                        if (psdGroupObj.mask.top === undefined) throw new Error('psdGroupObj.mask.top undefined');
                        innerCtx.drawImage(psdGroupObj.mask.canvas, psdGroupObj.mask.left, psdGroupObj.mask.top);
                    }
                    if (groupCanvas) {
                        if (groupCtx === undefined) throw new Error('groupCtx undefined');
                        groupCtx.globalCompositeOperation = innerItem.mixModeStr;
                        groupCtx.globalAlpha = innerItem.opacity;
                        groupCtx.drawImage(innerItem.image, 0, 0);
                    } else {
                        innerItem.opacity = innerItem.opacity * groupOpacity;
                        resultArr.push(innerItem);
                    }
                }
                continue;
            }
            const canvas = (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)(result.width, result.height);
            const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
            if (item.canvas) {
                // if a layer is empty it has no canvas
                if (item.top === undefined) throw new Error('item.top undefined');
                if (item.left === undefined) throw new Error('item.left undefined');
                ctx.drawImage(item.canvas, item.left, item.top);
            }
            // effects
            if (item.effects) addWarning('layer-effect');
            // mask
            if (item.mask) {
                addWarning('mask');
                if (item.mask.canvas === undefined) throw new Error('item.mask.canvas undefined');
                if (item.mask.defaultColor === undefined) throw new Error('item.mask.defaultColor undefined');
                if (item.mask.left === undefined) throw new Error('item.mask.left undefined');
                if (item.mask.top === undefined) throw new Error('item.mask.top undefined');
                prepareMask(item.mask.canvas, item.mask.defaultColor);
                ctx.globalCompositeOperation = item.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                ctx.drawImage(item.mask.canvas, item.mask.left, item.mask.top);
            }
            // group mask
            if (psdGroupObj.mask) {
                ctx.globalCompositeOperation = psdGroupObj.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                if (psdGroupObj.mask.canvas === undefined) throw new Error('psdGroupObj.mask.canvas undefined');
                if (psdGroupObj.mask.left === undefined) throw new Error('psdGroupObj.mask.left undefined');
                if (psdGroupObj.mask.top === undefined) throw new Error('psdGroupObj.mask.top undefined');
                ctx.drawImage(psdGroupObj.mask.canvas, psdGroupObj.mask.left, psdGroupObj.mask.top);
            }
            if (item.blendMode === undefined) throw new Error('item.blendMode undefined');
            if (item.hidden === undefined) throw new Error('item.hidden  undefined');
            if (item.opacity === undefined) throw new Error('item.opacity undefined');
            if (groupCanvas && groupCtx) {
                if (groupOpacity > 0) {
                    groupCtx.globalCompositeOperation = getMixModeStr(item.blendMode);
                    groupCtx.globalAlpha = item.hidden ? 0 : item.opacity;
                    groupCtx.drawImage(canvas, 0, 0);
                }
            } else {
                if (item.name === undefined) throw new Error('item.name undefined');
                resultArr.push({
                    name: item.name,
                    isVisible: !item.hidden && groupIsVisible,
                    opacity: item.opacity * groupOpacity,
                    mixModeStr: getMixModeStr(item.blendMode),
                    image: canvas
                });
                // Push simple clipping layers as separate isClipped layers
                if (hasClipping && !item.children) for(let e = i + 1; e < psdGroupObj.children.length && psdGroupObj.children[e].clipping; e++){
                    const clippingItem = psdGroupObj.children[e];
                    if (clippingItem.adjustment) {
                        addWarning('adjustment');
                        continue;
                    }
                    if (clippingItem.children) {
                        // clipping group on a simple base — bake warning, skip
                        addWarning('clipping');
                        continue;
                    }
                    if (clippingItem.blendMode === undefined) throw new Error('clippingItem.blendMode undefined');
                    if (clippingItem.opacity === undefined) throw new Error('clippingItem.opacity undefined');
                    if (clippingItem.name === undefined) throw new Error('clippingItem.name undefined');
                    const clCanvas = (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)(result.width, result.height);
                    const clCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(clCanvas);
                    if (clippingItem.canvas) {
                        if (clippingItem.left === undefined) throw new Error('clippingItem.left undefined');
                        if (clippingItem.top === undefined) throw new Error('clippingItem.top undefined');
                        clCtx.drawImage(clippingItem.canvas, clippingItem.left, clippingItem.top);
                    }
                    // mask on the clipping layer
                    if (clippingItem.mask) {
                        addWarning('mask');
                        if (clippingItem.mask.canvas === undefined) throw new Error('clippingItem.mask.canvas undefined');
                        if (clippingItem.mask.defaultColor === undefined) throw new Error('clippingItem.mask.defaultColor undefined');
                        if (clippingItem.mask.left === undefined) throw new Error('clippingItem.mask.left undefined');
                        if (clippingItem.mask.top === undefined) throw new Error('clippingItem.mask.top undefined');
                        prepareMask(clippingItem.mask.canvas, clippingItem.mask.defaultColor);
                        clCtx.globalCompositeOperation = clippingItem.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                        clCtx.drawImage(clippingItem.mask.canvas, clippingItem.mask.left, clippingItem.mask.top);
                    }
                    resultArr.push({
                        name: clippingItem.name,
                        isVisible: !clippingItem.hidden && groupIsVisible,
                        opacity: clippingItem.opacity * groupOpacity,
                        mixModeStr: getMixModeStr(clippingItem.blendMode),
                        image: clCanvas,
                        isClipped: true
                    });
                }
            }
        }
        if (groupCanvas) {
            if (psdGroupObj.name === undefined) throw new Error('psdGroupObj.name undefined');
            resultArr = [
                {
                    name: psdGroupObj.name,
                    isVisible: groupIsVisible,
                    opacity: groupOpacity,
                    mixModeStr: groupMixModeStr,
                    image: groupCanvas
                }
            ];
        }
        return resultArr;
    }
    result.layers = convertGroup({
        name: 'root',
        opacity: 1,
        blendMode: 'normal',
        children: psdObj.children
    });
    return result;
}
function $e9d04a247aa46c18$export$56493bf279c387b3(klPsd) {
    // only share references to Canvas elements
    const result = {
        projectId: (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)(),
        width: klPsd.width,
        height: klPsd.height,
        layers: []
    };
    if (klPsd.layers) result.layers = klPsd.layers.map((item)=>{
        return {
            name: item.name,
            isVisible: item.isVisible,
            opacity: item.opacity,
            mixModeStr: item.mixModeStr,
            image: item.image,
            isClipped: item.isClipped
        };
    });
    else // flattened
    result.layers = [
        {
            name: (0, $63d0b335c576c718$export$ce37e184d908d785)('background'),
            isVisible: true,
            opacity: 1,
            mixModeStr: 'source-over',
            image: klPsd.canvas
        }
    ];
    return result;
}




var $c19704f4e70546aa$exports = {};
$c19704f4e70546aa$exports = $parcel$resolve("gJYYq");



var $971718e1b87cb4cf$exports = {};
$971718e1b87cb4cf$exports = $parcel$resolve("fDGND");


var $225f2fa0a90eb49a$exports = {};
$225f2fa0a90eb49a$exports = $parcel$resolve("8f0bW");


var $a8802b2c46821c4c$exports = {};
$a8802b2c46821c4c$exports = $parcel$resolve("fAhTF");


var $d687c20280145495$exports = {};
$d687c20280145495$exports = $parcel$resolve("lTNVM");


var $d9bd1d2bff1f74cf$exports = {};
$d9bd1d2bff1f74cf$exports = $parcel$resolve("2mMxs");


var $efa7f1c37f31dc78$exports = {};
$efa7f1c37f31dc78$exports = $parcel$resolve("lkhcY");



var $ae8d4d20fe1b476f$exports = {};
$ae8d4d20fe1b476f$exports = $parcel$resolve("c9hFy");


var $289cf9e086264f67$exports = {};
$289cf9e086264f67$exports = $parcel$resolve("297B8");


var $2f2430cc582e1c11$exports = {};
$2f2430cc582e1c11$exports = $parcel$resolve("jxtUn");


var $c2c4adc0fdf54ba1$exports = {};
$c2c4adc0fdf54ba1$exports = $parcel$resolve("lfC0f");


var $038b7f7d23f79349$exports = {};
$038b7f7d23f79349$exports = $parcel$resolve("cDstS");


var $ee963b5db9745aca$exports = {};
$ee963b5db9745aca$exports = $parcel$resolve("arfqb");


var $f0e1c23f0e4f72a7$exports = {};
$f0e1c23f0e4f72a7$exports = $parcel$resolve("jz2is");


var $20d70891ea1a59f6$exports = {};
$20d70891ea1a59f6$exports = $parcel$resolve("aeV12");


var $51d846f6e7415a7b$exports = {};
$51d846f6e7415a7b$exports = $parcel$resolve("cFLos");


var $515bac1c8139a974$exports = {};
$515bac1c8139a974$exports = $parcel$resolve("abcn9");


const $aa2ca71db1de8ae6$export$24724bc1f91cba3 = {
    isLoaded: false
};
const $aa2ca71db1de8ae6$export$bac24f240bb7727d = {
    brightnessContrast: {
        lang: {
            name: 'filter-bright-contrast-title',
            button: 'filter-bright-contrast',
            description: 'filter-bright-contrast-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c19704f4e70546aa$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    cropExtend: {
        lang: {
            name: 'filter-crop-title',
            button: 'filter-crop-extend',
            description: 'filter-crop-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2d3a7d1efb01840c$exports))),
        updatePos: true,
        getDialog: null,
        apply: null,
        inEmbed: false
    },
    curves: {
        lang: {
            name: 'filter-curves-title',
            button: 'filter-curves',
            description: 'filter-curves-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($971718e1b87cb4cf$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    distort: {
        lang: {
            name: 'filter-distort',
            button: 'filter-distort',
            description: 'filter-distort-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($515bac1c8139a974$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    flip: {
        lang: {
            name: 'filter-flip-title',
            button: 'filter-flip',
            description: 'filter-flip-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($225f2fa0a90eb49a$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    hueSaturation: {
        lang: {
            name: 'filter-hue-sat-title',
            button: 'filter-hue-sat',
            description: 'filter-hue-sat-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a8802b2c46821c4c$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    invert: {
        lang: {
            name: 'filter-invert',
            button: 'filter-invert'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d687c20280145495$exports))),
        updatePos: false,
        isInstant: true,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    perspective: {
        lang: {
            name: 'filter-perspective-title',
            button: 'filter-perspective',
            description: 'filter-perspective-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d9bd1d2bff1f74cf$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    resize: {
        lang: {
            name: 'filter-resize-title',
            button: 'filter-resize',
            description: 'filter-resize-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($efa7f1c37f31dc78$exports))),
        updatePos: true,
        getDialog: null,
        apply: null,
        inEmbed: false
    },
    rotate: {
        lang: {
            name: 'filter-rotate-title',
            button: 'filter-rotate',
            description: 'filter-rotate-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($457bbdb587ea898d$exports))),
        updatePos: true,
        getDialog: null,
        apply: null,
        inEmbed: false
    },
    tiltShift: {
        lang: {
            name: 'filter-tilt-shift-title',
            button: 'filter-tilt-shift',
            description: 'filter-tilt-shift-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ae8d4d20fe1b476f$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    toAlpha: {
        lang: {
            name: 'filter-to-alpha-title',
            button: 'filter-to-alpha',
            description: 'filter-to-alpha-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($289cf9e086264f67$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    transform: {
        lang: {
            name: 'filter-transform-title',
            button: 'filter-transform',
            description: 'filter-transform-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2f2430cc582e1c11$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    blur: {
        lang: {
            name: 'filter-triangle-blur-title',
            button: 'filter-triangle-blur',
            description: 'filter-triangle-blur-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2c4adc0fdf54ba1$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    unsharpMask: {
        lang: {
            name: 'filter-unsharp-mask-title',
            button: 'filter-unsharp-mask',
            description: 'filter-unsharp-mask-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($038b7f7d23f79349$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    grid: {
        lang: {
            name: 'filter-grid',
            button: 'filter-grid',
            description: 'filter-grid-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ee963b5db9745aca$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    noise: {
        lang: {
            name: 'filter-noise',
            button: 'filter-noise',
            description: 'filter-noise-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f0e1c23f0e4f72a7$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    pattern: {
        lang: {
            name: 'filter-pattern',
            button: 'filter-pattern',
            description: 'filter-pattern-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($20d70891ea1a59f6$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    vanishPoint: {
        lang: {
            name: 'filter-vanish-point-title',
            button: 'filter-vanish-point',
            description: 'filter-vanish-point-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($51d846f6e7415a7b$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    }
};




/*
 * A speed-improved perlin and simplex noise algorithms for 2D.
 *
 * Based on example code by Stefan Gustavson (stegu@itn.liu.se).
 * Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
 * Better rank ordering method by Stefan Gustavson in 2012.
 * Converted to Javascript by Joseph Gentle.
 *
 * Version 2012-03-09
 *
 * This code was placed in the public domain by its original author,
 * Stefan Gustavson. You may use it as you see fit, but
 * attribution is appreciated.
 *
 */ const $f49636f27554dab5$var$myModule = {};
class $f49636f27554dab5$var$Grad {
    dot2(x, y) {
        return this.x * x + this.y * y;
    }
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
}
/*
Grad.prototype.dot3 = function(x, y, z) {
    return this.x*x + this.y*y + this.z*z;
};*/ const $f49636f27554dab5$var$grad3 = [
    new $f49636f27554dab5$var$Grad(1, 1, 0),
    new $f49636f27554dab5$var$Grad(-1, 1, 0),
    new $f49636f27554dab5$var$Grad(1, -1, 0),
    new $f49636f27554dab5$var$Grad(-1, -1, 0),
    new $f49636f27554dab5$var$Grad(1, 0, 1),
    new $f49636f27554dab5$var$Grad(-1, 0, 1),
    new $f49636f27554dab5$var$Grad(1, 0, -1),
    new $f49636f27554dab5$var$Grad(-1, 0, -1),
    new $f49636f27554dab5$var$Grad(0, 1, 1),
    new $f49636f27554dab5$var$Grad(0, -1, 1),
    new $f49636f27554dab5$var$Grad(0, 1, -1),
    new $f49636f27554dab5$var$Grad(0, -1, -1)
];
const $f49636f27554dab5$var$p = [
    151,
    160,
    137,
    91,
    90,
    15,
    131,
    13,
    201,
    95,
    96,
    53,
    194,
    233,
    7,
    225,
    140,
    36,
    103,
    30,
    69,
    142,
    8,
    99,
    37,
    240,
    21,
    10,
    23,
    190,
    6,
    148,
    247,
    120,
    234,
    75,
    0,
    26,
    197,
    62,
    94,
    252,
    219,
    203,
    117,
    35,
    11,
    32,
    57,
    177,
    33,
    88,
    237,
    149,
    56,
    87,
    174,
    20,
    125,
    136,
    171,
    168,
    68,
    175,
    74,
    165,
    71,
    134,
    139,
    48,
    27,
    166,
    77,
    146,
    158,
    231,
    83,
    111,
    229,
    122,
    60,
    211,
    133,
    230,
    220,
    105,
    92,
    41,
    55,
    46,
    245,
    40,
    244,
    102,
    143,
    54,
    65,
    25,
    63,
    161,
    1,
    216,
    80,
    73,
    209,
    76,
    132,
    187,
    208,
    89,
    18,
    169,
    200,
    196,
    135,
    130,
    116,
    188,
    159,
    86,
    164,
    100,
    109,
    198,
    173,
    186,
    3,
    64,
    52,
    217,
    226,
    250,
    124,
    123,
    5,
    202,
    38,
    147,
    118,
    126,
    255,
    82,
    85,
    212,
    207,
    206,
    59,
    227,
    47,
    16,
    58,
    17,
    182,
    189,
    28,
    42,
    223,
    183,
    170,
    213,
    119,
    248,
    152,
    2,
    44,
    154,
    163,
    70,
    221,
    153,
    101,
    155,
    167,
    43,
    172,
    9,
    129,
    22,
    39,
    253,
    19,
    98,
    108,
    110,
    79,
    113,
    224,
    232,
    178,
    185,
    112,
    104,
    218,
    246,
    97,
    228,
    251,
    34,
    242,
    193,
    238,
    210,
    144,
    12,
    191,
    179,
    162,
    241,
    81,
    51,
    145,
    235,
    249,
    14,
    239,
    107,
    49,
    192,
    214,
    31,
    181,
    199,
    106,
    157,
    184,
    84,
    204,
    176,
    115,
    121,
    50,
    45,
    127,
    4,
    150,
    254,
    138,
    236,
    205,
    93,
    222,
    114,
    67,
    29,
    24,
    72,
    243,
    141,
    128,
    195,
    78,
    66,
    215,
    61,
    156,
    180
];
// To remove the need for index wrapping, double the permutation table length
const $f49636f27554dab5$var$perm = new Array(512);
const $f49636f27554dab5$var$gradP = new Array(512);
// This isn't a very good seeding function, but it works ok. It supports 2^16
// different seed values. Write something better if you need more seeds.
$f49636f27554dab5$var$myModule.seed = function(seed) {
    if (seed > 0 && seed < 1) // Scale the seed out
    seed *= 65536;
    seed = Math.floor(seed);
    if (seed < 256) seed |= seed << 8;
    for(let i = 0; i < 256; i++){
        let v;
        if (i & 1) v = $f49636f27554dab5$var$p[i] ^ seed & 255;
        else v = $f49636f27554dab5$var$p[i] ^ seed >> 8 & 255;
        $f49636f27554dab5$var$perm[i] = $f49636f27554dab5$var$perm[i + 256] = v;
        $f49636f27554dab5$var$gradP[i] = $f49636f27554dab5$var$gradP[i + 256] = $f49636f27554dab5$var$grad3[v % 12];
    }
};
$f49636f27554dab5$var$myModule.seed(0);
/*
for (let i=0; i<256; i++) {
  perm[i] = perm[i + 256] = p[i];
  gradP[i] = gradP[i + 256] = grad3[perm[i] % 12];
}*/ // Skewing and unskewing factors for 2, 3, and 4 dimensions
const $f49636f27554dab5$var$F2 = 0.5 * (Math.sqrt(3) - 1);
const $f49636f27554dab5$var$G2 = (3 - Math.sqrt(3)) / 6;
/*let F3 = 1/3;
let G3 = 1/6;*/ // 2D simplex noise
$f49636f27554dab5$var$myModule.simplex2 = function(xin, yin) {
    let n0, n1, n2; // Noise contributions from the three corners
    // Skew the input space to determine which simplex cell we're in
    const s = (xin + yin) * $f49636f27554dab5$var$F2; // Hairy factor for 2D
    let i = Math.floor(xin + s);
    let j = Math.floor(yin + s);
    const t = (i + j) * $f49636f27554dab5$var$G2;
    const x0 = xin - i + t; // The x,y distances from the cell origin, unskewed.
    const y0 = yin - j + t;
    // For the 2D case, the simplex shape is an equilateral triangle.
    // Determine which simplex we are in.
    let i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
    if (x0 > y0) {
        // lower triangle, XY order: (0,0)->(1,0)->(1,1)
        i1 = 1;
        j1 = 0;
    } else {
        // upper triangle, YX order: (0,0)->(0,1)->(1,1)
        i1 = 0;
        j1 = 1;
    }
    // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
    // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
    // c = (3-sqrt(3))/6
    const x1 = x0 - i1 + $f49636f27554dab5$var$G2; // Offsets for middle corner in (x,y) unskewed coords
    const y1 = y0 - j1 + $f49636f27554dab5$var$G2;
    const x2 = x0 - 1 + 2 * $f49636f27554dab5$var$G2; // Offsets for last corner in (x,y) unskewed coords
    const y2 = y0 - 1 + 2 * $f49636f27554dab5$var$G2;
    // Work out the hashed gradient indices of the three simplex corners
    i &= 255;
    j &= 255;
    const gi0 = $f49636f27554dab5$var$gradP[i + $f49636f27554dab5$var$perm[j]];
    const gi1 = $f49636f27554dab5$var$gradP[i + i1 + $f49636f27554dab5$var$perm[j + j1]];
    const gi2 = $f49636f27554dab5$var$gradP[i + 1 + $f49636f27554dab5$var$perm[j + 1]];
    // Calculate the contribution from the three corners
    let t0 = 0.5 - x0 * x0 - y0 * y0;
    if (t0 < 0) n0 = 0;
    else {
        t0 *= t0;
        n0 = t0 * t0 * gi0.dot2(x0, y0); // (x,y) of grad3 used for 2D gradient
    }
    let t1 = 0.5 - x1 * x1 - y1 * y1;
    if (t1 < 0) n1 = 0;
    else {
        t1 *= t1;
        n1 = t1 * t1 * gi1.dot2(x1, y1);
    }
    let t2 = 0.5 - x2 * x2 - y2 * y2;
    if (t2 < 0) n2 = 0;
    else {
        t2 *= t2;
        n2 = t2 * t2 * gi2.dot2(x2, y2);
    }
    // Add contributions from each corner to get the final noise value.
    // The result is scaled to return values in the interval [-1,1].
    return 70 * (n0 + n1 + n2);
};
const $f49636f27554dab5$export$d3022aad56692482 = $f49636f27554dab5$var$myModule;


function $be08c7e8caa49ffa$export$74a44bbc21d06a28(w) {
    const scaleFac = w / 500;
    const h = w;
    const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
    const imData = ctx.createImageData(w, h);
    for(let x = 0; x < w; x++)for(let y = 0; y < h; y++){
        const i = (y * w + x) * 4;
        // base noise
        const sFac2 = scaleFac + (0, $f49636f27554dab5$export$d3022aad56692482).simplex2(x / 50 / scaleFac, y / 50 / scaleFac) * 0.04;
        let noisePattern = 100 + ((0, $f49636f27554dab5$export$d3022aad56692482).simplex2(x / 50 / sFac2, y / 50 / sFac2) + 1) / 2 * 100;
        noisePattern -= ((0, $f49636f27554dab5$export$d3022aad56692482).simplex2(x / 10 / scaleFac, y / 10 / scaleFac) + 1) / 2 * 100;
        // fade out in circular shape
        const centerDist = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).dist(w / 2, h / 2, x, y);
        const falloff = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(1 - ((centerDist - w / 2.5) / (w / 14) + (0, $f49636f27554dab5$export$d3022aad56692482).simplex2(x / 22 / sFac2, y / 22 / sFac2)), 0, 1);
        noisePattern = noisePattern * falloff;
        // make the middle darker
        const falloff2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(1 - centerDist / w, 0, 1) * 2;
        noisePattern = noisePattern * falloff2;
        imData.data[i] = 0;
        imData.data[i + 1] = 0;
        imData.data[i + 2] = 0;
        imData.data[i + 3] = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(noisePattern, 0, 255);
    }
    ctx.putImageData(imData, 0, 0);
    return canvas;
}
// https://www.shadertoy.com/view/3tdSDj
function $be08c7e8caa49ffa$var$udSegment(p, a, b) {
    const ba = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.sub(b, a);
    const pa = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.sub(p, a);
    const h = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp((0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.dot(pa, ba) / (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.dot(ba, ba), 0.0, 1.0);
    return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.len((0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.sub(pa, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.mul(ba, h)));
}
function $be08c7e8caa49ffa$export$eaa218d5d17c8f1c(w) {
    const pDist = 1 / 4;
    let centerSize = 2 / 3;
    let transitionSize = 1 / 3;
    centerSize *= pDist;
    transitionSize *= pDist;
    const p1 = {
        x: pDist * w,
        y: w - w * pDist
    };
    const p2 = {
        x: w - w * pDist,
        y: pDist * w
    };
    const h = w;
    const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
    const imData = ctx.createImageData(w, h);
    for(let x = 0; x < w; x++)for(let y = 0; y < h; y++){
        const i = (y * w + x) * 4;
        let col = $be08c7e8caa49ffa$var$udSegment({
            x: x,
            y: y
        }, p1, p2);
        col = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(255 - (col - w * centerSize) / (w * transitionSize) * 255, 0, 255);
        imData.data[i] = 0;
        imData.data[i + 1] = 0;
        imData.data[i + 2] = 0;
        imData.data[i + 3] = col;
    }
    ctx.putImageData(imData, 0, 0);
    return canvas;
}


const $f1a560137f603778$export$67a3081d7cc6182d = []; // used by default brush
$f1a560137f603778$export$67a3081d7cc6182d[1] = (0, $be08c7e8caa49ffa$export$74a44bbc21d06a28)(128);
$f1a560137f603778$export$67a3081d7cc6182d[2] = (0, $be08c7e8caa49ffa$export$eaa218d5d17c8f1c)(128);



function $fc7b31422a41da93$export$263fa670dc037098(composed, imageOrTiles) {
    const activeLayerId = composed.activeLayerId;
    const layerMap = Object.fromEntries(Object.entries(composed.layerMap).map(([layerId, layerItem])=>{
        if (layerId === activeLayerId) return [
            layerId,
            {
                tiles: imageOrTiles instanceof HTMLCanvasElement ? (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(imageOrTiles) : [
                    ...imageOrTiles
                ]
            }
        ];
        return [
            layerId,
            {}
        ];
    }));
    return {
        layerMap: layerMap
    };
}







const $ab3d0b0688f50842$var$ALPHA_CIRCLE = 0;
const $ab3d0b0688f50842$var$ALPHA_CHALK = 1;
const $ab3d0b0688f50842$var$ALPHA_CAL = 2; // calligraphy
const $ab3d0b0688f50842$var$ALPHA_SQUARE = 3;
const $ab3d0b0688f50842$var$TWO_PI = 2 * Math.PI;
class $ab3d0b0688f50842$export$6f96c8f9e6ae7341 {
    updateChangedTiles(bounds) {
        const boundsWithinSelection = (0, $9414f5ea41e9cf25$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        this.changedTiles = (0, $b37280925142c567$export$1774f90c6da5013c)(this.changedTiles, (0, $b37280925142c567$export$2098fe43203ddd32)(boundsWithinSelection, this.context.canvas.width, this.context.canvas.height));
    }
    updateAlphaCanvas() {
        if (this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_CIRCLE || this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_SQUARE) return;
        const instructionArr = [
            [
                this.alphaCanvas128,
                128
            ],
            [
                this.alphaCanvas64,
                64
            ],
            [
                this.alphaCanvas32,
                32
            ]
        ];
        let ctx;
        for(let i = 0; i < instructionArr.length; i++){
            ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(instructionArr[i][0]);
            ctx.save();
            ctx.clearRect(0, 0, instructionArr[i][1], instructionArr[i][1]);
            ctx.fillStyle = 'rgba(' + this.settingColor.r + ', ' + this.settingColor.g + ', ' + this.settingColor.b + ', ' + this.alphaOpacityArr[this.settingAlphaId] + ')';
            ctx.fillRect(0, 0, instructionArr[i][1], instructionArr[i][1]);
            ctx.globalCompositeOperation = 'destination-in';
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage((0, $f1a560137f603778$export$67a3081d7cc6182d)[this.settingAlphaId], 0, 0, instructionArr[i][1], instructionArr[i][1]);
            ctx.restore();
        }
    }
    calcOpacity(pressure) {
        return this.settingOpacity * (this.settingHasOpacityPressure ? pressure * pressure : 1);
    }
    calcScatter(pressure) {
        return this.settingScatter * this.settingSize * (this.settingHasScatterPressure ? pressure : 1);
    }
    /**
     * @param x
     * @param y
     * @param size
     * @param opacity
     * @param scatter
     * @param angle
     * @param before - [x, y, size, opacity, angle] the drawDot call before
     */ drawDot(x, y, size, opacity, scatter, angle, before) {
        if (size <= 0) return;
        if (this.settingLockLayerAlpha) this.context.globalCompositeOperation = 'source-atop';
        if (!before || before[3] !== opacity) this.context.globalAlpha = opacity;
        if (!before && (this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_CIRCLE || this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_SQUARE)) this.context.fillStyle = this.settingColorStr;
        if (scatter > 0) {
            // scatter equally distributed over area of a circle
            const scatterAngleRad = Math.random() * 2 * Math.PI;
            const distance = Math.sqrt(Math.random()) * scatter;
            x += Math.cos(scatterAngleRad) * distance;
            y += Math.sin(scatterAngleRad) * distance;
        }
        const boundsSize = this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_CIRCLE || this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_CAL ? size : size * Math.sqrt(2);
        this.updateChangedTiles({
            type: 'index',
            x1: Math.floor(x - boundsSize),
            y1: Math.floor(y - boundsSize),
            x2: Math.ceil(x + boundsSize - 1),
            y2: Math.ceil(y + boundsSize - 1)
        });
        if (this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_CIRCLE) {
            this.context.beginPath();
            this.context.arc(x, y, size, 0, $ab3d0b0688f50842$var$TWO_PI);
            this.context.closePath();
            this.context.fill();
            this.hasDrawnDot = true;
        } else if (this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_SQUARE) {
            if (angle !== undefined) {
                this.context.save();
                this.context.translate(x, y);
                this.context.rotate(angle / 180 * Math.PI);
                this.context.fillRect(-size, -size, size * 2, size * 2);
                this.context.restore();
                this.hasDrawnDot = true;
            }
        } else {
            // other brush alphas
            this.context.save();
            this.context.translate(x, y);
            let targetMipmap = this.alphaCanvas128;
            if (size <= 32 && size > 16) targetMipmap = this.alphaCanvas64;
            else if (size <= 16) targetMipmap = this.alphaCanvas32;
            this.context.scale(size, size);
            if (this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_CHALK) this.context.rotate((x + y) * 53123 % $ab3d0b0688f50842$var$TWO_PI); // without mod it sometimes looks different
            this.context.drawImage(targetMipmap, -1, -1, 2, 2);
            this.context.restore();
            this.hasDrawnDot = true;
        }
    }
    // continueLine
    continueLine(x, y, size, pressure) {
        if (this.bezierLine === null) {
            this.bezierLine = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).BezierLine();
            this.bezierLine.add(this.lastInput.x, this.lastInput.y, 0, ()=>{});
        }
        const drawArr = []; //draw instructions. will be all drawn at once
        const dotCallback = (val)=>{
            const localPressure = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.lastInput2.pressure, pressure, val.t);
            const localOpacity = this.calcOpacity(localPressure);
            const localSize = Math.max(0.1, this.settingSize * (this.settingHasSizePressure ? localPressure : 1));
            const localScatter = this.calcScatter(localPressure);
            drawArr.push([
                val.x,
                val.y,
                localSize,
                localOpacity,
                localScatter,
                val.angle
            ]);
        };
        const localSpacing = size * this.settingSpacing;
        if (x === null || y === null) this.bezierLine.addFinal(localSpacing, dotCallback);
        else this.bezierLine.add(x, y, localSpacing, dotCallback);
        // execute draw instructions
        this.context.save();
        let before = undefined;
        for(let i = 0; i < drawArr.length; i++){
            const item = drawArr[i];
            this.drawDot(item[0], item[1], item[2], item[3], item[4], item[5], before);
            before = item;
        }
        this.context.restore();
    }
    // ---- interface ----
    startLine(x, y, p) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedTiles = [];
        p = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(p, 0, 1);
        const localOpacity = this.calcOpacity(p);
        const localSize = this.settingHasSizePressure ? Math.max(0.1, p * this.settingSize) : Math.max(0.1, this.settingSize);
        const localScatter = this.calcScatter(p);
        this.hasDrawnDot = false;
        this.inputIsDrawing = true;
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.drawDot(x, y, localSize, localOpacity, localScatter);
        this.context.restore();
        this.lineToolLastDot = localSize * this.settingSpacing;
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2.pressure = p;
        this.inputArr = [
            {
                x: x,
                y: y,
                pressure: p
            }
        ];
    }
    goLine(x, y, p) {
        if (!this.inputIsDrawing) return;
        const pressure = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(p, 0, 1);
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.continueLine(x, y, localSize, this.lastInput.pressure);
        /*context.fillStyle = 'red';
        context.fillRect(Math.floor(x), Math.floor(y - 10), 1, 20);
        context.fillRect(Math.floor(x - 10), Math.floor(y), 20, 1);*/ this.context.restore();
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput2.pressure = this.lastInput.pressure;
        this.lastInput.pressure = pressure;
        this.inputArr.push({
            x: x,
            y: y,
            pressure: p
        });
    }
    endLine() {
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.continueLine(null, null, localSize, this.lastInput.pressure);
        this.context.restore();
        this.inputIsDrawing = false;
        if (this.settingAlphaId === $ab3d0b0688f50842$var$ALPHA_SQUARE && !this.hasDrawnDot) {
            // find max pressure input, use that one
            let maxInput = this.inputArr[0];
            this.inputArr.forEach((item)=>{
                if (item.pressure > maxInput.pressure) maxInput = item;
            });
            this.context.save();
            this.selectionPath && this.context.clip(this.selectionPath);
            const p = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(maxInput.pressure, 0, 1);
            const localOpacity = this.calcOpacity(p);
            const localScatter = this.calcScatter(p);
            this.drawDot(maxInput.x, maxInput.y, localSize, localOpacity, localScatter, 0);
            this.context.restore();
        }
        this.bezierLine = null;
        if (this.changedTiles.some((item)=>item)) this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $a262f7e0a9f5e4af$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
        this.hasDrawnDot = false;
        this.inputArr = [];
    }
    drawLineSegment(x1, y1, x2, y2) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedTiles = [];
        this.lastInput.x = x2;
        this.lastInput.y = y2;
        this.lastInput.pressure = 1;
        if (this.inputIsDrawing || x1 === undefined) return;
        const angle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).pointsToAngleDeg({
            x: x1,
            y: y1
        }, {
            x: x2,
            y: y2
        });
        const mouseDist = Math.sqrt(Math.pow(x2 - x1, 2.0) + Math.pow(y2 - y1, 2.0));
        const eX = (x2 - x1) / mouseDist;
        const eY = (y2 - y1) / mouseDist;
        let loopDist;
        const bdist = this.settingSize * this.settingSpacing;
        this.lineToolLastDot = this.settingSize * this.settingSpacing;
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        const localScatter = this.calcScatter(1);
        for(loopDist = this.lineToolLastDot; loopDist <= mouseDist; loopDist += bdist)this.drawDot(x1 + eX * loopDist, y1 + eY * loopDist, this.settingSize, this.settingOpacity, localScatter, angle);
        this.context.restore();
        if (this.changedTiles.some((item)=>item)) this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $a262f7e0a9f5e4af$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
    }
    //IS
    isDrawing() {
        return this.inputIsDrawing;
    }
    //SET
    setAlpha(a) {
        if (this.settingAlphaId === a) return;
        this.settingAlphaId = a;
        this.updateAlphaCanvas();
    }
    setColor(c) {
        if (this.settingColor === c) return;
        this.settingColor = {
            r: c.r,
            g: c.g,
            b: c.b
        };
        this.settingColorStr = 'rgb(' + this.settingColor.r + ',' + this.settingColor.g + ',' + this.settingColor.b + ')';
        this.updateAlphaCanvas();
    }
    setContext(c) {
        this.context = c;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSize(s) {
        this.settingSize = s;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    setScatter(o) {
        this.settingScatter = o;
    }
    setSpacing(s) {
        this.settingSpacing = s;
    }
    sizePressure(b) {
        this.settingHasSizePressure = b;
    }
    opacityPressure(b) {
        this.settingHasOpacityPressure = b;
    }
    scatterPressure(b) {
        this.settingHasScatterPressure = b;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    //GET
    getSpacing() {
        return this.settingSpacing;
    }
    getSize() {
        return this.settingSize;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    getScatter() {
        return this.settingScatter;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.context = {};
        this.klHistory = {};
        this.settingHasOpacityPressure = false;
        this.settingHasScatterPressure = false;
        this.settingHasSizePressure = true;
        this.settingSize = 2;
        this.settingSpacing = 0.8489;
        this.settingOpacity = 1;
        this.settingScatter = 0;
        this.settingColor = {};
        this.settingColorStr = '';
        this.settingAlphaId = $ab3d0b0688f50842$var$ALPHA_CIRCLE;
        this.settingLockLayerAlpha = false;
        this.hasDrawnDot = false;
        this.lineToolLastDot = 0;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.inputArr = [];
        this.inputIsDrawing = false;
        this.bezierLine = null;
        // mipmapping
        this.alphaCanvas128 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(128, 128);
        this.alphaCanvas64 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(64, 64);
        this.alphaCanvas32 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(32, 32);
        this.alphaOpacityArr = [
            1,
            0.9,
            1,
            1
        ];
        this.changedTiles = [];
    }
}













class $2beac24702a6836b$export$9659db8d01dd5313 {
    updateRedrawBounds(bounds) {
        const boundsWithinSelection = (0, $9414f5ea41e9cf25$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        this.redrawBounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).updateBounds(this.redrawBounds, boundsWithinSelection);
    }
    getCellsWidth() {
        return Math.ceil(this.context.canvas.width / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
    }
    /**
     * draw cells onto context
     * @param cells
     */ drawCells(cells) {
        const cellsW = this.getCellsWidth();
        cells.forEach((imageData, index)=>{
            if (!imageData) return;
            const cellOffsetX = index % cellsW * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            const cellOffsetY = Math.floor(index / cellsW) * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            this.context.putImageData(imageData, cellOffsetX, cellOffsetY);
        });
    }
    /**
     * draw changed cells (changed by brushstroke) onto context
     * @private
     */ drawChangedCells() {
        if (!this.redrawBounds) return;
        const cells = this.cells.map(()=>undefined);
        const touchedCells = this.getTouchedCells(this.redrawBounds);
        touchedCells.forEach((isTouched, index)=>{
            if (isTouched) cells[index] = this.cells[index];
        });
        this.drawCells(cells);
        this.redrawBounds = undefined;
    }
    getTouchedCells(bounds) {
        const touchedCells = this.cells.map(()=>false);
        const cellsW = this.getCellsWidth();
        bounds = {
            type: 'index',
            x1: Math.floor(bounds.x1 / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6)),
            y1: Math.floor(bounds.y1 / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6)),
            x2: Math.floor(bounds.x2 / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6)),
            y2: Math.floor(bounds.y2 / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6))
        };
        for(let i = bounds.x1; i <= bounds.x2; i++)for(let e = bounds.y1; e <= bounds.y2; e++)touchedCells[e * cellsW + i] = true;
        return touchedCells;
    }
    /**
     * Slice up bounds according to cells
     * @param bounds
     * @private
     */ sliceBounds(bounds) {
        const boundsWithinSelection = (0, $9414f5ea41e9cf25$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return [];
        const cellsW = this.getCellsWidth();
        const result = [];
        const touchedCells = this.getTouchedCells(boundsWithinSelection);
        touchedCells.forEach((cell, i)=>{
            if (!cell) return;
            const cellOffsetX = i % cellsW * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            const cellOffsetY = Math.floor(i / cellsW) * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            const cellWidth = this.cells[i].width;
            const cellHeight = this.cells[i].height;
            const inCellBounds = {
                type: 'index',
                x1: Math.max(0, boundsWithinSelection.x1 - cellOffsetX),
                y1: Math.max(0, boundsWithinSelection.y1 - cellOffsetY),
                x2: Math.min(cellWidth - 1, boundsWithinSelection.x2 - cellOffsetX),
                y2: Math.min(cellHeight - 1, boundsWithinSelection.y2 - cellOffsetY)
            };
            if (inCellBounds.x1 > inCellBounds.x2 || inCellBounds.y1 > inCellBounds.y2) return;
            result.push({
                index: i,
                bounds: inCellBounds
            });
        });
        return result;
    }
    /**
     * update copyImageData. copy over new regions if needed
     */ copyFromCanvas(bounds) {
        if (!bounds) return;
        const touchedCells = this.getTouchedCells(bounds);
        const composedLayer = this.klHistory.getComposed().layerMap[this.layerId];
        touchedCells.forEach((item, i)=>{
            if (!item || this.cells[i]) // not touched, or already copied
            return;
            // Uncaught TypeError: Cannot read properties of undefined (reading 'tiles')
            const composedTile = composedLayer.tiles[i];
            if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(composedTile)) {
                const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas((0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
                const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
                ctx.fillStyle = composedTile.fill;
                ctx.fillRect(0, 0, (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
                // InvalidStateError: The object is in an invalid state.
                this.cells[i] = ctx.getImageData(0, 0, (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
            } else this.cells[i] = (0, $2946cfe57170d555$export$3d7bd55e322555b1)(composedTile.data);
        });
    }
    getAverage(x, y, size) {
        size = Math.max(0.5, size * 0.75);
        const x1 = Math.max(0, Math.floor(x - size));
        const y1 = Math.max(0, Math.floor(y - size));
        const x2 = Math.min(this.context.canvas.width - 1, Math.ceil(x + size));
        const y2 = Math.min(this.context.canvas.height - 1, Math.ceil(y + size));
        if (x1 > x2 || y1 > y2) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
        let ar = 0, ag = 0, ab = 0, aa = 0;
        const slicedBounds = this.sliceBounds({
            type: 'index',
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        });
        const cellsW = this.getCellsWidth();
        slicedBounds.forEach((slice)=>{
            const cellOffsetX = slice.index % cellsW * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            const cellOffsetY = Math.floor(slice.index / cellsW) * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            const width = this.cells[slice.index].width;
            const data = this.cells[slice.index].data;
            const bounds = slice.bounds;
            for(let i = bounds.y1, globalY = i + cellOffsetY; i <= bounds.y2; i++, globalY++)for(let e = bounds.x1, globalX = e + cellOffsetX, e2 = (i * width + bounds.x1) * 4; e <= bounds.x2; e++, globalX++, e2 += 4){
                if (this.mask && this.mask[globalY * this.context.canvas.width + globalX] === 0) continue;
                const alpha = data[e2 + 3] / 255;
                if (alpha === 0) continue;
                ar += data[e2] * alpha;
                ag += data[e2 + 1] * alpha;
                ab += data[e2 + 2] * alpha;
                aa += alpha;
            }
        });
        if (aa !== 0) {
            ar /= aa;
            ag /= aa;
            ab /= aa;
            aa = Math.min(1, aa);
        }
        return {
            r: ar,
            g: ag,
            b: ab,
            a: aa
        };
    }
    getDotBounds(x, y, size) {
        size = Math.max(0.5, size);
        const x1 = Math.max(0, Math.floor(x - size));
        const y1 = Math.max(0, Math.floor(y - size));
        const x2 = Math.min(this.context.canvas.width - 1, Math.ceil(x + size));
        const y2 = Math.min(this.context.canvas.height - 1, Math.ceil(y + size));
        if (x1 > x2 || y1 > y2) return undefined;
        return {
            type: 'index',
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        };
    }
    drawDot(params) {
        // array with random numbers. faster than Math.random()
        let randI = 0;
        const randLen = params.size > 30 ? 1024 : 512; // lower lengths lead to noticeable patterns
        const randArr = [];
        for(let i = 0; i < randLen; i++)randArr[i] = (Math.random() - 0.5) / 1.001 + 0.5;
        // thin lines take more than just 1 sample
        const sampleArr = [
            8,
            4,
            4,
            4,
            2,
            2,
            2,
            2,
            2,
            2
        ]; // <0.5, 0.5, 1, 1.5, etc.
        const samples = sampleArr[Math.floor(params.size * 2)];
        const samplesSquared = samples ? samples * samples : 0;
        const sampleOffsets = [];
        if (samples) {
            let i = 0;
            for(let n = 0; n < samples; n++)for(let m = 0; m < samples; m++, i += 2){
                sampleOffsets[i] = (n + 1) / samples; // x offset
                sampleOffsets[i + 1] = (m + 1) / samples; // y offset
            }
        }
        const sharpness = Math.pow(params.opacity, 2) * 0.8;
        // to optimize calculations
        const invSharpness = 1 - sharpness;
        const sharpnessSubtrahend = sharpness / invSharpness;
        const sizeSquared = params.size * params.size;
        const distDivisor = sizeSquared * invSharpness / params.opacity;
        const alphaMinuend = (1 + sharpnessSubtrahend) * params.opacity;
        const slicedBounds = this.sliceBounds({
            type: 'index',
            x1: params.x1,
            y1: params.y1,
            x2: params.x2,
            y2: params.y2
        });
        const cellsW = this.getCellsWidth();
        slicedBounds.forEach((slice)=>{
            const cellOffsetX = slice.index % cellsW * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            const cellOffsetY = Math.floor(slice.index / cellsW) * (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6);
            const cellWidth = this.cells[slice.index].width;
            const data = this.cells[slice.index].data;
            // i - y index within cell
            // e - x index within cell
            // e2 - index in image data (a tile)
            // mi - index in mask (one mask for the entire image)
            // ri - y index within image relative to dot-center
            // re - x index within image relative to dot-center
            for(let i = slice.bounds.y1, ri = i + cellOffsetY - params.y; i <= slice.bounds.y2; i++, ri++)for(let e = slice.bounds.x1, mi = (i + cellOffsetY) * this.context.canvas.width + (slice.bounds.x1 + cellOffsetX), e2 = (i * cellWidth + slice.bounds.x1) * 4, re = e + cellOffsetX - params.x; e <= slice.bounds.x2; e++, mi++, e2 += 4, re++){
                if (this.mask && this.mask[mi] === 0) continue;
                // O = over -> brush-dot
                // U = under -> image
                let alphaO = 0;
                if (samplesSquared) {
                    for(let f = 0; f < sampleOffsets.length; f += 2){
                        const dist = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).lenSquared(re + sampleOffsets[f], ri + sampleOffsets[f + 1]);
                        if (dist >= sizeSquared) continue;
                        alphaO += (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(alphaMinuend - dist / distDivisor, 0, params.opacity);
                    }
                    if (!alphaO) continue;
                    alphaO /= samplesSquared;
                } else {
                    // technically needs + 0.5 offset, but not noticeable with large brush
                    const dist = Math.pow(re, 2) + Math.pow(ri, 2);
                    if (dist >= sizeSquared) continue;
                    alphaO = (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(alphaMinuend - dist / distDivisor, 0, params.opacity);
                }
                const invAlphaO = 1 - alphaO;
                const alphaU = data[e2 + 3] / 255;
                if (this.settingLockLayerAlpha) {
                    const underR = params.r * alphaO + data[e2] * invAlphaO;
                    const underG = params.g * alphaO + data[e2 + 1] * invAlphaO;
                    const underB = params.b * alphaO + data[e2 + 2] * invAlphaO;
                    if (alphaU) {
                        data[e2] = Math.floor(underR + randArr[randI]);
                        data[e2 + 1] = Math.floor(underG + randArr[randI]);
                        data[e2 + 2] = Math.floor(underB + randArr[randI]);
                    }
                } else {
                    const underR = params.r * alphaO + data[e2] * alphaU * invAlphaO;
                    const underG = params.g * alphaO + data[e2 + 1] * alphaU * invAlphaO;
                    const underB = params.b * alphaO + data[e2 + 2] * alphaU * invAlphaO;
                    const newAlpha = 1 - invAlphaO * (1 - alphaU);
                    data[e2 + 3] = Math.floor(Math.min(255, newAlpha * 255) + 0.5);
                    if (newAlpha) {
                        data[e2] = Math.floor(underR / newAlpha + randArr[randI]);
                        data[e2 + 1] = Math.floor(underG / newAlpha + randArr[randI]);
                        data[e2 + 2] = Math.floor(underB / newAlpha + randArr[randI]);
                    }
                }
                randI = (randI + 1) % randLen;
            }
        });
    }
    calcSpacing(size) {
        return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(size * 2 / 2, size * 2 / 9, (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)((size - 2.7) / 9.3, 0, 1));
    }
    continueLine(x, y, p, isCoalesced) {
        this.drawBuffer = [];
        let localPressure;
        let localOpacity;
        let localSize = this.settingSizePressure ? Math.max(1, p * this.size) : Math.max(1, this.size);
        const bDist = this.calcSpacing(localSize);
        const avgX = x === undefined ? this.lastInput.x : x;
        const avgY = y === undefined ? this.lastInput.y : y;
        let localColNew;
        if (this.blending === 0) {
            this.mixCol.r = this.color.r;
            this.mixCol.g = this.color.g;
            this.mixCol.b = this.color.b;
        } else {
            let average;
            if (isCoalesced) average = {
                r: this.localColOld.r,
                g: this.localColOld.g,
                b: this.localColOld.b,
                a: 0
            };
            else {
                const avgParams = [
                    avgX,
                    avgY,
                    this.settingSizePressure ? Math.max(0.5, p * this.size) : Math.max(0.5, this.size)
                ];
                const bounds = this.getDotBounds(avgParams[0], avgParams[1], avgParams[2]);
                if (bounds) this.copyFromCanvas(bounds);
                average = this.getAverage(avgParams[0], avgParams[1], avgParams[2]);
            }
            localColNew = {
                r: 0,
                g: 0,
                b: 0,
                a: 0
            };
            if (average.a > 0 && this.blendCol.a === 0) {
                this.blendCol.r = average.r;
                this.blendCol.g = average.g;
                this.blendCol.b = average.b;
                this.blendCol.a = average.a;
                localColNew.r = this.blendCol.r;
                localColNew.g = this.blendCol.g;
                localColNew.b = this.blendCol.b;
                localColNew.a = this.blendCol.a;
            } else {
                if (average.a === 0) {
                    average.r = this.color.r;
                    average.g = this.color.g;
                    average.b = this.color.b;
                    average.a = 1 - this.blending;
                }
                this.blendCol.r = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.blendCol.r, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.blendCol.r, average.r, this.blendMix), average.a);
                this.blendCol.g = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.blendCol.g, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.blendCol.g, average.g, this.blendMix), average.a);
                this.blendCol.b = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.blendCol.b, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.blendCol.b, average.b, this.blendMix), average.a);
                this.blendCol.a = Math.min(1, this.blendCol.a + average.a);
                localColNew.r = this.blendCol.r;
                localColNew.g = this.blendCol.g;
                localColNew.b = this.blendCol.b;
                localColNew.a = this.blendCol.a;
            }
        }
        const bezierCallback = (val)=>{
            if (this.blending >= 1 && this.blendCol.a <= 0) return;
            const factor = val.t;
            localPressure = this.lastInput2.pressure * (1 - factor) + p * factor;
            localOpacity = this.settingOpacityPressure ? this.opacity * localPressure * localPressure : this.opacity;
            localSize = this.settingSizePressure ? Math.max(0.1, localPressure * this.size) : Math.max(0.1, this.size);
            if (this.blending != 0) {
                this.mixCol.r = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.localColOld.r, localColNew.r, factor);
                this.mixCol.g = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.localColOld.g, localColNew.g, factor);
                this.mixCol.b = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.localColOld.b, localColNew.b, factor);
            }
            if (this.blending === 1 && this.localColOld.a === 0) {
                this.mixCol.r = localColNew.r;
                this.mixCol.g = localColNew.g;
                this.mixCol.b = localColNew.b;
            }
            const bounds = this.getDotBounds(val.x, val.y, localSize);
            if (bounds) {
                this.updateRedrawBounds(bounds);
                this.drawBuffer.push({
                    x: val.x,
                    y: val.y,
                    size: localSize,
                    opacity: localOpacity,
                    x1: bounds.x1,
                    y1: bounds.y1,
                    x2: bounds.x2,
                    y2: bounds.y2,
                    r: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.color.r, this.mixCol.r, this.blending),
                    g: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.color.g, this.mixCol.g, this.blending),
                    b: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.color.b, this.mixCol.b, this.blending)
                });
            }
        };
        if (x === undefined || y === undefined) this.bezierLine.addFinal(bDist, bezierCallback);
        else this.bezierLine.add(x, y, bDist, bezierCallback);
        this.copyFromCanvas(this.redrawBounds);
        this.drawBuffer.forEach((item)=>{
            this.drawDot(item);
        });
        this.drawBuffer = [];
        if (this.blending !== 0) this.localColOld = localColNew;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    getSize() {
        return this.size;
    }
    setSize(s) {
        this.size = s;
    }
    getOpacity() {
        return this.opacity;
    }
    setOpacity(o) {
        this.opacity = o;
    }
    getBlending() {
        return this.blending;
    }
    setBlending(b) {
        this.blending = b;
    }
    setColor(c) {
        this.color = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(c);
    }
    setContext(c, id) {
        this.context = c;
        this.layerId = id;
    }
    setSizePressure(b) {
        this.settingSizePressure = b;
    }
    setOpacityPressure(b) {
        this.settingOpacityPressure = b;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    getIsDrawing() {
        return this.isDrawing;
    }
    setIsTesting(b) {
        this.isTesting = b;
    }
    startLine(x, y, p) {
        const selection = this.klHistory.getComposed().selection.value;
        this.selectionBounds = selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(selection, 'index') : undefined;
        this.mask = selection ? (0, $12e0dda7c62dd122$export$820c5732ce56544)(selection, this.context.canvas.width, this.context.canvas.height) : undefined;
        const totalCells = Math.ceil(this.context.canvas.width / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6)) * Math.ceil(this.context.canvas.height / (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
        this.cells = (0, $fc4403c8ee6a33dc$export$7f1ebd623f131021)(totalCells, undefined);
        this.isDrawing = true;
        p = Math.max(0, Math.min(1, p));
        const localOpacity = this.settingOpacityPressure ? this.opacity * p * p : this.opacity;
        const localSize = this.settingSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size);
        if (this.blending === 0) {
            this.mixCol.r = this.color.r;
            this.mixCol.g = this.color.g;
            this.mixCol.b = this.color.b;
        } else {
            this.copyFromCanvas(this.getDotBounds(x, y, localSize));
            const average = this.getAverage(x, y, this.settingSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size));
            if (average.a === 0) this.blendCol = {
                r: this.color.r,
                g: this.color.g,
                b: this.color.b,
                a: 1 - this.blending
            };
            else this.blendCol = {
                r: average.r,
                g: average.g,
                b: average.b,
                a: average.a
            };
            this.mixCol.r = this.blendCol.r;
            this.mixCol.g = this.blendCol.g;
            this.mixCol.b = this.blendCol.b;
        }
        this.localColOld = {
            r: this.mixCol.r,
            g: this.mixCol.g,
            b: this.mixCol.b,
            a: this.blendCol.a
        };
        this.redrawBounds = undefined;
        this.drawBuffer = [];
        if (this.blending < 1 || this.blendCol.a > 0) {
            const bounds = this.getDotBounds(x, y, localSize);
            if (bounds) {
                this.updateRedrawBounds(bounds);
                this.drawBuffer.push({
                    x: x,
                    y: y,
                    size: localSize,
                    opacity: localOpacity,
                    x1: bounds.x1,
                    y1: bounds.y1,
                    x2: bounds.x2,
                    y2: bounds.y2,
                    r: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.color.r, this.mixCol.r, this.blending),
                    g: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.color.g, this.mixCol.g, this.blending),
                    b: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.color.b, this.mixCol.b, this.blending)
                });
            }
        }
        this.copyFromCanvas(this.redrawBounds);
        this.drawBuffer.forEach((item)=>{
            this.drawDot(item);
        });
        this.drawBuffer = [];
        this.bezierLine = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).BezierLine();
        this.bezierLine.add(x, y, 0, function() {});
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.lastInput);
        if (!this.isTesting) this.drawChangedCells();
    }
    goLine(x, y, p, isCoalesced) {
        if (!this.isDrawing) return;
        this.continueLine(x, y, this.lastInput.pressure, isCoalesced);
        this.lastInput2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.lastInput);
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        if (!this.isTesting) this.drawChangedCells();
    }
    endLine() {
        if (this.bezierLine) this.continueLine(undefined, undefined, this.lastInput.pressure, false);
        this.isDrawing = false;
        this.bezierLine = undefined;
        this.drawChangedCells();
        if (this.cells.some((item)=>item)) {
            let cells = this.cells;
            if (this.selectionBounds) {
                const tilesInSelection = (0, $b37280925142c567$export$2098fe43203ddd32)(this.selectionBounds, this.context.canvas.width, this.context.canvas.height);
                cells = cells.map((cell, index)=>{
                    return tilesInSelection[index] ? cell : undefined;
                });
            }
            this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), cells.map((cell)=>{
                return cell ? (0, $96d94f28640c04c3$export$55941c74c8f934)(cell) : undefined;
            })));
        }
        this.cells = [];
    }
    drawLineSegment(x1, y1, x2, y2) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const steps = Math.ceil(distance / 10);
        this.startLine(x1, y1, 1);
        for(let i = 1; i <= steps; i++){
            const t = i / steps;
            const xi = x1 + dx * t;
            const yi = y1 + dy * t;
            this.goLine(xi, yi, 1, false);
        }
        this.endLine();
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        // testing mode - context only gets updated when line is finished
        this.isTesting = false;
        this.context = {};
        this.layerId = 'NOT_SET';
        this.color = {};
        this.size = 29 // radius - 0.5 - 99999
        ;
        this.opacity = 0.6 // 0-1
        ;
        this.blending = 0.65 // 0-1
        ;
        this.settingLockLayerAlpha = false;
        this.settingSizePressure = true;
        this.settingOpacityPressure = false;
        this.blendCol = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        } // todo docs
        ;
        this.blendMix = 0.45 // todo docs
        ;
        this.mixCol = {
            r: 0,
            g: 0,
            b: 0
        } // todo docs
        ;
        this.localColOld = {} // todo docs
        ;
        this.isDrawing = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        } // todo docs
        ;
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        } // todo docs
        ;
        this.klHistory = {};
        this.cells = [];
        this.drawBuffer = [];
    }
}








const $ec1ed8bc550ccd88$var$sampleCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(32, 32);
const $ec1ed8bc550ccd88$var$sampleCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx($ec1ed8bc550ccd88$var$sampleCanvas);
class $ec1ed8bc550ccd88$export$566f9061f0f5ba33 {
    rand() {
        this.sketchySeed++;
        return Math.sin(6324634.2345 * Math.cos(this.sketchySeed * 5342.3423)) * 0.5 + 0.5;
    }
    // ---- interface ----
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSeed(s) {
        this.sketchySeed = parseInt('' + s);
    }
    getSeed() {
        return parseInt('' + this.sketchySeed);
    }
    getSize() {
        return this.settingSize / 2;
    }
    setColor(c) {
        this.settingColor = c;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    getBlending() {
        return this.settingBlending;
    }
    setBlending(b) {
        this.settingBlending = b;
    }
    setSize(s) {
        this.settingSize = s * 2;
    }
    getScale() {
        return this.settingScale;
    }
    setScale(s) {
        this.settingScale = s;
    }
    setContext(c) {
        this.context = c;
    }
    startLine(x, y, pressure, shift) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedBounds = undefined;
        if (shift && this.lastInput.x) {
            this.inputIsDrawing = true;
            this.endLine();
        } else {
            this.inputIsDrawing = true;
            this.lastX = x;
            this.lastY = y;
            this.lastInput.x = x;
            this.lastInput.y = y;
        }
    }
    goLine(p_x, p_y, pressure, preMixedColor) {
        if (!this.inputIsDrawing || p_x === this.lastInput.x && p_y === this.lastInput.y) return;
        let e, b, a, g;
        const x = parseInt('' + p_x);
        const y = parseInt('' + p_y);
        this.points.push([
            x,
            y
        ]);
        let mixr = this.settingColor.r;
        let mixg = this.settingColor.g;
        let mixb = this.settingColor.b;
        if (preMixedColor) {
            mixr = preMixedColor.r;
            mixg = preMixedColor.g;
            mixb = preMixedColor.b;
        } else {
            if (this.settingBlending !== 0) {
                if (x + 5 >= 0 && y + 5 >= 0 && x - 5 < this.context.canvas.width - 1 && y - 5 < this.context.canvas.height - 1) {
                    mixr = 0;
                    mixg = 0;
                    mixb = 0;
                    const mixX = Math.min(this.context.canvas.width - 1, Math.max(0, x - 5));
                    const mixY = Math.min(this.context.canvas.height - 1, Math.max(0, y - 5));
                    let mixW = Math.min(this.context.canvas.width - 1, Math.max(0, x + 5));
                    let mixH = Math.min(this.context.canvas.height - 1, Math.max(0, y + 5));
                    mixW -= mixX;
                    mixH -= mixY;
                    if (mixW > 0 && mixH > 0) {
                        const imDat = this.context.getImageData(mixX, mixY, mixW, mixH);
                        let countMix = 0;
                        for(let i = 0; i < imDat.data.length; i += 4){
                            mixr += imDat.data[i + 0];
                            mixg += imDat.data[i + 1];
                            mixb += imDat.data[i + 2];
                            countMix++;
                        }
                        mixr /= countMix;
                        mixg /= countMix;
                        mixb /= countMix;
                    }
                    const mixed = this.mixMode[0](new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(mixr, mixg, mixb), this.settingColor);
                    mixr = parseInt('' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.settingColor.r, mixed.r, this.settingBlending));
                    mixg = parseInt('' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.settingColor.g, mixed.g, this.settingBlending));
                    mixb = parseInt('' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.settingColor.b, mixed.b, this.settingBlending));
                }
            }
        }
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.context.strokeStyle = 'rgba(' + mixr + ', ' + mixg + ', ' + mixb + ', ' + this.settingOpacity + ')';
        this.context.lineWidth = this.settingSize;
        this.context.beginPath();
        this.context.moveTo(this.lastX, this.lastY);
        this.context.lineTo(x, y);
        for(e = 0; e < this.points.length; e++){
            b = this.points[e][0] - this.points[this.count][0];
            a = this.points[e][1] - this.points[this.count][1];
            g = b * b + a * a;
            if (g < 4000 * this.settingScale * this.settingScale && this.rand() > g / 2000 / this.settingScale / this.settingScale) {
                this.context.moveTo(this.points[this.count][0] + b * 0.3, this.points[this.count][1] + a * 0.3);
                this.context.lineTo(this.points[e][0] - b * 0.3, this.points[e][1] - a * 0.3);
            }
        }
        this.context.stroke();
        this.context.restore();
        this.count++;
        this.lastX = x;
        this.lastY = y;
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.changedBounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).updateBounds(this.changedBounds, {
            type: 'index',
            x1: Math.floor(x - this.settingSize / 2),
            y1: Math.floor(y - this.settingSize / 2),
            x2: Math.ceil(x + this.settingSize / 2),
            y2: Math.ceil(y + this.settingSize / 2)
        });
    }
    endLine() {
        this.inputIsDrawing = false;
        this.count = 0;
        this.points = [];
        if (this.changedBounds) {
            const boundsWithinSelection = (0, $9414f5ea41e9cf25$export$83720aaadc272d85)(this.changedBounds, this.selectionBounds);
            const layerData = (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(this.context.canvas, boundsWithinSelection);
            if (layerData.some((item)=>item)) this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), layerData));
        }
    }
    //cheap 'n' ugly
    drawLineSegment(x1, y1, x2, y2) {
        this.changedBounds = undefined;
        this.lastInput.x = x2;
        this.lastInput.y = y2;
        if (this.inputIsDrawing || x1 === undefined) return;
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.context.lineWidth = this.settingSize;
        const mixCol = {
            r: this.settingColor.r,
            g: this.settingColor.g,
            b: this.settingColor.b
        };
        if (x1 + 5 >= 0 && y1 + 5 >= 0 && x1 - 5 < this.context.canvas.width - 1 && y1 - 5 < this.context.canvas.height - 1) {
            mixCol.r = 0;
            mixCol.g = 0;
            mixCol.b = 0;
            const mixX = Math.min(this.context.canvas.width - 1, Math.max(0, x1 - 5));
            const mixY = Math.min(this.context.canvas.height - 1, Math.max(0, y1 - 5));
            let mixW = Math.min(this.context.canvas.width - 1, Math.max(0, x1 + 5));
            let mixH = Math.min(this.context.canvas.height - 1, Math.max(0, y1 + 5));
            mixW -= mixX;
            mixH -= mixY;
            if (mixW > 0 && mixH > 0) {
                const w = Math.min($ec1ed8bc550ccd88$var$sampleCanvas.width, mixW);
                const h = Math.min($ec1ed8bc550ccd88$var$sampleCanvas.height, mixH);
                $ec1ed8bc550ccd88$var$sampleCtx.save();
                $ec1ed8bc550ccd88$var$sampleCtx.globalCompositeOperation = 'copy';
                $ec1ed8bc550ccd88$var$sampleCtx.drawImage(this.context.canvas, mixX, mixY, mixW, mixH, 0, 0, w, h);
                $ec1ed8bc550ccd88$var$sampleCtx.restore();
                const imDat = $ec1ed8bc550ccd88$var$sampleCtx.getImageData(mixX, mixY, mixW, mixH);
                let countMix = 0;
                for(let i = 0; i < imDat.data.length; i += 4){
                    mixCol.r += imDat.data[i + 0];
                    mixCol.g += imDat.data[i + 1];
                    mixCol.b += imDat.data[i + 2];
                    countMix++;
                }
                mixCol.r /= countMix;
                mixCol.g /= countMix;
                mixCol.b /= countMix;
            }
        }
        const mixed = this.mixMode[0](new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(mixCol.r, mixCol.g, mixCol.b), this.settingColor);
        mixCol.r = parseInt('' + (this.settingBlending * mixed.r + this.settingColor.r * (1 - this.settingBlending)));
        mixCol.g = parseInt('' + (this.settingBlending * mixed.g + this.settingColor.g * (1 - this.settingBlending)));
        mixCol.b = parseInt('' + (this.settingBlending * mixed.b + this.settingColor.b * (1 - this.settingBlending)));
        this.context.strokeStyle = 'rgba(' + mixCol.r + ', ' + mixCol.g + ', ' + mixCol.b + ', ' + this.settingOpacity + ')';
        this.context.beginPath();
        this.context.moveTo(x1, y1);
        this.context.lineTo(x2, y2);
        this.context.stroke();
        this.context.strokeStyle = 'rgba(' + mixCol.r + ', ' + mixCol.g + ', ' + mixCol.b + ', ' + this.settingOpacity + ')';
        this.context.restore();
        this.changedBounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).updateBounds(this.changedBounds, {
            type: 'index',
            x1: Math.floor(x1 - this.settingSize / 2),
            y1: Math.floor(y1 - this.settingSize / 2),
            x2: Math.ceil(x1 + this.settingSize / 2),
            y2: Math.ceil(y1 + this.settingSize / 2)
        });
        this.changedBounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).updateBounds(this.changedBounds, {
            type: 'index',
            x1: Math.floor(x2 - this.settingSize / 2),
            y1: Math.floor(y2 - this.settingSize / 2),
            x2: Math.ceil(x2 + this.settingSize / 2),
            y2: Math.ceil(y2 + this.settingSize / 2)
        });
        if (this.changedBounds) {
            const boundsWithinSelection = (0, $9414f5ea41e9cf25$export$83720aaadc272d85)(this.changedBounds, this.selectionBounds);
            const layerData = (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(this.context.canvas, boundsWithinSelection);
            if (layerData.some((item)=>item)) this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), layerData));
        }
    }
    isDrawing() {
        return this.inputIsDrawing;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.context = {};
        this.settingColor = {};
        this.settingSize = 1;
        this.settingOpacity = 0.2;
        this.settingBlending = 0.5;
        this.settingScale = 1;
        this.lastX = 0;
        this.lastY = 0;
        this.inputIsDrawing = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.klHistory = {};
        this.sketchySeed = 0;
        this.points = [] // x y
        ;
        this.count = 0;
        this.mixMode = [
            (c1)=>{
                return c1;
            },
            (c1, c2)=>{
                // why
                const result = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(c1.r, c1.g, c1.b);
                result.r *= c2.r / 255;
                result.g *= c2.g / 255;
                result.b *= c2.b / 255;
                return result;
            }
        ];
    }
}











class $f01b5e3bd1be2f34$export$4de5ef8eecde6f12 {
    updateChangedTiles(bounds) {
        // fix bounds
        bounds = {
            type: 'index',
            x1: Math.min(bounds.x1, bounds.x2),
            y1: Math.min(bounds.y1, bounds.y2),
            x2: Math.max(bounds.x1, bounds.x2),
            y2: Math.max(bounds.y1, bounds.y2)
        };
        const boundsWithinSelection = (0, $9414f5ea41e9cf25$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        const changedTiles = (0, $b37280925142c567$export$2098fe43203ddd32)(boundsWithinSelection, this.context.canvas.width, this.context.canvas.height);
        this.redrawBounds = this.redrawBounds ? (0, $9414f5ea41e9cf25$export$f4467a4f41373bc7)(this.redrawBounds, boundsWithinSelection) : boundsWithinSelection;
        this.historyTiles = (0, $b37280925142c567$export$1774f90c6da5013c)(this.historyTiles, changedTiles);
    }
    initClone() {
        this.canvasClone = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.context.canvas.width, this.context.canvas.height);
        this.ctxClone = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.canvasClone);
        this.ctxClone.drawImage(this.context.canvas, 0, 0);
    }
    freeClone() {
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(this.canvasClone);
        this.ctxClone = {};
    }
    redrawToCanvas() {
        if (!this.redrawBounds) return;
        const boundsRect = (0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)(this.redrawBounds);
        this.context.save();
        this.context.clearRect(boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height);
        this.context.drawImage(this.canvasClone, boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height, boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height);
        this.context.restore();
        this.redrawBounds = undefined;
    }
    updateDither() {
        this.ditherCtx.clearRect(0, 0, 4, 4);
        this.ditherCtx.fillStyle = this.settingIsEraser ? `rgb(${0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28},${0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28},${0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28})` : this.settingColorStr;
        for(let i = 0; i < Math.max(1, Math.round(this.settingOpacity * this.ditherArr.length)); i++)this.ditherCtx.fillRect(this.ditherArr[i][0], this.ditherArr[i][1], 1, 1);
        this.ditherPattern = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(// InvalidStateError: The object is in an invalid state.
        this.context.createPattern(this.ditherCanvas, 'repeat'));
    }
    /**
     * Tests p1->p2 or p3->p4 deviate in their direction more than max, compared to p1->p4
     */ cubicCurveOverThreshold(p1, p2, p3, p4, maxAngleRad) {
        const d = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.nor({
            x: p4.x - p1.x,
            y: p4.y - p1.y
        });
        const d2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.nor({
            x: p2.x - p1.x,
            y: p2.y - p1.y
        });
        const d3 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.nor({
            x: p4.x - p3.x,
            y: p4.y - p3.y
        });
        // const a2 = Math.abs(BB.Vec2.angle(d, d2) % Math.PI) / Math.PI * 180;
        // const a3 = Math.abs(BB.Vec2.angle(d, d3) % Math.PI) / Math.PI * 180;
        return Math.max((0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.dist(d, d2), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.dist(d, d3)) > maxAngleRad;
    }
    plotCubicBezierLine(p1, p2, p3, p4) {
        const isOverThreshold = this.cubicCurveOverThreshold(p1, p2, p3, p4, 0.1);
        p1.x = Math.floor(p1.x);
        p1.y = Math.floor(p1.y);
        p4.x = Math.floor(p4.x);
        p4.y = Math.floor(p4.y);
        const dist = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).dist(p1.x, p1.y, p4.x, p4.y);
        if (!isOverThreshold || dist < 7) {
            this.plotLine(p1.x, p1.y, p4.x, p4.y, true);
            return;
        }
        const n = Math.max(2, Math.round(dist / 4));
        const pointArr = [];
        for(let i = 0; i <= n; i++){
            const t = i / n;
            const a = Math.pow(1 - t, 3);
            const b = 3 * t * Math.pow(1 - t, 2);
            const c = 3 * Math.pow(t, 2) * (1 - t);
            const d = Math.pow(t, 3);
            pointArr.push({
                x: a * p1.x + b * p2.x + c * p3.x + d * p4.x,
                y: a * p1.y + b * p2.y + c * p3.y + d * p4.y
            });
        }
        for(let i = 0; i < n; i++)this.plotLine(Math.round(pointArr[i].x), Math.round(pointArr[i].y), Math.round(pointArr[i + 1].x), Math.round(pointArr[i + 1].y), true);
    }
    drawDot(x, y, size, opacity) {
        const rect = {
            x: Math.round(x + -size),
            y: Math.round(y + -size),
            width: Math.round(size * 2),
            height: Math.round(size * 2)
        };
        this.updateChangedTiles((0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)(rect, 'index'));
        this.ctxClone.save();
        if (this.settingIsEraser) {
            this.ctxClone.fillStyle = this.settingUseDither ? this.ditherPattern : '#fff';
            if (this.settingLockLayerAlpha) this.ctxClone.globalCompositeOperation = 'source-atop';
            else this.ctxClone.globalCompositeOperation = 'destination-out';
        } else {
            this.ctxClone.fillStyle = this.settingUseDither ? this.ditherPattern : this.settingColorStr;
            if (this.settingLockLayerAlpha) this.ctxClone.globalCompositeOperation = 'source-atop';
        }
        this.ctxClone.globalAlpha = this.settingUseDither ? 1 : opacity;
        this.ctxClone.fillRect(rect.x, rect.y, rect.width, rect.height);
        this.ctxClone.restore();
    }
    continueLine(x, y, size, pressure) {
        if (this.bezierLine === null) {
            this.bezierLine = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).BezierLine();
            this.bezierLine.add(this.lastInput.x, this.lastInput.y, 0, ()=>{});
        }
        this.ctxClone.save();
        this.selectionPath && this.ctxClone.clip(this.selectionPath);
        const dotCallback = (val)=>{
            const localPressure = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.lastInput2.pressure, pressure, val.t);
            const localOpacity = this.settingOpacity * (this.settingHasOpacityPressure ? localPressure * localPressure : 1);
            const localSize = Math.max(0.5, this.settingSize * (this.settingHasSizePressure ? localPressure : 1));
            this.drawDot(val.x, val.y, localSize, localOpacity);
        };
        const controlCallback = (controlObj)=>{
            this.plotCubicBezierLine(controlObj.p1, controlObj.p2, controlObj.p3, controlObj.p4);
        };
        if (Math.round(this.settingSize * 2) === 1) {
            this.bresenheimPath = new Path2D();
            if (x === null || y === null) this.bezierLine.addFinal(4, undefined, controlCallback);
            else this.bezierLine.add(x, y, 4, undefined, controlCallback);
            if (this.settingIsEraser) {
                this.ctxClone.fillStyle = this.settingUseDither ? this.ditherPattern : '#fff';
                if (this.settingLockLayerAlpha) this.ctxClone.globalCompositeOperation = 'source-atop';
                else this.ctxClone.globalCompositeOperation = 'destination-out';
            } else {
                this.ctxClone.fillStyle = this.settingUseDither ? this.ditherPattern : this.settingColorStr;
                if (this.settingLockLayerAlpha) this.ctxClone.globalCompositeOperation = 'source-atop';
            }
            this.ctxClone.globalAlpha = this.settingUseDither ? 1 : this.settingOpacity;
            this.ctxClone.fill(this.bresenheimPath);
            this.bresenheimPath = undefined;
        } else {
            const localSpacing = size * this.settingSpacing;
            if (x === null || y === null) this.bezierLine.addFinal(localSpacing, dotCallback);
            else this.bezierLine.add(x, y, localSpacing, dotCallback);
        }
        this.ctxClone.restore();
    }
    /**
     * bresenheim line drawing
     */ plotLine(x0, y0, x1, y1, skipFirst) {
        this.updateChangedTiles((0, $9414f5ea41e9cf25$export$5aa63862e8b9c037)({
            type: 'index',
            x1: x0,
            y1: y0,
            x2: x1,
            y2: y1
        }));
        x0 = Math.floor(x0);
        y0 = Math.floor(y0);
        x1 = Math.floor(x1);
        y1 = Math.floor(y1);
        const dX = Math.abs(x1 - x0);
        const sX = x0 < x1 ? 1 : -1;
        const dY = -Math.abs(y1 - y0);
        const sY = y0 < y1 ? 1 : -1;
        let err = dX + dY;
        while(true){
            var _this_bresenheimPath;
            if (skipFirst) skipFirst = false;
            else (_this_bresenheimPath = this.bresenheimPath) === null || _this_bresenheimPath === void 0 ? void 0 : _this_bresenheimPath.rect(x0, y0, 1, 1);
            if (x0 === x1 && y0 === y1) break;
            const e2 = 2 * err;
            if (e2 >= dY) {
                err += dY;
                x0 += sX;
            }
            if (e2 <= dX) {
                err += dX;
                y0 += sY;
            }
        }
    }
    // ---- interface ----
    startLine(x, y, p) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.historyTiles = [];
        this.redrawBounds = undefined;
        if (this.settingUseDither) this.updateDither();
        this.initClone();
        p = Math.max(0, Math.min(1, p));
        const localOpacity = this.settingHasOpacityPressure ? this.settingOpacity * p * p : this.settingOpacity;
        const localSize = this.settingHasSizePressure ? Math.max(0.5, p * this.settingSize) : Math.max(0.5, this.settingSize);
        this.inputIsDrawing = true;
        this.ctxClone.save();
        this.selectionPath && this.ctxClone.clip(this.selectionPath);
        this.drawDot(x, y, localSize, localOpacity);
        this.ctxClone.restore();
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.lastInput);
        this.redrawToCanvas();
    }
    goLine(x, y, p) {
        if (!this.inputIsDrawing) return;
        //debug
        //drawDot(x, y, 1, 0.5);
        const pressure = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(p, 0, 1);
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.continueLine(x, y, localSize, this.lastInput.pressure);
        this.lastInput2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.lastInput);
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = pressure;
        this.redrawToCanvas();
    }
    endLine() {
        if (!this.inputIsDrawing) return;
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.continueLine(null, null, localSize, this.lastInput.pressure);
        //debug
        //drawDot(lastInput.x, lastInput.y, 3, 1);
        //drawDot(x, y, 10, 0.1);
        this.inputIsDrawing = false;
        this.bezierLine = null;
        this.redrawToCanvas();
        if (this.historyTiles.some((item)=>item)) this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $a262f7e0a9f5e4af$export$6706c882ea9c3dbd)(this.canvasClone, this.historyTiles)));
        this.freeClone();
    }
    drawLineSegment(x1, y1, x2, y2) {
        this.startLine(x1, y1, 1);
        this.goLine(x2, y2, 1);
        this.endLine();
    }
    //IS
    isDrawing() {
        return this.inputIsDrawing;
    }
    //SET
    setColor(c) {
        if (this.settingColor === c) return;
        this.settingColor = c;
        this.settingColorStr = 'rgb(' + this.settingColor.r + ',' + this.settingColor.g + ',' + this.settingColor.b + ')';
    }
    setContext(c) {
        this.context = c;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSize(s) {
        this.settingSize = Math.round(s * 2) / 2;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    setSpacing(s) {
        this.settingSpacing = s;
    }
    sizePressure(b) {
        this.settingHasSizePressure = b;
    }
    opacityPressure(b) {
        this.settingHasOpacityPressure = b;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    setIsEraser(b) {
        this.settingIsEraser = b;
    }
    setUseDither(b) {
        this.settingUseDither = b;
    }
    //GET
    getSpacing() {
        return this.settingSpacing;
    }
    getSize() {
        return this.settingSize;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    getIsEraser() {
        return this.settingIsEraser;
    }
    getUseDither() {
        return this.settingUseDither;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.klHistory = {};
        this.context = {};
        this.settingHasSizePressure = true;
        this.settingHasOpacityPressure = false;
        this.settingSize = 0.5;
        this.settingSpacing = 0.9;
        this.settingOpacity = 1;
        this.settingColor = {};
        this.settingColorStr = '';
        this.settingLockLayerAlpha = false;
        this.settingIsEraser = false;
        this.settingUseDither = true;
        this.inputIsDrawing = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.bezierLine = null;
        this.ditherArr = [
            [
                3,
                2
            ],
            [
                1,
                0
            ],
            [
                3,
                0
            ],
            [
                1,
                2
            ],
            [
                2,
                1
            ],
            [
                0,
                3
            ],
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                2,
                0
            ],
            [
                0,
                2
            ],
            [
                0,
                0
            ],
            [
                2,
                2
            ],
            [
                1,
                1
            ],
            [
                3,
                3
            ],
            [
                3,
                1
            ],
            [
                1,
                3
            ]
        ];
        this.ditherPattern = {};
        /*
        Draw brush into fresh canvas for each line,
        because otherwise chrome slows the main canvas down.
        Multiple reads on a canvas -> canvas moved to CPU. (my guess)
     */ this.canvasClone = {};
        this.ctxClone = {};
        // changed tiles that will be pushed to history
        this.historyTiles = [];
        this.ditherCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(4, 4);
        this.ditherCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.ditherCanvas);
    }
}










class $6debbe598e970932$export$fe52c90afd1cf5ba {
    updateChangedTiles(bounds) {
        const boundsWithinSelection = (0, $9414f5ea41e9cf25$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        this.changedTiles = (0, $b37280925142c567$export$1774f90c6da5013c)(this.changedTiles, (0, $b37280925142c567$export$2098fe43203ddd32)(bounds, this.context.canvas.width, this.context.canvas.height));
    }
    drawDot(x, y, size, opacity) {
        this.context.save();
        if (this.isBaseLayer) {
            if (this.isTransparentBG) this.context.globalCompositeOperation = 'destination-out';
            else this.context.globalCompositeOperation = 'source-atop';
        } else this.context.globalCompositeOperation = 'destination-out';
        const radgrad = this.context.createRadialGradient(size, size, 0, size, size, size);
        let sharpness = Math.pow(opacity, 2);
        sharpness = Math.max(0, Math.min((size - 1) / size, sharpness));
        const oFac = Math.max(0, Math.min(1, opacity));
        const localOpacity = 2 * oFac - oFac * oFac;
        radgrad.addColorStop(sharpness, `rgba(${(0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28)}, ${(0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28)}, ${(0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28)}, ` + localOpacity + ')');
        radgrad.addColorStop(1, `rgba(${(0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28)}, ${(0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28)}, ${(0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28)}, 0)`);
        this.context.fillStyle = radgrad;
        this.context.translate(x - size, y - size);
        this.context.fillRect(0, 0, size * 2, size * 2);
        this.context.restore();
        this.updateChangedTiles({
            type: 'index',
            x1: Math.floor(x - size),
            y1: Math.floor(y - size),
            x2: Math.ceil(x + size - 1),
            y2: Math.ceil(y + size - 1)
        });
    }
    continueLine(x, y, p) {
        p = Math.max(0, Math.min(1, p));
        let localPressure;
        let localOpacity;
        let localSize = this.useSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size);
        const bdist = Math.max(1, Math.max(0.5, 1 - this.opacity) * localSize * this.spacing);
        const bezierCallback = (val)=>{
            const factor = val.t;
            localPressure = this.lastInput2.pressure * (1 - factor) + p * factor;
            localOpacity = this.useOpacityPressure ? this.opacity * localPressure * localPressure : this.opacity;
            localSize = this.useSizePressure ? Math.max(0.1, localPressure * this.size) : Math.max(0.1, this.size);
            this.drawDot(val.x, val.y, localSize, localOpacity);
        };
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        if (x === undefined || y === undefined) this.bezierLine.addFinal(bdist, bezierCallback);
        else this.bezierLine.add(x, y, bdist, bezierCallback);
        this.context.restore();
    }
    // ---- interface ----
    startLine(x, y, p) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedTiles = [];
        this.isBaseLayer = 0 === this.layer.index;
        p = Math.max(0, Math.min(1, p));
        const localOpacity = this.useOpacityPressure ? this.opacity * p * p : this.opacity;
        const localSize = this.useSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size);
        this.started = true;
        if (localSize > 1) {
            this.context.save();
            this.selectionPath && this.context.clip(this.selectionPath);
            this.drawDot(x, y, localSize, localOpacity);
            this.context.restore();
        }
        this.lastDot = localSize * this.spacing;
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.lastInput);
        this.bezierLine = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).BezierLine();
        this.bezierLine.add(x, y, 0, ()=>undefined);
    }
    goLine(x, y, p) {
        if (!this.started) return;
        this.continueLine(x, y, this.lastInput.pressure);
        this.lastInput2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.lastInput);
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
    }
    endLine() {
        if (this.bezierLine) this.continueLine(undefined, undefined, this.lastInput.pressure);
        this.started = false;
        this.bezierLine = undefined;
        if (this.changedTiles.some((item)=>item)) this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $a262f7e0a9f5e4af$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
    }
    drawLineSegment(x1, y1, x2, y2) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedTiles = [];
        this.isBaseLayer = 0 === this.layer.index;
        this.lastInput.x = x2;
        this.lastInput.y = y2;
        if (this.started || x1 === undefined) return;
        const mouseDist = Math.sqrt(Math.pow(x2 - x1, 2.0) + Math.pow(y2 - y1, 2.0));
        const eX = (x2 - x1) / mouseDist;
        const eY = (y2 - y1) / mouseDist;
        let loopDist;
        const bdist = Math.max(1, Math.max(0.5, 1 - this.opacity) * this.size * this.spacing);
        this.lastDot = 0;
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        for(loopDist = this.lastDot; loopDist <= mouseDist; loopDist += bdist)this.drawDot(x1 + eX * loopDist, y1 + eY * loopDist, this.size, this.opacity);
        this.context.restore();
        if (this.changedTiles.some((item)=>item)) this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $a262f7e0a9f5e4af$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
    }
    //IS
    isDrawing() {
        return this.started;
    }
    //SET
    setLayer(layer) {
        this.layer = layer;
        this.context = layer.context;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSize(s) {
        this.size = s;
    }
    setOpacity(o) {
        this.opacity = o;
    }
    sizePressure(b) {
        this.useSizePressure = b;
    }
    opacityPressure(b) {
        this.useOpacityPressure = b;
    }
    setTransparentBG(b) {
        this.isTransparentBG = b;
    }
    //GET
    getSize() {
        return this.size;
    }
    getOpacity() {
        return this.opacity;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.size = 30;
        this.spacing = 0.4;
        this.opacity = 1;
        this.useSizePressure = true;
        this.useOpacityPressure = false;
        this.isTransparentBG = false;
        this.klHistory = {};
        this.isBaseLayer = false;
        this.layer = {};
        this.context = {};
        this.started = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.changedTiles = [];
    }
}









// let statCount = 1;
// let statAcc = 0;
// stats on win10, chrome, size 100, opacity 80, smudge()
// unoptimized: 1 ms
// minimal: 0.09 ms
// minimal + circle: 0.5ms
// minimal + circle + ix, iy: 0.23ms
// unoptimized + ix, iy: 0.64 ms
// unoptimized + ix, iy + sans rounding: 0.61 ms
// ix, iy + sans rounding + sans random: 0.32ms
// ix, iy + sans rounding + fast random: 0.46 ms
// ix, iy + sans rounding + fast random + offset const: 0.48 ms
const $baef4a032d46c3b8$var$CELL_SIZE = 256;
/**
 * determine bounds of smudge
 * @param imWidth
 * @param imHeight
 * @param aP
 * @param bP
 * @param size
 */ function $baef4a032d46c3b8$var$prepSmudge(imWidth, imHeight, aP, bP, size) {
    if (aP.x === bP.x && aP.y === bP.y) return null;
    aP = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(aP);
    bP = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(bP);
    size = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(size);
    // corner behavior
    // cut down rectangles, if a or b go outside
    // i.e. if user drags partially or fully outside the canvas
    {
        let top = 0;
        let right = 0;
        let bottom = 0;
        let left = 0;
        if (aP.x < 0) left = -aP.x;
        if (aP.y < 0) top = -aP.y;
        if (bP.x < 0) left = Math.max(left, -bP.x);
        if (bP.y < 0) top = Math.max(top, -bP.y);
        if (aP.x + size.w > imWidth) right = aP.x + size.w - imWidth;
        if (aP.y + size.h > imHeight) bottom = aP.y + size.h - imHeight;
        if (bP.x + size.w > imWidth) right = Math.max(right, bP.x + size.w - imWidth);
        if (bP.y + size.h > imHeight) bottom = Math.max(bottom, bP.y + size.h - imHeight);
        aP.x += left;
        bP.x += left;
        aP.y += top;
        bP.y += top;
        size.w = size.w - left - right;
        size.h = size.h - top - bottom;
        if (size.w <= 0 || size.h <= 0) return null;
    }
    return {
        aP: {
            x: aP.x,
            y: aP.y
        },
        bP: {
            x: bP.x,
            y: bP.y
        },
        size: {
            w: size.w,
            h: size.h
        }
    };
}
/**
 * Pixel operations that do the smudging via ImageData
 * @param imageData
 * @param p
 */ function $baef4a032d46c3b8$var$smudge(imageData, mask, p) {
    p = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(p);
    const cSize = p.brush.size;
    const cX = p.brush.center.x;
    const cY = p.brush.center.y;
    /*if (statCount % 1000 === 0) {
        console.log(statAcc / 1000);
        statAcc = 0;
    }
    let start = performance.now();*/ // determine offset
    const aIndex = p.aP.y * imageData.width + p.aP.x;
    const bIndex = p.bP.y * imageData.width + p.bP.x;
    const offset = (bIndex - aIndex) * 4;
    // array with random numbers. faster than Math.random()
    let randI = 0;
    const randLen = cSize > 30 ? 1024 : 512; // lower lengths lead to noticeable patterns
    const randArr = [];
    for(let i = 0; i < randLen; i++)randArr[i] = (Math.random() - 0.5) / 1.001 + 0.5;
    const softnessPx = Math.max(3, Math.min(8, p.brush.size - 8));
    const pixel = (ai, bi, ix, iy)=>{
        const dist = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).dist(cX, cY, ix, iy);
        const fac = 1 - p.brush.opacity * (1 - (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)((dist - (cSize - softnessPx)) / softnessPx, 0, 1));
        if (fac === 1) return;
        if (mask && (mask[ai / 4] === 0 || mask[bi / 4] === 0)) return;
        if (!imageData.data[ai + 3]) ;
        else if (!imageData.data[bi + 3]) {
            // don't mix if target fully transparent. pixel might have a strange color.
            imageData.data[bi] = imageData.data[ai];
            imageData.data[bi + 1] = imageData.data[ai + 1];
            imageData.data[bi + 2] = imageData.data[ai + 2];
        } else {
            // consider alpha ratio. If a has lower alpha than b, then b should be stronger, and vice versa
            // not totally accurate. TODO same compositing as blend brush
            let fac2;
            if (imageData.data[ai + 3] < imageData.data[bi + 3]) fac2 = 1 - imageData.data[ai + 3] / imageData.data[bi + 3] * (1 - fac);
            else fac2 = imageData.data[bi + 3] / imageData.data[ai + 3] * fac;
            // ImageData's Uint8ClampedArray rounds -> 0.5 becomes 1. But not in Safari, so needs to be done manually
            // Offset mixed color by random number noise (-0.5, 0.5), so it doesn't get stuck while mixing.
            // No +0.5, because it cancels out with rand.
            imageData.data[bi] = Math.floor((0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(imageData.data[ai], imageData.data[bi + 0], fac2) + randArr[randI]);
            imageData.data[bi + 1] = Math.floor((0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(imageData.data[ai + 1], imageData.data[bi + 1], fac2) + randArr[randI]);
            imageData.data[bi + 2] = Math.floor((0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(imageData.data[ai + 2], imageData.data[bi + 2], fac2) + randArr[randI]);
            randI = (randI + 1) % randLen;
        }
        // Always mix alpha. unless alpha lock
        if (!p.brush.alphaLock) imageData.data[bi + 3] = Math.floor((0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(imageData.data[ai + 3], imageData.data[bi + 3], fac) + 0.5);
    };
    const bx1 = p.bP.x * 4;
    const bx2 = bx1 + (p.size.w - 1) * 4;
    // transfer of pixels depends on direction of smudging if there is overlap
    if (p.aP.y < p.bP.y) for(let y = p.size.h - 1, iy = p.bP.y + p.size.h - 1; y >= 0; y--, iy--){
        const yStart = (y + p.bP.y) * imageData.width * 4;
        for(let x = bx2 + yStart, x2 = bx2 + yStart - offset, ix = p.bP.x + p.size.w - 1; x >= bx1 + yStart; x -= 4, x2 -= 4, ix--)pixel(x2, x, ix, iy);
    }
    else if (p.aP.y > p.bP.y) for(let y = 0, iy = p.bP.y; y < p.size.h; y++, iy++){
        const yStart = (y + p.bP.y) * imageData.width * 4;
        for(let x = bx2 + yStart, x2 = bx2 + yStart - offset, ix = p.bP.x + p.size.w - 1; x >= bx1 + yStart; x -= 4, x2 -= 4, ix--)pixel(x2, x, ix, iy);
    }
    else {
        if (p.aP.x < p.bP.x) for(let y = p.size.h - 1, iy = p.bP.y + p.size.h - 1; y >= 0; y--, iy--){
            const yStart = (y + p.bP.y) * imageData.width * 4;
            for(let x = bx2 + yStart, x2 = bx2 + yStart - offset, ix = p.bP.x + p.size.w - 1; x >= bx1 + yStart; x -= 4, x2 -= 4, ix--)pixel(x2, x, ix, iy);
        }
        else for(let y = 0, iy = p.bP.y; y < p.size.h; y++, iy++){
            const yStart = (y + p.bP.y) * imageData.width * 4;
            for(let x = bx1 + yStart, x2 = bx1 + yStart - offset, ix = p.bP.x; x < bx2 + yStart; x += 4, x2 += 4, ix++)pixel(x2, x, ix, iy);
        }
    }
//statCount++;
//statAcc += performance.now() - start;
}
class $baef4a032d46c3b8$export$c9f800961903deab {
    // workaround for https://github.com/microsoft/TypeScript/issues/41654
    resetRedrawBounds() {
        this.redrawBounds = undefined;
    }
    updateRedrawBounds(bounds) {
        const boundsWithinSelection = (0, $9414f5ea41e9cf25$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        this.redrawBounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).updateBounds(this.redrawBounds, boundsWithinSelection);
    }
    updateCompleteRedrawBounds(x1, y1, x2, y2) {
        this.completeRedrawBounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).updateBounds(this.completeRedrawBounds, {
            type: 'index',
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        });
    }
    /**
     * update copyImageData. copy over new regions if needed
     */ copyFromCanvas() {
        const touchedCells = this.copiedCells.map(()=>false);
        const bounds = [];
        const cellsW = Math.ceil(this.copyImageData.width / $baef4a032d46c3b8$var$CELL_SIZE);
        if (!this.redrawBounds) return;
        bounds.push({
            type: 'index',
            x1: Math.floor(this.redrawBounds.x1 / $baef4a032d46c3b8$var$CELL_SIZE),
            y1: Math.floor(this.redrawBounds.y1 / $baef4a032d46c3b8$var$CELL_SIZE),
            x2: Math.floor(this.redrawBounds.x2 / $baef4a032d46c3b8$var$CELL_SIZE),
            y2: Math.floor(this.redrawBounds.y2 / $baef4a032d46c3b8$var$CELL_SIZE)
        });
        bounds.forEach((item)=>{
            for(let i = item.x1; i <= item.x2; i++)for(let e = item.y1; e <= item.y2; e++)touchedCells[e * cellsW + i] = true;
        });
        touchedCells.forEach((item, i)=>{
            if (!item || this.copiedCells[i]) // not touched, or already copied
            return;
            this.copiedCells[i] = true;
            const x = i % cellsW;
            const y = Math.floor(i / cellsW);
            const w = (Math.min(x * $baef4a032d46c3b8$var$CELL_SIZE + $baef4a032d46c3b8$var$CELL_SIZE, this.copyImageData.width) - 1) % $baef4a032d46c3b8$var$CELL_SIZE + 1;
            const h = (Math.min(y * $baef4a032d46c3b8$var$CELL_SIZE + $baef4a032d46c3b8$var$CELL_SIZE, this.copyImageData.height) - 1) % $baef4a032d46c3b8$var$CELL_SIZE + 1;
            // temp canvas to prevent main canvas from getting slowed down in chrome
            const tmpCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
            const tmpCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(tmpCanvas);
            tmpCtx.drawImage(this.context.canvas, -x * $baef4a032d46c3b8$var$CELL_SIZE, -y * $baef4a032d46c3b8$var$CELL_SIZE);
            const data = tmpCtx.getImageData(0, 0, w, h);
            for(let i = 0; i < h; i++)for(let e = 0, e2 = i * w * 4, e3 = ((y * $baef4a032d46c3b8$var$CELL_SIZE + i) * this.copyImageData.width + x * $baef4a032d46c3b8$var$CELL_SIZE) * 4; e < w; e++, e2 += 4, e3 += 4){
                this.copyImageData.data[e3] = data.data[e2];
                this.copyImageData.data[e3 + 1] = data.data[e2 + 1];
                this.copyImageData.data[e3 + 2] = data.data[e2 + 2];
                this.copyImageData.data[e3 + 3] = data.data[e2 + 3];
            }
        });
    }
    /**
     * fill drawBuffer with params about to be drawn
     * @param x
     * @param y
     * @param size
     * @param opacity
     */ prepDot(x, y, size, opacity) {
        if (!this.lastDot) {
            this.lastDot = {
                x: x,
                y: y
            };
            return;
        }
        size = Math.round(size);
        const w = Math.round(size * 2);
        const h = Math.round(size * 2);
        const bounds = $baef4a032d46c3b8$var$prepSmudge(this.copyImageData.width, this.copyImageData.height, {
            x: Math.round(this.lastDot.x - size),
            y: Math.round(this.lastDot.y - size)
        }, {
            x: Math.round(x - size),
            y: Math.round(y - size)
        }, {
            w: w,
            h: h
        });
        if (bounds) {
            const params = {
                aP: bounds.aP,
                bP: bounds.bP,
                size: bounds.size,
                brush: {
                    center: {
                        x: x,
                        y: y
                    },
                    size: size,
                    opacity: opacity,
                    alphaLock: this.settingLockLayerAlpha
                }
            };
            this.updateRedrawBounds({
                type: 'index',
                x1: params.bP.x,
                y1: params.bP.y,
                x2: params.bP.x + params.brush.size * 2 - 1,
                y2: params.bP.y + params.brush.size * 2 - 1
            });
            this.drawBuffer.push(params);
        }
        this.lastDot = {
            x: x,
            y: y
        };
    }
    continueLine(x, y, size, pressure) {
        this.drawBuffer = [];
        if (!this.bezierLine) {
            this.bezierLine = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).BezierLine();
            this.bezierLine.add(this.lastInput.x, this.lastInput.y, 0, function() {});
        }
        const drawArr = []; //draw instructions. will be all drawn at once
        const dotCallback = (val)=>{
            const localPressure = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.lastInput2.pressure, pressure, val.t);
            const localOpacity = this.settingOpacity * (this.settingHasOpacityPressure ? localPressure * localPressure : 1);
            const localSize = Math.max(0.1, this.settingSize * (this.settingHasSizePressure ? localPressure : 1));
            drawArr.push([
                val.x,
                val.y,
                localSize,
                localOpacity
            ]); //, val.angle]);
        };
        const localSpacing = size * this.settingSpacing / 3;
        if (x === undefined || y === undefined) this.bezierLine.addFinal(localSpacing, dotCallback);
        else this.bezierLine.add(x, y, localSpacing, dotCallback);
        // execute draw instructions
        for(let i = 0; i < drawArr.length; i++){
            const item = drawArr[i];
            this.prepDot(item[0], item[1], item[2], item[3]);
        }
        this.copyFromCanvas();
        for(let i = 0; i < this.drawBuffer.length; i++)$baef4a032d46c3b8$var$smudge(this.copyImageData, this.mask, this.drawBuffer[i]);
    }
    startLine(x, y, p) {
        const selection = this.klHistory.getComposed().selection.value;
        this.selectionBounds = selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(selection, 'index') : undefined;
        this.mask = selection ? (0, $12e0dda7c62dd122$export$820c5732ce56544)(selection, this.context.canvas.width, this.context.canvas.height) : undefined;
        p = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(p, 0, 1);
        const localOpacity = this.settingHasOpacityPressure ? this.settingOpacity * p * p : this.settingOpacity;
        const localSize = this.settingHasSizePressure ? Math.max(0.1, p * this.settingSize) : Math.max(0.1, this.settingSize);
        this.lastDot = undefined;
        this.isDrawing = true;
        this.copyImageData = new ImageData(this.context.canvas.width, this.context.canvas.height);
        const totalCells = Math.ceil(this.context.canvas.width / $baef4a032d46c3b8$var$CELL_SIZE) * Math.ceil(this.context.canvas.height / $baef4a032d46c3b8$var$CELL_SIZE);
        this.copiedCells = (0, $fc4403c8ee6a33dc$export$7f1ebd623f131021)(totalCells, false);
        this.prepDot(x, y, localSize, localOpacity);
        this.lineToolLastDot = localSize * this.settingSpacing;
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2.pressure = p;
        this.completeRedrawBounds = undefined;
    }
    goLine(x, y, p) {
        if (!this.isDrawing) return;
        this.resetRedrawBounds();
        const pressure = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(p, 0, 1);
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.continueLine(x, y, localSize, this.lastInput.pressure);
        if (this.redrawBounds) {
            this.context.putImageData(this.copyImageData, 0, 0, this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2 - this.redrawBounds.x1, this.redrawBounds.y2 - this.redrawBounds.y1);
            this.updateCompleteRedrawBounds(this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2, this.redrawBounds.y2);
        }
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput2.pressure = this.lastInput.pressure;
        this.lastInput.pressure = pressure;
    }
    endLine() {
        this.resetRedrawBounds();
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.context.save();
        this.continueLine(undefined, undefined, localSize, this.lastInput.pressure);
        this.context.restore();
        this.isDrawing = false;
        this.bezierLine = undefined;
        if (this.redrawBounds) {
            this.context.putImageData(this.copyImageData, 0, 0, this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2 - this.redrawBounds.x1, this.redrawBounds.y2 - this.redrawBounds.y1);
            this.updateCompleteRedrawBounds(this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2, this.redrawBounds.y2);
        }
        if (this.completeRedrawBounds) this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(this.context.canvas, this.completeRedrawBounds)));
        this.copyImageData = {};
    }
    drawImage(im, x, y) {
        if (im instanceof ImageData) this.context.putImageData(im, x, y);
        else {
            this.context.clearRect(x, y, im.width, im.height);
            this.context.drawImage(im, x, y);
        }
    }
    drawLineSegment(x1, y1, x2, y2) {
        return;
    /*
        // todo
        lastInput.x = x2;
        lastInput.y = y2;
        lastInput.pressure = 1;

        if (isDrawing || x1 === undefined) {
            return;
        }

        let angle = BB.pointsToAngleDeg({x:x1, y:y1}, {x:x2, y:y2});
        let mouseDist = Math.sqrt(Math.pow(x2 - x1, 2.0) + Math.pow(y2 - y1, 2.0));
        let eX = (x2 - x1) / mouseDist;
        let eY = (y2 - y1) / mouseDist;
        let loopDist;
        let bdist = settingSize * settingSpacing;
        lineToolLastDot = settingSize * settingSpacing;
        for (loopDist = lineToolLastDot; loopDist <= mouseDist; loopDist += bdist) {
            drawDot(x1 + eX * loopDist, y1 + eY * loopDist, settingSize, settingOpacity);
        }


        let historyEntry = {
            tool: ["brush", "SmudgeBrush"],
            actions: []
        };
        // todo
        history.add(historyEntry);*/ }
    getIsDrawing() {
        return this.isDrawing;
    }
    setColor(c) {
        if (this.settingColor.r === c.r && this.settingColor.g === c.g && this.settingColor.b === c.b) return;
        this.settingColor = {
            r: c.r,
            g: c.g,
            b: c.b
        };
    }
    setContext(c) {
        this.context = c;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSize(s) {
        this.settingSize = s;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    setSpacing(s) {
        this.settingSpacing = s;
    }
    sizePressure(b) {
        this.settingHasSizePressure = b;
    }
    opacityPressure(b) {
        this.settingHasOpacityPressure = b;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    getSpacing() {
        return this.settingSpacing;
    }
    getSize() {
        return this.settingSize;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.context = {};
        this.klHistory = {};
        this.settingColor = {
            r: 0,
            g: 0,
            b: 0
        };
        this.settingSize = 35;
        this.settingSpacing = 0.20446882736951905;
        this.settingOpacity = 0.8;
        this.settingHasSizePressure = false;
        this.settingHasOpacityPressure = false;
        this.settingLockLayerAlpha = false;
        this.lineToolLastDot = 0;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.isDrawing = false;
        this.copyImageData = {};
        this.drawBuffer = [];
        this.copiedCells = [];
    }
}










class $458de7145dc8d2d0$export$38b08aa4ea8f61c6 {
    updateCompleteRedrawBounds(x, y) {
        let bounds = {
            type: 'index',
            x1: x,
            y1: y,
            x2: x,
            y2: y
        };
        if (this.settingXSymmetry) bounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).updateBounds(bounds, {
            type: 'index',
            x1: -x + this.copyCanvas.width,
            y1: y,
            x2: -x + this.copyCanvas.width,
            y2: y
        });
        if (this.settingYSymmetry) bounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).updateBounds(bounds, {
            type: 'index',
            x1: x,
            y1: -y + this.copyCanvas.height,
            x2: x,
            y2: -y + this.copyCanvas.height
        });
        const buffer = this.settingMode === 'stroke' ? this.settingSize + 1 : 1;
        bounds.x1 = Math.floor(bounds.x1 - buffer);
        bounds.y1 = Math.floor(bounds.y1 - buffer);
        bounds.x2 = Math.ceil(bounds.x2 + buffer);
        bounds.y2 = Math.ceil(bounds.y2 + buffer);
        this.completeRedrawBounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).updateBounds(this.completeRedrawBounds, bounds);
    }
    drawShape() {
        this.context.save();
        this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
        this.context.drawImage(this.copyCanvas, 0, 0);
        this.selectionPath && this.context.clip(this.selectionPath);
        const color = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.settingColor);
        if (this.settingIsEraser) {
            color.r = (0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28);
            color.g = (0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28);
            color.b = (0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28);
            if (this.settingLockLayerAlpha) this.context.globalCompositeOperation = 'source-atop';
            else this.context.globalCompositeOperation = 'destination-out';
        } else if (this.settingLockLayerAlpha) this.context.globalCompositeOperation = 'source-atop';
        if (this.path.length > 1) {
            // path
            const path = new Path2D();
            this.path.forEach((item, index)=>{
                if (index === 0) path.moveTo(item.x, item.y);
                else path.lineTo(item.x, item.y);
            });
            let style = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr({
                r: color.r,
                g: color.g,
                b: color.b,
                a: this.settingOpacity
            });
            if (this.settingGradient) {
                const startAtTop = this.path[0].x > this.path[this.path.length - 1].x;
                const gradient = this.context.createLinearGradient(0, startAtTop ? this.minY : this.maxY, 0, startAtTop ? this.maxY : this.minY);
                gradient.addColorStop(0, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr({
                    r: color.r,
                    g: color.g,
                    b: color.b,
                    a: this.settingOpacity
                }));
                gradient.addColorStop(1, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbaStr({
                    r: color.r,
                    g: color.g,
                    b: color.b,
                    a: 0
                }));
                style = gradient;
            }
            // setup params
            if (this.settingMode === 'fill') this.context.fillStyle = style;
            else {
                this.context.lineWidth = this.settingSize * 2;
                this.context.lineJoin = 'bevel';
                this.context.strokeStyle = style;
            }
            // draw
            const draw = ()=>{
                if (this.settingMode === 'fill') this.context.fill(path);
                else this.context.stroke(path);
            };
            draw();
            if (this.settingXSymmetry) {
                this.context.save();
                this.context.translate(this.context.canvas.width / 2, 0);
                this.context.scale(-1, 1);
                this.context.translate(-this.context.canvas.width / 2, 0);
                draw();
                this.context.restore();
            }
            if (this.settingYSymmetry) {
                this.context.save();
                this.context.translate(0, this.context.canvas.height / 2);
                this.context.scale(1, -1);
                this.context.translate(0, -this.context.canvas.height / 2);
                draw();
                this.context.restore();
                if (this.settingXSymmetry) {
                    this.context.save();
                    this.context.translate(this.context.canvas.width / 2, this.context.canvas.height / 2);
                    this.context.scale(-1, -1);
                    this.context.translate(-this.context.canvas.width / 2, -this.context.canvas.height / 2);
                    draw();
                    this.context.restore();
                }
            }
        }
        this.context.restore();
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    getSize() {
        return this.settingMode === 'stroke' ? this.settingSize : 0;
    }
    setSize(s) {
        this.settingSize = s;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    setColor(c) {
        this.settingColor = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(c);
    }
    setContext(c) {
        this.context = c;
    }
    setMode(mode) {
        this.settingMode = mode;
    }
    getMode() {
        return this.settingMode;
    }
    setDistort(distort) {
        this.settingDistort = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(distort, 0, 1);
    }
    getDistort() {
        return this.settingDistort;
    }
    setXSymmetry(b) {
        this.settingXSymmetry = b;
    }
    getXSymmetry() {
        return this.settingXSymmetry;
    }
    setYSymmetry(b) {
        this.settingYSymmetry = b;
    }
    getYSymmetry() {
        return this.settingYSymmetry;
    }
    setGradient(b) {
        this.settingGradient = b;
    }
    getGradient() {
        return this.settingGradient;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    getIsEraser() {
        return this.settingIsEraser;
    }
    setIsEraser(b) {
        this.settingIsEraser = b;
    }
    getIsDrawing() {
        return this.isDrawing;
    }
    startLine(x, y) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.isDrawing = true;
        this.path = [
            {
                x: x,
                y: y
            }
        ];
        this.minY = y;
        this.maxY = y;
        this.copyCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(this.context.canvas.width, this.context.canvas.height);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.copyCanvas).drawImage(this.context.canvas, 0, 0);
        this.completeRedrawBounds = undefined;
        this.updateCompleteRedrawBounds(x, y);
    }
    goLine(x, y) {
        if (!this.isDrawing) return;
        const pos = {
            x: x,
            y: y
        };
        if (this.settingDistort > 0) {
            pos.x += (Math.random() - 0.5) * this.settingDistort * 80;
            pos.y += (Math.random() - 0.5) * this.settingDistort * 80;
        }
        this.minY = Math.min(this.minY, pos.y);
        this.maxY = Math.max(this.maxY, pos.y);
        this.path.push(pos);
        this.updateCompleteRedrawBounds(x, y);
        this.drawShape();
    }
    endLine() {
        this.isDrawing = false;
        this.completeRedrawBounds = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).indexBoundsInArea(this.completeRedrawBounds, this.copyCanvas.width, this.copyCanvas.height);
        if (this.selectionBounds) this.completeRedrawBounds = (0, $9414f5ea41e9cf25$export$83720aaadc272d85)(this.completeRedrawBounds, this.selectionBounds);
        if (this.path.length > 1 && this.completeRedrawBounds) {
            const layerData = (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(this.context.canvas, this.completeRedrawBounds);
            this.klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(this.klHistory.getComposed(), layerData));
        }
        this.path = [];
        this.copyCanvas = {};
    }
    drawLineSegment(x1, y1, x2, y2) {
    // might make sense for stroke
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.context = {};
        this.settingColor = {};
        this.settingSize = 0.25 // radius - 0.5 - 99999
        ;
        this.settingOpacity = 1 // 0-1
        ;
        this.settingLockLayerAlpha = false;
        this.settingIsEraser = false;
        this.settingMode = 'fill';
        this.settingDistort = 0 // 0 - 1
        ;
        this.settingXSymmetry = false;
        this.settingYSymmetry = false;
        this.settingGradient = false;
        this.isDrawing = false;
        this.klHistory = {};
        this.copyCanvas = {};
        this.path = [];
        this.minY = 0;
        this.maxY = 0;
    }
}


const $8baf89d70f3487eb$export$32510733a89b2eab = {
    PenBrush: $ab3d0b0688f50842$export$6f96c8f9e6ae7341,
    BlendBrush: $2beac24702a6836b$export$9659db8d01dd5313,
    SketchyBrush: $ec1ed8bc550ccd88$export$566f9061f0f5ba33,
    PixelBrush: $f01b5e3bd1be2f34$export$4de5ef8eecde6f12,
    ChemyBrush: $458de7145dc8d2d0$export$38b08aa4ea8f61c6,
    SmudgeBrush: $baef4a032d46c3b8$export$c9f800961903deab,
    EraserBrush: $6debbe598e970932$export$fe52c90afd1cf5ba
};




const $718ed62694aada15$export$f02de051ab70b20e = 20;





var $589cd84fd65b9f5a$exports = {};
$589cd84fd65b9f5a$exports = $parcel$resolve("efRnq");





const $74487dc42eb45244$export$a0d4983f3b0b5c8e = function() {
    const brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($589cd84fd65b9f5a$exports))),
        tooltip: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1,
            curve: [
                [
                    0,
                    0.01
                ],
                [
                    0.5,
                    0.3
                ],
                [
                    1,
                    1
                ]
            ]
        },
        scatterSlider: {
            min: 0,
            max: 100,
            curve: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(0, 100, 0.1, 2.5)
        }
    };
    let alphaNames = [
        (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen-circle'),
        (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen-chalk'),
        (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen-calligraphy'),
        (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen-square')
    ];
    (0, $63d0b335c576c718$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen');
        alphaNames = [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen-circle'),
            (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen-chalk'),
            (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen-calligraphy'),
            (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pen-square')
        ];
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $8baf89d70f3487eb$export$32510733a89b2eab).PenBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        let scatterSlider;
        const alphaOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                0,
                1,
                2,
                3
            ].map((id)=>{
                const alpha = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    className: 'dark-invert',
                    css: {
                        width: '31px',
                        height: '31px',
                        backgroundSize: 'contain',
                        margin: '2px'
                    }
                });
                const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(70, 70);
                const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
                if (id === 0 || id === 3) {
                    if (id === 0) {
                        ctx.beginPath();
                        ctx.arc(35, 35, 30, 0, 2 * Math.PI);
                        ctx.closePath();
                        ctx.fill();
                    } else ctx.fillRect(5, 5, 60, 60);
                } else if (id === 1) ctx.drawImage((0, $be08c7e8caa49ffa$export$74a44bbc21d06a28)(60), 5, 5);
                else if (id === 2) ctx.drawImage((0, $be08c7e8caa49ffa$export$eaa218d5d17c8f1c)(60), 5, 5);
                alpha.style.backgroundImage = 'url(' + canvas.toDataURL('image/png') + ')';
                return {
                    id: id,
                    label: alpha,
                    title: alphaNames[id]
                };
            }),
            initId: 0,
            onChange: (id)=>{
                brush.setAlpha(id);
            }
        });
        const lockAlphaToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: brush.getLockAlpha(),
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha'),
            callback: function(b) {
                brush.setLockAlpha(b);
            },
            doHighlight: true,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha-title'),
            css: {
                display: 'inline-block'
            },
            name: 'lock-alpha-toggle'
        });
        const spacingSpline = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).SplineInterpolator([
            [
                0,
                15
            ],
            [
                8,
                7
            ],
            [
                14,
                4
            ],
            [
                30,
                3
            ],
            [
                50,
                2.7
            ],
            [
                100,
                2
            ]
        ]);
        function setSize(size) {
            brush.setSize(size);
            brush.setSpacing(Math.max(2, spacingSpline.interpolate(size)) / 15);
        }
        function init() {
            sizeSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brushInterface.opacitySlider.max,
                curve: brushInterface.opacitySlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            scatterSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('scatter'),
                width: 225,
                height: 30,
                min: brushInterface.scatterSlider.min,
                max: brushInterface.scatterSlider.max,
                value: brushInterface.scatterSlider.min,
                curve: brushInterface.scatterSlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                onChange: (val)=>{
                    brush.setScatter(val);
                    p.onScatterChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            const pressureSizeToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(true, function(b) {
                brush.sizePressure(b);
            });
            const pressureOpacityToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(false, function(b) {
                brush.opacityPressure(b);
            });
            const pressureScatterToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(false, function(b) {
                brush.scatterPressure(b);
            });
            div.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    scatterSlider.getElement(),
                    pressureScatterToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: alphaOptions.getElement(),
                css: {
                    marginTop: '10px'
                }
            }), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: lockAlphaToggle.getElement(),
                css: {
                    marginTop: '10px'
                }
            }));
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.getScatter = function() {
            return brush.getScatter();
        };
        this.setScatter = function(scatter) {
            brush.setScatter(scatter);
            scatterSlider.setValue(scatter);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();








var $66a76d3dbebc04df$exports = {};
$66a76d3dbebc04df$exports = $parcel$resolve("lGY8s");



const $389b24b4f03b3a27$export$156bb4fe8f4bcb4b = function() {
    const brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($66a76d3dbebc04df$exports))),
        tooltip: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-blend'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $63d0b335c576c718$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-blend');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $8baf89d70f3487eb$export$32510733a89b2eab).BlendBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        function setSize(size) {
            brush.setSize(size);
        }
        function init() {
            sizeSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: 58,
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                }
            });
            opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                curve: brushInterface.opacitySlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const blendingSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-blending'),
                width: 225,
                height: 30,
                min: 0,
                max: 1,
                value: brush.getBlending(),
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: function(val) {
                    brush.setBlending(val);
                }
            });
            blendingSlider.getElement().style.marginTop = '10px';
            const pressureSizeToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(true, function(b) {
                brush.setSizePressure(b);
            });
            const pressureOpacityToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(false, function(b) {
                brush.setOpacityPressure(b);
            });
            const lockAlphaToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
                init: brush.getLockAlpha(),
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha'),
                callback: function(b) {
                    brush.setLockAlpha(b);
                },
                doHighlight: true,
                title: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha-title'),
                css: {
                    marginTop: '10px',
                    display: 'inline-block'
                },
                name: 'lock-alpha'
            });
            div.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }), blendingSlider.getElement(), lockAlphaToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context, layer.id);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p, isCoalesced) {
            brush.goLine(x, y, p, false); // looks weird with isCoalesced
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.getIsDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();





var $072de38d598ac8ca$exports = {};
$072de38d598ac8ca$exports = $parcel$resolve("jDXzO");




const $ed2b11ff6c0e7481$export$ffae56164d1bde68 = function() {
    const brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($072de38d598ac8ca$exports))),
        tooltip: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-sketchy'),
        sizeSlider: {
            min: 0.5,
            max: 10
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $63d0b335c576c718$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-sketchy');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $8baf89d70f3487eb$export$32510733a89b2eab).SketchyBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        function setSize(size) {
            brush.setSize(size);
        }
        function init() {
            sizeSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-size'),
                width: 250,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize() * 2,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: function(val) {
                    brush.setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
                width: 250,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const blendSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-blending'),
                width: 250,
                height: 30,
                min: 0,
                max: 1,
                value: brush.getBlending(),
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: function(val) {
                    brush.setBlending(val);
                }
            });
            const scaleSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-sketchy-scale'),
                width: 250,
                height: 30,
                min: 1,
                max: 20,
                value: brush.getScale(),
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                onChange: function(val) {
                    brush.setScale(val);
                }
            });
            opacitySlider.getElement().style.marginTop = '10px';
            blendSlider.getElement().style.marginTop = '10px';
            scaleSlider.getElement().style.marginTop = '10px';
            div.append(sizeSlider.getElement(), opacitySlider.getElement(), blendSlider.getElement(), scaleSlider.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, pressure) {
            brush.startLine(x, y, pressure);
        };
        this.goLine = function(x, y, pressure) {
            brush.goLine(x, y, pressure, undefined);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getSeed = function() {
            return parseInt('' + brush.getSeed());
        };
        this.setSeed = function(s) {
            brush.setSeed(parseInt('' + s));
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();








var $a35d2108566d015a$exports = {};
$a35d2108566d015a$exports = $parcel$resolve("hkoNI");



const $c8f3acddc3f49bc0$export$d001f3406562d07 = function() {
    const brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a35d2108566d015a$exports))),
        tooltip: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pixel'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1,
            curve: [
                [
                    0,
                    0.01
                ],
                [
                    0.5,
                    0.3
                ],
                [
                    1,
                    1
                ]
            ]
        }
    };
    (0, $63d0b335c576c718$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pixel');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $8baf89d70f3487eb$export$32510733a89b2eab).PixelBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        const lockAlphaToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: brush.getLockAlpha(),
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha'),
            callback: function(b) {
                brush.setLockAlpha(b);
            },
            doHighlight: true,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha-title'),
            name: 'lock-alpha-toggle'
        });
        const eraserToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: brush.getIsEraser(),
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('eraser'),
            callback: function(b) {
                brush.setIsEraser(b);
            },
            name: 'eraser-toggle'
        });
        const ditherToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: brush.getUseDither(),
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-pixel-dither'),
            callback: function(b) {
                brush.setUseDither(b);
            },
            name: 'dither-toggle'
        });
        const spacingSpline = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).SplineInterpolator([
            [
                0.5,
                0.45
            ],
            [
                100,
                4
            ]
        ]);
        function setSize(size) {
            brush.setSize(size);
            brush.setSpacing(spacingSpline.interpolate(size) / size);
        }
        function init() {
            sizeSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                }
            });
            opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brushInterface.opacitySlider.max,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const pressureSizeToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(true, function(b) {
                brush.sizePressure(b);
            });
            div.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), opacitySlider.getElement());
            const toggleRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: div,
                css: {
                    display: 'flex',
                    marginTop: '10px',
                    gap: '10px',
                    flexWrap: 'wrap'
                }
            });
            toggleRow.append(lockAlphaToggle.getElement(), eraserToggle.getElement(), ditherToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size * 2);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity * 100);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.toggleEraser = ()=>{
            eraserToggle.setValue(!eraserToggle.getValue());
            brush.setIsEraser(eraserToggle.getValue());
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();








var $224bfe309e7ff70b$exports = {};
$224bfe309e7ff70b$exports = $parcel$resolve("baIZM");



const $411f23605301883c$export$cf481ecf227135a8 = function() {
    const brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($224bfe309e7ff70b$exports))),
        tooltip: (0, $63d0b335c576c718$export$ce37e184d908d785)('eraser') + ' [E]',
        sizeSlider: {
            min: 0.5,
            max: 200,
            curve: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(0.5, 200, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $63d0b335c576c718$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $63d0b335c576c718$export$ce37e184d908d785)('eraser') + ' [E]';
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $8baf89d70f3487eb$export$32510733a89b2eab).EraserBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        let isTransparentBg = false;
        function setSize(size) {
            brush.setSize(size);
        }
        function init() {
            sizeSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: 30,
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brushInterface.opacitySlider.max,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const pressureSizeToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(true, function(b) {
                brush.sizePressure(b);
            });
            const pressureOpacityToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(false, function(b) {
                brush.opacityPressure(b);
            });
            div.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }));
            const transparencyToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
                init: false,
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-eraser-transparent-bg'),
                callback: function(b) {
                    isTransparentBg = b;
                    brush.setTransparentBG(b);
                },
                css: {
                    marginTop: '10px'
                },
                name: 'transparency-toggle'
            });
            div.append(transparencyToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function() {};
        this.setLayer = function(layer) {
            brush.setLayer(layer);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.getIsTransparentBg = function() {
            return isTransparentBg;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();








var $77f4910ba5bfb2ef$exports = {};
$77f4910ba5bfb2ef$exports = $parcel$resolve("91Av5");



const $4218d17c2806f1f8$export$84831662ba707e7a = function() {
    const brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($77f4910ba5bfb2ef$exports))),
        tooltip: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-smudge'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1,
            curve: [
                [
                    0,
                    0.01
                ],
                [
                    0.5,
                    0.3
                ],
                [
                    1,
                    1
                ]
            ]
        }
    };
    (0, $63d0b335c576c718$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-smudge');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $8baf89d70f3487eb$export$32510733a89b2eab).SmudgeBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        const lockAlphaToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: brush.getLockAlpha(),
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha'),
            callback: function(b) {
                brush.setLockAlpha(b);
            },
            doHighlight: true,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha-title'),
            css: {
                display: 'inline-block'
            },
            name: 'lock-alpha-toggle'
        });
        const spacingSpline = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).SplineInterpolator([
            [
                0,
                15
            ],
            [
                8,
                7
            ],
            [
                14,
                4
            ],
            [
                30,
                3
            ],
            [
                50,
                2.7
            ],
            [
                100,
                2
            ]
        ]);
        function setSize(size) {
            brush.setSize(size);
            brush.setSpacing(Math.max(2, spacingSpline.interpolate(size)) / 15);
        }
        function init() {
            sizeSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                curve: brushInterface.opacitySlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const pressureSizeToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(false, function(b) {
                brush.sizePressure(b);
            });
            const pressureOpacityToggle = (0, $218f70778c2bf652$export$9da2e8821e6cbb57)(false, function(b) {
                brush.opacityPressure(b);
            });
            div.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }));
            const bottomRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: div,
                css: {
                    marginTop: '10px'
                }
            });
            bottomRow.append(lockAlphaToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.getIsDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();







var $017f6a414a9f5faf$exports = {};
$017f6a414a9f5faf$exports = $parcel$resolve("aI6cE");






const $720edf36b0105568$export$80819a93636ebb04 = function() {
    const brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($017f6a414a9f5faf$exports))),
        tooltip: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-chemy'),
        sizeSlider: {
            min: 0.25,
            max: 25,
            curve: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(0.25, 25, 0.1),
            isDisabled: true
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $63d0b335c576c718$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-chemy');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $8baf89d70f3487eb$export$32510733a89b2eab).ChemyBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        function setSize(size) {
            brush.setSize(size);
        }
        let eraserToggle;
        function init() {
            sizeSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-size'),
                width: 250,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                isEnabled: brush.getMode() === 'stroke',
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 5) return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
                width: 250,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                eventResMs: (0, $718ed62694aada15$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(opacitySlider.getElement(), {
                marginTop: '10px'
            });
            eraserToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
                init: brush.getIsEraser(),
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('eraser'),
                callback: function(b) {
                    brush.setIsEraser(b);
                },
                css: {
                    marginTop: '10px',
                    marginLeft: '10px'
                },
                name: 'eraser-toggle'
            });
            const lockAlphaToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
                init: brush.getLockAlpha(),
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha'),
                callback: function(b) {
                    brush.setLockAlpha(b);
                },
                doHighlight: true,
                title: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha-title'),
                css: {
                    marginTop: '10px'
                },
                name: 'lock-alpha-toggle'
            });
            const toggleRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    display: 'flex',
                    marginTop: '10px'
                }
            });
            const iconSize = 35;
            const padding = 8;
            const actualIconSize = iconSize - padding * 2;
            const halfSize = actualIconSize / 2;
            const modeOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
                optionArr: [
                    {
                        id: 'fill',
                        label: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
                            class: 'dark-invert',
                            elementType: 'svg',
                            width: iconSize + '',
                            height: iconSize + '',
                            childrenArr: [
                                {
                                    elementType: 'path',
                                    fill: '#000',
                                    css: {
                                        transformOrigin: '0 0',
                                        transform: `translate(-0.5px, -0.5px) scale(${actualIconSize}, ${actualIconSize}) translate(0.5px, 0.5px)`
                                    },
                                    d: 'M 0,0 C 1.5,0 -0.5,1 1,1'
                                }
                            ]
                        }),
                        title: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-chemy-fill')
                    },
                    {
                        id: 'stroke',
                        label: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
                            class: 'dark-invert',
                            elementType: 'svg',
                            width: iconSize + '',
                            height: iconSize + '',
                            childrenArr: [
                                {
                                    elementType: 'path',
                                    fill: 'none',
                                    stroke: '#000',
                                    css: {
                                        strokeWidth: '0.12px',
                                        transformOrigin: '0 0',
                                        transform: `translate(-0.5px, -0.5px) scale(${actualIconSize}, ${actualIconSize}) translate(0.5px, 0.5px)`
                                    },
                                    d: 'M 0,0 C 1.5,0 -0.5,1 1,1'
                                }
                            ]
                        }),
                        title: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-chemy-stroke')
                    }
                ],
                initId: brush.getMode(),
                onChange: (id)=>{
                    brush.setMode(id);
                    brushInterface.sizeSlider.isDisabled = brush.getMode() === 'fill';
                    sizeSlider.setIsEnabled(!brushInterface.sizeSlider.isDisabled);
                    const brushSize = brush.getSize();
                    sizeSlider.setValue(brushSize);
                    p.onSizeChange(brushSize);
                    p.onConfigChange();
                }
            });
            const mirrorXToggle = new (0, $8d99bd5fadaac7f9$export$2358c75ad3c15b2d)({
                label: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
                    class: 'dark-invert',
                    elementType: 'svg',
                    width: iconSize + '',
                    height: iconSize + '',
                    childrenArr: [
                        {
                            elementType: 'path',
                            fill: 'none',
                            stroke: '#000',
                            css: {
                                strokeWidth: '1px'
                            },
                            d: `M ${halfSize + padding},${padding} ${halfSize + padding},${actualIconSize + padding}`
                        }
                    ]
                }),
                title: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-chemy-mirror-x'),
                init: brush.getXSymmetry(),
                onChange: (b)=>{
                    brush.setXSymmetry(b);
                }
            });
            const mirrorYToggle = new (0, $8d99bd5fadaac7f9$export$2358c75ad3c15b2d)({
                label: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
                    class: 'dark-invert',
                    elementType: 'svg',
                    width: iconSize + '',
                    height: iconSize + '',
                    childrenArr: [
                        {
                            elementType: 'path',
                            fill: 'none',
                            stroke: '#000',
                            css: {
                                strokeWidth: '1px'
                            },
                            d: `M ${padding},${halfSize + padding} ${actualIconSize + padding},${halfSize + padding}`
                        }
                    ]
                }),
                title: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-chemy-mirror-y'),
                init: brush.getYSymmetry(),
                onChange: (b)=>{
                    brush.setYSymmetry(b);
                }
            });
            const gradientToggle = new (0, $8d99bd5fadaac7f9$export$2358c75ad3c15b2d)({
                label: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
                    class: 'dark-invert',
                    elementType: 'svg',
                    width: iconSize + '',
                    height: iconSize + '',
                    childrenArr: [
                        {
                            elementType: 'defs',
                            childrenArr: [
                                {
                                    elementType: 'linearGradient',
                                    id: 'gradient',
                                    x1: '0',
                                    y1: '0',
                                    x2: '0',
                                    y2: '1',
                                    childrenArr: [
                                        {
                                            elementType: 'stop',
                                            offset: '0%',
                                            'stop-color': 'rgba(0,0,0,0)'
                                        },
                                        {
                                            elementType: 'stop',
                                            offset: '100%',
                                            'stop-color': 'rgba(0,0,0,1)'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            elementType: 'rect',
                            fill: "url('#gradient')",
                            x: '' + padding,
                            y: '' + padding,
                            width: '' + actualIconSize,
                            height: '' + actualIconSize
                        }
                    ]
                }),
                title: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-chemy-gradient'),
                init: brush.getGradient(),
                onChange: (b)=>{
                    brush.setGradient(b);
                }
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(mirrorXToggle.getElement(), {
                marginLeft: '10px'
            });
            {
                const margin = {
                    marginLeft: '4px'
                };
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(mirrorYToggle.getElement(), margin);
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(gradientToggle.getElement(), margin);
            }
            toggleRow.append(modeOptions.getElement(), mirrorXToggle.getElement(), mirrorYToggle.getElement(), gradientToggle.getElement());
            div.append(sizeSlider.getElement(), opacitySlider.getElement(), toggleRow, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    lockAlphaToggle.getElement(),
                    eraserToggle.getElement()
                ],
                css: {
                    display: 'flex'
                }
            }));
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.getIsDrawing() && brush.getMode() === 'stroke') sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.getIsDrawing() && brush.getMode() === 'stroke') sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y);
        };
        this.goLine = function(x, y, p, isCoalesced) {
            brush.goLine(x, y);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.getIsDrawing();
        };
        this.toggleEraser = ()=>{
            eraserToggle.setValue(!eraserToggle.getValue());
            brush.setIsEraser(eraserToggle.getValue());
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();


const $b2f1ee6bcab52d93$export$d1a79a5ce7e46547 = {
    penBrush: (0, $74487dc42eb45244$export$a0d4983f3b0b5c8e),
    blendBrush: (0, $389b24b4f03b3a27$export$156bb4fe8f4bcb4b),
    sketchyBrush: (0, $ed2b11ff6c0e7481$export$ffae56164d1bde68),
    pixelBrush: (0, $c8f3acddc3f49bc0$export$d001f3406562d07),
    chemyBrush: (0, $720edf36b0105568$export$80819a93636ebb04),
    smudgeBrush: (0, $4218d17c2806f1f8$export$84831662ba707e7a),
    eraserBrush: (0, $411f23605301883c$export$cf481ecf227135a8)
};





function $165d2995997b2f9b$export$35fa34e5af64bd4a(url, isEmbed, options) {
    // window very small, modal might look bad
    if (!isEmbed && (options === null || options === void 0 ? void 0 : options.allowSmallScreenWindowOpen) !== false && (window.innerHeight < 500 || window.innerWidth < 700)) {
        window.open(url);
        return;
    }
    const iframe = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'iframe',
        custom: {
            src: url,
            title: (options === null || options === void 0 ? void 0 : options.iframeTitle) || 'Iframe Content'
        },
        css: {
            width: (options === null || options === void 0 ? void 0 : options.iframeWidth) || '100%',
            height: (options === null || options === void 0 ? void 0 : options.iframeHeight) || '100%',
            border: '0',
            opacity: '0'
        }
    });
    setTimeout(()=>{
        iframe.style.opacity = ''; // fallback
    }, 500);
    const titleEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
    const showOpenInNewTabLink = !isEmbed && (options === null || options === void 0 ? void 0 : options.showOpenInNewTabLink) !== false;
    let linkEl;
    if (showOpenInNewTabLink) {
        linkEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'a',
            parent: titleEl,
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('modal-new-tab'),
            custom: {
                href: url,
                target: '_blank'
            },
            onClick: function() {
                popup.close();
            }
        });
        iframe.onload = ()=>{
            if (linkEl && iframe.contentWindow) try {
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).setAttributes(linkEl, {
                    href: '' + iframe.contentWindow.location
                });
            } catch (e) {
            // might not have access
            }
            iframe.style.opacity = '';
        };
    }
    const onMessage = (options === null || options === void 0 ? void 0 : options.closeOnMessage) ? (event)=>{
        var _options_closeOnMessage, _options_closeOnMessage1;
        if (event.origin !== ((_options_closeOnMessage = options.closeOnMessage) === null || _options_closeOnMessage === void 0 ? void 0 : _options_closeOnMessage.origin)) return;
        if (typeof event.data !== 'object' || !event.data || event.data.action !== ((_options_closeOnMessage1 = options.closeOnMessage) === null || _options_closeOnMessage1 === void 0 ? void 0 : _options_closeOnMessage1.action)) return;
        if (event.source !== iframe.contentWindow) return;
        popup.close();
    } : undefined;
    if (onMessage) window.addEventListener('message', onMessage);
    const popup = new (0, $18361e3f5d6257e8$export$185108a9b725b68)({
        title: titleEl,
        content: iframe,
        width: (options === null || options === void 0 ? void 0 : options.modalWidth) || 880,
        height: options === null || options === void 0 ? void 0 : options.modalHeight,
        isMaxHeight: true,
        onClose: ()=>{
            if (onMessage) window.removeEventListener('message', onMessage);
            iframe.src = 'about:blank';
            if (linkEl) {
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(linkEl);
                linkEl = undefined;
            }
        }
    });
}



class $f734cb8286217c3c$export$3dff5655255b5729 {
    getValue() {
        for(let i = 0; i < this.inputs.length; i++){
            if (this.inputs[i].checked) return this.inputs[i].value;
        }
        return null;
    }
    getElement() {
        return this.el;
    }
    constructor({ name: name, init: init, items: items, ignoreFocus: ignoreFocus }){
        this.inputs = [];
        this.el = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-radio'
        });
        items.forEach((item)=>{
            const label = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'label'
            });
            const input = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'input',
                parent: label,
                custom: {
                    name: name,
                    value: item.value,
                    type: 'radio'
                }
            });
            if (ignoreFocus) input.setAttribute('data-ignore-focus', 'true');
            if (init === item.value) input.checked = true;
            label.append(item.label);
            this.el.append(label);
            this.inputs.push(input);
        });
    }
}








function $61cd8b4e4101a623$export$1b9ca798405c9eb6(timestamp) {
    let age = new Date().getTime() - timestamp;
    let ageStr;
    age = Math.floor(age / 1000 / 60);
    ageStr = (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-min-ago').replace('{x}', '' + age);
    if (age > 60) {
        age = Math.floor(age / 60);
        ageStr = (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-hours-ago').replace('{x}', '' + age);
        if (age > 24) {
            age = Math.floor(age / 24);
            ageStr = (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-days-ago').replace('{x}', '' + age);
            if (age > 31) ageStr = (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-month-ago');
        }
    }
    return ageStr;
}





class $744217e5b2377ce2$export$852ebaa1b01c8b5a {
    getElement() {
        return this.rootEl;
    }
    show() {}
    destroy() {
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.infoButton);
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.infoButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: '?',
            className: 'kl-info-btn',
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-about'),
            onClick: ()=>{
                (0, $165d2995997b2f9b$export$35fa34e5af64bd4a)('./help/#help-browser-storage', false);
            }
        });
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage'),
            css: {
                display: 'flex',
                margin: '-5px 0',
                gap: '6px'
            }
        });
        this.rootEl.append(this.infoButton);
    }
}


var $41907456dd919c99$export$bd46b8ab3689edc4;
var $41907456dd919c99$export$b5381822af66064b;
$41907456dd919c99$export$bd46b8ab3689edc4 = `a9LdEW_anim`;
$41907456dd919c99$export$bd46b8ab3689edc4;
$41907456dd919c99$export$b5381822af66064b = `a9LdEW_animEl`;



/**
 * https://developer.mozilla.org/en-US/docs/Web/API/StorageManager/persist
 * Might reduce deletions of indexedDB data by browser.
 *
 * "The best time to request your storage be marked as persistent is when you save critical user
 * data, and the request should ideally be **wrapped in a user gesture**."
 * from https://web.dev/articles/persistent-storage
 */ async function $2e574af1dfdb7def$export$f565b71ad023b7df() {
    if ('storage' in navigator && 'persist' in navigator.storage) await navigator.storage.persist();
}



class $1a83f3b0ed28fe18$export$9c72cf485ef46673 {
    updateAge() {
        if (!this.timestamp) return;
        this.ageEl.textContent = (0, $61cd8b4e4101a623$export$1b9ca798405c9eb6)(this.timestamp);
    }
    resetButtons() {
        this.previewEl.classList.remove('kl-storage-preview--disabled');
        if (this.timestamp) {
            if (this.openButtonEl) this.openButtonEl.disabled = false;
            this.storeButtonEl.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-overwrite');
            this.storeButtonEl.disabled = false;
            this.clearButtonEl.disabled = false;
        } else {
            if (this.openButtonEl) this.openButtonEl.disabled = true;
            this.storeButtonEl.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-store');
            this.storeButtonEl.disabled = false;
            this.clearButtonEl.disabled = true;
        }
    }
    updateThumb(timestamp, thumbnail) {
        var _this_thumbnail;
        this.timestamp = timestamp;
        (_this_thumbnail = this.thumbnail) === null || _this_thumbnail === void 0 ? void 0 : _this_thumbnail.remove();
        this.thumbnail = thumbnail ? (0, $13d5aa49e37e2734$export$dd0873c0fb3ccff6)(thumbnail) : undefined;
        const thumbnailCanvas = this.thumbnail; // typescript being weird
        if (thumbnailCanvas && timestamp) {
            thumbnailCanvas.classList.add('kl-storage-preview__im');
            this.ageEl.remove();
            this.emptyEl.remove();
            this.updateAge();
            this.previewEl.append(thumbnailCanvas, this.ageEl);
            this.previewEl.style.pointerEvents = this.onOpen ? '' : 'none';
            if (typeof performance !== 'undefined' && timestamp > performance.timeOrigin) {
                const animEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    parent: this.previewEl,
                    className: $41907456dd919c99$export$b5381822af66064b
                });
                setTimeout(()=>{
                    animEl.remove();
                }, 500);
            }
        } else {
            this.ageEl.remove();
            this.previewEl.append(this.emptyEl);
            this.previewEl.style.pointerEvents = 'none'; // prevent title
        }
        this.resetButtons();
    }
    async store() {
        const meta = this.projectStore.getCurrentMeta();
        const project = this.getProject();
        if (meta && meta.projectId !== project.projectId) {
            const doOverwrite = await new Promise((resolve, reject)=>{
                (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
                    type: 'warning',
                    message: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-overwrite-confirm'),
                    buttons: [
                        (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-overwrite'),
                        'Cancel'
                    ],
                    callback: async (result)=>{
                        if (result === 'Cancel') {
                            resolve(false);
                            return;
                        }
                        resolve(true);
                    }
                });
            });
            if (!doOverwrite) return;
        }
        this.applyUncommitted();
        await (0, $2e574af1dfdb7def$export$f565b71ad023b7df)();
        if (this.openButtonEl) this.openButtonEl.disabled = true;
        this.storeButtonEl.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-storing');
        this.storeButtonEl.disabled = true;
        this.clearButtonEl.disabled = true;
        this.previewEl.classList.add('kl-storage-preview--disabled');
        await new Promise((resolve)=>{
            setTimeout(()=>resolve(null), 20);
        });
        try {
            await this.projectStore.store(project);
            this.onStored();
        } catch (e) {
            this.resetButtons();
            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                type: 'error',
                message: [
                    `${(0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-failed-1')}<ul>`,
                    `<li>${(0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-failed-2')}</li>`,
                    `<li>${(0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-failed-3')}</li>`,
                    `<li>${(0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-failed-4')}</li>`,
                    '</ul>'
                ].join(''),
                buttons: [
                    'Ok'
                ]
            });
            setTimeout(()=>{
                throw new Error('storage-ui: failed to store browser storage, ' + e);
            }, 0);
        }
    }
    async clear() {
        (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
            type: 'warning',
            message: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-clear-prompt'),
            buttons: [
                (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-clear'),
                'Cancel'
            ],
            deleteButtonName: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-clear'),
            callback: async (result)=>{
                if (result === 'Cancel') return;
                if (this.openButtonEl) this.openButtonEl.disabled = true;
                this.storeButtonEl.disabled = true;
                this.clearButtonEl.disabled = true;
                try {
                    await this.projectStore.clear();
                } catch (e) {
                    this.resetButtons();
                    (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                        type: 'error',
                        message: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-failed-clear'),
                        buttons: [
                            'Ok'
                        ]
                    });
                    setTimeout(()=>{
                        throw new Error('storage-ui: failed to clear browser storage, ' + e);
                    }, 0);
                }
            }
        });
    }
    showError() {
        this.contentEl.innerHTML = '';
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.contentEl,
            content: "\uD83D\uDD34 " + (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-cant-access'),
            css: {
                marginTop: '10px'
            }
        });
    }
    getElement() {
        return this.rootEl;
    }
    show() {
        if (this.isFirst) {
            this.isFirst = false;
            if (!this.projectStore.getIsAvailable()) this.showError();
            else (async ()=>{
                try {
                    await this.projectStore.update();
                    const meta = this.projectStore.getCurrentMeta();
                    if (meta) this.updateThumb(meta.timestamp, meta.thumbnail);
                    else this.updateThumb();
                } catch (e) {
                    this.showError();
                    throw new Error('browser-storage-ui: failed initial read browser storage, ' + e);
                }
            })();
        }
    }
    hide() {
    // ...
    }
    destroy() {
        this.header.destroy();
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.storeButtonEl);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(this.clearButtonEl);
        clearInterval(this.updateAgeInterval);
        this.projectStore.unsubscribe(this.storeListener);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        var _this_options, _this_options1;
        this.previewEl = {};
        this.ageEl = {};
        this.emptyEl = {};
        this.storeButtonEl = {};
        this.clearButtonEl = {};
        this.storeListener = {};
        this.isFirst = true;
        this.updateAgeInterval = setInterval(()=>this.updateAge(), 60000);
        this.projectStore = p.projectStore;
        this.getProject = p.getProject;
        this.onStored = p.onStored;
        this.applyUncommitted = p.applyUncommitted;
        this.options = p.options;
        this.onOpen = p.onOpen;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({});
        this.header = new (0, $744217e5b2377ce2$export$852ebaa1b01c8b5a)();
        this.rootEl.append(this.header.getElement());
        this.contentEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl
        });
        if (!this.projectStore.getIsAvailable()) {
            this.showError();
            return;
        }
        this.previewEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-storage-preview',
            onClick: ()=>{
                var _this_onOpen, _this;
                return (_this_onOpen = (_this = this).onOpen) === null || _this_onOpen === void 0 ? void 0 : _this_onOpen.call(_this);
            },
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-open'),
            noRef: true
        });
        this.emptyEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-empty')
        });
        this.ageEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                right: '0',
                bottom: '0',
                width: '100%',
                textAlign: 'center',
                background: 'rgba(0,0,0,0.7)',
                color: '#fff',
                fontSize: '13px'
            }
        });
        if (this.onOpen) this.openButtonEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'grid-button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-open'),
            css: {
                margin: '0'
            },
            onClick: ()=>{
                var _this_onOpen, _this;
                return (_this_onOpen = (_this = this).onOpen) === null || _this_onOpen === void 0 ? void 0 : _this_onOpen.call(_this);
            },
            noRef: true
        });
        this.storeButtonEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'grid-button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-store'),
            css: {
                margin: '0'
            },
            onClick: ()=>this.store(),
            noRef: true
        });
        this.clearButtonEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'grid-button kl-button-delete',
            content: '<img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($03e87c70019af696$exports))) + '" height="20"/> ' + (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-clear'),
            css: {
                margin: '0'
            },
            onClick: ()=>this.clear(),
            noRef: true
        });
        if (!((_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.isFocusable)) {
            this.openButtonEl && (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(this.openButtonEl);
            (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(this.storeButtonEl);
            (0, $52ad4d7a7d6372c1$export$6bd63bfceaafae0c)(this.clearButtonEl);
        }
        if ((_this_options1 = this.options) === null || _this_options1 === void 0 ? void 0 : _this_options1.hideClearButton) this.clearButtonEl.style.visibility = 'hidden';
        this.contentEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    content: this.previewEl,
                    css: {
                        alignSelf: 'stretch',
                        flexGrow: '1'
                    }
                }),
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    content: [
                        this.openButtonEl,
                        this.storeButtonEl,
                        this.clearButtonEl
                    ],
                    css: {
                        display: 'flex',
                        gap: '10px',
                        flexDirection: 'column'
                    }
                })
            ],
            css: {
                marginTop: '10px',
                display: 'flex',
                gap: '10px'
            }
        }));
        this.storeListener = {
            onUpdate: (project)=>{
                this.updateThumb(project === null || project === void 0 ? void 0 : project.timestamp, project === null || project === void 0 ? void 0 : project.thumbnail);
            }
        };
        this.projectStore.subscribe(this.storeListener);
        this.updateThumb();
    }
}







const $c39dea662ab37110$export$f14c2a28fc1e9841 = 240;
function $c39dea662ab37110$export$fe58198efe02b173(blob) {
    return new Promise((resolve, reject)=>{
        const im = new Image();
        try {
            im.src = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).imageBlobToUrl(blob);
        } catch (e) {
            reject('imageBlobToUrl, ' + (e instanceof Error ? e.message : ''));
            return;
        }
        im.onload = ()=>{
            URL.revokeObjectURL(im.src);
            resolve(im);
        };
        im.onabort = ()=>{
            URL.revokeObjectURL(im.src);
            reject('layer image failed loading (abort)');
        };
        // This does occur. Maybe decoder runs of memory or storage corruption.
        im.onerror = ()=>{
            URL.revokeObjectURL(im.src);
            reject('layer image failed loading (error)');
        };
    });
}
class $c39dea662ab37110$export$f3c1ac6650038646 {
    static createThumbnail(project) {
        const size = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(project.width, project.height, $c39dea662ab37110$export$f14c2a28fc1e9841, $c39dea662ab37110$export$f14c2a28fc1e9841);
        const factor = size.width / project.width;
        return (0, $2b8bf7b32e5ba51f$export$5f63a7b18dc4503a)(project, factor);
    }
    static async createStorageProject(project) {
        const layers = [];
        for (const item of project.layers){
            let blob;
            if (item.image instanceof HTMLCanvasElement) blob = await (0, $13d5aa49e37e2734$export$403d539f215df596)(item.image, 'image/png');
            else // todo image
            throw new Error('Not implemented');
            var _item_mixModeStr;
            layers.push({
                name: item.name,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: (_item_mixModeStr = item.mixModeStr) !== null && _item_mixModeStr !== void 0 ? _item_mixModeStr : 'source-over',
                blob: blob
            });
        }
        return {
            id: 1,
            projectId: project.projectId,
            timestamp: new Date().getTime(),
            thumbnail: await (0, $13d5aa49e37e2734$export$403d539f215df596)($c39dea662ab37110$export$f3c1ac6650038646.createThumbnail(project), 'image/png'),
            width: project.width,
            height: project.height,
            layers: layers
        };
    }
    static async readStorageProject(storageProject) {
        if (!storageProject.width || !storageProject.height || isNaN(storageProject.width) || isNaN(storageProject.height) || storageProject.width < 1 || storageProject.height < 1) throw new Error('readStorageProject invalid canvas size: ' + storageProject.width + ', ' + storageProject.height);
        const project = {
            projectId: storageProject.projectId,
            width: storageProject.width,
            height: storageProject.height,
            layers: (await Promise.all(storageProject.layers.map((layer)=>{
                if (layer.blob) return $c39dea662ab37110$export$fe58198efe02b173(layer.blob).catch(()=>new Image(storageProject.width, storageProject.height));
                return new Image(storageProject.width, storageProject.height);
            }))).map((image, i)=>{
                const storageLayer = storageProject.layers[i];
                return {
                    name: storageLayer.name,
                    isVisible: storageLayer.isVisible,
                    opacity: storageLayer.opacity,
                    mixModeStr: storageLayer.mixModeStr,
                    image: image
                };
            })
        };
        return {
            project: project,
            timestamp: storageProject.timestamp,
            thumbnail: await $c39dea662ab37110$export$fe58198efe02b173(storageProject.thumbnail).catch(()=>new Image($c39dea662ab37110$export$f14c2a28fc1e9841, $c39dea662ab37110$export$f14c2a28fc1e9841))
        };
    }
    static async readStorageMeta(rawMeta) {
        return {
            projectId: rawMeta.projectId,
            timestamp: rawMeta.timestamp,
            thumbnail: rawMeta.thumbnail ? await $c39dea662ab37110$export$fe58198efe02b173(rawMeta.thumbnail).catch(()=>new Image($c39dea662ab37110$export$f14c2a28fc1e9841, $c39dea662ab37110$export$f14c2a28fc1e9841)) : (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(10, 10)
        };
    }
}




// 2025-05-20
// Blobs not supported on iPad in private tabs.
// Blobs are required for indexed db to be useful. Data urls would be wasteful.
const $4371a4d2eefbd53f$var$areBlobUrlsSupported = async function() {
    let result = true;
    const dbName = 'kl-blob-url-test';
    try {
        const blob = new Blob([
            'test'
        ], {
            type: 'text/plain'
        });
        const db = await (0, $fc4403c8ee6a33dc$export$f85d414d081200d8)(new Promise((resolve, reject)=>{
            const request = indexedDB.open(dbName, 1);
            request.onerror = ()=>reject(request.error);
            request.onsuccess = ()=>resolve(request.result);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                db.createObjectStore('testStore');
            };
        }), 'areBlobUrlsSupported.createDb');
        await (0, $fc4403c8ee6a33dc$export$f85d414d081200d8)(new Promise((resolve, reject)=>{
            const transaction = db.transaction('testStore', 'readwrite');
            const store = transaction.objectStore('testStore');
            const request = store.put(blob, 'testStore');
            transaction.onabort = ()=>resolve();
            request.onsuccess = ()=>resolve();
            request.onerror = ()=>reject(request.error);
        }), 'areBlobUrlsSupported.storeBlob');
        db.close();
    } catch (e) {
        result = false;
    }
    try {
        indexedDB.deleteDatabase(dbName);
    } catch (e) {
    // IDBFactory.deleteDatabase() called in an invalid security context
    }
    return result;
};
class $4371a4d2eefbd53f$export$7d13d7c63364db4b {
    disconnect() {
        var _this_db;
        (_this_db = this.db) === null || _this_db === void 0 ? void 0 : _this_db.close();
        this.db = undefined;
    }
    async autoDisconnectWrapper(activity) {
        try {
            this.openTransactionCount++;
            clearTimeout(this.disconnectTimeout);
            return await activity();
        } finally{
            this.openTransactionCount--;
            if (this.openTransactionCount === 0) {
                // When a new version of the app upgrades the DB, old tabs holding open connections would
                // block the upgrade.
                // -> Close DB connections when inactive.
                clearTimeout(this.disconnectTimeout);
                this.disconnectTimeout = setTimeout(()=>this.disconnect(), 1000);
            }
        }
    }
    async openDb() {
        if (this.db) return;
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.dbName, this.dbVersion);
            request.onupgradeneeded = (event)=>{
                this.upgrader(event);
            };
            request.onsuccess = (event)=>{
                this.db = event.target.result;
                this.db.onversionchange = ()=>{
                    this.isAvailable = false;
                    this.disconnect();
                    throw new Error('idb onversionchange');
                };
                resolve();
            };
            request.onerror = (event)=>{
                this.isAvailable = false;
                reject(event.target.error);
            };
        });
    }
    getTransaction(storeName, mode) {
        if (!this.storeNames.includes(storeName)) throw new Error(`indexedDb store "${storeName}" not found in "${this.dbName}"`);
        const transaction = this.db.transaction(storeName, mode);
        return {
            transaction: transaction,
            objectStore: transaction.objectStore(storeName)
        };
    }
    init(dbName, objectStoreNames, version, upgrader) {
        if (this.dbName !== '') throw new Error('IndexedDb already initialized');
        this.dbName = dbName;
        this.storeNames = [
            ...objectStoreNames
        ];
        this.dbVersion = version;
        this.upgrader = upgrader;
    }
    async testConnection() {
        this.isAvailable = this.isAvailable && await $4371a4d2eefbd53f$var$areBlobUrlsSupported();
        if (!this.isAvailable) return this.isAvailable;
        try {
            for (const name of this.storeNames){
                await (0, $fc4403c8ee6a33dc$export$f85d414d081200d8)(this.openDb(), 'indexed-db.testConnection.openDb');
                const { transaction: transaction } = this.getTransaction(name, 'readonly');
                transaction.abort();
            }
        } catch (e) {
            this.isAvailable = false;
        }
        return this.isAvailable;
    }
    async set(store, key, value) {
        return this.autoDisconnectWrapper(async ()=>{
            await this.openDb();
            return await new Promise((resolve, reject)=>{
                const { transaction: transaction, objectStore: objectStore } = this.getTransaction(store, 'readwrite');
                transaction.onabort = ()=>reject(transaction.error);
                const request = objectStore.put(value, key);
                request.onsuccess = ()=>{
                    resolve();
                };
                request.onerror = ()=>reject(request.error);
            });
        });
    }
    async get(store, key) {
        return this.autoDisconnectWrapper(async ()=>{
            await this.openDb();
            return await new Promise((resolve, reject)=>{
                const { transaction: transaction, objectStore: objectStore } = this.getTransaction(store, 'readonly');
                transaction.onabort = ()=>reject(transaction.error);
                const request = objectStore.get(key);
                request.onsuccess = ()=>resolve(request.result);
                request.onerror = ()=>reject(request.error);
            });
        });
    }
    async has(store, key) {
        return this.autoDisconnectWrapper(async ()=>{
            await this.openDb();
            return await new Promise((resolve, reject)=>{
                const { transaction: transaction, objectStore: objectStore } = this.getTransaction(store, 'readonly');
                transaction.onabort = ()=>reject(transaction.error);
                const request = objectStore.getKey(key);
                request.onsuccess = ()=>resolve(!!request.result);
                request.onerror = ()=>reject(request.error);
            });
        });
    }
    async getKeys(store) {
        return this.autoDisconnectWrapper(async ()=>{
            await this.openDb();
            return await new Promise((resolve, reject)=>{
                const { transaction: transaction, objectStore: objectStore } = this.getTransaction(store, 'readonly');
                transaction.onabort = ()=>reject(transaction.error);
                const request = objectStore.getAllKeys();
                request.onsuccess = ()=>resolve(request.result.map((key)=>key.toString()));
                request.onerror = ()=>reject(request.error);
            });
        });
    }
    async remove(store, key) {
        return this.autoDisconnectWrapper(async ()=>{
            await this.openDb();
            return await new Promise((resolve, reject)=>{
                const { transaction: transaction, objectStore: objectStore } = this.getTransaction(store, 'readwrite');
                transaction.onabort = ()=>reject(transaction.error);
                const request = objectStore.delete(key);
                request.onsuccess = ()=>{
                    resolve();
                };
                request.onerror = ()=>reject(request.error);
            });
        });
    }
    async bulkSet(store, entries) {
        return this.autoDisconnectWrapper(async ()=>{
            await this.openDb();
            return new Promise((resolve, reject)=>{
                const { transaction: transaction, objectStore: objectStore } = this.getTransaction(store, 'readwrite');
                transaction.onabort = ()=>reject(transaction.error);
                transaction.onerror = ()=>reject(transaction.error);
                transaction.oncomplete = ()=>resolve();
                for (const { key: key, value: value } of entries){
                    const request = objectStore.put(value, key);
                    request.onerror = ()=>reject(request.error);
                }
            });
        });
    }
    async bulkGet(store, keys) {
        return this.autoDisconnectWrapper(async ()=>{
            await this.openDb();
            return new Promise((resolve, reject)=>{
                const results = {};
                const { transaction: transaction, objectStore: objectStore } = this.getTransaction(store, 'readonly');
                transaction.onabort = ()=>reject(transaction.error);
                transaction.onerror = ()=>reject(transaction.error);
                transaction.oncomplete = ()=>resolve(results);
                keys.forEach((key, idx)=>{
                    const request = objectStore.get(key);
                    request.onsuccess = ()=>results['' + key] = request.result;
                    request.onerror = ()=>reject(request.error);
                });
            });
        });
    }
    async bulkRemove(store, keys) {
        return this.autoDisconnectWrapper(async ()=>{
            await this.openDb();
            return new Promise((resolve, reject)=>{
                const { transaction: transaction, objectStore: objectStore } = this.getTransaction(store, 'readwrite');
                transaction.onabort = ()=>reject(transaction.error);
                transaction.onerror = ()=>reject(transaction.error);
                transaction.oncomplete = ()=>resolve();
                for (const key of keys){
                    const request = objectStore.delete(key);
                    request.onerror = ()=>reject(request.error);
                }
            });
        });
    }
    getIsAvailable() {
        return this.isAvailable;
    }
    destroy() {
        this.disconnect();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.dbVersion = -1;
        this.dbName = '';
        this.storeNames = [];
        this.upgrader = ()=>{};
        this.isAvailable = true;
        this.openTransactionCount = 0;
    }
}


let $2a3419e253354ddb$var$dbName = 'Klecks';
function $2a3419e253354ddb$export$d21786ffb58aa58a(name) {
    $2a3419e253354ddb$var$dbName = name;
}
function $2a3419e253354ddb$export$620c18ffd80459f1() {
    return $2a3419e253354ddb$var$dbName;
}
const $2a3419e253354ddb$export$aa8c311c20a0e91f = 'RecoveryStore'; // key is string
const $2a3419e253354ddb$export$ca20f3c4ac3fef1e = 'ImageDataStore'; // key is string
const $2a3419e253354ddb$export$2ca9aea562746b89 = 'ProjectStore'; // key is number
const $2a3419e253354ddb$export$94f2205ed1af0024 = [
    $2a3419e253354ddb$export$aa8c311c20a0e91f,
    $2a3419e253354ddb$export$ca20f3c4ac3fef1e,
    $2a3419e253354ddb$export$2ca9aea562746b89
];
const $2a3419e253354ddb$export$889f6d04a9c72786 = 2;
const $2a3419e253354ddb$export$a11d3f631bfac1e6 = (event)=>{
    const oldVersion = event.oldVersion;
    const db = event.target.result;
    if (oldVersion < 1) {
        const store = db.createObjectStore($2a3419e253354ddb$export$2ca9aea562746b89, {
            keyPath: 'id'
        });
        store.createIndex('id', 'id', {
            unique: true
        });
    }
    if (oldVersion < 2) {
        db.createObjectStore($2a3419e253354ddb$export$ca20f3c4ac3fef1e);
        db.createObjectStore($2a3419e253354ddb$export$aa8c311c20a0e91f);
    }
};
const $2a3419e253354ddb$export$8d693ea241b9d9a6 = new (0, $4371a4d2eefbd53f$export$7d13d7c63364db4b)({});





function $e42d359db0fc5c76$export$96cc750ad8f2b8b0(input) {
    return typeof input === 'object' && input !== null && 'id' in input && typeof input.id === 'string';
}
async function $e42d359db0fc5c76$var$createFallbackThumbnail() {
    // very basic fallback. only affects data stored before version 0.5.1 (2022)
    return await (0, $13d5aa49e37e2734$export$403d539f215df596)((0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas((0, $c39dea662ab37110$export$f14c2a28fc1e9841), (0, $c39dea662ab37110$export$f14c2a28fc1e9841)), 'image/png');
}
class $e42d359db0fc5c76$export$93d91060b9af7e2a {
    async lowLevelStore(project) {
        // get image data ids
        const rawOld = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$2ca9aea562746b89), 1);
        const deleteIds = [];
        if (rawOld) {
            if ($e42d359db0fc5c76$export$96cc750ad8f2b8b0(rawOld.thumbnail)) deleteIds.push(rawOld.thumbnail.id);
            for (const layer of rawOld.layers)if ($e42d359db0fc5c76$export$96cc750ad8f2b8b0(layer.blob)) deleteIds.push(layer.blob.id);
        }
        // prepare for storing
        const imageDataList = [];
        const thumbnail = {
            id: (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)()
        };
        imageDataList.push({
            id: thumbnail.id,
            data: project.thumbnail
        });
        const layers = [];
        for (const layer of project.layers){
            const blob = {
                id: (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)()
            };
            imageDataList.push({
                id: blob.id,
                data: layer.blob
            });
            layers.push((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, layer), {
                blob: blob
            }));
        }
        const raw = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, project), {
            thumbnail: thumbnail,
            layers: layers
        });
        // store first. so nothing will be lost if something goes wrong
        for (const imageData of imageDataList)await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).set((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e), imageData.id, imageData.data);
        await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).set((0, $2a3419e253354ddb$export$2ca9aea562746b89), undefined, raw);
        // remove obsolete imageData
        for (const id of deleteIds)await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).remove((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e), id);
    }
    async lowLevelReadMeta() {
        const raw = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$2ca9aea562746b89), 1);
        if (!raw) return undefined;
        let thumbnail;
        if ($e42d359db0fc5c76$export$96cc750ad8f2b8b0(raw.thumbnail)) {
            const thumbnailReadResult = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e), raw.thumbnail.id);
            if ((0, $fc4403c8ee6a33dc$export$5bcd6e94ed871c88)(thumbnailReadResult)) thumbnail = thumbnailReadResult;
        } else thumbnail = raw.thumbnail;
        thumbnail = thumbnail !== null && thumbnail !== void 0 ? thumbnail : await $e42d359db0fc5c76$var$createFallbackThumbnail();
        var _raw_projectId;
        return {
            projectId: (_raw_projectId = raw.projectId) !== null && _raw_projectId !== void 0 ? _raw_projectId : (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)(),
            timestamp: raw.timestamp,
            thumbnail: thumbnail
        };
    }
    async lowLevelRead() {
        const raw = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$2ca9aea562746b89), 1);
        if (!raw) return undefined;
        let thumbnail;
        if ($e42d359db0fc5c76$export$96cc750ad8f2b8b0(raw.thumbnail)) {
            const thumbnailReadResult = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e), raw.thumbnail.id);
            if ((0, $fc4403c8ee6a33dc$export$5bcd6e94ed871c88)(thumbnailReadResult)) thumbnail = thumbnailReadResult;
        } else thumbnail = raw.thumbnail;
        thumbnail = thumbnail !== null && thumbnail !== void 0 ? thumbnail : await $e42d359db0fc5c76$var$createFallbackThumbnail();
        const layers = [];
        for (const layer of raw.layers){
            let blob;
            if ($e42d359db0fc5c76$export$96cc750ad8f2b8b0(layer.blob)) {
                const readResult = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e), layer.blob.id);
                if ((0, $fc4403c8ee6a33dc$export$5bcd6e94ed871c88)(readResult)) blob = readResult;
            } else blob = layer.blob;
            var _layer_isVisible, _layer_mixModeStr;
            layers.push((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, layer), {
                isVisible: (_layer_isVisible = layer.isVisible) !== null && _layer_isVisible !== void 0 ? _layer_isVisible : true,
                mixModeStr: (_layer_mixModeStr = layer.mixModeStr) !== null && _layer_mixModeStr !== void 0 ? _layer_mixModeStr : 'source-over',
                blob: blob
            }));
        }
        var _raw_projectId;
        return (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, raw), {
            projectId: (_raw_projectId = raw.projectId) !== null && _raw_projectId !== void 0 ? _raw_projectId : (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)(),
            thumbnail: thumbnail,
            layers: layers
        });
    }
    async lowLevelClear() {
        // get image data ids
        const rawOld = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$2ca9aea562746b89), 1);
        const deleteIds = [];
        if (rawOld) {
            if ($e42d359db0fc5c76$export$96cc750ad8f2b8b0(rawOld.thumbnail)) deleteIds.push(rawOld.thumbnail.id);
            for (const layer of rawOld.layers)if ($e42d359db0fc5c76$export$96cc750ad8f2b8b0(layer.blob)) deleteIds.push(layer.blob.id);
        }
        await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).remove((0, $2a3419e253354ddb$export$2ca9aea562746b89), 1);
        for (const id of deleteIds)await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).remove((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e), id);
    }
    emit(meta) {
        this.currentMeta = meta ? (0, $0616f0a0655c1023$export$71511d61b312f219)({}, meta) : undefined;
        this.listeners.forEach((item)=>{
            item.onUpdate(meta);
        });
    }
    updateTimestamp() {
        (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem('indexedDbUpdatedAt', '' + new Date().getTime());
    }
    async update() {
        try {
            this.emit(await this.readMeta());
        } catch (e) {
            if (e instanceof Error && e.message.indexOf('db-error') === 0) this.isAvailable = false;
        }
    }
    async read() {
        let storageProject;
        try {
            storageProject = await this.lowLevelRead();
        } catch (e) {
            this.isAvailable = false;
            throw new Error('db-error: ' + e);
        }
        if (!storageProject) return undefined;
        let result;
        try {
            result = await (0, $c39dea662ab37110$export$f3c1ac6650038646).readStorageProject(storageProject);
        } catch (e) {
            throw new Error('format-error: ' + e);
        }
        return result;
    }
    async readMeta() {
        let blobMeta;
        try {
            blobMeta = await this.lowLevelReadMeta();
        } catch (e) {
            this.isAvailable = false;
            throw new Error('db-error: ' + e);
        }
        if (!blobMeta) return undefined;
        let result;
        try {
            result = await (0, $c39dea662ab37110$export$f3c1ac6650038646).readStorageMeta(blobMeta);
        } catch (e) {
            throw new Error('format-error: ' + e);
        }
        return result;
    }
    async store(project) {
        try {
            const storageProject = await (0, $c39dea662ab37110$export$f3c1ac6650038646).createStorageProject(project);
            await this.lowLevelStore(storageProject);
        } catch (e) {
            this.isAvailable = false;
            throw new Error('db-error: ' + e);
        }
        this.updateTimestamp();
        setTimeout(async ()=>{
            const meta = await this.readMeta();
            this.emit(meta);
        });
    }
    async clear() {
        await this.lowLevelClear();
        this.updateTimestamp();
        setTimeout(()=>this.emit(), 0);
    }
    subscribe(listener) {
        if (this.listeners.includes(listener)) return;
        this.listeners.push(listener);
    }
    unsubscribe(listener) {
        for(let i = 0; i < this.listeners.length; i++)if (listener === this.listeners[i]) {
            this.listeners.splice(i, 1);
            return;
        }
    }
    getIsAvailable() {
        this.isAvailable = this.isAvailable && (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).getIsAvailable();
        return this.isAvailable;
    }
    getCurrentMeta() {
        return this.currentMeta;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.listeners = [];
        this.isAvailable = true;
        if (!(0, $2a3419e253354ddb$export$8d693ea241b9d9a6).getIsAvailable()) {
            this.isAvailable = false;
            return;
        }
        window.addEventListener('storage', async (e)=>{
            if (e.key !== 'indexedDbUpdatedAt' || this.listeners.length === 0) return;
            await this.update();
        });
    }
}









var $3be8226e2ed33509$exports = {};
$3be8226e2ed33509$exports = $parcel$resolve("k0KEP");



















async function $9a850f0c4a7704d4$export$151da384cc114748() {
    const keys = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).getKeys((0, $2a3419e253354ddb$export$aa8c311c20a0e91f));
    return keys.map((item)=>+item);
}
async function $9a850f0c4a7704d4$export$1fabc8133caf46e2() {
    return await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).getKeys((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e));
}
async function $9a850f0c4a7704d4$export$907f896f070645af() {
    const ids = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).getKeys((0, $2a3419e253354ddb$export$aa8c311c20a0e91f));
    const recoveries = await Promise.all(ids.map((id)=>{
        return (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), id);
    }));
    await Promise.all(recoveries.map((recovery, index)=>{
        if (recovery.timestamp < new Date().getTime() - (0, $b2aa268a64dedc9f$export$9c6f65e1c28cc08e)) return $9a850f0c4a7704d4$export$9c7685b8d5826628(ids[index]);
        return Promise.resolve();
    }));
}
async function $9a850f0c4a7704d4$var$loadFromImageDataStore(id, commonCtx) {
    const result = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e), id);
    if (!result) {
        commonCtx.clearRect(0, 0, (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
        return commonCtx.getImageData(0, 0, (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
    }
    if ((0, $fc4403c8ee6a33dc$export$5bcd6e94ed871c88)(result)) {
        let image;
        try {
            image = await (0, $c39dea662ab37110$export$fe58198efe02b173)(result);
        } catch (e) {
        // someday maybe pass error with result, to show user something went wrong
        }
        var _image_width;
        commonCtx.canvas.width = (_image_width = image === null || image === void 0 ? void 0 : image.width) !== null && _image_width !== void 0 ? _image_width : commonCtx.canvas.width;
        var _image_height;
        commonCtx.canvas.height = (_image_height = image === null || image === void 0 ? void 0 : image.height) !== null && _image_height !== void 0 ? _image_height : commonCtx.canvas.height;
        // no clear needed, because size was set
        image && commonCtx.drawImage(image, 0, 0);
        return commonCtx.getImageData(0, 0, commonCtx.canvas.width, commonCtx.canvas.height);
    }
    return result;
}
async function $9a850f0c4a7704d4$var$getRawRecoveryProject(id) {
    return await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), '' + id);
}
async function $9a850f0c4a7704d4$export$4484d7cddf79b0c1(candidateIds) {
    const imageDataIds = candidateIds !== null && candidateIds !== void 0 ? candidateIds : await $9a850f0c4a7704d4$export$1fabc8133caf46e2();
    const usedIds = new Set();
    const recoveryIds = await $9a850f0c4a7704d4$export$151da384cc114748();
    for (const id of recoveryIds){
        const raw = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), '' + id);
        if (!raw) continue;
        for (const layer of raw.layers){
            for (const tile of layer.image)if (!(0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) usedIds.add(tile.id);
        }
        usedIds.add(raw.thumbnail);
    }
    // also have to check browser storage store
    const browserStorageRaw = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$2ca9aea562746b89), 1);
    if (browserStorageRaw) {
        if ((0, $e42d359db0fc5c76$export$96cc750ad8f2b8b0)(browserStorageRaw.thumbnail)) usedIds.add(browserStorageRaw.thumbnail.id);
        for (const layer of browserStorageRaw.layers)if ((0, $e42d359db0fc5c76$export$96cc750ad8f2b8b0)(layer.blob)) usedIds.add(layer.blob.id);
    }
    // remove entries
    await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).bulkRemove((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e), imageDataIds.filter((id)=>!usedIds.has(id)));
}
async function $9a850f0c4a7704d4$export$a6d4bfb7a7d18ef3(tabId) {
    const raw = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), '' + tabId);
    if (raw === undefined) return undefined;
    // shared canvas to load tiles
    const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas((0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
    // speed up by loading in parallel
    const layers = [];
    await Promise.all(raw.layers.map(async (layerSerialized, index)=>{
        const tiles = [];
        for(let index = 0; index < layerSerialized.image.length; index++){
            const tile = layerSerialized.image[index];
            if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) tiles.push(tile);
            else tiles.push({
                id: tile.id,
                data: await $9a850f0c4a7704d4$var$loadFromImageDataStore(tile.id, ctx)
            });
        }
        layers[index] = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, layerSerialized), {
            image: tiles
        });
    }));
    var _raw_projectId;
    return {
        project: {
            projectId: (_raw_projectId = raw.projectId) !== null && _raw_projectId !== void 0 ? _raw_projectId : (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)(),
            width: raw.width,
            height: raw.height,
            layers: layers
        },
        timestamp: 0,
        thumbnail: await $9a850f0c4a7704d4$var$getThumbnail(raw.thumbnail)
    };
}
async function $9a850f0c4a7704d4$var$getThumbnail(id) {
    const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas((0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6), (0, $d2dccce11beb16cf$export$f7bc58374d6bc9b6));
    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
    const imageData = await $9a850f0c4a7704d4$var$loadFromImageDataStore(id, ctx);
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    ctx.putImageData(imageData, 0, 0);
    return canvas;
}
async function $9a850f0c4a7704d4$export$896fee2a85b1fc93(oldId, newId) {
    const storedProjectSerialized = await $9a850f0c4a7704d4$var$getRawRecoveryProject(oldId);
    if (!storedProjectSerialized) // nothing to do
    return false;
    storedProjectSerialized.timestamp = new Date().getTime();
    await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).set((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), '' + newId, storedProjectSerialized);
    await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).remove((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), '' + oldId);
    return true;
}
async function $9a850f0c4a7704d4$export$b9ecabbf4820fa1b(tabId, composed, getThumbnail) {
    let orphanCandidates;
    try {
        // get thumbnail early to be accurate
        const fit = (0, $fc4403c8ee6a33dc$export$fa55905620c22535)(composed.size.width, composed.size.height, (0, $b2aa268a64dedc9f$export$b5a0d0be1c619a31), (0, $b2aa268a64dedc9f$export$c9c3d910b57c6d44));
        const thumbCanvas = getThumbnail(fit.width / composed.size.width);
        const sortedComposedLayers = Object.values(composed.layerMap).sort((0, $a57b9cfc6d913e03$export$87eabc555ccfbb9f));
        // make a list of existing imageData ids in A (stored project)
        const storedProjectSerialized = await (0, $fc4403c8ee6a33dc$export$f85d414d081200d8)($9a850f0c4a7704d4$var$getRawRecoveryProject(tabId), 'storeRecovery.getRawRecoveryProject');
        const storedImageDataIds = new Set(storedProjectSerialized === null || storedProjectSerialized === void 0 ? void 0 : storedProjectSerialized.layers.flatMap((layer)=>{
            return layer.image.map((tile)=>!(0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile) ? tile.id : undefined).filter((id)=>id !== undefined);
        }));
        storedProjectSerialized && storedImageDataIds.add(storedProjectSerialized.thumbnail);
        // to help calculate updated memoryEstimateBytes
        const storedImageDataSizes = {};
        storedProjectSerialized && storedProjectSerialized.layers.forEach((layer)=>{
            layer.image.forEach((tile)=>{
                if (!(0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) storedImageDataSizes[tile.id] = tile.sizeBytes || 0;
            });
        });
        // make a list of imageData ids in B (to be stored)
        const idsFromProject = new Set(sortedComposedLayers.flatMap((layer)=>{
            return layer.tiles.flatMap((tile)=>{
                return (0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile) ? [] : [
                    tile.id
                ];
            });
        }));
        // the to delete list: not in B (aka no longer stored)
        orphanCandidates = [
            ...storedImageDataIds
        ].filter((id)=>{
            return !idsFromProject.has(id);
        });
        const layers = [];
        const imageDataList = [];
        // estimate memory
        let memoryEstimateBytes = 0;
        for (const composedLayer of sortedComposedLayers)layers.push({
            name: composedLayer.name,
            isVisible: composedLayer.isVisible,
            opacity: composedLayer.opacity,
            mixModeStr: composedLayer.mixModeStr,
            image: await (async ()=>{
                const result = [];
                for (const tile of composedLayer.tiles)if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) {
                    result.push(tile);
                    memoryEstimateBytes += tile.fill.length;
                } else {
                    let size = 0;
                    if (storedImageDataIds.has(tile.id)) size = storedImageDataSizes[tile.id];
                    else {
                        imageDataList.push({
                            id: tile.id,
                            data: tile.data
                        });
                        size = tile.data.width * tile.data.height * 4; // 4 channels, each 1 byte
                    }
                    memoryEstimateBytes += size;
                    result.push({
                        id: tile.id,
                        sizeBytes: size
                    });
                }
                return result;
            })()
        });
        const thumbImageData = {
            id: (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)(),
            data: (()=>{
                const thumbCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(thumbCanvas);
                return thumbCtx.getImageData(0, 0, thumbCanvas.width, thumbCanvas.height);
            })()
        };
        imageDataList.push(thumbImageData);
        memoryEstimateBytes += thumbImageData.data.width * thumbImageData.data.height * 4; // 4 channels, each 1 byte
        const serialized = {
            projectId: composed.projectId.value,
            width: composed.size.width,
            height: composed.size.height,
            timestamp: new Date().getTime(),
            thumbnail: thumbImageData.id,
            layers: layers,
            memoryEstimateBytes: memoryEstimateBytes
        };
        // check will we be over the memory limit - if so, removed oldest drawings until we won't.
        const totalExceptDrawingBytes = await (0, $fc4403c8ee6a33dc$export$f85d414d081200d8)($9a850f0c4a7704d4$var$getTotalMemoryExceptCurrentDrawing(tabId), 'storeRecovery.getTotalMemory');
        if (totalExceptDrawingBytes + memoryEstimateBytes > (0, $b2aa268a64dedc9f$export$2740edb783d24e35)) {
            const overLimitByBytes = totalExceptDrawingBytes + memoryEstimateBytes - (0, $b2aa268a64dedc9f$export$2740edb783d24e35);
            let toBeRemovedBytes = 0;
            const idsToRemove = [];
            const metas = (await $9a850f0c4a7704d4$var$getAllMeta()).sort((a, b)=>{
                if (a.timestamp > b.timestamp) return 1;
                if (a.timestamp < b.timestamp) return -1;
                return 0;
            });
            metas.forEach((meta)=>{
                if (toBeRemovedBytes >= overLimitByBytes) // removed enough
                return;
                idsToRemove.push(meta.id);
                toBeRemovedBytes += meta.memoryEstimateBytes;
            });
            // also make sure to remove the imagedata
            for (const id of idsToRemove)await $9a850f0c4a7704d4$export$9c7685b8d5826628(id);
        }
        // store first. so nothing will be lost if something goes wrong
        await (0, $fc4403c8ee6a33dc$export$f85d414d081200d8)((0, $2a3419e253354ddb$export$8d693ea241b9d9a6).bulkSet((0, $2a3419e253354ddb$export$ca20f3c4ac3fef1e), imageDataList.map((item)=>{
            return {
                key: item.id,
                value: item.data
            };
        })), 'storeRecovery.storeTile', 30000);
        await (0, $fc4403c8ee6a33dc$export$f85d414d081200d8)((0, $2a3419e253354ddb$export$8d693ea241b9d9a6).set((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), '' + tabId, serialized), 'storeRecovery.storeRecovery');
    } finally{
        /*
        Orphaned tiles are possible and must be cleaned up, even if there's a timeout or other exception.
         */ await (0, $fc4403c8ee6a33dc$export$f85d414d081200d8)($9a850f0c4a7704d4$export$4484d7cddf79b0c1(orphanCandidates), 'storeRecovery.removeOrphans', 8000);
    }
}
async function $9a850f0c4a7704d4$export$9c7685b8d5826628(id) {
    const recovery = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), id);
    if (!recovery) return;
    await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).remove((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), id);
    const orphanCandidates = [
        recovery.thumbnail
    ];
    for (const layer of recovery.layers){
        for (const tile of layer.image)if (!(0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) orphanCandidates.push(tile.id);
    }
    // prevent deletion of tiles referenced by multiple recoveries.
    await $9a850f0c4a7704d4$export$4484d7cddf79b0c1(orphanCandidates);
}
async function $9a850f0c4a7704d4$var$getAllMeta() {
    const ids = await $9a850f0c4a7704d4$export$151da384cc114748();
    const result = [];
    for (const id of ids)result.push(await $9a850f0c4a7704d4$export$8548546c0aa631e6('' + id));
    return result;
}
async function $9a850f0c4a7704d4$var$getTotalMemoryExceptCurrentDrawing(tabId) {
    const ids = await $9a850f0c4a7704d4$export$151da384cc114748();
    let result = 0;
    for (const id of ids){
        if (id === tabId) continue;
        const meta = await $9a850f0c4a7704d4$export$8548546c0aa631e6('' + id);
        result += meta.memoryEstimateBytes;
    }
    return result;
}
async function $9a850f0c4a7704d4$export$8548546c0aa631e6(drawingId, includeThumbnail) {
    const raw = await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).get((0, $2a3419e253354ddb$export$aa8c311c20a0e91f), drawingId);
    if (raw === undefined) throw new Error('drawing not found');
    const parsed = raw;
    return {
        id: drawingId,
        width: parsed.width,
        height: parsed.height,
        thumbnail: includeThumbnail ? await $9a850f0c4a7704d4$var$getThumbnail(parsed.thumbnail) : undefined,
        timestamp: parsed.timestamp,
        memoryEstimateBytes: parsed.memoryEstimateBytes
    };
}





const $a12bfee0fab37a82$var$originId = (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)();
class $a12bfee0fab37a82$export$84f7c9d87f70395e {
    getLsKey() {
        return this.localStoragePrefix + this.name;
    }
    postMessage(message) {
        if (this.broadcastChannel) this.broadcastChannel.postMessage(message);
        else {
            const now = new Date().getTime();
            let raw = null;
            try {
                raw = (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem(this.getLsKey());
            } catch (error) {
            // probably invalid value -> reset
            }
            let entries = raw === null ? [] : JSON.parse(raw);
            entries = entries.filter((entry)=>{
                // delete old entries
                return entry.timestamp > now - this.maxAgeMs;
            });
            entries.push({
                timestamp: now,
                originId: $a12bfee0fab37a82$var$originId,
                message: message
            });
            (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem(this.getLsKey(), JSON.stringify(entries));
        }
    }
    subscribe(listener) {
        if (this.broadcastChannel) {
            const preListener = (message)=>listener(message.data);
            this.broadcastChannelListeners.push({
                preListener: preListener,
                listener: listener
            });
            this.broadcastChannel.addEventListener('message', preListener);
        } else {
            if (this.localStorageListeners.size === 0) window.addEventListener('storage', this.onLocalStorageChange);
            this.localStorageListeners.add(listener);
        }
    }
    unsubscribe(listener) {
        if (this.broadcastChannel) {
            const match = this.broadcastChannelListeners.find((item)=>item.listener === listener);
            if (match) this.broadcastChannel.removeEventListener('message', match.preListener);
        } else {
            this.localStorageListeners.delete(listener);
            if (this.localStorageListeners.size === 0) window.removeEventListener('storage', this.onLocalStorageChange);
        }
    }
    close() {
        if (this.broadcastChannel) this.broadcastChannel.close();
    }
    // ----------------------------------- public ----------------------------------
    constructor(name){
        this.name = name;
        this.broadcastChannelListeners = [];
        this.lastReadTimestamp = new Date().getTime();
        this.maxAgeMs = 10000;
        this.localStoragePrefix = 'cross-tab-channel--';
        this.localStorageListeners = new Set();
        this.onLocalStorageChange = (e)=>{
            if (e.key !== this.getLsKey() || e.newValue === null) // case 1: irrelevant key changed
            // case 2: null means no new message
            // -> noop
            return;
            try {
                const entries = JSON.parse(e.newValue);
                entries.forEach((entry)=>{
                    if (entry.originId === $a12bfee0fab37a82$var$originId || entry.timestamp <= this.lastReadTimestamp) // ignore messages from our own tab, or that aren't new
                    return;
                    this.lastReadTimestamp = entry.timestamp;
                    this.localStorageListeners.forEach((listener)=>listener(entry.message));
                });
            } catch (error) {
                // probably invalid value -> reset
                (0, $0ecef66681b62a8c$export$19fffca37ef3e106).removeItem(this.getLsKey());
            }
        };
        if (typeof BroadcastChannel !== 'undefined') this.broadcastChannel = new BroadcastChannel(name);
    }
}



const $b2aa268a64dedc9f$export$b5a0d0be1c619a31 = 300;
const $b2aa268a64dedc9f$export$c9c3d910b57c6d44 = 180;
const $b2aa268a64dedc9f$export$9c6f65e1c28cc08e = 604800000; // 1 week
const $b2aa268a64dedc9f$export$2740edb783d24e35 = 1e9;
const $b2aa268a64dedc9f$var$FIRST_RECOVERY_AFTER_MS = 300000;
const $b2aa268a64dedc9f$export$9bd5f64d90351bc8 = 8;
const $b2aa268a64dedc9f$var$SUBSEQUENT_RECOVERY_AFTER_MS = 60000;
const $b2aa268a64dedc9f$var$SUBSEQUENT_RECOVERY_AFTER_CHANGES = 4;
const $b2aa268a64dedc9f$export$c72bbe997bb2ffd = false;
const $b2aa268a64dedc9f$export$fc41dada2b63b3f2 = false;
function $b2aa268a64dedc9f$export$42c3f3255a992e7(value) {
    if (value === undefined) {
        history.replaceState(null, '', ' ');
        return;
    }
    // avoid creating a new history state
    history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.search + '#' + value);
}
function $b2aa268a64dedc9f$var$getHash() {
    // returns without the "#"
    return window.location.hash ? window.location.hash.substring(1) : undefined;
}
const $b2aa268a64dedc9f$var$ignoredHashes = [
    'licenses'
];
function $b2aa268a64dedc9f$var$hashToTabId(rawHash) {
    if (rawHash === undefined || $b2aa268a64dedc9f$var$ignoredHashes.includes(rawHash)) return undefined;
    const num = +rawHash;
    if (isNaN(num) || num < 0 || num % 1 !== 0) return undefined;
    return num;
}
function $b2aa268a64dedc9f$var$genNewId(takenIds) {
    const limit = 1000;
    if (takenIds.length >= limit) throw new Error('No available IDs');
    const idSet = new Set(takenIds);
    const pool = (0, $fc4403c8ee6a33dc$export$7f1ebd623f131021)(limit, 0).map((_, index)=>index).filter((id)=>!idSet.has(id));
    const index = Math.floor(Math.random() * pool.length);
    if (pool[index] === undefined) throw new Error('No available IDs');
    return pool[index];
}
class $b2aa268a64dedc9f$export$36c5c4b26ead79bd {
    announceTabId() {
        this.crossTabChannel.postMessage({
            type: 'new-tab'
        });
    }
    initListeners() {
        document.addEventListener('visibilitychange', ()=>{
            if (document.hidden) return;
            // changes may have happened since tab last visible
            // might not register a tab is closed without timeout
            setTimeout(()=>{
                this.update();
            }, 500);
        });
        window.addEventListener('focus', ()=>{
            setTimeout(()=>{
                this.update();
            }, 500);
        });
        this.crossTabChannel.subscribe((message)=>{
            if (message.type === 'new-tab') {
                if (document.hidden) // we'll update when tab visible. noop.
                return;
                setTimeout(()=>{
                    this.update();
                }, 500);
            }
            if (message.type === 'request-ids') {
                if (this.tabId !== undefined) this.crossTabChannel.postMessage({
                    type: 'response-ids',
                    id: this.tabId
                });
            }
        });
        // I think this is not needed
        let debounceTimeout;
    /*KL_INDEXED_DB.addListener(async () => {
            if (document.hidden) {
                return;
            }
            console.log('indexed db change!');
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(async () => {
                this.update();
            }, 100);
        });*/ }
    async emitUpdate() {
        if (!(0, $2a3419e253354ddb$export$8d693ea241b9d9a6).getIsAvailable()) return;
        const ids = await (0, $9a850f0c4a7704d4$export$151da384cc114748)();
        const otherTabIds = await this.getIdsFromTabs();
        const tabIds = $b2aa268a64dedc9f$export$c72bbe997bb2ffd ? ids : ids.filter((id)=>!otherTabIds.includes(id) && id !== this.tabId);
        const drawings = await Promise.all(tabIds.map((id)=>{
            return (0, $9a850f0c4a7704d4$export$8548546c0aa631e6)('' + id, true);
        }));
        const totalMemoryUsedBytes = await this.getTotalMemoryUsedBytes();
        this.listeners.forEach((listener)=>{
            listener(drawings, totalMemoryUsedBytes);
        });
    }
    setHash(id) {
        $b2aa268a64dedc9f$export$42c3f3255a992e7(id === undefined ? undefined : '' + id);
        this.announceTabId();
    }
    async getIdsFromTabs() {
        this.crossTabChannel.postMessage({
            type: 'request-ids'
        });
        const result = [];
        const onMessage = (message)=>{
            if (message.type === 'response-ids') result.push(+message.id);
        };
        this.crossTabChannel.subscribe(onMessage);
        await (0, $fc4403c8ee6a33dc$export$e772c8ff12451969)(100);
        this.crossTabChannel.unsubscribe(onMessage);
        return result;
    }
    async getTotalMemoryUsedBytes() {
        const ids = await (0, $9a850f0c4a7704d4$export$151da384cc114748)();
        let result = 0;
        for (const id of ids){
            const meta = await (0, $9a850f0c4a7704d4$export$8548546c0aa631e6)('' + id);
            result += meta.memoryEstimateBytes;
        }
        return result;
    }
    async getRecovery() {
        try {
            // is there a tabId?
            const initialTabId = $b2aa268a64dedc9f$var$hashToTabId($b2aa268a64dedc9f$var$getHash());
            if (initialTabId === undefined) {
                this.noRecoveryReason = 'noTabIdHash';
                // we get a tabId later
                return undefined;
            }
            // is there another tab with the same tabId?
            const openTabIds = await this.getIdsFromTabs();
            if (openTabIds.includes(initialTabId)) {
                this.noRecoveryReason = 'alreadyOpened';
                // Already exists -> unset tabId. Nothing to load.
                this.setHash(undefined);
                return undefined;
            }
            // is id in storage?
            const storedIds = await (0, $9a850f0c4a7704d4$export$151da384cc114748)();
            if (!storedIds.includes(initialTabId)) {
                this.noRecoveryReason = 'idNotFound';
                // not found -> unset tabId and abort
                this.setHash(undefined);
                return undefined;
            }
            // change id of drawing and tab
            const newId = $b2aa268a64dedc9f$var$genNewId(storedIds);
            if (!await (0, $9a850f0c4a7704d4$export$896fee2a85b1fc93)(initialTabId, newId)) {
                this.noRecoveryReason = 'idChangeFailed';
                this.setHash(undefined);
                return undefined;
            }
            this.setHash(newId); // update hash
            const result = await (0, $9a850f0c4a7704d4$export$a6d4bfb7a7d18ef3)(newId);
            if (result) this.tabId = newId;
            setTimeout(()=>{
                // don't disrupt loading
                (0, $9a850f0c4a7704d4$export$4484d7cddf79b0c1)();
            });
            return result;
        } finally{
            setTimeout(()=>{
                // don't disrupt loading
                (0, $9a850f0c4a7704d4$export$4484d7cddf79b0c1)();
            }, 2000);
        }
    }
    setKlHistory(klHistory) {
        this.klHistory = klHistory;
        let startTime = new Date().getTime();
        let lastStoredChangeCount = 0;
        this.klHistory.addListener(async ()=>{
            if (this.isStoring) return;
            const changeCount = this.klHistory.getChangeCount();
            if (!$b2aa268a64dedc9f$export$fc41dada2b63b3f2) {
                const deltaMs = new Date().getTime() - startTime;
                // initial store after 5 minutes
                if (this.tabId === undefined && (deltaMs < $b2aa268a64dedc9f$var$FIRST_RECOVERY_AFTER_MS || changeCount < $b2aa268a64dedc9f$export$9bd5f64d90351bc8)) return;
                // subsequent store after 1 minutes
                if (this.tabId !== undefined && (deltaMs < $b2aa268a64dedc9f$var$SUBSEQUENT_RECOVERY_AFTER_MS || changeCount - lastStoredChangeCount < $b2aa268a64dedc9f$var$SUBSEQUENT_RECOVERY_AFTER_CHANGES)) return;
            }
            let isFreshDrawing = false;
            if (!this.tabId) {
                const storedIds = await (0, $fc4403c8ee6a33dc$export$f85d414d081200d8)((0, $9a850f0c4a7704d4$export$151da384cc114748)(), 'setKlHistory.getIdsFromStore');
                this.tabId = $b2aa268a64dedc9f$var$genNewId(storedIds);
                isFreshDrawing = true;
            }
            this.isStoring = true;
            try {
                await (0, $9a850f0c4a7704d4$export$b9ecabbf4820fa1b)(this.tabId, this.klHistory.getComposed(), this.getThumbnail);
                startTime = new Date().getTime();
            } catch (e) {
                setTimeout(()=>{
                    throw e;
                });
            } finally{
                this.isStoring = false;
            }
            if (isFreshDrawing) {
                this.setHash(this.tabId);
                await (0, $9a850f0c4a7704d4$export$907f896f070645af)();
            }
            startTime = new Date().getTime();
            lastStoredChangeCount = changeCount;
        });
    }
    setGetThumbnail(getThumbnail) {
        this.getThumbnail = getThumbnail;
    }
    /**
     * Listener will be informed about recoveries in closed tabs.
     * totalMemoryUsesBytes includes recoveries in open tabs
     */ subscribe(listener) {
        this.listeners.add(listener);
    }
    unsubscribe(listener) {
        this.listeners.delete(listener);
    }
    // re-checks what recoveries exist
    async update() {
        if (this.listeners.size > 0) await this.emitUpdate();
    }
    async remove(recoveryId) {
        await (0, $9a850f0c4a7704d4$export$9c7685b8d5826628)('' + recoveryId);
        this.update();
    }
    getTabId() {
        return this.tabId;
    }
    getNoRecoveryReason() {
        return this.noRecoveryReason;
    }
    destroy() {
    // todo
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.klHistory = {};
        this.isStoring = false;
        this.listeners = new Set();
        this.crossTabChannel = new (0, $a12bfee0fab37a82$export$84f7c9d87f70395e)('kl-tab-communication');
        this.initListeners();
    }
}





var $aa54b3f0adef983e$export$48c2d0f2f545ac27;
$aa54b3f0adef983e$export$48c2d0f2f545ac27 = `-c3MRW_preview`;





class $aa79ddb31a9becd1$export$feb3da9ac0115d49 {
    async update(metas, totalMemoryUsedBytes) {
        const elements = [];
        metas.sort((a, b)=>{
            if (a.timestamp > b.timestamp) return -1;
            if (a.timestamp < b.timestamp) return 1;
            return 0;
        }).forEach((meta)=>{
            const recoverBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'a',
                className: 'kl-button kl-button-link',
                content: (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-recover'),
                custom: {
                    href: '#' + meta.id,
                    target: '_blank'
                }
            });
            const deleteBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button-delete',
                content: `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($03e87c70019af696$exports)))}" height="20"/>${(0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-delete')}`,
                onClick: ()=>{
                    deleteBtn.blur();
                    const thumbnail2 = (0, $13d5aa49e37e2734$export$dd0873c0fb3ccff6)(meta.thumbnail);
                    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(thumbnail2, {
                        alignSelf: 'start',
                        background: 'var(--kl-checkerboard-background)',
                        maxWidth: '100%'
                    });
                    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
                        type: 'warning',
                        message: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                            content: [
                                (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-delete-confirmation'),
                                thumbnail2
                            ],
                            css: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px'
                            }
                        }),
                        buttons: [
                            (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-delete'),
                            'Cancel'
                        ],
                        deleteButtonName: (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-delete'),
                        callback: async (result)=>{
                            if (result === 'Cancel') return;
                            await this.klRecoveryManager.remove(+meta.id);
                        }
                    });
                },
                noRef: true
            });
            const preview = meta.thumbnail;
            const previewWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'a',
                content: preview,
                className: $aa54b3f0adef983e$export$48c2d0f2f545ac27,
                title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-recover'),
                css: {
                    minHeight: (0, $b2aa268a64dedc9f$export$c9c3d910b57c6d44) + 'px'
                },
                custom: {
                    href: '#' + meta.id,
                    target: '_blank'
                }
            });
            const infoEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    (0, $61cd8b4e4101a623$export$1b9ca798405c9eb6)(meta.timestamp),
                    ', ' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(meta.memoryEstimateBytes / 1000000, 1) + ' MB'
                ],
                css: {
                    textAlign: 'center'
                }
            });
            elements.push((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    previewWrapper,
                    infoEl,
                    recoverBtn,
                    deleteBtn
                ],
                css: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                    maxWidth: '100%'
                }
            }));
        });
        this.rootEl.innerHTML = '';
        if (0, $b2aa268a64dedc9f$export$c72bbe997bb2ffd) this.rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: 'Debug On - SHOWING ALL TABS',
            css: {
                background: 'red'
            }
        }));
        this.rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-explanation'),
            className: 'kl-toolspace-note'
        }), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-total-quota-label') + ' ' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(totalMemoryUsedBytes / 1000000, 1) + ' MB / ' + (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round((0, $b2aa268a64dedc9f$export$2740edb783d24e35) / 1000000, 1) + ' MB',
            css: {
                margin: '10px 0'
            }
        }), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                ...elements
            ],
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px 10px',
                justifyContent: 'space-evenly'
            }
        }));
        if (elements.length === 0) this.rootEl.append((0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-empty'));
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.klRecoveryManager.unsubscribe(this.recoveryListener);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.recoveryListener = (metas, totalMemoryUsedBytes)=>{
            this.update(metas, totalMemoryUsedBytes);
        };
        this.klRecoveryManager = p.klRecoveryManager;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('loading')
        });
        this.klRecoveryManager.subscribe(this.recoveryListener);
        setTimeout(async ()=>{
            try {
                await this.klRecoveryManager.update();
            } catch (e) {
                setTimeout(()=>{
                    throw e;
                });
                this.rootEl.innerHTML = 'error';
            }
        });
    }
}





function $64bb13f3226311c9$export$abc0e2c9b0afece1(klRecoveryManager) {
    if (!klRecoveryManager || !(0, $2a3419e253354ddb$export$8d693ea241b9d9a6).getIsAvailable()) {
        (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
            type: 'error',
            message: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-cant-access'),
            buttons: [
                'Ok'
            ]
        });
        return;
    }
    const recoveryManager = new (0, $aa79ddb31a9becd1$export$feb3da9ac0115d49)({
        klRecoveryManager: klRecoveryManager
    });
    const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        content: [
            recoveryManager.getElement()
        ]
    });
    const onModalExit = (val)=>{
        recoveryManager.destroy();
    };
    const modal = (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-recover-tabs')}</b>`,
        div: rootEl,
        buttons: [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('modal-close')
        ],
        callback: onModalExit,
        style: {
            width: 'calc(100% - 50px)',
            maxWidth: '1000px',
            minWidth: '300px',
            boxSizing: 'border-box'
        },
        clickOnEnter: 'Ok'
    });
}


var $26979e340e24ad46$export$bd7a7a9fa7e7f04b;
$26979e340e24ad46$export$bd7a7a9fa7e7f04b = `Tt6aiG_recoveryBubble`;




const $dad163782d7c02d0$var$LS_SHOW_SAVE_DIALOG = 'kl-save-dialog';
const $dad163782d7c02d0$var$createSpacer = ()=>{
    const el = document.createElement('div');
    const clearer = document.createElement('div');
    const line = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: 'grid-hr'
    });
    el.append(clearer, line);
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(clearer, {
        clear: 'both'
    });
    return el;
};
const $dad163782d7c02d0$var$createButtonContent = (text, icon, noInvert)=>{
    return `<img ${noInvert ? 'class="dark-no-invert"' : ''} src='${icon}' alt='icon' height='20'/>${text}`;
};
class $dad163782d7c02d0$export$409b892ffe02580b {
    refresh() {}
    getElement() {
        return this.rootEl;
    }
    setIsVisible(isVisible) {
        if (isVisible) {
            var _this_browserStorageUi;
            this.refresh();
            (_this_browserStorageUi = this.browserStorageUi) === null || _this_browserStorageUi === void 0 ? void 0 : _this_browserStorageUi.show();
            if (this.klRecoveryManager) {
                this.klRecoveryManager.subscribe(this.recoveryListener);
                this.klRecoveryManager.update();
            }
        } else if (this.klRecoveryManager) this.klRecoveryManager.unsubscribe(this.recoveryListener);
    }
    triggerImport() {
        this.importInput && this.importInput.click();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.recoveryListener = (metas)=>{
            if (!this.recoveryCountBubble) return;
            const count = metas.length;
            if (count === 0) this.recoveryCountBubble.style.display = 'none';
            else {
                this.recoveryCountBubble.textContent = '' + count;
                this.recoveryCountBubble.style.display = 'inline-block';
            }
        };
        this.exportType = p.exportType;
        this.applyUncommitted = p.applyUncommitted;
        this.rootEl = document.createElement('div');
        const asyncCreation = ()=>{
            var _this_browserStorageUi;
            // --- hint ---
            const saveNote = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'kl-toolspace-note',
                textContent: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-no-autosave'),
                css: {
                    margin: '10px 10px 0 10px'
                }
            });
            // --- new, import, save ---
            const newButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'grid-button',
                content: $dad163782d7c02d0$var$createButtonContent((0, $63d0b335c576c718$export$ce37e184d908d785)('file-new'), (0, (/*@__PURE__*/$parcel$interopDefault($cecb4b55c8dd017e$exports))), true),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    cssFloat: 'left'
                },
                onClick: ()=>p.onNewImage()
            });
            const importButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'grid-button',
                content: $dad163782d7c02d0$var$createButtonContent((0, $63d0b335c576c718$export$ce37e184d908d785)('file-import'), (0, (/*@__PURE__*/$parcel$interopDefault($375749381ca7b7b7$exports))), true),
                css: {
                    position: 'relative',
                    cursor: 'pointer',
                    cssFloat: 'left'
                },
                custom: {
                    tabIndex: '-1'
                },
                onClick: ()=>this.importInput.click()
            });
            this.importInput = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'input',
                css: {
                    display: 'none'
                },
                onChange: ()=>{
                    this.applyUncommitted();
                    this.importInput.files && p.onFileSelect(this.importInput.files, 'default');
                    this.importInput.value = '';
                },
                custom: {
                    tabIndex: '-1'
                }
            });
            this.importInput.type = 'file';
            this.importInput.multiple = true;
            this.importInput.accept = 'image/*,.psd'; // .psd needed for chrome, although it's image/vnd.adobe.photoshop
            const saveButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'grid-button grid-button--filter',
                content: $dad163782d7c02d0$var$createButtonContent((0, $63d0b335c576c718$export$ce37e184d908d785)('file-save'), (0, (/*@__PURE__*/$parcel$interopDefault($d94e039749bb6ca4$exports)))),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    cssFloat: 'left',
                    flex: '1 0 0',
                    margin: '0'
                },
                onClick: ()=>p.onSaveImageToComputer()
            });
            const canShowSaveDialog = 'showSaveFilePicker' in window;
            const showSaveDialogRaw = (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem($dad163782d7c02d0$var$LS_SHOW_SAVE_DIALOG);
            const initialShowSaveDialog = showSaveDialogRaw === null ? false : showSaveDialogRaw === 'true';
            const saveDialogCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
                init: initialShowSaveDialog,
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-show-save-dialog'),
                callback: (value)=>{
                    if (value) (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem($dad163782d7c02d0$var$LS_SHOW_SAVE_DIALOG, 'true');
                    else (0, $0ecef66681b62a8c$export$19fffca37ef3e106).removeItem($dad163782d7c02d0$var$LS_SHOW_SAVE_DIALOG); // default is false
                    p.onChangeShowSaveDialog(value);
                },
                css: {
                    maxWidth: 'fit-content'
                },
                name: 'show-save-dialog'
            });
            p.onChangeShowSaveDialog(initialShowSaveDialog);
            // export filetype dropdown
            const exportTypeSelect = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).Select({
                optionArr: [
                    [
                        'png',
                        'PNG'
                    ],
                    [
                        'jpg',
                        'JPG'
                    ],
                    [
                        'psd',
                        'PSD'
                    ],
                    [
                        'layers',
                        (0, $63d0b335c576c718$export$ce37e184d908d785)('layers') + ' (PNG)'
                    ]
                ],
                initValue: this.exportType,
                onChange: (val)=>{
                    this.exportType = val;
                    p.onExportTypeChange(this.exportType);
                    p.onSaveImageToComputer();
                },
                title: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-format'),
                name: 'export-type'
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(exportTypeSelect.getElement(), {
                height: '30px',
                width: 'calc(50% - 10px)',
                flex: '1 0 0'
            });
            // --- browser storage ---
            let browserStorageFallbackEl;
            if (p.projectStore) {
                this.browserStorageUi = new (0, $1a83f3b0ed28fe18$export$9c72cf485ef46673)({
                    projectStore: p.projectStore,
                    getProject: p.getProject,
                    applyUncommitted: this.applyUncommitted,
                    onOpen: p.onOpenBrowserStorage,
                    onStored: ()=>p.onStoredToBrowserStorage()
                });
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.browserStorageUi.getElement(), {
                    margin: '10px'
                });
            } else {
                const header = new (0, $744217e5b2377ce2$export$852ebaa1b01c8b5a)();
                browserStorageFallbackEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    content: [
                        header.getElement(),
                        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                            content: "\uD83D\uDD34 " + (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-cant-access'),
                            css: {
                                marginTop: '10px'
                            }
                        })
                    ],
                    css: {
                        margin: '10px 10px 0 10px'
                    }
                });
            }
            const saveRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: [
                    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                        content: [
                            saveButton,
                            exportTypeSelect.getElement()
                        ],
                        css: {
                            display: 'flex',
                            gap: '10px'
                        }
                    }),
                    ...canShowSaveDialog ? [
                        saveDialogCheckbox.getElement()
                    ] : []
                ],
                css: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    margin: '10px 10px 0 10px'
                }
            });
            // --- recovery ---
            this.klRecoveryManager = p.klRecoveryManager;
            const recoveryWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({});
            this.recoveryCountBubble = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: $26979e340e24ad46$export$bd7a7a9fa7e7f04b
            });
            const recoveryBrowserButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                content: [
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-recover-tabs'),
                    this.recoveryCountBubble
                ],
                onClick: ()=>(0, $64bb13f3226311c9$export$abc0e2c9b0afece1)(this.klRecoveryManager),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    margin: '10px 0 0 10px',
                    width: 'calc(100% - 20px)'
                }
            });
            recoveryWrapper.append(recoveryBrowserButton, $dad163782d7c02d0$var$createSpacer());
            (async ()=>{
                if (!this.klRecoveryManager) return;
                this.klRecoveryManager.subscribe(this.recoveryListener);
                await this.klRecoveryManager.update();
                this.klRecoveryManager.unsubscribe(this.recoveryListener);
            })();
            // --- upload, share ---
            const shareButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'grid-button',
                content: $dad163782d7c02d0$var$createButtonContent((0, $63d0b335c576c718$export$ce37e184d908d785)('file-share'), (0, (/*@__PURE__*/$parcel$interopDefault($390be88d04af75ef$exports)))),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    cssFloat: 'left'
                },
                onClick: ()=>{
                    shareButton.disabled = true;
                    p.onShareImage(()=>{
                        shareButton.disabled = false;
                    });
                }
            });
            const uploadImgurButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'grid-button',
                content: $dad163782d7c02d0$var$createButtonContent((0, $63d0b335c576c718$export$ce37e184d908d785)('file-upload'), (0, (/*@__PURE__*/$parcel$interopDefault($3be8226e2ed33509$exports)))),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    cssFloat: 'left'
                },
                onClick: ()=>{
                    p.onUpload();
                }
            });
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).append(this.rootEl, [
                saveNote,
                newButton,
                importButton,
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    css: {
                        clear: 'both'
                    }
                }),
                saveRow,
                $dad163782d7c02d0$var$createSpacer(),
                (_this_browserStorageUi = this.browserStorageUi) === null || _this_browserStorageUi === void 0 ? void 0 : _this_browserStorageUi.getElement(),
                browserStorageFallbackEl,
                $dad163782d7c02d0$var$createSpacer(),
                recoveryWrapper,
                uploadImgurButton,
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canShareFiles() ? shareButton : undefined,
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    css: {
                        clear: 'both'
                    }
                })
            ]);
        };
        setTimeout(asyncCreation, 1);
    }
}






function $ed5eddfb5f6912a0$export$d731e22ecd0c25d3(shader, uniforms, textureIn, textureOut) {
    (textureIn || this._.texture).use();
    this._.spareTexture.drawTo(function() {
        shader.uniforms(uniforms).drawRect();
    });
    this._.spareTexture.swapWith(textureOut || this._.texture);
}


let $ca843f6dd01906cb$export$5822a9d0880a5d82;
function $ca843f6dd01906cb$export$b59c6427db8463f4(newGl) {
    // more problems setting type to null
    $ca843f6dd01906cb$export$5822a9d0880a5d82 = newGl;
}



const $ba022370a1e95297$var$defaultVertexSource = '\
    attribute vec2 vertex;\
    attribute vec2 _texCoord;\
    varying vec2 texCoord;\
    void main() {\
        texCoord = _texCoord;\
        gl_Position = vec4(vertex * 2.0 - 1.0, 0.0, 1.0);\
    }';
const $ba022370a1e95297$var$defaultFragmentSource = '\
    uniform sampler2D texture;\
    varying vec2 texCoord;\
    void main() {\
        gl_FragColor = texture2D(texture, texCoord);\
    }';
function $ba022370a1e95297$var$isArray(obj) {
    return Object.prototype.toString.call(obj) == '[object Array]';
}
function $ba022370a1e95297$var$isNumber(obj) {
    return Object.prototype.toString.call(obj) == '[object Number]';
}
let $ba022370a1e95297$var$floatPrecision;
class $ba022370a1e95297$export$7d9b0d118d0c4108 {
    // ---- static ----
    static getDefaultShader() {
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).defaultShader = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).defaultShader || new $ba022370a1e95297$export$7d9b0d118d0c4108();
        return (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).defaultShader;
    }
    // ---- private ----
    compileSource(type, source, nameStr) {
        const shader = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).throwIfNull((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).createShader(type));
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).shaderSource(shader, source.replace(/#define.*/, '')); // glslify adds a line add the beginning that breaks it
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).compileShader(shader);
        if (!(0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getShaderParameter(shader, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).COMPILE_STATUS)) throw 'compile error: ' + nameStr + ' - ' + (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getShaderInfoLog(shader);
        return shader;
    }
    /**
     * HIGH_FLOAT | MEDIUM_FLOAT
     */ testPrecisionSupport(precisionType) {
        const format = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getShaderPrecisionFormat((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FRAGMENT_SHADER, precisionType);
        return format !== null && format.precision !== 0;
    }
    destroy() {
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).deleteProgram(this.program);
        this.program = null;
    }
    uniforms(uniforms) {
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).useProgram(this.program);
        Object.entries(uniforms).forEach(([name, value])=>{
            const location = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getUniformLocation(this.program, name);
            if (location === null) // will be null if the uniform isn't used in the shader
            return;
            if ($ba022370a1e95297$var$isArray(value)) switch(value.length){
                case 1:
                    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).uniform1fv(location, new Float32Array(value));
                    break;
                case 2:
                    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).uniform2fv(location, new Float32Array(value));
                    break;
                case 3:
                    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).uniform3fv(location, new Float32Array(value));
                    break;
                case 4:
                    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).uniform4fv(location, new Float32Array(value));
                    break;
                case 9:
                    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).uniformMatrix3fv(location, false, new Float32Array(value));
                    break;
                case 16:
                    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).uniformMatrix4fv(location, false, new Float32Array(value));
                    break;
                default:
                    throw 'don\'t know how to load uniform "' + name + '" of length ' + value.length;
            }
            else if ($ba022370a1e95297$var$isNumber(value)) (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).uniform1f(location, value);
            else throw 'attempted to set uniform "' + name + '" to invalid value ' + (value || 'undefined').toString();
        });
        // allow chaining
        return this;
    }
    //
    /**
     * textures are uniforms too but for some reason can't be specified by gl.uniform1f,
     * even though floating point numbers represent the integers 0 through 7 exactly
     */ textures(textures) {
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).useProgram(this.program);
        Object.entries(textures).forEach(([name, value])=>{
            (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).uniform1i((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getUniformLocation(this.program, name), value);
        });
        // allow chaining
        return this;
    }
    drawRect(left, top, right, bottom) {
        let undefined;
        const viewport = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getParameter((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).VIEWPORT);
        top = top !== undefined ? (top - viewport[1]) / viewport[3] : 0;
        left = left !== undefined ? (left - viewport[0]) / viewport[2] : 0;
        right = right !== undefined ? (right - viewport[0]) / viewport[2] : 1;
        bottom = bottom !== undefined ? (bottom - viewport[1]) / viewport[3] : 1;
        if ((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).vertexBuffer === undefined || (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).vertexBuffer === null) (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).vertexBuffer = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).throwIfNull((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).createBuffer());
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindBuffer((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).ARRAY_BUFFER, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).vertexBuffer);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bufferData((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).ARRAY_BUFFER, new Float32Array([
            left,
            top,
            left,
            bottom,
            right,
            top,
            right,
            bottom
        ]), (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).STATIC_DRAW);
        if ((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texCoordBuffer == null) {
            (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texCoordBuffer = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).throwIfNull((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).createBuffer());
            (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindBuffer((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).ARRAY_BUFFER, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texCoordBuffer);
            (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bufferData((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).ARRAY_BUFFER, new Float32Array([
                0,
                0,
                0,
                1,
                1,
                0,
                1,
                1
            ]), (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).STATIC_DRAW);
        }
        if (this.vertexAttribute == null) {
            this.vertexAttribute = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getAttribLocation(this.program, 'vertex');
            (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).enableVertexAttribArray(this.vertexAttribute);
        }
        if (this.texCoordAttribute == null) {
            this.texCoordAttribute = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getAttribLocation(this.program, '_texCoord');
            (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).enableVertexAttribArray(this.texCoordAttribute);
        }
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).useProgram(this.program);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindBuffer((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).ARRAY_BUFFER, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).vertexBuffer);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).vertexAttribPointer(this.vertexAttribute, 2, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FLOAT, false, 0, 0);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindBuffer((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).ARRAY_BUFFER, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texCoordBuffer);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).vertexAttribPointer(this.texCoordAttribute, 2, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FLOAT, false, 0, 0);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).drawArrays((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TRIANGLE_STRIP, 0, 4);
    }
    // ----------------------------------- public -----------------------------------
    constructor(vertexSource, fragmentSource, nameStr){
        this.vertexAttribute = null;
        this.texCoordAttribute = null;
        this.program = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).throwIfNull((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).createProgram());
        vertexSource = vertexSource || $ba022370a1e95297$var$defaultVertexSource;
        fragmentSource = fragmentSource || $ba022370a1e95297$var$defaultFragmentSource;
        if (!$ba022370a1e95297$var$floatPrecision) $ba022370a1e95297$var$floatPrecision = this.testPrecisionSupport((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).HIGH_FLOAT) ? 'highp' : this.testPrecisionSupport((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).MEDIUM_FLOAT) ? 'mediump' : 'lowp';
        fragmentSource = 'precision ' + $ba022370a1e95297$var$floatPrecision + ' float;' + fragmentSource; // annoying requirement is annoying
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).attachShader(this.program, this.compileSource((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).VERTEX_SHADER, vertexSource, nameStr + '(vertex)'));
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).attachShader(this.program, this.compileSource((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FRAGMENT_SHADER, fragmentSource, nameStr + '(fragment)'));
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).linkProgram(this.program);
        if (!(0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getProgramParameter(this.program, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).LINK_STATUS)) throw 'link error: ' + (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getProgramInfoLog(this.program);
    }
}



const $7aae3f183f304a55$export$6408eeb1703e74b8 = function(brightness, contrast) {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).brightnessContrast = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).brightnessContrast || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform float brightness;\
        uniform float contrast;\
        varying vec2 texCoord;\
        void main() {\
            vec4 color = texture2D(texture, texCoord);\
            color.rgb += brightness;\
            if (contrast > 0.0) {\
                color.rgb = (color.rgb - 0.5) / (1.0 - contrast) + 0.5;\
            } else {\
                color.rgb = (color.rgb - 0.5) * (1.0 + contrast) + 0.5;\
            }\
            gl_FragColor = clamp(color, 0.0, 1.0);\
        }\
    ', 'brightnessContrast');
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).brightnessContrast, {
        brightness: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(brightness, -1, 1),
        contrast: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(contrast, -1, 1)
    });
    return this;
};






class $4f7270b6400c73d7$export$7e6fd232cff50dd1 {
    // ---- static ----
    static fromElement(element) {
        const texture = new $4f7270b6400c73d7$export$7e6fd232cff50dd1(0, 0, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).UNSIGNED_BYTE);
        texture.loadContentsOf(element);
        return texture;
    }
    loadContentsOf(element) {
        this.width = element.width || element.videoWidth;
        this.height = element.height || element.videoHeight;
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindTexture((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texImage2D((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, 0, this.format, this.format, this.type, element);
    }
    initFromBytes(width, height, data) {
        this.width = width;
        this.height = height;
        this.format = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA;
        this.type = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).UNSIGNED_BYTE;
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindTexture((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texImage2D((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, 0, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA, width, height, 0, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA, this.type, new Uint8Array(data));
    }
    destroy() {
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).deleteTexture(this.id);
        this.id = null;
    }
    use(unit) {
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).activeTexture((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE0 + (unit || 0));
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindTexture((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
    }
    unuse(unit) {
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).activeTexture((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE0 + (unit || 0));
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindTexture((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, null);
    }
    ensureFormat(width, height, format, type) {
        // change the format only if required
        if (width != this.width || height != this.height || format != this.format || type != this.type) {
            this.width = width;
            this.height = height;
            this.format = format;
            this.type = type;
            (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindTexture((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
            (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texImage2D((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, 0, this.format, width, height, 0, this.format, this.type, null);
        }
    }
    ensureFormatViaTexture(texture) {
        this.ensureFormat(texture.width, texture.height, texture.format, texture.type);
    }
    drawTo(callback) {
        // start rendering to this texture
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).framebuffer = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).framebuffer || (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).createFramebuffer();
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindFramebuffer((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FRAMEBUFFER, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).framebuffer);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).framebufferTexture2D((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FRAMEBUFFER, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).COLOR_ATTACHMENT0, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, this.id, 0);
        const fbStatus = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).checkFramebufferStatus((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FRAMEBUFFER);
        if (fbStatus !== (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FRAMEBUFFER_COMPLETE) {
            if (this.id === null) throw new Error('incomplete framebuffer: texture already destroyed');
            if ((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).isContextLost()) throw new Error('incomplete framebuffer: context lost');
            if (this.width === 0 || this.height === 0) throw new Error(`incomplete framebuffer: texture has zero dimension (${this.width}x${this.height})`);
            if (fbStatus === (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FRAMEBUFFER_UNSUPPORTED) throw new Error(`incomplete framebuffer: unsupported format/type combination (format=0x${this.format.toString(16)}, type=0x${this.type.toString(16)})`);
            throw new Error(`incomplete framebuffer: status 0x${fbStatus.toString(16)}`);
        }
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).viewport(0, 0, this.width, this.height);
        // do the drawing
        callback();
        // stop rendering to this texture
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindFramebuffer((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FRAMEBUFFER, null);
    }
    /*
    // never seen this being used
    fillUsingCanvas (callback: (canvas: CanvasRenderingContext2D) => void): Texture {
        callback(this.getCanvas(this));
        this.format = gl.RGBA;
        this.type = gl.UNSIGNED_BYTE;
        gl.bindTexture(gl.TEXTURE_2D, this.id);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.canvas);
        return this;
    }

    // never seen this being used
    toImage (image: HTMLImageElement): void {
        this.use();
        Shader.getDefaultShader().drawRect();
        const size = this.width * this.height * 4;
        const pixels = new Uint8Array(size);
        const c = this.getCanvas(this);
        const data = c.createImageData(this.width, this.height);
        gl.readPixels(0, 0, this.width, this.height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
        for (let i = 0; i < size; i++) {
            data.data[i] = pixels[i];
        }
        c.putImageData(data, 0, 0);
        image.src = this.canvas.toDataURL();
    }
     */ swapWith(other) {
        let temp;
        temp = other.id;
        other.id = this.id;
        this.id = temp;
        temp = other.width;
        other.width = this.width;
        this.width = temp;
        temp = other.height;
        other.height = this.height;
        this.height = temp;
        temp = other.format;
        other.format = this.format;
        this.format = temp;
    // type?
    }
    /*
    // never seen this being used
    private getCanvas(texture: Texture): CanvasRenderingContext2D {
        if (this.canvas == null) {
            this.canvas = BB.canvas(texture.width, texture.height);
        }
        this.canvas.width = texture.width;
        this.canvas.height = texture.height;
        const c = BB.ctx(this.canvas);
        c.clearRect(0, 0, this.canvas.width, this.canvas.height);
        return c;
    }*/ // ----------------------------------- public -----------------------------------
    constructor(width, height, format, type){
        this.gl = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82);
        this.id = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).throwIfNull((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).createTexture());
        this.width = width;
        this.height = height;
        this.format = format;
        this.type = type;
        this.canvas = null;
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).bindTexture((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texParameteri((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_MAG_FILTER, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).LINEAR);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texParameteri((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_MIN_FILTER, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).LINEAR);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texParameteri((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_WRAP_S, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).CLAMP_TO_EDGE);
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texParameteri((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_WRAP_T, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).CLAMP_TO_EDGE);
        if (width && height) (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).texImage2D((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).TEXTURE_2D, 0, this.format, width, height, 0, this.format, this.type, null);
    }
}



function $6d7ade6aa4027844$export$4f237735eca1f248(points) {
    const interpolator = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).SplineInterpolator(points);
    const array = [];
    for(let i = 0; i < 256; i++)array.push((0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(Math.floor(interpolator.interpolate(i / 255) * 256), 0, 255));
    return array;
}





const $38704cd148486d5a$export$6894093bf294bea5 = function(red, green, blue) {
    // Create the ramp texture
    const redRamp = (0, $6d7ade6aa4027844$export$4f237735eca1f248)(red);
    const greenRamp = (0, $6d7ade6aa4027844$export$4f237735eca1f248)(green);
    const blueRamp = (0, $6d7ade6aa4027844$export$4f237735eca1f248)(blue);
    const array = [];
    for(let i = 0; i < 256; i++)array.splice(array.length, 0, redRamp[i], greenRamp[i], blueRamp[i], 255);
    this._.extraTexture.initFromBytes(256, 1, array);
    this._.extraTexture.use(1);
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).curves = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).curves || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform sampler2D map;\
        varying vec2 texCoord;\
        void main() {\
            vec4 color = texture2D(texture, texCoord);\
            color.r = texture2D(map, vec2(color.r)).r;\
            color.g = texture2D(map, vec2(color.g)).g;\
            color.b = texture2D(map, vec2(color.b)).b;\
            gl_FragColor = color;\
        }\
    ', 'curves');
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).curves.textures({
        map: 1
    });
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).curves, {});
    return this;
};






const $f13b1fa3c138ed02$export$ef28bbbd731e79bf = function(hue, saturation) {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).hueSaturation = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).hueSaturation || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform float hue;\
        uniform float saturation;\
        varying vec2 texCoord;\
        void main() {\
            vec4 color = texture2D(texture, texCoord);\
            \
            /* hue adjustment, wolfram alpha: RotationTransform[angle, {1, 1, 1}][{x, y, z}] */\
            float angle = hue * 3.14159265;\
            float s = sin(angle), c = cos(angle);\
            vec3 weights = (vec3(2.0 * c, -sqrt(3.0) * s - c, sqrt(3.0) * s - c) + 1.0) / 3.0;\
            float len = length(color.rgb);\
            color.rgb = vec3(\
                dot(color.rgb, weights.xyz),\
                dot(color.rgb, weights.zxy),\
                dot(color.rgb, weights.yzx)\
            );\
            \
            /* saturation adjustment */\
            float average = (color.r + color.g + color.b) / 3.0;\
            if (saturation > 0.0) {\
                color.rgb += (average - color.rgb) * (1.0 - 1.0 / (1.001 - saturation));\
            } else {\
                color.rgb += (average - color.rgb) * (-saturation);\
            }\
            \
            gl_FragColor = color;\
        }\
    ', 'hueSaturation');
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).hueSaturation, {
        hue: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(hue, -1, 1),
        saturation: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(saturation, -1, 1)
    });
    return this;
};





var $c0f1e1206ce9bdf1$exports = {};
$c0f1e1206ce9bdf1$exports = "#define GLSLIFY 1\nuniform sampler2D texture;\nvarying vec2 texCoord;\nuniform vec2 texSize;\n\nuniform float seed;\nuniform float type;\nuniform vec2 scale;\nuniform vec2 offset;\nuniform float octaves;\nuniform float samples;\n\nuniform float peaks;\nuniform float contrast;\nuniform float brightness;\nuniform float isReversed;\n\nuniform vec3 colA;\nuniform vec3 colB;\n\nuniform float channels; // 0 - rgb, 1 - alpha\n\n// fbm, cellular_noise based on\n// https://github.com/Gonkee/Gonkees-Shaders\n// MIT, Copyright \xa9 Gonkee\n\n// hash & simplex based on\n// https://www.shadertoy.com/view/Msf3WH\n// MIT, Copyright \xa9 2013 Inigo Quilez\n// https://www.youtube.com/c/InigoQuilez\n// https://iquilezles.org\n\nfloat rand(vec2 co) {\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nfloat value_noise(vec2 coord){\n    return rand(floor(coord) / 100.0);\n}\n\nfloat cellular_noise(vec2 coord) {\n    vec2 i = floor(coord);\n    vec2 f = fract(coord);\n\n    float min_dist = 99999.0;\n    for (float x = -1.0; x <= 1.0; x++) {\n        for (float y = -1.0; y <= 1.0; y++) {\n            vec2 node = rand(i + vec2(x, y)) + vec2(x, y);\n            float dist = sqrt((f - node).x * (f - node).x + (f - node).y * (f - node).y);\n            min_dist = min(min_dist, dist);\n        }\n    }\n    return min_dist;\n}\n\n// ---------- Simplex Alternative ---------------------\n\nvec3 hash(vec3 p)\n{ p=vec3(dot(p, vec3(127.1, 311.7, 74.7))\n, dot(p, vec3(269.5, 183.3, 246.1))\n, dot(p, vec3(113.5, 271.9, 124.6)))\n;return fract(sin(p)*43758.5453123)*2.-1.; }\n\nmat3 hash(mat3 p)\n{ return mat3(hash(p[0]), hash(p[1]), hash(p[2])); }\n\nvec3 dots(mat3 a, vec3 w, mat3 b){ return vec3\n(dot(a[0], w-b[0]), dot(a[1], w-b[1]), dot(a[2], w-b[2])); }\n\n//return noiseGra13dx as .x, and its derivatives as .yzw\n// https://www.shadertoy.com/view/llByD1\nvec3 noiseGra13dx(in vec3 x) {\n    vec3 p=floor(x), w=fract(x)\n    #if 1\n    , u=w*w*w*(w*(w*6.-15.)+10.), v=30.*w*w*(w*(w-2.)+1.)//quintic hermite\n    #else\n    , u=w*w*(3.-2.*w), v=6.*w*(1.-w)//cubic hermite\n    #endif\n    //gradients\n    , G=hash(p+vec3(0)), F=hash(p+vec3(1))\n    ;mat3 D=hash(mat3(p, p, p)+mat3(1)), E=hash(mat3(p, p, p)+1.-mat3(1));\n    //projections\n    vec3 d=dots(D, w, mat3(1)), e=dots(E, w, 1.-mat3(1));\n    //interpolations\n    float g=dot(G, w), f=dot(F, w-vec3(1));\n    vec3 h=u.yzx*(g-d.xyx-d.yzz+e.zxy)+d-g, U=u*h, a=d-e;\n    mat3 S=D-mat3(G, G, G), W=D-E;\n    a.x=(a.x+a.y+a.z)+f-g;\n    ;float b=u.x*u.y*u.z;\n\n    vec4 result = vec4(g+U.x+U.y+U.z+a.x*b// value\n    , G*(1.-b)+b*(W[0]+W[1]+W[2]+F)//https://www.shadertoy.com/view/llByD1\n    +u.x*(S[0]+u.y*(G-D[0]-D[1]+E[2]))// derivatives\n    +u.y*(S[1]+u.z*(G-D[1]-D[2]+E[0]))\n    +u.z*(S[2]+u.x*(G-D[0]-D[2]+E[1]))\n    +v*(u.zxy*(g-d.xxy-d.zyz+e.yzx)+h+u.yzx*u.zxy*a.x));\n    return 0.5 + 0.5 * result.xxx;\n}\n\nfloat fbm(vec2 coord) {\n    float normalize_factor = 0.0;\n    float value = 0.0;\n    float scale = 0.5;\n\n    for (float i = 0.0; i < 7.0; i++){\n        if (i < octaves) {\n            if (type == 0.0) {\n                value += value_noise(coord) * scale;\n            } else if (type == 1.0) {\n                value += noiseGra13dx(vec3(coord.x, coord.y, 0.0)).r * scale;\n            } else if (type == 2.0) {\n                value += cellular_noise(coord) * scale;\n            }\n            normalize_factor += scale;\n            coord *= 2.0;\n            scale *= 0.5;\n        }\n    }\n    return value / normalize_factor;\n}\n\nfloat render (vec2 pos) {\n    float result = fbm(pos);\n    //\n\n    if (peaks > 0.0) {\n        result = abs(mod(result * peaks - 0.5, 1.0) - 0.5) * 2.0;// triangle\n        //result = mod(result * (peaks + 1.0), 1.0); // sawtooth\n    }\n\n    result += brightness;\n    if (contrast > 0.0) {\n        result = clamp((result - 0.5) / (1.0 - contrast) + 0.5, 0.0, 1.0);\n    } else if (contrast < 0.0) {\n        result = clamp((result - 0.5) * (1.0 + contrast) + 0.5, 0.0, 1.0);\n    }\n\n    if (isReversed == 1.0) {\n        result = 1.0 - result;\n    }\n    return result;\n}\n\nvoid main() {\n    vec4 color;\n\n    vec2 seedOffset;\n    seedOffset.x = (rand(vec2(seed, 0.0)) * 100.0 - 50.0);\n    seedOffset.y = (rand(vec2(0.0, seed)) * 100.0 - 50.0);\n\n    float val = 0.0;\n    vec2 basePos = texCoord * texSize / scale - offset / scale + seedOffset;\n\n    if (samples == 1.0) {\n        val = render(basePos);\n\n    }/* else if (samples == 4.0) {\n        for (float i = 0.0; i < 2.0; i++) {\n            for (float e = 0.0; e < 2.0; e++) {\n                val += render(basePos + (vec2(i, e) - 0.5) * 0.5 / scale);\n            }\n        }\n        val /= 4.0;\n\n    }*/ else if (samples == 16.0) {\n        for (float i = 0.0; i < 4.0; i++) {\n            for (float e = 0.0; e < 4.0; e++) {\n                val += render(basePos + (vec2(i, e) - 0.25) * 0.25 / scale);\n            }\n        }\n        val /= 16.0;\n    }\n\n    if (channels == 0.0) {\n        gl_FragColor = vec4(vec3(mix(colA, colB, val)), 1.0);\n    } else {\n        gl_FragColor = vec4(vec3(1.0), val);\n    }\n}";


const $615309a02e3c3ec4$export$d3022aad56692482 = function(seed, type, scale, offset, octaves, samples, peaks, brightness, contrast, isReversed, colA, colB, channels) {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).noise = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).noise || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, (0, (/*@__PURE__*/$parcel$interopDefault($c0f1e1206ce9bdf1$exports))).replace(/#define.*/, ''), 'noise');
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).noise, {
        seed: seed || 0,
        type: type,
        scale: [
            scale[0],
            scale[1]
        ],
        offset: offset,
        octaves: octaves,
        samples: samples,
        texSize: [
            this.width,
            this.height
        ],
        peaks: peaks,
        brightness: brightness,
        contrast: contrast,
        isReversed: isReversed ? 1.0 : 0.0,
        colA: colA ? [
            colA.r / 255,
            colA.g / 255,
            colA.b / 255
        ] : [
            0,
            0,
            0
        ],
        colB: colB ? [
            colB.r / 255,
            colB.g / 255,
            colB.b / 255
        ] : [
            1,
            1,
            1
        ],
        channels: channels === 'rgb' ? 0 : 1
    });
    return this;
};




// returns a random number between 0 and 1
const $aec050322e5cb9b9$export$af69f7ca07da04c9 = '\
    float random(vec3 scale, float seed) {\
        /* use the fragment position for a different seed per-pixel */\
        return fract(sin(dot(gl_FragCoord.xyz + seed, scale)) * 43758.5453 + seed);\
    }\
';



const $c794506a27d0c6d6$export$6e852234f1597a14 = function(radius) {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).triangleBlur = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).triangleBlur || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform vec2 delta;\
        varying vec2 texCoord;\
        ' + (0, $aec050322e5cb9b9$export$af69f7ca07da04c9) + '\
        void main() {\
            vec4 color = vec4(0.0);\
            float total = 0.0;\
            \
            /* randomize the lookup values to hide the fixed number of samples */\
            float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);\
            \
            for (float t = -30.0; t <= 30.0; t++) {\
                float percent = (t + offset - 0.5) / 30.0;\
                float weight = 1.0 - abs(percent);\
                vec4 sample = texture2D(texture, texCoord + delta * percent);\
                \
                color += sample * weight;\
                total += weight;\
            }\
            \
            gl_FragColor = color / total;\
        }\
    ', 'triangleBlur');
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).triangleBlur, {
        delta: [
            radius / this.width,
            0
        ]
    });
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).triangleBlur, {
        delta: [
            0,
            radius / this.height
        ]
    });
    return this;
};






const $caa405d6896c91bf$export$4545acb2b6bb8f22 = function(startX, startY, endX, endY, blurRadius, gradientRadius) {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).tiltShift = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).tiltShift || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform float blurRadius;\
        uniform float gradientRadius;\
        uniform vec2 start;\
        uniform vec2 end;\
        uniform vec2 delta;\
        uniform vec2 texSize;\
        varying vec2 texCoord;\
        ' + (0, $aec050322e5cb9b9$export$af69f7ca07da04c9) + '\
        void main() {\
            vec4 color = vec4(0.0);\
            float total = 0.0;\
            \
            /* randomize the lookup values to hide the fixed number of samples */\
            float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);\
            \
            vec2 normal = normalize(vec2(start.y - end.y, end.x - start.x));\
            float radius = smoothstep(0.0, 1.0, abs(dot(texCoord * texSize - start, normal)) / gradientRadius) * blurRadius;\
            for (float t = -30.0; t <= 30.0; t++) {\
                float percent = (t + offset - 0.5) / 30.0;\
                float weight = 1.0 - abs(percent);\
                vec4 sample = texture2D(texture, texCoord + delta / texSize * percent * radius);\
                \
                color += sample * weight;\
                total += weight;\
            }\
            \
            gl_FragColor = color / total;\
        }\
    ', 'tiltShift');
    const dx = endX - startX;
    const dy = endY - startY;
    const d = Math.sqrt(dx * dx + dy * dy);
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).tiltShift, {
        blurRadius: blurRadius,
        gradientRadius: gradientRadius,
        start: [
            startX,
            startY
        ],
        end: [
            endX,
            endY
        ],
        delta: [
            dx / d,
            dy / d
        ],
        texSize: [
            this.width,
            this.height
        ]
    });
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).tiltShift, {
        blurRadius: blurRadius,
        gradientRadius: gradientRadius,
        start: [
            startX,
            startY
        ],
        end: [
            endX,
            endY
        ],
        delta: [
            -dy / d,
            dx / d
        ],
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};




function $83fc0aef7d823507$export$820b3a44cb7b2b21(uniformsStr, warpStr) {
    return new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, uniformsStr + '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    void main() {\
        vec2 coord = texCoord * texSize;\
        ' + warpStr + '\
        gl_FragColor = texture2D(texture, coord / texSize);\
        vec2 clampedCoord = clamp(coord, vec2(0.0), texSize);\
        if (coord != clampedCoord) {\
            /* fade to transparent if we are outside the image */\
            gl_FragColor.a *= max(0.0, 1.0 - length(coord - clampedCoord));\
        }\
    }', 'warp');
}



function $a7bdfb25622fe8b9$export$1c447127d27d7be4(x0, y0, x1, y1, x2, y2, x3, y3) {
    const dx1 = x1 - x2;
    const dy1 = y1 - y2;
    const dx2 = x3 - x2;
    const dy2 = y3 - y2;
    const dx3 = x0 - x1 + x2 - x3;
    const dy3 = y0 - y1 + y2 - y3;
    const det = dx1 * dy2 - dx2 * dy1;
    const a = (dx3 * dy2 - dx2 * dy3) / det;
    const b = (dx1 * dy3 - dx3 * dy1) / det;
    return [
        x1 - x0 + a * x1,
        y1 - y0 + a * y1,
        a,
        x3 - x0 + b * x3,
        y3 - y0 + b * y3,
        b,
        x0,
        y0,
        1
    ];
}
function $a7bdfb25622fe8b9$export$68b3343017e80691(m) {
    const a = m[0], b = m[1], c = m[2];
    const d = m[3], e = m[4], f = m[5];
    const g = m[6], h = m[7], i = m[8];
    const det = a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    return [
        (e * i - f * h) / det,
        (c * h - b * i) / det,
        (b * f - c * e) / det,
        (f * g - d * i) / det,
        (a * i - c * g) / det,
        (c * d - a * f) / det,
        (d * h - e * g) / det,
        (b * g - a * h) / det,
        (a * e - b * d) / det
    ];
}
function $a7bdfb25622fe8b9$export$2060d2db72cce88f(a, b) {
    return [
        a[0] * b[0] + a[1] * b[3] + a[2] * b[6],
        a[0] * b[1] + a[1] * b[4] + a[2] * b[7],
        a[0] * b[2] + a[1] * b[5] + a[2] * b[8],
        a[3] * b[0] + a[4] * b[3] + a[5] * b[6],
        a[3] * b[1] + a[4] * b[4] + a[5] * b[7],
        a[3] * b[2] + a[4] * b[5] + a[5] * b[8],
        a[6] * b[0] + a[7] * b[3] + a[8] * b[6],
        a[6] * b[1] + a[7] * b[4] + a[8] * b[7],
        a[6] * b[2] + a[7] * b[5] + a[8] * b[8]
    ];
}


const $4f209890e041e7d6$export$a93b0222aeadc54b = function(matrix, inverse, useTextureSpace) {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).matrixWarp = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).matrixWarp || (0, $83fc0aef7d823507$export$820b3a44cb7b2b21)('\
        uniform mat3 matrix;\
        uniform bool useTextureSpace;\
    ', '\
        if (useTextureSpace) coord = coord / texSize * 2.0 - 1.0;\
        vec3 warp = matrix * vec3(coord, 1.0);\
        coord = warp.xy / warp.z;\
        if (useTextureSpace) coord = (coord * 0.5 + 0.5) * texSize;\
    ');
    // Flatten all members of matrix into one big list
    matrix = matrix.flat();
    // Extract a 3x3 matrix out of the arguments
    if (matrix.length == 4) matrix = [
        matrix[0],
        matrix[1],
        0,
        matrix[2],
        matrix[3],
        0,
        0,
        0,
        1
    ];
    else if (matrix.length != 9) throw 'can only warp with 2x2 or 3x3 matrix';
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).matrixWarp, {
        matrix: inverse ? (0, $a7bdfb25622fe8b9$export$68b3343017e80691)(matrix) : matrix,
        texSize: [
            this.width,
            this.height
        ],
        useTextureSpace: useTextureSpace ? 1 : 0
    });
    return this;
};





const $41fe2bf18cc268d3$export$915fb7313c578ba2 = function(radius, strength) {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).unsharpMask = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).unsharpMask || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D blurredTexture;\
        uniform sampler2D originalTexture;\
        uniform float strength;\
        uniform float threshold;\
        varying vec2 texCoord;\
        void main() {\
            vec4 blurred = texture2D(blurredTexture, texCoord);\
            vec4 original = texture2D(originalTexture, texCoord);\
            gl_FragColor = mix(blurred, original, 1.0 + strength);\
        }\
    ', 'unsharpMask');
    // Store a copy of the current texture in the second texture unit
    this._.extraTexture.ensureFormatViaTexture(this._.texture);
    this._.texture.use();
    this._.extraTexture.drawTo(function() {
        (0, $ba022370a1e95297$export$7d9b0d118d0c4108).getDefaultShader().drawRect();
    });
    // Blur the current texture, then use the stored texture to detect edges
    this._.extraTexture.use(1);
    this.triangleBlur(radius);
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).unsharpMask.textures({
        originalTexture: 1
    });
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).unsharpMask, {
        strength: strength
    });
    this._.extraTexture.unuse(1);
    return this;
};





const $12b73c4d8c20eb5a$export$be1ee5ea42904fdc = function(isInverted, replaceRGBA) {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).toAlpha = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).toAlpha || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
    uniform bool isInverted;\
    uniform vec4 replace;\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        float alpha = (color.r + color.g + color.b) / 3.0;\
        if (isInverted) alpha = 1.0 - alpha;\
        alpha = min(color.a, alpha);\
        if (replace.a > 0.0) color = replace;\
        gl_FragColor = vec4(color.r, color.g, color.b, alpha);\
    }\
', 'toAlpha');
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).toAlpha, {
        isInverted: isInverted ? 1 : 0,
        replace: replaceRGBA ? [
            replaceRGBA.r / 255,
            replaceRGBA.g / 255,
            replaceRGBA.b / 255,
            replaceRGBA.a
        ] : [
            0,
            0,
            0,
            0
        ],
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};





const $6109e928236947f2$export$6897c284b6f9f4dc = function() {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).invert = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).invert || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        color.rgb = 1.0 - color.rgb;\
        gl_FragColor = color;\
    }\
', 'invert');
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).invert, {
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};



const $7d03762724365e43$export$541149539f3a4684 = function(before, after) {
    const a = (0, $a7bdfb25622fe8b9$export$1c447127d27d7be4)(...after);
    const b = (0, $a7bdfb25622fe8b9$export$1c447127d27d7be4)(...before);
    const c = (0, $a7bdfb25622fe8b9$export$2060d2db72cce88f)((0, $a7bdfb25622fe8b9$export$68b3343017e80691)(a), b);
    return this.matrixWarp(c);
};





const $1b7199a5e15fe4d8$export$b324c80262feb891 = function() {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).unmultiplyAlpha = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).unmultiplyAlpha || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        if(color.a > 0.0) {\
            color.rgb /= color.a;\
        }\
        gl_FragColor = color;\
    }\
', 'unmultiplyAlpha');
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).unmultiplyAlpha, {
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};





const $8f4949fd56b66485$export$7c9b924528782480 = function(settings) {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).distort = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).distort || (0, $83fc0aef7d823507$export$820b3a44cb7b2b21)(`
    uniform float stepSize;
    uniform vec2 scale;
    uniform vec2 strength;
    uniform vec2 phase;
    uniform float type;
    uniform vec2 offset;
`, `
    const float PI = 3.14159265;
    float x = coord.x + offset.x;
    float y = coord.y + offset.y;
    if (stepSize > 1.0) {
        x = floor(x / stepSize) * stepSize;
        y = floor(y / stepSize) * stepSize;
    }
    float distortX = sin((x/scale.x + phase.x) * PI * 2.0) * strength.x;
    float distortY = sin((y/scale.y + phase.y) * PI * 2.0) * strength.y;
    if (type == 0.0) {
        coord.y += distortX;
        coord.x += distortY;
    } else if (type == 1.0) {
        coord.x += distortX;
        coord.y += distortY;
    } else if (type == 2.0) {
        x -= offset.x;
        y -= offset.y;
        gl_FragColor = texture2D(texture, vec2(x, y) / texSize);
        coord.y += sin(gl_FragColor.r/scale.x*200.0 + phase.x * PI * 2.0) * strength.x;
        coord.x += cos(gl_FragColor.g/scale.y*200.0 + phase.y * PI * 2.0) * strength.y;
    }
    coord.x = mod(coord.x, texSize.x);
    coord.y = mod(coord.y, texSize.y);
`);
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).distort, {
        stepSize: settings.stepSize,
        type: settings.distortType,
        scale: [
            settings.scale.x,
            settings.scale.y
        ],
        strength: [
            settings.strength.x,
            settings.strength.y
        ],
        phase: [
            settings.phase.x,
            settings.phase.y
        ],
        offset: [
            settings.offset.x,
            settings.offset.y
        ],
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};





const $7b72315ed3e98576$export$57b05c961ff98d6a = function() {
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).multiplyAlpha = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).multiplyAlpha || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        color.rgb *= color.a;\
        gl_FragColor = color;\
    }\
', 'multiplyAlpha');
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).multiplyAlpha, {
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};






const $b8a2de52955396f1$export$d99f0801a68bbcf1 = function(maskTexture, originalTexture, premultiplyOriginal) {
    maskTexture._.use(1);
    if (originalTexture) originalTexture._.use(2);
    else {
        // should be faster than introducing a conditional in the shader
        this._.extraTexture.use(2);
        this._.extraTexture.initFromBytes(1, 1, [
            0,
            0,
            0,
            0
        ]);
    }
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).mask = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).mask || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, `
        uniform sampler2D texture;
        uniform sampler2D mask;
        uniform sampler2D original;
        uniform bool premultiplyOriginal;
        varying vec2 texCoord;

        void main() {
            vec4 filteredCol = texture2D(texture, texCoord);
            vec4 originalCol = texture2D(original, texCoord);
            if (premultiplyOriginal) {
                originalCol.rgb *= originalCol.a;
            }
            float maskStrength = texture2D(mask, texCoord).r;
            gl_FragColor = mix(originalCol, filteredCol, maskStrength);
        }
        `, 'mask');
    (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).mask.textures({
        mask: 1,
        original: 2
    });
    (0, $ed5eddfb5f6912a0$export$d731e22ecd0c25d3).call(this, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).mask, {
        premultiplyOriginal: premultiplyOriginal ? 1 : 0
    });
    return this;
};


const $03f71ba115904ed2$export$a04cfca62fd2892f = function() {
    function wrapTexture(texture) {
        return {
            _: texture,
            loadContentsOf: function(element) {
                // Make sure that we're using the correct global WebGL context
                (0, $ca843f6dd01906cb$export$b59c6427db8463f4)(this._.gl);
                this._.loadContentsOf(element);
            },
            destroy: function() {
                // Make sure that we're using the correct global WebGL context
                (0, $ca843f6dd01906cb$export$b59c6427db8463f4)(this._.gl);
                this._.destroy();
            }
        };
    }
    function texture(element) {
        return wrapTexture((0, $4f7270b6400c73d7$export$7e6fd232cff50dd1).fromElement(element));
    }
    function getTextureType() {
        let textureType = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).UNSIGNED_BYTE;
        // Go for floating point buffer textures if we can, it'll make the bokeh
        // filter look a lot better. Note that on Windows, ANGLE does not let you
        // render to a floating-point texture when linear filtering is enabled.
        // See http://crbug.com/172278 for more information.
        if ((0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getExtension('WEBGL_color_buffer_float') && // firefox shows warning without this line
        (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getExtension('OES_texture_float') && (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).getExtension('OES_texture_float_linear')) {
            const testTexture = new (0, $4f7270b6400c73d7$export$7e6fd232cff50dd1)(100, 100, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FLOAT);
            try {
                // Only use gl.FLOAT if we can render to it
                testTexture.drawTo(function() {
                    textureType = (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).FLOAT;
                });
            } catch (e) {
            /* empty */ }
            testTexture.destroy();
        }
        return textureType;
    }
    function initialize(width, height) {
        const textureType = getTextureType();
        if (this._.texture) this._.texture.destroy();
        if (this._.spareTexture) this._.spareTexture.destroy();
        this.width = width;
        this.height = height;
        this._.texture = new (0, $4f7270b6400c73d7$export$7e6fd232cff50dd1)(width, height, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA, textureType);
        this._.spareTexture = new (0, $4f7270b6400c73d7$export$7e6fd232cff50dd1)(width, height, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA, textureType);
        this._.extraTexture = this._.extraTexture || new (0, $4f7270b6400c73d7$export$7e6fd232cff50dd1)(0, 0, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA, textureType);
        this._.flippedShader = this._.flippedShader || new (0, $ba022370a1e95297$export$7d9b0d118d0c4108)(null, `
uniform sampler2D texture;
varying vec2 texCoord;
void main() {
    gl_FragColor = texture2D(texture, vec2(texCoord.x, 1.0 - texCoord.y));
}
        `, 'flippedShader');
        this._.isInitialized = true;
    }
    function draw(texture, width, height) {
        if (!this._.isInitialized || texture._.width != this.width || texture._.height != this.height) initialize.call(this, width ? width : texture._.width, height ? height : texture._.height);
        texture._.use();
        this._.texture.drawTo(function() {
            (0, $ba022370a1e95297$export$7d9b0d118d0c4108).getDefaultShader().drawRect();
        });
        return this;
    }
    function update() {
        this._.texture.use();
        this._.flippedShader.drawRect();
        return this;
    }
    function contents() {
        const texture = new (0, $4f7270b6400c73d7$export$7e6fd232cff50dd1)(this._.texture.width, this._.texture.height, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).UNSIGNED_BYTE);
        this._.texture.use();
        texture.drawTo(function() {
            (0, $ba022370a1e95297$export$7d9b0d118d0c4108).getDefaultShader().drawRect();
        });
        return wrapTexture(texture);
    }
    /*
       Get a Uint8 array of pixel values: [r, g, b, a, r, g, b, a, ...]
       Length of the array will be width * height * 4.
    */ function getPixelArray() {
        const w = this._.texture.width;
        const h = this._.texture.height;
        const array = new Uint8Array(w * h * 4);
        this._.texture.drawTo(function() {
            (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).readPixels(0, 0, w, h, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).RGBA, (0, $ca843f6dd01906cb$export$5822a9d0880a5d82).UNSIGNED_BYTE, array);
        });
        return array;
    }
    function wrap(fn) {
        return function(...args) {
            // Make sure that we're using the correct global WebGL context
            (0, $ca843f6dd01906cb$export$b59c6427db8463f4)(this._.gl);
            // Now that the context has been switched, we can call the wrapped function
            return fn.apply(this, args);
        };
    }
    function getWebGlContext(canvas, options) {
        const contextNames = [
            'webgl',
            'experimental-webgl',
            'webgl2'
        ];
        let context = null;
        contextNames.forEach((name)=>{
            if (context) return;
            // get.webgl.org does a try-catch
            try {
                context = canvas.getContext(name, options);
            } catch (e) {
            /* empty */ }
        });
        return context;
    }
    return ()=>{
        if (!window.WebGLRenderingContext) throw 'WebGLRenderingContext not set. Browser does not support WebGL.';
        const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(1, 1);
        const context = getWebGlContext(canvas, {
            premultipliedAlpha: false
        });
        if (!context) throw 'This browser does not support WebGL';
        (0, $ca843f6dd01906cb$export$b59c6427db8463f4)(context);
        canvas._ = {
            gl: $ca843f6dd01906cb$export$5822a9d0880a5d82,
            isInitialized: false,
            texture: null,
            spareTexture: null,
            flippedShader: null
        };
        // Core methods
        canvas.texture = wrap(texture);
        canvas.initialize = wrap(initialize);
        canvas.draw = wrap(draw);
        canvas.update = wrap(update);
        canvas.contents = wrap(contents);
        canvas.getPixelArray = wrap(getPixelArray);
        // Filter methods
        canvas.brightnessContrast = wrap((0, $7aae3f183f304a55$export$6408eeb1703e74b8));
        canvas.hueSaturation = wrap((0, $f13b1fa3c138ed02$export$ef28bbbd731e79bf));
        canvas.triangleBlur = wrap((0, $c794506a27d0c6d6$export$6e852234f1597a14));
        canvas.unsharpMask = wrap((0, $41fe2bf18cc268d3$export$915fb7313c578ba2));
        canvas.perspective = wrap((0, $7d03762724365e43$export$541149539f3a4684));
        canvas.matrixWarp = wrap((0, $4f209890e041e7d6$export$a93b0222aeadc54b));
        canvas.tiltShift = wrap((0, $caa405d6896c91bf$export$4545acb2b6bb8f22));
        canvas.noise = wrap((0, $615309a02e3c3ec4$export$d3022aad56692482));
        canvas.curves = wrap((0, $38704cd148486d5a$export$6894093bf294bea5));
        canvas.invert = wrap((0, $6109e928236947f2$export$6897c284b6f9f4dc));
        canvas.multiplyAlpha = wrap((0, $7b72315ed3e98576$export$57b05c961ff98d6a));
        canvas.unmultiplyAlpha = wrap((0, $1b7199a5e15fe4d8$export$b324c80262feb891));
        canvas.toAlpha = wrap((0, $12b73c4d8c20eb5a$export$be1ee5ea42904fdc));
        canvas.distort = wrap((0, $8f4949fd56b66485$export$7c9b924528782480));
        canvas.mask = wrap((0, $b8a2de52955396f1$export$d99f0801a68bbcf1));
        return canvas;
    };
}();


let $5caaf17bca0749c7$var$failed = false;
let $5caaf17bca0749c7$var$fx = null;
function $5caaf17bca0749c7$export$8c4423af32b21158() {
    // failed previously, don't need to try again.
    if ($5caaf17bca0749c7$var$failed) return $5caaf17bca0749c7$var$fx;
    if (!$5caaf17bca0749c7$var$fx || $5caaf17bca0749c7$var$fx._.gl.isContextLost()) try {
        $5caaf17bca0749c7$var$fx = (0, $03f71ba115904ed2$export$a04cfca62fd2892f)();
    } catch (e) {
        $5caaf17bca0749c7$var$failed = true;
        $5caaf17bca0749c7$var$fx = null;
        setTimeout(()=>{
            throw e;
        });
    }
    return $5caaf17bca0749c7$var$fx;
}





class $bc1f03f9e593bc1c$export$aeb1a0a0e64541b5 {
    testHasWebGL() {
        return !!(0, $5caaf17bca0749c7$export$8c4423af32b21158)();
    }
    init() {
        const filters = (0, $49faab2330529a96$export$6e4a713ddcda1e5e).FILTER_LIB;
        const buttons = [];
        if (!(0, $49faab2330529a96$export$6e4a713ddcda1e5e).FILTER_LIB_STATUS.isLoaded) throw new Error('filters not loaded');
        const hasWebGL = this.testHasWebGL();
        if (!hasWebGL) {
            const note = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: this.rootEl,
                className: 'kl-toolspace-note',
                content: 'Features disabled because WebGL is failing.',
                css: {
                    margin: '10px',
                    marginBottom: '0'
                }
            });
            const noteButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: note,
                tagName: 'button',
                textContent: 'Learn More',
                css: {
                    marginLeft: '5px'
                }
            });
            noteButton.onclick = ()=>{
                (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                    message: '<b>WebGL is not working</b>',
                    div: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                        content: `
See if your browser supports WebGL and has it enabled: <a href="https://get.webgl.org" target="_blank" rel="noopener noreferrer">get.webgl.org</a><br>
<br>
Recently (2023-05) a number of Chrome users on Chrome OS reported that WebGL fails, although it is enabled & supported.
This has been reported to Google.
`
                    }),
                    buttons: [
                        'Ok'
                    ],
                    clickOnEnter: 'Ok'
                });
            };
        }
        const createButton = (filterKey)=>{
            const filter = filters[filterKey];
            const button = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'grid-button grid-button--filter',
                content: [
                    (0, $52ad4d7a7d6372c1$export$ec664d7487540b)({
                        alt: 'icon',
                        src: filter.icon,
                        width: 18,
                        height: 20,
                        className: filter.darkNoInvert ? 'dark-no-invert' : '',
                        css: {
                            marginRight: '3px'
                        }
                    }),
                    (0, $63d0b335c576c718$export$ce37e184d908d785)(filter.lang.button)
                ],
                css: {
                    lineHeight: '20px',
                    fontSize: '12px'
                },
                custom: {
                    tabIndex: '-1'
                }
            });
            const filterName = (0, $63d0b335c576c718$export$ce37e184d908d785)(filter.lang.name);
            let isEnabled = true;
            if (filter.webGL && !hasWebGL) isEnabled = false;
            if (isEnabled) button.onclick = ()=>{
                this.applyUncommitted();
                const dialogButtons = [
                    'Ok',
                    'Cancel'
                ];
                const finishedDialog = (result, filterDialog)=>{
                    if ('error' in filterDialog) return;
                    if (result == 'Cancel') {
                        if (filterDialog.destroy) filterDialog.destroy();
                        return;
                    }
                    let input;
                    try {
                        input = filterDialog.getInput(); // also destroys
                    } catch (e) {
                        if (e.message.indexOf('.getInput is not a function') !== -1) throw 'filterDialog.getInput is not a function, filter: ' + filterName;
                        else throw e;
                    }
                    applyFilter(input);
                };
                if (!('apply' in filters[filterKey])) {
                    (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                        message: 'Application not fully loaded',
                        type: 'error'
                    });
                    return;
                }
                const applyFilter = (input)=>{
                    const filterResult = filters[filterKey].apply({
                        layer: this.getCurrentLayer(),
                        klCanvas: this.klCanvas,
                        klHistory: this.klHistory,
                        input: input
                    });
                    if (!filterResult) (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                        message: "Couldn't apply the edit action",
                        type: 'error'
                    });
                    filters[filterKey].updatePos && this.onCanvasChanged();
                    this.layersUi.update();
                };
                if (filters[filterKey].isInstant) {
                    button.blur();
                    applyFilter(null);
                    this.statusOverlay.out((0, $63d0b335c576c718$export$ce37e184d908d785)('filter-applied', {
                        x: filterName
                    }), true);
                } else {
                    const secondaryColorRGB = this.klColorSlider.getSecondaryRGB();
                    let filterDialog = undefined;
                    try {
                        filterDialog = filters[filterKey].getDialog({
                            context: this.getCurrentLayer().context,
                            klCanvas: this.klCanvas,
                            maxWidth: this.maxCanvasSize,
                            maxHeight: this.maxCanvasSize,
                            currentColorRgb: {
                                r: this.getCurrentColor().r,
                                g: this.getCurrentColor().g,
                                b: this.getCurrentColor().b
                            },
                            secondaryColorRgb: {
                                r: secondaryColorRGB.r,
                                g: secondaryColorRGB.g,
                                b: secondaryColorRGB.b
                            },
                            composed: this.klHistory.getComposed()
                        });
                    } catch (e) {
                        setTimeout(()=>{
                            throw e;
                        });
                    }
                    if (!filterDialog || 'error' in filterDialog) {
                        (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                            message: filterDialog ? filterDialog.error : 'Error: Could not perform action.',
                            type: 'error'
                        });
                        return;
                    }
                    let closeFunc;
                    // Todo should move into getDialogParams
                    filterDialog.errorCallback = (e)=>{
                        (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                            message: 'Error: Could not perform action.',
                            type: 'error'
                        });
                        setTimeout(()=>{
                            throw e;
                        }, 0);
                        closeFunc();
                    };
                    const style = {};
                    if ('width' in filterDialog) style.width = filterDialog.width + 'px';
                    let title;
                    {
                        const els = [
                            (0, $934e5f47c3374e21$export$db3b6bfb95261072)('b', filterName)
                        ];
                        if (filter.lang.description !== undefined) els.push((0, $934e5f47c3374e21$export$db3b6bfb95261072)({
                            className: 'kl-info-btn',
                            onClick: ()=>{
                                (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                                    message: (0, $63d0b335c576c718$export$ce37e184d908d785)(filter.lang.description)
                                });
                            },
                            title: (0, $63d0b335c576c718$export$ce37e184d908d785)(filter.lang.description),
                            noRef: true
                        }, '?'));
                        title = (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,gap-5', els);
                    }
                    (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                        message: title,
                        div: filterDialog.element,
                        style: style,
                        buttons: dialogButtons,
                        clickOnEnter: 'Ok',
                        callback: (result)=>{
                            finishedDialog(result, filterDialog);
                        },
                        closeFunc: (func)=>{
                            closeFunc = func;
                        }
                    });
                }
            };
            else button.disabled = true;
            buttons.push(button);
            return button;
        };
        const addGroup = (groupArr)=>{
            Object.entries(filters).forEach(([filterKey, filter])=>{
                if (!groupArr.includes(filterKey)) return;
                if (this.isEmbed && !filter.inEmbed) return;
                this.rootEl.append(createButton(filterKey));
            });
        };
        const groupA = [
            'cropExtend',
            'flip',
            'perspective',
            'resize',
            'rotate',
            'transform'
        ];
        const groupB = [
            'brightnessContrast',
            'curves',
            'distort',
            'hueSaturation',
            'invert',
            'tiltShift',
            'toAlpha',
            'blur',
            'unsharpMask'
        ];
        const groupC = [
            'grid',
            'noise',
            'pattern',
            'vanishPoint'
        ];
        if (!this.isEmbed) {
            const copyBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'grid-button grid-button--filter',
                content: [
                    (0, $52ad4d7a7d6372c1$export$ec664d7487540b)({
                        alt: 'icon',
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($895204cb2449c455$exports))),
                        width: 18,
                        height: 20,
                        css: {
                            marginRight: '3px'
                        }
                    }),
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('file-copy')
                ],
                onClick: ()=>this.onCopyToClipboard(),
                title: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-copy-title'),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    lineHeight: '20px'
                }
            });
            const pasteBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'grid-button grid-button--filter',
                content: [
                    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                        css: {
                            height: '20px',
                            cssFloat: 'left'
                        }
                    }),
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('file-paste')
                ],
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    lineHeight: '20px'
                },
                onClick: ()=>this.onPaste()
            });
            this.rootEl.append(copyBtn, pasteBtn, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'grid-hr'
            }));
        }
        addGroup(groupA);
        this.rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'grid-hr'
        }));
        addGroup(groupB);
        this.rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'grid-hr'
        }));
        addGroup(groupC);
        this.isInit = true;
    }
    getElement() {
        return this.rootEl;
    }
    show() {
        if (!this.isInit) this.init();
        this.rootEl.style.display = 'block';
    }
    hide() {
        this.rootEl.style.display = 'none';
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isInit = false;
        this.klRootEl = p.klRootEl;
        this.klColorSlider = p.klColorSlider;
        this.layersUi = p.layersUi;
        this.getCurrentColor = p.getCurrentColor;
        this.maxCanvasSize = p.maxCanvasSize;
        this.klCanvas = p.klCanvas;
        this.getCurrentLayer = p.getCurrentLayer;
        this.isEmbed = p.isEmbed;
        this.statusOverlay = p.statusOverlay;
        this.onCanvasChanged = p.onCanvasChanged;
        this.applyUncommitted = p.applyUncommitted;
        this.klHistory = p.klHistory;
        this.onCopyToClipboard = p.onCopyToClipboard;
        this.onPaste = p.onPaste;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
    }
}





var $c993ffd3ce3393ac$exports = {};
$c993ffd3ce3393ac$exports = $parcel$resolve("28TVy");




/**
 * uploads canvas, opens new tab with the upload progress & then opens the image page.
 */ async function $1acd53d54391923e$var$upload(canvas, title, description, type, imgurKey) {
    const imageBlob = await (0, $13d5aa49e37e2734$export$403d539f215df596)(canvas, 'image/' + type);
    const newTab = window.open();
    if (!newTab) throw new Error('could not create new tab');
    const label = newTab.document.createElement('div');
    const gif = newTab.document.createElement('img');
    gif.src = (0, (/*@__PURE__*/$parcel$interopDefault($c993ffd3ce3393ac$exports)));
    label.append(gif);
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(gif, {
        filter: 'invert(1)'
    });
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(newTab.document.body, {
        backgroundColor: '#121211',
        backgroundImage: 'linear-gradient(#2b2b2b 0%, #121211 50%)',
        backgroundRepeat: 'no-repeat'
    });
    const labelText = newTab.document.createElement('div');
    labelText.style.marginTop = '10px';
    label.append(labelText);
    labelText.textContent = (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-uploading');
    newTab.document.body.append(label);
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(label, {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '100px',
        fontFamily: 'system-ui, sans-serif',
        fontSize: '20px',
        textAlign: 'center',
        transition: 'opacity 0.3s ease-in-out',
        opacity: '0',
        color: '#ccc'
    });
    setTimeout(function() {
        label.style.opacity = '1';
    }, 20);
    let response;
    try {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('image', imageBlob);
        response = await fetch('https://api.imgur.com/3/image', {
            method: 'POST',
            headers: {
                Authorization: 'Client-ID ' + imgurKey
            },
            body: formData
        });
    } catch (e) {
        newTab.close();
        throw e;
    }
    if (!response.ok) {
        newTab.close();
        throw new Error();
    }
    const data = (await response.json()).data;
    newTab.location.href = data.link.replace(/\.(jpg|png)/, '');
    return data;
}
function $1acd53d54391923e$export$b1dd62fa0b5f32f5(klCanvas, klRootEl, imgurKey, onUploaded) {
    if (!imgurKey) throw new Error('imgur key missing');
    const inputTitle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'input',
        custom: {
            name: 'image-title'
        }
    });
    inputTitle.type = 'text';
    inputTitle.value = (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-title-untitled');
    const inputDescription = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'textarea',
        custom: {
            rows: '2',
            name: 'image-description'
        },
        css: {
            width: '100%',
            maxWidth: '100%'
        }
    });
    const labelTitle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        textContent: (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-name') + ':'
    });
    const labelDescription = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        textContent: (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-caption') + ':',
        css: {
            marginTop: '10px'
        }
    });
    const tos = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        content: `<br/><a href="https://imgur.com/tos" target="_blank" rel="noopener noreferrer">${(0, $63d0b335c576c718$export$ce37e184d908d785)('terms-of-service')}</a>`
    });
    const typeRadio = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).RadioList({
        name: 'filetype',
        init: 'jpeg',
        items: [
            {
                label: 'JPG',
                value: 'jpeg'
            },
            {
                label: 'PNG',
                value: 'png'
            }
        ],
        ignoreFocus: true
    });
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(typeRadio.getElement(), {
        marginBottom: '10px'
    });
    const outDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
    const infoHint = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: 'info-hint',
        textContent: (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-link-notice')
    });
    outDiv.append(infoHint, typeRadio.getElement(), labelTitle, inputTitle, labelDescription, inputDescription, tos);
    (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
        message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('upload-title')}</b>`,
        type: 'upload',
        div: outDiv,
        buttons: [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-submit'),
            'Cancel'
        ],
        clickOnEnter: (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-submit'),
        primaries: [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-submit')
        ],
        autoFocus: (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-submit'),
        callback: async function(val) {
            if (val === (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-submit') || val === 'Yes' || val === 'Ok') try {
                const result = await $1acd53d54391923e$var$upload(klCanvas.getCompleteCanvas(1), inputTitle.value, inputDescription.value, typeRadio.getValue(), imgurKey);
                (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                    type: 'ok',
                    message: `<h3>${(0, $63d0b335c576c718$export$ce37e184d908d785)('upload-success')}</h3><br>${(0, $63d0b335c576c718$export$ce37e184d908d785)('upload-delete')}<br><a target='_blank' rel="noopener noreferrer" href='https://imgur.com/delete/${result.deletehash}'>imgur.com/delete/${result.deletehash}</a><br><br>`,
                    buttons: [
                        'Ok'
                    ]
                });
                onUploaded();
            } catch (e) {
                (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                    type: 'error',
                    message: (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-failed'),
                    buttons: [
                        'Ok'
                    ]
                });
            }
        }
    });
}


let $e4b3248b4ce95ea5$var$agPsdLazy;

async function $e4b3248b4ce95ea5$export$ab3d838b1d336b38() {
    if (!$e4b3248b4ce95ea5$var$agPsdLazy) $e4b3248b4ce95ea5$var$agPsdLazy = await (parcelRequire("2UvqW"));
    return $e4b3248b4ce95ea5$var$agPsdLazy;
}






var $095683c145b0ace5$export$d4ef1ef99f1461a4;
$095683c145b0ace5$export$d4ef1ef99f1461a4 = `WKn-vG_psdWrapper`;



const $5ecc5a61dcd332b6$var$DEBUG_TIME_LIMIT_MS = undefined;
const $5ecc5a61dcd332b6$var$DEBUG_UNSAVED_ACTIONS_LIMIT = undefined;
// minimum number of actions required for reminder to show up (regardless of time limit)
const $5ecc5a61dcd332b6$var$UNSAVED_ACTIONS_LIMIT = $5ecc5a61dcd332b6$var$DEBUG_UNSAVED_ACTIONS_LIMIT !== null && $5ecc5a61dcd332b6$var$DEBUG_UNSAVED_ACTIONS_LIMIT !== void 0 ? $5ecc5a61dcd332b6$var$DEBUG_UNSAVED_ACTIONS_LIMIT : 100;
const $5ecc5a61dcd332b6$var$LS_REMINDER_KEY = 'kl-save-reminder';
class $5ecc5a61dcd332b6$export$befc6437ad34b28a {
    showPopup() {
        const min = Math.round((performance.now() - this.lastSavedAt) / 1000 / 60);
        const contentEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        contentEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('save-reminder-text', {
                a: '<strong>' + min,
                b: '</strong>'
            }),
            css: {
                marginBottom: '20px'
            }
        }));
        const psdWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: $095683c145b0ace5$export$d4ef1ef99f1461a4
        });
        const storageWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                margin: '0 -20px',
                padding: '20px',
                paddingBottom: '0'
            }
        });
        contentEl.append(psdWrapper, storageWrapper);
        const psdBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button kl-button-primary kl-button--extra-focus',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('save-reminder-save-psd'),
            onClick: ()=>{
                this.applyUncommitted();
                this.onSaveAsPsd();
            },
            css: {
                padding: '14px'
            },
            noRef: true
        });
        psdWrapper.append(psdBtn, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: "\u2714 " + (0, $63d0b335c576c718$export$ce37e184d908d785)('save-reminder-psd-layers'),
            css: {
                marginTop: '10px'
            }
        }));
        const storageUi = new (0, $1a83f3b0ed28fe18$export$9c72cf485ef46673)({
            projectStore: this.projectStore,
            getProject: this.getProject,
            applyUncommitted: this.applyUncommitted,
            options: {
                hideClearButton: true,
                isFocusable: true
            },
            onStored: ()=>this.onStored()
        });
        storageUi.show();
        storageWrapper.append(storageUi.getElement());
        (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
            type: 'warning',
            message: `<b>${(0, $63d0b335c576c718$export$ce37e184d908d785)('save-reminder-title')}</b>`,
            div: contentEl,
            ignoreBackground: true,
            callback: ()=>{
                storageUi.destroy();
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(psdBtn);
                this.closeFunc = undefined;
                this.lastReminderShownAt = performance.now();
            },
            closeFunc: (f)=>{
                this.closeFunc = f;
            }
        });
        setTimeout(()=>{
            psdBtn.focus();
        }, 40);
    }
    init() {
        if (this.lastSavedHistoryIndex !== undefined) // already initialized
        return;
        this.lastSavedHistoryIndex = this.klHistory.getTotalIndex();
        this.lastReminderShownAt = performance.now();
        this.lastSavedAt = performance.now();
        setInterval(()=>{
            if (document.visibilityState !== 'visible') return;
            const unsavedActions = Math.abs(this.klHistory.getTotalIndex() - this.lastSavedHistoryIndex);
            const timeLimitMs = $5ecc5a61dcd332b6$var$DEBUG_TIME_LIMIT_MS !== null && $5ecc5a61dcd332b6$var$DEBUG_TIME_LIMIT_MS !== void 0 ? $5ecc5a61dcd332b6$var$DEBUG_TIME_LIMIT_MS : 60000 * ({
                '20min': 20,
                '40min': 40,
                disabled: 0
            })[this.setting];
            if (timeLimitMs > 0 && (0, $49faab2330529a96$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() === 0 && !this.isDrawing() && this.lastReminderShownAt + timeLimitMs < performance.now() && unsavedActions >= $5ecc5a61dcd332b6$var$UNSAVED_ACTIONS_LIMIT) this.showPopup();
        }, 5000);
    }
    reset() {
        if (this.lastSavedHistoryIndex === undefined) // not initialized
        return;
        this.lastSavedHistoryIndex = this.klHistory.getTotalIndex();
        this.lastReminderShownAt = performance.now();
        this.lastSavedAt = performance.now();
        window.onbeforeunload = null;
        if (this.closeFunc) this.closeFunc();
    }
    getSetting() {
        return this.setting;
    }
    setSetting(setting) {
        this.setting = setting;
        (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem($5ecc5a61dcd332b6$var$LS_REMINDER_KEY, this.setting);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.klHistory = {};
        this.lastSavedAt = 0;
        this.lastReminderShownAt = 0;
        this.onSaveAsPsd = p.onSaveAsPsd;
        this.isDrawing = p.isDrawing;
        this.projectStore = p.projectStore;
        this.getProject = p.getProject;
        this.onStored = p.onStored;
        this.applyUncommitted = p.applyUncommitted;
        this.klHistory = p.klHistory;
        var _LocalStorage_getItem;
        this.setting = (_LocalStorage_getItem = (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem($5ecc5a61dcd332b6$var$LS_REMINDER_KEY)) !== null && _LocalStorage_getItem !== void 0 ? _LocalStorage_getItem : '40min';
    }
}




const $39ab97e4ee30a834$var$types = {
    'image/png': {
        description: 'PNG Image',
        accept: {
            'image/png': [
                '.png'
            ]
        }
    },
    'image/vnd.adobe.photoshop': {
        description: 'Adobe Photoshop Document',
        accept: {
            'image/vnd.adobe.photoshop': [
                '.psd'
            ]
        }
    }
};
// resolves to true if it saves via file picker (or user aborted)
async function $39ab97e4ee30a834$var$saveViaFilePicker(blob, fileName) {
    const mimeType = blob.type;
    if ('showSaveFilePicker' in window) {
        let fileHandle;
        if (!$39ab97e4ee30a834$var$types[mimeType]) {
            console.error('unknown mime type:', mimeType);
            return false;
        }
        try {
            fileHandle = await window.showSaveFilePicker({
                suggestedName: fileName,
                types: [
                    $39ab97e4ee30a834$var$types[mimeType]
                ]
            });
        } catch (e) {
            if (e instanceof Error && e.name === 'AbortError') // cancelled dialog
            return true;
            console.log('unpredicted error', e);
            return false;
        }
        if (!fileHandle) return false;
        const writableStream = await fileHandle.createWritable();
        await writableStream.write(blob);
        await writableStream.close();
        return true;
    } else return false;
}
async function $39ab97e4ee30a834$export$2bc2a80e311129ac(blob, fileName, showDialog = false) {
    if (showDialog && await $39ab97e4ee30a834$var$saveViaFilePicker(blob, fileName)) return;
    // Namespace is used to prevent conflict w/ Chrome Poper Blocker extension (Issue https://github.com/eligrey/FileSaver.js/issues/561)
    const a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
    a.download = fileName;
    a.rel = 'noopener';
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    setTimeout(()=>URL.revokeObjectURL(objectUrl), 40000);
    setTimeout(()=>{
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }, 1);
}


const $5a2f7ed66bdaf6a4$export$67ac20532b9ededa = {
    filenameBase: 'Klecks'
};



class $f853515918de2fdb$export$75e7b60500bb415b {
    async saveImage(canvas, filename, mimeType, showDialog = false) {
        const blob = await (0, $13d5aa49e37e2734$export$403d539f215df596)(canvas, mimeType);
        await (0, $39ab97e4ee30a834$export$2bc2a80e311129ac)(blob, filename, showDialog);
    }
    async save(format) {
        if (!format) format = this.getExportType();
        if (format === 'png') {
            const extension = 'png';
            const mimeType = 'image/png';
            const filename = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).getDate() + (0, $5a2f7ed66bdaf6a4$export$67ac20532b9ededa).filenameBase + '.' + extension;
            const fullCanvas = this.klCanvas.getCompleteCanvas(1);
            try {
                await this.saveImage(fullCanvas, filename, mimeType, this.showSaveDialog);
            } catch (error) {
                //fallback for old browsers
                alert('could not save');
                throw new Error('failed png export');
            }
        } else if (format === 'jpg') {
            const extension = 'jpg';
            const mimeType = 'image/jpeg';
            const filename = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).getDate() + (0, $5a2f7ed66bdaf6a4$export$67ac20532b9ededa).filenameBase + '.' + extension;
            const fullCanvas = this.klCanvas.getCompleteCanvas(1);
            try {
                await this.saveImage(fullCanvas, filename, mimeType, this.showSaveDialog);
            } catch (error) {
                alert('could not save');
                throw new Error('failed jpg export');
            }
        } else if (format === 'layers') {
            const extension = 'png';
            const mimeType = 'image/png';
            const fileBase = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).getDate() + (0, $5a2f7ed66bdaf6a4$export$67ac20532b9ededa).filenameBase;
            const layerArr = this.klCanvas.getLayersFast();
            for(let i = 0; i < layerArr.length; i++){
                const item = layerArr[i];
                const fnameArr = [
                    fileBase,
                    '_',
                    ('' + (i + 1)).padStart(2, '0'),
                    '_',
                    item.name,
                    '.',
                    extension
                ];
                await this.saveImage(item.canvas, fnameArr.join(''), mimeType);
            }
        } else if (format === 'psd') {
            const layerArr = this.klCanvas.getLayersFast();
            const width = this.klCanvas.getWidth();
            const height = this.klCanvas.getHeight();
            const psdConfig = {
                width: width,
                height: height,
                children: [],
                canvas: this.klCanvas.getCompleteCanvas(1)
            };
            for(let i = 0; i < layerArr.length; i++){
                const item = layerArr[i];
                // If a compositeObj is active, bake it into a fresh full-size canvas
                // so the exported layer data exactly matches what is rendered on screen
                // (pixel-perfect, no unfilled border artifacts).
                let canvas = item.canvas;
                if (item.compositeObj) {
                    canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(width, height);
                    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
                    ctx.drawImage(item.canvas, 0, 0);
                    item.compositeObj.draw(ctx);
                }
                psdConfig.children.push({
                    name: item.name,
                    hidden: !item.isVisible,
                    opacity: item.opacity,
                    canvas: canvas,
                    blendMode: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).PSD.blendKlToPsd(item.mixModeStr),
                    left: 0,
                    top: 0
                });
            }
            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).loadAgPsd().then((agPsdLazy)=>{
                const buffer = agPsdLazy.writePsdBuffer(psdConfig);
                const blob = new Blob([
                    buffer
                ], {
                    type: 'image/vnd.adobe.photoshop'
                });
                (0, $39ab97e4ee30a834$export$2bc2a80e311129ac)(blob, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).getDate() + (0, $5a2f7ed66bdaf6a4$export$67ac20532b9ededa).filenameBase + '.psd', this.showSaveDialog);
            }).catch(()=>{
                alert('Error: failed to load PSD library');
            });
        }
        this.onSaved();
    }
    setShowSaveDialog(b) {
        this.showSaveDialog = b;
    }
    // ----------------------------------- public -----------------------------------
    constructor(getExportType, klCanvas, onSaved){
        this.getExportType = getExportType;
        this.klCanvas = klCanvas;
        this.onSaved = onSaved;
        this.showSaveDialog = true;
    }
}


class $2cc9052c3f36f7f1$export$272bfd3ef9ef2f48 {
    emit(obj, skipSubscriber) {
        for(let i = 0; i < this.subscriberArr.length; i++){
            if (this.subscriberArr[i] === skipSubscriber) continue;
            this.subscriberArr[i](obj);
        }
    }
    emitColor(color, skipSubscriber) {
        this.emit({
            type: 'color',
            value: color
        }, skipSubscriber);
    }
    emitSize(size, skipSubscriber) {
        this.emit({
            type: 'size',
            value: size
        }, skipSubscriber);
    }
    emitOpacity(opacity, skipSubscriber) {
        this.emit({
            type: 'opacity',
            value: opacity
        }, skipSubscriber);
    }
    emitScatter(scatter, skipSubscriber) {
        this.emit({
            type: 'scatter',
            value: scatter
        }, skipSubscriber);
    }
    emitSliderConfig(sliderConfig, skipSubscriber) {
        this.emit({
            type: 'sliderConfig',
            value: sliderConfig
        }, skipSubscriber);
    }
    /**
     * set current brush color
     * @param color
     * @param skipSubscriber
     */ setColor(color, skipSubscriber) {
        this.onSetColor(color);
        this.emitColor(color, skipSubscriber);
    }
    /**
     * set current brush size
     * @param size
     * @param skipSubscriber
     */ setSize(size, skipSubscriber) {
        this.onSetSize(size);
    // why not emitting?
    }
    /**
     * set current opacity
     * @param opacity
     * @param skipSubscriber
     */ setOpacity(opacity, skipSubscriber) {
        this.onSetOpacity(opacity);
    // why not emitting?
    }
    /**
     * set current scatter
     * @param scatter
     * @param skipSubscriber
     */ setScatter(scatter, skipSubscriber) {
        this.onSetScatter(scatter);
    // why not emitting?
    }
    /**
     * get current brush color
     */ getColor() {
        return this.onGetColor();
    }
    getSize() {
        return this.onGetSize();
    }
    getOpacity() {
        return this.onGetOpacity();
    }
    getScatter() {
        return this.onGetScatter();
    }
    getSliderConfig() {
        return this.onGetSliderConfig();
    }
    /**
     * subscribe to changes
     * @param func
     */ subscribe(func) {
        if (this.subscriberArr.includes(func)) return;
        this.subscriberArr.push(func);
    }
    unsubscribe(func) {
        for(let i = 0; i < this.subscriberArr.length; i++)if (func === this.subscriberArr[i]) {
            this.subscriberArr.splice(i, 1);
            i--;
        }
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.subscriberArr = [];
        this.onSetColor = p.onSetColor;
        this.onSetSize = p.onSetSize;
        this.onSetOpacity = p.onSetOpacity;
        this.onSetScatter = p.onSetScatter;
        this.onGetColor = p.onGetColor;
        this.onGetSize = p.onGetSize;
        this.onGetOpacity = p.onGetOpacity;
        this.onGetScatter = p.onGetScatter;
        this.onGetSliderConfig = p.onGetSliderConfig;
        if ($2cc9052c3f36f7f1$export$272bfd3ef9ef2f48.instance) throw new Error('BrushSettingService already instantiated');
        $2cc9052c3f36f7f1$export$272bfd3ef9ef2f48.instance = this;
    }
}







var $ad3e45d1c2d7a6be$exports = {};
$ad3e45d1c2d7a6be$exports = $parcel$resolve("8EUal");



var $125579f7a33d840c$exports = {};
$125579f7a33d840c$exports = $parcel$resolve("lQWO9");






var $3a83d9f064170ff2$export$1c6ca1c73436aa3c;
$3a83d9f064170ff2$export$1c6ca1c73436aa3c = `ttl1Ia_licenses`;







function $385afea81bc7341b$export$d3fe39c7bff44f23() {
    const libraries = (0, $934e5f47c3374e21$export$db3b6bfb95261072)('.' + $3a83d9f064170ff2$export$1c6ca1c73436aa3c, (0, $63d0b335c576c718$export$ce37e184d908d785)('loading'));
    const fonts = (0, $934e5f47c3374e21$export$db3b6bfb95261072)('.' + $3a83d9f064170ff2$export$1c6ca1c73436aa3c, (0, $63d0b335c576c718$export$ce37e184d908d785)('loading'));
    const content = (0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,flexCol,gap-10', [
        libraries,
        fonts
    ]);
    new (0, $18361e3f5d6257e8$export$185108a9b725b68)({
        title: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('licenses')
        }),
        content: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: content,
            css: {
                height: '100%',
                overflowY: 'auto',
                padding: '10px',
                boxSizing: 'border-box'
            }
        }),
        width: 800,
        isMaxHeight: true,
        onClose: ()=>{
            if (window.location.hash === '#licenses') history.replaceState('', document.title, window.location.pathname + window.location.search);
        }
    });
    (parcelRequire("62C6p")).then((result)=>{
        libraries.innerHTML = '';
        result.LICENSES.forEach((item)=>{
            libraries.append((0, $934e5f47c3374e21$export$db3b6bfb95261072)('details', [
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)('summary', item.title),
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)('', item.full.replace(/\n/g, '<br>'))
            ]));
        });
    });
    (parcelRequire("9vuYc")).then((result)=>{
        fonts.innerHTML = '';
        result.FONT_LICENSES.forEach((item)=>{
            fonts.append((0, $934e5f47c3374e21$export$db3b6bfb95261072)('details', [
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)('summary', 'Font: ' + item.title),
                (0, $934e5f47c3374e21$export$db3b6bfb95261072)('', item.full.replace(/\n/g, '<br>'))
            ]));
        });
    });
}





class $4c0471ae90bf93cd$export$ad7f6c626a2cdfad {
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor({ onLeftRight: onLeftRight, saveReminder: saveReminder, customAbout: customAbout }){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                margin: '10px'
            }
        });
        // ---- language ----
        const autoLanguage = (0, $63d0b335c576c718$export$e4ce066d17694649).getAutoLanguage();
        const langWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: (0, $63d0b335c576c718$export$ce37e184d908d785)('settings-language') + ':',
                css: {
                    marginRight: '5px',
                    marginBottom: '2px'
                }
            }),
            css: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap'
            }
        });
        const options = [
            [
                'auto',
                (0, $63d0b335c576c718$export$ce37e184d908d785)('auto') + ` \u{2192} ${autoLanguage.name} (${autoLanguage.code})`
            ],
            ...(0, $970d7af44d8b8038$export$d0d68bb9ed2c643d).map((item)=>{
                return [
                    item.code,
                    item.name + ` (${item.code})`
                ];
            })
        ];
        const languageSelect = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).Select({
            initValue: (0, $fc4403c8ee6a33dc$export$d802c22d109d9806)((0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem((0, $63d0b335c576c718$export$991796128b2ca217)) ? (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem((0, $63d0b335c576c718$export$991796128b2ca217)) : 'auto'),
            optionArr: options,
            onChange: (val)=>{
                if (val === 'auto') (0, $0ecef66681b62a8c$export$19fffca37ef3e106).removeItem((0, $63d0b335c576c718$export$991796128b2ca217));
                else (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem((0, $63d0b335c576c718$export$991796128b2ca217), val);
                languageHint.style.display = 'block';
            },
            name: 'language'
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(languageSelect.getElement(), {
            flexGrow: '1'
        });
        const languageHint = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-toolspace-note',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('settings-language-reload'),
            css: {
                display: 'none',
                marginTop: '5px',
                flexGrow: '1'
            }
        });
        langWrapper.append(languageSelect.getElement(), languageHint);
        // ---- theme ----
        function themeToLabel(theme) {
            return theme === 'dark' ? "\u2B1B " + (0, $63d0b335c576c718$export$ce37e184d908d785)('theme-dark') : "\u2B1C " + (0, $63d0b335c576c718$export$ce37e184d908d785)('theme-light');
        }
        const themeSelect = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).Select({
            optionArr: [
                [
                    'auto',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('auto') + " \u2192 " + themeToLabel((0, $74a507c74cfe9692$export$5714e40777c1bcc2).getMediaQueryTheme())
                ],
                [
                    'light',
                    themeToLabel('light')
                ],
                [
                    'dark',
                    themeToLabel('dark')
                ]
            ],
            initValue: (0, $74a507c74cfe9692$export$5714e40777c1bcc2).getStoredTheme() || 'auto',
            onChange: (val)=>{
                (0, $74a507c74cfe9692$export$5714e40777c1bcc2).setStoredTheme(val === 'auto' ? undefined : val);
            },
            name: 'ui-theme'
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(themeSelect.getElement(), {
            flexGrow: '1'
        });
        (0, $fc4403c8ee6a33dc$export$a9dfd81f95a8a526)(()=>{
            themeSelect.updateLabel('auto', (0, $63d0b335c576c718$export$ce37e184d908d785)('auto') + " \u2192 " + themeToLabel((0, $74a507c74cfe9692$export$5714e40777c1bcc2).getMediaQueryTheme()));
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: [
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    content: (0, $63d0b335c576c718$export$ce37e184d908d785)('settings-theme') + ':',
                    css: {
                        marginRight: '5px',
                        marginBottom: '2px'
                    }
                }),
                themeSelect.getElement()
            ],
            css: {
                marginTop: '15px',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap'
            }
        });
        // ---- save reminder ----
        if (saveReminder) {
            const reminderSelect = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).Select({
                optionArr: [
                    [
                        '20min',
                        (0, $63d0b335c576c718$export$ce37e184d908d785)('x-minutes', {
                            x: '20'
                        })
                    ],
                    [
                        '40min',
                        (0, $63d0b335c576c718$export$ce37e184d908d785)('x-minutes', {
                            x: '40'
                        })
                    ],
                    [
                        'disabled',
                        "\u26A0\uFE0F " + (0, $63d0b335c576c718$export$ce37e184d908d785)('settings-save-reminder-disabled')
                    ]
                ],
                initValue: saveReminder.getSetting(),
                onChange: (val)=>{
                    if (val !== 'disabled') {
                        saveReminder.setSetting(val);
                        return;
                    }
                    const disableStr = (0, $63d0b335c576c718$export$ce37e184d908d785)('settings-save-reminder-confirm-disable');
                    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
                        message: "\u26A0\uFE0F" + (0, $63d0b335c576c718$export$ce37e184d908d785)('settings-save-reminder-confirm-title'),
                        div: (0, $934e5f47c3374e21$export$db3b6bfb95261072)('', [
                            (0, $934e5f47c3374e21$export$db3b6bfb95261072)('.info-hint', (0, $63d0b335c576c718$export$ce37e184d908d785)('settings-save-reminder-confirm-a')),
                            (0, $63d0b335c576c718$export$ce37e184d908d785)('settings-save-reminder-confirm-b')
                        ]),
                        buttons: [
                            disableStr,
                            'Cancel'
                        ],
                        callback: (result)=>{
                            if (result === disableStr) saveReminder.setSetting(val);
                            else reminderSelect.setValue(saveReminder.getSetting());
                        }
                    });
                },
                name: 'save-reminder-interval'
            });
            reminderSelect.getElement().style.flexGrow = '1';
            this.rootEl.append((0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,items-center,gap-5,mt-15,flexWrap', [
                (0, $63d0b335c576c718$export$ce37e184d908d785)('settings-save-reminder-label') + ':',
                reminderSelect.getElement()
            ]));
        }
        // ---- flip ui ----
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            parent: this.rootEl,
            content: [
                (0, $52ad4d7a7d6372c1$export$ec664d7487540b)({
                    alt: 'icon',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($125579f7a33d840c$exports))),
                    width: 18,
                    height: 20,
                    css: {
                        marginRight: '5px'
                    }
                }),
                (0, $63d0b335c576c718$export$ce37e184d908d785)('switch-ui-left-right')
            ],
            onClick: ()=>onLeftRight(),
            css: {
                marginTop: '15px'
            },
            custom: {
                tabIndex: '-1'
            }
        });
        // ---- about ----
        this.rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'grid-hr',
            css: {
                margin: '10px 0'
            }
        }));
        function makeLicenses() {
            return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'a',
                content: (0, $63d0b335c576c718$export$ce37e184d908d785)('licenses'),
                onClick: ()=>(0, $385afea81bc7341b$export$d3fe39c7bff44f23)()
            });
        }
        if (customAbout) {
            this.rootEl.append(customAbout);
            if (!customAbout.innerHTML) {
                const minimalAbout = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    parent: customAbout,
                    css: {
                        textAlign: 'center'
                    }
                });
                minimalAbout.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    content: [
                        (0, $52ad4d7a7d6372c1$export$ec664d7487540b)({
                            alt: 'icon',
                            height: 20,
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ad3e45d1c2d7a6be$exports))),
                            css: {
                                verticalAlign: 'middle'
                            }
                        }),
                        ' ',
                        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                            tagName: 'a',
                            content: 'bitbof',
                            custom: {
                                href: 'https://bitbof.com',
                                target: '_blank',
                                tabIndex: '-1'
                            }
                        }),
                        " \xa9 2025",
                        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                            tagName: 'br'
                        })
                    ]
                }), makeLicenses());
            }
        } else {
            const versionEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: this.rootEl,
                css: {
                    textAlign: 'center'
                },
                content: [
                    (0, $52ad4d7a7d6372c1$export$ec664d7487540b)({
                        alt: 'Klecks',
                        className: 'dark-invert',
                        height: 25,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d2b76ee5a41cc2d0$exports)))
                    }),
                    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                        tagName: 'br'
                    }),
                    (0, $52ad4d7a7d6372c1$export$ec664d7487540b)({
                        alt: 'icon',
                        height: 20,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ad3e45d1c2d7a6be$exports))),
                        css: {
                            verticalAlign: 'middle'
                        }
                    }),
                    ' ',
                    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                        tagName: 'a',
                        content: 'bitbof',
                        custom: {
                            href: 'https://bitbof.com',
                            target: '_blank',
                            tabIndex: '-1'
                        }
                    }),
                    " \xa9 2025",
                    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                        tagName: 'br'
                    })
                ]
            });
            versionEl.append(makeLicenses(), document.createTextNode(' | '), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'a',
                content: (0, $63d0b335c576c718$export$ce37e184d908d785)('donate'),
                custom: {
                    href: 'https://kleki.com/donate/',
                    target: '_blank'
                }
            }), document.createTextNode(' | '), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                tagName: 'a',
                content: (0, $63d0b335c576c718$export$ce37e184d908d785)('source-code'),
                custom: {
                    href: 'https://klecks.org',
                    target: '_blank'
                }
            }));
        }
        window.addEventListener('storage', (e)=>{
            if (e.key !== (0, $63d0b335c576c718$export$991796128b2ca217)) return;
            languageSelect.setValue((0, $fc4403c8ee6a33dc$export$d802c22d109d9806)((0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem((0, $63d0b335c576c718$export$991796128b2ca217)) ? (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem((0, $63d0b335c576c718$export$991796128b2ca217)) : 'auto'));
        });
    }
}






class $6395dd91f6160304$export$42a534af7eb650e8 {
    update() {
        let newUpDisplay = this.upBtn.style.display;
        let newDownDisplay = this.downBtn.style.display;
        if (this.toolspace.scrollHeight > this.toolspace.offsetHeight + 3) {
            // small buffer where it's not worth it
            if (!this.upInterval) newUpDisplay = this.toolspace.scrollTop === 0 ? 'none' : 'block';
            if (!this.downInterval) newDownDisplay = this.toolspace.scrollTop + this.toolspace.offsetHeight + 1 >= this.toolspace.scrollHeight ? 'none' : 'block';
        } else {
            newUpDisplay = 'none';
            newDownDisplay = 'none';
        }
        // check to prevent infinite MutationObserver loop in Pale Moon
        if (newUpDisplay !== this.upBtn.style.display) this.upBtn.style.display = newUpDisplay;
        if (newDownDisplay !== this.downBtn.style.display) this.downBtn.style.display = newDownDisplay;
    }
    updateUiState(uiState) {
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.upBtn, {
            left: uiState === 'left' ? '0' : '',
            right: uiState === 'right' ? '0' : ''
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.downBtn, {
            left: uiState === 'left' ? '0' : '',
            right: uiState === 'right' ? '0' : ''
        });
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.toolspace = p.toolspace;
        this.upBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.toolspace,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('scroll'),
            className: 'kl-scroller',
            css: {
                top: '0',
                transform: 'rotate(180deg)'
            }
        });
        this.downBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.toolspace,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('scroll'),
            className: 'kl-scroller',
            css: {
                bottom: '0'
            }
        });
        this.updateUiState(p.uiState);
        const upListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.upBtn,
            onPointer: (e)=>{
                if (e.type === 'pointerdown') this.upInterval = setInterval(()=>{
                    this.toolspace.scrollBy(0, -13);
                    this.update();
                }, 20);
                if (e.type === 'pointerup') {
                    clearInterval(this.upInterval);
                    setTimeout(()=>{
                        // prevent ff pressing anything underneath
                        this.upInterval = null;
                        this.update();
                    }, 50);
                }
            }
        });
        const downListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.downBtn,
            onPointer: (e)=>{
                if (e.type === 'pointerdown') this.downInterval = setInterval(()=>{
                    this.toolspace.scrollBy(0, 13);
                    this.update();
                }, 20);
                if (e.type === 'pointerup') {
                    clearInterval(this.downInterval);
                    setTimeout(()=>{
                        // prevent ff pressing anything underneath
                        this.downInterval = null;
                        this.update();
                    }, 50);
                }
            }
        });
        const wheelListener = (e)=>{
            this.toolspace.scrollBy(0, Math.round(0.7 * e.deltaY));
            this.update();
        };
        this.upBtn.addEventListener('wheel', wheelListener, {
            passive: false
        });
        this.downBtn.addEventListener('wheel', wheelListener, {
            passive: false
        });
        this.update();
        const observer = new MutationObserver(()=>this.update());
        observer.observe(this.toolspace, {
            attributes: true,
            childList: true,
            subtree: true
        });
        window.addEventListener('resize', ()=>this.update());
        // hide if in dialog because that can have its own scrollbar
        (0, $6b37b427615ca1fa$export$d3d1650bc39c4419).subscribe((v)=>{
            // ignores the 0.5 by tool dropdown
            this.upBtn.style.opacity = v >= 1 ? '0' : '';
            this.downBtn.style.opacity = v >= 1 ? '0' : '';
        });
    }
}








class $2ae4a5af5e108b3d$export$7fa03d1ef9d3489e {
    updateIcons() {
        const col1 = this.settings.isReversed ? '#0000' : '#000';
        const col2 = this.settings.isReversed ? '#000' : '#0000';
        this.iconArr[0].style.background = `linear-gradient(${col1}, ${col2})`;
        this.iconArr[1].style.background = `linear-gradient(${col2}, ${col1}, ${col2})`;
        this.iconArr[2].style.background = `radial-gradient(${col1}, ${col2})`;
    }
    getElement() {
        return this.rootEl;
    }
    setIsVisible(isVisible) {
        this.isVisible = isVisible;
        this.rootEl.style.display = isVisible ? 'block' : 'none';
        if (isVisible) this.colorDiv.append(this.colorSlider.getElement(), this.colorSlider.getOutputElement());
    }
    getSettings() {
        return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.settings);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.settings = {
            opacity: 1,
            type: 'linear',
            doLockAlpha: false,
            doSnap: false,
            isReversed: false,
            isEraser: false
        };
        this.colorSlider = p.colorSlider;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                margin: '10px'
            }
        });
        this.isVisible = true;
        this.colorDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                marginBottom: '10px'
            }
        });
        this.iconArr = [];
        {
            const size = 33;
            [
                0,
                1,
                2
            ].forEach(()=>{
                const el = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    className: 'dark-invert',
                    css: {
                        width: size + 'px',
                        height: size + 'px',
                        borderRadius: '3px',
                        margin: '1px'
                    }
                });
                this.iconArr.push(el);
            });
        }
        this.updateIcons();
        const typeOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'linear',
                    label: this.iconArr[0],
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('gradient-linear')
                },
                {
                    id: 'linear-mirror',
                    label: this.iconArr[1],
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('gradient-linear-mirror')
                },
                {
                    id: 'radial',
                    label: this.iconArr[2],
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('gradient-radial')
                }
            ],
            initId: 'linear',
            onChange: (id)=>{
                this.settings.type = id;
            }
        });
        this.rootEl.append(typeOptions.getElement());
        const opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
            width: 250,
            height: 30,
            min: 0.01,
            max: 1,
            value: this.settings.opacity,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100,
            onChange: (val)=>{
                this.settings.opacity = val;
            }
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(opacitySlider.getElement(), {
            marginTop: '10px'
        });
        this.rootEl.append(opacitySlider.getElement());
        const row1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px'
            }
        });
        const reverseToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('reverse'),
            callback: (b)=>{
                this.settings.isReversed = b;
                this.updateIcons();
            },
            css: {
                width: '50%'
            },
            name: 'reverse-gradient'
        });
        const doSnapToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('angle-snap'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('angle-snap-title'),
            callback: (b)=>{
                this.settings.doSnap = b;
            },
            css: {
                width: '50%'
            },
            name: 'enable-snapping'
        });
        row1.append(reverseToggle.getElement(), doSnapToggle.getElement());
        const row2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px'
            }
        });
        const eraserToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: this.settings.isEraser,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('eraser'),
            callback: (b)=>{
                this.settings.isEraser = b;
            },
            css: {
                width: '50%'
            },
            name: 'enable-eraser'
        });
        const lockAlphaToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('lock-alpha-title'),
            callback: (b)=>{
                this.settings.doLockAlpha = b;
            },
            doHighlight: true,
            css: {
                width: '50%'
            },
            name: 'enable-alpha-lock'
        });
        row2.append(eraserToggle.getElement(), lockAlphaToggle.getElement());
    }
}



const $49faab2330529a96$export$6e4a713ddcda1e5e = {
    BRUSHES: // --- brushes ---
    $8baf89d70f3487eb$export$32510733a89b2eab,
    BRUSHES_UI: $b2f1ee6bcab52d93$export$d1a79a5ce7e46547,
    BrushSettingService: $2cc9052c3f36f7f1$export$272bfd3ef9ef2f48,
    KlCanvas: // --- canvas ---
    $d26b85e649dca02a$export$4a819bde91671014,
    KlCanvasPreview: // --- canvas ui ---
    $1ac505c1a3109a32$export$e258ade1648009b7,
    FILTER_LIB_STATUS: // --- filters ---
    $aa2ca71db1de8ae6$export$24724bc1f91cba3,
    FILTER_LIB: $aa2ca71db1de8ae6$export$bac24f240bb7727d,
    ShapeTool: // --- image operations ---
    $583d130d11db85ad$export$27550cc14d7ae85a,
    drawShape: $583d130d11db85ad$export$71b514a25c47df50,
    GradientTool: $64881aa9f7f8f596$export$74d12f09ff9f1956,
    drawGradient: $64881aa9f7f8f596$export$b1f70a113e3b5c1b,
    PSD: // --- storage ---
    $e9d04a247aa46c18$exports,
    ProjectStore: $e42d359db0fc5c76$export$93d91060b9af7e2a,
    loadAgPsd: $e4b3248b4ce95ea5$export$ab3d838b1d336b38,
    SaveToComputer: $f853515918de2fdb$export$75e7b60500bb415b,
    Checkbox: // --- ui - components ---
    $213947897b67ec3a$export$48513f6b9f8ce62d,
    input: $760dd90d44275661$export$b7e3ae3d7c15e42e,
    Select: $b1ef42bd443626ca$export$ef9b1a59e592288f,
    ImageToggle: $a14a8e8cf8cc5885$export$b6d053cded550773,
    ImageRadioList: $fa6faa989b2cc6b2$export$7cc1012a658e6ad8,
    RadioList: $f734cb8286217c3c$export$3dff5655255b5729,
    createPenPressureToggle: $218f70778c2bf652$export$9da2e8821e6cbb57,
    KlSlider: $cd73d123a4560ac3$export$a1855b925e534de7,
    HexColorDialog: $49ce344532144fcf$export$cc42e119007cb939,
    KlColorSlider: $90a88670cfc900e0$export$4e5102252876c5d7,
    KlColorSliderSmall: $8f768338795db7a0$export$66306bf21a9ff39e,
    PointSlider: $867da577d723d824$export$ac00cea56cec3037,
    ColorOptions: $3032e23fa8f3a9e5$export$24ba9b81662d4366,
    Options: $1166276dc18d3ea9$export$c019608e5b5bb4cb,
    BoxToggle: $8d99bd5fadaac7f9$export$2358c75ad3c15b2d,
    StatusOverlay: $7ed35ae008fa6be6$export$5ee0af1d5c87e856,
    CropCopy: $c5a9090dbc3ef918$export$40175a5948a88a57,
    FreeTransform: $d42d1384577ab84d$export$79a74567acf241b0,
    FreeTransformCanvas: $1fee4e0c7c231d15$export$205c2dd29f8a66b5,
    Cropper: $c4e8a5b20c195c16$export$71ed2b85d4ca43d3,
    LayerPreview: $6f827bc527014b7f$export$d25420b53e16716f,
    KlImageDropper: $71c20b9a25b8f899$export$e789742143ba5b1,
    OverlayToolspace: $b80d451cabaa19d2$export$9f0da9b942594e99,
    ToolspaceTopRow: $50947f5db7d72ab3$export$665d2c76b1eb8459,
    ToolDropdown: $d199831ecec4fae4$export$a0a40f8a0b8fee15,
    ToolspaceToolRow: $79297c17befec587$export$c744a22bef9e0b97,
    ToolspaceStabilizerRow: $6ae4f2a30e17169a$export$8162a66cd18867a7,
    TabRow: $ae064bc6cfaee2ee$export$3c6d17ed0106bfb9,
    ToolspaceCollapser: $da66208906376381$export$5b91f641162972fc,
    BrowserStorageUi: $1a83f3b0ed28fe18$export$9c72cf485ef46673,
    SaveReminder: $5ecc5a61dcd332b6$export$befc6437ad34b28a,
    ToolspaceScroller: $6395dd91f6160304$export$42a534af7eb650e8,
    DIALOG_COUNTER: // --- ui - modals ---
    $6b37b427615ca1fa$export$d3d1650bc39c4419,
    popup: (0, $2016c314bff36ab9$export$d7e8d4d4450c819c),
    Popup: (0, $18361e3f5d6257e8$export$185108a9b725b68),
    clipboardDialog: $5e9fef22bb47992b$export$32b89bc9bb92706a,
    showImportAsLayerDialog: $6be05b3a68464314$export$962af7e240721d88,
    newImageDialog: $d43dc22de82019e6$export$f77a89101d7d6586,
    textToolDialog: $3217004ef102ca9c$export$e263e067d6140649,
    showImportImageDialog: $aa951ef8a5f9de6d$export$1bf16d9bd59fd8f9,
    showIframePopup: (0, $165d2995997b2f9b$export$35fa34e5af64bd4a),
    imgurUpload: $1acd53d54391923e$export$b1dd62fa0b5f32f5,
    HandUi: // --- ui - tool tabs ---
    $d4c26c4eab3ed9b4$export$cf20160367bae46c,
    FillUi: $274b5c24f0b5af79$export$1e63e3b0645421a2,
    GradientUi: $2ae4a5af5e108b3d$export$7fa03d1ef9d3489e,
    TextUi: $a6bad5d4783f8133$export$32a22540e4b2f123,
    ShapeUi: $f0a35036bcb542fb$export$a9387b1d4260d39c,
    FileUi: $dad163782d7c02d0$export$409b892ffe02580b,
    EditUi: $bc1f03f9e593bc1c$export$aeb1a0a0e64541b5,
    SettingsUi: $4c0471ae90bf93cd$export$ad7f6c626a2cdfad,
    LayersUi: $a4100dd1ad7b3844$export$c3bf51e04f391d6d
};
Object.keys($49faab2330529a96$export$6e4a713ddcda1e5e); // without this, parcel build may break this object








class $db287580a54bd175$export$ce26cd3db18613a3 {
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-toolspace-row',
            css: {
                height: '36px',
                display: 'flex'
            }
        });
        function createButton(p) {
            const padding = 6 + (p.extraPadding ? p.extraPadding : 0);
            const el = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'toolspace-row-button nohighlight',
                title: p.title,
                onClick: p.onClick,
                css: {
                    padding: p.content ? '' : p.contain ? padding + 'px 0' : ''
                }
            });
            if (p.content) el.append(p.content);
            else {
                const im = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    className: 'dark-invert',
                    css: {
                        backgroundImage: "url('" + p.image + "')",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: p.contain ? 'contain' : '',
                        //filter: 'grayscale(1)',
                        height: '100%'
                    }
                });
                im.style.pointerEvents = 'none';
                el.append(im);
            }
            const pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                // because :hover causes problems w touch
                target: el,
                onEnterLeave: function(isOver) {
                    el.classList.toggle('toolspace-row-button-hover', isOver);
                }
            });
            return {
                el: el,
                pointerListener: pointerListener
            };
        }
        const submitButton = createButton({
            onClick: p.onSubmit,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('submit-title'),
            content: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: (0, $63d0b335c576c718$export$ce37e184d908d785)('submit'),
                className: 'toolspace-row-button__submit',
                css: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%'
                }
            }),
            contain: true
        });
        submitButton.el.style.width = '45px';
        const helpButton = createButton({
            onClick: p.onHelp,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('help'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($1fbb59b08bf77b76$exports))),
            contain: true
        });
        const leftRightButton = createButton({
            onClick: p.onLeftRight,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('switch-ui-left-right'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($125579f7a33d840c$exports))),
            contain: true
        });
        this.rootEl.append(submitButton.el, leftRightButton.el, helpButton.el);
    }
}




const $21a9e2eeab18749b$export$f02de051ab70b20e = 60;











class $7f838dbc615d3028$export$94ec999f33a691e3 {
    setPostMix(postMix) {
        this.postMix = postMix;
    }
    destroy() {
        var // I don't remember why the other texture is destroyed differently.
        _this_maskTexture;
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(this.textureSource);
        this.maskCanvas && (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(this.maskCanvas);
        if (this.texture) {
            this.texture = this.fxCanvas.texture(this.textureSource);
            this.fxCanvas.draw(this.texture).update();
            this.texture && this.texture.destroy();
        }
        (_this_maskTexture = this.maskTexture) === null || _this_maskTexture === void 0 ? void 0 : _this_maskTexture.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.texture = undefined;
        this.maskCanvas = undefined // prevent destroying the mask repeatedly
        ;
        this.maskTexture = undefined;
        this.oldOnUpdateProps = {
            textureWidth: 0,
            textureHeight: 0,
            transform: {
                scaleX: 0,
                scaleY: 0,
                angleDeg: 0,
                x: 0,
                y: 0
            }
        };
        this.render = (viewportTransform, viewportWidth, viewportHeight)=>{
            const viewportMat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(viewportTransform);
            const padding = 0; // render more than visible with padding < 0
            let clippedViewportRect; // rect in viewport coordinates which contains the canvas
            let transformMatrix = (0, $5c473edaf09eadd3$export$f0954fd7d5368655)();
            {
                const topLeft = (0, $855520c81dfcb96a$export$9b20165a36586806)(viewportMat, {
                    x: 0,
                    y: 0
                });
                const bottomRight = (0, $855520c81dfcb96a$export$9b20165a36586806)(viewportMat, {
                    x: this.original.width,
                    y: this.original.height
                });
                bottomRight.x = Math.round(bottomRight.x);
                bottomRight.y = Math.round(bottomRight.y);
                const clippedTL = {
                    x: Math.max(padding, topLeft.x),
                    y: Math.max(padding, topLeft.y)
                };
                const clippedBR = {
                    x: Math.min(viewportWidth - padding, bottomRight.x),
                    y: Math.min(viewportHeight - padding, bottomRight.y)
                };
                clippedViewportRect = {
                    x: clippedTL.x,
                    y: clippedTL.y,
                    width: clippedBR.x - clippedTL.x,
                    height: clippedBR.y - clippedTL.y
                };
                if (clippedViewportRect.width <= 0 || clippedViewportRect.height <= 0) {
                    this.textureSource.width = 1;
                    this.textureSource.height = 1;
                    return this.textureSource;
                }
            }
            let resultTransform = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $077740f52fe6870e$export$70ae2c07e401031b)(viewportMat), (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(padding, padding), (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(clippedViewportRect.x - padding, clippedViewportRect.y - padding));
            const onUpdateProps = {
                textureWidth: Math.ceil(clippedViewportRect.width),
                textureHeight: Math.ceil(clippedViewportRect.height),
                transform: {
                    scaleX: viewportTransform.scaleX,
                    scaleY: viewportTransform.scaleY,
                    angleDeg: viewportTransform.angleDeg,
                    x: viewportTransform.x - clippedViewportRect.x,
                    y: viewportTransform.y - clippedViewportRect.y
                }
            };
            let tlOffsetX = 0;
            let tlOffsetY = 0;
            if (viewportTransform.scaleX > 1) {
                // what pixels of original canvas are actually visible
                const canvasTopLeft = (0, $855520c81dfcb96a$export$9b20165a36586806)(resultTransform, {
                    x: 0,
                    y: 0
                });
                tlOffsetX = -canvasTopLeft.x;
                tlOffsetY = -canvasTopLeft.y;
                canvasTopLeft.x = Math.max(0, Math.floor(canvasTopLeft.x));
                canvasTopLeft.y = Math.max(0, Math.floor(canvasTopLeft.y));
                tlOffsetX += canvasTopLeft.x;
                tlOffsetY += canvasTopLeft.y;
                const canvasBottomRight = (0, $855520c81dfcb96a$export$9b20165a36586806)(resultTransform, {
                    x: clippedViewportRect.width,
                    y: clippedViewportRect.height
                });
                canvasBottomRight.x = Math.min(this.original.width, Math.ceil(canvasBottomRight.x));
                canvasBottomRight.y = Math.min(this.original.height, Math.ceil(canvasBottomRight.y));
                const cw = canvasBottomRight.x - canvasTopLeft.x;
                const ch = canvasBottomRight.y - canvasTopLeft.y;
                onUpdateProps.textureWidth = cw;
                onUpdateProps.textureHeight = ch;
                onUpdateProps.transform = {
                    scaleX: 1,
                    scaleY: 1,
                    angleDeg: 0,
                    x: -canvasTopLeft.x,
                    y: -canvasTopLeft.y
                };
                resultTransform = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)(resultTransform, (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(viewportTransform.scaleX, viewportTransform.scaleY), (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(tlOffsetX, tlOffsetY));
            }
            if (!this.texture || JSON.stringify(onUpdateProps) !== JSON.stringify(this.oldOnUpdateProps) || this.postMix) {
                // update texture
                this.textureSource.width = onUpdateProps.textureWidth;
                this.textureSource.height = onUpdateProps.textureHeight;
                // draw original canvas into temp
                this.ctx.save();
                this.ctx.imageSmoothingEnabled = false;
                if (viewportTransform.scaleX > 1) {
                    transformMatrix = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(onUpdateProps.transform);
                    this.ctx.setTransform(...(0, $974f651610599156$export$2b60e7dafdbde18a)(transformMatrix));
                } else {
                    transformMatrix = (0, $077740f52fe6870e$export$70ae2c07e401031b)(resultTransform);
                    this.ctx.setTransform(...(0, $974f651610599156$export$2b60e7dafdbde18a)(transformMatrix));
                }
                this.ctx.drawImage(this.original, 0, 0);
                this.ctx.restore();
                // debug
                /*BB.css(this.canvas, {
                position: 'absolute',
                left: '0',
                top: '0',
                zIndex: '1000',
                boxShadow: '0 0 0 1px #f00',
            });
            document.body.append(this.canvas);*/ const propsDidChange = JSON.stringify(onUpdateProps) !== JSON.stringify(this.oldOnUpdateProps);
                if (!this.texture || propsDidChange) {
                    if (this.texture) this.texture.loadContentsOf(this.textureSource);
                    else this.texture = this.fxCanvas.texture(this.textureSource);
                }
                if (this.selection && (!this.maskTexture || propsDidChange)) {
                    if (!this.maskCanvas) this.maskCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(onUpdateProps.textureWidth, onUpdateProps.textureHeight);
                    else {
                        this.maskCanvas.width = onUpdateProps.textureWidth;
                        this.maskCanvas.height = onUpdateProps.textureHeight;
                    }
                    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.maskCanvas);
                    const transformedSelection = (0, $1d9e27e0466b80f7$export$aa391dbbf8073422)(this.selection, transformMatrix);
                    (0, $13d5aa49e37e2734$export$f7b95c0f504bef8b)(transformedSelection, ctx);
                    if (this.maskTexture) this.maskTexture.loadContentsOf(this.maskCanvas);
                    else this.maskTexture = this.fxCanvas.texture(this.maskCanvas);
                }
                if (!this.postMix) {
                    this.textureSource.width = 1;
                    this.textureSource.height = 1;
                }
            }
            this.oldOnUpdateProps = onUpdateProps;
            this.onUpdate(this.fxCanvas.draw(this.texture), onUpdateProps.transform);
            if (this.maskTexture) this.fxCanvas.multiplyAlpha().mask(this.maskTexture, this.isMaskingWithEmptyOriginal ? undefined : this.texture, true).unmultiplyAlpha();
            this.fxCanvas.update();
            if (this.postMix) {
                this.ctx.save();
                this.ctx.globalAlpha = this.postMix.opacity;
                this.ctx.globalCompositeOperation = this.postMix.operation;
                this.ctx.drawImage(this.fxCanvas, 0, 0);
                this.ctx.restore();
                return {
                    image: this.textureSource,
                    transform: resultTransform
                };
            }
            return {
                image: this.fxCanvas,
                transform: resultTransform
            };
        };
        this.original = p.original;
        this.onUpdate = p.onUpdate;
        this.textureSource = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(1, 1);
        this.ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(this.textureSource);
        this.fxCanvas = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)((0, $5caaf17bca0749c7$export$8c4423af32b21158)());
        this.postMix = p.postMix;
        this.selection = p.selection;
        this.isMaskingWithEmptyOriginal = !!p.isMaskingWithEmptyOriginal;
    }
}












function $31c92ae106360499$export$66c6ccb6bcae2c94(context, selection, applyFn, klHistory) {
    const fxCanvas = (0, $5caaf17bca0749c7$export$8c4423af32b21158)();
    if (!fxCanvas) return false; // todo more specific error?
    let maskTexture;
    if (selection) {
        const maskCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(context.canvas.width, context.canvas.height);
        const maskContext = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(maskCanvas);
        (0, $13d5aa49e37e2734$export$f7b95c0f504bef8b)(selection, maskContext);
        maskTexture = fxCanvas.texture(maskCanvas);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(maskCanvas);
    }
    const originalTexture = fxCanvas.texture(context.canvas);
    fxCanvas.draw(originalTexture);
    applyFn(fxCanvas);
    if (maskTexture) {
        fxCanvas.multiplyAlpha().mask(maskTexture, originalTexture, true).unmultiplyAlpha();
        maskTexture.destroy();
    }
    originalTexture.destroy();
    fxCanvas.update();
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    context.drawImage(fxCanvas, 0, 0);
    klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(klHistory.getComposed(), (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(context.canvas, selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(selection, 'index') : undefined)));
    return true;
}



const $257cfc293f7e7cb2$export$af433fb90aa90a38 = {
    getDialog (params) {
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        let brightness = 0, contrast = 0;
        const fxPreviewRenderer = new (0, $7f838dbc615d3028$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: (fxCanvas)=>{
                return fxCanvas.brightnessContrast(brightness, contrast);
            },
            selection: klCanvas.getSelection()
        });
        const brightnessSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-bright-contrast-brightness'),
            width: 300,
            height: 30,
            min: 0,
            max: 100,
            value: (brightness + 1) * 50,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: function(val) {
                brightness = val / 50 - 1;
                preview.render();
            }
        });
        const contrastSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-bright-contrast-contrast'),
            width: 300,
            height: 30,
            min: 0,
            max: 100,
            value: (contrast + 1) * 50,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: function(val) {
                contrast = val / 50 - 1;
                preview.render();
            }
        });
        brightnessSlider.getElement().style.marginBottom = '10px';
        contrastSlider.getElement().style.marginBottom = '10px';
        rootEl.append(brightnessSlider.getElement(), contrastSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            brightnessSlider.destroy();
            contrastSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                brightness: brightness,
                contrast: contrast
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const brightness = params.input.brightness;
        const contrast = params.input.contrast;
        const klHistory = params.klHistory;
        if (!context) return false;
        return (0, $31c92ae106360499$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.brightnessContrast(brightness, contrast);
        }, klHistory);
    }
};











const $979e97880c50429e$export$e5937df51b9e1d86 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        const tempCanvas = klCanvas.getCompleteCanvas(1);
        tempCanvas.style.display = 'block';
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        let left = 0, right = 0, top = 0, bottom = 0;
        let leftChanged = false, rightChanged = false, topChanged = false, bottomChanged = false;
        const maxWidth = params.maxWidth, maxHeight = params.maxHeight;
        let scale = 1;
        const selection = klCanvas.getSelection();
        let selectionBounds = selection ? (0, $9414f5ea41e9cf25$export$ddc1c0069d484d49)((0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(selection, 'index'), klCanvas.getWidth(), klCanvas.getHeight()) : undefined;
        if (selectionBounds) {
            const boundsWidth = selectionBounds.x2 - selectionBounds.x1 + 1;
            const boundsHeight = selectionBounds.y2 - selectionBounds.y1 + 1;
            if (boundsWidth <= maxWidth && boundsHeight <= maxHeight) {
                top = selectionBounds.y1;
                right = selectionBounds.x2 - klCanvas.getWidth();
                bottom = selectionBounds.y2 - klCanvas.getHeight();
                left = selectionBounds.x1;
            } else selectionBounds = undefined;
        }
        // --- input elements ---
        const leftInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: left,
            type: 'number',
            min: -klCanvas.getWidth(),
            max: maxWidth,
            css: {
                width: '75px'
            },
            callback: function() {
                leftChanged = true;
                updateInput();
            }
        });
        const rightInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: right,
            type: 'number',
            min: -klCanvas.getWidth(),
            max: maxWidth,
            css: {
                width: '75px'
            },
            callback: function() {
                rightChanged = true;
                updateInput();
            }
        });
        const topInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: top,
            type: 'number',
            min: -klCanvas.getHeight(),
            max: maxHeight,
            css: {
                width: '75px'
            },
            callback: function() {
                topChanged = true;
                updateInput();
            }
        });
        const bottomInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: bottom,
            type: 'number',
            min: -klCanvas.getHeight(),
            max: maxHeight,
            css: {
                width: '75px'
            },
            callback: function() {
                bottomChanged = true;
                updateInput();
            }
        });
        const sharedCss = {
            display: 'flex',
            flexDirection: 'column',
            width: 'calc(50% - 5px)',
            gap: '3px'
        };
        const leftWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-crop-left') + ':',
                leftInput
            ],
            css: sharedCss
        });
        const rightWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-crop-right') + ':',
                rightInput
            ],
            css: sharedCss
        });
        const topWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-crop-top') + ':',
                topInput
            ],
            css: sharedCss
        });
        const bottomWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-crop-bottom') + ':',
                bottomInput
            ],
            css: sharedCss
        });
        const wrapWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px'
            }
        });
        wrapWrapper.append(leftWrapper, rightWrapper, topWrapper, bottomWrapper);
        rootEl.append(wrapWrapper);
        function updateInput() {
            left = parseInt(leftInput.value);
            right = parseInt(rightInput.value);
            top = parseInt(topInput.value);
            bottom = parseInt(bottomInput.value);
            let newWidth = klCanvas.getWidth() + left + right;
            let newHeight = klCanvas.getHeight() + top + bottom;
            if (newWidth <= 0) {
                if (leftChanged) {
                    left = -klCanvas.getWidth() - right + 1;
                    leftInput.value = '' + left;
                }
                if (rightChanged) {
                    right = -klCanvas.getWidth() - left + 1;
                    rightInput.value = '' + right;
                }
                newWidth = 1;
            }
            if (newWidth > maxWidth) {
                if (leftChanged) {
                    left = -klCanvas.getWidth() - right + maxWidth;
                    leftInput.value = '' + left;
                }
                if (rightChanged) {
                    right = -klCanvas.getWidth() - left + maxWidth;
                    rightInput.value = '' + right;
                }
                newWidth = maxWidth;
            }
            if (newHeight <= 0) {
                if (topChanged) {
                    top = -klCanvas.getHeight() - bottom + 1;
                    topInput.value = '' + top;
                }
                if (bottomChanged) {
                    bottom = -klCanvas.getHeight() - top + 1;
                    bottomInput.value = '' + bottom;
                }
                newHeight = 1;
            }
            if (newHeight > maxHeight) {
                if (topChanged) {
                    top = -klCanvas.getHeight() - bottom + maxHeight;
                    topInput.value = '' + top;
                }
                if (bottomChanged) {
                    bottom = -klCanvas.getHeight() - top + maxHeight;
                    bottomInput.value = '' + bottom;
                }
                newHeight = maxHeight;
            }
            cropper.setTransform({
                x: -left,
                y: -top,
                width: newWidth,
                height: newHeight
            });
            leftChanged = false;
            rightChanged = false;
            topChanged = false;
            bottomChanged = false;
        }
        let useRuleOfThirds = true;
        const ruleOThirdsCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-crop-rule-thirds'),
            allowTab: true,
            callback: function(b) {
                useRuleOfThirds = b;
                cropper.showThirds(useRuleOfThirds);
            },
            name: 'rule-of-thirds'
        });
        rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                clear: 'both'
            }
        }));
        let selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
        const colorOptionsArr = [
            {
                r: 0,
                g: 0,
                b: 0,
                a: 0
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            }
        ];
        colorOptionsArr.push({
            r: params.currentColorRgb.r,
            g: params.currentColorRgb.g,
            b: params.currentColorRgb.b,
            a: 1
        });
        colorOptionsArr.push({
            r: params.secondaryColorRgb.r,
            g: params.secondaryColorRgb.g,
            b: params.secondaryColorRgb.b,
            a: 1
        });
        const colorOptions = new (0, $3032e23fa8f3a9e5$export$24ba9b81662d4366)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-crop-fill'),
            colorArr: colorOptionsArr,
            onChange: function(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                updateBg();
            }
        });
        const flexRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '10px'
            }
        });
        rootEl.append(flexRow);
        flexRow.append(ruleOThirdsCheckbox.getElement(), colorOptions.getElement());
        // when input field changed, or dragging in preview finished
        // adjusts the zoom
        function update(transform) {
            const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(transform.width, transform.height, 260, 180, 1);
            scale = fit.width / transform.width;
            const offset = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).centerWithin((0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).width, previewHeight, fit.width, fit.height);
            tempCanvas.style.width = klCanvas.getWidth() * scale + 'px';
            tempCanvas.style.height = klCanvas.getHeight() * scale + 'px';
            tempCanvas.style.imageRendering = scale >= 1 ? 'pixelated' : '';
            offsetWrapper.style.left = offset.x - transform.x * scale + 'px';
            offsetWrapper.style.top = offset.y - transform.y * scale + 'px';
            left = parseInt('' + -transform.x);
            top = parseInt('' + -transform.y);
            right = parseInt('' + (transform.x + transform.width - klCanvas.getWidth()));
            bottom = parseInt('' + (transform.y + transform.height - klCanvas.getHeight()));
            leftInput.value = '' + left;
            topInput.value = '' + top;
            rightInput.value = '' + right;
            bottomInput.value = '' + bottom;
            if (selectedRgbaObj.a !== 0) {
                tempCanvas.style.background = 'var(--kl-checkerboard-background)';
                tempCanvas.style.backgroundSize = 100 * scale + 'px';
            }
            previewWrapper.style.backgroundPosition = offset.x + 'px ' + offset.y + 'px';
            previewWrapper.style.backgroundSize = 100 * scale + 'px';
            cropper.setScale(scale);
        }
        const previewHeight = (0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).height - 2; // two less because of border
        const previewWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-edit-crop-preview',
            css: {
                width: (0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).width + 'px',
                marginTop: '10px',
                marginLeft: '-20px',
                height: previewHeight + 'px',
                backgroundColor: '#9e9e9e',
                position: 'relative',
                borderTop: '1px solid rgb(144,144,144)',
                borderBottom: '1px solid rgb(144,144,144)',
                overflow: 'hidden',
                userSelect: 'none',
                touchAction: 'none',
                background: 'var(--kl-checkerboard-background)'
            }
        });
        previewWrapper.oncontextmenu = function() {
            return false;
        };
        const bgColorOverlay = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                bottom: '0',
                right: '0'
            }
        });
        previewWrapper.append(bgColorOverlay);
        const offsetWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: previewWrapper,
            css: {
                position: 'absolute',
                left: '0',
                top: '0'
            }
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: offsetWrapper,
            content: tempCanvas,
            css: {
                boxShadow: '0 0 0px 1px rgb(130,130,130)',
                position: 'absolute',
                left: '0px',
                top: '0px'
            }
        });
        rootEl.append(previewWrapper);
        const cropper = new (0, $c4e8a5b20c195c16$export$71ed2b85d4ca43d3)({
            x: 0,
            y: 0,
            width: klCanvas.getWidth(),
            height: klCanvas.getHeight(),
            scale: scale,
            callback: update,
            maxW: maxWidth,
            maxH: maxHeight,
            init: selectionBounds
        });
        update(cropper.getTransform());
        offsetWrapper.append(cropper.getElement());
        function updateBg() {
            if (selectedRgbaObj.a === 0) {
                bgColorOverlay.style.background = '';
                tempCanvas.style.background = '';
            } else {
                bgColorOverlay.style.background = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(selectedRgbaObj);
                tempCanvas.style.background = 'var(--kl-checkerboard-background)';
                tempCanvas.style.backgroundSize = 100 * scale + 'px';
            }
        }
        result.destroy = ()=>{
            cropper.destroy();
            ruleOThirdsCheckbox.destroy();
            colorOptions.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                left: left,
                right: right,
                top: top,
                bottom: bottom,
                fillColor: selectedRgbaObj.a === 0 ? undefined : selectedRgbaObj
            };
        };
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        if (!klCanvas || isNaN(params.input.left) || isNaN(params.input.right) || isNaN(params.input.top) || isNaN(params.input.bottom)) return false;
        klCanvas.resizeCanvas(params.input);
        return true;
    }
};







function $160131d78cb8ea88$export$4300cf0a0df418a6() {
    return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj({
        r: [
            [
                0,
                0
            ],
            [
                1 / 3,
                1 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                1,
                1
            ]
        ],
        g: [
            [
                0,
                0
            ],
            [
                1 / 3,
                1 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                1,
                1
            ]
        ],
        b: [
            [
                0,
                0
            ],
            [
                1 / 3,
                1 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                1,
                1
            ]
        ]
    });
}
class $160131d78cb8ea88$export$1c43bf66c2a2e4da {
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    getModeButtons() {
        return this.modeButtons;
    }
    destroy() {
        this.p0.pointerListener.destroy();
        this.p1.pointerListener.destroy();
        this.p2.pointerListener.destroy();
        this.p3.pointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'relative',
                marginBottom: '10px'
            }
        });
        this.rootEl.oncontextmenu = ()=>false;
        let mode = 'All';
        let curves = p.curves;
        this.modeButtons = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'All',
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-curves-all')
                },
                {
                    id: 'Red',
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('red')
                },
                {
                    id: 'Green',
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('green')
                },
                {
                    id: 'Blue',
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('blue')
                }
            ],
            initId: 'All',
            onChange: (id)=>{
                mode = id;
                if (mode === 'All') curves = $160131d78cb8ea88$export$4300cf0a0df418a6();
                let curve = curves.r;
                if (mode === 'Green') curve = curves.g;
                if (mode === 'Blue') curve = curves.b;
                this.p0.setPos(0, areaH - curve[0][1] * areaH);
                this.p1.setPos(curve[1][0] * areaW, areaH - curve[1][1] * areaH);
                this.p2.setPos(curve[2][0] * areaW, areaH - curve[2][1] * areaH);
                this.p3.setPos(areaW, areaH - curve[3][1] * areaH);
                update();
            }
        });
        this.rootEl.append(this.modeButtons.getElement());
        const curveArea = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-curves-graph',
            css: {
                position: 'relative',
                marginTop: '10px'
            }
        });
        const areaW = 300, areaH = 100;
        const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(areaW, areaH);
        let ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
        curveArea.append(canvas);
        const fit = (v)=>{
            return Math.max(0, Math.min(1, v));
        };
        const createPoint = (x, y, callback, lock)=>{
            const gripSize = 14;
            let internalY = y, internalX = x;
            const pointEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                className: 'kl-curves-graph__grip',
                css: {
                    left: x - gripSize / 2 + 'px',
                    top: y - gripSize / 2 + 'px',
                    width: gripSize + 'px',
                    height: gripSize + 'px',
                    borderRadius: gripSize + 'px'
                }
            });
            const update = ()=>{
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(pointEl, {
                    left: x - gripSize / 2 + 'px',
                    top: y - gripSize / 2 + 'px'
                });
            };
            const pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
                target: pointEl,
                onPointer: (event)=>{
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown') {
                        internalX = x;
                        internalY = y;
                    }
                    if (event.button === 'left' && event.type === 'pointermove') {
                        if (!lock) internalX += event.dX;
                        x = Math.max(0, Math.min(areaW, internalX));
                        internalY += event.dY;
                        y = Math.max(0, Math.min(areaH, internalY));
                        update();
                        callback({
                            x: x,
                            y: y
                        });
                    }
                }
            });
            curveArea.append(pointEl);
            const setPos = (newX, newY)=>{
                x = newX;
                y = newY;
                internalY = y;
                internalX = x;
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(pointEl, {
                    left: x - gripSize / 2 + 'px',
                    top: y - gripSize / 2 + 'px'
                });
            };
            return {
                el: pointEl,
                setPos: setPos,
                pointerListener: pointerListener
            };
        };
        const updateControl = (i, x, y)=>{
            if (mode === 'All') {
                curves.r[i] = [
                    fit(x / areaW),
                    fit(1 - y / areaH)
                ];
                curves.g[i] = [
                    fit(x / areaW),
                    fit(1 - y / areaH)
                ];
                curves.b[i] = [
                    fit(x / areaW),
                    fit(1 - y / areaH)
                ];
            }
            if (mode === 'Red') curves.r[i] = [
                fit(x / areaW),
                fit(1 - y / areaH)
            ];
            if (mode === 'Green') curves.g[i] = [
                fit(x / areaW),
                fit(1 - y / areaH)
            ];
            if (mode === 'Blue') curves.b[i] = [
                fit(x / areaW),
                fit(1 - y / areaH)
            ];
        };
        this.p0 = createPoint(0, areaH, (val)=>{
            updateControl(0, val.x, val.y);
            update();
        }, true);
        this.p1 = createPoint(areaW / 3, areaH / 3 * 2, (val)=>{
            updateControl(1, val.x, val.y);
            update();
        });
        this.p2 = createPoint(areaW / 3 * 2, areaH / 3, (val)=>{
            updateControl(2, val.x, val.y);
            update();
        });
        this.p3 = createPoint(areaW, 0, (val)=>{
            updateControl(3, val.x, val.y);
            update();
        }, true);
        const update = ()=>{
            ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const outCurves = {
                r: [],
                g: [],
                b: []
            };
            for(let i = 0; i < curves.r.length; i++){
                outCurves.r.push(curves.r[i]);
                outCurves.g.push(curves.g[i]);
                outCurves.b.push(curves.b[i]);
            }
            const drawCurve = (curve)=>{
                ctx.beginPath();
                const spline = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).SplineInterpolator(curve);
                for(let i = 0; i < 100; i++){
                    let y = spline.interpolate(i / 100);
                    y = Math.max(0, Math.min(1, y));
                    if (i === 0) ctx.moveTo(i / 100 * areaW, areaH - y * areaH);
                    else ctx.lineTo(i / 100 * areaW, areaH - y * areaH);
                }
                ctx.stroke();
            };
            ctx.save();
            if (mode === 'All') {
                ctx.strokeStyle = 'black';
                drawCurve(outCurves.r);
            } else {
                ctx.globalAlpha = 0.5;
                ctx.strokeStyle = 'red';
                drawCurve(outCurves.r);
                ctx.strokeStyle = 'green';
                drawCurve(outCurves.g);
                ctx.strokeStyle = 'blue';
                drawCurve(outCurves.b);
            }
            ctx.restore();
            p.callback(outCurves);
        };
        update();
    }
}








const $eafcde4f99931bb4$export$309483fcb6d5c7ca = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        let curves = (0, $160131d78cb8ea88$export$4300cf0a0df418a6)();
        const fxPreviewRenderer = new (0, $7f838dbc615d3028$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: (fxCanvas)=>{
                return fxCanvas.curves(curves.r, curves.g, curves.b);
            },
            selection: klCanvas.getSelection()
        });
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        const input = new (0, $160131d78cb8ea88$export$1c43bf66c2a2e4da)({
            curves: curves,
            callback: function(val) {
                curves = val;
                preview.render();
            }
        });
        const modeButtons = input.getModeButtons();
        rootEl.append(input.getElement(), preview.getElement());
        result.destroy = ()=>{
            input.destroy();
            modeButtons.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                curves: curves
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const curves = params.input.curves;
        const klHistory = params.klHistory;
        if (!context) return false;
        return (0, $31c92ae106360499$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.curves(curves.r, curves.g, curves.b);
        }, klHistory);
    }
};









const $ca7e2a3c6a0e8777$export$9b1b7b3985b9625a = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(context.canvas.width, context.canvas.height, 280, 200, 1);
        const w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        let isHorizontal = true;
        let isVertical = false;
        let doFlipCanvas = true;
        const horizontalCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: isHorizontal,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-flip-horizontal') + " \u27F7",
            allowTab: true,
            callback: function(v) {
                isHorizontal = v;
                updatePreview();
            },
            css: {
                marginBottom: '10px'
            },
            name: 'flip-horizontal'
        });
        const verticalCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: isVertical,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-flip-vertical') + " \u2195",
            allowTab: true,
            callback: function(v) {
                isVertical = v;
                updatePreview();
            },
            css: {
                marginBottom: '10px'
            },
            name: 'flip-vertical'
        });
        rootEl.append(horizontalCheckbox.getElement());
        rootEl.append(verticalCheckbox.getElement());
        const targetOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: true,
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-flip-image')
                },
                {
                    id: false,
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-flip-layer')
                }
            ],
            onChange: (val)=>{
                doFlipCanvas = val;
                updatePreview();
            }
        });
        rootEl.append(targetOptions.getElement());
        const previewWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper',
            css: {
                width: (0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).width + 'px',
                height: (0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).height + 'px'
            }
        });
        const previewLayer = {
            image: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(Math.round(w), Math.round(h)),
            isVisible: true,
            opacity: 1,
            mixModeStr: 'source-over'
        };
        const klCanvasPreview = new (0, $1ac505c1a3109a32$export$e258ade1648009b7)({
            width: Math.round(w),
            height: Math.round(h),
            layers: [
                previewLayer
            ]
        });
        const previewInnerWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper__canvas',
            css: {
                width: parseInt('' + w) + 'px',
                height: parseInt('' + h) + 'px'
            }
        });
        previewInnerWrapper.append(klCanvasPreview.getElement());
        previewWrapper.append(previewInnerWrapper);
        function updatePreview() {
            const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(previewLayer.image);
            ctx.save();
            ctx.clearRect(0, 0, previewLayer.image.width, previewLayer.image.height);
            if (doFlipCanvas) {
                if (isHorizontal) {
                    ctx.translate(previewLayer.image.width, 0);
                    ctx.scale(-1, 1);
                }
                if (isVertical) {
                    ctx.translate(0, previewLayer.image.height);
                    ctx.scale(1, -1);
                }
            }
            for(let i = 0; i < layers.length; i++){
                if (!layers[i].isVisible) continue;
                ctx.save();
                if (!doFlipCanvas && selectedLayerIndex === i) {
                    if (isHorizontal) {
                        ctx.translate(previewLayer.image.width, 0);
                        ctx.scale(-1, 1);
                    }
                    if (isVertical) {
                        ctx.translate(0, previewLayer.image.height);
                        ctx.scale(1, -1);
                    }
                }
                if (ctx.canvas.width > layers[i].context.canvas.width) ctx.imageSmoothingEnabled = false;
                ctx.globalAlpha = layers[i].opacity;
                ctx.globalCompositeOperation = layers[i].mixModeStr;
                ctx.drawImage(layers[i].context.canvas, 0, 0, previewLayer.image.width, previewLayer.image.height);
                ctx.restore();
            }
            klCanvasPreview.render();
            ctx.restore();
        }
        setTimeout(updatePreview, 0);
        rootEl.append(previewWrapper);
        result.destroy = ()=>{
            horizontalCheckbox.destroy();
            verticalCheckbox.destroy();
            targetOptions.destroy();
            klCanvasPreview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                horizontal: isHorizontal,
                vertical: isVertical,
                flipCanvas: doFlipCanvas
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klCanvas = params.klCanvas;
        const horizontal = params.input.horizontal;
        const vertical = params.input.vertical;
        const flipCanvas = params.input.flipCanvas;
        if (!context || !klCanvas) return false;
        klCanvas.flip(horizontal, vertical, flipCanvas ? undefined : (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(klCanvas.getLayerIndex(context.canvas)));
        return true;
    }
};












const $345ea86e35fe44da$export$2aa46bd5587f0eb = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        let hue = 0, saturation = 0;
        const fxPreviewRenderer = new (0, $7f838dbc615d3028$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: (fxCanvas)=>{
                return fxCanvas.hueSaturation(hue, saturation);
            },
            selection: klCanvas.getSelection()
        });
        const hueSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-hue-sat-hue'),
            width: 300,
            height: 30,
            min: -100,
            max: 100,
            value: hue * 100,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: function(val) {
                hue = val / 100;
                preview.render();
            }
        });
        const saturationSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-hue-sat-saturation'),
            width: 300,
            height: 30,
            min: 0,
            max: 100,
            value: (saturation + 1) * 50,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: function(val) {
                saturation = val / 50 - 1;
                preview.render();
            }
        });
        hueSlider.getElement().style.marginBottom = '10px';
        saturationSlider.getElement().style.marginBottom = '10px';
        rootEl.append(hueSlider.getElement(), saturationSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            hueSlider.destroy();
            saturationSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                hue: hue,
                saturation: saturation
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const hue = params.input.hue;
        const klHistory = params.klHistory;
        const saturation = params.input.saturation;
        if (!context || hue === null || saturation === null) return false;
        return (0, $31c92ae106360499$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.hueSaturation(hue, saturation);
        }, klHistory);
    }
};



const $19cea8caa4f1f54e$export$b7ebcfbdc840ef76 = {
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        if (!context) return false;
        return (0, $31c92ae106360499$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.invert();
        }, klHistory);
    }
};






class $db258f044f5ffd5c$export$b1241e74876d9bbe {
    update() {
        this.leftTab.classList.toggle('kl-2-tabs--active', this.value === 0);
        this.rightTab.classList.toggle('kl-2-tabs--active', this.value === 1);
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.value = p.init;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-2-tabs'
        });
        this.leftTab = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: p.left,
            className: 'kl-2-tabs__left'
        });
        this.leftTab.onpointerdown = ()=>false;
        this.rightTab = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: p.right,
            className: 'kl-2-tabs__right'
        });
        this.rightTab.onpointerdown = ()=>false;
        this.update();
        this.leftTab.onclick = ()=>{
            if (this.value === 0) return;
            this.value = 0;
            this.update();
            p.onChange(this.value);
        };
        this.rightTab.onclick = ()=>{
            if (this.value === 1) return;
            this.value = 1;
            this.update();
            p.onChange(this.value);
        };
    }
}










const $d90200485e14eee7$var$SIZE = 16;
class $d90200485e14eee7$export$87247fc399965417 {
    update() {
        const p = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.transform), this.value);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
            left: p.x - $d90200485e14eee7$var$SIZE / 2 + 'px',
            top: p.y - $d90200485e14eee7$var$SIZE / 2 + 'px'
        });
    }
    setTransform(transform) {
        if (JSON.stringify(this.transform) === JSON.stringify(transform)) return;
        this.transform = transform;
        this.update();
    }
    getValue() {
        return this.value;
    }
    setValue(p) {
        this.value = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, p);
        this.update();
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.rootEl.remove();
        this.pointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.value = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.value);
        this.transform = {
            x: 0,
            y: 0,
            scale: 1,
            angleDeg: 0
        };
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: $d90200485e14eee7$var$SIZE + 'px',
                height: $d90200485e14eee7$var$SIZE + 'px',
                backgroundColor: '#fff',
                border: '2px solid #000',
                borderRadius: $d90200485e14eee7$var$SIZE + 'px',
                position: 'absolute',
                cursor: 'move',
                userSelect: 'none',
                touchAction: 'none'
            }
        });
        this.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: this.rootEl,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.button === 'left' && event.type === 'pointermove') {
                    this.value.x += event.dX / this.transform.scale;
                    this.value.y += event.dY / this.transform.scale;
                    this.update();
                    p.onChange(this.value);
                }
            }
        });
    }
}





const $68cd0c4958325f46$export$a76d798fa7d85e4e = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$3a4a74a7d8c44e62).width;
        const fxCanvas = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)((0, $5caaf17bca0749c7$export$8c4423af32b21158)());
        const texture = (0, $fc4403c8ee6a33dc$export$5c097f720de072a2)(fxCanvas === null || fxCanvas === void 0 ? void 0 : fxCanvas.texture(context.canvas));
        function update() {
            if (isBefore) fxCanvas.draw(texture).update();
            else fxCanvas.draw(texture).perspective(getFlatArr(beforeInputs), getFlatArr(afterInputs)).update();
            preview.render();
        }
        const rectPoints = [
            {
                x: 0,
                y: 0
            },
            {
                x: context.canvas.width,
                y: 0
            },
            {
                x: context.canvas.width,
                y: context.canvas.height
            },
            {
                x: 0,
                y: context.canvas.height
            }
        ];
        const beforeInputs = rectPoints.map((point)=>{
            return new (0, $d90200485e14eee7$export$87247fc399965417)({
                value: point,
                onChange: ()=>{
                    update();
                }
            });
        });
        beforeInputs.forEach((item)=>item.getElement().style.display = 'none');
        const afterInputs = rectPoints.map((point)=>{
            return new (0, $d90200485e14eee7$export$87247fc399965417)({
                value: point,
                onChange: ()=>{
                    update();
                }
            });
        });
        function getFlatArr(inputs, matrix) {
            return inputs.flatMap((item)=>{
                let value = item.getValue();
                if (matrix) value = (0, $855520c81dfcb96a$export$9b20165a36586806)(matrix, value);
                return [
                    value.x,
                    value.y
                ];
            });
        }
        let isBefore = false;
        const beforeAfterTabs = new (0, $db258f044f5ffd5c$export$b1241e74876d9bbe)({
            left: (0, $63d0b335c576c718$export$ce37e184d908d785)('compare-before'),
            right: (0, $63d0b335c576c718$export$ce37e184d908d785)('compare-after'),
            init: 1,
            onChange: (val)=>{
                isBefore = val === 0;
                if (isBefore) {
                    beforeInputs.forEach((item)=>item.getElement().style.display = 'block');
                    afterInputs.forEach((item)=>item.getElement().style.display = 'none');
                } else {
                    beforeInputs.forEach((item, index)=>{
                        afterInputs[index].setValue(item.getValue());
                    });
                    beforeInputs.forEach((item)=>item.getElement().style.display = 'none');
                    afterInputs.forEach((item)=>item.getElement().style.display = 'block');
                }
                update();
            }
        });
        rootEl.append(beforeAfterTabs.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxCanvas : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            onTransformChange: (transform)=>{
                beforeInputs.forEach((item)=>item.setTransform(transform));
                afterInputs.forEach((item)=>item.setTransform(transform));
            }
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        preview.getElement().append(...beforeInputs.map((item)=>item.getElement()), ...afterInputs.map((item)=>item.getElement()));
        rootEl.append(preview.getElement());
        update();
        result.destroy = ()=>{
            preview.destroy();
            texture.destroy();
            beforeInputs.forEach((item)=>item.destroy());
            afterInputs.forEach((item)=>item.destroy());
        };
        result.getInput = ()=>{
            result.destroy();
            return {
                before: getFlatArr(beforeInputs),
                after: getFlatArr(afterInputs)
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const before = params.input.before;
        const after = params.input.after;
        if (!context || !before || !after) return false;
        const fxCanvas = (0, $5caaf17bca0749c7$export$8c4423af32b21158)();
        if (!fxCanvas) return false; // todo more specific error?
        const texture = fxCanvas.texture(context.canvas);
        fxCanvas.draw(texture).multiplyAlpha().perspective(before, after).unmultiplyAlpha().update();
        context.clearRect(0, 0, context.canvas.width, context.canvas.height);
        context.drawImage(fxCanvas, 0, 0);
        texture.destroy();
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};





var $f8b38569e2ea4e10$exports = {};
$f8b38569e2ea4e10$exports = $parcel$resolve("2xc61");






const $7bec11dd1272a23d$export$5705240d31427a82 = {
    getDialog (params) {
        //BB.centerWithin
        const klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(klCanvas.getWidth(), klCanvas.getHeight(), 280, 200, 1);
        const w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        let previewFactor = w / klCanvas.getWidth();
        const tempCanvas = klCanvas.getCompleteCanvas(1);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        let newWidth = klCanvas.getWidth(), newHeight = klCanvas.getHeight();
        const maxWidth = params.maxWidth, maxHeight = params.maxHeight;
        const widthWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '150px',
                height: '35px',
                lineHeight: '30px'
            }
        });
        const heightWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '150px',
                height: '35px',
                lineHeight: '30px'
            }
        });
        const widthInput = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'input',
            css: {
                cssFloat: 'right',
                width: '90px'
            },
            custom: {
                type: 'number',
                min: '1',
                max: '' + maxWidth,
                value: '' + klCanvas.getWidth()
            }
        });
        const heightInput = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'input',
            css: {
                cssFloat: 'right',
                width: '90px'
            },
            custom: {
                type: 'number',
                min: '1',
                max: '' + maxHeight,
                value: '' + klCanvas.getHeight()
            }
        });
        widthInput.onclick = function() {
            this.focus();
            widthChanged = true;
            update();
        };
        heightInput.onclick = function() {
            this.focus();
            heightChanged = true;
            update();
        };
        widthInput.onchange = function() {
            widthChanged = true;
            update();
        };
        heightInput.onchange = function() {
            heightChanged = true;
            update();
        };
        widthWrapper.append((0, $63d0b335c576c718$export$ce37e184d908d785)('width') + ': ', widthInput);
        heightWrapper.append((0, $63d0b335c576c718$export$ce37e184d908d785)('height') + ': ', heightInput);
        const inputWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                background: 'url(' + (0, (/*@__PURE__*/$parcel$interopDefault($f8b38569e2ea4e10$exports))) + ') no-repeat 140px 5px',
                backgroundSize: '50px 52px'
            }
        });
        inputWrapper.append(widthWrapper, heightWrapper);
        const constrainIm = new Image();
        constrainIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($f8b38569e2ea4e10$exports)));
        constrainIm.height = 40;
        const sizeTable = (0, $1b372d80cb7a52ec$export$9852986a3ec5f6a0)([
            [
                (0, $63d0b335c576c718$export$ce37e184d908d785)('width') + ':&nbsp;',
                widthInput,
                constrainIm
            ],
            [
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    css: {
                        height: '5px'
                    }
                }),
                '',
                ''
            ],
            [
                (0, $63d0b335c576c718$export$ce37e184d908d785)('height') + ':&nbsp;',
                heightInput
            ]
        ], {
            '0.2': {
                rowspan: 3
            }
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(sizeTable, {
            marginBottom: '10px'
        });
        rootEl.append(sizeTable);
        //contrain checkbox
        let heightChanged = false, widthChanged = false;
        const ratio = klCanvas.getWidth() / klCanvas.getHeight();
        function updateConstrain() {
            constrainIm.style.display = isConstrained ? '' : 'none';
            if (isConstrained) {
                widthInput.value = '' + klCanvas.getWidth();
                heightInput.value = '' + klCanvas.getHeight();
                update();
            }
        }
        let isConstrained = true;
        const constrainCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('constrain-proportions'),
            allowTab: true,
            callback: function(b) {
                isConstrained = b;
                updateConstrain();
            },
            name: 'constrain-proportions'
        });
        rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                clear: 'both'
            }
        }));
        const algorithmSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
            isFocusable: true,
            optionArr: [
                [
                    'smooth',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('algorithm-smooth')
                ],
                [
                    'pixelated',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('algorithm-pixelated')
                ]
            ],
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('scaling-algorithm'),
            initValue: 'smooth',
            onChange: ()=>{
                update();
            },
            name: 'interpolation-algorithm'
        });
        const secondRowElement = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }
        });
        secondRowElement.append(constrainCheckbox.getElement(), algorithmSelect.getElement());
        const previewCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
        previewCanvas.style.imageRendering = 'pixelated';
        const previewCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(previewCanvas);
        function draw() {
            if (algorithmSelect.getValue() === 'smooth') {
                previewCanvas.style.imageRendering = previewFactor > 1 ? 'pixelated' : '';
                previewCanvas.width = klCanvas.getWidth();
                previewCanvas.height = klCanvas.getHeight();
                previewCtx.save();
                previewCtx.imageSmoothingQuality = 'high';
                previewCtx.drawImage(tempCanvas, 0, 0);
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).resizeCanvas(previewCanvas, newWidth, newHeight);
                previewCtx.restore();
            } else {
                previewCanvas.style.imageRendering = 'pixelated';
                previewCanvas.width = newWidth;
                previewCanvas.height = newHeight;
                previewCtx.save();
                previewCtx.imageSmoothingEnabled = false;
                previewCtx.drawImage(tempCanvas, 0, 0, previewCanvas.width, previewCanvas.height);
                previewCtx.restore();
            }
        }
        function update() {
            if (widthInput.value.length === 0 && widthChanged || heightInput.value.length === 0 && heightChanged) {
                heightChanged = false;
                widthChanged = false;
                return;
            }
            widthInput.value = '' + Math.max(1, parseInt(widthInput.value));
            heightInput.value = '' + Math.max(1, parseInt(heightInput.value));
            if (isConstrained) {
                if (heightChanged) widthInput.value = '' + parseInt('' + parseInt(heightInput.value) * ratio);
                if (widthChanged) heightInput.value = '' + parseInt('' + parseInt(widthInput.value) / ratio);
                if (parseInt(widthInput.value) > maxWidth || parseInt(heightInput.value) > maxHeight) {
                    const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(parseInt(widthInput.value), parseInt(heightInput.value), maxWidth, maxHeight, 1);
                    widthInput.value = '' + parseInt('' + fit.width);
                    heightInput.value = '' + parseInt('' + fit.height);
                }
            }
            if (parseInt(widthInput.value) > maxWidth) widthInput.value = '' + maxWidth;
            if (parseInt(heightInput.value) > maxHeight) heightInput.value = '' + maxHeight;
            heightChanged = false;
            widthChanged = false;
            newWidth = parseInt(widthInput.value);
            newHeight = parseInt(heightInput.value);
            const preview = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(newWidth, newHeight, 280, 200, 1);
            const previewW = parseInt('' + preview.width), previewH = parseInt('' + preview.height);
            previewFactor = previewW / newWidth;
            const offset = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).centerWithin((0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).width, (0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).height, previewW, previewH);
            draw();
            previewCanvas.style.width = Math.max(1, previewW) + 'px';
            previewCanvas.style.height = Math.max(1, previewH) + 'px';
            canvasWrapper.style.left = offset.x + 'px';
            canvasWrapper.style.top = offset.y + 'px';
            canvasWrapper.style.width = Math.max(1, previewW) + 'px';
            canvasWrapper.style.height = Math.max(1, previewH) + 'px';
        }
        const previewWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-transparent-preview',
            css: {
                width: (0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).width + 'px',
                height: (0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).height + 'px',
                marginLeft: '-20px',
                display: 'table',
                marginTop: '10px',
                position: 'relative',
                userSelect: 'none',
                background: 'var(--kl-checkerboard-background)',
                backgroundSize: '16px'
            }
        });
        const canvasWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: previewWrapper,
            content: previewCanvas,
            className: 'kl-transparent-preview__canvas',
            css: {
                width: w + 'px',
                height: h + 'px',
                position: 'absolute',
                overflow: 'hidden'
            }
        });
        rootEl.append(previewWrapper);
        update();
        result.destroy = ()=>{
            constrainCheckbox.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                width: newWidth,
                height: newHeight,
                algorithm: algorithmSelect.getValue()
            };
        };
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        const width = params.input.width;
        const height = params.input.height;
        const algorithm = params.input.algorithm;
        if (!klCanvas) return false;
        klCanvas.resize(width, height, algorithm);
        return true;
    }
};




const $4e52484ae64ee478$export$ac7e9efc751d5791 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(klCanvas.getWidth(), klCanvas.getHeight(), 280, 200, 1);
        const w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        const previewFactor = w / klCanvas.getWidth();
        const tempCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
        tempCanvas.style.display = 'block';
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(tempCanvas).drawImage(klCanvas.getCompleteCanvas(previewFactor), 0, 0, w, h);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        let deg = 0;
        function update() {
            canvasWrapper.style.transform = 'rotate(' + deg + 'deg)';
            if (Math.abs(deg % 180) === 90) {
                //height has to fit width because of rotation
                const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(h, w, 280, 200, 1);
                const scale = parseInt('' + fit.height) / w;
                canvasWrapper.style.transform = 'rotate(' + deg + 'deg) scale(' + scale + ')';
            }
        }
        const minusBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: [
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    tagName: 'span',
                    content: "\u27F2",
                    css: {
                        fontSize: '1.3em'
                    }
                }),
                " 90\xb0"
            ],
            onClick: ()=>{
                deg -= 90;
                update();
            },
            noRef: true
        });
        const plusBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: [
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    tagName: 'span',
                    content: "\u27F3",
                    css: {
                        fontSize: '1.3em'
                    }
                }),
                " 90\xb0"
            ],
            onClick: ()=>{
                deg += 90;
                update();
            },
            noRef: true,
            css: {
                marginLeft: '5px'
            }
        });
        rootEl.append(minusBtn, plusBtn);
        const previewWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper',
            css: {
                width: (0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).width + 'px',
                height: (0, $3ec5d4ed5944260f$export$ec2d17c6d3ae0768).height + 'px',
                display: 'table'
            }
        });
        const previewcell = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: previewWrapper,
            css: {
                display: 'table-cell',
                verticalAlign: 'middle'
            }
        });
        const canvasWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: previewcell,
            content: tempCanvas,
            className: 'kl-preview-wrapper__canvas',
            css: {
                width: w + 'px',
                height: h + 'px',
                marginLeft: 'auto',
                marginRight: 'auto',
                overflow: 'hidden',
                background: 'var(--kl-checkerboard-background)',
                backgroundSize: '16px'
            }
        });
        canvasWrapper.style.transition = 'transform 0.2s ease-out';
        rootEl.append(previewWrapper);
        update();
        result.destroy = ()=>{};
        result.getInput = function() {
            result.destroy();
            return {
                deg: deg
            };
        };
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        klCanvas.rotate(params.input.deg);
        return true;
    }
};















const $5aa2347b5ccd9148$export$1b8796b18b7c19ed = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        let blur = 20, gradient = 200;
        let fxPreviewRenderer = {
            destroy: ()=>{}
        };
        fxPreviewRenderer = new (0, $7f838dbc615d3028$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: (fxCanvas, transform)=>{
                fa.setTransform(preview.getTransform());
                fb.setTransform(preview.getTransform());
                const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(transform);
                const a = (0, $855520c81dfcb96a$export$9b20165a36586806)(m, fa.getValue());
                const b = (0, $855520c81dfcb96a$export$9b20165a36586806)(m, fb.getValue());
                return fxCanvas.multiplyAlpha().tiltShift(a.x, a.y, b.x, b.y, blur * transform.scaleX, gradient * transform.scaleX).unmultiplyAlpha();
            },
            selection: klCanvas.getSelection()
        });
        function update() {
            preview.render();
        }
        // focus line control points
        const fa = new (0, $d90200485e14eee7$export$87247fc399965417)({
            value: {
                x: context.canvas.width / 4,
                y: context.canvas.height / 2
            },
            onChange: ()=>{
                update();
            }
        });
        const fb = new (0, $d90200485e14eee7$export$87247fc399965417)({
            value: {
                x: 3 * context.canvas.width / 4,
                y: context.canvas.height / 2
            },
            onChange: ()=>{
                update();
            }
        });
        const gradientSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-tilt-shift-gradient'),
            width: 300,
            height: 30,
            min: 0,
            max: 1000,
            value: gradient,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: function(val) {
                gradient = val;
                update();
            }
        });
        gradientSlider.getElement().style.marginBottom = '10px';
        rootEl.append(gradientSlider.getElement());
        const blurSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-tilt-shift-blur'),
            width: 300,
            height: 30,
            min: 0,
            max: 200,
            value: blur,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: function(val) {
                blur = val;
                update();
            }
        });
        blurSlider.getElement().style.marginBottom = '10px';
        rootEl.append(blurSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        preview.getElement().append(fa.getElement(), fb.getElement());
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            blurSlider.destroy();
            gradientSlider.destroy();
            fa.destroy();
            fb.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                a: fa.getValue(),
                b: fb.getValue(),
                blur: blur,
                gradient: gradient
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const a = params.input.a;
        const b = params.input.b;
        const blur = params.input.blur;
        const gradient = params.input.gradient;
        if (!context) return false;
        return (0, $31c92ae106360499$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.multiplyAlpha().tiltShift(a.x, a.y, b.x, b.y, blur, gradient).unmultiplyAlpha();
        }, klHistory);
    }
};

















function $273e2af276df50c0$export$6be4733fa804854c(selection, context) {
    const selectionBounds = (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(selection, 'index');
    // integer bounds that are within the canvas
    const canvasSelectionBounds = (0, $9414f5ea41e9cf25$export$ddc1c0069d484d49)(selectionBounds, context.canvas.width, context.canvas.height);
    // selection area outside of canvas
    if (!canvasSelectionBounds) return undefined;
    // bounds of where pixels are non-transparent
    return (0, $13d5aa49e37e2734$export$c1fcf1f93aeabfbf)(context, canvasSelectionBounds);
}











// ---- Helper Functions ----
// Precomputed factorials for n = 0..8 (sufficient for lattice degrees up to 8×8).
// Gave slight performance improvement.
const $dd7061603b95efc4$var$factorials = [
    1,
    1,
    2,
    6,
    24,
    120,
    720,
    5040,
    40320
];
function $dd7061603b95efc4$export$b10970dad17863b6(n, k, t) {
    const coeff = $dd7061603b95efc4$var$factorials[n] / ($dd7061603b95efc4$var$factorials[k] * $dd7061603b95efc4$var$factorials[n - k]);
    return coeff * Math.pow(1 - t, n - k) * Math.pow(t, k);
}
function $dd7061603b95efc4$export$1dc7cad4a5f0f0a6(cols, rows, rect) {
    const controlPoints = [];
    for(let i = 0; i < rows; i++){
        controlPoints[i] = [];
        for(let j = 0; j < cols; j++)controlPoints[i][j] = {
            x: rect.x + j / (cols - 1) * rect.width,
            y: rect.y + i / (rows - 1) * rect.height
        };
    }
    return {
        cols: cols,
        rows: rows,
        controlPoints: controlPoints
    };
}
function $dd7061603b95efc4$export$24b0a92fce6b8497(s, t, lattice) {
    const n = lattice.cols - 1;
    const m = lattice.rows - 1;
    let x = 0;
    let y = 0;
    for(let i = 0; i <= m; i++)for(let j = 0; j <= n; j++){
        const weight = $dd7061603b95efc4$export$b10970dad17863b6(n, j, s) * $dd7061603b95efc4$export$b10970dad17863b6(m, i, t);
        x += lattice.controlPoints[i][j].x * weight;
        y += lattice.controlPoints[i][j].y * weight;
    }
    return {
        x: x,
        y: y
    };
}
function $dd7061603b95efc4$export$81dc197f519ea47(resolutionX, resolutionY, ffd, selectionSample, outputWidth, outputHeight, useCanvasSpace) {
    /**
     * Compute the parametric s/t ranges so that mesh only covers the texture's
     * portion of the lattice — UVs stay in [0, 1] and nothing outside the texture is drawn.
     */ const textureWidth = selectionSample.image.width;
    const textureHeight = selectionSample.image.height;
    const offset = selectionSample.imageOffset;
    const selWidth = selectionSample.selectionSize.width;
    const selHeight = selectionSample.selectionSize.height;
    const sRange = [
        offset.x / selWidth,
        (offset.x + textureWidth) / selWidth
    ];
    const tRange = [
        offset.y / selHeight,
        (offset.y + textureHeight) / selHeight
    ];
    return $dd7061603b95efc4$export$d6a0409d5640315a(resolutionX, resolutionY, ffd, outputWidth, outputHeight, useCanvasSpace, sRange, tRange);
}
function $dd7061603b95efc4$export$d6a0409d5640315a(resolutionX, resolutionY, lattice, // ignored if useCanvasSpace true
canvasWidth, canvasHeight, // if false will use vertex space
useCanvasSpace, /**
     * Parametric horizontal range to generate mesh for. Default: [0, 1].
     * Clips the mesh to the portion of the lattice covered by the texture,
     * so UVs stay in [0, 1] and we avoid texture wrapping issues.
     */ sRange, /**
     * Parametric vertical range to generate mesh for. Default: [0, 1].
     * Clips the mesh to the portion of the lattice covered by the texture,
     * so UVs stay in [0, 1] and we avoid texture wrapping issues.
     */ tRange) {
    const vertices = [];
    const texCoords = [];
    const frontIndices = [];
    const backIndices = [];
    const sMin = sRange ? sRange[0] : 0;
    const sMax = sRange ? sRange[1] : 1;
    const tMin = tRange ? tRange[0] : 0;
    const tMax = tRange ? tRange[1] : 1;
    // Generate mesh vertices
    for(let i = 0; i <= resolutionY; i++)for(let j = 0; j <= resolutionX; j++){
        // Parametric coords within the texture's sub-range of the lattice
        const s = sMin + j / resolutionX * (sMax - sMin);
        const t = tMin + i / resolutionY * (tMax - tMin);
        // Evaluate FFD to get canvas space position
        const canvasPos = $dd7061603b95efc4$export$24b0a92fce6b8497(s, t, lattice);
        let x, y;
        if (useCanvasSpace) {
            // Keep in canvas space for hit testing
            x = canvasPos.x;
            y = canvasPos.y;
        } else {
            // Convert to normalized vertex space [-1, 1]
            // Top-left is (-1, 1), bottom-right is (1, -1)
            x = canvasPos.x / canvasWidth * 2.0 - 1.0;
            y = 1.0 - canvasPos.y / canvasHeight * 2.0;
        }
        vertices.push(x, y);
        // UV maps linearly from the sub-range to [0, 1]
        const u = (s - sMin) / (sMax - sMin);
        const v = (t - tMin) / (tMax - tMin);
        texCoords.push(u, v);
    }
    // Generate indices, classifying each triangle as front- or back-facing inline
    for(let i = 0; i < resolutionY; i++)for(let j = 0; j < resolutionX; j++){
        const topLeft = i * (resolutionX + 1) + j;
        const topRight = topLeft + 1;
        const bottomLeft = topLeft + (resolutionX + 1);
        const bottomRight = bottomLeft + 1;
        const x0 = vertices[topLeft * 2], y0 = vertices[topLeft * 2 + 1];
        const x1 = vertices[bottomLeft * 2], y1 = vertices[bottomLeft * 2 + 1];
        const x2 = vertices[topRight * 2], y2 = vertices[topRight * 2 + 1];
        const x3 = vertices[bottomRight * 2], y3 = vertices[bottomRight * 2 + 1];
        const cross0 = (x1 - x0) * (y2 - y0) - (y1 - y0) * (x2 - x0);
        (cross0 > 0 ? frontIndices : backIndices).push(topLeft, bottomLeft, topRight);
        const cross1 = (x1 - x2) * (y3 - y2) - (y1 - y2) * (x3 - x2);
        (cross1 > 0 ? frontIndices : backIndices).push(topRight, bottomLeft, bottomRight);
    }
    return {
        resolutionX: resolutionX,
        resolutionY: resolutionY,
        vertices: vertices,
        texCoords: texCoords,
        frontIndices: frontIndices,
        backIndices: backIndices
    };
}
function $dd7061603b95efc4$export$2d232ae0b526c96b(// same space as mesh vertices
x, y, mesh) {
    const { vertices: vertices, texCoords: texCoords, frontIndices: frontIndices, backIndices: backIndices } = mesh;
    let frontHit = undefined;
    let backHit = undefined;
    function checkTriangles(indices) {
        for(let i = 0; i < indices.length; i += 3){
            const i0 = indices[i];
            const i1 = indices[i + 1];
            const i2 = indices[i + 2];
            const x0 = vertices[i0 * 2];
            const y0 = vertices[i0 * 2 + 1];
            const x1 = vertices[i1 * 2];
            const y1 = vertices[i1 * 2 + 1];
            const x2 = vertices[i2 * 2];
            const y2 = vertices[i2 * 2 + 1];
            // Barycentric coordinates
            const denom = (y1 - y2) * (x0 - x2) + (x2 - x1) * (y0 - y2);
            if (Math.abs(denom) < 0.00001) continue;
            const a = ((y1 - y2) * (x - x2) + (x2 - x1) * (y - y2)) / denom;
            const b = ((y2 - y0) * (x - x2) + (x0 - x2) * (y - y2)) / denom;
            const c = 1 - a - b;
            // Inside triangle?
            if (a >= 0 && b >= 0 && c >= 0) {
                // Get texture coordinates (which are the same as parametric coords)
                const s0 = texCoords[i0 * 2];
                const t0 = texCoords[i0 * 2 + 1];
                const s1 = texCoords[i1 * 2];
                const t1 = texCoords[i1 * 2 + 1];
                const s2 = texCoords[i2 * 2];
                const t2 = texCoords[i2 * 2 + 1];
                // Check winding order
                const cross = (x1 - x0) * (y2 - y0) - (y1 - y0) * (x2 - x0);
                const isBackFacing = cross > 0;
                const hit = {
                    s: a * s0 + b * s1 + c * s2,
                    t: a * t0 + b * t1 + c * t2
                };
                if (isBackFacing) backHit = hit;
                else frontHit = hit;
            }
        }
    }
    checkTriangles(frontIndices);
    checkTriangles(backIndices);
    // Prioritize back, because back faces are also rendered in front.
    return backHit || frontHit;
}
function $dd7061603b95efc4$export$fd7a293c27db611b(paramCoordinate, target, lattice) {
    lattice = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(lattice);
    // via trial and error these felt good
    // so the entire mesh doesn't move when warping. Somewhat localized.
    const influenceRadius = 1 / 3;
    // smaller -> edge folds less easily over
    const edgeFalloff = 0.5;
    const n = lattice.cols - 1;
    const m = lattice.rows - 1;
    const controlPoints = lattice.controlPoints;
    // Calculate basis function values at the drag point
    const basisWeights = [];
    for(let i = 0; i <= m; i++)for(let j = 0; j <= n; j++){
        const w = $dd7061603b95efc4$export$b10970dad17863b6(n, j, paramCoordinate.s) * $dd7061603b95efc4$export$b10970dad17863b6(m, i, paramCoordinate.t);
        // Calculate distance for influence radius
        const si = j / n;
        const ti = i / m;
        const paramDist = Math.sqrt(Math.pow(si - paramCoordinate.s, 2) + Math.pow(ti - paramCoordinate.t, 2));
        // Calculate a ramp from 1 to 0
        let strength = Math.max(0, 1 - paramDist / influenceRadius);
        const dragDistFromCenterX = Math.abs(paramCoordinate.s - 0.5);
        const cpDistFromCenterX = Math.abs(si - 0.5);
        const dragDistFromCenterY = Math.abs(paramCoordinate.t - 0.5);
        const cpDistFromCenterY = Math.abs(ti - 0.5);
        // weirdly feels right when warping
        if (cpDistFromCenterX > dragDistFromCenterX || cpDistFromCenterY > dragDistFromCenterY) strength *= edgeFalloff;
        basisWeights.push({
            i: i,
            j: j,
            w: w,
            strength: strength
        });
    }
    const start = $dd7061603b95efc4$export$24b0a92fce6b8497(paramCoordinate.s, paramCoordinate.t, lattice);
    const dx = target.x - start.x;
    const dy = target.y - start.y;
    // Direct manipulation: solve for control point displacements.
    // Invariant: evalFFD(paramCoordinate, updatedLattice) === target exactly.
    let sumWeightsSq = 0;
    for (const { w: w, strength: strength } of basisWeights)sumWeightsSq += w * w * strength;
    for (const { i: i, j: j, w: w, strength: strength } of basisWeights){
        const scale = w / sumWeightsSq * strength;
        controlPoints[i][j].x += dx * scale;
        controlPoints[i][j].y += dy * scale;
    }
    return {
        cols: lattice.cols,
        rows: lattice.rows,
        controlPoints: controlPoints
    };
}







// returns bounds of mesh that ffd lattice would create



function $50a0b6484b2d316d$var$getFfdMeshBounds(mesh) {
    const { vertices: vertices } = mesh;
    let x1 = Infinity;
    let y1 = Infinity;
    let x2 = -Infinity;
    let y2 = -Infinity;
    for(let i = 0; i < vertices.length; i += 2){
        x1 = Math.min(x1, vertices[i]);
        y1 = Math.min(y1, vertices[i + 1]);
        x2 = Math.max(x2, vertices[i]);
        y2 = Math.max(y2, vertices[i + 1]);
    }
    // round bernstein floating point errors
    const precision = 1e6;
    return {
        type: 'coordinate',
        x1: Math.round(x1 * precision) / precision,
        y1: Math.round(y1 * precision) / precision,
        x2: Math.round(x2 * precision) / precision,
        y2: Math.round(y2 * precision) / precision
    };
}
function $50a0b6484b2d316d$export$da260002c67d0dd(ffd) {
    // Use a dummy canvas size of 1x1 since we request canvas space — the actual
    // canvas dimensions don't matter here because useCanvasSpace bypasses the
    // NDC conversion entirely.
    const mesh = (0, $dd7061603b95efc4$export$d6a0409d5640315a)((0, $fa5dd7576eba601b$export$6ba60dd123964f3e), (0, $fa5dd7576eba601b$export$6ba60dd123964f3e), ffd, 1, 1, true);
    return $50a0b6484b2d316d$var$getFfdMeshBounds(mesh);
}
function $50a0b6484b2d316d$export$b8704036eca28391(mesh, width, height) {
    const ffdBounds = (0, $9414f5ea41e9cf25$export$b0036cbc597df324)($50a0b6484b2d316d$var$getFfdMeshBounds(mesh));
    return (0, $9414f5ea41e9cf25$export$ddc1c0069d484d49)(ffdBounds, width, height);
}


const $fa5dd7576eba601b$export$6ba60dd123964f3e = 64;
function $fa5dd7576eba601b$export$552b36716f27e91b(transform, center) {
    transform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') return (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform), {
        freeTransform: (0, $9e052f3767af1736$export$958c2bfe8d7142a9)((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform.freeTransform), {
            x: center.x,
            y: center.y
        }))
    });
    // ffd
    const bounds = (0, $50a0b6484b2d316d$export$da260002c67d0dd)(transform.ffd);
    // use freeTransform so we can use snapToPixel
    const freeTransform = $fa5dd7576eba601b$export$928f0648354c9a2f((0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)(bounds));
    const snappedTransform = (0, $9e052f3767af1736$export$958c2bfe8d7142a9)((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, freeTransform), {
        x: center.x,
        y: center.y
    }));
    const matrix = $fa5dd7576eba601b$export$e464a809f7257768(snappedTransform, (0, $9414f5ea41e9cf25$export$b0036cbc597df324)(bounds));
    return {
        type: 'ffd',
        ffd: $fa5dd7576eba601b$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $fa5dd7576eba601b$export$44831334ca780533(transform, axis) {
    transform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') {
        const ft = transform.freeTransform;
        return (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform), {
            freeTransform: (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, ft), {
                width: -ft.width,
                height: ft.height,
                angleDeg: axis === 'y' ? -ft.angleDeg + 180 : -ft.angleDeg
            })
        });
    }
    // ffd
    const bounds = (0, $50a0b6484b2d316d$export$da260002c67d0dd)(transform.ffd);
    const center = {
        x: (bounds.x1 + bounds.x2) / 2,
        y: (bounds.y1 + bounds.y2) / 2
    };
    const matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(center.x, center.y), (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(axis === 'x' ? -1 : 1, axis === 'y' ? -1 : 1), (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(-center.x, -center.y));
    return {
        type: 'ffd',
        ffd: $fa5dd7576eba601b$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $fa5dd7576eba601b$export$7eaa413076082bd7(transform, factor) {
    transform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') {
        const before = transform.freeTransform;
        // prevent edge cases (leading to NaN) where width and height are 0.
        if (factor > 1 && (factor * before.width === 0 || factor * before.height === 0)) return transform;
        if (factor < 1 && (factor * before.width < 1 || factor * before.height < 1)) return transform;
        return (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform), {
            freeTransform: (0, $9e052f3767af1736$export$958c2bfe8d7142a9)((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform.freeTransform), {
                width: transform.freeTransform.width * factor,
                height: transform.freeTransform.height * factor
            }))
        });
    }
    // ffd
    const bounds = (0, $50a0b6484b2d316d$export$da260002c67d0dd)(transform.ffd);
    const center = {
        x: (bounds.x1 + bounds.x2) / 2,
        y: (bounds.y1 + bounds.y2) / 2
    };
    const matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(center.x, center.y), (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(factor), (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(-center.x, -center.y));
    return {
        type: 'ffd',
        ffd: $fa5dd7576eba601b$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $fa5dd7576eba601b$export$71dd993772432b93(transform, deltaAngleDeg) {
    transform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') return (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform), {
        freeTransform: (0, $9e052f3767af1736$export$958c2bfe8d7142a9)((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform.freeTransform), {
            angleDeg: (transform.freeTransform.angleDeg + deltaAngleDeg) % 360
        }))
    });
    // ffd
    const bounds = (0, $50a0b6484b2d316d$export$da260002c67d0dd)(transform.ffd);
    // use freeTransform so we can use snapToPixel
    const freeTransform = $fa5dd7576eba601b$export$928f0648354c9a2f((0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)(bounds));
    const snappedTransform = (0, $9e052f3767af1736$export$958c2bfe8d7142a9)((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, freeTransform), {
        angleDeg: deltaAngleDeg % 360
    }));
    const matrix = $fa5dd7576eba601b$export$e464a809f7257768(snappedTransform, (0, $9414f5ea41e9cf25$export$b0036cbc597df324)(bounds));
    return {
        type: 'ffd',
        ffd: $fa5dd7576eba601b$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $fa5dd7576eba601b$export$e464a809f7257768(transform, bounds) {
    const rect = (0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)(bounds);
    const centerBefore = {
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2
    };
    const scaleX = transform.width / rect.width;
    const scaleY = transform.height / rect.height;
    const angleRad = transform.angleDeg / 180 * Math.PI;
    return (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(transform.x, transform.y), (0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(angleRad), (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(scaleX, scaleY), (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(-centerBefore.x, -centerBefore.y));
}
function $fa5dd7576eba601b$export$928f0648354c9a2f(rect) {
    return {
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2,
        width: rect.width,
        height: rect.height,
        angleDeg: 0
    };
}
// warps and automatically subdivides and optimizes the selection polygon
function $fa5dd7576eba601b$var$warpSelection(ffd, selection, selectionBounds) {
    const { width: width, height: height } = (0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)(selectionBounds);
    const result = selection.map((polygon)=>polygon.map((ring)=>{
            // ring 1 - subdivide based on edge delta relative to selection bounds
            const ring1 = [];
            for(let i = 0; i < ring.length; i++){
                const p1 = ring[i];
                const p2 = ring[(i + 1) % ring.length];
                // Add current point
                ring1.push(p1);
                // Subdivide based on whichever axis delta is proportionally larger
                const dx = p2[0] - p1[0];
                const dy = p2[1] - p1[1];
                const ratioX = Math.abs(dx) / width;
                const ratioY = Math.abs(dy) / height;
                const dominantRatio = Math.max(ratioX, ratioY);
                const segments = Math.max(1, Math.round(dominantRatio * 4));
                for(let j = 1; j < segments; j++){
                    const t = j / segments;
                    ring1.push([
                        p1[0] + dx * t,
                        p1[1] + dy * t
                    ]);
                }
            }
            // ring 2 - subdivide based on edge delta in warped space. but subdivide in the original space
            const ring2 = [];
            for(let i = 0; i < ring1.length; i++){
                const p1 = ring1[i];
                const p2 = ring1[(i + 1) % ring1.length];
                ring2.push(p1);
                // Warp both endpoints to measure edge length in warped space
                const s1 = (p1[0] - selectionBounds.x1) / width;
                const t1 = (p1[1] - selectionBounds.y1) / height;
                const w1 = (0, $dd7061603b95efc4$export$24b0a92fce6b8497)(s1, t1, ffd);
                const s2 = (p2[0] - selectionBounds.x1) / width;
                const t2 = (p2[1] - selectionBounds.y1) / height;
                const w2 = (0, $dd7061603b95efc4$export$24b0a92fce6b8497)(s2, t2, ffd);
                const wdx = w2.x - w1.x;
                const wdy = w2.y - w1.y;
                const warpedLength = Math.sqrt(wdx * wdx + wdy * wdy);
                const segments = Math.max(1, Math.ceil(warpedLength / 4));
                const dx = p2[0] - p1[0];
                const dy = p2[1] - p1[1];
                for(let j = 1; j < segments; j++){
                    const t = j / segments;
                    ring2.push([
                        p1[0] + dx * t,
                        p1[1] + dy * t
                    ]);
                }
            }
            const warpedRing = ring2.map((point)=>{
                // Convert point to normalized coordinates [0, 1]
                const s = (point[0] - selectionBounds.x1) / width;
                const t = (point[1] - selectionBounds.y1) / height;
                // Evaluate FFD at normalized coordinates
                const warped = (0, $dd7061603b95efc4$export$24b0a92fce6b8497)(s, t, ffd);
                return [
                    warped.x,
                    warped.y
                ];
            });
            // optimized ring - remove collinear points
            const angleDegThreshold = 1;
            const cosThreshold = Math.cos(angleDegThreshold / 180 * Math.PI);
            const optimizedRing = [];
            for(let i = 0; i < warpedRing.length - 1; i++){
                var _optimizedRing_;
                const prev = (_optimizedRing_ = optimizedRing[optimizedRing.length - 1]) !== null && _optimizedRing_ !== void 0 ? _optimizedRing_ : warpedRing[warpedRing.length - 1];
                const curr = warpedRing[i];
                const next = warpedRing[(i + 1) % warpedRing.length];
                const ax = curr[0] - prev[0];
                const ay = curr[1] - prev[1];
                const bx = next[0] - curr[0];
                const by = next[1] - curr[1];
                const lenA = Math.sqrt(ax * ax + ay * ay);
                const lenB = Math.sqrt(bx * bx + by * by);
                if (lenA !== 0 && lenB !== 0 && (ax * bx + ay * by) / (lenA * lenB) <= cosThreshold) optimizedRing.push(curr);
            }
            optimizedRing.push(warpedRing[warpedRing.length - 1]);
            return optimizedRing;
        }));
    return result;
}
function $fa5dd7576eba601b$export$c17d845d16ec8ae(transform, selection) {
    const selectionBounds = (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(selection, 'index');
    if (transform.type === 'ffd') return $fa5dd7576eba601b$var$warpSelection(transform.ffd, selection, selectionBounds);
    if (transform.type === 'ffd+free') return $fa5dd7576eba601b$var$warpSelection($fa5dd7576eba601b$export$a56ca41a0dbe2002(transform.ffd, $fa5dd7576eba601b$export$e464a809f7257768(transform.freeTransform, (0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)(transform.ffdBounds, 'index'))), selection, selectionBounds);
    const transformationMatrix = $fa5dd7576eba601b$export$e464a809f7257768(transform.freeTransform, selectionBounds);
    return (0, $1d9e27e0466b80f7$export$aa391dbbf8073422)(selection, transformationMatrix);
}
function $fa5dd7576eba601b$export$a56ca41a0dbe2002(ffd, matrix) {
    return {
        cols: ffd.cols,
        rows: ffd.rows,
        controlPoints: ffd.controlPoints.map((row)=>row.map((point)=>(0, $855520c81dfcb96a$export$9b20165a36586806)(matrix, point)))
    };
}


// preference expressed by user
let $31d0877b7a0bd896$var$preferenceIsTransparentBg;
function $31d0877b7a0bd896$var$getIsTransparentBg(isBgLayer, layerHasTransparency, preference) {
    if (!isBgLayer) return true;
    if (preference !== undefined) return preference;
    return layerHasTransparency;
}
function $31d0877b7a0bd896$var$parseCssColor(colorString) {
    if (colorString.startsWith('#')) {
        let hex = colorString.slice(1);
        if (hex.length === 3) hex = hex.split('').map((c)=>c + c).join('');
        if (hex.length === 6) // assume full alpha
        hex += 'ff';
        const intVal = parseInt(hex, 16);
        return {
            r: intVal >> 24 & 255,
            g: intVal >> 16 & 255,
            b: intVal >> 8 & 255,
            a: (intVal & 255) / 255
        };
    }
    const rgbMatch = colorString.match(/rgba?\(([^)]+)\)/);
    if (rgbMatch) {
        const [r, g, b, a = 1] = rgbMatch[1].split(',').map((v)=>parseFloat(v.trim()));
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    return undefined;
}
function $31d0877b7a0bd896$export$d7a217b118c790a6(layer) {
    for (const tile of layer.tiles)if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(tile)) {
        const color = $31d0877b7a0bd896$var$parseCssColor(tile.fill);
        if (color && color.a < 1) return true;
    } else {
        const data = tile.data.data;
        for(let i = 3; i < data.length; i += 4){
            if (data[i] < 255) return true;
        }
    }
    return false;
}
function $31d0877b7a0bd896$var$drawTransform(ctx, copiedCanvas, isPixelated, transform, selection, boundsObj, doClone, isTransparentBg) {
    const width = ctx.canvas.width;
    const height = ctx.canvas.height;
    ctx.save();
    ctx.clearRect(0, 0, width, height);
    ctx.save();
    if (selection) {
        // draw original with clipped selection
        ctx.drawImage(copiedCanvas, 0, 0);
        if (!doClone) {
            const selectionPath = (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(selection);
            ctx.clip(selectionPath);
            ctx.globalCompositeOperation = isTransparentBg ? 'destination-out' : 'source-atop';
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, width, height);
        }
    } else {
        if (isTransparentBg) {
            if (doClone) ctx.drawImage(copiedCanvas, 0, 0);
        } else {
            ctx.drawImage(copiedCanvas, 0, 0);
            if (!doClone) {
                ctx.fillStyle = 'white';
                ctx.globalCompositeOperation = 'source-atop';
                ctx.fillRect(0, 0, width, height);
            }
        }
    }
    ctx.restore();
    let matrix;
    if (selection) {
        const bounds = boundsObj !== null && boundsObj !== void 0 ? boundsObj : {
            x: 0,
            y: 0,
            width: ctx.canvas.width,
            height: ctx.canvas.height
        };
        if (isPixelated || (0, $d9f9f4926aa80a1c$export$921068d8846a1559).testShouldPixelate(transform, transform.width / bounds.width, transform.height / bounds.height)) ctx.imageSmoothingEnabled = false;
        else {
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
        }
        // derived from drawTransformedImageWithBounds
        matrix = (0, $611d5fdbbcda65d9$export$f672e0b6f7222cd7)((0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(transform.x, transform.y), (0, $20520e5c69c4ad5d$export$bb628a54ab399bc9)(transform.angleDeg / 180 * Math.PI), (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(transform.width > 0 ? 1 : -1, transform.height > 0 ? 1 : -1), (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(-Math.abs(transform.width) / 2, -Math.abs(transform.height) / 2), (0, $a78c550eaaca7cca$export$dcdf75081b88279d)(Math.abs(transform.width / bounds.width), Math.abs(transform.height / bounds.height)), (0, $cf0617f9860dc277$export$d73ee8ef04f5226a)(-bounds.x, -bounds.y));
        ctx.setTransform(...(0, $974f651610599156$export$2b60e7dafdbde18a)(matrix));
        const selectionPath = (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(selection);
        ctx.clip(selectionPath);
        ctx.drawImage(copiedCanvas, 0, 0);
    } else (0, $d9f9f4926aa80a1c$export$921068d8846a1559).drawTransformedImageWithBounds(ctx, copiedCanvas, transform, boundsObj, isPixelated);
    ctx.restore();
    return matrix;
}
const $31d0877b7a0bd896$export$dc15474d94cdc2b3 = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(klCanvas.getLayerIndex(context.canvas));
        const isBgLayer = selectedLayerIndex === 0;
        let hasTransparency = false;
        if (isBgLayer) {
            const layer = Object.entries(params.composed.layerMap).find(([_, layer])=>layer.index === selectedLayerIndex)[1];
            hasTransparency = $31d0877b7a0bd896$export$d7a217b118c790a6(layer);
        }
        const selection = klCanvas.getSelection();
        // determine bounds and initial transformation
        const boundsObj = selection ? (0, $273e2af276df50c0$export$6be4733fa804854c)(selection, context) : (0, $13d5aa49e37e2734$export$c1fcf1f93aeabfbf)(context);
        if (!boundsObj) return {
            error: (0, $63d0b335c576c718$export$ce37e184d908d785)(selection ? 'filter-transform-empty-selection' : 'filter-transform-empty')
        };
        const initTransform = {
            x: boundsObj.x + boundsObj.width / 2,
            y: boundsObj.y + boundsObj.height / 2,
            width: boundsObj.width,
            height: boundsObj.height,
            angleDeg: 0
        };
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$3a4a74a7d8c44e62).width;
        const keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
            onDown: function(keyStr) {
                if ((0, $d9f9f4926aa80a1c$export$921068d8846a1559).isInputFocused(true)) return;
                if (keyStr === 'left') {
                    inputX.value = '' + (parseFloat(inputX.value) - 1);
                    onInputsChanged();
                }
                if (keyStr === 'right') {
                    inputX.value = '' + (parseFloat(inputX.value) + 1);
                    onInputsChanged();
                }
                if (keyStr === 'up') {
                    inputY.value = '' + (parseFloat(inputY.value) - 1);
                    onInputsChanged();
                }
                if (keyStr === 'down') {
                    inputY.value = '' + (parseFloat(inputY.value) + 1);
                    onInputsChanged();
                }
            }
        });
        const leftWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '100px',
                height: '30px',
                display: 'inline-block'
            }
        });
        const rightWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '100px',
                height: '30px',
                display: 'inline-block'
            }
        });
        const rotWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '150px',
                height: '30px',
                display: 'inline-block'
            }
        });
        const inputY = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'input'
        });
        const inputX = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'input'
        });
        const inputR = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'input'
        });
        inputY.type = 'number';
        inputX.type = 'number';
        inputR.type = 'number';
        inputX.style.width = "70px";
        inputY.style.width = "70px";
        inputR.style.width = "70px";
        inputY.value = '0';
        inputX.value = '0';
        inputR.value = '0';
        inputY.onclick = function() {
            inputY.focus();
            onInputsChanged();
        };
        inputX.onclick = function() {
            inputX.focus();
            onInputsChanged();
        };
        inputR.onclick = function() {
            inputR.focus();
            onInputsChanged();
        };
        inputY.onchange = function() {
            onInputsChanged();
        };
        inputX.onchange = function() {
            onInputsChanged();
        };
        inputR.onchange = function() {
            onInputsChanged();
        };
        inputY.onkeyup = function() {
            onInputsChanged();
        };
        inputX.onkeyup = function() {
            onInputsChanged();
        };
        inputR.onkeyup = function() {
            onInputsChanged();
        };
        leftWrapper.append('X: ', inputX);
        rightWrapper.append('Y: ', inputY);
        rotWrapper.append((0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-rotation') + ': ', inputR);
        if (!isSmall) {
            const inputRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: rootEl,
                css: {
                    marginTop: '10px'
                }
            });
            inputRow.append(leftWrapper, rightWrapper, rotWrapper);
        }
        // buttons
        const buttonRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '10px',
                marginTop: '10px'
            }
        });
        const flipXBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-flip') + ' X',
            onClick: ()=>{
                const transformed = (0, $fa5dd7576eba601b$export$44831334ca780533)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 'x');
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        const flipYBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-flip') + ' Y',
            onClick: ()=>{
                const transformed = (0, $fa5dd7576eba601b$export$44831334ca780533)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 'y');
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        const scaleRotLeftBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            content: "-90\xb0",
            onClick: ()=>{
                const transformed = (0, $fa5dd7576eba601b$export$71dd993772432b93)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, -90);
                freeTransform.initialise(transformed.freeTransform);
                inputR.value = '' + Math.round(transformed.freeTransform.angleDeg);
                updatePreview();
            }
        });
        const scaleRotRightBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            content: "+90\xb0",
            onClick: ()=>{
                const transformed = (0, $fa5dd7576eba601b$export$71dd993772432b93)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 90);
                freeTransform.initialise(transformed.freeTransform);
                inputR.value = '' + Math.round(transformed.freeTransform.angleDeg);
                updatePreview();
            }
        });
        const scaleDoubleBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            content: '2&times;',
            onClick: ()=>{
                const transformed = (0, $fa5dd7576eba601b$export$7eaa413076082bd7)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 2);
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        const scaleHalfBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            content: '&frac12;&times;',
            onClick: ()=>{
                const transformed = (0, $fa5dd7576eba601b$export$7eaa413076082bd7)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 0.5);
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        const centerBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('center'),
            onClick: ()=>{
                const transformed = (0, $fa5dd7576eba601b$export$552b36716f27e91b)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, {
                    x: context.canvas.width / 2,
                    y: context.canvas.height / 2
                });
                freeTransform.initialise(transformed.freeTransform);
                inputX.value = '' + Math.round(transformed.freeTransform.x - initTransform.x);
                inputY.value = '' + Math.round(transformed.freeTransform.y - initTransform.y);
                updatePreview();
            }
        });
        let doClone = false;
        const cloneCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: doClone,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-transform-clone'),
            allowTab: true,
            callback: function(b) {
                doClone = b;
                updatePreview(true);
            },
            css: {
                display: 'inline-block'
            },
            name: 'clone-before-transforming'
        });
        let isTransparentBg = $31d0877b7a0bd896$var$getIsTransparentBg(isBgLayer, hasTransparency, $31d0877b7a0bd896$var$preferenceIsTransparentBg);
        let transparentBgCheckboxTouched = false;
        const transparentBgCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: isTransparentBg,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-eraser-transparent-bg'),
            allowTab: true,
            callback: function(b) {
                transparentBgCheckboxTouched = true;
                isTransparentBg = b;
                updatePreview(true);
            },
            css: {
                display: 'inline-block'
            },
            name: 'transparent-background'
        });
        buttonRow.append(cloneCheckbox.getElement());
        if (isBgLayer) buttonRow.append(transparentBgCheckbox.getElement());
        let isConstrained = true;
        const constrainCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-constrain'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('constrain-proportions'),
            allowTab: true,
            callback: function(b) {
                isConstrained = b;
                freeTransform.setIsConstrained(isConstrained);
            },
            css: {
                display: 'inline-block'
            },
            name: 'constrain-proportions'
        });
        let isSnapping = false;
        const snappingCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-snap'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-snap-title'),
            allowTab: true,
            callback: function(b) {
                isSnapping = b;
                freeTransform.setSnapping(isSnapping);
            },
            css: {
                display: 'inline-block',
                marginLeft: '10px'
            },
            name: 'enable-snapping'
        });
        const checkboxWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        checkboxWrapper.append(constrainCheckbox.getElement(), snappingCheckbox.getElement());
        rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                clear: 'both',
                height: '10px'
            }
        }));
        const bottomRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px'
            }
        });
        const algorithmSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
            isFocusable: true,
            optionArr: [
                [
                    'smooth',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('algorithm-smooth')
                ],
                [
                    'pixelated',
                    (0, $63d0b335c576c718$export$ce37e184d908d785)('algorithm-pixelated')
                ]
            ],
            initValue: 'smooth',
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('scaling-algorithm'),
            onChange: ()=>{
                updatePreview(true);
            },
            name: 'interpolation-algorithm'
        });
        bottomRow.append(checkboxWrapper, algorithmSelect.getElement());
        const previewCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(context.canvas.width, context.canvas.height);
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? previewCanvas : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            hasEditMode: true,
            onModeChange: (m)=>{
                freeTransform.getElement().style.pointerEvents = m === 'edit' ? '' : 'none';
                freeTransform.getElement().style.opacity = m === 'edit' ? '' : '0.5';
            },
            onTransformChange: (transform)=>{
                freeTransform.setViewportTransform(transform);
            },
            padding: 30
        });
        preview.render();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        let lastDrawnTransformStr = '';
        function updatePreview(doForce = false) {
            if (!freeTransform) return;
            const transform = freeTransform.getValue();
            if (JSON.stringify(transform) === lastDrawnTransformStr && !doForce) return;
            lastDrawnTransformStr = JSON.stringify(transform);
            const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(previewCanvas);
            $31d0877b7a0bd896$var$drawTransform(ctx, layers[selectedLayerIndex].context.canvas, algorithmSelect.getValue() === 'pixelated', transform, selection, boundsObj, doClone, isTransparentBg || selectedLayerIndex > 0);
            preview.render();
        }
        const freeTransform = new (0, $d42d1384577ab84d$export$79a74567acf241b0)({
            x: initTransform.x,
            y: initTransform.y,
            width: initTransform.width,
            height: initTransform.height,
            angleDeg: initTransform.angleDeg,
            isConstrained: true,
            snapX: [
                0,
                context.canvas.width
            ],
            snapY: [
                0,
                context.canvas.height
            ],
            callback: function(t) {
                inputX.value = '' + Math.round(t.x - initTransform.x);
                inputY.value = '' + Math.round(t.y - initTransform.y);
                inputR.value = '' + Math.round(t.angleDeg);
                updatePreview();
            },
            viewportTransform: preview.getTransform()
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(freeTransform.getElement(), {
            position: 'absolute',
            left: '0',
            top: '0'
        });
        preview.getElement().append(freeTransform.getElement());
        function onInputsChanged() {
            freeTransform.setPos({
                x: parseInt(inputX.value) + initTransform.x,
                y: parseInt(inputY.value) + initTransform.y
            });
            freeTransform.setAngleDeg(parseInt(inputR.value));
            updatePreview();
        }
        updatePreview();
        result.destroy = ()=>{
            keyListener.destroy();
            freeTransform.destroy();
            constrainCheckbox.destroy();
            snappingCheckbox.destroy();
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(flipXBtn);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(flipYBtn);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(scaleRotLeftBtn);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(scaleRotRightBtn);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(scaleDoubleBtn);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(scaleHalfBtn);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).destroyEl(centerBtn);
            preview.destroy();
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(previewCanvas);
        };
        result.getInput = function() {
            const transform = freeTransform.getValue();
            if (transparentBgCheckboxTouched) $31d0877b7a0bd896$var$preferenceIsTransparentBg = isTransparentBg;
            const input = {
                transform: transform,
                bounds: boundsObj,
                isPixelated: algorithmSelect.getValue() === 'pixelated',
                doClone: doClone,
                isTransparentBg: isTransparentBg
            };
            result.destroy();
            return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(input);
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        if (!context) return false;
        const input = params.input;
        const selectedLayerIndex = params.klCanvas.getLayerIndex(context.canvas);
        const copyCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyCanvas(context.canvas);
        let selection = params.klCanvas.getSelection();
        const matrix = $31d0877b7a0bd896$var$drawTransform(context, copyCanvas, input.isPixelated, input.transform, selection, input.bounds, input.doClone, input.isTransparentBg || selectedLayerIndex > 0);
        if (selection && matrix) {
            selection = (0, $1d9e27e0466b80f7$export$aa391dbbf8073422)(selection, matrix);
            klHistory.pause(true);
            try {
                params.klCanvas.setSelection(selection);
            } finally{
                klHistory.pause(false);
            }
        }
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push((0, $0616f0a0655c1023$export$71511d61b312f219)({
                layerMap: layerMap
            }, selection ? {
                selection: {
                    value: selection
                }
            } : undefined));
        }
        return true;
    }
};












const $b3e717c77532e1e1$export$55e7eb2ebd0db869 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const context = params.context;
        if (!klCanvas || !context) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        let radius = 10;
        const fxPreviewRenderer = new (0, $7f838dbc615d3028$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: (fxCanvas, transform)=>{
                return fxCanvas.multiplyAlpha().triangleBlur(radius * transform.scaleX).unmultiplyAlpha();
            },
            selection: klCanvas.getSelection()
        });
        const radiusSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('radius'),
            width: 300,
            height: 30,
            min: 1,
            max: 200,
            value: radius,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: (val)=>{
                radius = val;
                preview.render();
            }
        });
        radiusSlider.getElement().style.marginBottom = '10px';
        rootEl.append(radiusSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            radiusSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                radius: radius
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const radius = params.input.radius;
        if (!context || !radius) return false;
        return (0, $31c92ae106360499$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.multiplyAlpha().triangleBlur(radius).unmultiplyAlpha();
        }, klHistory);
    }
};











const $a392dfa9711a1868$export$62ac74a5ea43bd5c = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        let radius = 2, strength = 0.51;
        const fxPreviewRenderer = new (0, $7f838dbc615d3028$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: (fxCanvas, transform)=>{
                return fxCanvas.unsharpMask(radius * transform.scaleX, strength);
            },
            selection: klCanvas.getSelection()
        });
        function update() {
            preview.render();
        }
        const radiusSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('radius'),
            width: 300,
            height: 30,
            min: 0,
            max: 200,
            value: 2,
            //eventResMs: eventResMs,
            onChange: function(val) {
                radius = val;
                update();
            },
            curve: [
                [
                    0,
                    0
                ],
                [
                    0.1,
                    2
                ],
                [
                    0.5,
                    50
                ],
                [
                    1,
                    200
                ]
            ]
        });
        const strengthSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-unsharp-mask-strength'),
            width: 300,
            height: 30,
            min: 0,
            max: 50,
            value: 5.1,
            //eventResMs: eventResMs,
            onChange: function(val) {
                strength = val / 10;
                update();
            },
            curve: [
                [
                    0,
                    0
                ],
                [
                    0.1,
                    2
                ],
                [
                    0.5,
                    10
                ],
                [
                    1,
                    50
                ]
            ]
        });
        radiusSlider.getElement().style.marginBottom = '10px';
        strengthSlider.getElement().style.marginBottom = '10px';
        rootEl.append(radiusSlider.getElement());
        rootEl.append(strengthSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        update();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            radiusSlider.destroy();
            strengthSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                radius: radius,
                strength: strength
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const radius = params.input.radius;
        const strength = params.input.strength;
        if (!context || radius === null || strength === null) return false;
        return (0, $31c92ae106360499$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.unsharpMask(radius, strength);
        }, klHistory);
    }
};












const $125e47ad063697cb$export$6158ed2b22ebf4d9 = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        const fxPreviewRenderer = new (0, $7f838dbc615d3028$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: (fxCanvas)=>{
                return fxCanvas.toAlpha(sourceId === 'inverted-luminance', selectedRgbaObj);
            },
            selection: klCanvas.getSelection()
        });
        // source
        let sourceId = 'inverted-luminance';
        const sourceOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'inverted-luminance',
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-to-alpha-inverted-lum')
                },
                {
                    id: 'luminance',
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-to-alpha-lum')
                }
            ],
            initId: sourceId,
            onChange: function(id) {
                sourceId = id;
                preview.render();
            }
        });
        rootEl.append(sourceOptions.getElement());
        // color
        let selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        const colorOptionsArr = [
            null,
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            {
                r: params.currentColorRgb.r,
                g: params.currentColorRgb.g,
                b: params.currentColorRgb.b,
                a: 1
            },
            {
                r: params.secondaryColorRgb.r,
                g: params.secondaryColorRgb.g,
                b: params.secondaryColorRgb.b,
                a: 1
            }
        ];
        const colorOptions = new (0, $3032e23fa8f3a9e5$export$24ba9b81662d4366)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-to-alpha-replace'),
            colorArr: colorOptionsArr,
            initialIndex: 1,
            onChange: function(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                preview.render();
            },
            css: {
                margin: '10px 0'
            }
        });
        rootEl.append(colorOptions.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            sourceOptions.destroy();
            colorOptions.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                sourceId: sourceId,
                selectedRgbaObj: selectedRgbaObj
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const sourceId = params.input.sourceId;
        const selectedRgbaObj = params.input.selectedRgbaObj;
        if (!context || !sourceId) return false;
        return (0, $31c92ae106360499$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.toAlpha(sourceId === 'inverted-luminance', selectedRgbaObj);
        }, klHistory);
    }
};






// ideas: padding, gutter, other shapes
function $074907f5bc61bd8c$export$20d2db9c68afeac(ctx, cellsX, cellsY, thickness, color, opacity) {
    ctx.save();
    const w = ctx.canvas.width;
    const h = ctx.canvas.height;
    thickness = Math.round(thickness);
    const thickIsRound = thickness % 2 === 0;
    ctx.beginPath();
    ctx.lineWidth = thickness;
    ctx.strokeStyle = color;
    ctx.globalAlpha = opacity;
    for(let i = 0; i < cellsX - 1; i++){
        const cw = w / cellsX;
        let pos = cw * (i + 1);
        if (thickIsRound) pos = Math.round(pos);
        else pos = Math.round(pos + 0.5) - 0.5;
        ctx.moveTo(pos, 0);
        ctx.lineTo(pos, h);
    }
    for(let i = 0; i < cellsY - 1; i++){
        const ch = h / cellsY;
        let pos = ch * (i + 1);
        if (thickIsRound) pos = Math.round(pos);
        else pos = Math.round(pos + 0.5) - 0.5;
        ctx.moveTo(0, pos);
        ctx.lineTo(w, pos);
    }
    ctx.stroke();
    ctx.restore();
}







const $3e2f8fc3797db2c6$export$50020de79e1bc23 = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(klCanvas.getLayerIndex(context.canvas));
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        const settingsObj = {
            x: 2,
            y: 2,
            thickness: 8,
            color: '#000',
            opacity: 1
        };
        const line1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        const line2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px',
                marginBottom: '10px'
            }
        });
        const xInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: 2,
            type: 'number',
            min: 1,
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function(v) {
                settingsObj.x = parseFloat(v);
                updatePreview();
            }
        });
        const yInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: 2,
            type: 'number',
            min: 1,
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function(v) {
                settingsObj.y = parseFloat(v);
                updatePreview();
            }
        });
        const thicknessInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: settingsObj.thickness,
            type: 'number',
            min: 1,
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function(v) {
                settingsObj.thickness = parseFloat(v);
                updatePreview();
            }
        });
        let selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        const colorOptionsArr = [
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }
        ];
        colorOptionsArr.push({
            r: params.currentColorRgb.r,
            g: params.currentColorRgb.g,
            b: params.currentColorRgb.b,
            a: 1
        });
        colorOptionsArr.push({
            r: params.secondaryColorRgb.r,
            g: params.secondaryColorRgb.g,
            b: params.secondaryColorRgb.b,
            a: 1
        });
        settingsObj.color = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(selectedRgbaObj);
        const colorOptions = new (0, $3032e23fa8f3a9e5$export$24ba9b81662d4366)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-stroke'),
            colorArr: colorOptionsArr,
            onChange: function(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                settingsObj.color = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(selectedRgbaObj);
                updatePreview();
            }
        });
        const labelStyle = {
            display: 'inline-block',
            marginRight: '5px'
        };
        line1.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: 'X:',
            css: labelStyle
        }), xInput, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: 'Y:',
            css: labelStyle
        }), yInput);
        line2.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-line-width') + ':',
            css: labelStyle
        }), thicknessInput, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                flexGrow: '1'
            }
        }), colorOptions.getElement());
        const previewCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(context.canvas.width, context.canvas.height);
        const previewCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(previewCanvas);
        const previewLayerArr = layers.map((item, i)=>{
            return {
                image: i === selectedLayerIndex ? previewCanvas : item.context.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr,
                hasClipping: false
            };
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            }
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        function updatePreview() {
            const ctx = previewCtx;
            ctx.save();
            ctx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
            ctx.drawImage(context.canvas, 0, 0);
            (0, $074907f5bc61bd8c$export$20d2db9c68afeac)(ctx, settingsObj.x, settingsObj.y, Math.max(settingsObj.thickness, 1), settingsObj.color, settingsObj.opacity);
            ctx.restore();
            preview.render();
        }
        updatePreview();
        preview.render();
        result.destroy = ()=>{
            preview.destroy();
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(previewCanvas);
            colorOptions.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(settingsObj);
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klCanvas = params.klCanvas;
        const klHistory = params.klHistory;
        if (!context || !klCanvas) return false;
        (0, $074907f5bc61bd8c$export$20d2db9c68afeac)(context, params.input.x, params.input.y, params.input.thickness, params.input.color, params.input.opacity);
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};






















const $f4f1194f773d88e8$var$presetArr = [
    // each pixel random value
    {
        type: 0,
        scaleX: 1,
        scaleY: 1,
        offsetX: 0,
        offsetY: 0,
        octaves: 1,
        samples: 1,
        peaks: 0,
        brightness: 0,
        contrast: 0,
        isReversed: true
    },
    // cloud
    {
        type: 1,
        scaleX: 166,
        scaleY: 164,
        offsetX: 105,
        offsetY: 30,
        octaves: 6,
        samples: 1,
        peaks: 0,
        brightness: 0.055,
        contrast: 0.23,
        isReversed: true
    },
    // thin lines
    {
        type: 1,
        scaleX: 235,
        scaleY: 190,
        offsetX: 3227,
        offsetY: 2156,
        octaves: 4,
        samples: 16,
        peaks: 22,
        brightness: -0.375,
        contrast: 1,
        isReversed: false
    },
    // soft large simplex, only 1 octave
    {
        type: 1,
        scaleX: 40,
        scaleY: 40,
        offsetX: 0,
        offsetY: 0,
        octaves: 1,
        samples: 1,
        peaks: 0,
        brightness: 0,
        contrast: 0,
        isReversed: false
    },
    // two value large pixels
    {
        type: 0,
        scaleX: 26,
        scaleY: 26,
        offsetX: 557,
        offsetY: 365,
        octaves: 1,
        samples: 1,
        peaks: 0,
        brightness: 0.02,
        contrast: 1,
        isReversed: true
    },
    // zebra
    {
        type: 1,
        scaleX: 1500,
        scaleY: 1500,
        offsetX: 745,
        offsetY: 2871,
        octaves: 5,
        samples: 16,
        peaks: 156.02,
        brightness: 0.03,
        contrast: 1,
        isReversed: true
    },
    // sparse dots / stars
    {
        type: 1,
        scaleX: 11,
        scaleY: 11,
        offsetX: 2940,
        offsetY: 2045,
        octaves: 1,
        samples: 16,
        peaks: 1,
        brightness: -0.045,
        contrast: 1,
        isReversed: true
    },
    // pseudo marble
    {
        type: 2,
        scaleX: 74,
        scaleY: 74,
        offsetX: 4816,
        offsetY: 1304,
        octaves: 3,
        samples: 1,
        peaks: 2.78,
        brightness: 0,
        contrast: 0,
        isReversed: false
    }
];
function $f4f1194f773d88e8$var$createNoiseSettings(input) {
    const result = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj($f4f1194f773d88e8$var$presetArr[input.presetIndex]);
    result.seed = input.seed;
    result.scaleX = result.scaleX * input.scale / 50;
    result.scaleY = result.scaleY * input.scale / 50;
    result.colA = input.colA;
    result.colB = input.colB;
    result.isReversed = input.isReversed ? !result.isReversed : result.isReversed;
    result.channels = input.channels;
    return result;
}
function $f4f1194f773d88e8$var$createNoiseParameters(settings) {
    return [
        settings.seed,
        settings.type,
        [
            settings.scaleX,
            settings.scaleY
        ],
        [
            settings.offsetX,
            settings.offsetY
        ],
        settings.octaves,
        settings.samples,
        settings.peaks,
        settings.brightness,
        settings.contrast,
        settings.isReversed,
        settings.colA,
        settings.colB,
        settings.channels ? settings.channels : 'rgb'
    ];
}
const $f4f1194f773d88e8$export$1dab0536099042f5 = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(klCanvas.getLayerIndex(context.canvas));
        const thumbImgArr = [];
        const thumbSize = 32;
        {
            const fxCanvas = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)((0, $5caaf17bca0749c7$export$8c4423af32b21158)());
            const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(thumbSize, thumbSize);
            const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
            const texture = fxCanvas.texture(canvas);
            fxCanvas.draw(texture).update(); // update fxCanvas size
            texture.destroy();
            $f4f1194f773d88e8$var$presetArr.forEach((preset)=>{
                const thumbImg = new Image();
                const settings = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(preset);
                settings.scaleX /= 10;
                settings.scaleY /= 10;
                fxCanvas.noise(...$f4f1194f773d88e8$var$createNoiseParameters(settings)).update();
                ctx.drawImage(fxCanvas, 0, 0);
                thumbImg.src = canvas.toDataURL('image/png');
                thumbImgArr.push(thumbImg);
            });
            texture.destroy();
        }
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        const noiseInput = {
            seed: Math.random() * 300,
            presetIndex: 0,
            scale: 50,
            opacity: 0.5,
            isReversed: false,
            channels: 'rgb',
            mixModeStr: 'source-over',
            colA: {
                r: 0,
                g: 0,
                b: 0
            },
            colB: {
                r: 255,
                g: 255,
                b: 255
            }
        };
        const presetOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: thumbImgArr.map((img, index)=>{
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(img, {
                    margin: '1px',
                    borderRadius: '3px',
                    transition: 'all 0.1s ease-in-out'
                });
                return {
                    id: '' + index,
                    label: img
                };
            }),
            initId: '0',
            onChange: (id)=>{
                noiseInput.presetIndex = Number(id);
                update();
            },
            css: {
                marginBottom: '10px'
            }
        });
        rootEl.append(presetOptions.getElement());
        const scaleSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-noise-scale'),
            width: 300,
            height: 30,
            min: 1,
            max: 1000,
            value: noiseInput.scale,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            curve: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).powerSplineInput(1, 1000, 0.1),
            onChange: (value)=>{
                noiseInput.scale = value;
                update();
            }
        });
        scaleSlider.getElement().style.marginBottom = '10px';
        const opacitySlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('opacity'),
            width: 300,
            height: 30,
            min: 0.01,
            max: 1,
            value: noiseInput.opacity,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100,
            onChange: (value)=>{
                noiseInput.opacity = value;
                update();
            }
        });
        opacitySlider.getElement().style.marginBottom = '10px';
        const row1El = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                alignItems: 'center',
                marginBottom: '10px'
            }
        });
        const row2El = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                marginBottom: '10px'
            }
        });
        const channelsOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'rgb',
                    label: 'RGB'
                },
                {
                    id: 'alpha',
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-noise-alpha')
                }
            ],
            initId: 'rgb',
            onChange: (id)=>{
                noiseInput.channels = id;
                if (id === 'rgb') row2El.style.visibility = '';
                else row2El.style.visibility = 'hidden';
                update();
            }
        });
        const reverseToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('reverse'),
            callback: (val)=>{
                noiseInput.isReversed = val;
                update();
            },
            allowTab: true,
            name: 'reverse-gradient'
        });
        const mixModes = [
            'source-over',
            undefined,
            'darken',
            'multiply',
            'color-burn',
            undefined,
            'lighten',
            'screen',
            'color-dodge',
            undefined,
            'overlay',
            'soft-light',
            'hard-light',
            undefined,
            'difference',
            'exclusion',
            undefined,
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
        const blendSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
            isFocusable: true,
            optionArr: mixModes.map((item)=>{
                return item ? [
                    item,
                    (0, $326f2f7e3662b29f$export$6e1bedb2a6cdff30)(item)
                ] : undefined;
            }),
            initValue: noiseInput.mixModeStr,
            onChange: (val)=>{
                noiseInput.mixModeStr = val;
                update();
            },
            name: 'blend-mode'
        });
        blendSelect.getElement().title = (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-blending');
        const colorWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex'
            }
        });
        const colInputStyle = {
            width: '34px',
            height: '34px',
            marginRight: '5px'
        };
        const colAInput = (0, $49faab2330529a96$export$6e4a713ddcda1e5e).input({
            type: 'color',
            init: '#' + (0, $b68f66663c02a5d5$export$fb7efcd2e153af6e).toHexString(noiseInput.colA),
            callback: (val)=>{
                const newColor = (0, $b68f66663c02a5d5$export$fb7efcd2e153af6e).hexToRGB(val);
                if (newColor) {
                    noiseInput.colA = newColor;
                    update();
                }
            },
            css: colInputStyle
        });
        const colBInput = (0, $49faab2330529a96$export$6e4a713ddcda1e5e).input({
            type: 'color',
            init: '#' + (0, $b68f66663c02a5d5$export$fb7efcd2e153af6e).toHexString(noiseInput.colB),
            callback: (val)=>{
                const newColor = (0, $b68f66663c02a5d5$export$fb7efcd2e153af6e).hexToRGB(val);
                if (newColor) {
                    noiseInput.colB = newColor;
                    update();
                }
            },
            css: colInputStyle
        });
        colorWrapper.append(colAInput, colBInput);
        row1El.append(channelsOptions.getElement(), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                flexGrow: '1'
            }
        }), reverseToggle.getElement());
        row2El.append(blendSelect.getElement(), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                flexGrow: '1'
            }
        }), colorWrapper);
        rootEl.append(scaleSlider.getElement(), opacitySlider.getElement(), row1El, row2El);
        const fxPreviewRenderer = new (0, $7f838dbc615d3028$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: (fxCanvas, transform)=>{
                const settings = $f4f1194f773d88e8$var$createNoiseSettings(noiseInput);
                settings.scaleX *= transform.scaleX;
                settings.scaleY *= transform.scaleY;
                settings.offsetX = context.canvas.width / 2 * transform.scaleX + transform.x;
                settings.offsetY = context.canvas.height / 2 * transform.scaleY + transform.y;
                return fxCanvas.noise(...$f4f1194f773d88e8$var$createNoiseParameters(settings));
            },
            postMix: {
                opacity: noiseInput.opacity,
                operation: noiseInput.channels === 'alpha' ? 'destination-out' : noiseInput.mixModeStr
            },
            selection: klCanvas.getSelection(),
            isMaskingWithEmptyOriginal: true
        });
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        function update() {
            fxPreviewRenderer.setPostMix({
                opacity: noiseInput.opacity,
                operation: noiseInput.channels === 'alpha' ? 'destination-out' : noiseInput.mixModeStr
            });
            preview.render();
        }
        result.destroy = ()=>{
            presetOptions.destroy();
            scaleSlider.destroy();
            opacitySlider.destroy();
            reverseToggle.destroy();
            channelsOptions.destroy();
            blendSelect.destroy();
            preview.destroy();
            fxPreviewRenderer.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(noiseInput);
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klCanvas = params.klCanvas;
        const klHistory = params.klHistory;
        if (!context || !klCanvas) return false;
        const fxCanvas = (0, $5caaf17bca0749c7$export$8c4423af32b21158)();
        if (!fxCanvas) return false; // todo more specific error?
        const input = params.input;
        const selection = klCanvas.getSelection();
        let maskTexture;
        if (selection) {
            const maskCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(context.canvas.width, context.canvas.height);
            const maskContext = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(maskCanvas);
            (0, $13d5aa49e37e2734$export$f7b95c0f504bef8b)(selection, maskContext);
            maskTexture = fxCanvas.texture(maskCanvas);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(maskCanvas);
        }
        fxCanvas.initialize(context.canvas.width, context.canvas.height);
        {
            const settings = $f4f1194f773d88e8$var$createNoiseSettings(input);
            settings.offsetX = context.canvas.width / 2;
            settings.offsetY = context.canvas.height / 2;
            fxCanvas.noise(...$f4f1194f773d88e8$var$createNoiseParameters(settings)).update();
        }
        if (maskTexture) {
            fxCanvas.multiplyAlpha().mask(maskTexture).unmultiplyAlpha();
            maskTexture.destroy();
        }
        fxCanvas.update();
        context.save();
        context.globalAlpha = input.opacity;
        if (input.channels === 'alpha') context.globalCompositeOperation = 'destination-out';
        else context.globalCompositeOperation = input.mixModeStr;
        context.drawImage(fxCanvas, 0, 0);
        context.restore();
        klHistory.push((0, $fc7b31422a41da93$export$263fa670dc037098)(klHistory.getComposed(), (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(context.canvas, selection ? (0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(selection, 'index') : undefined)));
        return true;
    }
};














/**
 * Draws pattern onto context. Pattern generated from context.
 * Can use blending for smoother transition. Will use area outside of bounds for blending.
 *
 * @param context
 * @param settings
 */ function $0fd8ddcd0821b85a$var$drawPattern(context, settings) {
    // keep bounds in center via offset
    // because blending done towards bottom right
    const blendOffsetX = settings.blend ? Math.round(settings.blend * settings.width / 2) : 0;
    const blendOffsetY = settings.blend ? Math.round(settings.blend * settings.height / 2) : 0;
    const finalPatternCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(settings.width, settings.height);
    if (settings.blend) {
        // construct pattern via linear blending
        const blendCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(settings.width * 2, settings.height * 2);
        const blendCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(blendCanvas);
        const colTransparent = '#0000';
        const colOpaque = '#000';
        // transfer source to blendCanvas
        blendCtx.drawImage(context.canvas, -settings.x + blendOffsetX, -settings.y + blendOffsetY);
        // --- 1 cross-fade vertical ------------------------
        // erase vertical gradient bottom half
        blendCtx.save();
        let blendGradient = blendCtx.createLinearGradient(0, settings.height, 0, settings.height * 2);
        blendGradient.addColorStop(0, colOpaque);
        blendGradient.addColorStop(settings.blend, colTransparent);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, blendCanvas.width, blendCanvas.height);
        blendCtx.restore();
        // erase vertical gradient top half
        blendCtx.save();
        blendGradient = blendCtx.createLinearGradient(0, 0, 0, settings.height);
        blendGradient.addColorStop(0, colTransparent);
        blendGradient.addColorStop(settings.blend, colOpaque);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, settings.width * 2, settings.height * 2);
        blendCtx.restore();
        // draw bottom half over top half
        blendCtx.save();
        // lighter needed for accurate cross-fade
        blendCtx.globalCompositeOperation = 'lighter';
        blendCtx.drawImage(blendCanvas, 0, -settings.height);
        blendCtx.restore();
        // --- 2 cross-fade horizontal ------------------------
        // erase horizontal gradient right half
        blendCtx.save();
        blendGradient = blendCtx.createLinearGradient(settings.width, 0, settings.width * 2, 0);
        blendGradient.addColorStop(0, colOpaque);
        blendGradient.addColorStop(settings.blend, colTransparent);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, blendCanvas.width, blendCanvas.height);
        blendCtx.restore();
        // erase horizontal gradient left half
        blendCtx.save();
        blendGradient = blendCtx.createLinearGradient(0, 0, settings.width, 0);
        blendGradient.addColorStop(0, colTransparent);
        blendGradient.addColorStop(settings.blend, colOpaque);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, settings.width * 2, settings.height * 2);
        blendCtx.restore();
        // draw right half over left half
        blendCtx.save();
        // lighter needed for accurate cross-fade
        blendCtx.globalCompositeOperation = 'lighter';
        blendCtx.drawImage(blendCanvas, -settings.width, 0);
        blendCtx.restore();
        // transfer to pattern canvas
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(finalPatternCanvas).drawImage(blendCanvas, 0, 0);
    } else (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(finalPatternCanvas).drawImage(context.canvas, -settings.x, -settings.y);
    context.save();
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    context.translate(settings.offsetX - blendOffsetX, settings.offsetY - blendOffsetY);
    // InvalidStateError: The object is in an invalid state.
    context.fillStyle = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(context.createPattern(finalPatternCanvas, 'repeat'));
    context.fillRect(-settings.offsetX + blendOffsetX, -settings.offsetY + blendOffsetY, context.canvas.width, context.canvas.height);
    context.restore();
}
const $0fd8ddcd0821b85a$export$5b48b77a483d9b33 = {
    getDialog (params) {
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        const maxSize = 1024;
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const context = params.context;
        const width = context.canvas.width;
        const height = context.canvas.height;
        let settings = {
            x: 0,
            y: 0,
            width: width <= 250 ? Math.round(width / 4) : 200,
            height: height <= 250 ? Math.round(height / 4) : 200,
            blend: 0,
            offsetX: 0,
            offsetY: 0
        };
        let lastDrawnSettings;
        // determine bounds
        const bounds = (0, $13d5aa49e37e2734$export$c1fcf1f93aeabfbf)(context);
        // adjust settings according to bounds
        if (// use layer bounds if:
        bounds && bounds.width <= maxSize && bounds.height <= maxSize && // don't exceed max size
        (bounds.width < width * 0.75 || bounds.height < height * 0.75 // aren't too large (heuristic)
        )) {
            settings.x = bounds.x;
            settings.y = bounds.y;
            settings.width = bounds.width;
            settings.height = bounds.height;
        } else {
            // otherwise use default size in center
            settings.x = Math.round(width / 2 - settings.width / 2);
            settings.y = Math.round(height / 2 - settings.height / 2);
        }
        // ---- controls ----
        const xInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: settings.x,
            type: 'number',
            min: 0,
            max: width,
            css: {
                width: '100%'
            },
            callback: function(v) {
                settings.x = Number(v);
                updatePreview();
            }
        });
        const yInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: settings.y,
            type: 'number',
            min: 0,
            max: height,
            css: {
                width: '100%'
            },
            callback: function(v) {
                settings.y = Number(v);
                updatePreview();
            }
        });
        const widthInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: settings.width,
            type: 'number',
            min: 1,
            max: Math.min(maxSize, width),
            css: {
                width: '100%'
            },
            callback: function(v) {
                settings.width = Number(v);
                updatePreview();
            }
        });
        const heightInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: settings.height,
            type: 'number',
            min: 1,
            max: Math.min(maxSize, height),
            css: {
                width: '100%'
            },
            callback: function(v) {
                settings.height = Number(v);
                updatePreview();
            }
        });
        const inputStyle = {
            marginLeft: '5px',
            flex: '1'
        };
        rootEl.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    tagName: 'label',
                    content: [
                        'X:',
                        xInput
                    ],
                    css: inputStyle
                }),
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    tagName: 'label',
                    content: [
                        'Y:',
                        yInput
                    ],
                    css: inputStyle
                }),
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    tagName: 'label',
                    content: [
                        (0, $63d0b335c576c718$export$ce37e184d908d785)('width') + ':',
                        widthInput
                    ],
                    css: inputStyle
                }),
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                    tagName: 'label',
                    content: [
                        (0, $63d0b335c576c718$export$ce37e184d908d785)('height') + ':',
                        heightInput
                    ],
                    css: inputStyle
                })
            ],
            css: {
                display: 'flex',
                marginLeft: '-5px'
            }
        }));
        const blendSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-blending'),
            width: 300,
            height: 30,
            min: 0,
            max: 1,
            value: settings.blend,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: function(val) {
                settings.blend = val;
                updatePreview();
            },
            formatFunc: (val)=>{
                return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(val, 2);
            },
            manualInputRoundDigits: 2
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(blendSlider.getElement(), {
            margin: '10px 0'
        });
        rootEl.append(blendSlider.getElement());
        // ---- preview tabs ----
        let previewMode = 1; // 0 before, 1 after
        const beforeAfterTabs = new (0, $db258f044f5ffd5c$export$b1241e74876d9bbe)({
            left: (0, $63d0b335c576c718$export$ce37e184d908d785)('compare-before'),
            right: (0, $63d0b335c576c718$export$ce37e184d908d785)('compare-after'),
            init: previewMode,
            onChange: (val)=>{
                previewMode = val;
                overlayCanvas.style.display = val === 0 ? 'block' : 'none';
                updatePreview(true);
            }
        });
        rootEl.append(beforeAfterTabs.getElement());
        // ---- previews ----
        const klCanvas = params.klCanvas;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(klCanvas.getLayerIndex(context.canvas));
        const fit = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).fitInto(context.canvas.width, context.canvas.height, isSmall ? 280 : 490, isSmall ? 200 : 240, 1);
        const w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        const renderW = Math.min(w, context.canvas.width);
        const renderH = Math.min(h, context.canvas.height);
        // const renderFactor = renderW / context.canvas.width;
        const previewFactor = w / context.canvas.width;
        const previewWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper',
            css: {
                width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall) + 'px',
                height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall) + 'px',
                marginTop: '0'
            }
        });
        const previewLayer = {
            image: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(renderW, renderH),
            isVisible: layers[selectedLayerIndex].isVisible,
            opacity: layers[selectedLayerIndex].opacity,
            mixModeStr: layers[selectedLayerIndex].mixModeStr
        };
        const previewLayerArr = layers.map((item, i)=>{
            if (i === selectedLayerIndex) return previewLayer;
            else return {
                image: item.context.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr
            };
        });
        const klCanvasPreview = new (0, $1ac505c1a3109a32$export$e258ade1648009b7)({
            width: Math.round(w),
            height: Math.round(h),
            layers: previewLayerArr
        });
        const overlayCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(w, h);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(overlayCanvas, {
            position: 'absolute',
            left: '0',
            top: '0',
            mixBlendMode: 'difference',
            imageRendering: 'pixelated'
        });
        const previewInnerWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper__canvas',
            css: {
                width: parseInt('' + w) + 'px',
                height: parseInt('' + h) + 'px'
            }
        });
        previewInnerWrapper.append(klCanvasPreview.getElement(), overlayCanvas);
        previewWrapper.append(previewInnerWrapper);
        rootEl.append(previewWrapper);
        // ---- preview input processing ----
        const inputs = {};
        function syncInputs() {
            xInput.value = '' + settings.x;
            yInput.value = '' + settings.y;
            widthInput.value = '' + settings.width;
            heightInput.value = '' + settings.height;
        }
        const keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({});
        previewWrapper.oncontextmenu = function() {
            return false;
        };
        previewInnerWrapper.style.touchAction = 'none';
        const pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: previewInnerWrapper,
            onPointer: (event)=>{
                if (previewMode === 0) {
                    if (event.type === 'pointerdown') {
                        if (!inputs.state) {
                            inputs.oldSettings = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(settings);
                            const x = event.relX / previewFactor;
                            const y = event.relY / previewFactor;
                            if ((0, $d9f9f4926aa80a1c$export$921068d8846a1559).isInsideRect({
                                x: x,
                                y: y
                            }, {
                                x: settings.x,
                                y: settings.y,
                                width: settings.width,
                                height: settings.height
                            })) inputs.state = 'move';
                            else inputs.state = 'select';
                            inputs.start = {
                                x: x,
                                y: y
                            };
                        }
                    } else if (event.type === 'pointermove') {
                        const x = event.relX / previewFactor;
                        const y = event.relY / previewFactor;
                        if (inputs.state === 'select') {
                            inputs.end = {
                                x: x,
                                y: y
                            };
                            const x1 = Math.max(0, Math.min(inputs.start.x, inputs.end.x));
                            const y1 = Math.max(0, Math.min(inputs.start.y, inputs.end.y));
                            const x2 = Math.min(width, Math.max(inputs.start.x, inputs.end.x));
                            const y2 = Math.min(height, Math.max(inputs.start.y, inputs.end.y));
                            settings.x = Math.floor(x1);
                            settings.y = Math.floor(y1);
                            settings.width = Math.min(maxSize, Math.ceil(x2 - settings.x));
                            settings.height = Math.min(maxSize, Math.ceil(y2 - settings.y));
                            if (keyListener.isPressed('shift')) {
                                settings.width = Math.min(settings.width, settings.height);
                                settings.height = Math.min(settings.width, settings.height);
                            }
                            if (settings.width === 0 || settings.height === 0) settings = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(inputs.oldSettings);
                            syncInputs();
                            updatePreview();
                        } else if (inputs.state === 'move') {
                            const dX = Math.round(x - inputs.start.x);
                            const dY = Math.round(y - inputs.start.y);
                            settings.x = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(inputs.oldSettings.x + dX, 0, width - settings.width);
                            settings.y = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(inputs.oldSettings.y + dY, 0, height - settings.height);
                            syncInputs();
                            updatePreview();
                        }
                    } else if (event.type === 'pointerup') {
                        if (inputs.state) inputs.state = null;
                    }
                } else {
                    if (event.type === 'pointerdown') {
                        if (!inputs.state) {
                            inputs.state = 'move';
                            inputs.oldSettings = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(settings);
                            inputs.start = {
                                x: event.relX / previewFactor,
                                y: event.relY / previewFactor
                            };
                            inputs.end = null;
                        }
                    } else if (event.type === 'pointermove') {
                        if (inputs.state) {
                            inputs.end = {
                                x: event.relX / previewFactor,
                                y: event.relY / previewFactor
                            };
                            settings.offsetX = Math.round(inputs.end.x - inputs.start.x) + inputs.oldSettings.offsetX;
                            settings.offsetY = Math.round(inputs.end.y - inputs.start.y) + inputs.oldSettings.offsetY;
                            updatePreview();
                        }
                    } else if (event.type === 'pointerup') {
                        if (inputs.state) {
                            if (!inputs.end) {
                                settings.offsetX = 0;
                                settings.offsetY = 0;
                                updatePreview();
                            }
                            inputs.state = null;
                        }
                    }
                }
            }
        });
        // ---------- rendering ---------------------
        const fullSizeCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(width, height);
        const fullSizeCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(fullSizeCanvas);
        function sharpStrokeRect(context, x, y, width, height) {
            const drawX = Math.round(x + 0.5) - 0.5;
            const drawY = Math.round(y + 0.5) - 0.5;
            const drawWidth = Math.round(x + width - drawX);
            const drawHeight = Math.round(y + height - drawY);
            context.strokeRect(drawX, drawY, drawWidth, drawHeight);
        }
        function updatePreview(doForce) {
            if (!doForce && lastDrawnSettings && JSON.stringify(lastDrawnSettings) === JSON.stringify(settings)) return;
            if (previewMode === 0) {
                // before
                fullSizeCtx.clearRect(0, 0, width, height);
                fullSizeCtx.drawImage(context.canvas, 0, 0);
                const previewCanvas = previewLayer.image;
                const previewCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(previewCanvas);
                previewCtx.save();
                previewCtx.clearRect(0, 0, renderW, renderH);
                previewCtx.drawImage(fullSizeCanvas, 0, 0, renderW, renderH);
                previewCtx.restore();
                const pW = settings.width * previewFactor;
                const pH = settings.height * previewFactor;
                const overlayCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(overlayCanvas);
                overlayCtx.save();
                overlayCtx.clearRect(0, 0, w, h);
                overlayCtx.strokeStyle = '#fff';
                sharpStrokeRect(overlayCtx, settings.x * previewFactor, settings.y * previewFactor, pW, pH);
                if (settings.blend > 0.05) {
                    overlayCtx.strokeStyle = '#f0f';
                    sharpStrokeRect(overlayCtx, settings.x * previewFactor - pW / 2 * settings.blend, settings.y * previewFactor - pH / 2 * settings.blend, pW * (1 + settings.blend), pH * (1 + settings.blend));
                }
                overlayCtx.restore();
            } else {
                // after
                fullSizeCtx.clearRect(0, 0, width, height);
                fullSizeCtx.drawImage(context.canvas, 0, 0);
                $0fd8ddcd0821b85a$var$drawPattern(fullSizeCtx, settings);
                const previewCanvas = previewLayer.image;
                const previewCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(previewCanvas);
                previewCtx.clearRect(0, 0, renderW, renderH);
                previewCtx.drawImage(fullSizeCanvas, 0, 0, renderW, renderH);
            }
            klCanvasPreview.render();
            lastDrawnSettings = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(settings);
        }
        updatePreview();
        // ----- result -------------------
        const destroy = ()=>{
            blendSlider.destroy();
            keyListener.destroy();
            pointerListener.destroy();
            klCanvasPreview.destroy();
        };
        const result = {
            element: rootEl,
            destroy: destroy,
            getInput: ()=>{
                destroy();
                return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(settings);
            }
        };
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$3a4a74a7d8c44e62).width;
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        const ctx = params.layer.context;
        const klHistory = params.klHistory;
        if (!klCanvas) return false;
        $0fd8ddcd0821b85a$var$drawPattern(ctx, params.input);
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};















const $9fcfd66886ad70ef$export$77c344cc65ad0ed2 = {
    getDialog (params) {
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const context = params.context;
        let isSynced = true;
        const settings = {
            stepSize: 1,
            distortType: 0,
            scale: {
                x: 100,
                y: 100
            },
            strength: {
                x: 20,
                y: 20
            },
            phase: {
                x: 0,
                y: 0
            },
            offset: {
                x: 0,
                y: 0
            }
        };
        // let lastDrawnSettings = null;
        // ---- thumb -------
        const thumbImgArr = [];
        const thumbSize = 32;
        {
            const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(thumbSize, thumbSize);
            const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
            ctx.beginPath();
            ctx.arc(thumbSize / 2, thumbSize / 2, thumbSize / 2.5, 0, Math.PI * 2);
            ctx.fill();
            let gradient = ctx.createLinearGradient(0, 0, thumbSize, thumbSize);
            gradient.addColorStop(0, '#00f');
            gradient.addColorStop(0.5, '#f00');
            gradient.addColorStop(1, '#fff');
            ctx.fillStyle = gradient;
            ctx.globalCompositeOperation = 'source-atop';
            ctx.fillRect(0, 0, thumbSize, thumbSize);
            gradient = ctx.createLinearGradient(thumbSize, 0, 0, thumbSize);
            gradient.addColorStop(0, '#000');
            gradient.addColorStop(1, '#000');
            ctx.fillStyle = gradient;
            ctx.globalCompositeOperation = 'destination-atop';
            ctx.fillRect(0, 0, thumbSize, thumbSize);
            const fxCanvas = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)((0, $5caaf17bca0749c7$export$8c4423af32b21158)());
            const texture = fxCanvas.texture(canvas);
            fxCanvas.draw(texture).update(); // update fxCanvas size
            const scaleFactor = 20;
            [
                0,
                1,
                2
            ].forEach((item)=>{
                const thumbImg = new Image();
                const settingsCopy = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(settings);
                settingsCopy.distortType = item;
                settingsCopy.scale.x /= scaleFactor;
                settingsCopy.scale.y /= scaleFactor;
                settingsCopy.strength.x /= scaleFactor;
                settingsCopy.strength.y /= scaleFactor;
                fxCanvas.draw(texture).multiplyAlpha().distort(settingsCopy).unmultiplyAlpha().update();
                ctx.clearRect(0, 0, thumbSize, thumbSize);
                ctx.drawImage(fxCanvas, 0, 0);
                thumbImg.src = canvas.toDataURL('image/png');
                thumbImgArr.push(thumbImg);
            });
            texture.destroy();
        }
        // ---- controls ----
        const topRowEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        const typeOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: thumbImgArr.map((img, index)=>{
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(img, {
                    margin: '1px',
                    borderRadius: '3px',
                    transition: 'all 0.1s ease-in-out'
                });
                return {
                    id: '' + index,
                    label: img
                };
            }),
            initId: '0',
            onChange: (id)=>{
                settings.distortType = Number(id);
                preview.render();
            }
        });
        function sync(from) {
            if (from === 'x') {
                settings.scale.y = settings.scale.x;
                settings.strength.y = settings.strength.x;
                settings.phase.y = settings.phase.x;
                sliderArr[3].setValue(settings.scale.y);
                sliderArr[4].setValue(settings.strength.y);
                sliderArr[5].setValue(settings.phase.y);
            } else {
                settings.scale.x = settings.scale.y;
                settings.strength.x = settings.strength.y;
                settings.phase.x = settings.phase.y;
                sliderArr[0].setValue(settings.scale.x);
                sliderArr[1].setValue(settings.strength.x);
                sliderArr[2].setValue(settings.phase.x);
            }
            preview.render();
        }
        const syncToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-distort-sync-xy'),
            callback: (val)=>{
                isSynced = val;
                if (isSynced) sync('x');
            },
            name: 'sync-xy'
        });
        topRowEl.append(typeOptions.getElement(), (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                flexGrow: '1'
            }
        }), syncToggle.getElement());
        const xyRowEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                flexWrap: 'wrap'
            }
        });
        const leftCol = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: xyRowEl,
            css: {
                marginRight: '10px'
            }
        });
        const rightCol = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: xyRowEl
        });
        const sliderWidth = isSmall ? 300 : 245;
        const sliderArr = [];
        [
            'x',
            'y'
        ].forEach((item, index)=>{
            const targetEl = index === 0 ? leftCol : rightCol;
            const scaleSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-noise-scale') + ' ' + item.toUpperCase(),
                width: sliderWidth,
                height: 30,
                min: 1,
                max: 1000,
                curve: 'quadratic',
                value: settings.scale[item],
                eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
                onChange: (val)=>{
                    settings.scale[item] = val;
                    if (isSynced) sync(item);
                    else preview.render();
                }
            });
            scaleSlider.getElement().style.marginTop = '20px';
            targetEl.append(scaleSlider.getElement());
            const strengthSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-unsharp-mask-strength') + ' ' + item.toUpperCase(),
                width: sliderWidth,
                height: 30,
                min: 0,
                max: 200,
                curve: 'quadratic',
                value: settings.strength[item],
                eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
                onChange: (val)=>{
                    settings.strength[item] = val;
                    if (isSynced) sync(item);
                    else preview.render();
                }
            });
            strengthSlider.getElement().style.marginTop = '10px';
            targetEl.append(strengthSlider.getElement());
            const phaseSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
                label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-distort-phase') + ' ' + item.toUpperCase(),
                width: sliderWidth,
                height: 30,
                min: 0,
                max: 1,
                value: settings.phase[item],
                manualInputRoundDigits: 2,
                eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
                formatFunc: (val)=>(0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(val, 2),
                onChange: (val)=>{
                    settings.phase[item] = val;
                    if (isSynced) sync(item);
                    else preview.render();
                }
            });
            phaseSlider.getElement().style.marginTop = '10px';
            targetEl.append(phaseSlider.getElement());
            sliderArr.push(scaleSlider);
            sliderArr.push(strengthSlider);
            sliderArr.push(phaseSlider);
        });
        const stepSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-distort-stepsize'),
            width: 300,
            height: 30,
            min: 1,
            max: 300,
            curve: 'quadratic',
            value: settings.stepSize,
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: (val)=>{
                settings.stepSize = Math.round(val);
                preview.render();
            }
        });
        stepSlider.getElement().style.marginTop = '20px';
        stepSlider.getElement().style.marginBottom = '10px';
        rootEl.append(stepSlider.getElement());
        // ---- preview ----
        const klCanvas = params.klCanvas;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(klCanvas.getLayerIndex(context.canvas));
        const fxPreviewRenderer = new (0, $7f838dbc615d3028$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: (fxCanvas, transform)=>{
                const scaledSettings = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(settings);
                scaledSettings.stepSize *= transform.scaleX;
                scaledSettings.strength.x *= transform.scaleX;
                scaledSettings.strength.y *= transform.scaleY;
                if (scaledSettings.distortType !== 2) {
                    scaledSettings.scale.x *= transform.scaleX;
                    scaledSettings.scale.y *= transform.scaleY;
                }
                scaledSettings.offset.x = -transform.x;
                scaledSettings.offset.y = -transform.y;
                return fxCanvas.multiplyAlpha().distort(scaledSettings).unmultiplyAlpha();
            },
            selection: klCanvas.getSelection()
        });
        const previewLayerArr = layers.map((item, i)=>{
            return {
                image: i === selectedLayerIndex ? fxPreviewRenderer.render : item.context.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr,
                hasClipping: false
            };
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        const destroy = ()=>{
            typeOptions.destroy();
            sliderArr.forEach((item)=>item.destroy());
            stepSlider.destroy();
            syncToggle.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        // ----- result -------------------
        const result = {
            element: rootEl,
            destroy: destroy,
            getInput: ()=>{
                destroy();
                return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(settings);
            }
        };
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$3a4a74a7d8c44e62).width;
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        const context = params.layer.context;
        const klHistory = params.klHistory;
        if (!klCanvas) return false;
        return (0, $31c92ae106360499$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.multiplyAlpha().distort(params.input).unmultiplyAlpha();
        }, klHistory);
    }
};








function $9ccc4f1680c2a511$export$8f57d6bdbceb36d0(ctx, x, y, lines, thickness, color, opacity) {
    ctx.save();
    const degIncrement = 180 / lines;
    for(let deg = 0; deg < 180; deg += degIncrement){
        const p2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).rotateAround({
            x: x,
            y: y
        }, {
            x: x + 9999,
            y: y
        }, deg);
        (0, $583d130d11db85ad$export$71b514a25c47df50)(ctx, {
            type: 'line',
            x1: x,
            y1: y,
            x2: p2.x,
            y2: p2.y,
            //angleRad: 0,
            isOutwards: true,
            opacity: opacity,
            //isEraser: false,
            strokeRgb: color,
            lineWidth: thickness
        });
    }
    ctx.restore();
}










const $f20653d322f43e28$export$a77e8ecd2a7fa9a5 = {
    getDialog (params) {
        const context = params.context;
        const klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(klCanvas.getLayerIndex(context.canvas));
        const previewCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(context.canvas.width, context.canvas.height);
        const previewCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(previewCanvas);
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $8522c24dbe0f81fc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall);
        const settingsObj = {
            x: context.canvas.width / 2,
            y: context.canvas.height / 2,
            lines: 8,
            thickness: 2,
            color: {
                r: 0,
                g: 0,
                b: 0
            },
            opacity: 1
        };
        const linesSlider = new (0, $cd73d123a4560ac3$export$a1855b925e534de7)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-vanish-point-lines'),
            width: 300,
            height: 30,
            min: 2,
            max: 20,
            value: settingsObj.lines,
            curve: 'quadratic',
            eventResMs: (0, $21a9e2eeab18749b$export$f02de051ab70b20e),
            onChange: function(val) {
                settingsObj.lines = Math.round(val);
                update();
            }
        });
        linesSlider.getElement().style.marginBottom = '10px';
        rootEl.append(linesSlider.getElement());
        const line1 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        const line2 = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px',
                marginBottom: '10px'
            }
        });
        const xInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: settingsObj.x,
            type: 'number',
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function(v) {
                settingsObj.x = parseFloat(v);
                dragInput.setValue({
                    x: settingsObj.x,
                    y: settingsObj.y
                });
                update();
            }
        });
        const yInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: settingsObj.y,
            type: 'number',
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function(v) {
                settingsObj.y = parseFloat(v);
                dragInput.setValue({
                    x: settingsObj.x,
                    y: settingsObj.y
                });
                update();
            }
        });
        const thicknessInput = (0, $760dd90d44275661$export$b7e3ae3d7c15e42e)({
            init: 2,
            type: 'number',
            min: 1,
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function(v) {
                settingsObj.thickness = parseFloat(v);
                update();
            }
        });
        let selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        const colorOptionsArr = [
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }
        ];
        colorOptionsArr.push({
            r: params.currentColorRgb.r,
            g: params.currentColorRgb.g,
            b: params.currentColorRgb.b,
            a: 1
        });
        colorOptionsArr.push({
            r: params.secondaryColorRgb.r,
            g: params.secondaryColorRgb.g,
            b: params.secondaryColorRgb.b,
            a: 1
        });
        settingsObj.color = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(selectedRgbaObj);
        const colorOptions = new (0, $3032e23fa8f3a9e5$export$24ba9b81662d4366)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-stroke'),
            colorArr: colorOptionsArr,
            onChange: function(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                settingsObj.color = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(selectedRgbaObj);
                update();
            }
        });
        const labelStyle = {
            display: 'inline-block',
            marginRight: '5px'
        };
        line1.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: 'X:',
            css: labelStyle
        }), xInput, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: 'Y:',
            css: labelStyle
        }), yInput);
        line2.append((0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-line-width') + ':',
            css: labelStyle
        }), thicknessInput, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                flexGrow: '1'
            }
        }), colorOptions.getElement());
        // ---- preview input processing ----
        function syncInputs() {
            xInput.value = '' + settingsObj.x;
            yInput.value = '' + settingsObj.y;
        }
        function update() {
            const ctx = previewCtx;
            const w = previewCanvas.width;
            const h = previewCanvas.height;
            ctx.save();
            ctx.clearRect(0, 0, w, h);
            ctx.drawImage(context.canvas, 0, 0, w, h);
            (0, $9ccc4f1680c2a511$export$8f57d6bdbceb36d0)(ctx, settingsObj.x, settingsObj.y, settingsObj.lines, Math.max(settingsObj.thickness, 1), settingsObj.color, settingsObj.opacity);
            ctx.restore();
            preview.render();
        }
        const onRender = ()=>{
            dragInput.setTransform(preview.getTransform());
            return previewCanvas;
        };
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? onRender : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        const preview = new (0, $324add89932145ee$export$133773870222880f)({
            width: (0, $3ec5d4ed5944260f$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $3ec5d4ed5944260f$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            }
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px',
            overflow: 'hidden'
        });
        const dragInput = new (0, $d90200485e14eee7$export$87247fc399965417)({
            value: {
                x: settingsObj.x,
                y: settingsObj.y
            },
            onChange: (val)=>{
                settingsObj.x = Math.round(val.x);
                settingsObj.y = Math.round(val.y);
                syncInputs();
                update();
            }
        });
        update();
        preview.getElement().append(dragInput.getElement());
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            linesSlider.destroy();
            colorOptions.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(settingsObj);
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klCanvas = params.klCanvas;
        const klHistory = params.klHistory;
        if (!context || !klCanvas) return false;
        (0, $9ccc4f1680c2a511$export$8f57d6bdbceb36d0)(context, params.input.x, params.input.y, params.input.lines, params.input.thickness, params.input.color, params.input.opacity);
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};


function $a5bdfa66fb1ba8cd$var$importFilter(libObj, moduleObj) {
    if (moduleObj.getDialog) libObj.getDialog = moduleObj.getDialog;
    libObj.apply = moduleObj.apply;
}
function $a5bdfa66fb1ba8cd$export$4283b00eae4a6956() {
    if ((0, $aa2ca71db1de8ae6$export$24724bc1f91cba3).isLoaded) return;
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).brightnessContrast, (0, $257cfc293f7e7cb2$export$af433fb90aa90a38));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).cropExtend, (0, $979e97880c50429e$export$e5937df51b9e1d86));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).curves, (0, $eafcde4f99931bb4$export$309483fcb6d5c7ca));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).flip, (0, $ca7e2a3c6a0e8777$export$9b1b7b3985b9625a));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).hueSaturation, (0, $345ea86e35fe44da$export$2aa46bd5587f0eb));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).invert, (0, $19cea8caa4f1f54e$export$b7ebcfbdc840ef76));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).perspective, (0, $68cd0c4958325f46$export$a76d798fa7d85e4e));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).resize, (0, $7bec11dd1272a23d$export$5705240d31427a82));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).rotate, (0, $4e52484ae64ee478$export$ac7e9efc751d5791));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).tiltShift, (0, $5aa2347b5ccd9148$export$1b8796b18b7c19ed));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).transform, (0, $31d0877b7a0bd896$export$dc15474d94cdc2b3));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).blur, (0, $b3e717c77532e1e1$export$55e7eb2ebd0db869));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).unsharpMask, (0, $a392dfa9711a1868$export$62ac74a5ea43bd5c));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).toAlpha, (0, $125e47ad063697cb$export$6158ed2b22ebf4d9));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).grid, (0, $3e2f8fc3797db2c6$export$50020de79e1bc23));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).noise, (0, $f4f1194f773d88e8$export$1dab0536099042f5));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).pattern, (0, $0fd8ddcd0821b85a$export$5b48b77a483d9b33));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).distort, (0, $9fcfd66886ad70ef$export$77c344cc65ad0ed2));
    $a5bdfa66fb1ba8cd$var$importFilter((0, $aa2ca71db1de8ae6$export$bac24f240bb7727d).vanishPoint, (0, $f20653d322f43e28$export$a77e8ecd2a7fa9a5));
    (0, $aa2ca71db1de8ae6$export$24724bc1f91cba3).isLoaded = true;
}





async function $3ccac2760787e643$export$92433b641be3f7a(klCanvas) {
    const layerArr = klCanvas.getLayersFast();
    const width = klCanvas.getWidth();
    const height = klCanvas.getHeight();
    const psdConfig = {
        width: width,
        height: height,
        //canvas: klCanvas.getCompleteCanvas(1), // preview, can be skipped
        children: layerArr.map((item)=>{
            // If a compositeObj is active, bake it into a fresh full-size canvas
            // so the exported layer data exactly matches what is rendered on screen
            // (pixel-perfect, no unfilled border artifacts).
            let canvas = item.canvas;
            if (item.compositeObj) {
                canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(width, height);
                const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
                ctx.drawImage(item.canvas, 0, 0);
                item.compositeObj.draw(ctx);
            }
            return {
                name: item.name,
                hidden: !item.isVisible,
                opacity: item.opacity,
                canvas: canvas,
                blendMode: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).PSD.blendKlToPsd(item.mixModeStr),
                left: 0,
                top: 0
            };
        })
    };
    const agPsd = await (0, $e4b3248b4ce95ea5$export$ab3d838b1d336b38)();
    const buffer = agPsd.writePsdBuffer(psdConfig);
    return new Blob([
        buffer
    ], {
        type: 'application/octet-stream'
    });
}







class $2d79f7f8e2e2d334$export$c57e2ed65bcf4d6a {
    chainIn(event) {
        event = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(event);
        clearTimeout(this.timeout);
        clearInterval(this.interval);
        if (event.type === 'down') this.lastMixedInput = {
            x: event.x,
            y: event.y,
            pressure: event.pressure
        };
        if (event.type === 'move') {
            const inputX = event.x;
            const inputY = event.y;
            const inputPressure = event.pressure;
            event.x = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(event.x, this.lastMixedInput.x, this.smoothing);
            event.y = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(event.y, this.lastMixedInput.y, this.smoothing);
            event.pressure = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(event.pressure, this.lastMixedInput.pressure, this.smoothing);
            this.lastMixedInput = {
                x: event.x,
                y: event.y,
                pressure: event.pressure
            };
            if (this.smoothing > 0) this.timeout = setTimeout(()=>{
                this.interval = setInterval(()=>{
                    var _this_chainOut, _this;
                    event = JSON.parse(JSON.stringify(event));
                    event.x = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(inputX, this.lastMixedInput.x, this.smoothing);
                    event.y = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(inputY, this.lastMixedInput.y, this.smoothing);
                    event.pressure = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(inputPressure, this.lastMixedInput.pressure, this.smoothing);
                    this.lastMixedInput = {
                        x: event.x,
                        y: event.y,
                        pressure: event.pressure
                    };
                    (_this_chainOut = (_this = this).chainOut) === null || _this_chainOut === void 0 ? void 0 : _this_chainOut.call(_this, event);
                }, 35);
            }, 80);
        }
        return event;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    setSmoothing(s) {
        this.smoothing = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(s, 0, 1);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.smoothing = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(p.smoothing, 0, 1);
    }
}


class $b47927ff4e129b10$export$91dcf4209534d21f {
    // ----------------------------------- public -----------------------------------
    chainIn(event) {
        if (event.type === 'down') {
            if (this.isDrawing) //console.log('line sanitizer - down, but already drawing');
            this.chainOut && this.chainOut({
                type: 'up',
                scale: event.scale,
                shiftIsPressed: event.shiftIsPressed,
                isCoalesced: false
            });
            else this.isDrawing = true;
        }
        if (!this.isDrawing && (event.type === 'move' || event.type === 'up')) //console.log('line sanitizer - ' + event.type + ' but not drawing');
        return null;
        if (event.type === 'up' && this.isDrawing) this.isDrawing = false;
        return event;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    getIsDrawing() {
        return this.isDrawing;
    }
    constructor(){
        this.isDrawing = false;
    }
}


/**
 * from stabilizer dropdown value to line-smoothing value
 */ function $b2e5423e81cbdb22$export$bcd109042a2e4bb5(s) {
    if (s == 1) return 0.5;
    if (s == 2) return 0.84;
    if (s == 3) return 0.965;
    if (s == 4) return 0.9825;
    if (s == 5) return 0.99125;
    return s;
}







// image - png, jpg, webp, whatever the browser natively supports
function $2b81f395a2c93f97$var$isBufferMatch(buffer, bytes) {
    return bytes.every((byte, index)=>{
        if (byte === undefined) return true;
        return buffer[index] === byte;
    });
}
async function $2b81f395a2c93f97$export$16b40d0fc7becfe6(file) {
    // photoshop is sub type of image.* - so check first
    const nameSplit = file.name.split('.');
    const extension = nameSplit[nameSplit.length - 1].toLowerCase();
    if (file.type.match('image/vnd.adobe.photoshop') || extension === 'psd') return 'psd';
    if (file.type.match('image.*')) return 'image';
    // check for headers
    try {
        const arr = await new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result === null) {
                    reject();
                    return;
                }
                // we did read as array buffer
                resolve(new Uint8Array(reader.result));
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file.slice(0, 12));
        });
        // PSD: '8BPS'
        if ($2b81f395a2c93f97$var$isBufferMatch(arr, [
            56,
            66,
            80,
            83
        ])) return 'psd';
        // PNG: 89 50 4E 47 0D 0A 1A 0A
        if ($2b81f395a2c93f97$var$isBufferMatch(arr, [
            0x89,
            0x50,
            0x4e,
            0x47,
            0x0d,
            0x0a,
            0x1a,
            0x0a
        ])) return 'image';
        // JPEG: 0xFF 0xD8
        if ($2b81f395a2c93f97$var$isBufferMatch(arr, [
            0xff,
            0xd8
        ])) return 'image';
        // WebP: 'RIFF....WEBP'
        if ($2b81f395a2c93f97$var$isBufferMatch(arr, [
            0x52,
            0x49,
            0x46,
            0x46,
            undefined,
            undefined,
            undefined,
            undefined,
            0x57,
            0x45,
            0x42,
            0x50
        ])) return 'image';
    } catch (e) {
    // ...
    }
    return undefined;
}


class $d4355fc62c3bbadf$export$1ec1306c0c05d48d {
    importFinishedLoading(importedImage, filename, optionStr) {
        if (!importedImage || isNaN(importedImage.width) || isNaN(importedImage.height) || importedImage.width <= 0 || importedImage.height <= 0) {
            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                type: 'error',
                message: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-broken-file'),
                buttons: [
                    'Ok'
                ]
            });
            return;
        }
        const getResizedDimensions = (width, height)=>{
            let w = parseInt('' + width);
            let h = parseInt('' + height);
            if (w > this.klMaxCanvasSize) {
                h = this.klMaxCanvasSize / w * h;
                w = this.klMaxCanvasSize;
            }
            if (h > this.klMaxCanvasSize) {
                w = this.klMaxCanvasSize / h * w;
                h = this.klMaxCanvasSize;
            }
            w = parseInt('' + w);
            h = parseInt('' + h);
            return {
                width: w,
                height: h
            };
        };
        const importAsImage = (canvas)=>{
            this.applyUncommitted();
            const resizedDimensions = getResizedDimensions(canvas.width, canvas.height);
            //resize first
            const tempCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(canvas.width, canvas.height);
            const tempCanvasCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(tempCanvas);
            tempCanvasCtx.drawImage(canvas, 0, 0);
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).resizeCanvas(tempCanvas, resizedDimensions.width, resizedDimensions.height);
            this.klCanvas.reset({
                width: resizedDimensions.width,
                height: resizedDimensions.height,
                image: tempCanvas,
                layerName: filename
            });
            this.layersUi.update(0);
            this.setCurrentLayer(this.klCanvas.getLayer(0));
            this.onImportConfirm();
        };
        /**
         * convertedPsdObj has no layers if flattened
         */ const importAsImagePsd = (convertedPsdObj, cropObj)=>{
            this.applyUncommitted();
            // crop
            const crop = (targetCanvas, cropCanvas, cropObj)=>{
                // eslint-disable-next-line no-self-assign
                cropCanvas.width = cropCanvas.width;
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(cropCanvas).drawImage(targetCanvas, -cropObj.x, -cropObj.y);
                targetCanvas.width = cropObj.width;
                targetCanvas.height = cropObj.height;
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(targetCanvas).drawImage(cropCanvas, 0, 0);
            };
            if (cropObj && (cropObj.width !== convertedPsdObj.width || cropObj.height !== convertedPsdObj.height)) {
                const cropCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(cropObj.width, cropObj.height);
                convertedPsdObj.width = cropObj.width;
                convertedPsdObj.height = cropObj.height;
                if (!convertedPsdObj.layers) crop(convertedPsdObj.canvas, cropCanvas, cropObj);
                if (convertedPsdObj.layers) for(let i = 0; i < convertedPsdObj.layers.length; i++){
                    const item = convertedPsdObj.layers[i];
                    crop(item.image, cropCanvas, cropObj);
                }
            }
            // resize
            const resizedDimensions = getResizedDimensions(convertedPsdObj.width, convertedPsdObj.height);
            convertedPsdObj.width = resizedDimensions.width;
            convertedPsdObj.height = resizedDimensions.height;
            if (!convertedPsdObj.layers) (0, $d9f9f4926aa80a1c$export$921068d8846a1559).resizeCanvas(convertedPsdObj.canvas, convertedPsdObj.width, convertedPsdObj.height);
            if (convertedPsdObj.layers) for(let i = 0; i < convertedPsdObj.layers.length; i++){
                const item = convertedPsdObj.layers[i];
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).resizeCanvas(item.image, convertedPsdObj.width, convertedPsdObj.height);
            }
            let layerIndex;
            if (convertedPsdObj.layers) layerIndex = this.klCanvas.reset({
                width: convertedPsdObj.width,
                height: convertedPsdObj.height,
                layers: convertedPsdObj.layers.map((layer)=>{
                    return {
                        id: (0, $07b32ff703dd0314$export$b2ce7a8a096070e2)(),
                        name: layer.name,
                        isVisible: layer.isVisible,
                        opacity: layer.opacity,
                        mixModeStr: layer.mixModeStr,
                        image: layer.image,
                        isClipped: layer.isClipped
                    };
                })
            });
            else layerIndex = this.klCanvas.reset({
                width: convertedPsdObj.width,
                height: convertedPsdObj.height,
                image: convertedPsdObj.canvas
            });
            this.layersUi.update(layerIndex);
            this.setCurrentLayer(this.klCanvas.getLayer(layerIndex));
            this.onImportConfirm();
        };
        const importAsLayer = (canvas)=>{
            this.applyUncommitted();
            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).showImportAsLayerDialog({
                target: this.klRootEl,
                klCanvas: this.klCanvas,
                importImage: canvas,
                callback: (transformObj, isPixelated)=>{
                    if (!transformObj) return;
                    const operation = (ctx)=>{
                        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).drawTransformedImageWithBounds(ctx, canvas, transformObj, undefined, isPixelated);
                    };
                    if (!this.klCanvas.addLayer(undefined, {
                        name: filename,
                        isVisible: true,
                        opacity: 1,
                        image: operation
                    })) this.klCanvas.drawOperation(this.klCanvas.getLayers().length - 1, operation);
                    const layers = this.klCanvas.getLayers();
                    const activeLayerIndex = layers.length - 1;
                    this.setCurrentLayer(this.klCanvas.getLayer(activeLayerIndex));
                    this.layersUi.update(activeLayerIndex);
                }
            });
        };
        if (optionStr === 'default' || !optionStr) (0, $49faab2330529a96$export$6e4a713ddcda1e5e).showImportImageDialog({
            image: importedImage,
            target: this.klRootEl,
            maxSize: this.klMaxCanvasSize,
            callback: (res)=>{
                if (res.type === 'as-image') importAsImage(res.image);
                else if (res.type === 'as-image-psd') importAsImagePsd(res.image, res.cropObj);
                else if (res.type === 'as-layer') importAsLayer(res.image);
                else res.type;
            }
        });
        if (optionStr === 'layer') importAsLayer(importedImage.canvas);
        if (optionStr === 'image') {
            if (importedImage.type === 'psd') importAsImagePsd(importedImage);
            else importAsImage(importedImage.canvas);
        }
    }
    // ---- interface ----
    async readClipboard() {
        try {
            /*if (Math.random() > 0.001) {
                throw new Error('haha');
            }*/ // May freeze the app until it read the clipboard
            // But if you show a loading indicator on this line, it will show up too early.
            const clipboardItems = await navigator.clipboard.read();
            // On this line it's already done freezing.
            let hasImage = false;
            for (const item of clipboardItems){
                for (const type of item.types)if (type.startsWith('image')) {
                    hasImage = true;
                    const blob = await item.getType(type);
                    const img = new Image();
                    img.onload = ()=>{
                        URL.revokeObjectURL(img.src);
                        this.importFinishedLoading({
                            type: 'image',
                            width: img.width,
                            height: img.height,
                            canvas: img
                        }, undefined, 'default');
                    };
                    img.src = URL.createObjectURL(blob);
                    return;
                }
            }
            if (!hasImage) (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                type: 'error',
                message: (0, $63d0b335c576c718$export$ce37e184d908d785)('clipboard-no-image'),
                buttons: [
                    'Ok'
                ]
            });
        } catch (error) {
            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                type: 'error',
                message: (0, $63d0b335c576c718$export$ce37e184d908d785)('clipboard-read-fail'),
                buttons: [
                    'Ok'
                ]
            });
        }
    }
    onPaste(e) {
        if ((0, $49faab2330529a96$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0) return;
        const retrieveImageFromClipboardAsBlob = (items, callback)=>{
            if (!items) return;
            for(let i = 0; i < items.length; i++){
                if (items[i].type.indexOf('image') == -1) continue;
                const file = items[i].getAsFile();
                file && callback(file);
            }
        };
        e.stopPropagation();
        e.preventDefault();
        if (!e.clipboardData) return;
        if (e.clipboardData.files[0]) retrieveImageFromClipboardAsBlob(e.clipboardData.items, (imageBlob)=>{
            // If there's an image, display it in the canvas
            const img = new Image();
            img.onload = ()=>{
                URL.revokeObjectURL(img.src);
                this.importFinishedLoading({
                    type: 'image',
                    width: img.width,
                    height: img.height,
                    canvas: img
                }, undefined, 'default');
            };
            const URLObj = window.URL || window.webkitURL;
            img.src = URLObj.createObjectURL(imageBlob);
        });
        else if (e.clipboardData.items[0]) e.clipboardData.items[0].getAsString((pasteStr)=>{
            pasteStr = pasteStr.trim();
            if (pasteStr.match(/^https?/)) {
                // url
                const img = new Image();
                img.onload = ()=>{
                    this.importFinishedLoading({
                        type: 'image',
                        width: img.width,
                        height: img.height,
                        canvas: img
                    }, undefined, 'default');
                };
                img.onerror = (e)=>{
                    console.log('error loading', e);
                };
                img.crossOrigin = 'Anonymous';
                img.src = pasteStr;
            } else if (pasteStr.match(/^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/)) {
                // url
                const rgbObj = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.hexToRGB(pasteStr.replace('#', ''));
                rgbObj && this.onColor(rgbObj);
            }
        });
    }
    async handleFileSelect(files, optionStr) {
        const showWarningPsdFlattened = ()=>{
            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                type: 'warning',
                message: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-psd-unsupported') + '<br /><br />',
                buttons: [
                    'Ok'
                ]
            });
        };
        let hasUnsupportedFile = false;
        // files need to be copied, because the input is reset
        const fileArr = [
            ...files
        ];
        for(let i = 0; i < fileArr.length; i++){
            const file = fileArr[i];
            const fileType = await (0, $2b81f395a2c93f97$export$16b40d0fc7becfe6)(file);
            if (fileType === 'image') ((f)=>{
                window.URL = window.URL || window.webkitURL;
                const url = window.URL.createObjectURL(f);
                const im = new Image();
                im.src = url;
                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).loadImage(im, ()=>{
                    URL.revokeObjectURL(url);
                    this.importFinishedLoading({
                        type: 'image',
                        width: im.width,
                        height: im.height,
                        canvas: im
                    }, f.name, optionStr);
                });
            })(file);
            else if (fileType === 'psd') ((f)=>{
                const loaderSizeBytes = 26214400; // 25mb
                const maxSizeBytes = 1073741824; // 1gb
                const maxResolution = 4096;
                if (f.size >= maxSizeBytes) {
                    // pretty likely to break stuff
                    (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                        type: 'error',
                        message: 'File too big. Unable to import.<br /><br />',
                        buttons: [
                            'Ok'
                        ]
                    });
                    return;
                }
                const doShowLoader = fileArr.length === 1 && f.size >= loaderSizeBytes;
                let loaderIsOpen = true;
                let closeLoader;
                if (doShowLoader) (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                    message: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-opening'),
                    callback: (result)=>{
                        loaderIsOpen = false;
                        closeLoader = null;
                    },
                    closeFunc: (f)=>{
                        closeLoader = f;
                    }
                });
                const reader = new FileReader();
                reader.onload = (readerResult)=>{
                    const target = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(readerResult.target);
                    (0, $49faab2330529a96$export$6e4a713ddcda1e5e).loadAgPsd().then((agPsdLazy)=>{
                        if (doShowLoader && !loaderIsOpen) return;
                        try {
                            let psd;
                            // first pass, only read metadata
                            psd = agPsdLazy.readPsd(target.result, {
                                skipLayerImageData: true,
                                skipThumbnail: true,
                                skipCompositeImageData: true
                            });
                            if (psd.width > maxResolution || psd.height > maxResolution) {
                                if (closeLoader) closeLoader();
                                (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                                    type: 'error',
                                    message: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-psd-too-large').replace(/{x}/g, '' + maxResolution) + '<br /><br />' + (0, $63d0b335c576c718$export$ce37e184d908d785)('import-psd-size') + ': ' + psd.width + ' x ' + psd.height + ' pixels' + '<br /><br />',
                                    buttons: [
                                        'Ok'
                                    ]
                                });
                                return;
                            }
                            // second pass, now load actual data.
                            psd = null;
                            try {
                                psd = agPsdLazy.readPsd(target.result);
                            } catch (e) {
                            //console.log('failed regular psd import', e);
                            }
                            if (psd) {
                                //console.log('psd', psd);
                                const convertedPsd = (0, $49faab2330529a96$export$6e4a713ddcda1e5e).PSD.readPsd(psd);
                                //console.log('converted', convertedPsd);
                                if (optionStr === 'image' && convertedPsd.error) showWarningPsdFlattened();
                                if (closeLoader) closeLoader();
                                this.importFinishedLoading(convertedPsd, f.name, optionStr);
                            } else {
                                psd = agPsdLazy.readPsd(target.result, {
                                    skipLayerImageData: true,
                                    skipThumbnail: true
                                });
                                if (optionStr === 'image') showWarningPsdFlattened();
                                if (closeLoader) closeLoader();
                                this.importFinishedLoading({
                                    type: 'psd',
                                    width: psd.width,
                                    height: psd.height,
                                    canvas: (0, $fc4403c8ee6a33dc$export$5c097f720de072a2)(psd.canvas),
                                    error: true
                                }, f.name, optionStr);
                            }
                        } catch (e) {
                            closeLoader === null || closeLoader === void 0 ? void 0 : closeLoader();
                            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                                type: 'error',
                                message: 'Failed to load PSD.<br /><br />',
                                buttons: [
                                    'Ok'
                                ]
                            });
                            console.log(e);
                            setTimeout(()=>{
                                throw new Error('psd load error');
                            });
                        }
                    }).catch((e)=>{
                        closeLoader === null || closeLoader === void 0 ? void 0 : closeLoader();
                        alert('Error: failed to load PSD library');
                    });
                };
                reader.readAsArrayBuffer(f);
            })(file);
            else hasUnsupportedFile = true;
        }
        if (hasUnsupportedFile) (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
            message: (0, $63d0b335c576c718$export$ce37e184d908d785)('import-unsupported-file'),
            type: 'error',
            buttons: [
                'OK'
            ]
        });
    }
    // ----------------------------------- public -----------------------------------
    constructor(input, callback){
        this.klRootEl = input.klRootEl;
        this.klMaxCanvasSize = input.maxCanvasSize;
        this.layersUi = input.layersUi;
        this.setCurrentLayer = input.setCurrentLayer;
        this.klCanvas = input.klCanvas;
        this.onImportConfirm = input.onImportConfirm;
        this.applyUncommitted = input.applyUncommitted;
        this.onColor = callback.onColor;
    }
}









var $b1066d3ce24bdbb8$exports = {};
$b1066d3ce24bdbb8$exports = $parcel$resolve("gXLuy");


var $4c22caf787ef90d3$exports = {};
$4c22caf787ef90d3$exports = $parcel$resolve("ll6eH");


var $a4d127e6391465c0$exports = {};
$a4d127e6391465c0$exports = $parcel$resolve("elaiI");


function $1050fcf084a1ca84$export$982e7602957287fa(p) {
    const output = [
        'Draw via the console! Learn more: %cKL.help()',
        'background: #000; color: #0f0;'
    ];
    'info' in console ? console.info(...output) : console.log(...output);
    return Object.freeze({
        draw: (path)=>{
            p.onDraw(path);
        },
        help: ()=>{
            console.log(`KL.draw({x: number; y: number}[]) // draw a line
KL.help() // print help
`);
        }
    });
}















class $6f9f66a6815f0457$export$ae7d5b5c7fa00e77 {
    chainIn(e) {
        this.pointerEventChain.chainIn(e);
    }
    setDoubleTapPointerTypes(p) {
        this.mainDoubleTapper.setAllowedPointerTypeArr(p);
    }
    destroy() {
    // todo
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        const nFingerSubChain = [];
        if (p.onUndo) {
            this.twoFingerTap = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).NFingerTapper({
                fingers: 2,
                onTap: p.onUndo
            });
            nFingerSubChain.push(this.twoFingerTap);
        }
        if (p.onRedo) {
            this.threeFingerTap = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).NFingerTapper({
                fingers: 3,
                onTap: p.onRedo
            });
            nFingerSubChain.push(this.threeFingerTap);
        }
        this.mainDoubleTapper = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).DoubleTapper({
            onDoubleTap: p.onDoubleTap
        });
        this.mainDoubleTapper.setAllowedPointerTypeArr([
            'touch'
        ]);
        this.middleDoubleTapper = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).DoubleTapper({
            onDoubleTap: p.onDoubleTap
        });
        this.middleDoubleTapper.setAllowedButtonArr([
            'middle'
        ]);
        this.pinchZoomer = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PinchZoomer({
            onPinch: p.onPinch
        });
        this.pointerEventChain = new (0, $3c485cff20ed4548$export$649a211db9812745)({
            chainArr: [
                ...nFingerSubChain,
                this.mainDoubleTapper,
                this.middleDoubleTapper,
                this.pinchZoomer,
                new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).OnePointerLimiter()
            ]
        });
        this.pointerEventChain.setChainOut(p.onChainOut);
    }
}







const $3757e4eb154d55dd$export$31ee023005d8c68f = [
    'touch'
];
const $3757e4eb154d55dd$export$4f41ddbc92f66d7d = [
    'space',
    'alt',
    'r',
    'z'
];
const $3757e4eb154d55dd$export$c5299001bfb7de59 = [
    'mouse-middle',
    'mouse-right',
    ...$3757e4eb154d55dd$export$4f41ddbc92f66d7d
];
const $3757e4eb154d55dd$export$5e2c057e240c0b8c = 1 / 16;
const $3757e4eb154d55dd$export$ac82c07320907c00 = Math.pow(2, 7);


function $9c9e0831687a01d5$export$296b597c2b22784a(a, b) {
    const isPositionChanged = a.x !== b.x || a.y !== b.y;
    const isScaleOrAngleChanged = a.scale !== b.scale || a.angleDeg !== b.angleDeg;
    return !isPositionChanged && !isScaleOrAngleChanged;
}









function $1f3a5022d3c168fe$export$e5cb90f7d2eee96c(currentTransform, targetTransform, projectSize, viewportCenter, easeFactor) {
    // equal
    if ((0, $9c9e0831687a01d5$export$296b597c2b22784a)(currentTransform, targetTransform)) return (0, $0616f0a0655c1023$export$71511d61b312f219)({}, targetTransform);
    // approximately equal
    if ((currentTransform.x === targetTransform.x || Math.abs(currentTransform.x - targetTransform.x) < 2) && (currentTransform.y === targetTransform.y || Math.abs(currentTransform.y - targetTransform.y) < 2) && (currentTransform.scale === targetTransform.scale || Math.abs(currentTransform.scale - targetTransform.scale) < 0.08 * targetTransform.scale)) return (0, $0616f0a0655c1023$export$71511d61b312f219)({}, targetTransform);
    // same angle, just translate and scale
    if (currentTransform.angleDeg === targetTransform.angleDeg) return {
        x: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(currentTransform.x, targetTransform.x, easeFactor),
        y: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(currentTransform.y, targetTransform.y, easeFactor),
        angleDeg: targetTransform.angleDeg,
        scale: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(currentTransform.scale, targetTransform.scale, easeFactor)
    };
    // rotating around a point
    const currentMeta = (0, $bfc75b1b92419309$export$935bc53f7df03c95)(currentTransform, viewportCenter);
    const targetMeta = (0, $bfc75b1b92419309$export$935bc53f7df03c95)(targetTransform, viewportCenter);
    if ((0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.dist(currentMeta.canvasP, targetMeta.canvasP) < 1) {
        // move angles closer to each other. assumes [-180, 180] angle range.
        let closerCurrentAngleDeg = currentMeta.angleDeg;
        // -180 180 -> 180 + 180 = 360
        // 180 -180 -> -180 - 180 = -360
        const angleDelta = targetMeta.angleDeg - currentMeta.angleDeg;
        if (angleDelta > 180) closerCurrentAngleDeg += 360;
        if (angleDelta < -180) closerCurrentAngleDeg -= 360;
        const mixedMeta = {
            viewportP: viewportCenter,
            canvasP: targetMeta.canvasP,
            scale: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(currentTransform.scale, targetTransform.scale, easeFactor),
            angleDeg: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(closerCurrentAngleDeg, targetTransform.angleDeg, easeFactor)
        };
        return (0, $68a5ab3e745a3a87$export$99c68a89351e15c0)(mixedMeta.viewportP, mixedMeta.canvasP, mixedMeta.scale, mixedMeta.angleDeg);
    }
    // rotate around center of canvas
    const canvasCenter = {
        x: projectSize.width / 2,
        y: projectSize.height / 2
    };
    const currentMatrix = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(currentTransform);
    const targetMatrix = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(targetTransform);
    const currentCenter = (0, $855520c81dfcb96a$export$9b20165a36586806)(currentMatrix, canvasCenter);
    const targetCenter = (0, $855520c81dfcb96a$export$9b20165a36586806)(targetMatrix, canvasCenter);
    const mixedCenter = {
        x: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(currentCenter.x, targetCenter.x, easeFactor),
        y: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(currentCenter.y, targetCenter.y, easeFactor)
    };
    const mixedScale = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(currentTransform.scale, targetTransform.scale, easeFactor);
    const mixedAngleDeg = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(currentTransform.angleDeg, targetTransform.angleDeg, easeFactor);
    const mixedAngleRad = mixedAngleDeg * (Math.PI / 180);
    // calculate the offset from the center to the top-left corner (origin)
    const offsetX = -canvasCenter.x * mixedScale;
    const offsetY = -canvasCenter.y * mixedScale;
    const rotatedOffsetX = offsetX * Math.cos(mixedAngleRad) - offsetY * Math.sin(mixedAngleRad);
    const rotatedOffsetY = offsetX * Math.sin(mixedAngleRad) + offsetY * Math.cos(mixedAngleRad);
    const origin = {
        x: mixedCenter.x + rotatedOffsetX,
        y: mixedCenter.y + rotatedOffsetY
    };
    return {
        x: origin.x,
        y: origin.y,
        scale: mixedScale,
        angleDeg: mixedAngleDeg
    };
}






function $78c6779614eabe8b$export$29dc1c77cb35d1c5(rect, viewportTransform, easelSize, snapRotation, padding = 0) {
    // rotate
    let newAngleDeg = viewportTransform.angleDeg;
    if (snapRotation) {
        if (newAngleDeg === 45) // would otherwise get rounded to 90
        newAngleDeg = 0;
        newAngleDeg = (0, $9414f5ea41e9cf25$export$c0156198713d0f0)(newAngleDeg, 90, 90);
    }
    // calc width and height of bounds after rotation
    const rectCenterX = rect.x + rect.width / 2;
    const rectCenterY = rect.y + rect.height / 2;
    const canvasPointsArr = [
        [
            rect.x,
            rect.y
        ],
        [
            rect.x + rect.width,
            rect.y
        ],
        [
            rect.x + rect.width,
            rect.y + rect.height
        ],
        [
            rect.x,
            rect.y + rect.height
        ]
    ];
    // setup transformation matrix
    let matrix = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Matrix.getIdentity();
    matrix = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Matrix.multiplyMatrices(matrix, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Matrix.createRotationMatrix(newAngleDeg / 180 * Math.PI));
    // rotate points
    for(let i = 0; i < canvasPointsArr.length; i++){
        let coords = [
            canvasPointsArr[i][0],
            canvasPointsArr[i][1],
            0,
            1
        ];
        coords = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Matrix.multiplyMatrixAndPoint(matrix, coords);
        canvasPointsArr[i][0] = coords[0];
        canvasPointsArr[i][1] = coords[1];
    }
    const boundsObj = {};
    for(let i = 0; i < canvasPointsArr.length; i++){
        if (boundsObj.x1 === undefined || canvasPointsArr[i][0] < boundsObj.x1) boundsObj.x1 = canvasPointsArr[i][0];
        if (boundsObj.y1 === undefined || canvasPointsArr[i][1] < boundsObj.y1) boundsObj.y1 = canvasPointsArr[i][1];
        if (boundsObj.x2 === undefined || canvasPointsArr[i][0] > boundsObj.x2) boundsObj.x2 = canvasPointsArr[i][0];
        if (boundsObj.y2 === undefined || canvasPointsArr[i][1] > boundsObj.y2) boundsObj.y2 = canvasPointsArr[i][1];
    }
    const boundsWidth = boundsObj.x2 - boundsObj.x1;
    const boundsHeight = boundsObj.y2 - boundsObj.y1;
    // fit bounds
    const { width: fitWidth } = (0, $fc4403c8ee6a33dc$export$fa55905620c22535)(boundsWidth, boundsHeight, easelSize.width - padding * 2, easelSize.height - padding * 2, 1);
    // determine scale
    // when bringing something into view avoid zooming in too far
    const maxScale = Math.max(viewportTransform.scale, 1);
    const factor = Math.min(maxScale, fitWidth / boundsWidth);
    return (0, $68a5ab3e745a3a87$export$99c68a89351e15c0)({
        x: easelSize.width / 2,
        y: easelSize.height / 2
    }, {
        x: rectCenterX,
        y: rectCenterY
    }, factor, newAngleDeg);
}



function $ef524340be1400ac$var$getToolEntries(tools) {
    return Object.entries(tools);
}
class $ef524340be1400ac$export$2732362bcaeb02c2 {
    setTargetTransform(transform, isImmediate) {
        if (isImmediate) this.viewport.setTransform(transform);
        this.targetTransform = transform;
        this.doRender = true;
    }
    updateToolSvgs() {
        var _this_tempToolId;
        const tool = (_this_tempToolId = this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : this.toolId;
        Object.keys(this.toolsMap).forEach((toolId)=>{
            this.toolsMap[toolId].getSvgElement().style.display = toolId === tool ? '' : 'none';
        });
    }
    // different tools allow different pointer types to trigger the gesture
    updateDoubleTapPointerTypes() {
        var _this_tempToolId, _this_toolsMap__doubleTapPointerTypes;
        const pointerTypes = (_this_toolsMap__doubleTapPointerTypes = this.toolsMap[(_this_tempToolId = this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : this.toolId].doubleTapPointerTypes) !== null && _this_toolsMap__doubleTapPointerTypes !== void 0 ? _this_toolsMap__doubleTapPointerTypes : (0, $3757e4eb154d55dd$export$31ee023005d8c68f);
        this.pointerPreprocessor.setDoubleTapPointerTypes(pointerTypes);
    }
    /**
     * Only call once from outside. Will perpetuate itself and render when doRender = true
     */ renderLoop() {
        const now = performance.now();
        const deltaMs = now - this.lastFrameTimestamp;
        this.lastFrameTimestamp = now;
        this.animationFrameId = requestAnimationFrame(()=>this.renderLoop());
        if (!this.doRender) return;
        const tool = this.getActiveTool();
        const oldTransform = this.viewport.getTransform();
        let newTransform = oldTransform;
        if ((0, $9c9e0831687a01d5$export$296b597c2b22784a)(oldTransform, this.targetTransform)) this.doRender = false;
        else {
            const defaultDeltaMs = 1000 / 60;
            const timeFactor = deltaMs / defaultDeltaMs;
            const easeFactor = 1 - 0.7 ** timeFactor;
            newTransform = (0, $1f3a5022d3c168fe$export$e5cb90f7d2eee96c)(oldTransform, this.targetTransform, {
                width: this.project.width,
                height: this.project.height
            }, {
                x: this.width / 2,
                y: this.height / 2
            }, easeFactor);
            this.viewport.setTransform(newTransform);
        }
        // todo: is last renderedTransform needed?
        const isPositionChanged = newTransform.x !== this.lastRenderedTransform.x || newTransform.y !== this.lastRenderedTransform.y;
        const isScaleOrAngleChanged = newTransform.scale !== this.lastRenderedTransform.scale || newTransform.angleDeg !== this.lastRenderedTransform.angleDeg;
        this.viewport.render(!(0, $9c9e0831687a01d5$export$296b597c2b22784a)(oldTransform, newTransform));
        if (isPositionChanged || isScaleOrAngleChanged) {
            var _tool_onUpdateTransform;
            (_tool_onUpdateTransform = tool.onUpdateTransform) === null || _tool_onUpdateTransform === void 0 ? void 0 : _tool_onUpdateTransform.call(tool, newTransform);
            this.selectionRenderer.setTransform(newTransform);
            this.onTransformChange(this.targetTransform, isScaleOrAngleChanged);
            this.lastRenderedTransform = newTransform;
        }
    }
    /**
     * activate temporary tool. Can only push one.
     */ pushTempTool(toolId) {
        var _tool_getIsLocked, _this_toolsMap_activeToolId_activate, _this_toolsMap_activeToolId;
        if (this.tempToolId !== undefined || toolId === undefined) return;
        const tool = this.toolsMap[this.toolId];
        if ((_tool_getIsLocked = tool.getIsLocked) === null || _tool_getIsLocked === void 0 ? void 0 : _tool_getIsLocked.call(tool)) return;
        this.tempToolId = toolId;
        const activeToolId = this.getActiveToolId();
        (_this_toolsMap_activeToolId_activate = (_this_toolsMap_activeToolId = this.toolsMap[activeToolId]).activate) === null || _this_toolsMap_activeToolId_activate === void 0 ? void 0 : _this_toolsMap_activeToolId_activate.call(_this_toolsMap_activeToolId, this.cursorPos);
        Object.values(this.toolsMap).forEach((tool)=>{
            var _tool_onTool;
            return (_tool_onTool = tool.onTool) === null || _tool_onTool === void 0 ? void 0 : _tool_onTool.call(tool, activeToolId);
        });
        this.updateToolSvgs();
        this.updateDoubleTapPointerTypes();
    }
    /**
     * Turn off temporary tool
     */ popTempTool(toolId) {
        var _this_getActiveTool_activate, _this_getActiveTool;
        if (this.tempToolId !== toolId || toolId === undefined) return;
        this.tempToolId = undefined;
        (_this_getActiveTool_activate = (_this_getActiveTool = this.getActiveTool()).activate) === null || _this_getActiveTool_activate === void 0 ? void 0 : _this_getActiveTool_activate.call(_this_getActiveTool, this.cursorPos, true);
        const activeToolId = this.getActiveToolId();
        Object.values(this.toolsMap).forEach((tool)=>{
            var _tool_onTool;
            return (_tool_onTool = tool.onTool) === null || _tool_onTool === void 0 ? void 0 : _tool_onTool.call(tool, activeToolId);
        });
        this.updateToolSvgs();
        this.updateDoubleTapPointerTypes();
    }
    getActiveToolId() {
        var _this_tempToolId;
        return (_this_tempToolId = this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : this.toolId;
    }
    getActiveTool() {
        return this.toolsMap[this.getActiveToolId()];
    }
    getResetTransform() {
        return (0, $68a5ab3e745a3a87$export$99c68a89351e15c0)({
            x: this.width / 2,
            y: this.height / 2
        }, {
            x: this.project.width / 2,
            y: this.project.height / 2
        }, 1, 0);
    }
    getFitTransform() {
        return (0, $78c6779614eabe8b$export$29dc1c77cb35d1c5)({
            x: 0,
            y: 0,
            width: this.project.width,
            height: this.project.height
        }, this.viewport.getTransform(), {
            width: this.width,
            height: this.height
        }, true);
    }
    /** update and render */ setProject(project) {
        var _this_getActiveTool_onUpdateSelection, _this_getActiveTool;
        this.project = project;
        this.viewport.setProject({
            width: this.project.width,
            height: this.project.height,
            layers: this.project.layers
        });
        this.selectionRenderer.setSelection(this.project.selection);
        (_this_getActiveTool_onUpdateSelection = (_this_getActiveTool = this.getActiveTool()).onUpdateSelection) === null || _this_getActiveTool_onUpdateSelection === void 0 ? void 0 : _this_getActiveTool_onUpdateSelection.call(_this_getActiveTool, this.project.selection);
        this.requestRender();
    }
    /** update and render */ setSize(width, height) {
        var _this_getActiveTool_onResize, _this_getActiveTool;
        const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.viewport.getTransform());
        const canvasCenterPoint = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(m), {
            x: this.width / 2,
            y: this.height / 2
        });
        this.width = width;
        this.height = height;
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).setAttributes(this.svgEl, {
            width: '' + this.width,
            height: '' + this.height
        });
        this.selectionRenderer.setSize(width, height);
        (_this_getActiveTool_onResize = (_this_getActiveTool = this.getActiveTool()).onResize) === null || _this_getActiveTool_onResize === void 0 ? void 0 : _this_getActiveTool_onResize.call(_this_getActiveTool, width, height);
        this.viewport.setSize(width, height);
        const transform = this.viewport.getTransform();
        this.setTargetTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)({
            x: this.width / 2,
            y: this.height / 2
        }, canvasCenterPoint, transform.scale, transform.angleDeg), true);
        this.requestRender();
    }
    requestRender() {
        this.doRender = true;
    }
    getTransform() {
        return this.viewport.getTransform();
    }
    setTransform(transform) {
        this.setTargetTransform(transform, true);
    }
    setTool(toolId) {
        var _this_toolsMap_this_toolId_activate, _this_toolsMap_this_toolId;
        if (toolId === this.toolId) return;
        this.toolId = toolId;
        (_this_toolsMap_this_toolId_activate = (_this_toolsMap_this_toolId = this.toolsMap[this.toolId]).activate) === null || _this_toolsMap_this_toolId_activate === void 0 ? void 0 : _this_toolsMap_this_toolId_activate.call(_this_toolsMap_this_toolId, this.cursorPos);
        Object.values(this.toolsMap).forEach((tool)=>{
            var _tool_onTool;
            return (_tool_onTool = tool.onTool) === null || _tool_onTool === void 0 ? void 0 : _tool_onTool.call(tool, this.toolId);
        });
        this.onChangeTool(toolId);
        this.updateToolSvgs();
        this.updateDoubleTapPointerTypes();
        this.requestRender();
    }
    getTool() {
        return this.toolId;
    }
    translate(dX, dY) {
        const transform = this.targetTransform;
        this.setTargetTransform((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, transform), {
            x: transform.x + dX,
            y: transform.y + dY
        }));
    }
    scale(factor, viewportX, viewportY) {
        const before = this.targetTransform;
        const viewportRect = {
            width: this.width,
            height: this.height
        };
        viewportX = viewportX !== null && viewportX !== void 0 ? viewportX : viewportRect.width / 2;
        viewportY = viewportY !== null && viewportY !== void 0 ? viewportY : viewportRect.height / 2;
        const metaTransform = (0, $bfc75b1b92419309$export$935bc53f7df03c95)(before, {
            x: viewportX,
            y: viewportY
        });
        metaTransform.scale = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(metaTransform.scale * factor, (0, $3757e4eb154d55dd$export$5e2c057e240c0b8c), (0, $3757e4eb154d55dd$export$ac82c07320907c00));
        this.setTargetTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg));
    }
    resetTransform(isImmediate) {
        const transform = this.getResetTransform();
        this.setTargetTransform(transform, isImmediate);
        this.requestRender();
    }
    fitTransform(isImmediate) {
        const oldTransform = this.viewport.getTransform();
        const transform = this.getFitTransform();
        const isPositionChanged = transform.x !== oldTransform.x || transform.y !== oldTransform.y;
        const isScaleOrAngleChanged = transform.scale !== oldTransform.scale || transform.angleDeg !== oldTransform.angleDeg;
        if (!isPositionChanged && !isScaleOrAngleChanged) return false;
        this.setTargetTransform(transform, isImmediate);
        return true;
    }
    /**
     * Automatically decide what is best. E.g. if it's pixel art, Fit might be better.
     */ resetOrFitTransform(isImmediate) {
        const threshold = 4; // >= 400% zoom. pixelated, not blurry
        if (!(0, $5a2f7ed66bdaf6a4$export$67ac20532b9ededa).disableAutoFit && this.project.width <= this.width / threshold && this.project.height <= this.height / threshold) this.fitTransform(isImmediate);
        else this.resetTransform(isImmediate);
    }
    setAngleDeg(angleDeg, isRelative) {
        const viewportTransform = this.targetTransform;
        const viewportMat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(viewportTransform);
        const viewportRect = {
            width: this.width,
            height: this.height
        };
        const viewportCenterP = {
            x: viewportRect.width / 2,
            y: viewportRect.height / 2
        };
        const newAngleDeg = (0, $9414f5ea41e9cf25$export$ec85425cac357ca9)(isRelative ? viewportTransform.angleDeg + angleDeg : angleDeg);
        const newViewportTransform = (0, $68a5ab3e745a3a87$export$99c68a89351e15c0)(viewportCenterP, (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(viewportMat), viewportCenterP), viewportTransform.scale, newAngleDeg);
        this.setTargetTransform(newViewportTransform);
    }
    getIsLocked() {
        var _this_getActiveTool_getIsLocked, _this_getActiveTool;
        var _this_getActiveTool_getIsLocked1;
        return (_this_getActiveTool_getIsLocked1 = (_this_getActiveTool_getIsLocked = (_this_getActiveTool = this.getActiveTool()).getIsLocked) === null || _this_getActiveTool_getIsLocked === void 0 ? void 0 : _this_getActiveTool_getIsLocked.call(_this_getActiveTool)) !== null && _this_getActiveTool_getIsLocked1 !== void 0 ? _this_getActiveTool_getIsLocked1 : false;
    }
    setIsFrozen(b) {
        this.isFrozen = b;
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.viewport.destroy();
        this.pointerListener.destroy();
        this.keyListener.destroy();
        this.animationFrameId !== undefined && cancelAnimationFrame(this.animationFrameId);
        this.selectionRenderer.destroy();
        window.removeEventListener('pointerdown', this.windowPointerListener);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        var _this_toolsMap_this_toolId_activate, _this_toolsMap_this_toolId;
        this.doRender = false // true -> will render on next renderLoop
        ;
        this.isFrozen = false // disable interaction with the easel whatsoever
        ;
        this.lastRenderedTransform = {} // previously rendered viewport transformation
        ;
        this.targetTransform = {};
        // custom interface passed to tools
        this.easelInterface = {
            setCursor: (cursor)=>this.rootEl.style.cursor = cursor,
            getTransform: ()=>this.viewport.getTransform(),
            getTargetTransform: ()=>this.targetTransform,
            getSize: ()=>({
                    width: this.width,
                    height: this.height
                }),
            getProjectSize: ()=>({
                    width: this.project.width,
                    height: this.project.height
                }),
            setTransform: (transform, isImmediate)=>this.setTargetTransform(transform, isImmediate),
            requestRender: ()=>this.requestRender(),
            isKeyPressed: (keyStr)=>this.keyListener.isPressed(keyStr),
            minScale: (0, $3757e4eb154d55dd$export$5e2c057e240c0b8c),
            maxScale: (0, $3757e4eb154d55dd$export$ac82c07320907c00),
            setAngleDeg: (...args)=>this.setAngleDeg(...args),
            keyListener: {},
            updateDoubleTapPointerTypes: ()=>this.updateDoubleTapPointerTypes(),
            setRenderedSelection: (selection)=>this.selectionRenderer.setRenderedSelection(selection),
            clearRenderedSelection: (isImmediate)=>this.selectionRenderer.clearRenderedSelection(isImmediate),
            onWheel: (e)=>this.onWheel(e),
            getElement: ()=>this.rootEl
        };
        this.lastFrameTimestamp = 0;
        this.onWheel = (e)=>{
            var _e_event;
            (_e_event = e.event) === null || _e_event === void 0 ? void 0 : _e_event.preventDefault();
            let isImmediate = false;
            if (Math.abs(e.deltaY) < 0.8) isImmediate = true;
            if (e.event && e.event.ctrlKey && !this.keyListener.isPressed('ctrl')) {
                isImmediate = true;
                let factor = 1;
                if (e.event.deltaMode === 0) factor = 6;
                e.deltaY *= factor;
            }
            if (this.keyListener.isPressed('shift')) e.deltaY /= 4;
            // zoom
            const transform = this.targetTransform;
            const viewportPoint = {
                x: e.relX,
                y: e.relY
            };
            const mat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(transform);
            const canvasPoint = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(mat), viewportPoint);
            const newScale = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(transform.scale * Math.pow(1.4, -e.deltaY), (0, $3757e4eb154d55dd$export$5e2c057e240c0b8c), (0, $3757e4eb154d55dd$export$ac82c07320907c00));
            this.setTargetTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)(viewportPoint, canvasPoint, newScale, transform.angleDeg), isImmediate);
        };
        this.project = p.project;
        this.width = p.width;
        this.height = p.height;
        this.toolId = p.tool;
        this.toolsMap = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.tools);
        this.onChangeTool = p.onChangeTool;
        this.onTransformChange = p.onTransformChange;
        this.onUndo = p.onUndo;
        this.onRedo = p.onRedo;
        this.tempTools = Object.fromEntries((0, $3757e4eb154d55dd$export$c5299001bfb7de59).map((trigger)=>{
            return [
                trigger,
                $ef524340be1400ac$var$getToolEntries(this.toolsMap).filter(([toolName, tool])=>{
                    return tool.tempTriggers && tool.tempTriggers.includes(trigger);
                }).map((i)=>i[0])[0]
            ];
        }));
        this.viewport = new (0, $0ca7fca685ce788f$export$a140ed60c2ca052c)({
            width: this.width,
            height: this.height,
            project: {
                width: this.project.width,
                height: this.project.height,
                layers: this.project.layers
            },
            transform: this.getResetTransform(),
            renderAfter: (ctx, renderedTransform)=>{
                var _tool_renderAfterViewport;
                const tool = this.getActiveTool();
                (_tool_renderAfterViewport = tool.renderAfterViewport) === null || _tool_renderAfterViewport === void 0 ? void 0 : _tool_renderAfterViewport.call(tool, ctx, renderedTransform);
            }
        });
        Object.values(this.toolsMap).forEach((tool)=>{
            var _tool_setEaselInterface, _tool_onResize;
            (_tool_setEaselInterface = tool.setEaselInterface) === null || _tool_setEaselInterface === void 0 ? void 0 : _tool_setEaselInterface.call(tool, this.easelInterface);
            (_tool_onResize = tool.onResize) === null || _tool_onResize === void 0 ? void 0 : _tool_onResize.call(tool, this.width, this.height);
        });
        let mouseMiddleIsDown = false;
        let mouseRightIsDown = false;
        let angleIsExtraSticky = false;
        this.pointerPreprocessor = new (0, $6f9f66a6815f0457$export$ae7d5b5c7fa00e77)({
            onUndo: this.onUndo,
            onRedo: this.onRedo,
            onPinch: (event)=>{
                if (event.type === 'move') {
                    const transform = this.viewport.getTransform();
                    if (!this.pinchInitialTransform) {
                        this.pinchInitialTransform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(transform);
                        angleIsExtraSticky = this.pinchInitialTransform.angleDeg % 180 === 0;
                    }
                    let newAngleDeg = this.pinchInitialTransform.angleDeg + event.angleRad / Math.PI * 180;
                    newAngleDeg = (0, $9414f5ea41e9cf25$export$ec85425cac357ca9)((0, $9414f5ea41e9cf25$export$c0156198713d0f0)(newAngleDeg, 90, angleIsExtraSticky ? 12 : 4));
                    if (newAngleDeg % 90 !== 0) angleIsExtraSticky = false;
                    const metaTransform = (0, $bfc75b1b92419309$export$935bc53f7df03c95)(this.pinchInitialTransform, {
                        x: event.downRelX,
                        y: event.downRelY
                    });
                    metaTransform.scale = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.pinchInitialTransform.scale * event.scale, (0, $3757e4eb154d55dd$export$5e2c057e240c0b8c), (0, $3757e4eb154d55dd$export$ac82c07320907c00));
                    metaTransform.viewportP.x += event.relX - event.downRelX;
                    metaTransform.viewportP.y += event.relY - event.downRelY;
                    metaTransform.angleDeg = newAngleDeg;
                    this.setTargetTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg), true);
                    this.requestRender();
                } else if (event.type === 'end') this.pinchInitialTransform = undefined;
            },
            onDoubleTap: (e)=>{
                if (this.fitTransform()) this.requestRender();
                else this.scale(2, e.relX, e.relY);
            },
            onChainOut: (e)=>{
                this.cursorPos = {
                    x: e.relX,
                    y: e.relY
                };
                if (e.type === 'pointerdown') {
                    if (e.button === 'middle') {
                        mouseMiddleIsDown = true;
                        this.pushTempTool(this.tempTools['mouse-middle']);
                    }
                    if (e.button === 'right') {
                        mouseRightIsDown = true;
                        this.pushTempTool(this.tempTools['mouse-right']);
                    }
                } else if (e.type === 'pointermove') ;
                else if (e.type === 'pointerup') {
                    if (mouseMiddleIsDown) {
                        mouseMiddleIsDown = false;
                        this.getActiveTool().onPointer(e);
                        this.popTempTool(this.tempTools['mouse-middle']);
                        return;
                    }
                    if (mouseRightIsDown) {
                        mouseRightIsDown = false;
                        this.getActiveTool().onPointer(e);
                        this.popTempTool(this.tempTools['mouse-right']);
                        return;
                    }
                }
                this.getActiveTool().onPointer(e);
            }
        });
        /*
        // My trackpad pinching (via PointerListener) doesn't currently work with Safari on macOS.
        // So I tried GestureListener, which works, but doesn't mesh well with the other event listeners.
        let lastScale = 0;
        this.gestureListener = new GestureListener({
            target: this.viewport.getElement(),
            onStart: (e) => {
                lastScale = e.scale;
            },
            onChange: (e) => {
                const deltaScale = e.scale / lastScale;
                lastScale = e.scale;

                // zoom
                const transform = this.viewport.getTransform();
                const viewportPoint = {
                    x: e.layerX,
                    y: e.layerY,
                };
                const mat = createMatrixFromTransform(transform);
                const canvasPoint = applyToPoint(inverse(mat), viewportPoint);
                const newScale = BB.clamp(
                    transform.scale * deltaScale,
                    EASEL_MIN_SCALE,
                    EASEL_MAX_SCALE,
                );
                this.setTransform(
                    createTransform(viewportPoint, canvasPoint, newScale, transform.angleDeg),
                );
                this.requestRender();
            },
        });*/ this.pointerListener = new (0, $a07742141701d1f2$export$9371bd96776f4e82)({
            target: this.viewport.getElement(),
            onPointer: (e)=>{
                this.pointerPreprocessor.chainIn(e);
            },
            onWheel: this.onWheel,
            onEnterLeave: (isOver)=>{
                const tool = this.getActiveTool();
                if (!isOver) {
                    var _tool_onPointerLeave;
                    this.cursorPos = undefined;
                    (_tool_onPointerLeave = tool.onPointerLeave) === null || _tool_onPointerLeave === void 0 ? void 0 : _tool_onPointerLeave.call(tool);
                }
            },
            useDirtyWheel: true,
            isWheelPassive: false,
            maxPointers: 3
        });
        this.windowPointerListener = (e)=>{
            var _this_getActiveTool_onClickOutside, _this_getActiveTool;
            if (this.isFrozen) return;
            if (!(e.target instanceof Node && this.rootEl.contains(e.target))) (_this_getActiveTool_onClickOutside = (_this_getActiveTool = this.getActiveTool()).onClickOutside) === null || _this_getActiveTool_onClickOutside === void 0 ? void 0 : _this_getActiveTool_onClickOutside.call(_this_getActiveTool);
        };
        window.addEventListener('pointerdown', this.windowPointerListener);
        this.keyListener = new (0, $08e838e8af75c5e2$export$f17908c5de22d32e)({
            onDown: (keyStr, e, comboStr, isRepeat)=>{
                var _tool_onKeyDown;
                if (this.isFrozen) return;
                if (comboStr === 'plus') {
                    const oldScale = this.getTransform().scale;
                    const newScale = (0, $b18d1bd8e7aad78b$export$8c03162b1a39d183)(oldScale, this.keyListener.isPressed('shift') ? 1 / 8 : 0.5);
                    this.scale(newScale / oldScale);
                }
                if (comboStr === 'minus') {
                    const oldScale = this.getTransform().scale;
                    const newScale = (0, $b18d1bd8e7aad78b$export$8c03162b1a39d183)(oldScale, this.keyListener.isPressed('shift') ? -1 / 8 : -0.5);
                    this.scale(newScale / oldScale);
                }
                if (comboStr !== 'shift' && this.keyListener.comboOnlyContains([
                    'shift',
                    'left',
                    'right',
                    'up',
                    'down'
                ])) {
                    var _activeTool_onArrowKeys;
                    const arrowKey = comboStr.split('+').find((item)=>item !== 'shift');
                    const activeTool = this.getActiveTool();
                    if (!((_activeTool_onArrowKeys = activeTool.onArrowKeys) === null || _activeTool_onArrowKeys === void 0 ? void 0 : _activeTool_onArrowKeys.call(activeTool, arrowKey))) {
                        const stepSize = 40;
                        if (arrowKey === 'left') this.translate(stepSize, 0);
                        if (arrowKey === 'right') this.translate(-stepSize, 0);
                        if (arrowKey === 'up') this.translate(0, stepSize);
                        if (arrowKey === 'down') this.translate(0, -stepSize);
                    }
                }
                // activate temporary tool
                (0, $3757e4eb154d55dd$export$4f41ddbc92f66d7d).forEach((keyTrigger)=>{
                    if (comboStr === keyTrigger && this.toolsMap[this.toolId].blockTrigger !== keyTrigger) this.pushTempTool(this.tempTools[keyTrigger]);
                });
                var _this_tempToolId;
                const tool = this.toolsMap[(_this_tempToolId = this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : this.toolId];
                (_tool_onKeyDown = tool.onKeyDown) === null || _tool_onKeyDown === void 0 ? void 0 : _tool_onKeyDown.call(tool, keyStr, e, comboStr, isRepeat);
            },
            onUp: (keyStr, e, oldComboStr)=>{
                var _tool_onKeyUp;
                if (this.isFrozen) return;
                // turn off temporary tool again
                (0, $3757e4eb154d55dd$export$4f41ddbc92f66d7d).forEach((keyTrigger)=>{
                    if (keyStr === keyTrigger && this.toolsMap[this.toolId].blockTrigger !== keyTrigger) this.popTempTool(this.tempTools[keyTrigger]);
                });
                var _this_tempToolId;
                const tool = this.toolsMap[(_this_tempToolId = this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : this.toolId];
                (_tool_onKeyUp = tool.onKeyUp) === null || _tool_onKeyUp === void 0 ? void 0 : _tool_onKeyUp.call(tool, keyStr, e, oldComboStr);
            },
            onBlur: ()=>{
                var _tool_onBlur;
                var _this_tempToolId;
                const tool = this.toolsMap[(_this_tempToolId = this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : this.toolId];
                (_tool_onBlur = tool.onBlur) === null || _tool_onBlur === void 0 ? void 0 : _tool_onBlur.call(tool);
            }
        });
        this.easelInterface.keyListener = this.keyListener;
        this.selectionRenderer = new (0, $af70c2e1b3c35649$export$c61ab90e0d3eb9b1)({
            transform: this.viewport.getTransform(),
            selection: this.project.selection,
            width: this.width,
            height: this.height
        });
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + this.width,
            height: '' + this.height
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.svgEl, {
            position: 'absolute',
            left: '0',
            top: '0',
            pointerEvents: 'none'
        });
        this.svgEl.append(this.selectionRenderer.getElement(), ...Object.values(this.toolsMap).map((item)=>item.getSvgElement()));
        this.htmlOverlayEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                left: '0',
                top: '0'
            }
        });
        this.htmlOverlayEl.append(...Object.values(this.toolsMap).map((item)=>{
            var _item_getHtmlOverlayElement;
            return ((_item_getHtmlOverlayElement = item.getHtmlOverlayElement) === null || _item_getHtmlOverlayElement === void 0 ? void 0 : _item_getHtmlOverlayElement.call(item)) || undefined;
        }).filter((item)=>item !== undefined));
        this.updateToolSvgs();
        this.rootEl = (0, $934e5f47c3374e21$export$db3b6bfb95261072)({
            css: {
                userSelect: 'none',
                touchAction: 'none',
                overscrollBehaviorX: 'none'
            }
        }, [
            this.viewport.getElement(),
            this.svgEl,
            this.htmlOverlayEl
        ]);
        // prevent contextmenu
        this.rootEl.addEventListener('contextmenu', (e)=>{
            e.preventDefault();
            return false;
        }, {
            passive: false
        });
        // Carried over from old KlCanvasWorkspace. Prevent some default browser behavior. Todo what breaks if removed?
        this.rootEl.addEventListener('touchend', (e)=>{
            e.preventDefault();
            return false;
        });
        // Carried over from old KlCanvasWorkspace. Prevent some default browser behavior. Todo what breaks if removed?
        this.rootEl.addEventListener('dragstart', (e)=>{
            e.preventDefault();
            return false;
        });
        (_this_toolsMap_this_toolId_activate = (_this_toolsMap_this_toolId = this.toolsMap[this.toolId]).activate) === null || _this_toolsMap_this_toolId_activate === void 0 ? void 0 : _this_toolsMap_this_toolId_activate.call(_this_toolsMap_this_toolId, this.cursorPos);
        Object.values(this.toolsMap).forEach((tool)=>{
            var _tool_onTool;
            return (_tool_onTool = tool.onTool) === null || _tool_onTool === void 0 ? void 0 : _tool_onTool.call(tool, this.toolId);
        });
        this.renderLoop();
    }
}





class $7c395458bbf78292$export$6c14c4cb1f26a0eb {
    stop() {
        if (this.animationFrameHandle === undefined) return;
        cancelAnimationFrame(this.animationFrameHandle);
        this.animationFrameHandle = undefined;
    }
    dampen(timeFactor) {
        const vecLen = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.len(this.momentum);
        if (vecLen < 0.3) {
            this.momentum.x = 0;
            this.momentum.y = 0;
            this.stop();
        } else if (vecLen < 5) {
            this.momentum.x *= 0.85 ** timeFactor;
            this.momentum.y *= 0.85 ** timeFactor;
        } else {
            this.momentum.x *= 0.95 ** timeFactor;
            this.momentum.y *= 0.95 ** timeFactor;
        }
    }
    // only call through requestAnimationFrame when animationFrameHandle undefined
    physicsLoop() {
        this.animationFrameHandle = requestAnimationFrame(()=>this.physicsLoop());
        const nowMs = performance.now();
        const deltaMs = nowMs - this.lastTimestamp;
        const timeFactor = deltaMs / this.defaultDeltaMs;
        this.lastTimestamp = nowMs;
        if (this.momentum.x === 0 && this.momentum.y === 0 || this.isDragging) {
            if (this.isDragging) this.dampen(timeFactor);
            else this.stop();
            return;
        }
        const transform = this.getTransform();
        if (this.lastTransform && (this.lastTransform.x !== transform.x || this.lastTransform.y !== transform.y || this.lastTransform.x !== transform.x || this.lastTransform.x !== transform.x)) {
            this.momentum.x = 0;
            this.momentum.y = 0;
            this.lastTransform = undefined;
            this.stop();
            return;
        }
        transform.x += this.momentum.x;
        transform.y += this.momentum.y;
        this.lastTransform = transform;
        this.dampen(timeFactor);
        this.setTransform(transform);
    }
    dragStart() {
        if (!this.isEnabled) return;
        this.isDragging = true;
        this.momentum.x = 0;
        this.momentum.y = 0;
        this.stop();
    }
    dragMove(dX, dY) {
        if (!this.isEnabled) return;
        this.momentum = {
            x: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.momentum.x, dX, 0.6),
            y: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).mix(this.momentum.y, dY, 0.6)
        };
        this.lastDragTimestamp = new Date().getTime();
    }
    dragEnd() {
        if (!this.isEnabled) return;
        if (new Date().getTime() - this.lastDragTimestamp > 80) {
            this.momentum.x = 0;
            this.momentum.y = 0;
        } else {
            this.lastTimestamp = performance.now();
            this.animationFrameHandle = requestAnimationFrame(()=>this.physicsLoop());
        }
        this.lastTransform = undefined;
        this.lastDragTimestamp = 0;
        this.isDragging = false;
    }
    setIsEnabled(b) {
        this.isEnabled = b;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.defaultDeltaMs = 1000 / 60 // time factor is 1 for 60fps, 2 for 120fps
        ;
        this.momentum = {
            x: 0,
            y: 0
        };
        this.isDragging = false;
        this.lastDragTimestamp = 0;
        this.lastTimestamp = 0;
        this.isEnabled = false;
        this.getTransform = p.getTransform;
        this.setTransform = p.setTransform;
    }
}


class $d8c027c12d076d23$export$8202a4a90789f655 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor('grab');
        if (e.type === 'pointerdown' && [
            'left',
            'middle'
        ].includes(e.button)) {
            this.inertiaScrolling.dragStart();
            this.easel.setCursor('grabbing');
        }
        if (e.type === 'pointermove' && [
            'left',
            'middle'
        ].includes(e.button)) {
            const vTransform = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.easel.getTransform());
            vTransform.x += e.dX;
            vTransform.y += e.dY;
            this.easel.setTransform(vTransform, true);
            this.easel.requestRender();
            this.easel.setCursor('grabbing');
            this.inertiaScrolling.dragMove(e.dX, e.dY);
        }
        if (e.type === 'pointerup' && e.button === undefined) this.inertiaScrolling.dragEnd();
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor('grab');
    }
    setUseInertiaScrolling(b) {
        this.inertiaScrolling.setIsEnabled(b);
    }
    constructor(p){
        this.easel = {};
        // ----------------------------------- public -----------------------------------
        this.doubleTapPointerTypes = [
            'touch',
            'mouse',
            'pen'
        ];
        this.tempTriggers = [
            'space',
            'mouse-middle'
        ];
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.inertiaScrolling = new (0, $7c395458bbf78292$export$6c14c4cb1f26a0eb)({
            getTransform: ()=>this.easel.getTransform(),
            setTransform: (transform)=>this.easel.setTransform(transform, true)
        });
    }
}













class $a79112c6366113fa$export$e91d1e53efcc28e3 {
    update(transform, position, size) {
        const mat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(transform);
        size = Math.round(size * 2) / 2;
        const width = Math.round(size * 2);
        const canvasCenter = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(mat), position);
        canvasCenter.x = width % 2 === 0 ? Math.round(canvasCenter.x) : Math.floor(canvasCenter.x) + 0.5;
        canvasCenter.y = width % 2 === 0 ? Math.round(canvasCenter.y) : Math.floor(canvasCenter.y) + 0.5;
        {
            const canvasPoints = [
                [
                    canvasCenter.x - size,
                    canvasCenter.y - size
                ],
                [
                    canvasCenter.x + size,
                    canvasCenter.y - size
                ],
                [
                    canvasCenter.x + size,
                    canvasCenter.y + size
                ],
                [
                    canvasCenter.x - size,
                    canvasCenter.y + size
                ],
                [
                    canvasCenter.x - size,
                    canvasCenter.y - size
                ]
            ];
            const viewportPoints = canvasPoints.map((point)=>{
                return (0, $855520c81dfcb96a$export$9b20165a36586806)(mat, point);
            });
            let path = 'M ';
            viewportPoints.forEach((point)=>{
                path += point.join(',') + ' ';
            });
            (0, $fc4403c8ee6a33dc$export$74da2cba014bdc09)(this.rootEl.children[1], {
                d: path
            });
        }
        {
            const viewport1px = 1 / transform.scale;
            const canvasPoints = [
                [
                    canvasCenter.x - size + viewport1px,
                    canvasCenter.y - size + viewport1px
                ],
                [
                    canvasCenter.x + size - viewport1px,
                    canvasCenter.y - size + viewport1px
                ],
                [
                    canvasCenter.x + size - viewport1px,
                    canvasCenter.y + size - viewport1px
                ],
                [
                    canvasCenter.x - size + viewport1px,
                    canvasCenter.y + size - viewport1px
                ],
                [
                    canvasCenter.x - size + viewport1px,
                    canvasCenter.y - size + viewport1px
                ]
            ];
            const viewportPoints = canvasPoints.map((point)=>{
                return (0, $855520c81dfcb96a$export$9b20165a36586806)(mat, point);
            });
            let path = 'M ';
            viewportPoints.forEach((point)=>{
                path += point.join(',') + ' ';
            });
            (0, $fc4403c8ee6a33dc$export$74da2cba014bdc09)(this.rootEl.firstChild, {
                d: path
            });
        }
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g',
            childrenArr: [
                {
                    elementType: 'path',
                    fill: 'none',
                    stroke: 'rgba(255,255,255,0.7)',
                    'stroke-width': '1'
                },
                {
                    elementType: 'path',
                    fill: 'none',
                    stroke: 'rgba(0,0,0,0.7)',
                    'stroke-width': '1'
                }
            ]
        });
    }
}



class $2b394378f1de843c$export$249b9041c848ec46 {
    update(transform, position, size) {
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).setAttributes(this.rootEl.children[0], {
            r: '' + Math.max(0, size * transform.scale - 1)
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).setAttributes(this.rootEl.children[1], {
            r: '' + size * transform.scale
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).setAttributes(this.rootEl, {
            transform: `translate(${position.x} ${position.y})`
        });
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g',
            childrenArr: [
                {
                    elementType: 'circle',
                    cx: '0',
                    cy: '0',
                    fill: 'none',
                    stroke: 'rgba(255,255,255,0.7)',
                    'stroke-width': '1'
                },
                {
                    elementType: 'circle',
                    cx: '0',
                    cy: '0',
                    fill: 'none',
                    stroke: 'rgba(0,0,0,0.7)',
                    'stroke-width': '1'
                }
            ]
        });
    }
}


class $d5398ba9251670c1$export$dfeedd8879a1038a {
    onExplodedPointer(e) {
        const vTransform = this.easel.getTransform();
        const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(vTransform);
        // canvas coordinates
        const p = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        const x = p.x;
        const y = p.y;
        if (vTransform.scale !== this.oldScale) this.oldScale = vTransform.scale;
        if (!e.isCoalesced) {
            this.lastPos.x = e.relX;
            this.lastPos.y = e.relY;
            this.currentCursor.update(this.easel.getTransform(), {
                x: e.relX,
                y: e.relY
            }, this.radius);
            if (!this.isOver && e.type !== 'pointerup') this._onPointerEnter();
        }
        var _e_pressure;
        const pressure = (_e_pressure = e.pressure) !== null && _e_pressure !== void 0 ? _e_pressure : 1;
        const isCoalesced = e.isCoalesced;
        const shiftIsPressed = this.easel.keyListener.isPressed('shift');
        if (shiftIsPressed && !this.firstShiftPos) this.firstShiftPos = {
            x: e.relX,
            y: e.relY
        };
        if (!shiftIsPressed) {
            this.firstShiftPos = undefined;
            this.lineToolDirection = undefined;
        }
        if (e.type === 'pointerdown' && e.button === 'left') {
            if (shiftIsPressed) {
                if (this.lastLineEnd) this.onLine(this.lastLineEnd, {
                    x: x,
                    y: y
                });
                return;
            }
            this.onLineStart({
                x: x,
                y: y,
                pressure: pressure,
                isCoalesced: isCoalesced
            });
            this.isDragging = true;
        }
        if (e.type === 'pointermove' && e.button === 'left') {
            if (shiftIsPressed) {
                if (!this.lineToolDirection) {
                    const dX = Math.abs(e.relX - this.firstShiftPos.x);
                    const dY = Math.abs(e.relY - this.firstShiftPos.y);
                    if (dX > 5 || dY > 5) this.lineToolDirection = dX > dY ? 'x' : 'y';
                }
                if (this.lineToolDirection) {
                    const viewportP = {
                        x: this.lineToolDirection === 'x' ? e.relX : this.firstShiftPos.x,
                        y: this.lineToolDirection === 'y' ? e.relY : this.firstShiftPos.y
                    };
                    const canvasP = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(m), viewportP);
                    this.onLineGo((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, canvasP), {
                        pressure: pressure,
                        isCoalesced: isCoalesced
                    }));
                }
            } else this.onLineGo({
                x: x,
                y: y,
                pressure: pressure,
                isCoalesced: isCoalesced
            });
        }
        if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
            this.onLineEnd();
            this.isDragging = false;
            if (e.pointerType === 'touch') // due to delay of double-tap listener, pointerleave fires to early
            this.onPointerLeave();
        }
    }
    _onPointerEnter() {
        clearTimeout(this.hideCursorTimeout);
        this.svgEl.setAttribute('opacity', '1');
        this.isOver = true;
    }
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.eventChain.chainIn(e);
    }
    onPointerLeave() {
        clearTimeout(this.hideCursorTimeout);
        this.svgEl.setAttribute('opacity', '0');
        this.isOver = false;
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    onUpdateTransform(transform) {
        this.currentCursor.update(transform, {
            x: this.lastPos.x,
            y: this.lastPos.y
        }, this.radius);
    }
    getIsLocked() {
        return this.isDragging;
    }
    setBrush(p) {
        if (p.radius !== undefined) {
            this.radius = p.radius;
            if (!this.isOver) {
                this.svgEl.setAttribute('opacity', '1');
                clearTimeout(this.hideCursorTimeout);
                this.hideCursorTimeout = setTimeout(()=>{
                    this.svgEl.setAttribute('opacity', '0');
                }, 500);
            }
            const { width: width, height: height } = this.easel.getSize();
            this.currentCursor.update(this.easel.getTransform(), this.isOver ? this.lastPos : {
                x: width / 2,
                y: height / 2
            }, this.radius);
        }
        if (p.type !== undefined) {
            const newBrushCursor = p.type === 'round' ? this.brushCursorRound : this.brushCursorPixelSquare;
            if (newBrushCursor !== this.currentCursor) {
                this.currentCursor.getElement().remove();
                this.currentCursor = newBrushCursor;
                this.getSvgElement().append(this.currentCursor.getElement());
            }
        }
    }
    setLastDrawEvent(p) {
        this.lastLineEnd = p ? (0, $0616f0a0655c1023$export$71511d61b312f219)({}, p) : undefined;
    }
    activate(cursorPos) {
        this.easel.setCursor('crosshair');
        this.isDragging = false;
        if (cursorPos) {
            this.lastPos.x = cursorPos.x;
            this.lastPos.y = cursorPos.y;
            this.currentCursor.update(this.easel.getTransform(), {
                x: cursorPos.x,
                y: cursorPos.y
            }, this.radius);
        } else this.onPointerLeave();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.oldScale = 1;
        this.isDragging = false;
        this.lastPos = {
            x: 0,
            y: 0
        };
        this.isOver = false;
        this.radius = p.radius;
        this.onLineStart = p.onLineStart;
        this.onLineGo = p.onLineGo;
        this.onLineEnd = p.onLineEnd;
        this.onLine = p.onLine;
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.brushCursorRound = new (0, $2b394378f1de843c$export$249b9041c848ec46)();
        this.brushCursorPixelSquare = new (0, $a79112c6366113fa$export$e91d1e53efcc28e3)();
        this.currentCursor = this.brushCursorRound;
        this.svgEl.append(this.currentCursor.getElement());
        this.eventChain = new (0, $3c485cff20ed4548$export$649a211db9812745)({
            chainArr: [
                new (0, $2df67d7abe113884$export$fe11e0afe623a677)()
            ]
        });
        this.eventChain.setChainOut((e)=>{
            this.onExplodedPointer(e);
        });
    }
}




class $d5ac8c3334d6d49f$export$abfede0290e9bfba {
    update() {
        const width = this.klCanvas.getWidth();
        const height = this.klCanvas.getHeight();
        const layers = this.klCanvas.getLayersFast();
        // free resources if no compositing being done (compositeObj path)
        if (layers.some((layer)=>layer.compositeObj)) {
            if (!this.compositeCanvas) this.compositeCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(width, height);
        } else if (this.compositeCanvas) {
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(this.compositeCanvas);
            this.compositeCanvas = undefined;
        }
        const compositeCanvas = this.compositeCanvas;
        const easelLayers = [];
        const usedGroupKeys = new Set();
        let i = 0;
        while(i < layers.length){
            const baseLayer = layers[i];
            const baseIndex = i;
            // Collect consecutive clipped layers above this base
            const clippedGroup = [];
            let j = i + 1;
            while(j < layers.length && layers[j].isClipped){
                clippedGroup.push(layers[j]);
                j++;
            }
            i = j;
            if (clippedGroup.length === 0) {
                // Simple layer — use compositeObj path if present, or raw canvas
                let image;
                if (baseLayer.compositeObj && compositeCanvas) {
                    const capturedLayer = baseLayer;
                    image = ()=>{
                        var _capturedLayer_compositeObj;
                        if (compositeCanvas.width !== width || compositeCanvas.height !== height) {
                            compositeCanvas.width = width;
                            compositeCanvas.height = height;
                        }
                        const ctx = compositeCanvas.getContext('2d');
                        ctx.clearRect(0, 0, width, height);
                        ctx.drawImage(capturedLayer.canvas, 0, 0);
                        (_capturedLayer_compositeObj = capturedLayer.compositeObj) === null || _capturedLayer_compositeObj === void 0 ? void 0 : _capturedLayer_compositeObj.draw((0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(compositeCanvas.getContext('2d')));
                        return compositeCanvas;
                    };
                } else image = baseLayer.canvas;
                easelLayers.push({
                    image: image,
                    isVisible: baseLayer.isVisible,
                    opacity: baseLayer.opacity,
                    mixModeStr: baseLayer.mixModeStr,
                    hasClipping: false
                });
            } else {
                // Clipping group — composite all layers into a group canvas
                usedGroupKeys.add(baseIndex);
                if (!this.groupCanvases.has(baseIndex)) this.groupCanvases.set(baseIndex, (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(width, height));
                const groupCanvas = this.groupCanvases.get(baseIndex);
                const capturedBase = baseLayer;
                const capturedClipped = [
                    ...clippedGroup
                ];
                const imageFunc = ()=>{
                    // Ensure correct size
                    if (groupCanvas.width !== width || groupCanvas.height !== height) {
                        groupCanvas.width = width;
                        groupCanvas.height = height;
                    }
                    // Draw base to a temp canvas (used as clip mask)
                    const baseCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(width, height);
                    const baseCtx = baseCanvas.getContext('2d');
                    baseCtx.drawImage(capturedBase.canvas, 0, 0);
                    // Start group with base content
                    const groupCtx = groupCanvas.getContext('2d');
                    groupCtx.clearRect(0, 0, width, height);
                    groupCtx.drawImage(baseCanvas, 0, 0);
                    // Composite each clipped layer, clipped to base alpha
                    for (const clipLayer of capturedClipped){
                        if (!clipLayer.isVisible || clipLayer.opacity === 0) continue;
                        const clipCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(width, height);
                        const clipCtx = clipCanvas.getContext('2d');
                        clipCtx.drawImage(clipLayer.canvas, 0, 0);
                        // Restrict to base alpha
                        clipCtx.globalCompositeOperation = 'destination-in';
                        clipCtx.drawImage(baseCanvas, 0, 0);
                        // Blend into group
                        groupCtx.globalAlpha = clipLayer.opacity;
                        groupCtx.globalCompositeOperation = clipLayer.mixModeStr;
                        groupCtx.drawImage(clipCanvas, 0, 0);
                        groupCtx.globalAlpha = 1;
                        groupCtx.globalCompositeOperation = 'source-over';
                        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(clipCanvas);
                    }
                    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(baseCanvas);
                    return groupCanvas;
                };
                // The whole group is rendered at the base layer's opacity/blend mode
                easelLayers.push({
                    image: imageFunc,
                    isVisible: baseLayer.isVisible,
                    opacity: baseLayer.opacity,
                    mixModeStr: baseLayer.mixModeStr,
                    hasClipping: false
                });
            }
        }
        // Free group canvases no longer needed
        for (const [key, canvas] of this.groupCanvases.entries())if (!usedGroupKeys.has(key)) {
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(canvas);
            this.groupCanvases.delete(key);
        }
        this.easel.setProject({
            width: width,
            height: height,
            layers: easelLayers,
            selection: this.klCanvas.getSelection()
        });
    }
    // if you're not rendering easel for a while
    freeCompositeCanvas() {
        if (this.compositeCanvas) {
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(this.compositeCanvas);
            this.compositeCanvas = undefined;
        }
        for (const canvas of this.groupCanvases.values())(0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(canvas);
        this.groupCanvases.clear();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        // per-group canvases for clipping group compositing (keyed by base layer index)
        this.groupCanvases = new Map();
        this.klCanvas = p.klCanvas;
        this.easel = p.easel;
        this.update();
    }
}




var $f57775de34880207$exports = {};
$f57775de34880207$exports = $parcel$resolve("6rWqS");




class $0bd0e1e89228720f$export$1fda302750a9ba48 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($f57775de34880207$exports))) + "') 0 15, crosshair");
        const transform = this.easel.getTransform();
        const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(transform);
        const p = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        let color = undefined;
        let isDown = [
            'left',
            'right'
        ].includes(e.button);
        if (isDown) {
            this.svgEl.setAttribute('transform', `translate(${e.relX},${e.relY})`);
            this.svgEl.style.opacity = '1';
        } else this.svgEl.style.opacity = '0';
        if (e.type === 'pointerdown' && isDown) {
            color = this.onPick(p);
            this.isDragging = true;
            isDown = true;
        }
        if (e.type === 'pointermove' && isDown) {
            color = this.onPick(p);
            isDown = true;
        }
        if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
            this.onPickEnd();
            this.isDragging = false;
        }
        if (color && isDown) {
            this.previewColor.setAttribute('stroke', (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(color));
            const borderColor = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).testIsWhiteBestContrast(color) ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)';
            this.previewBorder.setAttribute('stroke', borderColor);
        }
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($f57775de34880207$exports))) + "') 0 15, crosshair");
        this.isDragging = false;
        this.svgEl.style.opacity = '0';
    }
    onPointerLeave() {
        if (this.isDragging) return;
        this.svgEl.style.opacity = '0';
    }
    constructor(p){
        this.easel = {};
        this.isDragging = false;
        // ----------------------------------- public -----------------------------------
        this.tempTriggers = [
            'mouse-right',
            'alt'
        ];
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onPick = p.onPick;
        this.onPickEnd = p.onPickEnd;
        //color picker preview circle
        this.previewBorder = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'circle',
            r: '47',
            stroke: 'black',
            'stroke-width': '22',
            fill: 'none'
        });
        this.previewColor = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'circle',
            r: '47',
            stroke: 'black',
            'stroke-width': '20',
            fill: 'none'
        });
        this.svgEl.append(this.previewBorder, this.previewColor);
    }
}



var $2620a7374975e56c$exports = {};
$2620a7374975e56c$exports = $parcel$resolve("gy6aj");




class $b94c0aafb6fba54d$export$9b29623161064b87 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($2620a7374975e56c$exports))) + "') 1 12, crosshair");
        const vTransform = this.easel.getTransform();
        const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(vTransform);
        const p = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        if (e.type === 'pointerdown' && e.button === 'left') this.onFill({
            x: Math.floor(p.x),
            y: Math.floor(p.y)
        });
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($2620a7374975e56c$exports))) + "') 1 12, crosshair");
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onFill = p.onFill;
    }
}





class $317b4db69c17519a$export$11badb1ec62816a1 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor('crosshair');
        const vTransform = this.easel.getTransform();
        const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(vTransform);
        const p = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        if (e.type === 'pointerdown' && e.button === 'left') {
            this.onDown(p, vTransform.angleDeg / 180 * Math.PI);
            this.isDragging = true;
        }
        if (e.type === 'pointermove' && e.button === 'left') this.onMove(p);
        if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
            this.onUp(p);
            this.isDragging = false;
        }
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    getIsLocked() {
        return this.isDragging;
    }
    activate(cursorPos) {
        this.easel.setCursor('crosshair');
        this.isDragging = false;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.isDragging = false;
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onDown = p.onDown;
        this.onMove = p.onMove;
        this.onUp = p.onUp;
    }
}



var $2ea6783c01238ca9$exports = {};
$2ea6783c01238ca9$exports = $parcel$resolve("9SVhx");




class $737d4594390c240a$export$b10c22a3fee9197f {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($2ea6783c01238ca9$exports))) + "') 1 12, crosshair");
        const vTransform = this.easel.getTransform();
        const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(vTransform);
        const p = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        if (e.type === 'pointerdown' && e.button === 'left') this.onDown(p, vTransform.angleDeg / 180 * Math.PI);
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($2ea6783c01238ca9$exports))) + "') 1 12, crosshair");
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onDown = p.onDown;
    }
}





class $065fe39023128955$export$4deed4c512c630c2 {
    // only call through requestAnimationFrame when animationFrameHandle undefined
    movementLoop() {
        if (!this.cornerDirection) {
            if (this.animationFrameHandle) cancelAnimationFrame(this.animationFrameHandle);
            this.animationFrameHandle = undefined;
            this.lastFrameTimestamp = 0;
            return;
        }
        this.animationFrameHandle = requestAnimationFrame(()=>this.movementLoop());
        const now = performance.now();
        const deltaMs = now - this.lastFrameTimestamp;
        const defaultDeltaMs = 1000 / 60;
        const timeFactor = Math.min(deltaMs / defaultDeltaMs, 10);
        this.lastFrameTimestamp = now;
        const transform = this.getTransform();
        transform.x += this.cornerDirection.x * timeFactor;
        transform.y += this.cornerDirection.y * timeFactor;
        this.setTransform(transform);
        this.onRepeatEvent(this.repeatEvent);
    }
    getSpeed(thresholdDelta) {
        return Math.min(thresholdDelta, this.thresholdPx) * 0.4;
    }
    onPointer(event) {
        let isMoving = false;
        this.cornerDirection = {
            x: 0,
            y: 0
        };
        if (this.testCanPan(event.button !== undefined) && event.type === 'pointermove') {
            if (event.relX > this.getEaselSize().width - this.thresholdPx) {
                this.cornerDirection.x -= this.getSpeed(event.relX - (this.getEaselSize().width - this.thresholdPx));
                isMoving = true;
            }
            if (event.relX < this.thresholdPx) {
                this.cornerDirection.x += this.getSpeed(this.thresholdPx - event.relX);
                isMoving = true;
            }
            if (event.relY > this.getEaselSize().height - this.thresholdPx) {
                this.cornerDirection.y -= this.getSpeed(event.relY - (this.getEaselSize().height - this.thresholdPx));
                isMoving = true;
            }
            if (event.relY < this.thresholdPx) {
                this.cornerDirection.y += this.getSpeed(this.thresholdPx - event.relY);
                isMoving = true;
            }
        }
        if (isMoving) {
            if (this.lastFrameTimestamp === 0) this.lastFrameTimestamp = performance.now();
            this.repeatEvent = event;
            this.animationFrameHandle = requestAnimationFrame(()=>this.movementLoop());
        } else this.cornerDirection = undefined;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.thresholdPx = 25;
        this.lastFrameTimestamp = 0;
        this.repeatEvent = {};
        this.getEaselSize = p.getEaselSize;
        this.getTransform = p.getTransform;
        this.setTransform = p.setTransform;
        this.testCanPan = p.testCanPan;
        this.onRepeatEvent = p.onRepeatEvent;
    }
}


class $0d69a1331eb93d66$export$f4821fa73b1145e5 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e, isRepeat) {
        if (this.doPan && !isRepeat) this.cornerPanning.onPointer(e);
        this.easel.setCursor('crosshair');
        const vTransform = this.easel.getTransform();
        const m = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(vTransform);
        const p = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        if (e.type === 'pointerdown' && e.button === 'left') {
            this.onDown(p, vTransform.angleDeg / 180 * Math.PI);
            this.isDragging = true;
        }
        if (e.type === 'pointermove' && e.button === 'left') this.onMove(p);
        if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
            this.onUp(p);
            this.isDragging = false;
        }
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    getIsLocked() {
        return this.isDragging;
    }
    activate(cursorPos) {
        this.easel.setCursor('crosshair');
        this.isDragging = false;
    }
    setPanning(doPan) {
        this.doPan = doPan;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.isDragging = false;
        this.doPan = false;
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onDown = p.onDown;
        this.onMove = p.onMove;
        this.onUp = p.onUp;
        this.cornerPanning = new (0, $065fe39023128955$export$4deed4c512c630c2)({
            getEaselSize: ()=>this.easel.getSize(),
            getTransform: ()=>this.easel.getTargetTransform(),
            setTransform: (transform)=>this.easel.setTransform(transform, true),
            testCanPan: (buttonIsPressed)=>{
                return buttonIsPressed;
            },
            onRepeatEvent: (e)=>{
                this.onPointer(e, true);
            }
        });
    }
}








class $7d88d4eb596d13ba$export$f3b0846760df78b {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor(e.button === 'left' ? 'grabbing' : 'grab');
        if (e.type === 'pointerdown' && e.button === 'left') {
            this.downPos = {
                x: e.relX,
                y: e.relY
            };
            this.downTransform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.easel.getTargetTransform());
        } else if (e.button === 'left' && this.downPos && this.downTransform) {
            const { width: width, height: height } = this.easel.getSize();
            const centerObj = {
                x: width / 2,
                y: height / 2
            };
            const startAngleRad = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.angle(centerObj, this.downPos);
            const newAngleRad = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).Vec2.angle(centerObj, {
                x: e.relX,
                y: e.relY
            });
            const dAngleDeg = (newAngleRad - startAngleRad) / Math.PI * 180;
            let newAngleDeg = this.downTransform.angleDeg + dAngleDeg;
            if (this.easel.isKeyPressed('shift')) newAngleDeg = Math.round(newAngleDeg / 45) * 45;
            newAngleDeg = (0, $9414f5ea41e9cf25$export$ec85425cac357ca9)(newAngleDeg);
            //rotate transform
            const mat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.downTransform);
            const canvasPoint = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(mat), centerObj);
            this.easel.setTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)(centerObj, canvasPoint, this.downTransform.scale, newAngleDeg), !this.easel.isKeyPressed('shift'));
            this.easel.requestRender();
        } else if (e.type === 'pointerup' && this.downPos) {
            this.downPos = undefined;
            this.downTransform = undefined;
        }
    }
    onUpdateTransform(transform) {
        const targetTransform = this.easel.getTargetTransform();
        this.needleWrapper.setAttribute('transform', 'rotate(' + transform.angleDeg + ')');
        this.compassLineCircle.style.opacity = targetTransform.angleDeg % 90 === 0 ? '1' : '0';
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor('grab');
        const { width: width, height: height } = this.easel.getSize();
        this.compass.setAttribute('transform', 'translate(' + width / 2 + ', ' + height / 2 + ')');
        this.onUpdateTransform(this.easel.getTransform());
    }
    onKeyDown(keyStr, event, comboStr) {
        if ([
            'r+left',
            'r+right'
        ].includes(comboStr)) {
            if (keyStr === 'left') this.easel.setAngleDeg(-15, true);
            if (keyStr === 'right') this.easel.setAngleDeg(15, true);
        }
        if ([
            'r+up'
        ].includes(comboStr)) this.easel.setAngleDeg(0, false);
    }
    onResize(width, height) {
        this.compass.setAttribute('transform', 'translate(' + width / 2 + ', ' + height / 2 + ')');
    }
    constructor(p){
        this.easel = {};
        this.downPos = undefined;
        // ----------------------------------- public -----------------------------------
        this.tempTriggers = [
            'r'
        ];
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        //rotation compass
        this.compassSize = 30;
        this.compass = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.compass, {
            transition: 'opacity 0.25s ease-in-out'
        });
        this.compassInner = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.compassBaseCircle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'circle',
            fill: 'rgba(0,0,0,0.9)',
            stroke: 'none',
            cx: '0',
            cy: '0',
            r: '' + this.compassSize
        });
        this.compassLineCircle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'circle',
            fill: 'none',
            stroke: 'rgba(255,255,255,0.75)',
            'stroke-width': '1',
            cx: '0',
            cy: '0',
            r: '' + this.compassSize * 0.9
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.compassLineCircle, {
            transition: 'opacity 0.1s ease-in-out'
        });
        this.needleWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g',
            'transform-origin': '0 0'
        });
        this.compassUpperTriangle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'path',
            fill: '#f00',
            stroke: 'none',
            d: 'M -' + this.compassSize * 0.25 + ',0 ' + this.compassSize * 0.25 + ',0 0,-' + this.compassSize * 0.9 + ' z'
        });
        this.compassLowerTriangle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'path',
            fill: '#fff',
            stroke: 'none',
            d: 'M -' + this.compassSize * 0.25 + ',0 ' + this.compassSize * 0.25 + ',0 0,' + this.compassSize * 0.9 + ' z'
        });
        this.needleWrapper.append(this.compassUpperTriangle, this.compassLowerTriangle);
        this.compassInner.append(this.compassBaseCircle, this.compassLineCircle, this.needleWrapper);
        this.compass.append(this.compassInner);
        this.svgEl.append(this.compass);
    }
}



var $25a553072a0e8a1f$exports = {};
$25a553072a0e8a1f$exports = $parcel$resolve("5mHop");





class $44d9d077b3aa143c$export$6c389c8425707374 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($25a553072a0e8a1f$exports))) + "') 7 7, zoom-in");
        if (e.type === 'pointerdown' && [
            'left'
        ].includes(e.button)) {
            this.downPos = {
                x: e.relX,
                y: e.relY
            };
            this.downTransform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.easel.getTransform());
        }
        if (e.type === 'pointermove' && [
            'left'
        ].includes(e.button) && this.downPos && this.downTransform) {
            const viewportPoint = this.downPos;
            const mat = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.downTransform);
            const canvasPoint = (0, $855520c81dfcb96a$export$9b20165a36586806)((0, $077740f52fe6870e$export$70ae2c07e401031b)(mat), viewportPoint);
            const dX = e.relX - this.downPos.x;
            const newScale = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).clamp(this.downTransform.scale * Math.pow(1 + 1 / 400, dX), this.easel.minScale, this.easel.maxScale);
            this.easel.setTransform((0, $68a5ab3e745a3a87$export$99c68a89351e15c0)(viewportPoint, canvasPoint, newScale, this.downTransform.angleDeg), true);
            this.easel.requestRender();
        }
        if (e.type === 'pointerup' && e.button === undefined) {
            this.downPos = undefined;
            this.downTransform = undefined;
        }
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($25a553072a0e8a1f$exports))) + "') 7 7, zoom-in");
    }
    constructor(p){
        this.easel = {};
        this.downPos = undefined;
        // ----------------------------------- public -----------------------------------
        this.tempTriggers = [
            'z'
        ];
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
    }
}






var $e14946753ad377e3$exports = {};
$e14946753ad377e3$exports = $parcel$resolve("6WP3U");


var $becee295081a3fa9$exports = {};
$becee295081a3fa9$exports = $parcel$resolve("hNYGT");



var $15ecc27dd88d5ab1$exports = {};
$15ecc27dd88d5ab1$exports = $parcel$resolve("lU1xy");


var $a6f29d5eb2004776$exports = {};
$a6f29d5eb2004776$exports = $parcel$resolve("d4ONi");


var $8915f4d9d327a3ba$exports = {};
$8915f4d9d327a3ba$exports = $parcel$resolve("efKXt");


var $742817cefa663d54$exports = {};
$742817cefa663d54$exports = $parcel$resolve("iG2IE");


var $67fed947ea9fa458$exports = {};
$67fed947ea9fa458$exports = $parcel$resolve("heTsK");


var $e5e249ddf082f14c$exports = {};
$e5e249ddf082f14c$exports = $parcel$resolve("bXno8");


var $529fdcde1dab71dc$exports = {};
$529fdcde1dab71dc$exports = $parcel$resolve("4BXSU");




var $cc941ca9a002a767$exports = {};
$cc941ca9a002a767$exports = $parcel$resolve("g8wiX");









class $d49d366dcf65e875$export$f04a61298a47a40f {
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: p.darkInvert ? 'dark-invert' : '',
            css: (0, $0616f0a0655c1023$export$71511d61b312f219)({
                backgroundImage: `url("${p.imageUrl}")`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: p.width + 'px',
                height: p.height + 'px'
            }, p.css)
        });
    }
}





function $8d3b291d55b109e6$export$b9cf8e4fed0549e8() {
    let webgl2IsSupported = false;
    const canvas = (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)();
    try {
        const gl = canvas.getContext('webgl2');
        webgl2IsSupported = gl !== null;
    } catch (_) {
    // noop
    }
    (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(canvas);
    return webgl2IsSupported;
}
class $8d3b291d55b109e6$export$382d1cdfd2c9e133 {
    compileShader(source, type) {
        const shader = this.gl.createShader(type);
        if (!shader) return null;
        this.gl.shaderSource(shader, source);
        this.gl.compileShader(shader);
        if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
            console.error('Shader compile error:', this.gl.getShaderInfoLog(shader));
            this.gl.deleteShader(shader);
            return null;
        }
        return shader;
    }
    createProgram() {
        const vertexShaderSource = `#version 300 es
            in vec2 a_position;
            in vec2 a_texCoord;
            out vec2 v_texCoord;
            void main() {
                gl_Position = vec4(a_position, 0.0, 1.0);
                v_texCoord = a_texCoord;
            }
        `;
        const fragmentShaderSource = `#version 300 es
            precision mediump float;
            in vec2 v_texCoord;
            out vec4 outColor;
            uniform sampler2D u_texture;
            void main() {
                outColor = texture(u_texture, v_texCoord);
            }
        `;
        const vertexShader = this.compileShader(vertexShaderSource, this.gl.VERTEX_SHADER);
        if (!vertexShader) throw new Error('Failed to compile vertex shader');
        const fragmentShader = this.compileShader(fragmentShaderSource, this.gl.FRAGMENT_SHADER);
        if (!fragmentShader) throw new Error('Failed to compile fragment shader');
        this.program = this.gl.createProgram();
        this.gl.attachShader(this.program, vertexShader);
        this.gl.attachShader(this.program, fragmentShader);
        this.gl.linkProgram(this.program);
        if (!this.gl.getProgramParameter(this.program, this.gl.LINK_STATUS)) {
            console.error('Program link error:', this.gl.getProgramInfoLog(this.program));
            throw new Error('Failed to link program');
        }
        this.gl.deleteShader(vertexShader);
        this.gl.deleteShader(fragmentShader);
        this.gl.useProgram(this.program);
        this.positionLocation = this.gl.getAttribLocation(this.program, 'a_position');
        this.texCoordLocation = this.gl.getAttribLocation(this.program, 'a_texCoord');
        this.textureLocation = this.gl.getUniformLocation(this.program, 'u_texture');
        this.gl.useProgram(null);
    }
    createMultisampleFramebuffer() {
        const gl = this.gl;
        const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
        this.msaaSamples = Math.min(maxSamples, 8);
        this.multisampleRenderbuffer = gl.createRenderbuffer();
        gl.bindRenderbuffer(gl.RENDERBUFFER, this.multisampleRenderbuffer);
        gl.renderbufferStorageMultisample(gl.RENDERBUFFER, this.msaaSamples, gl.RGBA8, this.canvas.width, this.canvas.height);
        this.multisampleFramebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.multisampleFramebuffer);
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, this.multisampleRenderbuffer);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindRenderbuffer(gl.RENDERBUFFER, null);
    }
    detectAnisotropicFiltering() {
        // Check for anisotropic filtering extension
        this.anisotropicExtension = this.gl.getExtension('EXT_texture_filter_anisotropic') || this.gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || this.gl.getExtension('MOZ_EXT_texture_filter_anisotropic');
        if (this.anisotropicExtension) this.maxAnisotropy = this.gl.getParameter(this.anisotropicExtension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    }
    /**
     * Creates a mesh (vertex array object)
     * @param positions - x,y positions in clip space top-left: (-1,1), bottom-right: (1,-1)
     * @param texCoords - u,v texture coordinates top-left: (0,0), bottom-right: (1,1)
     * @param indices - indices specifying triangles
     */ createMesh(positions, texCoords, indices) {
        const vao = this.gl.createVertexArray();
        this.gl.bindVertexArray(vao);
        const positionBuffer = this.gl.createBuffer();
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, positionBuffer);
        this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array(positions), this.gl.STATIC_DRAW);
        this.gl.enableVertexAttribArray(this.positionLocation);
        this.gl.vertexAttribPointer(this.positionLocation, 2, this.gl.FLOAT, false, 0, 0);
        const texCoordBuffer = this.gl.createBuffer();
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, texCoordBuffer);
        this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array(texCoords), this.gl.STATIC_DRAW);
        this.gl.enableVertexAttribArray(this.texCoordLocation);
        this.gl.vertexAttribPointer(this.texCoordLocation, 2, this.gl.FLOAT, false, 0, 0);
        const indexBuffer = this.gl.createBuffer();
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
        this.gl.bufferData(this.gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), this.gl.STATIC_DRAW);
        const id = this.nextMeshId++;
        this.meshes.set(id, {
            id: id,
            vao: vao,
            positionBuffer: positionBuffer,
            texCoordBuffer: texCoordBuffer,
            indexBuffer: indexBuffer,
            indexCount: indices.length
        });
        return {
            id: id,
            destroy: ()=>this.destroyMesh(id)
        };
    }
    destroyMesh(id) {
        const mesh = this.meshes.get(id);
        if (mesh) {
            this.gl.deleteVertexArray(mesh.vao);
            this.gl.deleteBuffer(mesh.positionBuffer);
            this.gl.deleteBuffer(mesh.texCoordBuffer);
            this.gl.deleteBuffer(mesh.indexBuffer);
            this.meshes.delete(id);
        }
    }
    createTexture(source) {
        const texture = this.gl.createTexture();
        this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
        if (source instanceof HTMLImageElement || source instanceof HTMLCanvasElement) this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA8, this.gl.RGBA, this.gl.UNSIGNED_BYTE, source);
        else this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA8, source.width, source.height, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, source.data);
        // texture filtering
        if (this.interpolation === 'pixelated') {
            this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.NEAREST);
            this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.NEAREST);
        } else {
            this.gl.generateMipmap(this.gl.TEXTURE_2D);
            this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR_MIPMAP_LINEAR);
            this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);
            if (this.anisotropicExtension) this.gl.texParameterf(this.gl.TEXTURE_2D, this.anisotropicExtension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(this.maxAnisotropy, 8));
        }
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
        const id = this.nextTextureId++;
        this.textures.set(id, {
            id: id,
            texture: texture
        });
        return {
            id: id,
            destroy: ()=>this.destroyTexture(id)
        };
    }
    destroyTexture(id) {
        const texture = this.textures.get(id);
        if (texture) {
            this.gl.deleteTexture(texture.texture);
            this.textures.delete(id);
        }
    }
    clear() {
        var _this_multisampleFramebuffer;
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, (_this_multisampleFramebuffer = this.multisampleFramebuffer) !== null && _this_multisampleFramebuffer !== void 0 ? _this_multisampleFramebuffer : null);
        this.gl.clearColor(0, 0, 0, 0);
        this.gl.clear(this.gl.COLOR_BUFFER_BIT);
    }
    draw(mesh, texture) {
        const meshData = this.meshes.get(mesh.id);
        const textureData = this.textures.get(texture.id);
        if (!meshData || !textureData) throw new Error('Invalid mesh or texture');
        var _this_multisampleFramebuffer;
        // null -> directly onto the canvas
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, (_this_multisampleFramebuffer = this.multisampleFramebuffer) !== null && _this_multisampleFramebuffer !== void 0 ? _this_multisampleFramebuffer : null);
        this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
        this.gl.useProgram(this.program);
        this.gl.bindVertexArray(meshData.vao);
        this.gl.activeTexture(this.gl.TEXTURE0);
        this.gl.bindTexture(this.gl.TEXTURE_2D, textureData.texture);
        this.gl.uniform1i(this.textureLocation, 0);
        this.gl.drawElements(this.gl.TRIANGLES, meshData.indexCount, this.gl.UNSIGNED_SHORT, 0);
    }
    present() {
        if (!this.multisampleFramebuffer) // pixelated: already drew directly to canvas
        return;
        // Resolve the multisample FBO to the canvas by blitting.
        const gl = this.gl;
        const w = this.canvas.width;
        const h = this.canvas.height;
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.multisampleFramebuffer);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null); // canvas
        gl.blitFramebuffer(0, 0, w, h, 0, 0, w, h, gl.COLOR_BUFFER_BIT, gl.NEAREST);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    }
    getCanvas() {
        return this.canvas;
    }
    isContextLost() {
        // Yes, every browser supports this for WebGL2RenderingContext.
        return this.gl.isContextLost();
    }
    destroy() {
        for (const [id] of this.meshes)this.destroyMesh(id);
        for (const [id] of this.textures)this.destroyTexture(id);
        if (this.multisampleFramebuffer) {
            this.gl.deleteFramebuffer(this.multisampleFramebuffer);
            this.multisampleFramebuffer = null;
        }
        if (this.multisampleRenderbuffer) {
            this.gl.deleteRenderbuffer(this.multisampleRenderbuffer);
            this.multisampleRenderbuffer = null;
        }
        if (this.program) this.gl.deleteProgram(this.program);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(this.canvas);
    }
    // ----------------------------------- public -----------------------------------
    constructor(canvas, interpolation = 'smooth'){
        this.program = null;
        this.positionLocation = -1;
        this.texCoordLocation = -1;
        this.textureLocation = null;
        this.meshes = new Map();
        this.textures = new Map();
        this.nextMeshId = 1;
        this.nextTextureId = 1;
        this.anisotropicExtension = null;
        this.maxAnisotropy = 1;
        this.multisampleFramebuffer = null;
        this.multisampleRenderbuffer = null;
        this.msaaSamples = 0;
        this.canvas = canvas;
        this.interpolation = interpolation;
        const gl = canvas.getContext('webgl2', {
            alpha: true,
            // All textures and framebuffers have premultiplied alpha
            premultipliedAlpha: true,
            // we manually handle MSAA via a framebuffer
            antialias: false
        });
        if (!gl) throw new Error('WebGL2 not supported');
        // init
        this.gl = gl;
        this.createProgram();
        if (this.interpolation === 'smooth') {
            this.detectAnisotropicFiltering();
            this.createMultisampleFramebuffer();
        }
        // we always want textures with premultiplied alpha
        this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        // we always want blending
        this.gl.enable(this.gl.BLEND);
        this.gl.blendFunc(this.gl.ONE, this.gl.ONE_MINUS_SRC_ALPHA);
    }
}


function $726e24f56af72b92$var$getAlgorithmIconDataUrl() {
    const canvas = (0, $9f64dcf89d8f9132$export$cd3d1f114b139967)(3, 3);
    const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
    ctx.fillRect(0, 0, 1, 1);
    ctx.fillRect(2, 0, 1, 1);
    ctx.fillRect(1, 1, 1, 1);
    ctx.fillRect(0, 2, 1, 1);
    ctx.fillRect(2, 2, 1, 1);
    return canvas.toDataURL('image/png');
}
class $726e24f56af72b92$export$b3e6ed306341f794 {
    update() {
        this.selectResetBtn.style.display = this.hasSelection ? 'block' : 'none';
    }
    setIsVisible(isVisible) {
        this.isVisible = isVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) this.operationOptions.setValue('new');
    }
    setMode(mode) {
        this.modeOptions.setValue(mode);
    }
    setLayers(layers) {
        this.moveToLayerSelect.setOptionArr(layers.map((layer, index)=>{
            return [
                '' + index,
                layer
            ];
        }).reverse());
    }
    setMoveToLayer(targetIndex) {
        this.moveToLayerSelect.setValue(targetIndex === undefined ? undefined : '' + targetIndex);
    }
    setHasSelection(b) {
        this.hasSelection = b;
        this.update();
    }
    setBackgroundIsTransparent(b) {
        this.transparentBackgroundToggle.setValue(b);
    }
    setAlgorithm(algorithm) {
        this.algorithmOptions.setValue(algorithm);
    }
    setFreeTransformTransformation(transform) {
        const x = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(transform.x, 0);
        const y = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(transform.y, 0);
        const rotation = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).round(transform.angleDeg, 0);
        this.positionOutput.innerText = `X:${x} Y:${y} ${(0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-rotation')}:${rotation}\xb0`;
    }
    setShowTransparentBackgroundToggle(show) {
        this.transparentBackgroundToggle.getElement().style.display = show ? 'block' : 'none';
    }
    setIsWarping(isWarping) {
        this.warpCheckbox.setValue(isWarping);
        this.constrainCheckbox.setEnabled(!isWarping);
        this.snappingCheckbox.setEnabled(!isWarping);
    }
    getIsWarping() {
        return this.warpCheckbox.getValue();
    }
    getAlgorithm() {
        return this.algorithmOptions.getValue();
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
    // ...
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isVisible = true;
        this.hasSelection = false;
        this.onChangeMode = p.onChangeMode;
        this.modeOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'select',
                    label: (0, $934e5f47c3374e21$export$db3b6bfb95261072)('', [
                        (0, $934e5f47c3374e21$export$db3b6bfb95261072)({
                            content: "<img class='dark-invert' src='" + (0, (/*@__PURE__*/$parcel$interopDefault($e14946753ad377e3$exports))) + "' height='20'/>" + '<span>' + (0, $63d0b335c576c718$export$ce37e184d908d785)('select-select') + '</span>',
                            css: {
                                display: 'flex',
                                gap: '5px',
                                alignItems: 'center',
                                height: '100%',
                                margin: '10px 4px',
                                justifyContent: 'center'
                            }
                        })
                    ])
                },
                {
                    id: 'transform',
                    label: (0, $934e5f47c3374e21$export$db3b6bfb95261072)('', [
                        (0, $934e5f47c3374e21$export$db3b6bfb95261072)({
                            content: "<img class='dark-invert' src='" + (0, (/*@__PURE__*/$parcel$interopDefault($becee295081a3fa9$exports))) + "' height='20'/>" + '<span>' + (0, $63d0b335c576c718$export$ce37e184d908d785)('select-transform') + '</span>',
                            css: {
                                display: 'flex',
                                gap: '5px',
                                alignItems: 'center',
                                height: '100%',
                                margin: '10px 4px',
                                justifyContent: 'center'
                            }
                        })
                    ])
                }
            ],
            initId: 'select',
            onChange: (val)=>{
                if (val === 'select') this.operationOptions.setValue('new');
                updateMode();
            },
            onBeforeChange: (val)=>{
                // change to "transform" can be rejected if selection is empty
                return this.onChangeMode(val);
            },
            optionCss: {
                flexGrow: '1',
                flexBasis: '0'
            },
            css: {
                marginBottom: '10px'
            }
        });
        // --- select ---
        const selectModeEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const defaultIm = new Image();
        defaultIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($15ecc27dd88d5ab1$exports)));
        defaultIm.classList.add('dark-invert');
        const unionIm = new Image();
        unionIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($a6f29d5eb2004776$exports)));
        unionIm.classList.add('dark-invert');
        const subtractIm = new Image();
        subtractIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($8915f4d9d327a3ba$exports)));
        subtractIm.classList.add('dark-invert');
        this.operationOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'new',
                    label: defaultIm,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-boolean-replace')
                },
                {
                    id: 'union',
                    label: unionIm,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-boolean-add')
                },
                {
                    id: 'difference',
                    label: subtractIm,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-boolean-subtract')
                }
            ],
            initId: 'new',
            onChange: (v)=>{
                p.onChangeBooleanOperation(v);
            },
            css: {
                marginBottom: '10px'
            }
        });
        const imStyle = {
            width: '32px',
            height: '32px'
        };
        const rectIm = new Image();
        rectIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($742817cefa663d54$exports)));
        rectIm.classList.add('dark-invert');
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(rectIm, imStyle);
        const ellipseIm = new Image();
        ellipseIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($67fed947ea9fa458$exports)));
        ellipseIm.classList.add('dark-invert');
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(ellipseIm, imStyle);
        const lassoIm = new Image();
        lassoIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($e5e249ddf082f14c$exports)));
        lassoIm.classList.add('dark-invert');
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(lassoIm, imStyle);
        const polyIm = new Image();
        polyIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($529fdcde1dab71dc$exports)));
        polyIm.classList.add('dark-invert');
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(polyIm, imStyle);
        const shapeOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'rect',
                    label: rectIm,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-rect')
                },
                {
                    id: 'ellipse',
                    label: ellipseIm,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('shape-ellipse')
                },
                {
                    id: 'lasso',
                    label: lassoIm,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-lasso')
                },
                {
                    id: 'poly',
                    label: polyIm,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-polygon')
                }
            ],
            initId: p.select.shape,
            onChange: (val)=>{
                p.select.onChangeShape(val);
            },
            css: {
                marginBottom: '10px'
            }
        });
        selectModeEl.append(shapeOptions.getElement(), this.operationOptions.getElement());
        const actionRow = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: selectModeEl,
            css: {
                display: 'flex',
                gap: '5px',
                flexWrap: 'wrap'
            }
        });
        const selectAllBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: actionRow,
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-all'),
            onClick: ()=>{
                p.select.onAll();
            },
            custom: {
                tabindex: '-1'
            },
            css: {
                minHeight: '30px'
            }
        });
        const selectInvertBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: actionRow,
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-invert'),
            onClick: ()=>{
                p.select.onInvert();
            },
            custom: {
                tabindex: '-1'
            },
            css: {
                minHeight: '30px'
            }
        });
        this.selectResetBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: actionRow,
            tagName: 'button',
            content: [
                (0, $52ad4d7a7d6372c1$export$ec664d7487540b)({
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($03e87c70019af696$exports))),
                    alt: 'icon',
                    height: 20,
                    css: {
                        marginRight: '3px',
                        filter: 'invert(1)'
                    }
                }),
                (0, $63d0b335c576c718$export$ce37e184d908d785)('select-reset')
            ],
            className: 'kl-button kl-button-primary',
            css: {
                paddingRight: '8px',
                display: 'none'
            },
            onClick: ()=>{
                p.select.onReset();
            },
            custom: {
                tabindex: '-1'
            }
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'grid-hr',
            parent: selectModeEl,
            css: {
                margin: '10px 0'
            }
        });
        const actionsWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: selectModeEl,
            css: {
                display: 'flex',
                gap: '5px'
            }
        });
        const eraseBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: actionsWrapper,
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-erase'),
            onClick: ()=>{
                p.onErase();
            },
            custom: {
                tabindex: '-1'
            }
        });
        const fillBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: actionsWrapper,
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-fill'),
            onClick: ()=>{
                p.onFill();
            },
            custom: {
                tabindex: '-1'
            }
        });
        // --- transform ---
        const transformModeEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
            }
        });
        this.positionOutput = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                fontFamily: 'monospace',
                fontSize: '13px'
            }
        });
        transformModeEl.append(this.positionOutput);
        const transformFlipXBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-flip') + ' X',
            className: 'kl-button',
            onClick: ()=>{
                p.transform.onFlipX();
            },
            custom: {
                tabindex: '-1'
            }
        });
        const transformFlipYBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-flip') + ' Y',
            onClick: ()=>{
                p.transform.onFlipY();
            },
            custom: {
                tabindex: '-1'
            }
        });
        const rotateNegativeBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: "-90\xb0",
            onClick: ()=>{
                p.transform.onRotateDeg(-90);
            },
            custom: {
                tabindex: '-1'
            }
        });
        const rotatePositiveBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: "+90\xb0",
            onClick: ()=>{
                p.transform.onRotateDeg(90);
            },
            custom: {
                tabindex: '-1'
            }
        });
        const duplicateIcon = new (0, $d49d366dcf65e875$export$f04a61298a47a40f)({
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($0ecce9fc138ec1e3$exports))),
            width: 20,
            height: 20,
            darkInvert: true
        });
        const transformDuplicateBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: [
                duplicateIcon.getElement(),
                (0, $63d0b335c576c718$export$ce37e184d908d785)('select-transform-clone')
            ],
            onClick: ()=>{
                p.transform.onClone();
            },
            css: {
                display: 'flex',
                gap: '5px'
            },
            custom: {
                tabindex: '-1'
            }
        });
        const scaleDoubleBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: '2&times;',
            onClick: ()=>{
                p.transform.onScale(2);
            },
            custom: {
                tabindex: '-1'
            }
        });
        const scaleHalfBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: '&frac12;&times;',
            onClick: ()=>{
                p.transform.onScale(0.5);
            },
            custom: {
                tabindex: '-1'
            }
        });
        const centerBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('center'),
            onClick: ()=>{
                p.transform.onCenter();
            },
            custom: {
                tabindex: '-1'
            }
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: transformModeEl,
            content: [
                transformDuplicateBtn,
                transformFlipXBtn,
                transformFlipYBtn,
                rotateNegativeBtn,
                rotatePositiveBtn,
                scaleDoubleBtn,
                scaleHalfBtn,
                centerBtn
            ],
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '5px'
            }
        });
        this.constrainCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-constrain'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('constrain-proportions'),
            callback: function(b) {
                p.transform.onChangeConstrain(b);
            },
            css: {
                display: 'inline-block'
            },
            name: 'constrain-proportions'
        });
        this.snappingCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-snap'),
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('filter-transform-snap-title'),
            callback: function(b) {
                p.transform.onChangeSnapping(b);
            },
            css: {
                display: 'inline-block',
                marginLeft: '10px'
            },
            name: 'enable-snapping'
        });
        this.warpCheckbox = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            init: false,
            isEnabled: (0, $8d3b291d55b109e6$export$b9cf8e4fed0549e8)(),
            label: `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($cc941ca9a002a767$exports)))}" class="dark-invert" height="23">` + (0, $63d0b335c576c718$export$ce37e184d908d785)('select-transform-warp'),
            callback: (b)=>{
                p.transform.onChangeWarp(b);
                // Disable constrain and snapping checkboxes when warping
                this.constrainCheckbox.setEnabled(!b);
                this.snappingCheckbox.setEnabled(!b);
            },
            css: {
                width: 'fit-content'
            },
            name: 'transform-warp'
        });
        transformModeEl.append(this.warpCheckbox.getElement());
        const checkboxWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        checkboxWrapper.append(this.constrainCheckbox.getElement(), this.snappingCheckbox.getElement());
        transformModeEl.append(checkboxWrapper);
        const iconSmooth = new Image();
        iconSmooth.src = $726e24f56af72b92$var$getAlgorithmIconDataUrl();
        iconSmooth.className = 'dark-invert';
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(iconSmooth, {
            width: '20px',
            height: '20px',
            margin: '4px'
        });
        const iconPixelated = new Image();
        iconPixelated.src = iconSmooth.src;
        iconPixelated.className = 'dark-invert';
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(iconPixelated, {
            width: '20px',
            height: '20px',
            margin: '4px',
            imageRendering: 'pixelated'
        });
        this.algorithmOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'smooth',
                    label: iconSmooth,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('algorithm-smooth')
                },
                {
                    id: 'pixelated',
                    label: iconPixelated,
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('algorithm-pixelated')
                }
            ],
            onChange: (algorithm)=>{
                p.transform.onChangeAlgorithm(algorithm);
            }
        });
        transformModeEl.append(this.algorithmOptions.getElement());
        this.moveToLayerSelect = new (0, $b1ef42bd443626ca$export$ef9b1a59e592288f)({
            optionArr: [
                [
                    '1',
                    'Layer 2'
                ],
                [
                    '0',
                    'Layer 1'
                ]
            ],
            onChange: (val)=>{
                p.transform.onMoveToLayer(+val);
            },
            name: 'move-to-layer',
            css: {
                width: '100%'
            }
        });
        transformModeEl.append((0, $934e5f47c3374e21$export$db3b6bfb95261072)(',flex,items-center,gap-5,flexWrap', [
            (0, $63d0b335c576c718$export$ce37e184d908d785)('select-transform-move-to-layer'),
            this.moveToLayerSelect.getElement()
        ]));
        this.transparentBackgroundToggle = new (0, $213947897b67ec3a$export$48513f6b9f8ce62d)({
            label: (0, $63d0b335c576c718$export$ce37e184d908d785)('brush-eraser-transparent-bg'),
            callback: (b)=>{
                p.transform.onChangeTransparentBackground(b);
            },
            name: 'enable-transparent-background'
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.transparentBackgroundToggle.getElement(), {
            display: 'inline-block'
        });
        transformModeEl.append(this.transparentBackgroundToggle.getElement());
        const updateMode = ()=>{
            if (this.modeOptions.getValue() === 'select') {
                this.rootEl.append(selectModeEl);
                transformModeEl.remove();
            } else {
                selectModeEl.remove();
                this.rootEl.append(transformModeEl);
            }
        };
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: [
                this.modeOptions.getElement()
            ],
            css: {
                margin: '10px'
            }
        });
        updateMode();
    }
}









function $824d08e9579aaba6$export$eca13ebc72c99beb(rect, viewportTransform, easelSize, padding = 0) {
    const rectCenterX = rect.x + rect.width / 2;
    const rectCenterY = rect.y + rect.height / 2;
    // compute AABB of the rotated rect in viewport space
    const angleRad = viewportTransform.angleDeg / 180 * Math.PI;
    const cos = Math.abs(Math.cos(angleRad));
    const sin = Math.abs(Math.sin(angleRad));
    const aabbWidth = (rect.width * cos + rect.height * sin) * viewportTransform.scale;
    const aabbHeight = (rect.width * sin + rect.height * cos) * viewportTransform.scale;
    const matrix = (0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(viewportTransform);
    const centerInViewport = (0, $855520c81dfcb96a$export$9b20165a36586806)(matrix, {
        x: rectCenterX,
        y: rectCenterY
    });
    const halfW = aabbWidth / 2;
    const halfH = aabbHeight / 2;
    return centerInViewport.x - halfW >= padding && centerInViewport.x + halfW <= easelSize.width - padding && centerInViewport.y - halfH >= padding && centerInViewport.y + halfH <= easelSize.height - padding;
}










const $4c7f3f5331b420df$var$FFD_DEBUG = false;
const $4c7f3f5331b420df$var$operationToCursor = {
    new: 'default',
    union: 'copy',
    difference: 'alias'
};
class $4c7f3f5331b420df$export$24961ed376c522a3 {
    viewportToCanvas(p) {
        const matrix = (0, $077740f52fe6870e$export$70ae2c07e401031b)((0, $00bfc001d6438b5d$export$ad1d215dd03fe75a)(this.easel.getTransform()));
        return (0, $855520c81dfcb96a$export$9b20165a36586806)(matrix, p);
    }
    updateSelectionPath() {
        this.selectionPath = (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(this.canvasSelection);
    }
    resetPolyShape() {
        if (this.polyShape.length === 0) return false;
        this.polyShape = [];
        this.doubleTapPointerTypes = [
            'touch'
        ];
        this.easel.updateDoubleTapPointerTypes();
        this.easel.requestRender(); // because polyShape might have changed
        return true;
    }
    /** boolean operation if you also consider keys */ getEffectiveBooleanOperation() {
        const isSubtract = this.defaultBooleanOperation === 'new' ? this.easel.keyListener.isPressed('alt') : this.defaultBooleanOperation === 'difference';
        const isAdd = this.defaultBooleanOperation === 'new' ? this.easel.keyListener.isPressed('shift') : this.defaultBooleanOperation === 'union';
        if (isSubtract) return 'difference';
        if (isAdd) return 'union';
        return 'new';
    }
    getDoMoveSelection(effectiveOperation, cursorCanvasPos) {
        const isOverSelection = this.polyShape.length < 2 && this.selectionPath && this.tempCtx.isPointInPath(this.selectionPath, cursorCanvasPos.x, cursorCanvasPos.y);
        return effectiveOperation === 'new' && isOverSelection;
    }
    // can be repeatedly called with the same event
    selectOnPointer(event) {
        const effectiveOperation = this.getEffectiveBooleanOperation();
        const wasDragging = this.isDragging;
        const cursorCanvasPos = this.viewportToCanvas({
            x: event.relX,
            y: event.relY
        });
        const doMove = this.getDoMoveSelection(effectiveOperation, cursorCanvasPos);
        if (event.type === 'pointerdown') {
            this.isDragging = true;
            if (doMove) this.selectSelectMode = 'move';
            else this.selectSelectMode = 'select';
        }
        if (event.type === 'pointerup') this.isDragging = false;
        if (this.selectSelectMode === 'move') {
            if (event.type === 'pointerdown' && event.button === 'left') {
                this.didSelectionMove = false;
                this.onStartMoveSelect(cursorCanvasPos);
            }
            if (event.type === 'pointermove' && event.button === 'left') {
                this.didSelectionMove = true;
                this.onGoMoveSelect(cursorCanvasPos, this.easel.keyListener.isPressed('shift'));
            }
            if (event.type === 'pointerup') {
                this.onEndMoveSelect();
                if (!this.didSelectionMove) this.onResetSelection();
            }
        } else // select
        if (this.selectShape === 'poly') {
            if (event.type === 'pointermove') {
                var _this_polyShape_;
                if ((_this_polyShape_ = this.polyShape[this.polyShape.length - 1]) === null || _this_polyShape_ === void 0 ? void 0 : _this_polyShape_.temp) this.polyShape.pop();
                this.polyShape.push((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, cursorCanvasPos), {
                    temp: true
                }));
                this.easel.requestRender();
            }
            if (event.type === 'pointerup' && wasDragging) {
                var _this_polyShape_1;
                if (this.polyShape.length < 2) this.appliedBooleanOperation = effectiveOperation;
                this.doubleTapPointerTypes = [];
                this.easel.updateDoubleTapPointerTypes();
                if ((_this_polyShape_1 = this.polyShape[this.polyShape.length - 1]) === null || _this_polyShape_1 === void 0 ? void 0 : _this_polyShape_1.temp) this.polyShape.pop();
                const lastPolyShapePoint = this.polyShape[this.polyShape.length - 1];
                if (!lastPolyShapePoint || cursorCanvasPos.x !== lastPolyShapePoint.x || cursorCanvasPos.y !== lastPolyShapePoint.y) {
                    this.polyShape.push(cursorCanvasPos);
                    this.easel.requestRender();
                }
                const first = this.polyShape[0];
                const last = this.polyShape[this.polyShape.length - 1];
                if (this.polyShape.length > 2 && (0, $d9f9f4926aa80a1c$export$921068d8846a1559).dist(first.x, first.y, last.x, last.y) * this.viewportTransform.scale < 4) {
                    this.polyShape.pop();
                    this.polyShape.push((0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.polyShape[0]));
                    const shape = this.polyShape;
                    this.polyShape = [];
                    this.onSelectAddPoly(shape, this.appliedBooleanOperation);
                    this.appliedBooleanOperation = undefined;
                }
            }
        } else {
            if (event.type === 'pointerdown' && event.button === 'left') {
                this.appliedBooleanOperation = effectiveOperation;
                this.onStartSelect(cursorCanvasPos, this.appliedBooleanOperation);
            }
            if (event.type === 'pointermove' && event.button === 'left' && this.isDragging) this.onGoSelect(cursorCanvasPos, this.easel.keyListener.isPressed('shift'));
            if (event.type === 'pointerup' && wasDragging) {
                this.onEndSelect();
                this.appliedBooleanOperation = undefined;
            }
        }
        if (!event.button) {
            if (doMove) this.selectSelectMode = 'move';
            else this.selectSelectMode = 'select';
        }
        var _this_appliedBooleanOperation;
        if (this.selectSelectMode === 'move') this.easel.setCursor('move');
        else this.easel.setCursor($4c7f3f5331b420df$var$operationToCursor[(_this_appliedBooleanOperation = this.appliedBooleanOperation) !== null && _this_appliedBooleanOperation !== void 0 ? _this_appliedBooleanOperation : effectiveOperation]);
    }
    // can be repeatedly called with the same event
    transformOnPointer(event) {
        if (!this.transformation || this.transformation.type !== 'ffd' || !this.ffdMesh) {
            this.easel.setCursor('default');
            // handled via this.freeTransform
            return;
        }
        // warping
        const cursorCanvasPos = this.viewportToCanvas({
            x: event.relX,
            y: event.relY
        });
        const parametricCoordinate = (0, $dd7061603b95efc4$export$2d232ae0b526c96b)(cursorCanvasPos.x, cursorCanvasPos.y, this.ffdMesh);
        if (event.type === 'pointerdown' && event.button === 'left') {
            if (parametricCoordinate) {
                this.warpStart = {
                    parametricCoordinate: parametricCoordinate,
                    lattice: this.transformation.ffd
                };
                this.easel.setCursor('move');
            }
        }
        if (event.type === 'pointermove' && this.warpStart) {
            // Apply warp
            this.transformation.ffd = (0, $dd7061603b95efc4$export$fd7a293c27db611b)(this.warpStart.parametricCoordinate, cursorCanvasPos, this.warpStart.lattice);
            const { width: width, height: height } = this.easel.getProjectSize();
            this.ffdMesh = (0, $dd7061603b95efc4$export$d6a0409d5640315a)((0, $fa5dd7576eba601b$export$6ba60dd123964f3e), (0, $fa5dd7576eba601b$export$6ba60dd123964f3e), this.transformation.ffd, width, height, true);
            this.updateLatticePath();
            this.easel.requestRender();
            this.onTransform(this.transformation);
        }
        if (event.type === 'pointerup') {
            if (this.warpStart) this.onTransformEnd();
            this.warpStart = undefined;
        }
        if (!this.warpStart) // Update cursor if not already dragging
        this.easel.setCursor(parametricCoordinate ? 'move' : 'default');
    }
    onPointerChainOut(event) {
        if (this.mode === 'select') {
            this.cornerPanning.onPointer(event);
            this.selectOnPointer(event);
        } else this.transformOnPointer(event);
    }
    createFreeTransform() {
        this.freeTransform = new (0, $d42d1384577ab84d$export$79a74567acf241b0)({
            x: 1,
            y: 1,
            width: 1,
            height: 1,
            angleDeg: 0,
            isConstrained: this.freeTransformIsConstrained,
            snapX: [],
            snapY: [],
            viewportTransform: {
                scale: 1,
                x: 0,
                y: 0,
                angleDeg: 0
            },
            callback: (transform)=>{
                if (this.mode === 'select' || !this.transformation || !(this.transformation.type === 'free' || this.transformation.type === 'ffd+free')) return;
                if (isNaN(transform.x) || isNaN(transform.y) || isNaN(transform.width) || isNaN(transform.height)) //can be provoked by repeatedly x0.5, then dragging a corner
                return;
                this.onTransform((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.transformation), {
                    freeTransform: transform
                }));
                // avoid spamming undo steps
                if (this.freeTransformTimeout) clearTimeout(this.freeTransformTimeout);
                this.freeTransformTimeout = setTimeout(()=>this.onTransformEnd(), 250);
            },
            onWheel: this.easel.onWheel,
            wheelParent: this.easel.getElement()
        });
        this.freeTransform.setSnapping(this.freeTransformIsSnapping);
        this.htmlEl.append(this.freeTransform.getElement());
        this.freeTransform.setViewportTransform(this.viewportTransform);
    }
    destroyFreeTransform() {
        var _this_freeTransform, _this_freeTransform1;
        (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.getElement().remove();
        (_this_freeTransform1 = this.freeTransform) === null || _this_freeTransform1 === void 0 ? void 0 : _this_freeTransform1.destroy();
        this.freeTransform = undefined;
    }
    updateFreeTransformVisibility() {
        var _this_transformation, _this_freeTransform;
        (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.getElement().style.setProperty('display', ((_this_transformation = this.transformation) === null || _this_transformation === void 0 ? void 0 : _this_transformation.type) === 'ffd' ? 'none' : '');
    }
    updateLatticePath() {
        if (!this.transformation || this.transformation.type !== 'ffd') {
            this.latticePath = undefined;
            return;
        }
        const lattice = this.transformation.ffd;
        const sampleCount = (0, $fa5dd7576eba601b$export$6ba60dd123964f3e);
        const path = new Path2D();
        function addPolyline(path, points) {
            path.moveTo(points[0].x, points[0].y);
            for(let i = 1; i < points.length; i++)path.lineTo(points[i].x, points[i].y);
        }
        // horizontal lines
        for(let i = 0; i < lattice.rows; i++){
            const t = i / (lattice.rows - 1);
            const pts = [];
            for(let e = 0; e <= sampleCount; e++)pts.push((0, $dd7061603b95efc4$export$24b0a92fce6b8497)(e / sampleCount, t, lattice));
            addPolyline(path, pts);
        }
        // vertical lines
        for(let i = 0; i < lattice.cols; i++){
            const s = i / (lattice.cols - 1);
            const pts = [];
            for(let e = 0; e <= sampleCount; e++)pts.push((0, $dd7061603b95efc4$export$24b0a92fce6b8497)(s, e / sampleCount, lattice));
            addPolyline(path, pts);
        }
        this.latticePath = path;
    }
    renderLattice(ctx, scale) {
        var _this_transformation;
        if (!this.latticePath) return;
        ctx.save();
        ctx.lineWidth = 1 / scale;
        // globalCompositeOperation = 'difference' is slow in firefox,
        // and it doesn't look all that nice in any browser.
        ctx.strokeStyle = 'rgb(128, 128, 128)';
        ctx.stroke(this.latticePath);
        if ($4c7f3f5331b420df$var$FFD_DEBUG && ((_this_transformation = this.transformation) === null || _this_transformation === void 0 ? void 0 : _this_transformation.type) === 'ffd') {
            const lattice = this.transformation.ffd;
            for(let i = 0; i < lattice.rows; i++)for(let j = 0; j < lattice.cols; j++){
                const cp = lattice.controlPoints[i][j];
                ctx.beginPath();
                ctx.arc(cp.x, cp.y, 4 / scale, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(255, 100, 100, 0.8)';
                ctx.fill();
                ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
                ctx.lineWidth = 1.5 / scale;
                ctx.stroke();
            }
        }
        ctx.restore();
    }
    getSvgElement() {
        return this.svgEl;
    }
    getHtmlOverlayElement() {
        return this.htmlEl;
    }
    onPointer(event) {
        this.onPointerChainOut(event);
        this.pointerChain.chainIn(event);
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
        this.viewportTransform = this.easel.getTransform();
    }
    setMode(mode) {
        this.mode = mode;
        this.resetPolyShape();
        if (this.mode === 'transform') this.createFreeTransform();
        else {
            this.ffdMesh = undefined;
            this.destroyFreeTransform();
        }
    }
    onTool(toolId) {
        if (toolId === 'select') this.htmlEl.style.display = 'block';
        else this.htmlEl.style.display = 'none';
    }
    activate(cursorPos, poppedTemp) {
        if (cursorPos && this.transformation && this.ffdMesh) {
            const cursorCanvasPos = this.viewportToCanvas(cursorPos);
            const param = (0, $dd7061603b95efc4$export$2d232ae0b526c96b)(cursorCanvasPos.x, cursorCanvasPos.y, this.ffdMesh);
            this.easel.setCursor(param ? 'move' : 'default');
        } else this.easel.setCursor('default');
        this.isDragging = false;
        this.onUpdateTransform(this.easel.getTransform());
        if (!poppedTemp) this.resetPolyShape();
    }
    onUpdateTransform(transform) {
        var _this_freeTransform;
        this.viewportTransform = transform;
        this.updateSelectionPath();
        (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.setViewportTransform(transform);
    }
    onUpdateSelection(selection) {
        this.canvasSelection = selection || [];
        this.updateSelectionPath();
    }
    setRenderedSelection(selection) {
        this.selection = selection;
        this.easel.setRenderedSelection(selection);
    }
    bringTransformRectIntoView(freeTransform) {
        const viewportTransform = this.easel.getTransform();
        const easelSize = this.easel.getSize();
        const padding = 40;
        const rect = {
            x: freeTransform.x - freeTransform.width / 2,
            y: freeTransform.y - freeTransform.height / 2,
            width: freeTransform.width,
            height: freeTransform.height
        };
        if ((0, $824d08e9579aaba6$export$eca13ebc72c99beb)(rect, viewportTransform, easelSize, 0)) return;
        this.easel.setTransform((0, $78c6779614eabe8b$export$29dc1c77cb35d1c5)(rect, viewportTransform, easelSize, false, padding));
    }
    initialiseTransform(transform) {
        var _this_freeTransform, _this_freeTransform1;
        transform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(transform);
        if (transform.type !== 'free') throw new Error('must call initialiseTransform with transform.type = "free"');
        this.transformation = transform;
        (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.initialise(transform.freeTransform);
        const { width: width, height: height } = this.easel.getProjectSize();
        (_this_freeTransform1 = this.freeTransform) === null || _this_freeTransform1 === void 0 ? void 0 : _this_freeTransform1.setSnappingPoints([
            0,
            width
        ], [
            0,
            height
        ]);
        this.bringTransformRectIntoView(transform.freeTransform);
    }
    setTransform(transform) {
        transform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(transform);
        this.transformation = transform;
        if (transform.type === 'ffd') {
            const { width: width, height: height } = this.easel.getProjectSize();
            this.ffdMesh = (0, $dd7061603b95efc4$export$d6a0409d5640315a)((0, $fa5dd7576eba601b$export$6ba60dd123964f3e), (0, $fa5dd7576eba601b$export$6ba60dd123964f3e), transform.ffd, width, height, true);
            this.easel.requestRender();
        } else {
            var _this_freeTransform;
            (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.initialise(transform.freeTransform);
            this.ffdMesh = undefined;
        }
        this.updateLatticePath();
        this.updateFreeTransformVisibility();
    }
    clearRenderedSelection(isImmediate) {
        this.easel.clearRenderedSelection(isImmediate);
    }
    setBooleanOperation(operation) {
        this.defaultBooleanOperation = operation;
    }
    setSelectShape(shape) {
        this.resetPolyShape();
        this.selectShape = shape;
    }
    getIsLocked() {
        return this.isDragging;
    }
    renderAfterViewport(ctx, transform) {
        var _this_transformation;
        if (this.mode === 'transform' && ((_this_transformation = this.transformation) === null || _this_transformation === void 0 ? void 0 : _this_transformation.type) === 'ffd') {
            ctx.save();
            this.renderLattice(ctx, transform.scaleX);
            ctx.restore();
        }
        if (this.polyShape.length < 2) return;
        ctx.save();
        ctx.globalCompositeOperation = 'difference';
        ctx.beginPath();
        const shape = this.polyShape;
        ctx.moveTo(shape[0].x, shape[0].y);
        for(let i = 1; i < shape.length; i++)ctx.lineTo(shape[i].x, shape[i].y);
        ctx.lineWidth = 1 / transform.scaleX;
        ctx.strokeStyle = 'white';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.stroke();
        ctx.restore();
    }
    onKeyDown(keyStr, e) {
        if (keyStr === 'esc') {
            if (this.resetPolyShape()) e.preventDefault();
        }
    }
    onClickOutside() {
        this.resetPolyShape();
    }
    onBlur() {
        this.resetPolyShape();
    }
    onArrowKeys(direction) {
        if (!this.freeTransform) return false;
        const movementMap = {
            left: {
                x: -1,
                y: 0
            },
            right: {
                x: 1,
                y: 0
            },
            up: {
                x: 0,
                y: -1
            },
            down: {
                x: 0,
                y: 1
            }
        };
        const multiplier = this.easel.isKeyPressed('shift') ? 5 : 1;
        const movement = movementMap[direction];
        this.freeTransform.move(movement.x * multiplier, movement.y * multiplier);
        return true;
    }
    setIsConstrained(isConstrained) {
        var _this_freeTransform;
        this.freeTransformIsConstrained = isConstrained;
        (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.setIsConstrained(isConstrained);
    }
    setIsSnapping(isSnapping) {
        var _this_freeTransform;
        this.freeTransformIsSnapping = isSnapping;
        (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.setSnapping(isSnapping);
    }
    constructor(p){
        this.easel = {};
        this.viewportTransform = {};
        this.tempCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx((0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(1, 1)) // used for isPointInPath()
        ;
        // state
        this.canvasSelection = [];
        this.selectionPath = (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)([]);
        this.mode = 'select';
        this.isDragging = false;
        // select-mode state
        this.selectSelectMode = 'select';
        this.didSelectionMove = false;
        this.defaultBooleanOperation = 'new' // set by the UI
        ;
        this.selectShape = 'rect';
        this.polyShape = [];
        this.freeTransformIsConstrained = true;
        this.freeTransformIsSnapping = true;
        // ----------------------------------- public -----------------------------------
        this.doubleTapPointerTypes = [
            'touch'
        ];
        this.blockTrigger = 'alt';
        this.mode = p.selectMode;
        this.onStartSelect = p.onStartSelect;
        this.onGoSelect = p.onGoSelect;
        this.onEndSelect = p.onEndSelect;
        this.onStartMoveSelect = p.onStartMoveSelect;
        this.onGoMoveSelect = p.onGoMoveSelect;
        this.onEndMoveSelect = p.onEndMoveSelect;
        this.onSelectAddPoly = p.onSelectAddPoly;
        this.onResetSelection = p.onResetSelection;
        this.onTransform = p.onTransform;
        this.onTransformEnd = p.onTransformEnd;
        this.cornerPanning = new (0, $065fe39023128955$export$4deed4c512c630c2)({
            getEaselSize: ()=>this.easel.getSize(),
            getTransform: ()=>this.easel.getTargetTransform(),
            setTransform: (transform)=>this.easel.setTransform(transform, true),
            testCanPan: (buttonIsPressed)=>{
                return (buttonIsPressed || this.polyShape.length > 1) && !(this.selectShape === 'lasso' && this.selectSelectMode === 'select');
            },
            onRepeatEvent: (e)=>{
                if (this.mode === 'select') this.selectOnPointer(e);
                else this.transformOnPointer(e);
            }
        });
        this.pointerChain = new (0, $3c485cff20ed4548$export$649a211db9812745)({
            chainArr: [
                new (0, $afe05ecd8ae7f4be$export$db3963a21c01d803)({
                    onDoubleTap: (e)=>{
                        if (this.polyShape.length < 3) return;
                        const shape = this.polyShape.map((item)=>({
                                x: item.x,
                                y: item.y
                            }));
                        this.resetPolyShape();
                        if (shape.length > 1) {
                            shape.push((0, $0616f0a0655c1023$export$71511d61b312f219)({}, shape[0]));
                            p.onSelectAddPoly(shape, this.appliedBooleanOperation);
                        }
                    },
                    isInstant: true
                })
            ]
        });
        this.svgEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.htmlEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
    }
}




function $5af8531f823a0d35$export$1b1b9d54d324857f(cx, cy, rx, ry, steps) {
    const result = [];
    const d = 2 * Math.PI / steps;
    for(let i = 0; i < 2 * Math.PI; i += d)result.push([
        Math.cos(i) * rx + cx,
        Math.sin(i) * ry + cy
    ]);
    return [
        result
    ];
}




const $baef18034167f5fc$export$6f71e8a0179bd005 = 2;
function $baef18034167f5fc$export$1f0b3b9c2ff2269f(num) {
    return parseFloat(num.toFixed($baef18034167f5fc$export$6f71e8a0179bd005));
}
function $baef18034167f5fc$export$9ff2e12a5746572e(poly) {
    return poly.map((ring)=>ring.map(([x, y])=>[
                $baef18034167f5fc$export$1f0b3b9c2ff2269f(x),
                $baef18034167f5fc$export$1f0b3b9c2ff2269f(y)
            ]));
}
class $baef18034167f5fc$export$53d9e71218013355 {
    reset() {
        this.selection = undefined;
    }
    combineSelection(polygon) {
        var _this_selection;
        let result = (_this_selection = this.selection) !== null && _this_selection !== void 0 ? _this_selection : [];
        if (this.selectOperation === 'new') result = [
            polygon
        ];
        else {
            if (this.selection && this.selection.length > 0) {
                const operation = this.selectOperation === 'difference' ? 'difference' : 'union';
                result = (0, $bec2c57bfccd422e$export$7ec1a3fdd6e82838)(operation, this.selection, polygon);
            } else if (this.selectOperation === 'union') result = [
                polygon
            ];
        }
        return result;
    }
    /** current state of selection */ getSelection() {
        // combine selections
        let selection = this.selection || [];
        if (this.selectDragInputs.length > 1) {
            // currently inputting
            const operation = this.selectOperation === 'difference' ? 'difference' : 'union';
            if (this.shape === 'rect') {
                const first = this.selectDragInputs[0];
                const last = this.selectDragInputs[this.selectDragInputs.length - 1];
                // floor and ceil already limit precision
                const minX = Math.floor(Math.min(first.x, last.x));
                const minY = Math.floor(Math.min(first.y, last.y));
                const maxX = Math.ceil(Math.max(first.x, last.x));
                const maxY = Math.ceil(Math.max(first.y, last.y));
                selection = this.combineSelection([
                    [
                        [
                            minX,
                            minY
                        ],
                        [
                            maxX,
                            minY
                        ],
                        [
                            maxX,
                            maxY
                        ],
                        [
                            minX,
                            maxY
                        ]
                    ]
                ]);
            } else if (this.shape === 'ellipse') {
                const first = this.selectDragInputs[0];
                const last = this.selectDragInputs[this.selectDragInputs.length - 1];
                const cx = (first.x + last.x) / 2;
                const cy = (first.y + last.y) / 2;
                const rx = Math.abs(last.x - first.x) / 2;
                const ry = Math.abs(last.y - first.y) / 2;
                selection = this.combineSelection($baef18034167f5fc$export$9ff2e12a5746572e((0, $5af8531f823a0d35$export$1b1b9d54d324857f)(cx, cy, rx, ry, 50)));
            } else if (this.shape === 'lasso') selection = this.combineSelection([
                this.selectDragInputs.map((p)=>[
                        $baef18034167f5fc$export$1f0b3b9c2ff2269f(p.x),
                        $baef18034167f5fc$export$1f0b3b9c2ff2269f(p.y)
                    ])
            ]);
        }
        return selection.length === 0 ? undefined : selection;
    }
    // --- selecting ---
    startSelect(pos, operation) {
        this.selectOperation = operation;
        if (this.selectOperation === 'new') this.reset();
        this.selectDragInputs = [
            pos
        ];
    }
    goSelect(pos, isShiftPressed = false) {
        let p = pos;
        if ((this.shape === 'ellipse' || this.shape === 'rect') && isShiftPressed && this.selectDragInputs.length > 0) {
            const start = this.selectDragInputs[0];
            const dx = pos.x - start.x;
            const dy = pos.y - start.y;
            const size = Math.min(Math.abs(dx), Math.abs(dy));
            p = {
                x: start.x + Math.sign(dx) * size,
                y: start.y + Math.sign(dy) * size
            };
        }
        this.selectDragInputs.push({
            x: p.x,
            y: p.y
        });
    }
    endSelect() {
        if (this.selectDragInputs.length > 1) // commit
        this.selection = this.getSelection();
        else this.reset();
        this.selectDragInputs = [];
    }
    addPoly(polygon, operation) {
        this.selectOperation = operation;
        this.selection = this.combineSelection([
            polygon.map((p)=>[
                    $baef18034167f5fc$export$1f0b3b9c2ff2269f(p.x),
                    $baef18034167f5fc$export$1f0b3b9c2ff2269f(p.y)
                ])
        ]);
    }
    // --- moving selection ---
    startMoveSelect(pos) {
        this.moveStartPos = pos;
        this.selectionAtMoveStart = this.selection ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.selection) : undefined;
        this.didMove = false;
    }
    goMoveSelect(pos, isShiftPressed = false) {
        if (!this.moveStartPos) return;
        this.didMove = true;
        let dx = pos.x - this.moveStartPos.x;
        let dy = pos.y - this.moveStartPos.y;
        if (isShiftPressed) {
            // snap to 0°, 45°, 90°, 135° axes from start position
            const angle = Math.atan2(dy, dx);
            const snapAngle = Math.round(angle / (Math.PI / 4)) * (Math.PI / 4);
            const dist = Math.sqrt(dx * dx + dy * dy);
            dx = Math.cos(snapAngle) * dist;
            dy = Math.sin(snapAngle) * dist;
        }
        dx = Math.round(dx);
        dy = Math.round(dy);
        if (this.selectionAtMoveStart) this.selection = (0, $b5fa43d1e9c9aab9$export$199acb5b15c43176)(this.selectionAtMoveStart, dx, dy);
    }
    endMoveSelect() {
        this.moveStartPos = undefined;
        this.selectionAtMoveStart = undefined;
    }
    getDidMove() {
        return this.didMove;
    }
    selectAll() {
        this.reset();
        const width = this.klCanvas.getWidth();
        const height = this.klCanvas.getHeight();
        this.selection = [
            [
                [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        0
                    ],
                    [
                        width,
                        height
                    ],
                    [
                        0,
                        height
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ]
        ];
    }
    invertSelection() {
        var _this_selection;
        const selection = (_this_selection = this.selection) !== null && _this_selection !== void 0 ? _this_selection : [];
        const width = this.klCanvas.getWidth();
        const height = this.klCanvas.getHeight();
        this.selection = (0, $bec2c57bfccd422e$export$7ec1a3fdd6e82838)('difference', [
            [
                [
                    0,
                    0
                ],
                [
                    width,
                    0
                ],
                [
                    width,
                    height
                ],
                [
                    0,
                    height
                ]
            ]
        ], selection);
    }
    setShape(shape) {
        this.shape = shape;
    }
    getShape() {
        return this.shape;
    }
    setSelection(selection) {
        this.selection = selection ? (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(selection).map($baef18034167f5fc$export$9ff2e12a5746572e) : undefined;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.shape = 'rect';
        this.selectOperation = 'new';
        this.selectDragInputs = [];
        this.didMove = false // was selection moved
        ;
        this.klCanvas = p.klCanvas;
    }
}






class $6c863e89ac8eb39c$export$348ded3d52c9ce4c {
    invalidateCompositeCanvas() {
        try {
            var _this_texture, _this_canvas;
            (_this_texture = this.texture) === null || _this_texture === void 0 ? void 0 : _this_texture.destroy();
            this.texture = undefined;
            (_this_canvas = this.canvas) === null || _this_canvas === void 0 ? void 0 : _this_canvas.destroy();
            this.canvas = undefined;
        } catch (_) {
        // noop
        }
        this.cachedSelectionSample = undefined;
        this.cachedAlgorithm = undefined;
        this.cachedWidth = undefined;
        this.cachedHeight = undefined;
        this.cachedFfdLattice = undefined;
    }
    ensureCompositeCanvas(width, height, algorithm) {
        if (!this.canvas || this.canvas.isContextLost() || this.cachedAlgorithm !== algorithm || this.cachedWidth !== width || this.cachedHeight !== height) {
            this.invalidateCompositeCanvas();
            try {
                this.canvas = new (0, $8d3b291d55b109e6$export$382d1cdfd2c9e133)((0, $9f64dcf89d8f9132$export$cd3d1f114b139967)(width, height), algorithm);
                this.cachedAlgorithm = algorithm;
                this.cachedWidth = width;
                this.cachedHeight = height;
            } catch (_) {
            // noop
            }
        }
    }
    ensureTexture(selectionSample) {
        if (this.cachedSelectionSample !== selectionSample || !this.texture) {
            var _this_texture;
            (_this_texture = this.texture) === null || _this_texture === void 0 ? void 0 : _this_texture.destroy();
            this.texture = undefined;
            try {
                this.texture = this.canvas.createTexture(selectionSample.image);
                this.cachedSelectionSample = selectionSample;
            } catch (_) {
            // noop
            }
        }
    }
    // ---- public ----
    render(p) {
        if (p.ffdLattice === this.cachedFfdLattice && p.selectionSample === this.cachedSelectionSample && p.algorithm === this.cachedAlgorithm && p.outputWidth === this.cachedWidth && p.outputHeight === this.cachedHeight) return; // output canvas already holds the correct result
        this.ensureCompositeCanvas(p.outputWidth, p.outputHeight, p.algorithm);
        if (!this.canvas) return;
        this.ensureTexture(p.selectionSample);
        if (!this.texture) return;
        this.cachedFfdLattice = p.ffdLattice;
        const ffdMesh = (0, $dd7061603b95efc4$export$81dc197f519ea47)((0, $fa5dd7576eba601b$export$6ba60dd123964f3e), (0, $fa5dd7576eba601b$export$6ba60dd123964f3e), p.ffdLattice, p.selectionSample, p.outputWidth, p.outputHeight, undefined);
        let frontMesh;
        let backMesh;
        try {
            frontMesh = this.canvas.createMesh(ffdMesh.vertices, ffdMesh.texCoords, ffdMesh.frontIndices);
            backMesh = this.canvas.createMesh(ffdMesh.vertices, ffdMesh.texCoords, ffdMesh.backIndices);
            this.canvas.clear();
            this.canvas.draw(frontMesh, this.texture);
            this.canvas.draw(backMesh, this.texture);
            this.canvas.present();
        } catch (_) {
        // noop
        } finally{
            frontMesh === null || frontMesh === void 0 ? void 0 : frontMesh.destroy();
            backMesh === null || backMesh === void 0 ? void 0 : backMesh.destroy();
        }
    }
    getCanvas() {
        var _this_canvas;
        return (_this_canvas = this.canvas) === null || _this_canvas === void 0 ? void 0 : _this_canvas.getCanvas();
    }
    freeResources() {
        this.invalidateCompositeCanvas();
    }
    // when you want to discard this object
    destroy() {
        this.invalidateCompositeCanvas();
    }
}







function $0638025f30fc210b$export$13786f381c8abcf1(selectionSample) {
    const x = selectionSample.x - selectionSample.imageOffset.x;
    const y = selectionSample.y - selectionSample.imageOffset.y;
    return (0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)({
        x: x,
        y: y,
        width: selectionSample.selectionSize.width,
        height: selectionSample.selectionSize.height
    }, 'index');
}
function $0638025f30fc210b$export$a70ad15f9d5e7f79(selectionSample, transformation) {
    const rect = {
        x: selectionSample.x,
        y: selectionSample.y,
        width: selectionSample.image.width,
        height: selectionSample.image.height
    };
    if (transformation) return (0, $9414f5ea41e9cf25$export$b0036cbc597df324)((0, $182738d3ab29089b$export$5dd60a54dd55622)((0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)(rect, 'coordinate'), transformation));
    return (0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)(rect, 'index');
}
function $0638025f30fc210b$export$f97155819e62dfa1(selectionSample, transformation) {
    const bounds = (0, $9414f5ea41e9cf25$export$86989866a3954672)($0638025f30fc210b$export$a70ad15f9d5e7f79(selectionSample, transformation));
    return [
        [
            [
                [
                    bounds.x1,
                    bounds.y1
                ],
                [
                    bounds.x2,
                    bounds.y1
                ],
                [
                    bounds.x2,
                    bounds.y2
                ],
                [
                    bounds.x1,
                    bounds.y2
                ],
                [
                    bounds.x1,
                    bounds.y1
                ]
            ]
        ]
    ];
}



function $6dd27963ff379fef$export$a8cb0d8fd60b16e8(ctx, algorithm) {
    ctx.imageSmoothingEnabled = algorithm === 'smooth';
    if (algorithm === 'smooth') ctx.imageSmoothingQuality = 'high';
}






function $ea52836156ddc10c$export$7c52f4d84a7cbc6e(layers, changes) {
    const result = {};
    const layerEntries = [];
    for (const change of changes)if ('selection' in change) result.selection = {
        value: change.selection
    };
    else {
        const existing = layerEntries.find((e)=>e.layerId === change.layerId);
        if (existing) existing.bounds = (0, $9414f5ea41e9cf25$export$f4467a4f41373bc7)(existing.bounds, change.bounds);
        else layerEntries.push({
            layerId: change.layerId,
            attributes: [
                'tiles'
            ],
            bounds: change.bounds
        });
    }
    if (layerEntries.length > 0) result.layerMap = (0, $52ec11e106a92aac$export$7cefb04ac49374c4)(layers, ...layerEntries);
    return result;
}


function $6941d465213761e0$var$drawTransformedSelectionSample(algorithm, selectionSample, ctx, transformation) {
    ctx.save();
    ctx.setTransform(...(0, $974f651610599156$export$2b60e7dafdbde18a)(transformation));
    (0, $6dd27963ff379fef$export$a8cb0d8fd60b16e8)(ctx, algorithm);
    ctx.drawImage(selectionSample.image, selectionSample.x, selectionSample.y);
    ctx.restore();
}
function $6941d465213761e0$export$2f6704cc6a7abecb(p) {
    var _p_backgroundIsTransparent;
    const backgroundIsTransparent = (_p_backgroundIsTransparent = p.backgroundIsTransparent) !== null && _p_backgroundIsTransparent !== void 0 ? _p_backgroundIsTransparent : false;
    const klHistory = p.klCanvas.getKlHistory();
    const layers = p.klCanvas.getLayersRaw();
    const targetLayer = layers[p.targetLayerIndex];
    const matrix = (0, $fa5dd7576eba601b$export$e464a809f7257768)(p.freeTransform, (0, $0638025f30fc210b$export$13786f381c8abcf1)(p.selectionSample));
    let transformedSelection;
    klHistory.pause(true);
    try {
        if (p.eraseLayerIndex !== undefined) p.klCanvas.eraseLayer({
            layerIndex: p.eraseLayerIndex,
            useSelection: true,
            useAlphaLock: p.eraseLayerIndex === 0 && !backgroundIsTransparent
        });
        $6941d465213761e0$var$drawTransformedSelectionSample(p.algorithm, p.selectionSample, targetLayer.context, matrix);
        transformedSelection = p.selection ? (0, $fa5dd7576eba601b$export$c17d845d16ec8ae)({
            type: 'free',
            freeTransform: p.freeTransform
        }, p.selection) : undefined;
        p.klCanvas.setSelection(transformedSelection);
    } finally{
        klHistory.pause(false);
    }
    if (!klHistory.isPaused()) {
        const eraseLayer = p.eraseLayerIndex !== undefined ? layers[p.eraseLayerIndex] : undefined;
        const targetBounds = (0, $9414f5ea41e9cf25$export$ddc1c0069d484d49)((0, $0638025f30fc210b$export$a70ad15f9d5e7f79)(p.selectionSample, matrix), p.klCanvas.getWidth(), p.klCanvas.getHeight());
        const changes = [];
        transformedSelection && changes.push({
            selection: transformedSelection
        });
        eraseLayer && changes.push({
            layerId: eraseLayer.id,
            bounds: (0, $0638025f30fc210b$export$a70ad15f9d5e7f79)(p.selectionSample)
        });
        targetBounds && changes.push({
            layerId: targetLayer.id,
            bounds: targetBounds
        });
        klHistory.push((0, $ea52836156ddc10c$export$7c52f4d84a7cbc6e)(layers, changes));
    }
}








function $c3652a7447f3558b$var$drawWarpedSelectionSample(algorithm, selectionSample, ctx, ffdLattice, ffdRenderer) {
    ffdRenderer.render({
        ffdLattice: ffdLattice,
        selectionSample: selectionSample,
        algorithm: algorithm,
        outputWidth: ctx.canvas.width,
        outputHeight: ctx.canvas.height
    });
    const outputCanvas = ffdRenderer.getCanvas();
    if (outputCanvas) {
        ctx.save();
        ctx.drawImage(outputCanvas, 0, 0);
        ctx.restore();
    }
}
function $c3652a7447f3558b$export$d43d373c54e74296(p) {
    var _p_backgroundIsTransparent;
    const backgroundIsTransparent = (_p_backgroundIsTransparent = p.backgroundIsTransparent) !== null && _p_backgroundIsTransparent !== void 0 ? _p_backgroundIsTransparent : false;
    const klHistory = p.klCanvas.getKlHistory();
    const layers = p.klCanvas.getLayersRaw();
    const targetLayer = layers[p.targetLayerIndex];
    let transformedSelection;
    klHistory.pause(true);
    try {
        if (p.eraseLayerIndex !== undefined) p.klCanvas.eraseLayer({
            layerIndex: p.eraseLayerIndex,
            useSelection: true,
            useAlphaLock: p.eraseLayerIndex === 0 && !backgroundIsTransparent
        });
        $c3652a7447f3558b$var$drawWarpedSelectionSample(p.algorithm, p.selectionSample, targetLayer.context, p.ffd, p.ffdRenderer);
        transformedSelection = p.selection ? (0, $fa5dd7576eba601b$export$c17d845d16ec8ae)({
            type: 'ffd',
            ffd: p.ffd
        }, p.selection) : undefined;
        p.klCanvas.setSelection(transformedSelection);
    } finally{
        klHistory.pause(false);
    }
    if (!klHistory.isPaused()) {
        const ffdMesh = (0, $dd7061603b95efc4$export$81dc197f519ea47)((0, $fa5dd7576eba601b$export$6ba60dd123964f3e), (0, $fa5dd7576eba601b$export$6ba60dd123964f3e), p.ffd, p.selectionSample, 1, 1, true);
        const width = p.klCanvas.getWidth();
        const height = p.klCanvas.getHeight();
        const targetBounds = (0, $50a0b6484b2d316d$export$b8704036eca28391)(ffdMesh, width, height);
        const eraseLayer = p.eraseLayerIndex !== undefined ? layers[p.eraseLayerIndex] : undefined;
        const changes = [];
        transformedSelection && changes.push({
            selection: transformedSelection
        });
        eraseLayer && changes.push({
            layerId: eraseLayer.id,
            bounds: (0, $0638025f30fc210b$export$a70ad15f9d5e7f79)(p.selectionSample)
        });
        targetBounds && changes.push({
            layerId: targetLayer.id,
            bounds: targetBounds
        });
        klHistory.push((0, $ea52836156ddc10c$export$7c52f4d84a7cbc6e)(layers, changes));
    }
}












function $3c28ae679e7e116a$export$fbfe89095a95dee(config, // "same" when (source layer === destination layer)
layer) {
    var _config_selection;
    const selectionPath = (0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)((_config_selection = config.selection) !== null && _config_selection !== void 0 ? _config_selection : (0, $0638025f30fc210b$export$f97155819e62dfa1)(config.selectionSample));
    const erase = (ctx)=>{
        if (!config.doClone && (layer === 'same' || layer === 'src')) {
            // erase
            ctx.save();
            ctx.clip(selectionPath);
            if (config.backgroundIsTransparent) ctx.clearRect(0, 0, config.klCanvasWidth, config.klCanvasHeight);
            else {
                // fastest in firefox like so
                ctx.globalCompositeOperation = 'source-atop';
                ctx.fillStyle = '#fff';
                ctx.fillRect(0, 0, config.klCanvasWidth, config.klCanvasHeight);
            }
            ctx.restore();
        }
    };
    // ffd
    if (config.transform.type === 'ffd' || config.transform.type === 'ffd+free') {
        let ffd = config.transform.ffd;
        if (config.transform.type === 'ffd+free') // apply further free transform
        ffd = (0, $fa5dd7576eba601b$export$a56ca41a0dbe2002)(ffd, (0, $fa5dd7576eba601b$export$e464a809f7257768)(config.transform.freeTransform, (0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)(config.transform.ffdBounds, 'index')));
        return {
            draw: (ctx)=>{
                ctx.save();
                erase(ctx);
                if (layer === 'same' || layer === 'dest') {
                    config.ffdRenderer.render({
                        ffdLattice: ffd,
                        selectionSample: config.selectionSample,
                        algorithm: config.algorithm,
                        outputWidth: config.klCanvasWidth,
                        outputHeight: config.klCanvasHeight
                    });
                    const outputCanvas = config.ffdRenderer.getCanvas();
                    outputCanvas && ctx.drawImage(outputCanvas, 0, 0);
                }
                ctx.restore();
            }
        };
    }
    // free transform
    const selectionBounds = (0, $0638025f30fc210b$export$13786f381c8abcf1)(config.selectionSample);
    const transformMatrix = (0, $fa5dd7576eba601b$export$e464a809f7257768)(config.transform.freeTransform, selectionBounds);
    return {
        draw: (ctx)=>{
            ctx.save();
            erase(ctx);
            if (layer === 'same' || layer === 'dest') {
                (0, $6dd27963ff379fef$export$a8cb0d8fd60b16e8)(ctx, config.algorithm);
                ctx.setTransform(...(0, $974f651610599156$export$2b60e7dafdbde18a)(transformMatrix));
                ctx.drawImage(config.selectionSample.image, config.selectionSample.x, config.selectionSample.y);
            }
            ctx.restore();
        }
    };
}








function $368f039a1cc13ef7$export$bf78d14945c1101(layerIndex, klCanvas) {
    const srcLayer = klCanvas.getLayersRaw()[layerIndex];
    const klCanvasSelection = klCanvas.getSelection();
    const hasSelection = !!klCanvasSelection;
    let selectionBounds;
    let imageBounds;
    if (hasSelection) {
        selectionBounds = (0, $9414f5ea41e9cf25$export$3488993c9d026384)((0, $b6390a4afb7d8067$export$a04a50ae6d6450f8)(klCanvasSelection, 'index'));
        imageBounds = (0, $273e2af276df50c0$export$6be4733fa804854c)(klCanvasSelection, srcLayer.context);
    } else {
        const width = klCanvas.getWidth();
        const height = klCanvas.getHeight();
        var _klCanvas_getSelection;
        imageBounds = (0, $273e2af276df50c0$export$6be4733fa804854c)((_klCanvas_getSelection = klCanvas.getSelection()) !== null && _klCanvas_getSelection !== void 0 ? _klCanvas_getSelection : [
            [
                [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        0
                    ],
                    [
                        width,
                        height
                    ],
                    [
                        0,
                        height
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ]
        ], srcLayer.context);
        selectionBounds = imageBounds ? (0, $0616f0a0655c1023$export$71511d61b312f219)({}, imageBounds) : undefined;
    }
    // empty
    if (!selectionBounds || !imageBounds) return undefined;
    const sampleCanvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(imageBounds.width, imageBounds.height);
    const sampleCtx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(sampleCanvas);
    sampleCtx.save();
    sampleCtx.translate(-imageBounds.x, -imageBounds.y);
    if (klCanvasSelection) sampleCtx.clip((0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(klCanvasSelection));
    sampleCtx.drawImage(srcLayer.canvas, 0, 0);
    sampleCtx.restore();
    return {
        image: sampleCanvas,
        x: imageBounds.x,
        y: imageBounds.y,
        imageOffset: {
            x: imageBounds.x - selectionBounds.x,
            y: imageBounds.y - selectionBounds.y
        },
        selectionSize: {
            width: selectionBounds.width,
            height: selectionBounds.height
        }
    };
}



function $9f442e11ca4a81af$var$isSelectTransformTempEntry(entry) {
    return entry.type === 'select-transform' && !!entry.data;
}
function $9f442e11ca4a81af$var$initialiseTransformState(p) {
    const selectionSample = p.selectionSample;
    const selectionBounds = (0, $0638025f30fc210b$export$13786f381c8abcf1)(p.selectionSample);
    const transform = {
        // no ffd initially
        type: 'free',
        freeTransform: (0, $fa5dd7576eba601b$export$928f0648354c9a2f)((0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)(selectionBounds))
    };
    return {
        selection: p.selection,
        selectionSample: selectionSample,
        transform: transform,
        algorithm: p.algorithm,
        doClone: false,
        isWarping: false,
        targetLayerIndex: p.targetLayerIndex,
        backgroundIsTransparent: p.backgroundIsTransparent
    };
}
class $9f442e11ca4a81af$export$e471993a29671b7 {
    // ----------------------------------- private methods -----------------------------------
    isTransformationChanged() {
        if (!this.transformState) return false;
        const initial = this.tempHistory.getEntries()[0];
        if (!$9f442e11ca4a81af$var$isSelectTransformTempEntry(initial)) throw new Error('initial temp history entry has wrong type');
        if (this.transformState.doClone !== initial.data.doClone) return true;
        if (this.transformState.targetLayerIndex !== initial.data.targetLayerIndex) return true;
        // not perfect but would be a lot of effort to determine if two transforms are equivalent
        return JSON.stringify(this.transformState.transform) !== JSON.stringify(initial.data.transform);
    }
    /** reset KlCanvas layer composites **/ resetKlCanvasLayerComposites() {
        const srcLayerCtx = this.getCurrentLayerCtx();
        const srcLayerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.klCanvas.getLayerIndex(srcLayerCtx.canvas));
        this.klCanvas.setComposite(srcLayerIndex, undefined);
        if (this.transformState && this.transformState.targetLayerIndex !== srcLayerIndex) this.klCanvas.setComposite(this.transformState.targetLayerIndex, undefined);
    }
    updateComposites() {
        if (!this.transformState) return;
        const srcLayerCanvas = this.getCurrentLayerCtx().canvas;
        const srcLayerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.klCanvas.getLayerIndex(srcLayerCanvas));
        const config = {
            klCanvasWidth: this.klCanvas.getWidth(),
            klCanvasHeight: this.klCanvas.getHeight(),
            transform: this.transformState.transform,
            selection: this.transformState.selection,
            selectionSample: this.transformState.selectionSample,
            algorithm: this.transformState.algorithm,
            doClone: this.transformState.doClone,
            backgroundIsTransparent: srcLayerIndex !== 0 || this.transformState.backgroundIsTransparent,
            ffdRenderer: this.ffdRenderer
        };
        if (srcLayerIndex === this.transformState.targetLayerIndex) this.klCanvas.setComposite(srcLayerIndex, (0, $3c28ae679e7e116a$export$fbfe89095a95dee)(config, 'same'));
        else {
            this.klCanvas.setComposite(srcLayerIndex, (0, $3c28ae679e7e116a$export$fbfe89095a95dee)(config, 'src'));
            this.klCanvas.setComposite(this.transformState.targetLayerIndex, (0, $3c28ae679e7e116a$export$fbfe89095a95dee)(config, 'dest'));
        }
    }
    updateUiLayerList() {
        this.selectUi.setLayers(this.klCanvas.getLayers().map((layer)=>{
            return layer.name;
        }));
    }
    resetSelection() {
        this.selectTool.reset();
        const selection = this.selectTool.getSelection();
        this.klCanvas.setSelection(selection);
        this.selectUi.setHasSelection(!!selection);
    }
    tempHistoryPush() {
        if (!this.transformState) return;
        const newEntry = {
            type: 'select-transform',
            data: {
                transform: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(this.transformState.transform),
                doClone: this.transformState.doClone,
                targetLayerIndex: this.transformState.targetLayerIndex,
                backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                algorithm: this.transformState.algorithm
            }
        };
        const topEntry = this.tempHistory.getEntries().at(-1);
        // skip if no change
        if (JSON.stringify(newEntry) === JSON.stringify(topEntry)) return;
        this.tempHistory.push(newEntry);
    }
    propagateTransformationChange(skipPushUndo = false) {
        if (!this.transformState) return;
        if (this.transformState.selection) {
            const selection = (0, $fa5dd7576eba601b$export$c17d845d16ec8ae)(this.transformState.transform, this.transformState.selection);
            this.easelSelect.setRenderedSelection(selection);
        }
        this.updateComposites();
        this.onUpdateProject();
        this.updateSelectUi();
        !skipPushUndo && this.tempHistoryPush();
    }
    updateSelectUi() {
        if (!this.transformState) return;
        if (this.transformState.transform.type !== 'ffd') this.selectUi.setFreeTransformTransformation(this.transformState.transform.freeTransform);
    }
    clearTransformState() {
        if (this.transformState) {
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(this.transformState.selectionSample.image);
            this.transformState = undefined;
        }
    }
    getSelectUi() {
        return this.selectUi;
    }
    getEaselSelect() {
        return this.easelSelect;
    }
    getSelectMode() {
        return this.selectMode;
    }
    /**
     * If transform changed something, changes are applied. -> return true
     * If no changes applied -> return false
     */ commitTransform() {
        let result = false;
        if (this.selectMode === 'transform') {
            this.selectUi.setMode('select'); // this triggers selectUi.onMode
            result = true;
        }
        return result;
    }
    /** if transforming, changes are discarded */ discardTransform() {
        if (this.selectMode === 'transform') {
            // so there's no transformation to apply.
            this.clearTransformState();
            // this triggers selectUi.onMode synchronously, which does the cleanup
            this.selectUi.setMode('select');
            return true;
        }
        return false;
    }
    onHistory(type) {
        if (this.transformState && (type === 'tempUndo' || type === 'tempRedo')) {
            this.resetKlCanvasLayerComposites();
            // recreate
            const entries = this.tempHistory.getEntries();
            const top = entries.at(-1);
            if (!$9f442e11ca4a81af$var$isSelectTransformTempEntry(top)) return;
            const state = top.data;
            this.transformState.transform = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(state.transform);
            this.transformState.doClone = state.doClone;
            this.transformState.targetLayerIndex = state.targetLayerIndex;
            this.transformState.backgroundIsTransparent = state.backgroundIsTransparent;
            this.transformState.algorithm = state.algorithm;
            this.transformState.isWarping = state.transform.type === 'ffd';
            this.selectUi.setBackgroundIsTransparent(state.backgroundIsTransparent);
            this.selectUi.setAlgorithm(state.algorithm);
            this.selectUi.setIsWarping(state.transform.type === 'ffd');
            if (this.transformState.selection) {
                const selection = (0, $fa5dd7576eba601b$export$c17d845d16ec8ae)(this.transformState.transform, this.transformState.selection);
                this.easelSelect.setRenderedSelection(selection);
            }
            this.easelSelect.setTransform(this.transformState.transform);
            this.selectUi.setMoveToLayer(this.klCanvas.getLayerIndex(this.getCurrentLayerCtx().canvas) === state.targetLayerIndex ? undefined : state.targetLayerIndex);
            this.updateComposites();
            this.onUpdateProject();
            this.updateSelectUi();
        }
    }
    destroy() {
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    // not a proper cleanup yet
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        // state
        this.selectMode = 'select';
        this.klCanvas = p.klCanvas;
        this.onUpdateProject = p.onUpdateProject;
        this.getCurrentLayerCtx = p.getCurrentLayerCtx;
        this.klHistory = p.klHistory;
        this.tempHistory = p.tempHistory;
        this.statusOverlay = p.statusOverlay;
        this.onFill = p.onFill;
        this.onErase = p.onErase;
        // keep layer list up-to-date
        this.klHistory.addListener(()=>{
            this.selectUi.setHasSelection(!!this.klCanvas.getSelection());
            if (this.selectMode === 'transform') this.updateUiLayerList();
        });
        this.selectTool = new (0, $baef18034167f5fc$export$53d9e71218013355)({
            klCanvas: this.klCanvas
        });
        this.ffdRenderer = new (0, $6c863e89ac8eb39c$export$348ded3d52c9ce4c)();
        this.onVisibilityChange = ()=>{
            if (document.hidden && this.selectMode === 'transform') this.ffdRenderer.freeResources();
        };
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.easelSelect = new (0, $4c7f3f5331b420df$export$24961ed376c522a3)({
            selectMode: this.selectMode,
            onStartSelect: (p, operation)=>this.selectTool.startSelect(p, operation),
            onGoSelect: (p, isShiftPressed)=>{
                this.selectTool.goSelect(p, isShiftPressed);
                this.easelSelect.setRenderedSelection(this.selectTool.getSelection());
            },
            onEndSelect: ()=>{
                this.selectTool.endSelect();
                const selection = this.selectTool.getSelection();
                this.easelSelect.clearRenderedSelection();
                this.klCanvas.setSelection(selection);
                this.selectUi.setHasSelection(!!selection);
            },
            onStartMoveSelect: (p)=>{
                this.selectTool.startMoveSelect(p);
            },
            onGoMoveSelect: (p, isShiftPressed)=>{
                this.selectTool.goMoveSelect(p, isShiftPressed);
                this.easelSelect.setRenderedSelection(this.selectTool.getSelection());
            },
            onEndMoveSelect: ()=>{
                this.selectTool.endMoveSelect();
                if (!this.selectTool.getDidMove()) return;
                const selection = this.selectTool.getSelection();
                this.easelSelect.clearRenderedSelection();
                this.klCanvas.setSelection(selection);
                this.selectUi.setHasSelection(!!selection);
            },
            onSelectAddPoly: (p, operation)=>{
                this.selectTool.addPoly(p, operation);
                const selection = this.selectTool.getSelection();
                this.klCanvas.setSelection(selection);
                this.selectUi.setHasSelection(!!selection);
            },
            onResetSelection: ()=>this.resetSelection(),
            onTransform: (transform)=>{
                if (!this.transformState) return;
                this.transformState.transform = transform;
                this.propagateTransformationChange(true);
            },
            onTransformEnd: ()=>{
                this.tempHistoryPush();
            }
        });
        this.selectUi = new (0, $726e24f56af72b92$export$b3e6ed306341f794)({
            onChangeMode: (mode)=>{
                if (mode === 'select') {
                    const layerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.klCanvas.getLayerIndex(this.getCurrentLayerCtx().canvas));
                    if (this.transformState && (this.isTransformationChanged() || this.transformState.doClone || layerIndex !== this.transformState.targetLayerIndex || this.selectUi.getIsWarping())) {
                        // something changed -> apply
                        const transform = this.transformState.transform;
                        if (transform.type === 'free') (0, $6941d465213761e0$export$2f6704cc6a7abecb)((0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample
                        }, this.transformState.doClone ? {} : {
                            eraseLayerIndex: layerIndex
                        }), {
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            freeTransform: transform.freeTransform,
                            backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection
                        }));
                        else {
                            const ffd = transform.type === 'ffd+free' ? (0, $fa5dd7576eba601b$export$a56ca41a0dbe2002)(transform.ffd, (0, $fa5dd7576eba601b$export$e464a809f7257768)(transform.freeTransform, (0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)(transform.ffdBounds, 'index'))) : transform.ffd;
                            if (this.transformState.doClone) (0, $c3652a7447f3558b$export$d43d373c54e74296)({
                                klCanvas: this.klCanvas,
                                selectionSample: this.transformState.selectionSample,
                                targetLayerIndex: this.transformState.targetLayerIndex,
                                ffd: ffd,
                                algorithm: this.transformState.algorithm,
                                selection: this.transformState.selection,
                                ffdRenderer: this.ffdRenderer
                            });
                            else (0, $c3652a7447f3558b$export$d43d373c54e74296)({
                                klCanvas: this.klCanvas,
                                selectionSample: this.transformState.selectionSample,
                                eraseLayerIndex: layerIndex,
                                targetLayerIndex: this.transformState.targetLayerIndex,
                                ffd: ffd,
                                backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                                algorithm: this.transformState.algorithm,
                                selection: this.transformState.selection,
                                ffdRenderer: this.ffdRenderer
                            });
                        }
                        this.clearTransformState();
                        p.statusOverlay.out((0, $63d0b335c576c718$export$ce37e184d908d785)('select-transform-applied'), true);
                    }
                    this.tempHistory.clear();
                    this.tempHistory.setIsActive(false);
                    this.selectUi.setIsWarping(false);
                    this.resetKlCanvasLayerComposites();
                    this.ffdRenderer.freeResources();
                    this.easelSelect.clearRenderedSelection(true);
                    const selection = this.klCanvas.getSelection();
                    this.selectTool.setSelection(selection);
                    this.selectUi.setHasSelection(!!selection);
                    this.onUpdateProject();
                    this.easelSelect.setMode(mode);
                } else {
                    // -> transform
                    // avoid changing state while mode-change can be rejected
                    const currentLayerCanvas = this.getCurrentLayerCtx().canvas;
                    const layerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.klCanvas.getLayerIndex(currentLayerCanvas));
                    const selectionSample = (0, $368f039a1cc13ef7$export$bf78d14945c1101)(layerIndex, this.klCanvas);
                    if (!selectionSample) {
                        setTimeout(()=>{
                            (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
                                message: (0, $63d0b335c576c718$export$ce37e184d908d785)('select-transform-empty'),
                                type: 'error'
                            });
                        });
                        return false;
                    }
                    this.tempHistory.setIsActive(true);
                    const isBgLayer = layerIndex === 0;
                    let isTransparent = false;
                    if (isBgLayer) {
                        const layer = Object.entries(this.klHistory.getComposed().layerMap).find(([_, layer])=>layer.index === layerIndex)[1];
                        isTransparent = (0, $31d0877b7a0bd896$export$d7a217b118c790a6)(layer);
                        this.selectUi.setBackgroundIsTransparent(isTransparent);
                    }
                    this.transformState = $9f442e11ca4a81af$var$initialiseTransformState({
                        selection: this.klCanvas.getSelection(),
                        selectionSample: selectionSample,
                        algorithm: this.selectUi.getAlgorithm(),
                        targetLayerIndex: layerIndex,
                        backgroundIsTransparent: isTransparent
                    });
                    // push initial state
                    this.tempHistoryPush();
                    this.selectUi.setShowTransparentBackgroundToggle(isBgLayer);
                    this.updateComposites();
                    this.updateUiLayerList();
                    this.selectUi.setMoveToLayer(undefined);
                    this.onUpdateProject();
                    this.easelSelect.setMode(mode);
                    if (this.transformState.selection) {
                        const transformedSelection = (0, $fa5dd7576eba601b$export$c17d845d16ec8ae)(this.transformState.transform, this.transformState.selection);
                        this.easelSelect.setRenderedSelection(transformedSelection);
                    }
                    this.easelSelect.initialiseTransform(this.transformState.transform);
                    this.updateSelectUi();
                }
                this.selectMode = mode;
                return true;
            },
            onChangeBooleanOperation: (operation)=>{
                this.easelSelect.setBooleanOperation(operation);
            },
            select: {
                shape: this.selectTool.getShape(),
                onChangeShape: (shape)=>{
                    this.selectTool.setShape(shape);
                    this.easelSelect.setSelectShape(shape);
                },
                onReset: ()=>this.resetSelection(),
                onAll: ()=>{
                    this.selectTool.selectAll();
                    const selection = this.selectTool.getSelection();
                    this.klCanvas.setSelection(selection);
                    this.selectUi.setHasSelection(!!selection);
                },
                onInvert: ()=>{
                    this.selectTool.invertSelection();
                    const selection = this.selectTool.getSelection();
                    this.klCanvas.setSelection(selection);
                    this.selectUi.setHasSelection(!!selection);
                }
            },
            transform: {
                onFlipY: ()=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $fa5dd7576eba601b$export$44831334ca780533)(this.transformState.transform, 'y');
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onFlipX: ()=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $fa5dd7576eba601b$export$44831334ca780533)(this.transformState.transform, 'x');
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onRotateDeg: (deg)=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $fa5dd7576eba601b$export$71dd993772432b93)(this.transformState.transform, deg);
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onClone: ()=>{
                    if (!this.transformState) return;
                    // commit
                    const layerIndex = (0, $fc4403c8ee6a33dc$export$b813e062795b89b5)(this.klCanvas.getLayerIndex(this.getCurrentLayerCtx().canvas));
                    const transform = this.transformState.transform;
                    // apply
                    // should always apply. user might want to make something more opaque.
                    if (transform.type === 'free') {
                        if (this.transformState.doClone) (0, $6941d465213761e0$export$2f6704cc6a7abecb)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample,
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            freeTransform: transform.freeTransform,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection
                        });
                        else if (this.isTransformationChanged()) (0, $6941d465213761e0$export$2f6704cc6a7abecb)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample,
                            eraseLayerIndex: layerIndex,
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            freeTransform: transform.freeTransform,
                            backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection
                        });
                    } else {
                        const ffd = transform.type === 'ffd+free' ? (0, $fa5dd7576eba601b$export$a56ca41a0dbe2002)(transform.ffd, (0, $fa5dd7576eba601b$export$e464a809f7257768)(transform.freeTransform, (0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)(transform.ffdBounds, 'index'))) : transform.ffd;
                        if (this.transformState.doClone) (0, $c3652a7447f3558b$export$d43d373c54e74296)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample,
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            ffd: ffd,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection,
                            ffdRenderer: this.ffdRenderer
                        });
                        else if (this.isTransformationChanged()) (0, $c3652a7447f3558b$export$d43d373c54e74296)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample,
                            eraseLayerIndex: layerIndex,
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            ffd: ffd,
                            backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection,
                            ffdRenderer: this.ffdRenderer
                        });
                    }
                    this.tempHistory.clear();
                    // push initial state
                    this.tempHistoryPush();
                    this.transformState.doClone = true;
                    this.updateComposites();
                    this.onUpdateProject();
                    this.statusOverlay.out((0, $63d0b335c576c718$export$ce37e184d908d785)('select-transform-clone-applied'), true);
                },
                onScale: (factor)=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $fa5dd7576eba601b$export$7eaa413076082bd7)(this.transformState.transform, factor);
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onCenter: ()=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $fa5dd7576eba601b$export$552b36716f27e91b)(this.transformState.transform, {
                        x: this.klCanvas.getWidth() / 2,
                        y: this.klCanvas.getHeight() / 2
                    });
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onMoveToLayer: (index)=>{
                    if (!this.transformState) return;
                    this.resetKlCanvasLayerComposites();
                    this.transformState.targetLayerIndex = index;
                    this.updateComposites();
                    this.onUpdateProject();
                    this.tempHistoryPush();
                },
                onChangeTransparentBackground: (isTransparent)=>{
                    if (!this.transformState) return;
                    this.transformState.backgroundIsTransparent = isTransparent;
                    this.updateComposites();
                    this.onUpdateProject();
                    this.tempHistoryPush();
                },
                onChangeAlgorithm: (algorithm)=>{
                    if (!this.transformState) return;
                    this.transformState.algorithm = algorithm;
                    this.updateComposites();
                    this.onUpdateProject();
                    this.tempHistoryPush();
                },
                onChangeConstrain: (isConstrained)=>{
                    this.easelSelect.setIsConstrained(isConstrained);
                },
                onChangeSnapping: (isSnapping)=>{
                    this.easelSelect.setIsSnapping(isSnapping);
                },
                onChangeWarp: (isWarping)=>{
                    if (!this.transformState) return;
                    const transform = this.transformState.transform;
                    if (isWarping) {
                        if (transform.type === 'free') {
                            const selectionBounds = (0, $0638025f30fc210b$export$13786f381c8abcf1)(this.transformState.selectionSample);
                            const matrix = (0, $fa5dd7576eba601b$export$e464a809f7257768)(transform.freeTransform, selectionBounds);
                            this.transformState.transform = {
                                type: 'ffd',
                                ffd: (0, $fa5dd7576eba601b$export$a56ca41a0dbe2002)((0, $dd7061603b95efc4$export$1dc7cad4a5f0f0a6)(5, 5, (0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)(selectionBounds)), matrix)
                            };
                        } else if (transform.type === 'ffd+free') {
                            const matrix = (0, $fa5dd7576eba601b$export$e464a809f7257768)(transform.freeTransform, (0, $9414f5ea41e9cf25$export$d89ccdf57354a99c)(transform.ffdBounds, 'index'));
                            this.transformState.transform = {
                                type: 'ffd',
                                ffd: (0, $fa5dd7576eba601b$export$a56ca41a0dbe2002)(transform.ffd, matrix)
                            };
                        }
                    } else if (transform.type === 'ffd') {
                        const ffdBounds = (0, $9414f5ea41e9cf25$export$4218cb0e42c2e7e)((0, $50a0b6484b2d316d$export$da260002c67d0dd)(transform.ffd));
                        const freeTransform = (0, $fa5dd7576eba601b$export$928f0648354c9a2f)(ffdBounds);
                        this.transformState.transform = {
                            type: 'ffd+free',
                            ffd: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(transform.ffd),
                            ffdBounds: ffdBounds,
                            freeTransform: freeTransform
                        };
                    }
                    this.transformState.isWarping = isWarping;
                    this.easelSelect.setTransform(this.transformState.transform);
                    this.updateComposites();
                    this.onUpdateProject();
                    this.tempHistoryPush();
                }
            },
            onErase: ()=>{
                this.onErase();
            },
            onFill: ()=>{
                this.onFill();
            }
        });
        this.klHistory.addListener(()=>{
            const selection = this.klCanvas.getSelection();
            if (this.selectMode === 'select') this.selectTool.setSelection(selection);
        });
    }
}


class $444b5d8ddd6258bc$export$ab82e91194f5da86 {
    emit(type) {
        this.listeners.forEach((item)=>item(type));
    }
    push(entry) {
        while(this.currentIndex < this.entries.length - 1)this.entries.pop();
        this.entries.push(entry);
        this.currentIndex = this.entries.length - 1;
        setTimeout(()=>this.emit('push'));
    }
    replaceTop(newEntry) {
        this.entries.splice(this.currentIndex);
        this.entries.push(newEntry);
        this.currentIndex = this.entries.length - 1;
        setTimeout(()=>this.emit('push'));
    }
    canDecreaseIndex() {
        return this.currentIndex > 0;
    }
    canIncreaseIndex() {
        return this.currentIndex < this.entries.length - 1;
    }
    /** aka undo */ decreaseIndex() {
        if (!this.canDecreaseIndex()) return;
        this.currentIndex--;
        setTimeout(()=>this.emit('decrease'));
    }
    /** aka redo */ increaseIndex() {
        if (!this.canIncreaseIndex()) return;
        this.currentIndex++;
        setTimeout(()=>this.emit('increase'));
    }
    /**
     * all entries up to currentIndex
     */ getEntries() {
        return this.entries.slice(0, this.currentIndex + 1);
    }
    clear() {
        this.entries = [];
        this.currentIndex = -1;
        setTimeout(()=>this.emit('clear'));
    }
    /**
     * emits on push, decrease, increase, clear, or toggle active
     */ addListener(listener) {
        if (this.listeners.includes(listener)) return;
        this.listeners.push(listener);
    }
    removeListener(listener) {
        this.listeners.map((item, index)=>{
            if (item === listener) this.listeners.splice(index, 1);
        });
    }
    setIsActive(isActive) {
        if (this.isActive === isActive) return;
        this.isActive = isActive;
        this.emit('active');
    }
    getIsActive() {
        return this.isActive;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.entries = [];
        this.currentIndex = -1;
        this.listeners = [];
        this.isActive = false;
    }
}





class $a5b80f2248448743$export$3e66e8feec69f8d {
    // -------------------- public ----------------------
    constructor(){
        if (!('visualViewport' in window) || visualViewport === null) return;
        const viewport = visualViewport;
        let isDismissed = false;
        const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('browser-zoom-help'),
            className: 'kl-pinch-overlay',
            css: {
                position: 'fixed',
                pointerEvents: 'none',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: '100',
                flexDirection: 'column',
                gap: '10px',
                padding: '10px',
                backdropFilter: 'blur(3px)'
            }
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: rootEl,
            tagName: 'button',
            content: (0, $63d0b335c576c718$export$ce37e184d908d785)('dismiss'),
            onClick: ()=>{
                isDismissed = true;
                iframe.remove();
                rootEl.remove();
            },
            css: {
                pointerEvents: 'initial'
            }
        });
        // iframe allows pinch-zooming the page even if viewport meta tag set to user-scalable=no
        const iframe = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'iframe',
            css: {
                position: 'fixed',
                width: '100vw',
                height: '100vh',
                zIndex: '99',
                opacity: '0'
            }
        });
        let isInDom = false;
        function check() {
            if (!document.body) // somehow this is possible although all scripts run from within <body>
            // observed with user agent: Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/146.0.0.0 Safari/537.36
            return;
            if (isDismissed) return;
            const testEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: document.body,
                css: {
                    position: 'fixed',
                    inset: '0',
                    zIndex: '-1'
                }
            });
            const rect = testEl.getBoundingClientRect();
            testEl.remove();
            const isZoomed = (viewport.width !== Math.round(rect.width) || viewport.height !== Math.round(rect.height)) && viewport.scale > 1;
            if (isZoomed) {
                (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(rootEl, {
                    left: viewport.offsetLeft + 'px',
                    top: viewport.offsetTop + 'px',
                    width: viewport.width + 'px',
                    height: viewport.height + 'px'
                });
                if (!isInDom) {
                    document.body.append(iframe);
                    document.body.append(rootEl);
                }
            } else if (isInDom) {
                iframe.remove();
                rootEl.remove();
            }
            isInDom = isZoomed;
        }
        viewport.addEventListener('resize', check);
        viewport.addEventListener('scroll', check);
        setTimeout(check);
    }
}



class $22677d38776ea068$export$cb9945923eaef1dd {
    /**
     * If UI is frozen while pressing undo/redo, the user might click multiple times
     * because they think the click wasn't registered.
     * This test prevents multiple undo/redo at once.
     * true = skip
     */ testShouldSkip() {
        if (this.doIgnore) return true;
        this.doIgnore = true;
        setTimeout(()=>{
            this.doIgnore = false;
        }, 0);
        return false;
    }
    canUndo() {
        return this.tempHistory.getIsActive() && this.tempHistory.canDecreaseIndex() || this.klHistory.canUndo();
    }
    canRedo() {
        if (this.tempHistory.getIsActive()) return this.tempHistory.canIncreaseIndex();
        return this.klHistory.canRedo();
    }
    // returns undefined if it can't undo
    undo() {
        if (this.testShouldSkip()) return undefined;
        if (this.tempHistory.getIsActive() && this.tempHistory.canDecreaseIndex()) {
            this.tempHistory.decreaseIndex();
            return {
                type: 'tempUndo'
            };
        }
        if (!this.klHistory.canUndo()) return undefined;
        this.klHistory.decreaseIndex();
        return {
            type: 'undo'
        };
    }
    // returns undefined if it can't redo
    redo() {
        if (this.testShouldSkip()) return undefined;
        if (this.tempHistory.getIsActive() && this.tempHistory.canIncreaseIndex()) {
            this.tempHistory.increaseIndex();
            return {
                type: 'tempRedo'
            };
        }
        if (!this.klHistory.canRedo()) return undefined;
        this.klHistory.increaseIndex();
        return {
            type: 'redo'
        };
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.doIgnore = false;
        this.lastCanUndo = false;
        this.lastCanRedo = false;
        this.klHistory = p.klHistory;
        this.tempHistory = p.tempHistory;
        this.onCanUndoRedoChange = p.onCanUndoRedoChange;
        const emitCanUndoRedo = ()=>{
            const canUndo = this.canUndo();
            const canRedo = this.canRedo();
            if (this.lastCanUndo === canUndo && this.lastCanRedo === canRedo) return;
            this.lastCanUndo = canUndo;
            this.lastCanRedo = canRedo;
            this.onCanUndoRedoChange(canUndo, canRedo);
        };
        this.klHistory.addListener(emitCanUndoRedo);
        this.tempHistory.addListener(emitCanUndoRedo);
    }
}



function $4b95c7d5307dee66$export$beb462111ff337c5(entry) {
    const keys = Object.keys(entry);
    return keys.length === 1 && keys[0] === 'activeLayerId';
}






class $0497dee7143bcf86$export$38b681d46b785af1 {
    update() {
        if (this.isVisible) {
            if (this.toolspaceIsOpen) {
                this.mobileWrapperEl.style.display = 'none';
                if (this.orientation === 'left') (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
                    left: '271px',
                    right: ''
                });
                else (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
                    left: '',
                    right: '271px'
                });
            } else {
                this.mobileWrapperEl.style.display = 'flex';
                if (this.orientation === 'left') (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
                    left: '0',
                    right: ''
                });
                else (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
                    left: '',
                    right: '0'
                });
            }
            this.rootEl.style.display = 'block';
        } else this.rootEl.style.display = 'none';
    }
    setOrientation(orientation) {
        this.orientation = orientation;
        this.toolspaceCollapser.setOrientation(orientation);
    }
    setIsVisible(b) {
        this.isVisible = b;
    }
    getToolspaceIsOpen() {
        return this.toolspaceIsOpen;
    }
    setToolspaceIsOpen(b) {
        this.toolspaceIsOpen = b;
        this.toolspaceCollapser.setIsOpen(b);
        this.onShowToolspace(b);
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.toolspaceIsOpen = true;
        this.orientation = 'right';
        this.isVisible = false;
        this.onShowToolspace = p.onShowToolspace;
        this.toolspaceCollapser = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).ToolspaceCollapser({
            onChange: ()=>{
                this.toolspaceIsOpen = this.toolspaceCollapser.isOpen();
                this.onShowToolspace(this.toolspaceIsOpen);
                if (this.toolspaceIsOpen) (0, $0ecef66681b62a8c$export$19fffca37ef3e106).removeItem('uiShowMobile');
                else (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem('uiShowMobile', 'true');
            }
        });
        this.mobileWrapperEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                marginTop: '4px',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
            }
        });
        this.mobileWrapperEl.append(...p.toolUis);
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                top: '0',
                userSelect: 'none'
            }
        });
        this.rootEl.append(this.toolspaceCollapser.getElement(), this.mobileWrapperEl);
        this.update();
    }
}








class $690058b3c2558cac$export$87fd7552ee5cd26e {
    setIsVisible(b) {
        this.rootEl.style.display = b ? 'block' : 'none';
    }
    setType(type) {
        this.brushOptions.setValue(type, true);
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        const brushIcon = new (0, $d49d366dcf65e875$export$f04a61298a47a40f)({
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4933c2551a80d49a$exports))),
            width: 28,
            height: 28,
            darkInvert: true,
            css: {
                margin: '4px'
            }
        });
        const eraserIcon = new (0, $d49d366dcf65e875$export$f04a61298a47a40f)({
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($224bfe309e7ff70b$exports))),
            width: 28,
            height: 28,
            darkInvert: true,
            css: {
                margin: '4px'
            }
        });
        this.brushOptions = new (0, $1166276dc18d3ea9$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'brush',
                    label: brushIcon.getElement(),
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-brush')
                },
                {
                    id: 'eraser',
                    label: eraserIcon.getElement(),
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('eraser')
                }
            ],
            initId: 'brush',
            onChange: (id)=>{
                if (id === 'brush') p.onBrush();
                else p.onEraser();
            },
            isColumn: true
        });
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {}
        });
        this.rootEl.append(this.brushOptions.getElement());
    }
}







function $d45be62ad1325a1c$export$f8f3f96593f6a47(project) {
    let lastId = '';
    const layerMap = Object.fromEntries(project.layers.map((layer, index)=>{
        lastId = (0, $07b32ff703dd0314$export$b2ce7a8a096070e2)();
        let tiles = [];
        if (layer.image instanceof Array) tiles = [
            ...layer.image
        ];
        else {
            const canvas = (()=>{
                if (layer.image instanceof HTMLCanvasElement) return layer.image;
                const canvas = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(project.width, project.height);
                const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(canvas);
                if ((0, $15ded6c5722f2bc8$export$dba0834b723f37f4)(layer.image)) {
                    ctx.fillStyle = layer.image.fill;
                    ctx.fillRect(0, 0, project.width, project.height);
                } else ctx.drawImage(layer.image, 0, 0);
                return canvas;
            })();
            tiles = (0, $a262f7e0a9f5e4af$export$7b1ba44282f9a519)(canvas);
        }
        var _layer_mixModeStr, _layer_isClipped;
        return [
            lastId,
            {
                name: layer.name,
                opacity: layer.opacity,
                isVisible: layer.isVisible,
                mixModeStr: (_layer_mixModeStr = layer.mixModeStr) !== null && _layer_mixModeStr !== void 0 ? _layer_mixModeStr : 'source-over',
                index: index,
                tiles: tiles,
                isClipped: (_layer_isClipped = layer.isClipped) !== null && _layer_isClipped !== void 0 ? _layer_isClipped : false
            }
        ];
    }));
    return {
        projectId: {
            value: project.projectId
        },
        size: {
            width: project.width,
            height: project.height
        },
        selection: {},
        activeLayerId: lastId,
        layerMap: layerMap
    };
}





class $8545773f317e59cd$export$747c5e57cda7ca57 {
    update() {
        const historyIndex = this.klHistory.getTotalIndex();
        if (this.getLastSavedHistoryIndex() !== historyIndex) window.addEventListener('beforeunload', this.onBeforeUnload);
        else window.removeEventListener('beforeunload', this.onBeforeUnload);
    }
    destroy() {
    //...
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.onBeforeUnload = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        this.klHistory = p.klHistory;
        this.getLastSavedHistoryIndex = p.getLastSavedHistoryIndex;
        p.klHistory.addListener(()=>this.update());
    }
}





var $88c9efa60ac19d5d$export$bb5ee47d9ea2348e;
var $88c9efa60ac19d5d$export$534219b709288da9;
var $88c9efa60ac19d5d$export$8001e369bcc9b474;
var $88c9efa60ac19d5d$export$efe229eab43a9869;
var $88c9efa60ac19d5d$export$ad430d422a89f9f0;
var $88c9efa60ac19d5d$export$48c2d0f2f545ac27;
var $88c9efa60ac19d5d$export$4a3e8128f471434a;
var $88c9efa60ac19d5d$export$e8e78c978b129247;
var $88c9efa60ac19d5d$export$bbeb943159d69f5b;
$88c9efa60ac19d5d$export$bb5ee47d9ea2348e = `RP219q_banner`;
$88c9efa60ac19d5d$export$534219b709288da9 = `RP219q_btn`;
$88c9efa60ac19d5d$export$8001e369bcc9b474 = `RP219q_closeArea`;
$88c9efa60ac19d5d$export$efe229eab43a9869 = `RP219q_closeButton`;
$88c9efa60ac19d5d$export$ad430d422a89f9f0 = `RP219q_mainContent`;
$88c9efa60ac19d5d$export$48c2d0f2f545ac27 = `RP219q_preview`;
$88c9efa60ac19d5d$export$4a3e8128f471434a = `RP219q_rightCol`;
$88c9efa60ac19d5d$export$e8e78c978b129247 = `RP219q_root`;
$88c9efa60ac19d5d$export$bbeb943159d69f5b = `RP219q_rootAnim`;
$88c9efa60ac19d5d$export$bbeb943159d69f5b;






async function $df709f40cddecd59$export$4a2ed1038e76f37f(p) {
    var _p_klRecoveryManager;
    /*
    only show banner if all:
    - nothing was recovered
    - project store is not empty
    - no other tab has this project already open (prevent confusion)
     */ if (!p.projectStore) // no store -> noop
    return;
    const openedProjectIds = [];
    const crossTabChannel = new (0, $a12bfee0fab37a82$export$84f7c9d87f70395e)('kl-tab-communication');
    {
        // subscription stays up during run of application
        crossTabChannel.subscribe((message)=>{
            if (message.type === 'request-project-ids') crossTabChannel.postMessage({
                type: 'response-project-id',
                id: p.klHistory.getComposed().projectId.value
            });
        });
        const otherIdListener = (message)=>{
            if (message.type === 'response-project-id') openedProjectIds.push(message.id);
        };
        crossTabChannel.subscribe(otherIdListener);
        crossTabChannel.postMessage({
            type: 'request-project-ids'
        });
        await (0, $fc4403c8ee6a33dc$export$e772c8ff12451969)(100);
        crossTabChannel.unsubscribe(otherIdListener);
    }
    if (((_p_klRecoveryManager = p.klRecoveryManager) === null || _p_klRecoveryManager === void 0 ? void 0 : _p_klRecoveryManager.getTabId()) !== undefined) // something already recovered -> noop
    return;
    const meta = await p.projectStore.readMeta();
    if (!meta) // nothing stored -> noop
    return;
    if (openedProjectIds.includes(meta.projectId)) // already open in other tab -> noop
    return;
    const fit = (0, $fc4403c8ee6a33dc$export$fa55905620c22535)(meta.thumbnail.width, meta.thumbnail.height, 100, 100);
    (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(meta.thumbnail, {
        width: fit.width + 'px',
        height: fit.height + 'px'
    });
    const closeButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'button',
        className: $88c9efa60ac19d5d$export$efe229eab43a9869 + ' popup-x',
        content: `<img alt="${(0, $63d0b335c576c718$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($f6d60f0cc8cfa5ae$exports)))}">`,
        title: (0, $63d0b335c576c718$export$ce37e184d908d785)('modal-close'),
        custom: {
            tabindex: '0'
        }
    });
    closeButton.onclick = close;
    const preview = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: $88c9efa60ac19d5d$export$48c2d0f2f545ac27,
        content: meta.thumbnail,
        title: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-open')
    });
    preview.onclick = ()=>{
        close();
        p.onOpenBrowserStorage();
    };
    const title = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        content: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage')
    });
    const buttonClass = $88c9efa60ac19d5d$export$534219b709288da9;
    const openBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        tagName: 'button',
        className: [
            'kl-button-primary',
            buttonClass
        ].join(' '),
        content: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-open'),
        custom: {
            tabIndex: '-1'
        }
    });
    openBtn.onclick = ()=>{
        close();
        p.onOpenBrowserStorage();
    };
    const rightCol = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: $88c9efa60ac19d5d$export$4a3e8128f471434a,
        content: [
            title,
            openBtn
        ]
    });
    const mainContent = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: $88c9efa60ac19d5d$export$ad430d422a89f9f0,
        content: [
            preview,
            rightCol
        ]
    });
    const closeArea = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: $88c9efa60ac19d5d$export$8001e369bcc9b474
    });
    closeArea.onclick = close;
    const banner = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        className: $88c9efa60ac19d5d$export$bb5ee47d9ea2348e,
        content: [
            closeArea,
            mainContent,
            closeButton
        ]
    });
    banner.onclick = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).handleClick;
    const rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
        content: [
            banner
        ],
        className: $88c9efa60ac19d5d$export$e8e78c978b129247
    });
    document.body.append(rootEl);
    function close() {
        clearTimeout(timeout);
        document.removeEventListener('pointerdown', onPointerDown);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(rootEl, {
            opacity: '0'
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(banner, {
            pointerEvents: 'none'
        });
        setTimeout(()=>{
            rootEl.remove();
        }, 200);
    }
    const timeout = setTimeout(close, 4500);
    const onPointerDown = (e)=>{
        const target = e.target;
        if (banner.contains(target) || banner.contains(target)) return;
        close();
    };
    document.addEventListener('pointerdown', onPointerDown, {
        passive: false
    });
}
















class $2a29e69ee6709f86$export$a82a053f5f536d09 {
    applyPosition() {
        const rect = this.rootEl.getBoundingClientRect();
        this.position.x = (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(this.position.x, 0, window.innerWidth - rect.width);
        this.position.y = (0, $9414f5ea41e9cf25$export$7d15b64cf5a3a4c4)(this.position.y, 0, window.innerHeight - rect.height);
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.rootEl, {
            left: this.position.x + 'px',
            top: this.position.y + 'px'
        });
    }
    getElement() {
        return this.rootEl;
    }
    getPosition() {
        return (0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.position);
    }
    destroy() {
        this.pointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.position = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.position);
        this.xButton = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'popup-x',
            content: `<img alt="${(0, $63d0b335c576c718$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($f6d60f0cc8cfa5ae$exports)))}">`,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('modal-close'),
            noRef: true,
            onClick: ()=>{
                p.onClose();
            },
            css: {
                width: '32px',
                height: '32px',
                lineHeight: '32px',
                background: 'none',
                boxShadow: 'none'
            },
            custom: {
                tabindex: '0'
            }
        });
        const header = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-floating-window-header'
        });
        header.append(this.xButton);
        const body = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            content: p.content
        });
        let downPosition = {
            x: 0,
            y: 0
        };
        this.pointerListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).PointerListener({
            target: header,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.button === 'left' && event.type === 'pointerdown') downPosition = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.position);
                if (event.button === 'left' && event.type === 'pointermove') {
                    this.position.x = downPosition.x + event.pageX - event.downPageX;
                    this.position.y = downPosition.y + event.pageY - event.downPageY;
                    this.applyPosition();
                }
            }
        });
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                position: 'fixed',
                display: 'flex',
                flexDirection: 'column',
                left: this.position.x + 'px',
                top: this.position.y + 'px'
            }
        });
        this.rootEl.append(header, body);
        setTimeout(()=>this.applyPosition());
    }
}



class $2099b242ded3a643$export$f27d6e4616dd9b30 {
    getIsEyedropping() {
        return this.eyedropperToggle.getValue();
    }
    setIsEyedropping(b) {
        this.eyedropperToggle.setValue(b);
    }
    setColor(color) {
        var _this_colorPicker;
        this.color = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, color);
        this.colorCircle.style.backgroundColor = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(color);
        (_this_colorPicker = this.colorPicker) === null || _this_colorPicker === void 0 ? void 0 : _this_colorPicker.setColor(color);
    }
    closeColorPicker() {
        var _this_colorPicker;
        if (this.colorWindow) {
            var _this_colorWindow, _this_colorWindow1;
            this.colorPickerPosition = this.colorWindow.getPosition();
            (_this_colorWindow = this.colorWindow) === null || _this_colorWindow === void 0 ? void 0 : _this_colorWindow.destroy();
            (_this_colorWindow1 = this.colorWindow) === null || _this_colorWindow1 === void 0 ? void 0 : _this_colorWindow1.getElement().remove();
            this.colorWindow = undefined;
        }
        (_this_colorPicker = this.colorPicker) === null || _this_colorPicker === void 0 ? void 0 : _this_colorPicker.destroy();
        this.colorPicker = undefined;
    }
    setIsVisible(b) {
        this.rootEl.style.display = b ? 'flex' : 'none';
        if (!b) this.closeColorPicker();
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.colorPickerPosition = {
            x: 100,
            y: 100
        };
        this.color = {
            r: 0,
            g: 0,
            b: 0
        };
        this.color = (0, $0616f0a0655c1023$export$71511d61b312f219)({}, p.color);
        this.colorCircle = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '30px',
                height: '30px',
                background: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr(p.color),
                borderRadius: '100%',
                boxShadow: '0 0 0 1px rgba(0,0,0,0.5), inset 0 0 0 1px rgba(255,255,255,0.5)',
                alignSelf: 'center',
                cursor: 'pointer'
            },
            noRef: true,
            onClick: ()=>{
                if (this.colorPicker) {
                    this.closeColorPicker();
                    return;
                }
                this.colorPicker = new (0, $8f768338795db7a0$export$66306bf21a9ff39e)({
                    width: 200,
                    heightSV: 200,
                    heightH: 30,
                    color: this.color,
                    callback: p.onColorChange
                });
                this.colorWindow = new (0, $2a29e69ee6709f86$export$a82a053f5f536d09)({
                    content: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                        content: this.colorPicker.getElement()
                    }),
                    onClose: ()=>{
                        this.closeColorPicker();
                    },
                    position: this.colorPickerPosition
                });
                document.body.append(this.colorWindow.getElement());
            }
        });
        const icon = new (0, $d49d366dcf65e875$export$f04a61298a47a40f)({
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($d1c3e18053002796$exports))),
            width: 1,
            height: 1,
            css: {
                width: '100%',
                height: '100%'
            },
            darkInvert: true
        });
        this.eyedropperToggle = new (0, $8d99bd5fadaac7f9$export$2358c75ad3c15b2d)({
            init: false,
            title: (0, $63d0b335c576c718$export$ce37e184d908d785)('eyedropper'),
            onChange: (b)=>{
                p.onEyedropper(b);
            },
            label: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                content: icon.getElement(),
                css: {
                    padding: '6px',
                    height: '36px'
                }
            })
        });
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
            }
        });
        this.rootEl.append(this.colorCircle, this.eyedropperToggle.getElement());
    }
}




(0, $a5bdfa66fb1ba8cd$export$4283b00eae4a6956)();
class $b7af2ed4a75d4700$export$96f6458b62e4c2c {
    updateLastSaved() {
        var _this_saveReminder, _this_unloadWarningTrigger;
        this.lastSavedHistoryIndex = this.klHistory.getTotalIndex();
        (_this_saveReminder = this.saveReminder) === null || _this_saveReminder === void 0 ? void 0 : _this_saveReminder.reset();
        (_this_unloadWarningTrigger = this.unloadWarningTrigger) === null || _this_unloadWarningTrigger === void 0 ? void 0 : _this_unloadWarningTrigger.update();
    }
    updateCollapse(isInitial) {
        if (isInitial) {
            var _LocalStorage_getItem;
            const isMobile = Boolean((_LocalStorage_getItem = (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem('uiShowMobile')) !== null && _LocalStorage_getItem !== void 0 ? _LocalStorage_getItem : false);
            if (isMobile) this.mobileUi.setToolspaceIsOpen(false);
        }
        this.mobileUi.setOrientation(this.uiLayout);
        if (this.uiWidth < this.collapseThreshold) {
            this.mobileUi.setIsVisible(true);
            if (this.mobileUi.getToolspaceIsOpen()) {
                if (this.uiLayout === 'left') (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.easel.getElement(), {
                    left: '271px'
                });
                else (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.easel.getElement(), {
                    left: '0'
                });
                this.toolspace.style.display = 'block';
                this.easel.setSize(Math.max(0, this.uiWidth - this.toolWidth), this.uiHeight);
                this.statusOverlay.setWide(false);
            } else {
                if (this.uiLayout === 'left') (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.easel.getElement(), {
                    left: '0'
                });
                else (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.easel.getElement(), {
                    left: '0'
                });
                this.toolspace.style.display = 'none';
                this.easel.setSize(Math.max(0, this.uiWidth), this.uiHeight);
                this.statusOverlay.setWide(true);
            }
        } else {
            this.mobileColorUi.closeColorPicker();
            this.mobileUi.setIsVisible(false);
            if (this.uiLayout === 'left') (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.easel.getElement(), {
                left: '271px'
            });
            this.toolspace.style.display = 'block';
            this.easel.setSize(Math.max(0, this.uiWidth - this.toolWidth), this.uiHeight);
            this.statusOverlay.setWide(false);
        }
        this.mobileUi.update();
    }
    updateBottomBar() {
        if (!this.bottomBar) return;
        const isVisible = this.toolspaceInner.scrollHeight + 40 < window.innerHeight;
        const newDisplay = isVisible ? '' : 'none';
        // check to prevent infinite MutationObserver loop in Pale Moon
        if (newDisplay !== this.bottomBarWrapper.style.display) this.bottomBarWrapper.style.display = newDisplay;
    }
    updateUi() {
        this.toolspace.classList.toggle('kl-toolspace--left', this.uiLayout === 'left');
        this.toolspace.classList.toggle('kl-toolspace--right', this.uiLayout === 'right');
        if (this.uiLayout === 'left') {
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.toolspace, {
                left: '0',
                right: ''
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.easel.getElement(), {
                left: '271px'
            });
        } else {
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.toolspace, {
                left: '',
                right: '0'
            });
            (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.easel.getElement(), {
                left: '0'
            });
        }
        this.statusOverlay.setUiState(this.uiLayout);
        this.layerPreview.setUiState(this.uiLayout);
        this.layersUi.setUiState(this.uiLayout);
        this.updateCollapse();
        this.toolspaceScroller.updateUiState(this.uiLayout);
    }
    // -------- interface --------
    getElement() {
        return this.rootEl;
    }
    resize(w, h) {
        // iPad scrolls down when increasing text zoom
        if (window.scrollY > 0) window.scrollTo(0, 0);
        if (this.uiWidth === Math.max(0, w) && this.uiHeight === Math.max(0, h)) return;
        this.uiWidth = Math.max(0, w);
        this.uiHeight = Math.max(0, h);
        this.updateCollapse();
        this.updateBottomBar();
        this.layerPreview.setIsVisible(this.uiHeight >= 579);
        this.klColorSlider.setHeight(Math.max(163, Math.min(400, this.uiHeight - 505)));
        this.toolspaceToolRow.setIsSmall(this.uiHeight < 540);
    }
    out(msg) {
        this.statusOverlay.out(msg);
    }
    async getPNG() {
        return await (0, $13d5aa49e37e2734$export$403d539f215df596)(this.klCanvas.getCompleteCanvas(1), 'image/png');
    }
    getProject() {
        return this.klCanvas.getProject();
    }
    swapUiLeftRight() {
        this.uiLayout = this.uiLayout === 'left' ? 'right' : 'left';
        if (!this.embed) (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem('uiState', this.uiLayout);
        this.updateUi();
    }
    setLogo(logoImg, isPixelated, keepOriginalColors) {
        if (this.toolspaceTopRow instanceof (0, $50947f5db7d72ab3$export$665d2c76b1eb8459)) this.toolspaceTopRow.setLogo(logoImg, isPixelated, keepOriginalColors);
    }
    saveAsPsd() {
        this.saveToComputer.save('psd');
    }
    isDrawing() {
        return this.lineSanitizer.getIsDrawing() || this.easel.getIsLocked();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        var _this_saveReminder;
        this.collapseThreshold = 820;
        this.toolWidth = 271;
        this.lastSavedHistoryIndex = 0;
        this.getPSD = async ()=>{
            return await (0, $3ccac2760787e643$export$92433b641be3f7a)(this.klCanvas);
        };
        this.embed = p.embed;
        // default 2048, unless your screen is bigger than that (that computer then probably has the horsepower for that)
        // but not larger than 4096 - a fairly arbitrary decision
        const maxCanvasSize = Math.min(4096, Math.max(2048, Math.max(window.screen.width, window.screen.height)));
        this.uiLayout = this.embed ? 'left' : (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem('uiState') ? (0, $0ecef66681b62a8c$export$19fffca37ef3e106).getItem('uiState') : 'right';
        const projectStore = (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).getIsAvailable() ? new (0, $e42d359db0fc5c76$export$93d91060b9af7e2a)() : undefined;
        this.rootEl = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'g-root',
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                right: '0',
                bottom: '0'
            }
        });
        this.uiWidth = Math.max(0, window.innerWidth);
        this.uiHeight = Math.max(0, window.innerHeight);
        let exportType = 'png';
        const initialWidth = Math.max(10, Math.min(maxCanvasSize, window.innerWidth < this.collapseThreshold ? this.uiWidth : this.uiWidth - this.toolWidth));
        const initialHeight = Math.max(10, Math.min(maxCanvasSize, this.uiHeight));
        var _p_project;
        this.klHistory = new (0, $d2dccce11beb16cf$export$1a1044741a812c67)({
            oldest: (0, $d45be62ad1325a1c$export$f8f3f96593f6a47)((_p_project = p.project) !== null && _p_project !== void 0 ? _p_project : {
                projectId: (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)(),
                width: initialWidth,
                height: initialHeight,
                layers: [
                    {
                        name: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers-layer') + ' 1',
                        opacity: 1,
                        isVisible: true,
                        mixModeStr: 'source-over',
                        image: {
                            fill: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ColorConverter.toRgbStr({
                                r: (0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28),
                                g: (0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28),
                                b: (0, $7a2aeb795d64bafc$export$e4203cb02d5e5b28)
                            })
                        }
                    }
                ]
            })
        });
        const klRecoveryManager = p.klRecoveryManager;
        if (klRecoveryManager) {
            klRecoveryManager.setKlHistory(this.klHistory);
            klRecoveryManager.setGetThumbnail((factor)=>{
                return (0, $2b8bf7b32e5ba51f$export$5f63a7b18dc4503a)(this.klCanvas.getProject(), factor);
            });
        }
        if (p.project) // attempt at freeing memory
        p.project.layers.forEach((layer)=>{
            if (layer.image instanceof HTMLCanvasElement) (0, $d9f9f4926aa80a1c$export$921068d8846a1559).freeCanvas(layer.image);
            layer.image = null;
        });
        this.klCanvas = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).KlCanvas(this.klHistory, this.embed ? -1 : 1);
        const tempHistory = new (0, $444b5d8ddd6258bc$export$ab82e91194f5da86)();
        let mainTabRow = undefined;
        const clearLayer = (showStatus, ignoreSelection)=>{
            applyUncommitted();
            const layerIndex = currentLayer.index;
            this.klCanvas.eraseLayer({
                layerIndex: layerIndex,
                useAlphaLock: layerIndex === 0 && !brushUiMap.eraserBrush.getIsTransparentBg(),
                useSelection: !ignoreSelection
            });
            showStatus && this.statusOverlay.out(this.klCanvas.getSelection() ? (0, $63d0b335c576c718$export$ce37e184d908d785)('cleared-selected-area') : (0, $63d0b335c576c718$export$ce37e184d908d785)('cleared-layer'), true);
        };
        let currentColor = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(0, 0, 0);
        let currentBrushUi;
        let currentBrushId;
        let lastNonEraserBrushId;
        let currentLayer = this.klCanvas.getLayer(this.klCanvas.getLayerCount() - 1);
        // when cycling through brushes you need to know the next non-eraser brush
        const getNextBrushId = ()=>{
            if (currentBrushId === 'eraserBrush') return lastNonEraserBrushId;
            const keyArr = Object.keys(brushUiMap).filter((item)=>item !== 'eraserBrush');
            const i = keyArr.findIndex((item)=>item === currentBrushId);
            return keyArr[(i + 1) % keyArr.length];
        };
        const sizeWatcher = (val)=>{
            brushSettingService.emitSize(val);
            if (this.easelBrush) this.easelBrush.setBrush({
                radius: val
            });
        };
        const brushSettingService = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BrushSettingService({
            onSetColor: (color)=>{
                this.klColorSlider.setColor(color);
                currentBrushUi.setColor(color);
                this.mobileColorUi.setColor(color);
                currentColor = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).copyObj(color);
            },
            onSetSize: (size)=>{
                currentBrushUi.setSize(size);
                this.easelBrush.setBrush({
                    radius: size
                });
            },
            onSetOpacity: (opacity)=>{
                currentBrushUi.setOpacity(opacity);
            },
            onSetScatter: (scatter)=>{
                currentBrushUi.setScatter(scatter);
            },
            onGetColor: ()=>this.klColorSlider.getColor(),
            onGetSize: ()=>brushUiMap[currentBrushId].getSize(),
            onGetOpacity: ()=>brushUiMap[currentBrushId].getOpacity(),
            onGetScatter: ()=>brushUiMap[currentBrushId].getScatter(),
            onGetSliderConfig: ()=>{
                return {
                    sizeSlider: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].sizeSlider,
                    opacitySlider: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].opacitySlider,
                    scatterSlider: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].scatterSlider
                };
            }
        });
        const lineSmoothing = new (0, $2d79f7f8e2e2d334$export$c57e2ed65bcf4d6a)({
            smoothing: (0, $b2e5423e81cbdb22$export$bcd109042a2e4bb5)(1)
        });
        this.lineSanitizer = new (0, $b47927ff4e129b10$export$91dcf4209534d21f)();
        const drawEventChain = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).EventChain({
            chainArr: [
                this.lineSanitizer,
                lineSmoothing
            ]
        });
        drawEventChain.setChainOut((event)=>{
            if (event.type === 'down') {
                this.toolspace.style.pointerEvents = 'none';
                currentBrushUi.startLine(event.x, event.y, event.pressure);
                this.easelBrush.setLastDrawEvent({
                    x: event.x,
                    y: event.y
                });
                this.easel.requestRender();
            }
            if (event.type === 'move') {
                currentBrushUi.goLine(event.x, event.y, event.pressure, event.isCoalesced);
                this.easelBrush.setLastDrawEvent({
                    x: event.x,
                    y: event.y
                });
                this.easel.requestRender();
            }
            if (event.type === 'up') {
                this.toolspace.style.pointerEvents = '';
                currentBrushUi.endLine();
                this.easel.requestRender();
            }
            if (event.type === 'line') {
                currentBrushUi.getBrush().drawLineSegment(event.x0, event.y0, event.x1, event.y1);
                this.easelBrush.setLastDrawEvent({
                    x: event.x1,
                    y: event.y1
                });
                this.easel.requestRender();
            }
        });
        let textToolSettings = {
            size: 20,
            align: 'left',
            isBold: false,
            isItalic: false,
            font: 'sans-serif',
            letterSpacing: 0,
            lineHeight: 1,
            fill: {
                color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                }
            }
        };
        /**
         * Uncommited action is something like select tool > transform which puts the canvas and UI into
         * a temporary state. Changes need to be committed or discarded *before* doing something else.
         *
         * returns true if something was applied
         */ const applyUncommitted = ()=>{
            let didApply = false;
            if (this.easel.getTool() === 'select') didApply = klAppSelect.commitTransform();
            return didApply;
        };
        /** see applyUncommitted **/ const discardUncommitted = ()=>{
            if (this.easel.getTool() === 'select') return klAppSelect.discardTransform();
            return false;
        };
        const propagateUndoRedoChanges = (type, composedBefore)=>{
            if ([
                'undo',
                'redo'
            ].includes(type)) {
                const composedAfter = this.klHistory.getComposed();
                this.klCanvas.updateViaComposed(composedBefore, composedAfter);
                setCurrentLayer(this.klCanvas.getLayer(composedAfter.layerMap[composedAfter.activeLayerId].index));
                this.easelProjectUpdater.update(); // triggers render
                const dimensionChanged = composedBefore.size.width !== composedAfter.size.width || composedBefore.size.height !== composedAfter.size.height;
                if (dimensionChanged) this.easel.resetOrFitTransform(true);
                this.easelBrush.setLastDrawEvent();
                this.layersUi.update(currentLayer.index);
            }
            klAppSelect.onHistory(type);
        };
        const undo = (showMessage)=>{
            if (!tempHistory.canDecreaseIndex()) discardUncommitted();
            const composedBefore = this.klHistory.getComposed();
            const result = klHistoryExecutor.undo();
            if (!result) // didn't do anything
            return;
            propagateUndoRedoChanges(result.type, composedBefore);
            if (showMessage) this.statusOverlay.out((0, $63d0b335c576c718$export$ce37e184d908d785)('undo'), true);
        };
        const redo = (showMessage)=>{
            const composedBefore = this.klHistory.getComposed();
            const result = klHistoryExecutor.redo();
            if (!result) // didn't do anything
            return;
            propagateUndoRedoChanges(result.type, composedBefore);
            if (showMessage) this.statusOverlay.out((0, $63d0b335c576c718$export$ce37e184d908d785)('redo'), true);
        };
        this.statusOverlay = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).StatusOverlay();
        const klAppSelect = new (0, $9f442e11ca4a81af$export$e471993a29671b7)({
            klCanvas: this.klCanvas,
            getCurrentLayerCtx: ()=>currentLayer.context,
            onUpdateProject: ()=>this.easelProjectUpdater.update(),
            klHistory: this.klHistory,
            tempHistory: tempHistory,
            statusOverlay: this.statusOverlay,
            onFill: ()=>{
                this.klCanvas.layerFill(currentLayer.index, this.klColorSlider.getColor(), undefined, true);
                this.statusOverlay.out(this.klCanvas.getSelection() ? (0, $63d0b335c576c718$export$ce37e184d908d785)('filled-selected-area') : (0, $63d0b335c576c718$export$ce37e184d908d785)('filled'), true);
            },
            onErase: ()=>{
                const layerIndex = currentLayer.index;
                this.klCanvas.eraseLayer({
                    layerIndex: layerIndex,
                    useAlphaLock: layerIndex === 0 && !brushUiMap.eraserBrush.getIsTransparentBg(),
                    useSelection: true
                });
                this.statusOverlay.out(this.klCanvas.getSelection() ? (0, $63d0b335c576c718$export$ce37e184d908d785)('cleared-selected-area') : (0, $63d0b335c576c718$export$ce37e184d908d785)('cleared-layer'), true);
            }
        });
        this.easelBrush = new (0, $d5398ba9251670c1$export$dfeedd8879a1038a)({
            radius: 5,
            onLineStart: (e)=>{
                // Block drawing on background layers
                if (currentLayer.isBackground) return;
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'down',
                    scale: this.easel.getTransform().scale,
                    shiftIsPressed: keyListener.isPressed('shift'),
                    pressure: e.pressure,
                    isCoalesced: e.isCoalesced,
                    x: e.x,
                    y: e.y
                });
            },
            onLineGo: (e)=>{
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'move',
                    scale: this.easel.getTransform().scale,
                    shiftIsPressed: keyListener.isPressed('shift'),
                    pressure: e.pressure,
                    isCoalesced: e.isCoalesced,
                    x: e.x,
                    y: e.y
                });
            },
            onLineEnd: ()=>{
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'up',
                    scale: this.easel.getTransform().scale,
                    shiftIsPressed: keyListener.isPressed('shift'),
                    isCoalesced: false
                });
            },
            onLine: (p1, p2)=>{
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'line',
                    x0: p1.x,
                    y0: p1.y,
                    x1: p2.x,
                    y1: p2.y,
                    pressure0: 1,
                    pressure1: 1
                });
            }
        });
        const easelHand = new (0, $d8c027c12d076d23$export$8202a4a90789f655)({});
        const easelShape = new (0, $0d69a1331eb93d66$export$f4821fa73b1145e5)({
            onDown: (p, angleRad)=>{
                shapeTool.onDown(p.x, p.y, angleRad);
            },
            onMove: (p)=>{
                shapeTool.onMove(p.x, p.y);
            },
            onUp: (p)=>{
                shapeTool.onUp(p.x, p.y);
            }
        });
        let isFirstTransform = true;
        this.easel = new (0, $ef524340be1400ac$export$2732362bcaeb02c2)({
            width: Math.max(0, this.uiWidth - this.toolWidth),
            height: this.uiHeight,
            project: {
                width: this.klCanvas.getWidth(),
                height: this.klCanvas.getHeight(),
                layers: []
            },
            tools: {
                brush: this.easelBrush,
                hand: easelHand,
                select: klAppSelect.getEaselSelect(),
                eyedropper: new (0, $0bd0e1e89228720f$export$1fda302750a9ba48)({
                    onPick: (p)=>{
                        const color = this.klCanvas.getColorAt(p.x, p.y);
                        if (color) {
                            brushSettingService.setColor(color);
                            return color;
                        }
                        return brushSettingService.getColor();
                    },
                    onPickEnd: ()=>{
                        if (this.klColorSlider.getIsEyedropping() || this.mobileColorUi.getIsEyedropping()) {
                            this.klColorSlider.setIsEyedropping(false);
                            this.mobileColorUi.setIsEyedropping(false);
                            this.easel.setTool(this.toolspaceToolRow.getActive());
                        }
                    }
                }),
                paintBucket: new (0, $b94c0aafb6fba54d$export$9b29623161064b87)({
                    onFill: (p)=>{
                        this.klCanvas.floodFill(currentLayer.index, p.x, p.y, fillUi.getIsEraser() ? null : this.klColorSlider.getColor(), fillUi.getOpacity(), fillUi.getTolerance(), fillUi.getSample(), fillUi.getGrow(), fillUi.getContiguous());
                        this.easel.requestRender();
                    }
                }),
                gradient: new (0, $317b4db69c17519a$export$11badb1ec62816a1)({
                    onDown: (p, angleRad)=>{
                        gradientTool.onDown(p.x, p.y, angleRad);
                    },
                    onMove: (p)=>{
                        gradientTool.onMove(p.x, p.y);
                    },
                    onUp: (p)=>{
                        gradientTool.onUp(p.x, p.y);
                    }
                }),
                text: new (0, $737d4594390c240a$export$b10c22a3fee9197f)({
                    onDown: (p, angleRad)=>{
                        if ((0, $49faab2330529a96$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0) return;
                        (0, $49faab2330529a96$export$6e4a713ddcda1e5e).textToolDialog({
                            klCanvas: this.klCanvas,
                            layerIndex: currentLayer.index,
                            primaryColor: this.klColorSlider.getColor(),
                            secondaryColor: this.klColorSlider.getSecondaryRGB(),
                            text: (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, textToolSettings), {
                                text: '',
                                x: p.x,
                                y: p.y,
                                angleRad: angleRad,
                                fill: textToolSettings.fill ? {
                                    color: (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.klColorSlider.getColor()), {
                                        a: textToolSettings.fill.color.a
                                    })
                                } : undefined,
                                stroke: textToolSettings.stroke ? (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, textToolSettings.stroke), {
                                    color: (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, this.klColorSlider.getSecondaryRGB()), {
                                        a: textToolSettings.stroke.color.a
                                    })
                                }) : undefined
                            }),
                            onConfirm: (val)=>{
                                textToolSettings = (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, val), {
                                    text: ''
                                });
                                this.klCanvas.text(currentLayer.index, val);
                            }
                        });
                    }
                }),
                shape: easelShape,
                rotate: new (0, $7d88d4eb596d13ba$export$f3b0846760df78b)({}),
                zoom: new (0, $44d9d077b3aa143c$export$6c389c8425707374)({})
            },
            tool: 'brush',
            onChangeTool: (toolId)=>{
                this.mobileBrushUi.setIsVisible(toolId === 'brush');
                this.mobileColorUi.setIsVisible(toolId !== 'select');
            },
            onTransformChange: (transform, isScaleOrAngleChanged)=>{
                handUi.update(transform.scale, transform.angleDeg);
                this.toolspaceToolRow.setEnableZoomIn(transform.scale !== (0, $3757e4eb154d55dd$export$ac82c07320907c00));
                this.toolspaceToolRow.setEnableZoomOut(transform.scale !== (0, $3757e4eb154d55dd$export$5e2c057e240c0b8c));
                if (isScaleOrAngleChanged && !isFirstTransform) this.statusOverlay.out({
                    type: 'transform',
                    scale: transform.scale,
                    angleDeg: transform.angleDeg
                });
                if (isFirstTransform) isFirstTransform = false;
            },
            onUndo: ()=>{
                undo(true);
            },
            onRedo: ()=>{
                redo(true);
            }
        });
        (0, $fc4403c8ee6a33dc$export$dbf350e5966cf602)(this.easel.getElement(), {
            position: 'absolute',
            left: '0',
            top: '0'
        });
        this.easelProjectUpdater = new (0, $d5ac8c3334d6d49f$export$abfede0290e9bfba)({
            klCanvas: this.klCanvas,
            easel: this.easel
        });
        this.klHistory.addListener(()=>{
            this.easelProjectUpdater.update();
        });
        (0, $49faab2330529a96$export$6e4a713ddcda1e5e).DIALOG_COUNTER.subscribe((count)=>{
            this.easel.setIsFrozen(count > 0);
        });
        const updateMainTabVisibility = ()=>{
            if (!mainTabRow) return;
            const toolObj = {
                brush: {},
                hand: {},
                paintBucket: {},
                gradient: {},
                text: {},
                shape: {},
                select: {}
            };
            const activeStr = this.toolspaceToolRow.getActive();
            const oldTabId = mainTabRow.getOpenedTabId();
            const keysArr = Object.keys(toolObj);
            for(let i = 0; i < keysArr.length; i++)if (activeStr === keysArr[i]) mainTabRow.setIsVisible(keysArr[i], true);
            else {
                mainTabRow.setIsVisible(keysArr[i], false);
                if (oldTabId === keysArr[i]) mainTabRow.open(activeStr);
            }
        };
        const keyListener = new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).KeyListener({
            onDown: (keyStr, event, comboStr)=>{
                if ((0, $49faab2330529a96$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0 || (0, $d9f9f4926aa80a1c$export$921068d8846a1559).isInputFocused(true)) return;
                const isDrawing = this.lineSanitizer.getIsDrawing() || this.easel.getIsLocked();
                if (isDrawing) return;
                if (comboStr === 'home') this.easel.fitTransform();
                if (comboStr === 'end') this.easel.resetTransform();
                if ([
                    'ctrl+z',
                    'cmd+z'
                ].includes(comboStr)) {
                    event.preventDefault();
                    undo();
                }
                if ([
                    'ctrl+y',
                    'cmd+y'
                ].includes(comboStr) || ((0, $d9f9f4926aa80a1c$export$921068d8846a1559).sameKeys('ctrl+shift+z', comboStr) || (0, $d9f9f4926aa80a1c$export$921068d8846a1559).sameKeys('cmd+shift+z', comboStr)) && keyStr === 'z') {
                    event.preventDefault();
                    redo();
                }
                if (!this.embed) {
                    if ([
                        'ctrl+s',
                        'cmd+s'
                    ].includes(comboStr)) {
                        event.preventDefault();
                        applyUncommitted();
                        this.saveToComputer.save();
                    }
                    if ([
                        'ctrl+shift+s',
                        'cmd+shift+s'
                    ].includes(comboStr)) {
                        event.preventDefault();
                        applyUncommitted();
                        if (projectStore) (async ()=>{
                            await (0, $2e574af1dfdb7def$export$f565b71ad023b7df)();
                            const meta = projectStore.getCurrentMeta();
                            const project = this.getProject();
                            if (meta && meta.projectId !== project.projectId) {
                                const doOverwrite = await new Promise((resolve, reject)=>{
                                    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
                                        type: 'warning',
                                        message: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-overwrite-confirm'),
                                        buttons: [
                                            (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-overwrite'),
                                            'Cancel'
                                        ],
                                        callback: async (result)=>{
                                            if (result === 'Cancel') {
                                                resolve(false);
                                                return;
                                            }
                                            resolve(true);
                                        }
                                    });
                                });
                                if (!doOverwrite) return;
                            }
                            let success = true;
                            try {
                                await projectStore.store(this.klCanvas.getProject());
                            } catch (e) {
                                success = false;
                                setTimeout(()=>{
                                    throw new Error('keyboard-shortcut: failed to store browser storage, ' + e);
                                }, 0);
                                this.statusOverlay.out("\u274C " + (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-failed'), true);
                            }
                            if (success) {
                                this.updateLastSaved();
                                this.statusOverlay.out((0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-stored'), true);
                            }
                        })();
                        else this.statusOverlay.out("\u274C " + (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-failed'), true);
                    }
                    if ([
                        'ctrl+c',
                        'cmd+c'
                    ].includes(comboStr)) {
                        event.preventDefault();
                        applyUncommitted();
                        copyToClipboard(true);
                    }
                }
                if ([
                    'ctrl+a',
                    'cmd+a'
                ].includes(comboStr)) event.preventDefault();
                if (comboStr === 'sqbr_open') currentBrushUi.decreaseSize(Math.max(0.005, 0.03 / this.easel.getTransform().scale));
                if (comboStr === 'sqbr_close') currentBrushUi.increaseSize(Math.max(0.005, 0.03 / this.easel.getTransform().scale));
                if (comboStr === 'enter') {
                    if (!applyUncommitted()) {
                        this.klCanvas.layerFill(currentLayer.index, this.klColorSlider.getColor(), undefined, true);
                        this.statusOverlay.out(this.klCanvas.getSelection() ? (0, $63d0b335c576c718$export$ce37e184d908d785)('filled-selected-area') : (0, $63d0b335c576c718$export$ce37e184d908d785)('filled'), true);
                    }
                }
                if (comboStr === 'esc') {
                    if (discardUncommitted()) event.preventDefault();
                }
                if ([
                    'delete',
                    'backspace'
                ].includes(comboStr)) clearLayer(true);
                if (comboStr === 'ctrl+shift+e' || comboStr === 'shift+ctrl+e') {
                    event.preventDefault();
                    this.layersUi.advancedMergeDialog();
                }
                if (comboStr === 'shift+e') {
                    var _currentBrushUi_toggleEraser;
                    event.preventDefault();
                    (_currentBrushUi_toggleEraser = currentBrushUi.toggleEraser) === null || _currentBrushUi_toggleEraser === void 0 ? void 0 : _currentBrushUi_toggleEraser.call(currentBrushUi);
                } else if (comboStr === 'e') {
                    event.preventDefault();
                    applyUncommitted();
                    this.easel.setTool('brush');
                    this.toolspaceToolRow.setActive('brush');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('brush');
                    updateMainTabVisibility();
                    brushTabRow.open('eraserBrush');
                }
                if (comboStr === 'b') {
                    event.preventDefault();
                    const prevMode = this.easel.getTool();
                    const prevMainTabId = mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.getOpenedTabId();
                    applyUncommitted();
                    this.easel.setTool('brush');
                    this.toolspaceToolRow.setActive('brush');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('brush');
                    updateMainTabVisibility();
                    brushTabRow.open(prevMode === 'brush' && prevMainTabId === 'brush' ? getNextBrushId() : currentBrushId);
                }
                if (comboStr === 'g') {
                    event.preventDefault();
                    applyUncommitted();
                    const newMode = this.easel.getTool() === 'paintBucket' ? 'gradient' : 'paintBucket';
                    this.easel.setTool(newMode);
                    this.toolspaceToolRow.setActive(newMode);
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open(newMode);
                    updateMainTabVisibility();
                }
                if (comboStr === 't') {
                    event.preventDefault();
                    applyUncommitted();
                    this.easel.setTool('text');
                    this.toolspaceToolRow.setActive('text');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('text');
                    updateMainTabVisibility();
                }
                if (comboStr === 'u') {
                    event.preventDefault();
                    applyUncommitted();
                    this.easel.setTool('shape');
                    this.toolspaceToolRow.setActive('shape');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('shape');
                    updateMainTabVisibility();
                }
                if (comboStr === 'l') {
                    event.preventDefault();
                    const prevTool = this.easel.getTool();
                    const prevSelectMode = klAppSelect.getSelectMode();
                    const prevMainTabId = mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.getOpenedTabId();
                    applyUncommitted();
                    this.easel.setTool('select');
                    this.toolspaceToolRow.setActive('select');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('select');
                    updateMainTabVisibility();
                    if (prevTool === 'select' && prevSelectMode === 'select' && prevMainTabId === 'select') klAppSelect.getSelectUi().setMode('transform');
                }
                if (comboStr === 'x') {
                    event.preventDefault();
                    this.klColorSlider.swapColors();
                }
            },
            onUp: (keyStr, event)=>{}
        });
        const brushUiMap = {};
        // create brush UIs
        Object.entries((0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI).forEach(([b, brushUi])=>{
            const ui = new brushUi.Ui({
                klHistory: this.klHistory,
                onSizeChange: sizeWatcher,
                onScatterChange: (scatter)=>{
                    brushSettingService.emitScatter(scatter);
                },
                onOpacityChange: (opacity)=>{
                    brushSettingService.emitOpacity(opacity);
                },
                onConfigChange: ()=>{
                    brushSettingService.emitSliderConfig({
                        sizeSlider: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].sizeSlider,
                        opacitySlider: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].opacitySlider,
                        scatterSlider: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].scatterSlider
                    });
                }
            });
            brushUiMap[b] = ui;
            ui.getElement().style.padding = "10px";
        });
        this.toolspace = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            className: 'kl-toolspace',
            css: {
                position: 'absolute',
                right: '0',
                top: '0',
                bottom: '0',
                width: this.toolWidth + 'px',
                overflow: 'hidden',
                userSelect: 'none',
                touchAction: 'none'
            }
        });
        this.toolspaceInner = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            parent: this.toolspace
        });
        this.toolspace.oncontextmenu = ()=>{
            return false;
        };
        this.toolspace.onclick = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).handleClick;
        this.mobileBrushUi = new (0, $690058b3c2558cac$export$87fd7552ee5cd26e)({
            onBrush: ()=>{
                brushTabRow.open(lastNonEraserBrushId);
            },
            onEraser: ()=>{
                brushTabRow.open('eraserBrush');
            }
        });
        this.mobileColorUi = new (0, $2099b242ded3a643$export$f27d6e4616dd9b30)({
            onEyedropper: (isActive)=>{
                if (isActive) {
                    this.klColorSlider.setIsEyedropping(true);
                    this.easel.setTool('eyedropper');
                } else {
                    this.klColorSlider.setIsEyedropping(false);
                    this.easel.setTool(this.toolspaceToolRow.getActive());
                }
            },
            color: currentColor,
            onColorChange: (c)=>{
                brushSettingService.setColor(c);
            }
        });
        this.mobileUi = new (0, $0497dee7143bcf86$export$38b681d46b785af1)({
            onShowToolspace: (b)=>{
                this.mobileColorUi.closeColorPicker();
                this.updateCollapse();
            },
            toolUis: [
                this.mobileBrushUi.getElement(),
                this.mobileColorUi.getElement()
            ]
        });
        this.updateCollapse(true);
        let overlayToolspace;
        setTimeout(()=>{
            overlayToolspace = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).OverlayToolspace({
                enabledTest: ()=>{
                    return (0, $49faab2330529a96$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() === 0 && !this.easel.getIsLocked();
                },
                brushSettingService: brushSettingService
            });
            this.rootEl.append(overlayToolspace.getElement());
        }, 0);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).append(this.rootEl, [
            this.easel.getElement(),
            // this.klCanvasWorkspace.getElement(),
            this.toolspace,
            this.mobileUi.getElement()
        ]);
        if (this.embed) this.toolspaceTopRow = new (0, $db287580a54bd175$export$ce26cd3db18613a3)({
            onHelp: ()=>{
                (0, $165d2995997b2f9b$export$35fa34e5af64bd4a)(this.embed.url + '/help.html', !!this.embed);
            },
            onSubmit: ()=>{
                applyUncommitted();
                const onFailure = ()=>{
                    let closeFunc;
                    const saveBtn = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                        tagName: 'button',
                        textContent: (0, $63d0b335c576c718$export$ce37e184d908d785)('save-reminder-save-psd'),
                        css: {
                            display: 'block'
                        }
                    });
                    saveBtn.onclick = ()=>{
                        this.saveAsPsd();
                        closeFunc();
                    };
                    (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                        message: '<b>' + (0, $63d0b335c576c718$export$ce37e184d908d785)('upload-failed') + '</b>',
                        div: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                            content: [
                                (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                                    content: (0, $63d0b335c576c718$export$ce37e184d908d785)('backup-drawing'),
                                    css: {
                                        marginBottom: '10px'
                                    }
                                }),
                                saveBtn
                            ]
                        }),
                        ignoreBackground: true,
                        closeFunc: (f)=>{
                            closeFunc = f;
                        }
                    });
                };
                (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                    message: (0, $63d0b335c576c718$export$ce37e184d908d785)('submit-prompt'),
                    buttons: [
                        (0, $63d0b335c576c718$export$ce37e184d908d785)('submit'),
                        'Cancel'
                    ],
                    callback: async (result)=>{
                        if (result !== (0, $63d0b335c576c718$export$ce37e184d908d785)('submit')) return;
                        const overlay = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                            parent: this.rootEl,
                            className: 'upload-overlay',
                            content: '<div class="spinner"></div> ' + (0, $63d0b335c576c718$export$ce37e184d908d785)('submit-submitting')
                        });
                        this.embed.onSubmit(()=>{
                            this.updateLastSaved();
                            overlay.remove();
                        }, ()=>{
                            overlay.remove();
                            onFailure();
                        });
                    }
                });
            },
            onLeftRight: ()=>{
                this.uiLayout = this.uiLayout === 'left' ? 'right' : 'left';
                this.updateUi();
            }
        });
        else this.toolspaceTopRow = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).ToolspaceTopRow({
            logoImg: p.logoImg,
            onLogo: ()=>{
                (0, $165d2995997b2f9b$export$35fa34e5af64bd4a)('./home/', !!this.embed);
            },
            onNew: ()=>{
                showNewImageDialog();
            },
            onImport: ()=>{
                fileUi.triggerImport();
            },
            onSave: ()=>{
                this.saveToComputer.save();
            },
            onShare: ()=>{
                shareImage();
            },
            onHelp: ()=>{
                (0, $165d2995997b2f9b$export$35fa34e5af64bd4a)('./help/', !!this.embed);
            }
        });
        this.toolspaceTopRow.getElement().style.marginBottom = '10px';
        this.toolspaceInner.append(this.toolspaceTopRow.getElement());
        this.toolspaceToolRow = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).ToolspaceToolRow({
            onActivate: (activeStr)=>{
                if (activeStr !== 'hand') // hand only one that doesn't cause changes
                applyUncommitted();
                if (activeStr === 'brush') this.easel.setTool('brush');
                else if (activeStr === 'hand') this.easel.setTool('hand');
                else if (activeStr === 'paintBucket') this.easel.setTool('paintBucket');
                else if (activeStr === 'gradient') this.easel.setTool('gradient');
                else if (activeStr === 'text') this.easel.setTool('text');
                else if (activeStr === 'shape') this.easel.setTool('shape');
                else if (activeStr === 'select') // this.klCanvasWorkspace.setMode('shape');
                this.easel.setTool('select');
                else throw new Error('unknown activeStr');
                mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open(activeStr);
                updateMainTabVisibility();
                this.klColorSlider.setIsEyedropping(false);
                this.mobileColorUi.setIsEyedropping(false);
            },
            onZoomIn: ()=>{
                const oldScale = this.easel.getTransform().scale;
                const newScale = (0, $b18d1bd8e7aad78b$export$8c03162b1a39d183)(oldScale, keyListener.isPressed('shift') ? 1 / 8 : 0.5);
                this.easel.scale(newScale / oldScale);
            },
            onZoomOut: ()=>{
                const oldScale = this.easel.getTransform().scale;
                const newScale = (0, $b18d1bd8e7aad78b$export$8c03162b1a39d183)(oldScale, keyListener.isPressed('shift') ? -1 / 8 : -0.5);
                this.easel.scale(newScale / oldScale);
            },
            onUndo: ()=>{
                undo();
            },
            onRedo: ()=>{
                redo();
            }
        });
        this.toolspaceToolRow.setIsSmall(this.uiHeight < 540);
        this.toolspaceInner.append(this.toolspaceToolRow.getElement());
        const setBrushColor = (p_color)=>{
            currentColor = p_color;
            currentBrushUi.setColor(p_color);
            brushSettingService.emitColor(p_color);
            this.mobileColorUi.setColor(p_color);
            this.klColorSlider.setIsEyedropping(false);
            this.mobileColorUi.setIsEyedropping(false);
        };
        this.klColorSlider = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).KlColorSlider({
            width: 250,
            height: 30,
            svHeight: 100,
            startValue: new (0, $d9f9f4926aa80a1c$export$921068d8846a1559).RGB(0, 0, 0),
            onPick: setBrushColor,
            onEyedropper: (isActive)=>{
                if (isActive) {
                    this.mobileColorUi.setIsEyedropping(true);
                    this.easel.setTool('eyedropper');
                } else {
                    this.mobileColorUi.setIsEyedropping(false);
                    this.easel.setTool(this.toolspaceToolRow.getActive());
                }
            }
        });
        this.klColorSlider.setHeight(Math.max(163, Math.min(400, this.uiHeight - 505)));
        const setCurrentBrush = (brushId)=>{
            if (brushId !== 'eraserBrush') lastNonEraserBrushId = brushId;
            if (this.klColorSlider) {
                if (brushId === 'eraserBrush') this.klColorSlider.enable(false);
                else this.klColorSlider.enable(true);
            }
            currentBrushId = brushId;
            currentBrushUi = brushUiMap[brushId];
            currentBrushUi.setColor(currentColor);
            currentBrushUi.setLayer(currentLayer);
            this.easelBrush.setBrush({
                type: currentBrushId === 'pixelBrush' ? 'pixel-square' : 'round'
            });
            this.toolspaceToolRow.setActive('brush');
            updateMainTabVisibility();
        };
        const setCurrentLayer = (layer)=>{
            currentLayer = layer;
            currentBrushUi.setLayer(currentLayer);
            this.layerPreview.setLayer(currentLayer);
        };
        const brushDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el();
        const colorDiv = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                margin: '10px',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'flex-end'
            }
        });
        const toolspaceStabilizerRow = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).ToolspaceStabilizerRow({
            smoothing: 1,
            onSelect: (v)=>{
                lineSmoothing.setSmoothing((0, $b2e5423e81cbdb22$export$bcd109042a2e4bb5)(v));
            }
        });
        brushDiv.append(colorDiv);
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).append(colorDiv, [
            this.klColorSlider.getElement(),
            this.klColorSlider.getOutputElement(),
            toolspaceStabilizerRow.getElement()
        ]);
        const brushTabRow = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).TabRow({
            initialId: 'penBrush',
            useAccent: true,
            tabArr: (()=>{
                const result = [];
                const createTab = (keyStr)=>{
                    return {
                        id: keyStr,
                        image: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].image,
                        title: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].tooltip,
                        onOpen: ()=>{
                            brushUiMap[keyStr].getElement().style.display = 'block';
                            setCurrentBrush(keyStr);
                            this.klColorSlider.setIsEyedropping(false);
                            this.mobileColorUi.setIsEyedropping(false);
                            brushSettingService.emitSliderConfig({
                                sizeSlider: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].sizeSlider,
                                opacitySlider: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].opacitySlider,
                                scatterSlider: (0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].scatterSlider
                            });
                            sizeWatcher(brushUiMap[keyStr].getSize());
                            brushSettingService.emitOpacity(brushUiMap[keyStr].getOpacity());
                            this.mobileBrushUi.setType(keyStr === 'eraserBrush' ? 'eraser' : 'brush');
                        },
                        onClose: ()=>{
                            brushUiMap[keyStr].getElement().style.display = 'none';
                        }
                    };
                };
                const keyArr = Object.keys(brushUiMap);
                for(let i = 0; i < keyArr.length; i++)result.push(createTab(keyArr[i]));
                return result;
            })()
        });
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).append(brushDiv, [
            brushTabRow.getElement(),
            ...Object.entries((0, $49faab2330529a96$export$6e4a713ddcda1e5e).BRUSHES_UI).map(([b])=>brushUiMap[b].getElement())
        ]);
        const handUi = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).HandUi({
            scale: this.easel.getTransform().scale,
            angleDeg: 0,
            onReset: ()=>{
                this.easel.resetTransform();
            },
            onFit: ()=>{
                this.easel.fitTransform();
            },
            onAngleChange: (angleDeg, isRelative)=>{
                this.easel.setAngleDeg(angleDeg, isRelative);
            },
            onChangeUseInertiaScrolling: (b)=>{
                easelHand.setUseInertiaScrolling(b);
            }
        });
        const fillUi = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).FillUi({
            colorSlider: this.klColorSlider
        });
        const gradientUi = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).GradientUi({
            colorSlider: this.klColorSlider
        });
        const textUi = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).TextUi({
            colorSlider: this.klColorSlider
        });
        const shapeUi = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).ShapeUi({
            colorSlider: this.klColorSlider,
            onChangePanning: (doPan)=>easelShape.setPanning(doPan)
        });
        const gradientTool = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).GradientTool({
            onGradient: (isDone, x1, y1, x2, y2, angleRad)=>{
                const layerIndex = currentLayer.index;
                const settings = gradientUi.getSettings();
                const gradientObj = {
                    type: settings.type,
                    color1: this.klColorSlider.getColor(),
                    isReversed: settings.isReversed,
                    opacity: settings.opacity,
                    doLockAlpha: settings.doLockAlpha,
                    isEraser: settings.isEraser,
                    doSnap: keyListener.isPressed('shift') || settings.doSnap,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    angleRad: angleRad
                };
                if (isDone) {
                    this.klCanvas.setComposite(layerIndex, undefined);
                    this.klCanvas.drawGradient(layerIndex, gradientObj);
                } else {
                    const selection = this.klCanvas.getSelection();
                    const selectionPath = selection ? new Path2D((0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(selection)) : undefined;
                    this.klCanvas.setComposite(layerIndex, {
                        draw: (ctx)=>{
                            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).drawGradient(ctx, gradientObj, selectionPath);
                        }
                    });
                }
                this.easelProjectUpdater.update();
            }
        });
        const shapeTool = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).ShapeTool({
            onShape: (isDone, x1, y1, x2, y2, angleRad)=>{
                const layerIndex = currentLayer.index;
                const shapeObj = {
                    type: shapeUi.getShape(),
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    angleRad: angleRad,
                    isOutwards: shapeUi.getIsOutwards(),
                    opacity: shapeUi.getOpacity(),
                    isEraser: shapeUi.getIsEraser(),
                    doLockAlpha: shapeUi.getDoLockAlpha()
                };
                if (shapeUi.getShape() === 'line') {
                    shapeObj.strokeRgb = this.klColorSlider.getColor();
                    shapeObj.lineWidth = shapeUi.getLineWidth();
                    shapeObj.isAngleSnap = shapeUi.getIsSnap() || keyListener.isPressed('shift');
                } else {
                    shapeObj.isFixedRatio = shapeUi.getIsFixed() || keyListener.isPressed('shift');
                    if (shapeUi.getMode() === 'stroke') {
                        shapeObj.strokeRgb = this.klColorSlider.getColor();
                        shapeObj.lineWidth = shapeUi.getLineWidth();
                    } else shapeObj.fillRgb = this.klColorSlider.getColor();
                }
                if (isDone) {
                    this.klCanvas.setComposite(layerIndex, undefined);
                    this.klCanvas.drawShape(layerIndex, shapeObj);
                } else {
                    const selection = this.klCanvas.getSelection();
                    const selectionPath = selection ? new Path2D((0, $6b6f23a269032ad5$export$ba7ed3181f35c1cc)(selection)) : undefined;
                    this.klCanvas.setComposite(layerIndex, {
                        draw: (ctx)=>{
                            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).drawShape(ctx, shapeObj, selectionPath);
                        }
                    });
                }
                this.easelProjectUpdater.update();
            }
        });
        this.layersUi = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).LayersUi({
            klCanvas: this.klCanvas,
            onSelect: (layerIndex, pushHistory)=>{
                const activeLayer = this.klCanvas.getLayer(layerIndex);
                setCurrentLayer(activeLayer);
                if (pushHistory) {
                    const topEntry = this.klHistory.getEntries().at(-1).data;
                    const replaceTop = (0, $4b95c7d5307dee66$export$beb462111ff337c5)(topEntry);
                    this.klHistory.push({
                        activeLayerId: activeLayer.id
                    }, replaceTop);
                }
            },
            parentEl: this.rootEl,
            uiState: this.uiLayout,
            applyUncommitted: ()=>applyUncommitted(),
            klHistory: this.klHistory,
            onUpdateProject: ()=>this.easelProjectUpdater.update(),
            onClearLayer: ()=>clearLayer(false, true)
        });
        this.layerPreview = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).LayerPreview({
            klRootEl: this.rootEl,
            onClick: ()=>{
                mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('layers');
            },
            uiState: this.uiLayout,
            klHistory: this.klHistory
        });
        this.layerPreview.setIsVisible(this.uiHeight >= 579);
        this.layerPreview.setLayer(currentLayer);
        const editUi = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).EditUi({
            klRootEl: this.rootEl,
            klColorSlider: this.klColorSlider,
            layersUi: this.layersUi,
            getCurrentColor: ()=>currentColor,
            maxCanvasSize: maxCanvasSize,
            klCanvas: this.klCanvas,
            getCurrentLayer: ()=>currentLayer,
            isEmbed: !!this.embed,
            statusOverlay: this.statusOverlay,
            onCanvasChanged: ()=>{
                this.easelProjectUpdater.update();
                this.easel.resetOrFitTransform(true);
            },
            applyUncommitted: ()=>applyUncommitted(),
            klHistory: this.klHistory,
            onCopyToClipboard: ()=>{
                applyUncommitted();
                copyToClipboard(false, false);
            },
            onPaste: ()=>importHandler.readClipboard()
        });
        const klHistoryExecutor = new (0, $22677d38776ea068$export$cb9945923eaef1dd)({
            klHistory: this.klHistory,
            tempHistory: tempHistory,
            onCanUndoRedoChange: (canUndo, canRedo)=>{
                this.toolspaceToolRow.setEnableUndo(canUndo);
                this.toolspaceToolRow.setEnableRedo(canRedo);
            }
        });
        const showNewImageDialog = ()=>{
            applyUncommitted();
            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).newImageDialog({
                currentColor: currentColor,
                secondaryColor: this.klColorSlider.getSecondaryRGB(),
                maxCanvasSize: maxCanvasSize,
                canvasWidth: this.klCanvas.getWidth(),
                canvasHeight: this.klCanvas.getHeight(),
                workspaceWidth: window.innerWidth < this.collapseThreshold ? this.uiWidth : this.uiWidth - this.toolWidth,
                workspaceHeight: this.uiHeight,
                onConfirm: (width, height, color)=>{
                    this.klCanvas.reset({
                        width: width,
                        height: height,
                        color: color.a === 1 ? color : undefined
                    });
                    this.layersUi.update(0);
                    setCurrentLayer(this.klCanvas.getLayer(0));
                    this.easelProjectUpdater.update();
                    this.easel.resetOrFitTransform(true);
                },
                onCancel: ()=>{}
            });
        };
        const shareImage = (callback)=>{
            applyUncommitted();
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).shareCanvas({
                canvas: this.klCanvas.getCompleteCanvas(1),
                fileName: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).getDate() + (0, $5a2f7ed66bdaf6a4$export$67ac20532b9ededa).filenameBase + '.png',
                title: (0, $d9f9f4926aa80a1c$export$921068d8846a1559).getDate() + (0, $5a2f7ed66bdaf6a4$export$67ac20532b9ededa).filenameBase + '.png',
                callback: callback ? callback : ()=>{}
            });
        };
        this.saveToComputer = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).SaveToComputer(()=>exportType, this.klCanvas, ()=>{
            this.updateLastSaved();
        });
        const copyToClipboard = (showCrop = false, closeOnBlur = true)=>{
            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).clipboardDialog(this.rootEl, (maskSelection)=>{
                return this.klCanvas.getCompleteCanvas(1, maskSelection);
            }, (inputObj)=>{
                if (inputObj.left === 0 && inputObj.right === 0 && inputObj.top === 0 && inputObj.bottom === 0) return;
                //do a crop
                (0, $49faab2330529a96$export$6e4a713ddcda1e5e).FILTER_LIB.cropExtend.apply({
                    layer: currentLayer,
                    klCanvas: this.klCanvas,
                    input: inputObj,
                    klHistory: this.klHistory
                });
                this.layersUi.update();
                this.easelProjectUpdater.update();
                this.easel.resetOrFitTransform(true);
            }, this.statusOverlay, showCrop || false, closeOnBlur, this.klCanvas.getSelection());
        };
        const onOpenBrowserStorage = async ()=>{
            const showFailureMessage = ()=>{
                (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                    message: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-open-failed'),
                    type: 'error'
                });
            };
            if (!projectStore) {
                showFailureMessage();
                return;
            }
            const meta = projectStore.getCurrentMeta();
            // Check is project already opened in other tab.
            // (if it's already open in the current tab, user showed intentionality. Don't ask again.)
            if (meta && this.klHistory.getComposed().projectId.value !== meta.projectId) {
                let doOpen = true;
                const crossTabChannel = new (0, $a12bfee0fab37a82$export$84f7c9d87f70395e)('kl-tab-communication');
                const openedProjectIds = [];
                const otherIdListener = (message)=>{
                    if (message.type === 'response-project-id') openedProjectIds.push(message.id);
                };
                crossTabChannel.subscribe(otherIdListener);
                crossTabChannel.postMessage({
                    type: 'request-project-ids'
                });
                await (0, $fc4403c8ee6a33dc$export$e772c8ff12451969)(100);
                crossTabChannel.unsubscribe(otherIdListener);
                if (meta && openedProjectIds.includes(meta.projectId)) doOpen = await new Promise((resolve, reject)=>{
                    (0, $2016c314bff36ab9$export$d7e8d4d4450c819c)({
                        message: (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-open-confirmation'),
                        buttons: [
                            (0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-open'),
                            'Cancel'
                        ],
                        callback: async (result)=>{
                            if (result === 'Cancel') {
                                resolve(false);
                                return;
                            }
                            resolve(true);
                        }
                    });
                });
                crossTabChannel.close();
                if (!doOpen) return;
            }
            let closeLoader;
            (0, $49faab2330529a96$export$6e4a713ddcda1e5e).popup({
                message: (0, $63d0b335c576c718$export$ce37e184d908d785)('loading'),
                callback: (result)=>{
                    closeLoader = undefined;
                },
                closeFunc: (f)=>{
                    closeLoader = f;
                }
            });
            let project;
            try {
                project = await (projectStore === null || projectStore === void 0 ? void 0 : projectStore.read());
            } catch (e) {
                setTimeout(()=>{
                    throw e;
                });
            }
            if (!project) {
                closeLoader === null || closeLoader === void 0 ? void 0 : closeLoader();
                showFailureMessage();
                return;
            }
            applyUncommitted();
            const layerIndex = this.klCanvas.reset({
                projectId: project.project.projectId,
                width: project.project.width,
                height: project.project.height,
                layers: project.project.layers.map((item)=>{
                    let image = item.image;
                    if (!(image instanceof HTMLCanvasElement)) {
                        image = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).canvas(project.project.width, project.project.height);
                        if (item.image instanceof HTMLImageElement) {
                            const ctx = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).ctx(image);
                            ctx.drawImage(item.image, 0, 0);
                        }
                    }
                    var _item_mixModeStr;
                    return (0, $70adf2daf994ff61$export$71511d61b312f219)((0, $0616f0a0655c1023$export$71511d61b312f219)({}, item), {
                        id: (0, $fc4403c8ee6a33dc$export$4773ec3a7b05a3f2)(),
                        image: image,
                        mixModeStr: (_item_mixModeStr = item.mixModeStr) !== null && _item_mixModeStr !== void 0 ? _item_mixModeStr : 'source-over'
                    });
                })
            });
            this.layersUi.update(layerIndex);
            setCurrentLayer(this.klCanvas.getLayer(layerIndex));
            this.easelProjectUpdater.update();
            this.easel.resetOrFitTransform(true);
            setTimeout(()=>{
                // timeout to overwrite zoom overlay msg
                this.statusOverlay.out((0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-restored'));
            });
            closeLoader === null || closeLoader === void 0 ? void 0 : closeLoader();
        };
        const fileUi = this.embed ? null : new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).FileUi({
            klRootEl: this.rootEl,
            projectStore: projectStore,
            getProject: ()=>this.klCanvas.getProject(),
            exportType: exportType,
            onExportTypeChange: (type)=>{
                exportType = type;
            },
            onFileSelect: (files, optionsStr)=>importHandler.handleFileSelect(files, optionsStr),
            onSaveImageToComputer: ()=>{
                applyUncommitted();
                this.saveToComputer.save();
            },
            onNewImage: showNewImageDialog,
            onShareImage: (callback)=>{
                applyUncommitted();
                shareImage(callback);
            },
            onUpload: ()=>{
                // on upload
                applyUncommitted();
                (0, $49faab2330529a96$export$6e4a713ddcda1e5e).imgurUpload(this.klCanvas, this.rootEl, p.app && p.app.imgurKey ? p.app.imgurKey : '', ()=>this.updateLastSaved());
            },
            applyUncommitted: ()=>applyUncommitted(),
            onChangeShowSaveDialog: (b)=>{
                this.saveToComputer.setShowSaveDialog(b);
            },
            klRecoveryManager: klRecoveryManager,
            onOpenBrowserStorage: onOpenBrowserStorage,
            onStoredToBrowserStorage: ()=>{
                this.updateLastSaved();
            }
        });
        if (!this.embed && projectStore) this.saveReminder = new (0, $5ecc5a61dcd332b6$export$befc6437ad34b28a)({
            onSaveAsPsd: ()=>{
                if (!this.embed) this.saveAsPsd();
            },
            isDrawing: ()=>{
                return this.isDrawing();
            },
            projectStore: projectStore,
            getProject: ()=>this.getProject(),
            onStored: ()=>{
                this.updateLastSaved();
            },
            applyUncommitted: applyUncommitted,
            klHistory: this.klHistory
        });
        const settingsUi = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).SettingsUi({
            onLeftRight: ()=>{
                this.uiLayout = this.uiLayout === 'left' ? 'right' : 'left';
                this.updateUi();
                if (!this.embed) (0, $0ecef66681b62a8c$export$19fffca37ef3e106).setItem('uiState', this.uiLayout);
            },
            saveReminder: this.saveReminder,
            customAbout: p.aboutEl
        });
        mainTabRow = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).TabRow({
            initialId: 'brush',
            tabArr: [
                {
                    id: 'brush',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-brush'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($4933c2551a80d49a$exports))),
                    onOpen: ()=>{
                        if (currentBrushId === 'eraserBrush') this.klColorSlider.enable(false);
                        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).append(colorDiv, [
                            this.klColorSlider.getElement(),
                            this.klColorSlider.getOutputElement(),
                            toolspaceStabilizerRow.getElement()
                        ]);
                        brushDiv.style.display = 'block';
                    },
                    onClose: ()=>{
                        brushDiv.style.display = 'none';
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'hand',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-hand'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($071c8859c903033f$exports))),
                    isVisible: false,
                    onOpen: ()=>{
                        handUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        handUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'paintBucket',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-paint-bucket'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($43ffa4c6f98eaf6b$exports))),
                    isVisible: false,
                    onOpen: ()=>{
                        this.klColorSlider.enable(true);
                        fillUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        fillUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'gradient',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-gradient'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($c4a14de060935e98$exports))),
                    isVisible: false,
                    onOpen: ()=>{
                        this.klColorSlider.enable(true);
                        gradientUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        gradientUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'text',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-text'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($821d1b86107d7d25$exports))),
                    isVisible: false,
                    onOpen: ()=>{
                        this.klColorSlider.enable(true);
                        textUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        textUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'shape',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-shape'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($fd406f4e4b510fcf$exports))),
                    isVisible: false,
                    onOpen: ()=>{
                        this.klColorSlider.enable(true);
                        shapeUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        shapeUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'select',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tool-select'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($7783104c7d4a03b1$exports))),
                    isVisible: false,
                    onOpen: ()=>{
                        klAppSelect.getSelectUi().setIsVisible(true);
                    },
                    onClose: ()=>{
                        klAppSelect.getSelectUi().setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'layers',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('layers'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($4c22caf787ef90d3$exports))),
                    onOpen: ()=>{
                        this.layersUi.setIsVisible(true);
                        this.layersUi.update();
                    },
                    onClose: ()=>{
                        this.layersUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'edit',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-edit'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($a4d127e6391465c0$exports))),
                    onOpen: ()=>{
                        editUi.show();
                    },
                    onClose: ()=>{
                        editUi.hide();
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'file',
                    label: (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-file'),
                    isVisible: !!fileUi,
                    onOpen: ()=>{
                        if (!fileUi) return;
                        fileUi.getElement().style.display = 'block';
                        fileUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        if (!fileUi) return;
                        fileUi.getElement().style.display = 'none';
                        fileUi.setIsVisible(false);
                    },
                    css: {
                        padding: '0 7px'
                    }
                },
                {
                    id: 'settings',
                    title: (0, $63d0b335c576c718$export$ce37e184d908d785)('tab-settings'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($b1066d3ce24bdbb8$exports))),
                    onOpen: ()=>{
                        settingsUi.getElement().style.display = 'block';
                    // settingsTab.setIsVisible(true);
                    },
                    onClose: ()=>{
                        settingsUi.getElement().style.display = 'none';
                    // settingsTab.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                }
            ]
        });
        this.bottomBarWrapper = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
            css: {
                width: '270px',
                position: 'absolute',
                bottom: '0',
                left: '0'
            }
        });
        if (p.bottomBar) {
            this.bottomBar = p.bottomBar;
            this.bottomBarWrapper.append(this.bottomBar);
            const observer = new MutationObserver(()=>this.updateBottomBar());
            observer.observe(this.toolspaceInner, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        (0, $d9f9f4926aa80a1c$export$921068d8846a1559).append(this.toolspaceInner, [
            this.layerPreview.getElement(),
            mainTabRow.getElement(),
            brushDiv,
            handUi.getElement(),
            fillUi.getElement(),
            gradientUi.getElement(),
            textUi.getElement(),
            shapeUi.getElement(),
            klAppSelect.getSelectUi().getElement(),
            this.layersUi.getElement(),
            editUi.getElement(),
            fileUi ? fileUi.getElement() : undefined,
            settingsUi.getElement(),
            (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                css: {
                    height: '10px'
                }
            }),
            this.bottomBarWrapper ? this.bottomBarWrapper : undefined
        ]);
        this.toolspaceScroller = new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).ToolspaceScroller({
            toolspace: this.toolspace,
            uiState: this.uiLayout
        });
        if (!this.embed) Object.defineProperty(window, 'KL', {
            value: (0, $1050fcf084a1ca84$export$982e7602957287fa)({
                onDraw: (path)=>{
                    if (!path || path.length === 0) return;
                    path.forEach((p, index)=>{
                        if (index === 0) currentBrushUi.startLine(p.x, p.y, 1);
                        else currentBrushUi.goLine(p.x, p.y, 1);
                    });
                    currentBrushUi.endLine();
                }
            }),
            writable: false
        });
        this.resize(this.uiWidth, this.uiHeight);
        this.updateUi();
        const importHandler = new (0, $d4355fc62c3bbadf$export$1ec1306c0c05d48d)({
            klRootEl: this.rootEl,
            maxCanvasSize: maxCanvasSize,
            layersUi: this.layersUi,
            setCurrentLayer: setCurrentLayer,
            klCanvas: this.klCanvas,
            onImportConfirm: ()=>{
                this.easelProjectUpdater.update();
                this.easel.resetOrFitTransform(true);
            },
            applyUncommitted: ()=>applyUncommitted()
        }, {
            onColor: (rgb)=>brushSettingService.setColor(rgb)
        });
        if (!this.embed || this.embed.enableImageDropperImport) {
            new (0, $49faab2330529a96$export$6e4a713ddcda1e5e).KlImageDropper({
                target: document.body,
                onDrop: (files, optionStr)=>{
                    if ((0, $49faab2330529a96$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0) return;
                    applyUncommitted();
                    importHandler.handleFileSelect(files, optionStr);
                },
                enabledTest: ()=>{
                    return (0, $49faab2330529a96$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() === 0;
                }
            });
            window.document.addEventListener('paste', (e)=>importHandler.onPaste(e), false);
        }
        this.unloadWarningTrigger = new (0, $8545773f317e59cd$export$747c5e57cda7ca57)({
            klHistory: this.klHistory,
            getLastSavedHistoryIndex: ()=>this.lastSavedHistoryIndex
        });
        {
            window.addEventListener('resize', ()=>{
                this.resize(window.innerWidth, window.innerHeight);
            });
            window.addEventListener('orientationchange', ()=>{
                this.resize(window.innerWidth, window.innerHeight);
            });
            // 2024-08: window.resize doesn't fire on iPad Safari when:
            // pinch zoomed page, then reload, and un-pinch-zoom page
            // therefor also listen to visualViewport.
            if ('visualViewport' in window && visualViewport !== null) visualViewport.addEventListener('resize', ()=>{
                this.resize(window.innerWidth, window.innerHeight);
            });
            // iPad doesn't trigger 'resize' event when using text zoom, although it's resizing the window.
            // Workaround: place a div in the body that fills the window, and use a ResizeObserver
            const windowResizeWatcher = (0, $d9f9f4926aa80a1c$export$921068d8846a1559).el({
                parent: document.body,
                css: {
                    position: 'fixed',
                    left: '0',
                    top: '0',
                    right: '0',
                    bottom: '0',
                    pointerEvents: 'none',
                    zIndex: '-1',
                    userSelect: 'none'
                }
            });
            try {
                // Not all browsers support ResizeObserver. Not critical though.
                const observer = new ResizeObserver(()=>this.resize(window.innerWidth, window.innerHeight));
                observer.observe(windowResizeWatcher);
            } catch (e) {
                windowResizeWatcher.remove();
            }
            // prevent ctrl scroll -> zooming page
            this.rootEl.addEventListener('wheel', (event)=>{
                if (keyListener.isPressed('ctrl')) event.preventDefault();
            }, {
                passive: false
            });
            //maybe prevent zooming on safari mac os - todo still needed?
            const prevent = (e)=>{
                e.preventDefault();
            };
            window.addEventListener('gesturestart', prevent, {
                passive: false
            });
            window.addEventListener('gesturechange', prevent, {
                passive: false
            });
            window.addEventListener('gestureend', prevent, {
                passive: false
            });
            const pinchZoomWatcher = new (0, $a5b80f2248448743$export$3e66e8feec69f8d)();
        }
        if (!this.embed) setTimeout(()=>{
            (0, $df709f40cddecd59$export$4a2ed1038e76f37f)({
                projectStore: projectStore,
                klRecoveryManager: klRecoveryManager,
                onOpenBrowserStorage: onOpenBrowserStorage,
                klHistory: this.klHistory
            });
        });
        (_this_saveReminder = this.saveReminder) === null || _this_saveReminder === void 0 ? void 0 : _this_saveReminder.init();
    }
}






function $8e7310a6fc595c9c$var$showInitError(e) {
    const el = document.createElement('div');
    el.style.textAlign = 'center';
    el.style.background = '#fff';
    el.style.padding = '20px';
    el.innerHTML = '<h1>App failed to initialize</h1>';
    const errorMsg = document.createElement('div');
    errorMsg.textContent = 'Error: ' + (e.message ? e.message : '' + e);
    el.append(errorMsg);
    document.body.append(el);
    console.error(e);
}
(async ()=>{
    try {
        const outQueue = [];
        await (0, $63d0b335c576c718$export$7a2ea9f2e4d199d3)();
        (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).init((0, $2a3419e253354ddb$export$620c18ffd80459f1)(), (0, $2a3419e253354ddb$export$94f2205ed1af0024), (0, $2a3419e253354ddb$export$889f6d04a9c72786), (0, $2a3419e253354ddb$export$a11d3f631bfac1e6));
        if (!await (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).testConnection()) outQueue.push((0, $63d0b335c576c718$export$ce37e184d908d785)('file-storage-cant-access'));
        const klRecoveryManager = (0, $2a3419e253354ddb$export$8d693ea241b9d9a6).getIsAvailable() ? new (0, $b2aa268a64dedc9f$export$36c5c4b26ead79bd)({}) : undefined;
        let project = undefined;
        try {
            const readResult = klRecoveryManager ? await klRecoveryManager.getRecovery() : undefined;
            if (readResult) {
                project = readResult.project;
                outQueue.push((0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-recovered'));
            }
        } catch (e) {
            setTimeout(()=>{
                throw e;
            });
            outQueue.push((0, $63d0b335c576c718$export$ce37e184d908d785)('tab-recovery-failed-to-recover'));
        }
        // in case an extension manipulated the page
        const loadingScreenEl = document.getElementById('loading-screen');
        loadingScreenEl === null || loadingScreenEl === void 0 ? void 0 : loadingScreenEl.remove();
        const klApp = new (0, $b7af2ed4a75d4700$export$96f6458b62e4c2c)({
            project: project,
            klRecoveryManager: klRecoveryManager
        });
        document.body.append(klApp.getElement());
        setTimeout(()=>{
            outQueue.forEach((msg)=>{
                klApp.out(msg);
            });
        }, 100);
    } catch (e) {
        $8e7310a6fc595c9c$var$showInitError(e);
    }
})();


//# sourceMappingURL=klecks.7e2976e6.js.map
